"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2109],{

/***/ 1725:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
var _g;
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}

var SvgClose = function SvgClose(props) {
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 14,
        height: 14,
        viewBox: "0 0 14 14"
    }, props), _g || (_g = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("g", {
        fill: "none",
        fillRule: "evenodd",
        stroke: "#000",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 1.5
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
        d: "m1.375 12.625 11.25-11.25M12.625 12.625 1.375 1.374"
    }))));
};
/* harmony default export */ __webpack_exports__["Z"] = (SvgClose);


/***/ }),

/***/ 2002:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
var _path;
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}

var SvgClose = function SvgClose(props) {
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 10,
        height: 10,
        viewBox: "0 0 10 10"
    }, props), _path || (_path = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
        fill: "#000",
        fillRule: "evenodd",
        d: "m5.894 5 3.92-3.92A.632.632 0 1 0 8.92.185L5 4.105 1.08.186a.632.632 0 0 0-.895.895L4.105 5 .186 8.92a.632.632 0 1 0 .895.895L5 5.895l3.92 3.92a.632.632 0 1 0 .895-.895z"
    })));
};
/* harmony default export */ __webpack_exports__["Z"] = (SvgClose);


/***/ }),

/***/ 53989:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "N": function() { return /* binding */ handleClientException; },
/* harmony export */   "s": function() { return /* binding */ handleRuntimeError; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(10092);
/* harmony import */ var _sentry_nextjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(64487);
/* harmony import */ var services_bigbrain_service__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(65488);
/* harmony import */ var constants_bigbrain_event_types__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(65023);

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}



var handleClientException = function() {
    var _ref = _async_to_generator(function(param) {
        var e, _bbEventParams, bbEventParams, _name, name, params;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_1__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    e = param.e, _bbEventParams = param.bbEventParams, bbEventParams = _bbEventParams === void 0 ? {} : _bbEventParams;
                    // 1. capture exception in Sentry
                    _sentry_nextjs__WEBPACK_IMPORTED_MODULE_2__/* .captureException */ .Tb(e);
                    return [
                        4,
                        _sentry_nextjs__WEBPACK_IMPORTED_MODULE_2__/* .flush */ .yl(2000)
                    ];
                case 1:
                    _state.sent();
                    _name = bbEventParams.name, name = _name === void 0 ? constants_bigbrain_event_types__WEBPACK_IMPORTED_MODULE_3__.CLIENT_EXCEPTION : _name, params = _object_without_properties(bbEventParams, [
                        "name"
                    ]);
                    (0,services_bigbrain_service__WEBPACK_IMPORTED_MODULE_0__.trackEvent)(name, _object_spread_props(_object_spread({}, params), {
                        placement: window && window.location.href,
                        info1: e && e.message
                    }));
                    return [
                        2
                    ];
            }
        });
    });
    return function handleClientException(_) {
        return _ref.apply(this, arguments);
    };
}();
var handleRuntimeError = function() {
    var _ref = _async_to_generator(function(errorMessage) {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_1__.__generator)(this, function(_state) {
            // 1. capture message in Sentry
            _sentry_nextjs__WEBPACK_IMPORTED_MODULE_2__/* .captureMessage */ .uT(errorMessage);
            return [
                2
            ];
        });
    });
    return function handleRuntimeError(errorMessage) {
        return _ref.apply(this, arguments);
    };
}();


/***/ }),

/***/ 24065:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "N": function() { return /* binding */ companySizeList; },
/* harmony export */   "o": function() { return /* binding */ SMALLEST_COMPANY_SIZE; }
/* harmony export */ });
var SMALLEST_COMPANY_SIZE = "1-19";
var companySizeList = [
    SMALLEST_COMPANY_SIZE,
    "20-49",
    "50-99",
    "100-250",
    "251-1500",
    "1500+"
];


/***/ }),

/***/ 5893:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "W6": function() { return /* binding */ CHECKBOX_INPUT; },
  "dN": function() { return /* binding */ COMPANY_SIZE_INPUT; },
  "I6": function() { return /* binding */ EMAIL_INPUT; },
  "oo": function() { return /* binding */ FIRSTNAME_INPUT; },
  "Ce": function() { return /* binding */ LASTNAME_INPUT; },
  "wY": function() { return /* binding */ MAXIMUM_LONG_INPUT_LENGTH; },
  "l5": function() { return /* binding */ PHONE_INPUT; },
  "$O": function() { return /* binding */ getInputComponentByType; },
  "Je": function() { return /* binding */ inputTypes; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./client/services/form-service/form-constants.js
var form_constants = __webpack_require__(24065);
// EXTERNAL MODULE: ./constants/input-validations-patterns.js
var input_validations_patterns = __webpack_require__(18455);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(52951);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(88029);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 4 modules
var _create_super = __webpack_require__(60460);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/styled-jsx/style.js
var style = __webpack_require__(60357);
var style_default = /*#__PURE__*/__webpack_require__.n(style);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./styles/colors.js
var colors = __webpack_require__(12573);
;// CONCATENATED MODULE: ./client/components/system/form-inputs/common-inputs.scss.js

var commonInputStyles = new String(".hp-input{height:40px;-webkit-border-radius:4px;-moz-border-radius:4px;border-radius:4px;border:1px solid;border-color:".concat(colors/* default.wolf */.Z.wolf, ";padding:8px;-webkit-transition:border-color.1s ease;-moz-transition:border-color.1s ease;-o-transition:border-color.1s ease;transition:border-color.1s ease;width:100%;&.input-required{position:relative;border-color:").concat(colors/* default.brand-red */.Z["brand-red"], "}&:focus{border-color:").concat(colors/* default.basic-blue */.Z["basic-blue"], "}}"));
commonInputStyles.__hash = "7df3a6382602be4e";

// EXTERNAL MODULE: ./contexts/generic-config-context.js
var generic_config_context = __webpack_require__(3156);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
;// CONCATENATED MODULE: ./client/components/system/form-inputs/text-input/text-input.js










var TextInput = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(TextInput, PureComponent);
    var _super = (0,_create_super/* default */.Z)(TextInput);
    function TextInput(props) {
        (0,_class_call_check/* default */.Z)(this, TextInput);
        return _super.call(this, props);
    }
    (0,_create_class/* default */.Z)(TextInput, [
        {
            key: "render",
            value: function render() {
                var _props = this.props, inputData = _props.inputData, errorState = _props.errorState, onInputChange = _props.onInputChange, onInputBlur = _props.onInputBlur, invalid = _props.invalid, errorLabelId = _props.errorLabelId, id = _props.id, defaultValue = _props.defaultValue, translate = _props.translate;
                var inputName = inputData.inputName, type = inputData.type, isRequired = inputData.isRequired, placeholder = inputData.placeholder;
                var isValid = errorState.isValid;
                var showRequiredError = !isValid && isRequired;
                var requiredClass = {
                    "input-required": showRequiredError
                };
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                            id: id,
                            onChange: onInputChange,
                            onBlur: onInputBlur,
                            name: inputName,
                            type: type,
                            placeholder: translate(placeholder),
                            "aria-required": isRequired,
                            "aria-invalid": invalid,
                            "aria-describedby": errorLabelId,
                            defaultValue: defaultValue,
                            className: "jsx-".concat(commonInputStyles.__hash) + " " + (classnames_default()("hp-input hp-text-input", requiredClass) || "")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((style_default()), {
                            id: commonInputStyles.__hash,
                            children: commonInputStyles
                        })
                    ]
                });
            }
        }
    ]);
    return TextInput;
}(react.PureComponent);
TextInput.defaultProps = {
    invalid: false,
    errorLabelId: null
};
/* harmony default export */ var text_input = ((0,generic_config_context/* withGenericConfig */.P)(TextInput));

;// CONCATENATED MODULE: ./client/components/system/form-inputs/textarea-input/textarea-input.scss.js

var componentStyles = new String(".hp-textarea-input{width:100%;max-width:100%;height:106px;resize:none}");
componentStyles.__hash = "cd455d3ac866b4ba";

;// CONCATENATED MODULE: ./client/components/system/form-inputs/textarea-input/textarea-input.js











var TextareaInput = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(TextareaInput, PureComponent);
    var _super = (0,_create_super/* default */.Z)(TextareaInput);
    function TextareaInput(props) {
        (0,_class_call_check/* default */.Z)(this, TextareaInput);
        return _super.call(this, props);
    }
    (0,_create_class/* default */.Z)(TextareaInput, [
        {
            key: "render",
            value: function render() {
                var _props = this.props, inputData = _props.inputData, errorState = _props.errorState, onInputChange = _props.onInputChange, onInputBlur = _props.onInputBlur, translate = _props.translate, invalid = _props.invalid, errorLabelId = _props.errorLabelId, id = _props.id, value = _props.value;
                var inputName = inputData.inputName, isRequired = inputData.isRequired, placeholder = inputData.placeholder;
                var isValid = errorState.isValid;
                var showRequiredError = !isValid && isRequired;
                var requiredClass = {
                    "input-required": showRequiredError
                };
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("textarea", {
                            id: id,
                            onChange: onInputChange,
                            onBlur: onInputBlur,
                            name: inputName,
                            placeholder: translate(placeholder),
                            "aria-required": isRequired,
                            "aria-invalid": invalid,
                            "aria-describedby": errorLabelId,
                            value: value,
                            className: "jsx-".concat(componentStyles.__hash, " jsx-").concat(commonInputStyles.__hash) + " " + (classnames_default()("hp-input hp-textarea-input", requiredClass) || "")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((style_default()), {
                            id: commonInputStyles.__hash,
                            children: commonInputStyles
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((style_default()), {
                            id: componentStyles.__hash,
                            children: componentStyles
                        })
                    ]
                });
            }
        }
    ]);
    return TextareaInput;
}(react.PureComponent);
TextareaInput.defaultProps = {
    invalid: false,
    errorLabelId: null
};
/* harmony default export */ var textarea_input = ((0,generic_config_context/* withGenericConfig */.P)(TextareaInput));

// EXTERNAL MODULE: ./node_modules/react-phone-input-2/lib/lib.js
var lib = __webpack_require__(67555);
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);
;// CONCATENATED MODULE: ./client/components/system/form-inputs/phone-input/phone-input.scss.js
var phone_input_scss_componentStyles = new String(".hp-phone-input{border:0;padding:0}");
phone_input_scss_componentStyles.__hash = "74b374e5521510e1";

;// CONCATENATED MODULE: ./client/components/system/form-inputs/phone-input/phone-input-component.scss.js
var phoneInputStyles = new String('.react-tel-input{font-family:"Roboto",sans-serif;font-size:.844rem;position:relative;width:100%}.react-tel-input :disabled{cursor:not-allowed}.react-tel-input .flag{width:16px;height:11px;background:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAQAAAACmCAMAAAACnqETAAADAFBMVEUAAAD30gQCKn0GJJ4MP4kMlD43WGf9/f329vcBAQHhAADx8vHvAwL8AQL7UlL4RUUzqDP2MjLp6un2Jyj0Ghn2PTr9fHvi5OJYuln7Xl75+UPpNzXUAQH29jH6cXC+AAIAJwBNtE/23Ff5aGdDr0TJAQHsZV3qR0IAOQB3x3fdRD/Z2NvuWFLkcG7fVlH4kI4AAlXO0M8BATsdS6MCagIBfQEASgPoKSc4VKL442q4xeQAigD46eetAABYd9jvf3nZMiwAAoD30zz55X5ng9tPbKZnwGXz8x77+lY7OTjzzikABGsenh72pKNPldEAWgHgGBgAACH88/Gqt95JR0OWAwP3uLd/qdr53kMBBJJ3d3XMPTpWer8NnAwABKPH1O1VVFIuLSz13NtZnlf2kEh9keLn7vfZ4vNkZGHzvwJIXZRfZLuDwfv4y8tvk79LlUblzsxorGcCBusFKuYCCcdmfq5jqvlxt/tzktEABLb8/HL2tlTAw8SLlMFpj/ZlpNhBZ81BYbQcGxuToN9SYdjXY2Lz7lD0dCQ6S9Dm0EUCYPdDlvWWvd2AnviXqc11eMZTqPc3cPMCRev16ZrRUE0Hf/tNT7HIJyTptDVTffSsTkvhtgQ0T4jigoFUx/g+hsX9/QUHzQY1dbJ7sHV02Pduvd0leiK1XmaTrfpCQPgELrrdsrY1NamgyPrh03iPxosvX92ysbCgoZzk5kP1YD7t6AILnu+45LykNS40qvXDdHnR6tBennz6u3TSxU1Or9Swz6wqzCsPZKzglJbIqEY8hDhyAgFzbJxuOC+Li4d9sJLFsnhwbvH2d1A3kzAqPZQITsN76nq2dzaZdKJf4F6RJkb078YFiM+tnWZGh2F+dDibykYoMcsnekdI1UhCAwWb25qVkEq43km9yBrclQMGwfyZ3/zZ2QK9gJxsJWCBUk32QwqOSYKRxh6Xdm3B4oMW22EPZzawnR72kgZltCqPxrdH1dkBkqDdWwwMwMO9O2sqKXHvipPGJkzlRVLhJjVIs9KrAAAAB3RSTlMA/v3+/Pn9Fk05qAAAUU9JREFUeNp0nAlYVNcVxzHazoroGBkXhAgCCjMsroDoKIgKdFABBwQUnSAoCqLRFBfcCBIM4kbqShO1hlSrCJqQQmNssVFqjBarsdjFJWlMTOLXJDZt8/X7+j/n3pk3vNq/bb8+3nbP79137/+dd954qTVt8uTJL73OMhqNer03ady4cWOhWbNmjV+0FfKGjMb36Y9/1fXUst9cb2y8/lpb797z5k2dOjXVD9Ljn59fcHBwQEDAgGch3l9on6feeeedn0r9kvT222+/sErRgvcDArwV8f5tN/rcvPnMZ22pqVFRSVGjR38k9Rsp9fLql/MXLj20VGjt2rVeak2Og/auI/kHBQ3We/tCo0ZNhwYNGj58/NaWlpbOyMhIX1//2/jTrICvckhXruQsWbJw4cL3tzhPORynSk5lZWVtglL9IkmdDQ05NqvVGhLwbKSUL+Tvb9yH/2sj+eN0IZZ3fvq3Hnp71ZtCOyofdnTYSzq9xX7UtsF9+/Y1FpeZT54sc2aUlq6Jy89YM/qj2oZaoeOkMR8dV/Tee++NWb04rrA5MRYKDAyc/NKCpwDIyKhE9LEzZ/r4DLQAAE6EyEeM6AcNH7m1pTMnB+fHX7tG9Bs0Xt+GwM/frqm5tz950aKDk6rsiA0xbUrbRAii/BDeV9bGhQsPRlyOCAuZ9GykZwT++n2RHPnVYQU+oaFDPQD8jEQAPiDdaLPaHGVXbn/O7YHQuIH9B/gYgzts1iqrtSopKWlNRkzS6I8arFaOFvTfew8AfiYil/rN6sWTKwtbArOzExISUl7+vwCuQNt8Bg71AQCcTwNpWeFbW3IIQEmJr08XgIzX2xDcvZrs7Jru5EWXwwKSwh2RkQ77w7Q0bXp6YRoDaKO+kZl8MCwsYpJ3pEf8liAAoPhDhqUMQ/wAkF+oqKiosJYA7HxotdnTtVe6Pr/S0h+AI90QffU3T9obGuwdD5PqkmJiMtbM+ajWI/60TX0COhoarAAE1dfXV80FgMmLi1oSKP7/B6ASAGyBV4YM7D/Bx8/bF7g5fgmgEwCCSiJtJQRgxEi9zZqVdYUu9pW0tLCIgOvxdR0dpxx5aWl7EzV7CYDV+tXnCzMzkzMvE4AFlTuhZaSf/OQny1L32RC+JcHikzJ06NAJoe+YNKRbsbG3xPlWZTxssNmdOP/J27ffudLJ60V7DAaT1lxRVvfwYe3Jlrq4uJiKjAwAcIWP+BkAhV/i7HA0uAG8BAIUf8qfzvwvgJcQf+XMK4GWi8OGTpgQ6uftzwC0LIM2WgcASwaXOBwlA7v6/YgAhFRt2pRGeu0/UyImbal77eHDo2kVAJAeKwE0fl6P63/5nSlTAKBCiR8AovbZEL9lf8I5AMD5booAE7OzY8X5fhGJi0/nTzTcMh+80iIBaF0APqvIu3EjqfRGcV3S4aSKYk8AaW4ADU4gOFlfn8sAXnoJBDpTCMDL87zU2kwATl+x1Nw+P2HChKHBBMDHFT8DwGjX11FSYu/f/aMf9XtOjwAacf2hmxRg7ywXDrr30kb7NVhDquo/z0y+nJs7ZUoYA5DxM4BFmcnJyV93PzjbvQhK3urqAYF7xflWVT5ssDaU4Ox7T9+6Ei4BaN0AUkvXJEExMTGHD9cdFgA2yfgZQAP1f0dJw0lrfS4BmIb4z5yZBgL/H8DibbehGROenQ0AQRhvZPwQAGDQ8wlqsFkmdP9ofr/n/OgK2ml1xxQECAAy/tdee++91wCA1mfWJy/KXUTr536T+O67764X2r9//T+3JkPdDx50f7qItDXfff+zeAxY1lYV0VCmPV1Ts5fGAGUYDbHpo0qT6vKTignAtWvXiuf0StwGZZPQybMPAYC8/xF/bj0AUPwvvzytKCdl6dMAvJxRuXjxkCHnL86YMXs2A8B4m4yWQTrdIp0uByMajcATJrwzXwCIiIjAFSrbJwGI+FlH00YH8/rQy5enQPsYgBK/BLCI1c0Afonhn/XjH8MNLP9o1Y4Pfg795N9hYQ23bt1q4fb07z+A/ITR2J8AFJnqOP7iuj7Fc35TK+9/bkPaM+NGiSnsB6wRIwGA4n/5T5Pzc5aeeAqAP1VCM4niWRqVgr1p1sEYlskNJQC4BQZbLJi0MAgCgBUKqYo3VEVEhIWFTZqXtYmVxiIAtB4QeDUAvMuSFBgAJCkwAKHlLAKw4wMIFG5URVgdLdwedEq6BuCgj1qzpi4uiVScYa6I0fWKJQVC2aRDY0eNWrlyECwMMIDDc2vZ6UF0F7z8tB5w4kTvtZ+ygklGkk4lvZ6sne45SDg8aJIQ2z+4Mmg0qcfauXPnfvPNN9XV/1S0VSWyf1Ls4FZ5aIHu/blGKb2UOM0ckq4PmsZ2b8yYMb2l4FbhX8ePHwmhuSPXkhaQ5q0tXzBvntdUUq9eSyFu9njXxpA74Leg198yktRWVI4OkAkymw2Q3WO90+nnN3u2H0QkHI6JpHHj2GvTYdsupd68GfVZ4yTJqJeUaNKhQ+rzCUvOMXEr//4vD3333XdLe+rRJx4iqumDnT2O5zW1HII1hPLy8pJGjz9GWgk9D61Al4fWkWay9VRbUa1GEVCYDRoonu0dr++n0ZQ0dMCNdDRYHVrtuImjWHQ80lvfl4WfhJetw1CFm6h+rkazd28iJHvyIe/IHt7ZOBY7o4GPH4smPqf7nRwz/sH6bmmi2HtvYiBUYPxEcZakt701PdsPAIhb3DBbYmIIAOK+F9HXJ6z7t799AwDI48+cOQRi66m2ogoAYVwIQEkQb8DrJza1azRWq9NpjUjXtg+aNXHU9EEQHW/YsGFD3toHMFZbgzUsDNPkPgAgpScG1vA4TgB8PZATAAoc6IasWPHhhwCQkyNCdwMIJCVqDabA8+cAAJFLYVD92dvpjvQe7ZcA7p0/350dEzNmy+iRAHBPrO9+AwB41Of4h2HoFdZYhsfL7ej7QmbSBdED/GkDXv+ju9Pv4i9mM+g09Rs1duKoQSQR/4whb7msbFhufHy8M2xup6AZ3sHzWOChaveIWQCtn00A7s/84MDuD4bd+fBDcYEukrVna5fwMQPAsqnQZOqqLtBzezysvHd6z/YLANndUELMGAmgXqzPfeON3+IE8PHbuL2YegYCAO+/fz/io2VMM+5HpR/BGXIPGCzix3oAaBo13aApK9Mahg8fNAo9ANsPGi7iB4BLZRUPH9advJGb6zx+3Jk7FwFtCNekNzQUabW3cAv0Ek9uUA0U+PGsY4NmzrxQVBS3e82wGQDA7bvI8SsAsgNP7y26HV4GALyeJzGaY5J18fZ4GT+3DwBK8/K2ZF/s7v46ZYwEsMJHrJ/gApBJ8QPAs9gh2BYBnT077OwUnvcBwB0/nCEAQPFBdADefv5dPEu3p2u18e39Bg2aPou2h9wNmP3wi7bGL9qsuVOcizoBgM/X0BBtamggK2wGABn+WSLw8awm9P4Du3ecys+aMWPGt6J9medF/EsBIBbxJxSFm4vM5moJAOGL+AHAO90jfglgy5bshO7uFAIQM2fkyhUr6sX6fW+MJQDYX1wvWI/+uOIc79mziJec4ESxDPGy6AF9RfzYHgBw02s7yswNhf1GDJ8+lvcfPgKrxfoAa0S9uP9HTV95LHdur8TzuF7W5OSqDdEGAFiaiIjk9U8hAMdw+1Ts3r37VPOMGR/K9l3k+CUA9P9b4c6y8LKC6upqAiDj3wpxD1Dix/m9Uku3KAD6xMx5DgC6xfrLYwnAEuw/jOJnAMHjpnvECwA8aK5YseK3EA2aogf0pQNIAIOaXI8S0/sBAPaHaLUEIOJHPmjUsWACACN7/qLVmoz2Zjabv3x8X+oBdP/DWeih94d9sHv3BzO+fOOND6l9C93xL00BgOy97dHo/ZHm6EcAwM8OHlZ+YLpFtF9eQAGA9+81pg8DQCzdU3D9Ef/YN3AC8OP4Z5D1DBg7XYmfAKitqYl7AA8AvDxxVLtGW1VVVhYRZjC0jhg/Tuzv3j6gCuEjfghGYd/cXrFk5BNqai4K633k938h/Zp15C8Tx68E7X7Dtm2b8QZEAH743j8gYQQwC8TGlp08Z7ZWC+k/4eFf6pc//Sje3+TZ/pFeqXkQ7hoIhhoAnve8ogRgCQZBMQsgTgBgXykpAoDKmpoIuJP/wMvzwaOKHkisVfUnDYZZ2J/k3n4ST/94UiHt2/d+Lx7yttFAXnP+60W6+X9ggQFzGDdeOJT791fQNAgAv/qHFFMAAJou7AWQBCAkKXzknW71bD96APnWQ4c+hthRsv1Ty2WNA4InwYYpzhJSW1MT+lmkxx9awyfNhQVmvf9+c9M4kVt1by8tsmuLub3I/in6er7URGkh1SZ1znfk/xR9o2oP7F8Pax1vbO8RgJcwhYp8BvpMcD1t+0GffPJ7xUo+CA54Yc+DPXv2vGA0vkBavfqIW+xeH3kr8iJ9QxJegQNpu/TMzZupnzXOkQ7+OkumeCCOU+Si2Sr7kR6RkQZ/iA0y62PWVKlUiLy8fsz1MSd6s+YhLz1vu0t7ILS4T1Rqn2cU9fF6YQdpMZIAG6dNmzZ5bX+7PZKGsXi0CM9xwZ+0DmuVnejxsHMDJu3Zu24vkrT+QTtYq4/8nvWHPzyeCa2HUySRbzMKAO9CGhZ15Pku67uGlaS7frzoeFat26uY2CpzijiIrbKfLdH2buy7eKLkR8oAaXWhQNLH8+qEKirKy0tLS6O8bXVZQpvg8dPmbV/O+jH0IvRClLY06hkPAcBGqLa19ckBzC0HVg+0R9rQFpqFtWER1oBPhr3+eutPocevPzIaBwTseTORAu/rQ7sd2AgA4g69T1PlfmGVsX9fn8ESALk4ER5Gsb/Mny2tbzGkPQwASH1s2iTDBwC2yhYeVdgq+yXODAwpCCzAozT7Dml12fqR8VGcOMtk9A0pkUvsI7YvR+DQrl2vQLtWpdbFPAVAq8lgMrcygKEEoKQsJKTMYQgLDQn4ZN3r60T43ngSrH5g1rBcWaINAoCMX1plXq8GoBUAXNYX4RcfPqzVXa8tqk3bpATAVtnCVpytsp8tsCBifcJVil8BoFhfu7OE5RCyGn0HWxweQLYvf/HF2tp1T568IgD0Gf2MJilKBSCrPf5Cc3h76e4zuwmAv8ZqQ5cLMwwNA4DWn+IfwoeqX3/8kQvAQC2rGQCU+NkqywuiAqAVACa6rO/hYsR/uBi3wKZd7wGA1gPAcEvfhAQAmEEA4DwLEgo4/tmzwyYdYqurWF+9zWKxhCKlTjnV2WEBxkhHX5/G8jSZEZoKALWJWbuyYgWBVRgA6vqk9hgDNh54YtI2t2jbn5wBgAl2m1XTYAmxhFoNU5DG/uRnHuG/d/yjEa0X7kID+99tgu6OxTytxK8A0KoAaCGexz+rWHPpUtKaG4e1hwnAhhNZlLtMhwyG+HhDGVvl0PXZ2fv7w3oMe8vPijuf4of2AQCyutDmzWdI1zcv0Psr8SOFF2As0Th8Qr84CiEzcjSKni09b4l5C+al4r9uAcCBA1nthuYKc3spA4i0hWgNdFazgbK8n3iEjzct380S1rd/f+mkAECJH87O21/2v76eALQM4MiRX0+MKqXsFXSYAei8/d3WXLHaoQNTUga4AYSGiesPTSEASvwEwCrin4D4GYAv4m9MS5M5yalGX1uixccntCDwKqf5n5FSboGNBw4caG03m1tbz5zZs3v1bAAAKvtJDAuzAeD1c0r4DEBY4f4DKH4C8AclfgYQxFl0etRWAAj+RwjA6DUyfuoC3xt02F6JnwDQ8UNpeQAB+DTY6op/HxJLU+au3jj5JYRPwvR5ZoFN3v12oVxjkE+oXbG+4o71WH5dJa9VALD7wBPMArvP7AEAfaTVgm3NZkzcszHoBCvhM4BvhTcfMOCB8OZH/sDxp0hrCwA8PvKjNqkaAPaL80sAyvU3fF+sU1tptspDaRkA3gKAEIoforwaAPhZ3f2de4RWeUvAARqDKH65ZDKE7/nxriexm17ZtO0JxvhXX1n1Q5UAYCMQTCsvn7ybEuYL9JE2q9jfZJoSBgADEP5xt757MJM0xMcHUUOfzr9Pywlua+vtThhJAOvdPYDc/LjRayC+CxiDTm2l2SpbeJmPHywzyhLDXH1ICI96wEAcAlIr4ABKSThuXt4c75ByyJ2Zj9qDWbD2SSJmAdaqBSp5CdPoB5frx9LDdEVDG6C5cKnB/xz1kdB3rAcP2Bb7+X0q9GtOXirWU7HGEgBSwI/CoehosrIT2f7pFKmtNFvlYF4W/jvAI6kMoX2y1kBIZKBHu1PDwfNI7A1ZbP+UIgPMAn08hFnAIOROal3P6pnlzSQlK8pHf4F2s+AwjSRNvDsCadl76bQif9tbqDBdNvzPfxcy8+nCw1OULDDrOukEi7PXnngo+IDLY8UZZMmGOmsMn09yPTI8VwjhWEUkXIY4mYVu2/7qq9tJXuqsLoxJj+XMZqEWUmdnskabf8olWOI9Rl9Ik07vqeh1id/EpqZRUGKOhksqxveuZGm0Idx3g//+BPrd734n793wXnuFEoUOXc+ClJcrC4wiI8rv0On4GNUbbh8TBRtwDOPVWerxv2P9SuiPukKcBwd0xRPusuLSH+/xUmd1r9dm5XsuZzZ35kBLxCt+ANBoihA5CY6YAODEmnS8KRpIr7cBgJp2uyDkahcmi+EAUE7SpvPQFRrw9yfcvk5nPHUyApDokQWPBQCOXN7DafPo+ABH1RN8fL0t6OrVq1X3eC7C8dVZ6vHu2P/4xz//WQDAQ44rnmhXFlrYYxeAW+mJ6bcSEyUAEFCyqJdPfkX6HLp8+fJXBEBTyAR2uAD0tWjSfbh9BGAUxX/1zi8HVXcpAHZq03m9BNBptXY4ET8DUOKXANJk/AxAFETYbO/ayJ3aACAwcH3gep/Qru4PUZ8w/nW8X9gWOMSdZR7bRG81jkOU1XjeDUArFOey4i++WFW1vr4NAMTLaFjLvekuAJvylYKIXIcvFcQItzLB9o5G44CzylcA+Pe1+GjS+fojwGDO4hbcOfuXX35bnZ0deIgB7Nyp1QqrygB+1Wb9lbOBAUQTAOV1XuwhdRZXI7Q3UVplfSKS45aEc0MH9p/yTveKkQCw7WrIXneWmYDMrD3++Mnx47x8Iqt8GiTs4+bJ8y6V3Xj4sOLkjV27qjA9AYCBvGJsQkLgXraKBAAEOsCdZPfLdbjjRwQAUOJvxy7t/BK+NKuPhqVYTX6PEHJ101+qq8MWLcrUqdf/ne5Pa+OvMLPRPB3dBw+ychaDSkers7gaFiAliv31sSHr14euv0o8n322XoeAHXhwOyuydsMYwJDax0+ePD5OywCA8NM4fAIwdWfdtIqKvKyMXbuKDPWFRS8wAG3r3lvtF0RBAveANuqv7K2Dc+3K9Z/g7gGtlKRja9sjPjSQF6/eqc7+9ttztKz3Z6uarl22BcqL+jvdo1URvyqzGbSUpOTX6XlkW0mvpaqzuBLA6dOxOD4DKMA7koRzaMyUf3+xczUCvlVgic+m+CWAIUNqjz95vEkBwJdfAniVhj6+/xuRjGyTAO42XRjVxJMfACjxE4CuveRlC2SO7d13NJD59yJFSQD0QRj+tPHu7flhpqv6y+pv/9lF7wn0QexZ4g1bBIBZBCAnIsJaEm+QAJT4f/Naqrmndd2wCFMPhuHTp3OWQDk6vS1hfcL+6v6I/iU8vgPAkAs1+5vPIn62zt6+56AsdNChjx49OqcvwsEQPx2OjwcAIv5d+YW5hfkSgNZ814wNGADHP0HEo58Q8PXe2Fjx/JkCxd7T8uXn+CUA3P4AILcPFu8NuqrDziF+lND4hfCjigAQsywKozQN0Esc8eJ89LTHLk8+7ZmV+LnBnJX2KNAA8KvVQ//9xWTYkDNnJq9VW2m5XF8vl2lSx/X3AMDhU35kee7yXS94mfh8St78RNZDOetAEwBAmaRjoS6t4a7M0TKFcWxNtfE+cvvgsWKCjs3U8jwFAGxd0w150DIAkHO0QSjaSPM3Pa6BI+RnVtojAPAErBRo6AeHtN1YDP8uRra1aiutXgYALTZ1H287pn+SxAAA0pFB0aQT7wuzKbOQwV93kfC/Qt13j/TI0k5kg2Yqox1YY0VBwlKdWXgx6VvLzKlRrPEjRU53Q7QQdpenE/bW7G7JBpZOpUmfLVi9arXQWkhtpdXLZP8WzFsQFx3Hh2vm/CjrBZaX9UbvmzenotZWWmpZ3AOJUgvCtkq/2u2Vy0lmbiOfZhxLqSWuyC/FpS5qbCyiW/6LUm/om2rv6mrvR9VGyCRkNErs6uOprS2bcpaZ91Bbd0CTmsTiPd/i8gtuzxGVPpoIebTY61qJ+aT9pJOytEnQ6NfiSBlxcbWsMTRG7LBtdFvJ8nxI9FAyKEhgkJRa4jqHpigjQxMZqamry/fV1Hk3eWRx198zmjTpmEZovSbe7tRGq4+ntraGnlY9nJfT47Wu5YAGVIKSZIEF7y8KOrg9R5C++r2iI6/W9myvF2p3/YNwyqQYcl/Fc14TkcNAk+r60AkPhBzg0wkA4GNi2fyDCMAg5VURKkfz4uwOzWJN0GBNuR0Qrnk3jTrrqlh68O1wvDlyNCBp6R+k0Tqq7ACgOp7K2koA6b7xSgFGeuTgvkElWBYAEDgidxVY8P5c0DGMrbLTgx908tVTPdo73uumw+4baW94WByTlp+fFuMCkJGhBqD1ACCeFP2pTg/WVzkgTpiXUV6GtCCeD4Li82N29vYGoDs1/Lrvy379ngcADaWtg0JwMAe8ufp46gIM+brdYnEKL4/lSF5fItqjFE6ms6/g/UVBB18Qb1xgeno4x7qqf/XUKdr81i2ZIfJaU1LR0YEsbUxMWmnFUQEgP5/sYFxceXlWn1XIGR6w0JzDWosGZ2SIBgeFwJvDeBBvtxWVz5Ior2Xle486i4KIO1fP3aEXkiv0QQ47pa9CQoTTnP304227d08ejwMsszRaylwAZIGDvwCw/RQ8ObRRaBUXcIiCDpwPAN6NvQoN5vgHngOA5XT7NDVJa+31WUXSjRsxa27EXEuLawGAo3HU/+OysnBjlpdmPeNnExkYV16+HO3NEKMQJjgrGizjl1a0MTLI4xL2vek9KrBg+IiuhBRUFhMAfrojiae74Kcf715m8j0+ngDgj/vBR9QOAyArUmj2njc5cJmkOLCKa5u5PTO4YMM7cR0REPELAMtxxA0bpDX3SsXYFwNdu5bWmZN0bc7RjNraOMSPHpBRCgCrKWcYKq//njNrp4kGmyCQCQlGg5X40WDZA3z6u3vAnUEjRtw5d+5LAJi/Qm9xcOstFht9JxHp9/TjDeteKJyd7AFhuVPKhFX39vcXXd4hssjbuQO4IGxkAD6iPZy1Rg9Yj/g5/IGPAGD58kJ42Q0bwnE8AUDG39mZl5eToyMAiL62Fok2AkD34O7QM26jlIcG14oui6sYEjymrpxeyuUJlaZuqViWnz5Y0x8AQpt7J6V6Hxs+4k4N2chD386f/6EeRseB9lso89oBY6I+3lhVAQYDSHfud5qEkUEWGftj574ii2xWUqJyPTqfKOjg/WlQ5P7v4wJwSguhoJEV7hW1huOHKO1xDQD45aJWWyoAUAPOhBEAgwtAbZ2YhC2haDA/bbkfNvKmxmRobJF5mgEDNL/Q2EPKU72nD7rPPhq5rwf9CIDdageAUK2hod4GAKrj/U8BRiQ/ju8/R/7UJ4Ssbl9HutbpL63uUws2RH/k5bKe1vrKq8td1nsflDsXAES5OXQY9da639SS6uQswAC0ByyTlR6QAQkbEgIBQNbicggY8qCpdRpb3M6dNAguS4rTWC4ZjwVCXIABCitgdZ2RGNBDMAs4bSUAoDre/xRgsCFYvx5hkbkVVjfIv6/L6j61YIMLOs7ysuvttdSRV+vcnqEecycAiFpbFtUbiEpbzpiy6NKsDlhL/pS1ZQuq6TZwkjCYJOtuSVNJpZ8nIQeaf/NmPlKyz9R+b4T++cj46JF+9iM9JK2un5+0uurjkX2T5Qsso5Df/7O6smCj5/a93oI+5eUjKu0JVpLMJK/r18PDZRaWq4i3k0ykcHbLKmcqaoVlCvcQtGjEjyZ6emF1Fre3CpDa6vKZhbHn8wdLueytnqU8n7CTFSllugeMik0WaJd6CrUZDTfmwep/cY3S5M/hmqjP73V9Mj0uKjnA7ZQtFebiRWiVt8x/yrHW6GE1SYf8Hraa2psUa2m0QWRlQ0QWd8FiUrkrL5XK+ytm13iiUog3mzZtQbANsrpL7CfpySCz+G8BXEChYRVAxj1vSsmCDVUBxTfFTq3zpDO+Li5/Q9OFlrg6tdX2MovZCn6MtXM7PS8LAPQ+HQA48IcPeardqFesJtf6HvL2bby97tat9unCCQIAz/ORkWKeBwB3PgafKWxOFVYXCYvjwuqe4NAlnpcIgIhcFkQAAAfOfwwNIwAALR4IkKEpMJp6ZrWj1QUUgx2Yde32G/hIB+VVx6LUVlsCcF2Dyt4MQBzvFQgAKP62pvA2CUBaTZmF/RjLEV+dn7nuVvuo4fQRFQBYoHRH31DKAgdX5EMSb0ZGXIy0uiU+JcLqEoBprvgZgBK/BKDEHxYBAIMEAG16NQDoJYAdO7QCQAKnL043N5+mbpB4qNEZ77CXlFRk5FMJfFOd/OyOxJ/deZ1A99+8Weue5gjALphFLL+yezcB2AhZmy5Y2Wnh9feSCGE1ET8DAM2D3WeHDKFuMGi80R/hl+CjqvgSBsBlc5V0vMpCqigRF4viN7AVXV252B3+S8jaKtdTZoH5q7IIaUUjJnEBhYHWxysA3ty4482Nb2r5+KyMuvw64fQqnBknT2aU7aQe0PX8MqoXaKUsaCvivWvQmiQA7qHQ5t7bkSt5RctWYzcD2MEAwsNDJICvFi7sewf6knRnIltPn8vdxGNYvGkcAPj42OPt9hJfTqpyAws1GRnaImRBXQAQf4mBG7i2snwnaxlp51R1FjnEYRfqgBo69nHO0YD1ngAKNxbiP7S9BFAXV1EhnN7D8KLw5riiirq4lXUHK47VIf6mC63tTU3trU3T78IJilJSpQcAwK5XeLlQAXCg6oMbVYife8DCep8RSqkpACD+e0hL70UPGD5S70/pLXQ6pyhY4BzfYi20uNDgBoD4Bxi4gQyQZnVZPK3OMquXOecIdgQA0vMGuPwbD+yg9RIA4o8T20+tAFvxlV59Te6y0Vh5wWQytLYaTOgBAFCp3KNiEPzxrldUADD8VV06/wUWfw4AZDUVqzoSy2GXHwyZiTGgHwGhLHGoj7Mk0jmUAVS4D54BxcVcr90E5fUfkJTGb36ox4gSDwg9hkthP4RQCDtu3Ic6dYEDF1CYPAHweowBwgqPbVoJyXJXfFCxrCgjDv8Jr4urO51bk1GBLDOUQ+IssxesKKlSqveeH7+iBnAAqo/YTTogsq49rOfB7m23brUOp2UGQNH4DJ1gEVnledP47pKvfLdEqd/9occo8TMAJX4CoFXilwBg+lQA5HoFAIcvviiZWsHXH4q5nVDzk9HqLLNXUaFLJlORqahuz4uQOCDPAkblUYvkx1bTw3oGt3Xi4ivLsoDBnVWeygNc3mYSsoQA4PnyFwDIMCglD8EjXc3/kAQAPbPE4Wx9PW6BF6RDkW1ci2+K+JsngQE9AB2QOwEudGNdRoU6y+zl/ohMmjWyf6uiyfduWEVSnJ0wZLw4UvkMTaebCCuqLOtVFQxKGasQdwSYZdcZPWweSykFFuKwlZxoOBdQXIiGmvUkVxJ5g5TaSivnHs3SqeQ1UZUl7Q1p9Bp3kQWvFicXNvvQfGX7cR8fmqs6oPozOp1KAqgClSyw1AKSnqVA/PbTXj3E7RWnn/81jrcb4loHme7+n/Pz5krWuu3GM5+hVnmOfAICAFVWtzdVE9g05VApHvNTPawnW8fLiYmPeXvofmCNztv2lRxRuG/p1AUXOl6rrDd6WFGyyqsXQ4oXnKe3sRIT2f5YAsY2PV4nNJPUS2nv/a9wQJ3yewPiW2OcP3wDN8LQvIHP3zO+7/kXJ8IvrYGuJBUDgEhqyruaAJSXa0I0eaSjRwGA1otw2DrqOs8HBt6hzb+tSbi4RAdn17jE/UI7UwJw+Po6xLOFjmsroj//fEMmr+eCCovl6lUfeqHu47d2scsG0WA5eSqMj1AovM/QiAB8JXZnnRvBul6u9k4/v9Ccmbzwn8ZIgROwwDPET6sxdeaEa5xOTfiSnHA+//OeWetce0cDVAzl5BwGgNb29lb570L73fZ+AFCqsWg4fgCIYuspLidbVxzwNgggzZOQ0o2AyNpG2JWHKQZgJ6sdycvR3CGdDbYyE6kFABD/+uyEgoFcUBHQEAHVV1XxZyNhcwUAy/r1FP+UiIBZo0zmY+2etcQc//3uzE5T54P1evSokvj4SB/w7I/jAUB4Z3N6ZF8f3/TmJRsYwMILraQLUOvwz8ocHR2ODlSo5V65sg8ANKx0B7IsJGGtLaraXXF+Nir0/r77fPb58wkXM1HAAACUpbZjvQJAfJY00EnLRt8gdPXPIyIuiwoRLqi4mlBQkFI9gQFQUWpDhNNZbwWAXADg+AMD9w8dOmVKaMAsg2FQ+3BYFs/2TL+/EIN4Z8qjgXqjf4kdpoP7kwCgMWkdMGNDI03hOD+11+xhrWWt8uHiwyfbGk+6AdjtjkhhPV3Fx2F0/tnyszixP9cCy8/UshP2y8/Q7Brg9sHeImvLX42JlLADy+E4HrxxZlhY8gSuEGGrjOrnagAg4wMA9RH4lCu+w5lLADpQ+mlxxm8LvFUytKTEcnCWofV5fOVzzAmVlDk7yAneP4/4M79GcSoBcJb4l8SHIH4+Hj8oNoeGLtv8kNojASjWGlnwS5eK16BMM6eidMlhFwBtpK/Bw3qGqqyn2J+SkASAPtM6fz7l62QG4O8RvwQQL95qOGnZDeCyLGaGVeYesL8ayxKANl6Lt125+/DV2CVTZZGzcrHZPDmvbPLm8O/RA4a39+uux+WQF2T6/ZZMxJ/yDbcHPcBGPYDjFwBM2lPL8jafyTCF4/zUXrOHlY7iStXDEDlUAPCNdzgdeHqz8z9Hwzx8SQoAR4/S6/yYo1FsPbUKADipewnZeMvxZcrS7q2LuNY3TMYPAQAUSfHbeDma/1xmtdIYYMYYQE5yYEFKyjdoLwMIC4sHAPzHSQAqKovi8L5w2uT8yrz8uPLiWStN7Su60COnkADg8fkWU2dmZkr/ZwWAoCCMAUEU/7M4np9BE57TrM3avLm8sHnhBkM0ffbX4S4mdoSNXiPiv3b7ypIlt2/rvNjaYnwXFQb99QRAO5QB4Fvio6PZeor4OAury7mYXfMtWeFvD/X6OpNqfbtkXpYLIkTBhX1w30gDA6D9Mfp2d/cTn6kZg7gQoLpaFlQsKH/J9Sj6p1/8Yktq76LFIDAtP39yXn5dXv4zs5DFqFB06Us8jYZn7v/GVRCBW4qrC4aKMQA9wJyzJFqbn2+IXrgkmgHkDqRV8nwE4DDU53DO7dt0C6gLCqZi+tdatHlyGhjN1lPL4vVbAwPvu2aVOyn7dd4h92ReVhREqAsuxk6XqyFplT0LMILXyklQUpiaVJlfWRkXt7g8P6M8I2Na1KyVpTt2vPjiRgjO/MAq3RKopsDd3lNFbuVDWTj/hmYTj3ctzQYCEIFRVzkfirUheRdcAwB1lpXsnyHAFOVyj2w9hdPk9UsPjVM+Oxv/9cdzx49VliF1wcVY1S84eBg9JavMLlyqeOrhw6mpl4qjooqfiSruM+sErLmHYP7++sijvduVYgfa7gX1+XV6Y48TzoF6WOFPDilfxZHUWWB1VlY+Fe12qTe0wCOIQKkE+SaAQcp6E1JvlZRSYaH+AyCPn1sTnxMqmq2SOsurXl5L6vUWnYFb4KXWJ3v39viFBXXWVFpT/EFY0wOiSjg//03Wmd5ZdRcSL9SJdyN4MRK4cuX69bHvtjWyLn4claHNqFCssfN/ACSSlF+MGKC8+fSFjHPbWOJ4Bw/+1VsldXvVy2sXQ+ug2Fgy108DwIHXPr4gfmHhs4fQDegL0g2dPhI20/2ISwA4B52fv5EeQncAwGk0/HReHj/u5qUGrny+oCBWNPhg48GuKK3GcMkKcR2DddI8IfQYIffvA8hfjEDBBklG4A8AHDj0DnTwr656mAApdZZXvcxWe+bM27e3bQujn/J6CoDH/FFkQs1dBnCiklL4izERbebSUmEMTE3HzOIzOQaw42+dnX/bCBGAFjS/heNXADQ27u+6eLHrIABkGOouKVmdsgyhiooMoU/58/ga1vnzNV/j9beUqB94v02JnwDopFxPzOqCCvUyAZi8rQa/d5f9fwAkcg/APXteApgGFWq0hZM9ANx9fkWTJ4CizOQiAWDBYnR8cf1BYHNq4PMAEAgACfsPgkBXVMWlS+gBso6lapJGqKVFI6T+BQpTz6ywuSzeKVVG6tCxtrZsdQPgeLu65C9W8LLyCxEAgFlm2+2IiHsAMOWpAKgHXKAe8AQE3j5BxMrp/NO4tJQBtFOKpp2sJAPYsTwuOTnuRQbwfcWNG5eEMLdc0kkABxMu7t+f0nWzK75nlrdMxpe8SAGgxA8fYVJlhf+nFpkVvUSn6RQAOCtd39WVi3gJQKS4f0R9bxAATAaAewUFADDlqQD+W9y1hkVRRmGyy+6ygrYleMVCM4sQoRvQKiFSBlG56CZiYYigEIgFlcJWhIJ0YUuUCLMbT1mhS4ClaRJPEQRElhbhpRD1qSyhInvq6f6e832zMzta/arebm4zOzvnnW9n3j3fOe9H8f/gev6HH57vpPZyMAbK0pESpAfz/YKA5YuWvb9skdnMBGCq6PO2lpbMz6l19pWhUZdg8h1ljvLHSOCiZUxASxyw/eM9F7Cbn1LHNGWugYHyv3pJgIcDhSRAla5B/zQCZNvdnj2y7U73/lAiYFVJ3/33980jJXkqAsDA84e+aaorq5MEYCaLlBjiVwgw73z//eadZgAEIAV3O6YB9qN4CASQ1t/KMkP82BEE4Mu/5+ieoyDA6pnVzd3G6Ni3r0P8aVqwNA94nJDcetfnWyRuB7Z80rqDvv8MPA+36y1M9W13escIEACVNW9eX9+8vyIghr0Fnq/r/IEdFnq/xP1fwbHjprFqZyYCvHDaYzRXGBkHJAoCArby5qtJa4KAGctAwIzqTR9/vP3j7Xu20whQ69gwAs7UgbPIfGyRRUYxs1LMCzy6tnWTGj8R8CkDnUfyDyc5WOiyxCtmQmTOGxcXd20cm7mdTIALI4DwvHBYGOopjceO9czaggDcA0TBA+4BIGCSsp1mr8YIAgKrqqs/BrbvOWr1lMa5egJ0WWQQAIhqXgAEqE9BQu+3OuilvL7W+FZKOAmHvYuBkwl4rV81WCB4CmNtgncag+XfKyr0bWyiq7kK2MDQdb2dPALUtzPWywznWolWoFcD/fv1Ul6pE1DKjVmkiloGPgMvPTh/qpGOWjsGoPeZUlF9+ypv//pVTspyLe5S3n/paR5YynvfweDt+qzzEAn5CWhkdySGR2NKMD4+1oH/c5WAsv9lO9qSqJZ5k5LbNgukKuerrxUmKrSXzyTQ2moSuJEgiiouIKBfAPBTpWO0IzJS9rAsWNAWPLR0ZQw9VyIisH1UQcnXnJVdSYjg/U/Twcdvl5/fewzejv0ZSlZ2SDmhsLs7t5w+I2yIozwjwwGxjFcZkflh+iz1L7VBtW+jzc3pzM8CwoyGUM7hBcjz5YIKqTSBaWrWWbTxcVZ6IHhgYNMAZ6Vv7ADEk4J9jgUBE1TpiConQzls5WJji2IHStN+8vErCEzzpSqlEVtnVG0dylnZEioQmMf7y7jnzXMTEDjBF/aHAG/n/YHD54us8xDE7WjurLVXuPDDlAjIiUzPyTcY8ImRKSBAZH0PHJAFF4+/jfDwd2wl5c5jw8xB9cSAzVeeL0tleZ8gpYik6yRlQp0KMSkrXb3uq2EXvpv8LmWluWNFEIAqBDcBqnSMTiQCEH7R/D2lu1ItkJZdBWm+aWkj0qq2YjtnZbkKawbvf4TQ39/d3d/Pf/TZFVjg+xID22l/jv6aiyYOP4DECBNQX9HgKMx3VRAB0Q5k9nNiiYCUICaA4p84ejTCp/25zQ21zCCgvHxmJUZAoYEJkOcLLzQMDE5fsRcaLDQ+BA5to8IwImCA4qcn7cePX6cSAG8zI0nj8WJ6fJQqHeMdiZH5dPk3IXyjOf/rkC5fhF9QUFp69jkoNOSsLBdIzOD9ScGcf+gio/GiQ+dfjxcYMV2SAN6O/YGJzcaJQuoSARXfFDkiwztiYjPzw8opNZcSaTBGRpYnwhwT+59/WEijfux/heI4URk+8+aamZWzzTKNPUyebxKZwRURwskLbSqatCj+nTsPCQJ8/Dyn35kAY27nV7VaAiZdDAjT03gUfdLl79rVbcxw5M+mvjykMEePSyutikPpKkvXEtkxzwQA2wzANv6jT0RBYJcggLfT/ofroKK2NSOi4ZOHOEBAaE650VEUkwkC+LGNf5SkJRFwzWiaGm08QbW+xxxZe/dWOvdmhs901EzP1BAgpO9UR74U4sBZbSYm4KNtOz8iIAlLSlGVSgoB/vUDQWb+bSAIGMnnTlL0ivgcXP62Tbu6zZE54bDW+toPI6CrNC6utPQcGgEsXRE/CGDlxe1Tt8Ay8NAtz9KffWBmtpXCv/NO1RFip9G80+hfh+MTAfmFFbGO0AUdMZnhsbPLUzLSMQjQ05kY5J8YGUv7L2scfaB/XOMLtH+8MysWU9tAT0tfX7gkwGgdIaWvvlZZEPAhj4DPQIDOoYIJ2GdsQFkiDDLcBJyvFjzE5+Dmtys7qDwW1ZIgAFJza0HaCIRf+v3XisMD1+IKAoRIsaRmp2/nP/pEzPAkgM3TcAecOFwc35Gf73C5CuubY9rDQQCMkVPgCms04kVkfvhs3v/9/nHj+hE/E1CE+LmYt69vtyQAOWSY1UkCZPyybQ7KkupCP9yG+ImAG2vUyXYyiLyCCfBvaPDXEGA8Xy14iM9v67Tj4u++dPduJiCgYF7p2WdXVZ177tenfT9CODzw58Wx9OQMlq/9ppvsvufSn/EVmAECKEGnOkIMP7TN/9A1fHwiIL+jor4+ph7FuUxAeUo+EwBvcBDA+7//Pp8PEyDiZ4AAPl8iQErfE4cPc8GSBNr4hDK/Wrb9ieOp8YGAffvEF078NmDpeI1a4DC1vjYxJ5YQDuArMCuwC4MItjaY7Kq6lmtz5VOApScr2DE3QcvjP4APPZ9fYpyyljdetMkWFnJ2lghIsVgc+UYjnoL+QeGz9ftP5cd/bCxYIJhk1tn6F7XC+qzzeP32K94ABAEXAyCApOONkwGRtT1rSLxaPQzAP4qwdKk34wvOEn/xKnDUmzBGB9477w4gj7frfX01hg8MvMbfYRZLmHAX4/35DfyOydjbo5pZJn1zvSXUUmEBVb4L6D+f/yMKQKYRvPKSBgeTUKp7gdT0c3XSNSlaZqzjo4upse0DAVFcDHytgmt3rwDqLNQXbekwAaLAwky1x3w8ofRVua/P4iImwwcGNQ198OBBLy2mMlQSnQGLF/vOnD5scyCjTPEpVnZhFjRtdkrbHX8U4JVUUVFfUeF4z2wjWHN9NtZ5SNFop8PBZXzF6dmjID0/ePjh4vLyYsXn4davd0mI/uKh8CWm2Wwz5uN2ki8xS1tRsMDHQy2ytnfzTn3tMLLQhocNAcETpOPEwaHeBz0IQLM5Q5ixzX4iIzVjZUZ2yr0ls8gQvEw6RNCdZm8+vmLjbXZjsGfbnTGdunBEgYa31/6KehdKS9dMkVlfH79JfdousCSnK7ANPviRlgBIz4TmDx7+xlUyq6T+vpkzUeM0EwSkKSil2l2y2AQBNTWoxiSLTZa2ggA+HipRAf65DxABOBN3HpMImGS42cClc+w4sXmoNfVlDwI4cDm7Ezt7UmpMQkRIRMLqEkYZHCJYOmeGH99xfDcISDWkTvHwPU7npplhskADBDhcaE5fY7EycimrmqvxCU5yBoIAZ0YqbEKH5W678VgFcsz7R4/u3MsIy7ZZFaQCtZMFAYsWGY3bXmACRgoCjGaWtg8h06Ma3N3+4Dlau/xRAd6CAJmCIQJsqanW0zUE5GjihxvdsOyYkEC/iLensB98SZl0iNiLG+bx3cczZ4832g1TZPxyBKRsYTM04XiBr0CM0+VyrrmYSwKmjB+6o2CS77qFC5WSl2hnW1tloiUE99yQoIuoDW3WrP19eAYMGwY16uuN2IDsXbtkSQwREGrYtuydDiLgHZNa22tmKawYQsRUiIIFs2cWOMgA3Ky+tuy2W63eY4d4jgCKX5qxPZFhD5oVaX9xeiPiBwGKQ0T4pszdxzcdnz0+WG2rpPoD5fMofiYgz4HLDygjYKhrfqDvsGTFwQEEVGbh8o84e5h950RuQ5vVtx8MjEP8RIA4YEJX6S7hQEG+xKGGmnfeWW5sJgLU2l4LZX0VApo3SkcIszZ+aeCw+D5gJq8Qcesv3t6bdyN9oBCwocKloKmpyTW4KmHx4mGLnVOyED9QdmxvZlvbk20gYNPu3cfDmQAZPxOwfosYfTTbRZ4kXhdQ/z6AEUfCYLz3QGDwsGS+/A8IAootCfh2+gUdIqlMI2B0H+KfQfFTZ6c6AjgLS77Eoc3L33lnUUcz+RKrtb0Wer86AmKE9jfrsrj06j5NQcMvYzdu5OsvQStKuGd3z8g0Bc7CzY/RyASobYAQckPCTdK3mJukqP6A70G4Aymf52W1EZRvsTWXtHM20hUSndEZVrQt4vKPFFJ58jdNfXPm9I07wZnJfaZt8maxU6D5PCKgbhkufkcz+RKTtJUE8PvlPeD55/kxcPfa0++RM/EA2d9ByRnuY8cV4RU2NSo1dcpULQHlhoxYEf4ZggAZ/jyE31g1NV+N/9iQ3aZp5Fs8nCDOn9sBRDl0SBSyxl5jgy/RZnWnQfunwdWcgPRG3NEgKviZkNs8XErJyW8coJo4jh+pWZNH29pVw88jX2I00eBGENRMvsQsRQUB/H4qxmasB2BuFp0jg+dmrefCxk4iAjhLTO5x08JgTD9pWpibAHiRWSIRvyDgSRDA8SN8ip8IcMdfXX0MBJBvscZHGN5iiJ8IyL5wTDYISLUB6n28FtpftrkxC0d98JCy+9e5peR57FEk8SkI0ElN8iVGaVxNjdFcCF9isV0QwNvXqklvgAjIkUOAAQImGW82KlVaIOACOKmOBwMqATnKUwA8yBEgKWACshQdn3kcbYDsW6w5v7UYeQSaqU6lEUBunLUCbxOGfr90A5qtjiqAYuqsu0yVkqjj9YBeatLmGmRlC4NCF7m3hwbR/zmPtq8FtPZm0bpaXsg/88sWNcuJ/81QGFCW01DA8k+iCsD+HrtwOhonqIh9pZgCYpghfIXF1RcNegLu1rVeb0+p2pDkmTcmWenO4QI2BXJIXRYVdUWS5h1508aqWXZAX2sszNDUz1uvgvXzKZf40MwX6R0puCXvVeC009T0uSZGL5aimlrgsbq2NdPARqFSAgp4++juYqdmsawwesRrpbPNs1Y4NcpiycbuLqcLv7OzKqfe8d6XG0UWF4Djg77WGFIaULPU6kQJpm0efXTtqZf4GFD8vkx6RwquRdYsEeI9aRSyppw2JYwHATiQphZ4rK5tDVnV6kt8gbQZcVuxHQEmInBgMyAIuIZqd6Ujg00bPhPgb8/KaiqrbGrLbNkNApAvp/dI5OprjSGllx9oKiiQWV8QgMB/+OabH14ngIBTLfGB0IXXGQjQOVLk0WSvcJTg/b1HjRmT3NWVfDWDCcDxNLXAcqkrV0y3UGKUVv4KS06k4a5IvsFGg82W4pTxny4IQPzI+E1sngil5yZABvhCtr2msrKsrL2sJbNpSWwYCHjpvQx1u77WGAQ0lXVtLaiSWV8i4BCmYcYJBtby8ckugn1ozf5iBHD8TIDekSKPJns1S4SMRU3pxStXagkAnZpaYNGuHjElLcIqCVhY2DCnetjWrajuRUbI2L1ypc3s3Mzxn75ZElDnP3L4yJ3NUHoKAcoVDsKZVFa2tcMvP65lScvUOx5JwdpRe1ezozwmS30CRslaY5WArtTcLrmEBxMw7hmgkVYgen2tCDg1JCRVU5w9wPEzAXpHCnah1SwRMgQP3ITkZDseusBz8V6cNVVrgQUBFYGrdwRWSHO0woVz6ue8m3z2OaVLUZxs6541q9uwsuH4McJxk5l+506sI9P+kcNJKofILyjPWI7CXB0IaI/tmUEE7G8JuyPSkIFs0XEpTVuJAG2tsSAgI7iKs54gAN/9ZwjjBAHpQnnWObOF9BZKEvFLAvSOFAoBSOLheIIAFDFnX6olQK4mp86vm8v37i2HYwET0DBnznx8P7efc24ptmMEVNhsIe4sKxFw/sSLzIdkgYM+CxtKBLS0NM3vw11uMBNfgUhaNkuugLYaI0CNX0rpAy1dUWVx4v0g4NFHrxUj4DUQcKcgIDUqCgSYFQIGZPyt75r0jhRUIHF/ibpECBEA45mNl3KPPAgQq8npCDBmwARItKlRre2cBvpl0Ps4B2zrtmVPkPFJApBTbTbX1TWPBAH6goWhWI+wMhMFUC0tRwaXbAYBuP4Z6nS5rtaYf0scaKqqKsX7FQLoHnBtx2uCAGVPbvNKZwKMRhl+77smvSPFipmo9OD4BQFGIDk7N5mPgQssaoU1tcB6H18QUN9O8QNzh3LACcPUggQmgB4AdTv9rxl+1clLbnh3pq3bvHl+S8sgsGTzbBCwyuJu6zHX6muNJ9MSH+/jAPx+IgC3vh8OH0b8TADf1QFaLg1marcyAQNMQG8rCNA7UqygUieO/1U+Ht+YduzINQv4i1phtRYYBEzx8PFFbW77EqXN7N2rva/tDtEvqWH+uyU3QMDqrErG5vDNRMBe7ZoarfpaY7HEh/r+9fT4B15nEAGA6LYGmACcungMAia9IwXXInMWex4fz6wWTwgChhJyGd6EC7QqDTB5ojVNV5BAVN+od3AANJP0c8NUeTo7r3U8jqsuqaGrNZZaW33/ep37WR5B02amb03TO1LQXis2cIGEPF8mxw0vo4TSO6lRngycm8f6c3mL895Tz2D7IGRuUvQR8i6Tvr46qXoGgAINLomYCgz19qw/GeMMv2l8uPNxxQhZ3/ZmtCkwQ1pbLM+6cQvDKODuHLuccBrjlFL6KkDbR6f3Fc5YzwVaAi7X3WshTRmyE9NUbFxsSHwPwJewweXaHw2dW78SSBPS9Ko6T6l6BrLHqATOEXg6zDvbZseyvAEy6zu2MiElISTFnuh0kt1g1lSeKFXPx6Jvw4MpitYW5Rb9+bO5GytfIX3VeISPsFqwIXyJ9b7C/kgZKVnrzrIyFwhwNyPj7rTMlFecQrGvATrLmpYhY5SV5YLUTGNpSgURNVqpCgJycvCDTVr0gQCbPcAOF6ULpZMUChsnTAAdYoa/CATgt4Z6PhabgWtm+bUgQLPuDlas0J0/CEBgmtXx1HiEj7BnBsq80+slt0cwrW35yB14g7L/fU1N5SBgUd225prmZvzT8QIIWJyBq4/w9zaVHXiBCWgX8Z+tFEQs12QYckHADcgv5CN+SUDqJVi2WcQPAi5IwHjxi9pRVNQCFE2FoUIGtxKuIkxPeiUxalSq36jixYziFZ9tOwQoo+DDZyUBLpdRIQAXViN9RTx3bdnyKKUh7lrrE8J1pAUFUqh54bHEEBO6L92xXsaP3ekNdxIBzc11zXUdy5mANcZVxmJx+V9A3osIcLnjv8SeS1ng5WrbSOhS/ZIYdlsCHtDSIv/C8UUJiVEbEzc6isKZgLAVM+1m+xrCQWBNdN4jAci8+zqJEJTu3qp+PTRSuK4C+dHl/BoE0Fp2Bw4I6QsCEM2WlIwMUPDoQyCACyZm4IRYamsJoCzFS3dgvh1QZpxLvkCWt3lnc0dH3aLlNcsQcF7kquJVuPxNB16QBLTL+M+eYIew4CzwIqVSDwREqPETAUNxBTTl9xfMjSzescNZviM8fMCR4ggHAZhtUOJ/GQQsDh6VGuI7cxURsMZNgHL8IL5gD3f+8ENPA7JMd93Jnz8aNSaHxep44oLiB3IK4gcBomAibdy4UsSvJ+AOEKAvOJisLqbGAa/A+HfSt5/iv4wIcHH8IwKy3W12y/3l+TEBFL+6GpzNMwucixHEX38QMLBsERGAG4wHAaHOmc7a6Rw/E6B9vyRgeWddTc+yh4gAWcDR3y+lr/ARvj09/faHeLuQ3jNQyS1Xm5u28WfCbwI/t+oLDkiaNjMKmwUBaxo6cfk5fiKggeIfRj/OcEtpvhxZ4EWaR23hkJynn0b80qP0uTAmQOMHEO1E/JVU4VS0bFlReNjcL38W+Jjwc+/4jW/nTg/FuuF8fuvmHpSOQwC7zrBP8H03d7bcdwNPtbEZm0b6Ch9h3Ai2KFNxbqXGaX0vvXRFAB7L0REBYt21ukV0xfPqcfkXyfiR9Y12pQ3zTbCiBubQRcOx/+XXLJqjdWgAAc/h+iN+JmC2TY2fgBGgVHjtxlK54WGn8AkOsEepr1es4tEB5AEHo0Wef0ts7O0iQM5Sq6vjgQB1KpK2mw3ysy2M0JPa5k7K8roNKd4hmOZ0lnVqV6ML2+Vn99/ZXDdyotj/suWeDg1UEIG7AB4CjNlmXe1wvJPL3ABRkPFPPsG3riIo3xEQIGcZRZhEgPoUoP312y93t/HJ1eZOMifTFRwAJi2ODr7g8frdd9+/6jLs7y5AMHmC5B+yzO4SB5Jz0gwil0ACkHPCEv/kE6zvslOFsgCXVyAHitU5dFJabscO2iy211kmT4zXFUioApyxoiF4UrCKKVfrs7TwRvFwJt7Rdvqxj4cc26Skvrm0gl0hNrAWlu+9SpGm+uONB7T11nkEFvj4B2jV7T958uPT5k4+7zvluumPZxZQzdSefEVncRHlKRXvhLXMI8WPKHeeFfWpU66+2I2bxuuztDeopjkPA2+dIWt9xSIwsWFsniYW1SA5PFYWSLg/T18wofcN5l+D5JPlqidtkGTq3OXx+ZM7MLkB++7QDp7BMZ3sU5zqB6td5TUIeH29RyelT9QkjfEuCPDw+gIBWEYZi2lLPL5dn6X9vkK7uvqun0St78bg2KL89vZYIgB5e9EoCCFABCRkB4waFSgelWVy9ThVCut9gykfkJ7TiQVPmnqK1tyfZJrfE9ilfj4I2LFxdce+jn3+b/ASG3x+2Zj/svtJn+JRtByesj8IwK+kyFSLgoU+fl1pJcDoRrqTNvanpKutuUBxvXVXdwgYUAjQL2xMxcvrqhcutNqruc3tmFzSIraoKbCqpWg2ETBTNEqyEPLB9Ugd5et2f6tkSyMH4AQc0eK5H1NREWHj43OOL316J9DUfpAIWNJXUqDWOk/uwFjZV7gv1PLGp5IAX7vdzzfAHjJB+BRnj4Kxsbrw8hkPbXvo0ewQBe9CKnaljR5dMoj4B68dfcTgqbUt9fVL2g3Z5yhfKzYsMDaT+dghiyQgrQWPgVBrbkvuu9W9+bLWt6ioottNADu9BUIOEwF2q93X94QEapI4feLOOhs5/u6KCmuMQkBDw/T0+9e0d7b3HLw/2tQQtHB/ybw0WTsMAlZvWr3vDf+gjn1MAElfu1+C1c8vdQJtlxdMXXj5jIefKXxw/c8+Er1QSl1bYex73eC4/bcNjpMEpNTUpIiChvr65x21BssxBXRArK6N+M+/iKRv647OzoUNDXMKl7TX7tmDEeBYwKvLhYe3NLWAAG7MdHG36BgmIISywr7utrloJ8evpt0pfuSpkaN2kfSFUnQ1dC5Ys6aop70FvxVMFqyEg4qVNFkLfB4TsG/fGxQ/pu9J+dl9rX7D7NZRtF1XOwwCHq149MEv8UoABPAIaBwcd+2rg9cyAXyNm2XBQkPnlztiUqBZBIbwCGCLjzp/MxPgKK+GCij0r9/elrO9N56qLlnptBw4MBg+m5e8cFH8IECt5j7BGH7iininev1PT9osa4PxiypGSGsQ0NlQ1g4CsEY6pDKPgMZ5aUoW+rw3Vg+sw7y1nL4XBASEWBP8Un1puz5r7XXWaw8+mNJtVbDQZ8LWNEUJv/pqY3+k+v0X94DumApHtLpiob5NjdvcPr7utsJaavOSBIQTAZktLWeFzz6dZmpcFH8ZF0EtjaCeYVmQgIWTk4o1M4+VWVPNuuODgPbOpibcAfct20cEzJ+zv0TMoigEVK/m+CUByDonJEwYAWfJS2i7LmsNAh5c/60GV/gEY4EkjVsc33SgvbDEHdTXqlvxFFgQPUSF3pzse9z+GVWEgp9AgIj/0ieBcNPp90xfsMDF/cJXEgEbIsoA8l0mxA3qzdN4Ieh3VOmNLG9WT1N7T0/PvmUvEwFL+maUqtIZBLy9eqMIXxKAeO2pVmvCKN6ul9pev6z/9lktAd471BwtcF6e6vIEHkBAyu54TfzxenMyOFMzygWGTOXHP0HU+t56j3ITdF0IoJbX8/N88MiWE0sEb/1C0LfiPJwNrsCypvY3yHHC1FMwSiOVQQAeg7J8AzD9g7TGCPiOcYWCabqCB9XxVqAt3mPR1l9MOkD+aZ2Jz9CW+tL205OAQV43mBPQemmql776haClFI6Pjxbo1e1vMs31qDn4J2ntpZeKVgzkB6y+7tetEr2M7b0vM2B6JrerWdbLTxzBB+qzynqCshT4BfAMvX7JjPjElKypUxMdiZI3xV3CIrPEdDlOkyDmXj1yhMsfFOxou/XYx0mQ3sBUQH98fbxeeql4jq1h/vwGm1153bpDwaZO16ae3pdp4QG4aSvb3W1uFzWW9KHAAQUNgFrQYFINHAmmLMMW+sv4ovimN5htFVjj62HCzcDp8UYkiOm2K+6Cs3k1OpRVKlnhvPe43oHTvlSQ8X7UykPyNWFpkpDexe4CjgqrrbvCUIG/u7u7K1z6eEWBREKC6sBgt7UvXDjfliBf66XpyzcXw4UX5dlyu2JudrgR1lq37R+k6WwOXRY0cIpN9SF+NWuLdCDBrDD8xqZYUHpbwfe8dEJkfEa6IyMyIzIofDM1SIAAIRttstY3773pq5TjkTna+4unf6M5/lLZZrfaXcBRERGD6CNKbLaIwLLGTindu7oUKcxS0Wq1qw4MCWBgznxriHgNy1as2vQmgMLNuI4hgoDp0y9Us8Bk7tXYuB/3wMHGfhCgncpae5pYKFlK3XlHs7YYHzM+Zn5sPY3LWeZCEFCyEi1jW7bwyh5vtX6ptAF+DFSblMXYbObuzs5uKwhYtQrF2qNJqpOP8WlEsOpzvEFI7417Kzcvwn0QBEBDlJQsdux9zzXuSFl3EMULFMxQpDCEiJ/Nb1jACOswxYEhwTZ/DjHAr/F+Q4qM/+mON0EA1ieFR+aFQkoyAbj8TXPQlHek8dAHTMBTMn5MZgqhk91gtIv9s7Y8Rlj/li8oP8dvndkaE2M1SpdReIzqsr6FICCCYMzo6Ww6UiEIOHzg8OETh6+l2uM8nqVIxwDiLHJSFknv4tq9mzfvq2letjnMaQx1BZY4sVNZo6sisZDPZ96M0aPj4s5mKQxlZLdhPCOppUhFMICCgCXWEHptaG7GIBDxPx3XEX36zewRugBnL9vi6PL34RnY19j45utrP3n4ecKbEpdCGAHGhiVGaoDfjnsALr/lQf8P+L6UXm+hiSCcvkShrna4cKkwWcFPIXNPj9koCDgwsbFxeP+1JJ3xGvEXrzlYnIEs2ZqkY85KVHdnEQF1ze+AgIxIgyHCFpy7uqy5OAMEsI0vjZcROH8mAPEGQCj5ZZ/rlooh1iW33bbEGoXXMRUx3Rkcf08cLWV98kLJB+jyX4fLX0fT16d5ZpVp/UASxsaL68XqcTwCHnzrg5eZQb/qG1J4+Ct4K10bv4YAY4WrtrY+NHSFGAEnTvQfuZZylnjN8R8EA5QjjHZL6X3LQMDs4sgUw7JAIqAx0uEPAvj8S5EWl1KYpKEd9Xw0Ia9KRTDwwAMLU6PO9jZ0d3P4lOmJewME6KTkVa6SPmigvsbDb74mCFDjJwIGXU3AEQX70Umi+qQGpba/fLNqsksE97KUdsO0IUa47GCuqbbWbAmlgFHwcWI4jk6lt71uvwdRshOfpfyU6Ozra9rMXWaNByqaWppccUGQ0uL8x20dgaSxJIDiDaH4tVIxxLrwgQfmpIZ466WpXkp+4VooLj8qWCQBavyvjtvwjOfrL/yy/ahVW3yDfAKqM/j+z4Crr6VQ5yvMBAQCZloMGgFQVrgEXYX9OBoRoD8fECB/SvUAggBzs6UszlVcaGYCeK0KavbD/kzAqaUixsB1ty1J9e5Vbsp7qvYgw3GStCQp3NdY8vzrDBCgPvUIG3y6BLYKeAepbFrS/f27XlZshm9gRF/h6SsMAuRTgN7DBOArII7feKqCjHihH+QwYAL487qRpmMC9FL4r6Virgmo7WVAYP7Ue0ppif+1/4sTH7izrm5jsA0C+v2nELhEpJrhr1teTilEUCCOcvRortxpxYqkJOXopyrI0LflWdxrTwicJIUf2GCaq5WGSTC4nzZtndvyIgzgo2G7B2SNw1VXjQw9R/N+/epzQZM1OWZgnhszGJfq8MckTbGtbdIfXv82TD0xAzs00jDJiaxncIIsY1s3Nyy/PMgRCTsouR0ODVF+qpPt2P66ukOWBPX9l9cp6CkoaEk7z2io+YaADlfCVaNHqEBKqErGHa4QkD3l92xeZZWqAX+fku31b8M0vy8QpbCKFGYCVq97e906tvYhAiLb2spRmy+2gwBEfoni4njJ2MGYi5ZftDNhgnw/CLhIunuPXJ6WVjMZN9FOrRSeN8LdIgkwAUVFOQtynAvuKSrCC4Ph1z9+tRm6ugw2/MFg8Pq3QVnVsq+q3VlSImAdCEhel2tMTU5uRYNCZnkbehPk9pBsuwLy6LzQ1BlxzfKROy3yfweDAMR/jSwrWT7ZuDLBMCBvgj/9tHU8CKDoq6q8CRczAU6MAAyBBQvwgi/879lRUfRvw39BgCuwqa9MWeh4jkkSkJycm1yLv0BAZmI59WZI6asvUKC8PFWLi6zGyCtAgDR3H3PObQ+keUfFzAqJql5XnZzMbnCt80Yg/LRzq6puSsPEEAgQGOjJFH8wEH4dExx8MS7/f0JA55KyOftlv8WGsj3JYi2L5GRj7eNvm0FAW2Ybxf+LlL46qUq+vX2B15xPFilw9Zl43uV1irm9IMAeMmuW3Sj5hRIUBFS99VZV2lg3AZkopJQMSJ/jm25KMPxHBPS0NO0vk+eHE5wWLK29UpPffhwjQC999W1uuIeU1cD1REwlnT8ZBMjhf+W5D4AAc8isAnM1H5L79ogA79KqHxdV/aQSgPjBQLgkgG8D+Ps/ImAJrv+c990LKU9bLU82udZci2puvfRtL9Sux19/namzERUFO/3FdGBklljiYqRKAHyWv8Is4k8//cQNGCDAG6iqajmGphVJQHgPCBhQRkAqf/v/s3vAEjV+QQDHT0DG7vFWvdTEkFduGDxiBiOoXWLxGqVgQV3i4qZzHzCVggBzzziNFJ43huMvrfqpCk07IICR2TMwHwNAfQoA/9VToM+15HzNQspz8fgHkiUNraeQvu48MGDqp6fgYnfFQrS6xMWFY667rdTbaK45wBBGF5fNGKN1uU0GAYz5bh1wCS484T/TAUdNk7ULKSuFvK0SJ0lfHS677MzyFZrV1NQlLi6Aj9dYb3+T55IXM9CxogAcV/3vSvC/Bj1utPD6n/EnnaQbrf6BCX0AAAAASUVORK5CYII=)}.react-tel-input .ad{background-position:-16px 0}.react-tel-input .ae{background-position:-32px 0}.react-tel-input .af{background-position:-48px 0}.react-tel-input .ag{background-position:-64px 0}.react-tel-input .ai{background-position:-80px 0}.react-tel-input .al{background-position:-96px 0}.react-tel-input .am{background-position:-112px 0}.react-tel-input .ao{background-position:-128px 0}.react-tel-input .ar{background-position:-144px 0}.react-tel-input .as{background-position:-160px 0}.react-tel-input .at{background-position:-176px 0}.react-tel-input .au{background-position:-192px 0}.react-tel-input .aw{background-position:-208px 0}.react-tel-input .az{background-position:-224px 0}.react-tel-input .ba{background-position:-240px 0}.react-tel-input .bb{background-position:0 -11px}.react-tel-input .bd{background-position:-16px -11px}.react-tel-input .be{background-position:-32px -11px}.react-tel-input .bf{background-position:-48px -11px}.react-tel-input .bg{background-position:-64px -11px}.react-tel-input .bh{background-position:-80px -11px}.react-tel-input .bi{background-position:-96px -11px}.react-tel-input .bj{background-position:-112px -11px}.react-tel-input .bm{background-position:-128px -11px}.react-tel-input .bn{background-position:-144px -11px}.react-tel-input .bo{background-position:-160px -11px}.react-tel-input .br{background-position:-176px -11px}.react-tel-input .bs{background-position:-192px -11px}.react-tel-input .bt{background-position:-208px -11px}.react-tel-input .bw{background-position:-224px -11px}.react-tel-input .by{background-position:-240px -11px}.react-tel-input .bz{background-position:0 -22px}.react-tel-input .ca{background-position:-16px -22px}.react-tel-input .cd{background-position:-32px -22px}.react-tel-input .cf{background-position:-48px -22px}.react-tel-input .cg{background-position:-64px -22px}.react-tel-input .ch{background-position:-80px -22px}.react-tel-input .ci{background-position:-96px -22px}.react-tel-input .ck{background-position:-112px -22px}.react-tel-input .cl{background-position:-128px -22px}.react-tel-input .cm{background-position:-144px -22px}.react-tel-input .cn{background-position:-160px -22px}.react-tel-input .co{background-position:-176px -22px}.react-tel-input .cr{background-position:-192px -22px}.react-tel-input .cu{background-position:-208px -22px}.react-tel-input .cv{background-position:-224px -22px}.react-tel-input .cw{background-position:-240px -22px}.react-tel-input .cy{background-position:0 -33px}.react-tel-input .cz{background-position:-16px -33px}.react-tel-input .de{background-position:-32px -33px}.react-tel-input .dj{background-position:-48px -33px}.react-tel-input .dk{background-position:-64px -33px}.react-tel-input .dm{background-position:-80px -33px}.react-tel-input .do{background-position:-96px -33px}.react-tel-input .dz{background-position:-112px -33px}.react-tel-input .ec{background-position:-128px -33px}.react-tel-input .ee{background-position:-144px -33px}.react-tel-input .eg{background-position:-160px -33px}.react-tel-input .er{background-position:-176px -33px}.react-tel-input .es{background-position:-192px -33px}.react-tel-input .et{background-position:-208px -33px}.react-tel-input .fi{background-position:-224px -33px}.react-tel-input .fj{background-position:-240px -33px}.react-tel-input .fk{background-position:0 -44px}.react-tel-input .fm{background-position:-16px -44px}.react-tel-input .fo{background-position:-32px -44px}.react-tel-input .fr,.react-tel-input .bl,.react-tel-input .mf{background-position:-48px -44px}.react-tel-input .ga{background-position:-64px -44px}.react-tel-input .gb{background-position:-80px -44px}.react-tel-input .gd{background-position:-96px -44px}.react-tel-input .ge{background-position:-112px -44px}.react-tel-input .gf{background-position:-128px -44px}.react-tel-input .gh{background-position:-144px -44px}.react-tel-input .gi{background-position:-160px -44px}.react-tel-input .gl{background-position:-176px -44px}.react-tel-input .gm{background-position:-192px -44px}.react-tel-input .gn{background-position:-208px -44px}.react-tel-input .gp{background-position:-224px -44px}.react-tel-input .gq{background-position:-240px -44px}.react-tel-input .gr{background-position:0 -55px}.react-tel-input .gt{background-position:-16px -55px}.react-tel-input .gu{background-position:-32px -55px}.react-tel-input .gw{background-position:-48px -55px}.react-tel-input .gy{background-position:-64px -55px}.react-tel-input .hk{background-position:-80px -55px}.react-tel-input .hn{background-position:-96px -55px}.react-tel-input .hr{background-position:-112px -55px}.react-tel-input .ht{background-position:-128px -55px}.react-tel-input .hu{background-position:-144px -55px}.react-tel-input .id{background-position:-160px -55px}.react-tel-input .ie{background-position:-176px -55px}.react-tel-input .il{background-position:-192px -55px}.react-tel-input .in{background-position:-208px -55px}.react-tel-input .io{background-position:-224px -55px}.react-tel-input .iq{background-position:-240px -55px}.react-tel-input .ir{background-position:0 -66px}.react-tel-input .is{background-position:-16px -66px}.react-tel-input .it{background-position:-32px -66px}.react-tel-input .je{background-position:-144px -154px}.react-tel-input .jm{background-position:-48px -66px}.react-tel-input .jo{background-position:-64px -66px}.react-tel-input .jp{background-position:-80px -66px}.react-tel-input .ke{background-position:-96px -66px}.react-tel-input .kg{background-position:-112px -66px}.react-tel-input .kh{background-position:-128px -66px}.react-tel-input .ki{background-position:-144px -66px}.react-tel-input .xk{background-position:-128px -154px}.react-tel-input .km{background-position:-160px -66px}.react-tel-input .kn{background-position:-176px -66px}.react-tel-input .kp{background-position:-192px -66px}.react-tel-input .kr{background-position:-208px -66px}.react-tel-input .kw{background-position:-224px -66px}.react-tel-input .ky{background-position:-240px -66px}.react-tel-input .kz{background-position:0 -77px}.react-tel-input .la{background-position:-16px -77px}.react-tel-input .lb{background-position:-32px -77px}.react-tel-input .lc{background-position:-48px -77px}.react-tel-input .li{background-position:-64px -77px}.react-tel-input .lk{background-position:-80px -77px}.react-tel-input .lr{background-position:-96px -77px}.react-tel-input .ls{background-position:-112px -77px}.react-tel-input .lt{background-position:-128px -77px}.react-tel-input .lu{background-position:-144px -77px}.react-tel-input .lv{background-position:-160px -77px}.react-tel-input .ly{background-position:-176px -77px}.react-tel-input .ma{background-position:-192px -77px}.react-tel-input .mc{background-position:-208px -77px}.react-tel-input .md{background-position:-224px -77px}.react-tel-input .me{background-position:-112px -154px;height:12px}.react-tel-input .mg{background-position:0 -88px}.react-tel-input .mh{background-position:-16px -88px}.react-tel-input .mk{background-position:-32px -88px}.react-tel-input .ml{background-position:-48px -88px}.react-tel-input .mm{background-position:-64px -88px}.react-tel-input .mn{background-position:-80px -88px}.react-tel-input .mo{background-position:-96px -88px}.react-tel-input .mp{background-position:-112px -88px}.react-tel-input .mq{background-position:-128px -88px}.react-tel-input .mr{background-position:-144px -88px}.react-tel-input .ms{background-position:-160px -88px}.react-tel-input .mt{background-position:-176px -88px}.react-tel-input .mu{background-position:-192px -88px}.react-tel-input .mv{background-position:-208px -88px}.react-tel-input .mw{background-position:-224px -88px}.react-tel-input .mx{background-position:-240px -88px}.react-tel-input .my{background-position:0 -99px}.react-tel-input .mz{background-position:-16px -99px}.react-tel-input .na{background-position:-32px -99px}.react-tel-input .nc{background-position:-48px -99px}.react-tel-input .ne{background-position:-64px -99px}.react-tel-input .nf{background-position:-80px -99px}.react-tel-input .ng{background-position:-96px -99px}.react-tel-input .ni{background-position:-112px -99px}.react-tel-input .nl,.react-tel-input .bq{background-position:-128px -99px}.react-tel-input .no{background-position:-144px -99px}.react-tel-input .np{background-position:-160px -99px}.react-tel-input .nr{background-position:-176px -99px}.react-tel-input .nu{background-position:-192px -99px}.react-tel-input .nz{background-position:-208px -99px}.react-tel-input .om{background-position:-224px -99px}.react-tel-input .pa{background-position:-240px -99px}.react-tel-input .pe{background-position:0 -110px}.react-tel-input .pf{background-position:-16px -110px}.react-tel-input .pg{background-position:-32px -110px}.react-tel-input .ph{background-position:-48px -110px}.react-tel-input .pk{background-position:-64px -110px}.react-tel-input .pl{background-position:-80px -110px}.react-tel-input .pm{background-position:-96px -110px}.react-tel-input .pr{background-position:-112px -110px}.react-tel-input .ps{background-position:-128px -110px}.react-tel-input .pt{background-position:-144px -110px}.react-tel-input .pw{background-position:-160px -110px}.react-tel-input .py{background-position:-176px -110px}.react-tel-input .qa{background-position:-192px -110px}.react-tel-input .re{background-position:-208px -110px}.react-tel-input .ro{background-position:-224px -110px}.react-tel-input .rs{background-position:-240px -110px}.react-tel-input .ru{background-position:0 -121px}.react-tel-input .rw{background-position:-16px -121px}.react-tel-input .sa{background-position:-32px -121px}.react-tel-input .sb{background-position:-48px -121px}.react-tel-input .sc{background-position:-64px -121px}.react-tel-input .sd{background-position:-80px -121px}.react-tel-input .se{background-position:-96px -121px}.react-tel-input .sg{background-position:-112px -121px}.react-tel-input .sh{background-position:-128px -121px}.react-tel-input .si{background-position:-144px -121px}.react-tel-input .sk{background-position:-160px -121px}.react-tel-input .sl{background-position:-176px -121px}.react-tel-input .sm{background-position:-192px -121px}.react-tel-input .sn{background-position:-208px -121px}.react-tel-input .so{background-position:-224px -121px}.react-tel-input .sr{background-position:-240px -121px}.react-tel-input .ss{background-position:0 -132px}.react-tel-input .st{background-position:-16px -132px}.react-tel-input .sv{background-position:-32px -132px}.react-tel-input .sx{background-position:-48px -132px}.react-tel-input .sy{background-position:-64px -132px}.react-tel-input .sz{background-position:-80px -132px}.react-tel-input .tc{background-position:-96px -132px}.react-tel-input .td{background-position:-112px -132px}.react-tel-input .tg{background-position:-128px -132px}.react-tel-input .th{background-position:-144px -132px}.react-tel-input .tj{background-position:-160px -132px}.react-tel-input .tk{background-position:-176px -132px}.react-tel-input .tl{background-position:-192px -132px}.react-tel-input .tm{background-position:-208px -132px}.react-tel-input .tn{background-position:-224px -132px}.react-tel-input .to{background-position:-240px -132px}.react-tel-input .tr{background-position:0 -143px}.react-tel-input .tt{background-position:-16px -143px}.react-tel-input .tv{background-position:-32px -143px}.react-tel-input .tw{background-position:-48px -143px}.react-tel-input .tz{background-position:-64px -143px}.react-tel-input .ua{background-position:-80px -143px}.react-tel-input .ug{background-position:-96px -143px}.react-tel-input .us{background-position:-112px -143px}.react-tel-input .uy{background-position:-128px -143px}.react-tel-input .uz{background-position:-144px -143px}.react-tel-input .va{background-position:-160px -143px}.react-tel-input .vc{background-position:-176px -143px}.react-tel-input .ve{background-position:-192px -143px}.react-tel-input .vg{background-position:-208px -143px}.react-tel-input .vi{background-position:-224px -143px}.react-tel-input .vn{background-position:-240px -143px}.react-tel-input .vu{background-position:0 -154px}.react-tel-input .wf{background-position:-16px -154px}.react-tel-input .ws{background-position:-32px -154px}.react-tel-input .ye{background-position:-48px -154px}.react-tel-input .za{background-position:-64px -154px}.react-tel-input .zm{background-position:-80px -154px}.react-tel-input .zw{background-position:-96px -154px}.react-tel-input *{-webkit-box-sizing:border-box;box-sizing:border-box;-moz-box-sizing:border-box}.react-tel-input .hide{display:none}.react-tel-input .v-hide{visibility:hidden}.react-tel-input .form-control{position:relative;font-size:.8125rem;letter-spacing:.01rem;margin-top:0!important;margin-bottom:0!important;padding-left:48px;margin-left:0;background:#fff;border:1px solid#cacaca;-webkit-border-radius:5px;-moz-border-radius:5px;border-radius:5px;line-height:25px;height:35px;width:300px;outline:none}.react-tel-input .form-control.invalid-number{border:1px solid#d79f9f;background-color:#faf0f0;border-left-color:#cacaca}.react-tel-input .form-control.invalid-number:focus{border:1px solid#d79f9f;border-left-color:#cacaca;background-color:#faf0f0}.react-tel-input .flag-dropdown{position:absolute;top:0;bottom:0;padding:0;background-color:#f5f5f5;border:1px solid#cacaca;-webkit-border-radius:3px 0 0 3px;-moz-border-radius:3px 0 0 3px;border-radius:3px 0 0 3px}.react-tel-input .flag-dropdown:hover,.react-tel-input .flag-dropdown:focus{cursor:pointer}.react-tel-input .flag-dropdown.invalid-number{border-color:#d79f9f}.react-tel-input .flag-dropdown.open{z-index:2;background:#fff;-webkit-border-radius:3px 0 0 0;-moz-border-radius:3px 0 0 0;border-radius:3px 0 0 0}.react-tel-input .flag-dropdown.open .selected-flag{background:#fff;-webkit-border-radius:3px 0 0 0;-moz-border-radius:3px 0 0 0;border-radius:3px 0 0 0}.react-tel-input input[disabled]+.flag-dropdown:hover{cursor:default}.react-tel-input input[disabled]+.flag-dropdown:hover .selected-flag{background-color:transparent}.react-tel-input .selected-flag{outline:none;position:relative;width:38px;height:100%;padding:0 0 0 8px;-webkit-border-radius:3px 0 0 3px;-moz-border-radius:3px 0 0 3px;border-radius:3px 0 0 3px}.react-tel-input .selected-flag:hover,.react-tel-input .selected-flag:focus{background-color:#fff}.react-tel-input .selected-flag .flag{position:absolute;top:50%;margin-top:-5px}.react-tel-input .selected-flag .arrow{position:relative;top:50%;margin-top:-2px;left:20px;width:0;height:0;border-left:3px solid transparent;border-right:3px solid transparent;border-top:4px solid#555}.react-tel-input .selected-flag .arrow.up{border-top:none;border-bottom:4px solid#555}.react-tel-input .country-list{outline:none;z-index:1;list-style:none;position:absolute;padding:0;margin:10px 0 10px -1px;-webkit-box-shadow:1px 2px 10px rgba(0,0,0,.35);-moz-box-shadow:1px 2px 10px rgba(0,0,0,.35);box-shadow:1px 2px 10px rgba(0,0,0,.35);background-color:white;width:300px;max-height:200px;overflow-y:scroll;-webkit-border-radius:0 0 3px 3px;-moz-border-radius:0 0 3px 3px;border-radius:0 0 3px 3px}.react-tel-input .country-list .flag{display:inline-block}.react-tel-input .country-list .divider{padding-bottom:5px;margin-bottom:5px;border-bottom:1px solid#ccc}.react-tel-input .country-list .country{padding:7px 9px}.react-tel-input .country-list .country .dial-code{color:#6b6b6b}.react-tel-input .country-list .country:hover{background-color:#f1f1f1}.react-tel-input .country-list .country.highlight{background-color:#f1f1f1}.react-tel-input .country-list .flag{margin-right:7px;margin-top:2px}.react-tel-input .country-list .country-name{margin-right:6px}.react-tel-input .country-list .search{position:-webkit-sticky;position:sticky;top:0;background-color:#fff;padding:10px 0 6px 10px}.react-tel-input .country-list .search-emoji{font-size:.844rem}.react-tel-input .country-list .search-box{border:1px solid#cacaca;-webkit-border-radius:3px;-moz-border-radius:3px;border-radius:3px;font-size:.844rem;line-height:15px;margin-left:6px;padding:3px 8px 5px;outline:none}.react-tel-input .country-list .no-entries-message{padding:7px 10px 11px;opacity:.7}.react-tel-input .invalid-number-message{position:absolute;z-index:1;font-size:.731rem;left:46px;top:-8px;background:#fff;padding:0 2px;color:#de0000}');
phoneInputStyles.__hash = "ff69f46855722c1d";

;// CONCATENATED MODULE: ./client/components/system/form-inputs/phone-input/phone-input.js












var PhoneInput = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(PhoneInput, PureComponent);
    var _super = (0,_create_super/* default */.Z)(PhoneInput);
    function PhoneInput(props) {
        (0,_class_call_check/* default */.Z)(this, PhoneInput);
        return _super.call(this, props);
    }
    (0,_create_class/* default */.Z)(PhoneInput, [
        {
            key: "render",
            value: function render() {
                var _props = this.props, inputData = _props.inputData, errorState = _props.errorState, onInputChange = _props.onInputChange, onInputBlur = _props.onInputBlur, value = _props.value, cloudfrontViewerCountry = _props.cloudfrontViewerCountry, id = _props.id;
                var inputName = inputData.inputName, isRequired = inputData.isRequired;
                var isValid = errorState.isValid;
                var showRequiredError = !isValid && isRequired;
                var defaultCountry = cloudfrontViewerCountry && cloudfrontViewerCountry.toLowerCase() || "us";
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    id: id,
                    className: "jsx-".concat(phone_input_scss_componentStyles.__hash, " jsx-").concat(commonInputStyles.__hash, " jsx-").concat(phoneInputStyles.__hash) + " " + "hp-input hp-phone-input",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((lib_default()), {
                            country: defaultCountry,
                            value: value,
                            onChange: function(phone) {
                                return onInputChange({
                                    target: {
                                        name: inputName,
                                        value: phone
                                    }
                                });
                            },
                            onBlur: function() {
                                return onInputBlur({
                                    target: {
                                        name: inputName,
                                        value: value
                                    }
                                });
                            },
                            name: inputName,
                            enableSearch: true,
                            disableSearchIcon: true,
                            inputClass: showRequiredError ? "input-required" : "",
                            specialLabel: ""
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((style_default()), {
                            id: phoneInputStyles.__hash,
                            children: phoneInputStyles
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((style_default()), {
                            id: commonInputStyles.__hash,
                            children: commonInputStyles
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((style_default()), {
                            id: phone_input_scss_componentStyles.__hash,
                            children: phone_input_scss_componentStyles
                        })
                    ]
                });
            }
        }
    ]);
    return PhoneInput;
}(react.PureComponent);
PhoneInput.defaultProps = {};
/* harmony default export */ var phone_input = ((0,generic_config_context/* withGenericConfig */.P)(PhoneInput));

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_assert_this_initialized.mjs
var _assert_this_initialized = __webpack_require__(4111);
;// CONCATENATED MODULE: ./client/components/system/form-inputs/select-input/select-input.scss.js
var select_input_scss_componentStyles = new String(".hp-select-input{font-size:.8125rem;&.is-placholder{color:gray}}");
select_input_scss_componentStyles.__hash = "9272064ecffd449c";

;// CONCATENATED MODULE: ./client/components/system/form-inputs/select-input/select-input.js





function select_input_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}







var SelectInput = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(SelectInput, PureComponent);
    var _super = (0,_create_super/* default */.Z)(SelectInput);
    function SelectInput(props) {
        (0,_class_call_check/* default */.Z)(this, SelectInput);
        var _this;
        _this = _super.call(this, props);
        select_input_define_property((0,_assert_this_initialized/* default */.Z)(_this), "renderOptions", function(options, defaultValue) {
            var translate = _this.props.translate;
            var optionsToRender = options.map(function(option) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                    className: "contact-form-row",
                    value: option,
                    name: option,
                    children: translate(option)
                }, option);
            });
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                children: [
                    defaultValue && /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                        disabled: true,
                        value: defaultValue,
                        children: translate(defaultValue)
                    }),
                    optionsToRender
                ]
            });
        });
        return _this;
    }
    (0,_create_class/* default */.Z)(SelectInput, [
        {
            key: "render",
            value: function render() {
                var _props = this.props, inputData = _props.inputData, errorState = _props.errorState, onInputChange = _props.onInputChange, onInputBlur = _props.onInputBlur, value = _props.value, invalid = _props.invalid, errorLabelId = _props.errorLabelId, id = _props.id;
                var inputName = inputData.inputName, isRequired = inputData.isRequired, options = inputData.options, defaultValue = inputData.defaultValue;
                var isValid = errorState.isValid;
                var showRequiredError = !isValid && isRequired;
                var requiredClass = {
                    "input-required": showRequiredError
                };
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("select", {
                            id: id,
                            onChange: onInputChange,
                            onBlur: onInputBlur,
                            name: inputName,
                            value: value || defaultValue,
                            "aria-required": isRequired,
                            "aria-invalid": invalid,
                            "aria-describedby": errorLabelId,
                            className: "jsx-".concat(select_input_scss_componentStyles.__hash, " jsx-").concat(commonInputStyles.__hash) + " " + (classnames_default()("hp-input hp-select-input", requiredClass, {
                                "is-placholder": !value
                            }) || ""),
                            children: this.renderOptions(options, defaultValue)
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((style_default()), {
                            id: commonInputStyles.__hash,
                            children: commonInputStyles
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((style_default()), {
                            id: select_input_scss_componentStyles.__hash,
                            children: select_input_scss_componentStyles
                        })
                    ]
                });
            }
        }
    ]);
    return SelectInput;
}(react.PureComponent);
SelectInput.defaultProps = {
    invalid: false,
    errorLabelId: null
};
/* harmony default export */ var select_input = ((0,generic_config_context/* withGenericConfig */.P)(SelectInput));

;// CONCATENATED MODULE: ./client/components/system/form-inputs/checkbox-input/checkbox-input.scss.js
var checkbox_input_scss_componentStyles = new String(".consent-checkbox{display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-webkit-flex-direction:row;-moz-box-orient:horizontal;-moz-box-direction:normal;-ms-flex-direction:row;flex-direction:row;text-align:left;.checkbox{margin-right:8px}}");
checkbox_input_scss_componentStyles.__hash = "238ebeb04f37ba2c";

;// CONCATENATED MODULE: ./client/components/system/form-inputs/checkbox-input/checkbox-input.js










var CheckboxInput = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(CheckboxInput, PureComponent);
    var _super = (0,_create_super/* default */.Z)(CheckboxInput);
    function CheckboxInput(props) {
        (0,_class_call_check/* default */.Z)(this, CheckboxInput);
        return _super.call(this, props);
    }
    (0,_create_class/* default */.Z)(CheckboxInput, [
        {
            key: "isChecked",
            value: function isChecked() {
                var _this__input;
                return (_this__input = this._input) === null || _this__input === void 0 ? void 0 : _this__input.checked;
            }
        },
        {
            key: "render",
            value: function render() {
                var _this = this;
                var _props = this.props, inputData = _props.inputData, id = _props.id, defaultValue = _props.defaultValue, onInputChange = _props.onInputChange, translate = _props.translate;
                var inputName = inputData.inputName, text = inputData.text;
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    id: id,
                    className: "jsx-".concat(checkbox_input_scss_componentStyles.__hash) + " " + "consent-checkbox",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                            className: "jsx-".concat(checkbox_input_scss_componentStyles.__hash) + " " + (classnames_default()("input-title") || ""),
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                    type: "checkbox",
                                    defaultChecked: defaultValue,
                                    name: inputName,
                                    onChange: function() {
                                        return onInputChange({
                                            target: {
                                                name: inputName,
                                                value: _this.isChecked()
                                            }
                                        });
                                    },
                                    ref: function(input) {
                                        return _this._input = input;
                                    },
                                    className: "jsx-".concat(checkbox_input_scss_componentStyles.__hash) + " " + "checkbox"
                                }),
                                translate(text)
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((style_default()), {
                            id: checkbox_input_scss_componentStyles.__hash,
                            children: checkbox_input_scss_componentStyles
                        })
                    ]
                });
            }
        }
    ]);
    return CheckboxInput;
}(react.PureComponent);
/* harmony default export */ var checkbox_input = ((0,generic_config_context/* withGenericConfig */.P)(CheckboxInput));

// EXTERNAL MODULE: ./node_modules/react-select/dist/react-select.browser.esm.js + 13 modules
var react_select_browser_esm = __webpack_require__(16455);
// EXTERNAL MODULE: ./styles/color-consts.js
var color_consts = __webpack_require__(273);
;// CONCATENATED MODULE: ./client/components/system/form-inputs/multi-select-input/multi-select-input.scss.js


// We put here styles that we can't manipulate straight from the react-select component styles prop (see react-select-styles.js)
var multi_select_input_scss_componentStyles = new String(".hp-multi-select-input{.action-indicator{display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center;stroke:rgba(0,0,0,.7);&:hover{stroke:rgba(0,0,0,1)}}.multi-select-custom-option{display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center;.custom-checkbox{margin-right:10px;width:18px;height:18px;background-color:white;border:1px solid#cbcbcb;-webkit-border-radius:3px;-moz-border-radius:3px;border-radius:3px;display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-webkit-justify-content:center;-moz-box-pack:center;-ms-flex-pack:center;justify-content:center;&.selected{background-color:".concat(colors/* default */.Z[color_consts.WORK_OS_IRIS_COLOR_NAME], ";border:none}}}}"));
multi_select_input_scss_componentStyles.__hash = "7aa1195bb76692ac";

// EXTERNAL MODULE: ./node_modules/react-select/dist/index-75b02bac.browser.esm.js + 1 modules
var index_75b02bac_browser_esm = __webpack_require__(97896);
;// CONCATENATED MODULE: ./client/components/system/form-inputs/multi-select-input/close-icon.js

function CloseIcon(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "10",
        height: "10",
        viewBox: "0 0 10 10",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M1 1L9 9",
                strokeWidth: "1.5"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M9 1L1 9",
                strokeWidth: "1.5"
            })
        ]
    });
}

;// CONCATENATED MODULE: ./client/components/system/form-inputs/multi-select-input/dropdown-icon.js

function DropdownIcon(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "10",
        height: "6",
        viewBox: "0 0 10 6",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M1 1L5 5L9 1",
            strokeWidth: "1.5"
        })
    });
}

;// CONCATENATED MODULE: ./client/components/system/form-inputs/multi-select-input/checkmark-icon.js

function CheckmarkIcon(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "13",
        height: "10",
        viewBox: "0 0 13 10",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M1.5 3.91667L5.48565 8L12.3182 1",
            stroke: "white",
            "stroke-width": "1.5"
        })
    });
}

;// CONCATENATED MODULE: ./client/components/system/form-inputs/multi-select-input/multi-select-custom-components.js
function multi_select_custom_components_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            multi_select_custom_components_define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}






// Custom Option component with custom checkbox
var Option = function(props) {
    var isSelected = props.isSelected, label = props.label;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_75b02bac_browser_esm.F.Option, _object_spread_props(_object_spread({}, props), {
            className: "multi-select-custom-option",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: classnames_default()("custom-checkbox", {
                        selected: isSelected
                    }),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckmarkIcon, {})
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                    children: label
                })
            ]
        }))
    });
};
var MultiValueRemove = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_75b02bac_browser_esm.F.MultiValueRemove, _object_spread_props(_object_spread({}, props), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CloseIcon, {})
    }));
};
// taken from the docs: https://react-select.com/components search for "ClearIndicator"
var ClearIndicator = function(props) {
    var _children = props.children, children = _children === void 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CloseIcon, {}) : _children, getStyles = props.getStyles, ref = props.innerProps.ref, restInnerProps = _object_without_properties(props.innerProps, [
        "ref"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", _object_spread_props(_object_spread({}, restInnerProps), {
        ref: ref,
        style: getStyles("clearIndicator", props),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "action-indicator",
            children: children
        })
    }));
};
// same as ClearIndicator
var DropdownIndicator = function(props) {
    var _children = props.children, children = _children === void 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(DropdownIcon, {}) : _children, getStyles = props.getStyles, ref = props.innerProps.ref, restInnerProps = _object_without_properties(props.innerProps, [
        "ref"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", _object_spread_props(_object_spread({}, restInnerProps), {
        ref: ref,
        style: getStyles("clearIndicator", props),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "action-indicator",
            children: children
        })
    }));
};

;// CONCATENATED MODULE: ./client/components/system/form-inputs/multi-select-input/multi-select-styles.js
function multi_select_styles_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function multi_select_styles_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            multi_select_styles_define_property(target, key, source[key]);
        });
    }
    return target;
}
function multi_select_styles_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function multi_select_styles_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        multi_select_styles_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}


// docs: https://react-select.com/styles#the-styles-prop
function getReactSelectStyles(invalid) {
    var selectStyles = {
        control: function(styles) {
            return multi_select_styles_object_spread_props(multi_select_styles_object_spread({}, styles), {
                minHeight: "40px",
                borderColor: "".concat(invalid ? colors/* default.red */.Z.red : colors/* default.wolf */.Z.wolf)
            });
        },
        menu: function(styles) {
            return multi_select_styles_object_spread_props(multi_select_styles_object_spread({}, styles), {
                padding: "8px"
            });
        },
        option: function(styles, state) {
            return multi_select_styles_object_spread_props(multi_select_styles_object_spread({}, styles), {
                textAlign: "left",
                padding: "10px 8px 10px 8px",
                color: "black",
                backgroundColor: state.isFocused ? colors/* default */.Z[color_consts.BACKGROUND_GRAY_COLOR_NAME] : "transparent"
            });
        },
        multiValue: function(styles) {
            return multi_select_styles_object_spread_props(multi_select_styles_object_spread({}, styles), {
                backgroundColor: "#DED4FC",
                height: "30px",
                borderRadius: "20px",
                padding: "4px 10px 4px 10px"
            });
        },
        multiValueLabel: function(styles) {
            return multi_select_styles_object_spread_props(multi_select_styles_object_spread({}, styles), {
                fontSize: "12px",
                display: "flex",
                alignItems: "center"
            });
        },
        multiValueRemove: function(styles) {
            return multi_select_styles_object_spread_props(multi_select_styles_object_spread({}, styles), {
                height: "100%",
                borderRadius: "20px",
                stroke: "rgba(0, 0, 0, 0.7)",
                "&:hover": {
                    stroke: "rgba(0, 0, 0, 1)",
                    backgroundColor: "transparent"
                }
            });
        },
        indicatorsContainer: function(styles) {
            return multi_select_styles_object_spread_props(multi_select_styles_object_spread({}, styles), {
                paddingLeft: "0px"
            });
        },
        indicatorSeparator: function(styles) {
            return multi_select_styles_object_spread_props(multi_select_styles_object_spread({}, styles), {
                visibility: "hidden",
                width: "0px"
            });
        }
    };
    return selectStyles;
}

;// CONCATENATED MODULE: ./client/components/system/form-inputs/multi-select-input/multi-select-input.js








// react-select docs: https://react-select.com/home
function MultiSelectInput(props) {
    var inputData = props.inputData, onInputChange = props.onInputChange, onInputBlur = props.onInputBlur, value = props.value, invalid = props.invalid, errorLabelId = props.errorLabelId, id = props.id, translate = props.translate;
    var inputName = inputData.inputName, isRequired = inputData.isRequired, options = inputData.options, defaultValue = inputData.defaultValue, isMulti = inputData.isMulti, placeholder = inputData.placeholder;
    var getTranslatedOptions = function() {
        return options.map(function(option) {
            return {
                label: translate(option.label),
                value: option.value
            };
        });
    };
    var getTranslatedPlaceholder = function() {
        return translate(placeholder);
    };
    var onBlur = function() {
        // we change the data from react-select to be the same as the data from the other inputs
        onInputBlur({
            target: {
                name: inputName,
                value: value !== null && value !== void 0 ? value : ""
            }
        });
    };
    var onChange = function(newValue, action) {
        // we change the data from react-select to be the same as the data from the other inputs
        onInputChange({
            target: {
                name: action.name,
                value: newValue
            }
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(react_select_browser_esm/* default */.ZP, {
                className: "hp-multi-select-input",
                classNamePrefix: "react-select",
                id: id,
                name: inputName,
                onChange: onChange,
                onBlur: onBlur,
                defaultValue: defaultValue,
                options: getTranslatedOptions(),
                placeholder: getTranslatedPlaceholder(),
                components: {
                    Option: Option,
                    MultiValueRemove: MultiValueRemove,
                    ClearIndicator: ClearIndicator,
                    DropdownIndicator: DropdownIndicator
                },
                isMulti: isMulti,
                hideSelectedOptions: false,
                styles: getReactSelectStyles(invalid),
                required: isRequired,
                "aria-required": isRequired,
                "aria-invalid": invalid,
                "aria-describedby": errorLabelId,
                isSearchable: false,
                closeMenuOnSelect: false,
                blurInputOnSelect: false,
                value: value
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)((style_default()), {
                id: multi_select_input_scss_componentStyles.__hash,
                children: multi_select_input_scss_componentStyles
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)((style_default()), {
                id: commonInputStyles.__hash,
                children: commonInputStyles
            })
        ]
    });
}
/* harmony default export */ var multi_select_input = ((0,generic_config_context/* withGenericConfig */.P)(MultiSelectInput));

;// CONCATENATED MODULE: ./client/services/form-service/form-inputs.js









var inputTypes = {
    TEXT: "text",
    NUMBER: "number",
    EMAIL: "email",
    SELECT: "select",
    TEXT_AREA: "text_area",
    PHONE: "phone",
    CHECKBOX: "checkbox",
    MULTI_SELECT: "multi_select"
};
var _obj;
var inputTypesToComponent = (_obj = {}, (0,_define_property/* default */.Z)(_obj, inputTypes.TEXT, text_input), (0,_define_property/* default */.Z)(_obj, inputTypes.NUMBER, text_input), (0,_define_property/* default */.Z)(_obj, inputTypes.EMAIL, text_input), (0,_define_property/* default */.Z)(_obj, inputTypes.SELECT, select_input), (0,_define_property/* default */.Z)(_obj, inputTypes.MULTI_SELECT, multi_select_input), (0,_define_property/* default */.Z)(_obj, inputTypes.TEXT_AREA, textarea_input), (0,_define_property/* default */.Z)(_obj, inputTypes.PHONE, phone_input), (0,_define_property/* default */.Z)(_obj, inputTypes.CHECKBOX, checkbox_input), _obj);
var MAXIMUM_INPUT_LENGTH = 40;
var MINIMUM_PHONE_LENGTH = 8;
var MAXIMUM_PHONE_LENGTH = 40;
var MAXIMUM_LONG_INPUT_LENGTH = 120;
var getInputComponentByType = function(type) {
    return inputTypesToComponent[type] || text_input;
};
var FIRSTNAME_INPUT = {
    id: "first_name",
    type: inputTypes.TEXT,
    title: "forms.fieldTitle.firstName",
    validate: function(val) {
        return val.length < MAXIMUM_INPUT_LENGTH;
    }
};
var LASTNAME_INPUT = {
    id: "last_name",
    type: inputTypes.TEXT,
    title: "forms.fieldTitle.lastName",
    validate: function(val) {
        return val.length < MAXIMUM_INPUT_LENGTH;
    }
};
var EMAIL_INPUT = {
    id: "email",
    type: inputTypes.EMAIL,
    title: "forms.fieldTitle.workEmail",
    placeholder: "name@company.com",
    validate: function(val) {
        return input_validations_patterns/* EMAIL_PATTERN.test */.Q.test(val);
    },
    errorMessage: "forms.emailField.errorMessage"
};
var PHONE_INPUT = {
    id: "phone",
    type: inputTypes.PHONE,
    title: "forms.fieldTitle.phoneNumber",
    validate: function(val) {
        return (val === null || val === void 0 ? void 0 : val.length) >= MINIMUM_PHONE_LENGTH && (val === null || val === void 0 ? void 0 : val.length) < MAXIMUM_PHONE_LENGTH;
    },
    errorMessage: "forms.phoneField.errorMessage"
};
var COMPANY_SIZE_INPUT = {
    id: "company_size",
    type: inputTypes.SELECT,
    title: "forms.fieldTitle.companySize",
    options: form_constants/* companySizeList */.N,
    defaultValue: "forms.fields.selectPlaceholder"
};
var CHECKBOX_INPUT = {
    id: "checkbox_input",
    type: inputTypes.CHECKBOX,
    text: "forms.zendesk.tickets.contactConsentCheckbox",
    defaultValue: false
};


/***/ }),

/***/ 32184:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useInterval; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(29815);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);


function useInterval(callback, delay) {
    var deps = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : [];
    var intervalRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
    var savedCallback = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(callback);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        savedCallback.current = callback;
    }, [
        callback
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if (delay === null || delay === 0) {
            if (intervalRef.current) {
                window.clearInterval(intervalRef.current);
                intervalRef.current = null;
            }
            return;
        }
        var tick = function() {
            return savedCallback.current();
        };
        if (typeof delay === "number") {
            intervalRef.current = window.setInterval(tick, delay);
            return function() {
                return window.clearInterval(intervalRef.current);
            };
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(deps).concat([
        delay
    ]));
    return intervalRef;
}


/***/ }),

/***/ 96339:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "FZ": function() { return /* binding */ currentSmallerThanFinalDate; },
/* harmony export */   "jB": function() { return /* binding */ fireHotjarEventScript; },
/* harmony export */   "no": function() { return /* binding */ fireHotjarEvents; }
/* harmony export */ });
/* unused harmony export fireHotjarEvent */
/* harmony import */ var _sentry_nextjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(64487);

var fireHotjarEventScript = function(eventName) {
    return '(function(w){\n        if(!hj) return;\n        w.hj("event","'.concat(eventName, '");\n    })(window)');
};
var fireHotjarEvent = function(eventName) {
    try {
        if (window.hj) {
            window.hj("event", eventName);
        }
    } catch (e) {
        _sentry_nextjs__WEBPACK_IMPORTED_MODULE_0__/* .captureException */ .Tb(e);
    }
};
// fires a list of events to Hotjar
var fireHotjarEvents = function(eventNames) {
    // have only unique values
    var uniqueEventNames = eventNames.filter(function(element, index, array) {
        return array.indexOf(element) === index;
    });
    // fire each event, so filtering can be fully customized on Hotjar side
    uniqueEventNames.forEach(function(uniqueEventName) {
        return fireHotjarEvent(uniqueEventName);
    });
};
var currentSmallerThanFinalDate = function(hotjarFinalDate) {
    var currentDate = new Date();
    var finalDate = new Date(hotjarFinalDate);
    return currentDate.getTime() <= finalDate.getTime();
};


/***/ }),

/***/ 49228:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "PD": function() { return /* binding */ CONTACT_SALES_HUBSPOT_FORM_ID; },
  "Qo": function() { return /* binding */ EMAIL_ONLY_FORM_ID; },
  "yF": function() { return /* binding */ EVENTS_HUBSPOT_FORM_ID; },
  "f": function() { return /* binding */ NURTURE_CONTACT_US_FORM_ID; },
  "Im": function() { return /* binding */ PORTAL_ID; },
  "F0": function() { return /* binding */ REPORT_FORM_ID; },
  "pO": function() { return /* binding */ REQUEST_A_DEMO_HUBSPOT_FORM_ID; },
  "aC": function() { return /* binding */ TEST_CONTACT_SALES_HUBSPOT_FORM_ID; },
  "ND": function() { return /* binding */ TEST_PORTAL_ID; },
  "Ty": function() { return /* binding */ getContactFormConfigById; }
});

// EXTERNAL MODULE: ./constants/sales/campaigns.js
var campaigns = __webpack_require__(44363);
// EXTERNAL MODULE: ./client/services/hubspot-service/hubspot-constants.js
var hubspot_constants = __webpack_require__(22638);
// EXTERNAL MODULE: ./utils/url.js
var url = __webpack_require__(8339);
// EXTERNAL MODULE: ./client/services/form-service/form-inputs.js + 18 modules
var form_inputs = __webpack_require__(5893);
// EXTERNAL MODULE: ./client/services/form-service/form-constants.js
var form_constants = __webpack_require__(24065);
;// CONCATENATED MODULE: ./client/services/hubspot-service/hubspot-inputs.js
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}




var validateHowCanWeHelpFieldRequiredByCompanySize = function(currentValue, allInputsValues) {
    var companySize = allInputsValues[hubspot_constants/* HUBSPOT_API_COMPANY_SIZE */.h4];
    if (companySize === form_constants/* SMALLEST_COMPANY_SIZE */.o) {
        return !!currentValue; //this can't be empty because CS need this value
    }
    return true;
};
var getEmail = function() {
    var emailParam = (0,url.getUrlParamValueFromCurrentLocation)("email");
    var emailString = emailParam.replace("%40", "@").replace(" ", "+");
    return emailString;
};
var HUBSPOT_FIRSTNAME_INPUT = _object_spread_props(_object_spread({}, form_inputs/* FIRSTNAME_INPUT */.oo), {
    inputName: hubspot_constants/* HUBSPOT_API_FIRSTNAME */.uy,
    isRequired: true
});
var HUBSPOT_FIRSTNAME_INPUT_WITH_PLACEHOLDER = _object_spread_props(_object_spread({}, form_inputs/* FIRSTNAME_INPUT */.oo), {
    inputName: hubspot_constants/* HUBSPOT_API_FIRSTNAME */.uy,
    isRequired: true,
    placeholder: "forms.fieldTitle.requiredFirstName"
});
var HUBSPOT_LASTNAME_INPUT = _object_spread_props(_object_spread({}, form_inputs/* LASTNAME_INPUT */.Ce), {
    inputName: hubspot_constants/* HUBSPOT_API_LASTNAME */.aH,
    isRequired: true
});
var HUBSPOT_LASTNAME_INPUT_WITH_PLACEHOLDER = _object_spread_props(_object_spread({}, form_inputs/* LASTNAME_INPUT */.Ce), {
    inputName: hubspot_constants/* HUBSPOT_API_LASTNAME */.aH,
    isRequired: true,
    placeholder: "forms.fieldTitle.requiredLastName"
});
var HUBSPOT_EMAIL_INPUT = _object_spread_props(_object_spread({}, form_inputs/* EMAIL_INPUT */.I6), {
    inputName: hubspot_constants/* HUBSPOT_API_EMAIL */.dP,
    defaultValue: getEmail(),
    isRequired: true
});
var HUBSPOT_EMAIL_INPUT_WITH_PLACEHOLDER = _object_spread_props(_object_spread({}, form_inputs/* EMAIL_INPUT */.I6), {
    inputName: hubspot_constants/* HUBSPOT_API_EMAIL */.dP,
    defaultValue: getEmail(),
    isRequired: true,
    placeholder: "forms.fieldTitle.requiredWorkEmail"
});
var HUBSPOT_JOBTITLE_INPUT = {
    id: "job_title",
    inputName: hubspot_constants/* HUBSPOT_API_JOB */.W_,
    type: form_inputs/* inputTypes.TEXT */.Je.TEXT,
    isRequired: false,
    title: "contactSales.hubspotForm.form.fieldTitle.jobTitle",
    validate: function(val) {
        return !val || val.length < form_inputs/* MAXIMUM_LONG_INPUT_LENGTH */.wY;
    },
    errorMessage: "contactSales.hubspotForm.form.fieldErrorMsg.jobTitle"
};
var HUBSPOT_JOBTITLE_INPUT_WITH_PLACEHOLDER = {
    id: "job_title",
    inputName: hubspot_constants/* HUBSPOT_API_JOB */.W_,
    type: form_inputs/* inputTypes.TEXT */.Je.TEXT,
    isRequired: false,
    title: "contactSales.hubspotForm.form.fieldTitle.jobTitle",
    validate: function(val) {
        return !val || val.length < form_inputs/* MAXIMUM_LONG_INPUT_LENGTH */.wY;
    },
    errorMessage: "contactSales.hubspotForm.form.fieldErrorMsg.jobTitle",
    placeholder: "contactSales.hubspotForm.form.fieldTitle.jobTitle"
};
var HUBSPOT_PHONE_INPUT = _object_spread_props(_object_spread({}, form_inputs/* PHONE_INPUT */.l5), {
    inputName: hubspot_constants/* HUBSPOT_API_PHONE */.dG,
    isRequired: true
});
var HUBSPOT_COMPANY_INPUT_WITH_PLACEHOLDER = {
    id: "company_name",
    inputName: hubspot_constants/* HUBSPOT_API_COMPANY */.$G,
    type: form_inputs/* inputTypes.TEXT */.Je.TEXT,
    isRequired: true,
    placeholder: "contactSales.hubspotForm.form.fieldTitle.requiredCompanyName"
};
var HUBSPOT_COMPANY_INPUT = {
    id: "company_name",
    inputName: hubspot_constants/* HUBSPOT_API_COMPANY */.$G,
    type: form_inputs/* inputTypes.TEXT */.Je.TEXT,
    isRequired: true,
    title: "contactSales.hubspotForm.form.fieldTitle.companyName"
};
var HUBSPOT_COMPANYSIZE_INPUT_WITH_PLACEHOLDER = _object_spread_props(_object_spread({}, form_inputs/* COMPANY_SIZE_INPUT */.dN), {
    inputName: hubspot_constants/* HUBSPOT_API_COMPANY_SIZE */.h4,
    isRequired: true,
    defaultValue: "forms.fieldTitle.RequiredCompanySize"
});
var HUBSPOT_COMPANYSIZE_INPUT = _object_spread_props(_object_spread({}, form_inputs/* COMPANY_SIZE_INPUT */.dN), {
    inputName: hubspot_constants/* HUBSPOT_API_COMPANY_SIZE */.h4,
    isRequired: true
});
var getHubspotHowCanHelpInput = function() {
    var overrideParams = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return {
        id: "how_can_help",
        inputName: hubspot_constants/* HUBSPOT_API_HOW_CAN_HELP */.db,
        type: form_inputs/* inputTypes.TEXT_AREA */.Je.TEXT_AREA,
        isRequired: false,
        placeholder: (overrideParams === null || overrideParams === void 0 ? void 0 : overrideParams.placeholderKey) || "contactSales.hubspotForm.form.fieldPlaceholder.howCanHelp",
        title: (overrideParams === null || overrideParams === void 0 ? void 0 : overrideParams.titleKey) || "contactSales.hubspotForm.form.fieldTitle.howCanHelp",
        validateOnFormSubmission: validateHowCanWeHelpFieldRequiredByCompanySize,
        errorMessage: "forms.detailsField.requiredSoWeCanHelpError"
    };
};
var HUBSPOT_HOWPLANUSE_INPUT = {
    id: "how_plan_use",
    inputName: hubspot_constants/* HUBSPOT_API_HOW_CAN_HELP */.db,
    type: form_inputs/* inputTypes.TEXT_AREA */.Je.TEXT_AREA,
    isRequired: false,
    placeholder: "contactSales.hubspotForm.form.fieldPlaceholder.howCanHelp",
    title: "contactSales.hubspotForm.form.fieldTitle.howPlanToUse",
    validateOnFormSubmission: validateHowCanWeHelpFieldRequiredByCompanySize,
    errorMessage: "forms.detailsField.requiredSoWeCanHelpError"
};
var HUBSPOT_PRODUCT_QUESTION_INPUT = {
    id: "product_question",
    inputName: hubspot_constants/* HUBSPOT_API_PRODUCT_QUESTION */.eo,
    type: form_inputs/* inputTypes.MULTI_SELECT */.Je.MULTI_SELECT,
    isMulti: true,
    title: "contactSales.hubspotForm.form.fieldTitle.productQuestion",
    options: hubspot_constants/* productQuestionOptionsList */.Ys,
    placeholder: "forms.fields.selectPlaceholder",
    isRequired: true,
    errorMessage: "forms.requiredError"
};
var HUBSPOT_PRODUCT_QUESTION_INPUT_WITH_PLACEHOLDER = {
    id: "product_question",
    inputName: hubspot_constants/* HUBSPOT_API_PRODUCT_QUESTION */.eo,
    type: form_inputs/* inputTypes.MULTI_SELECT */.Je.MULTI_SELECT,
    isMulti: true,
    options: hubspot_constants/* productQuestionOptionsList */.Ys,
    placeholder: "contactSales.hubspotForm.form.fieldTitle.shorterRequiredProductQuestion",
    isRequired: true,
    errorMessage: "forms.requiredError"
};

;// CONCATENATED MODULE: ./client/services/hubspot-service/contact-form-config.js


var PORTAL_ID = "5945317";
var TEST_PORTAL_ID = "22796107";
var CONTACT_SALES_HUBSPOT_FORM_ID = "215c1dc9-0c3c-44ad-be61-add5f71dfe22";
var REQUEST_A_DEMO_HUBSPOT_FORM_ID = "1027e76f-6a94-489b-8ee3-e6d8141cc0f6";
var REPORT_FORM_ID = "1091544b-bff2-40ef-aada-8acfea9089b3";
var NURTURE_CONTACT_US_FORM_ID = "38593c14-af5b-4f56-8d3b-a403dee4266b";
var EMAIL_ONLY_FORM_ID = "c46e9209-b721-472f-8c2e-b151cba6d12e";
var EVENTS_HUBSPOT_FORM_ID = "192ded92-8c95-44bd-bf4e-1fcf0a32c0c2";
// used for testing only
var TEST_CONTACT_SALES_HUBSPOT_FORM_ID = "6fe93320-3033-4c28-9215-c19b535ebcae";
var getOverrideParamsForCampaigin = function(campaignId) {
    if (campaignId === campaigns/* IPO_CAMPAIGN_ID */.Q) {
        return {
            titleKey: "contactSales.hubspotForm.form.ipoCampaignFieldTitle.howCanHelp",
            placeholderKey: "contactSales.hubspotForm.form.ipoCampaignFieldPlaceholder.howCanHelp"
        };
    }
    return null;
};
var getContactSalesConfig = function(param) {
    var formId = param.formId, campaignId = param.campaignId, withSubmitNotice = param.withSubmitNotice, formTitle = param.formTitle, lastNameFirst = param.lastNameFirst, isV2 = param.isV2, splitForm = param.splitForm, firstFormSubmitted = param.firstFormSubmitted;
    var overrideParams = getOverrideParamsForCampaigin(campaignId);
    var getFirstNameLastNameRow = function() {
        var withPlaceHolder = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
        var row = withPlaceHolder ? [
            HUBSPOT_FIRSTNAME_INPUT_WITH_PLACEHOLDER,
            HUBSPOT_LASTNAME_INPUT_WITH_PLACEHOLDER
        ] : [
            HUBSPOT_FIRSTNAME_INPUT,
            HUBSPOT_LASTNAME_INPUT
        ];
        return lastNameFirst ? row.reverse() : row;
    };
    var getProductQuestionRow = function() {
        var withPlaceHolder = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
        if (withPlaceHolder) {
            return HUBSPOT_PRODUCT_QUESTION_INPUT_WITH_PLACEHOLDER;
        }
        return HUBSPOT_PRODUCT_QUESTION_INPUT;
    };
    var getSplitFormConfig = function() {
        if (isV2) {
            if (firstFormSubmitted) {
                return {
                    formTitle: formTitle,
                    rows: [
                        [
                            HUBSPOT_EMAIL_INPUT_WITH_PLACEHOLDER
                        ],
                        getFirstNameLastNameRow(true),
                        [
                            HUBSPOT_JOBTITLE_INPUT_WITH_PLACEHOLDER
                        ],
                        [
                            HUBSPOT_PHONE_INPUT
                        ],
                        [
                            HUBSPOT_COMPANY_INPUT_WITH_PLACEHOLDER,
                            HUBSPOT_COMPANYSIZE_INPUT_WITH_PLACEHOLDER
                        ],
                        [
                            getProductQuestionRow(true)
                        ],
                        [
                            getHubspotHowCanHelpInput({
                                placeholderKey: "contactSales.hubspotForm.form.fieldTitle.howCanHelp"
                            })
                        ]
                    ],
                    submitButtonText: "contactSales.hubspotForm.form.submitButton"
                };
            }
            return {
                formTitle: formTitle,
                rows: [
                    [
                        HUBSPOT_EMAIL_INPUT_WITH_PLACEHOLDER
                    ],
                    [
                        HUBSPOT_PHONE_INPUT
                    ],
                    [
                        getProductQuestionRow(true)
                    ],
                    [
                        getHubspotHowCanHelpInput({
                            placeholderKey: "contactSales.hubspotForm.form.fieldTitle.howCanHelp"
                        })
                    ]
                ],
                submitButtonText: "contactSales.hubspotForm.form.submitButton"
            };
        }
        if (firstFormSubmitted) {
            return {
                formTitle: formTitle,
                rows: [
                    [
                        HUBSPOT_COMPANY_INPUT,
                        HUBSPOT_JOBTITLE_INPUT
                    ],
                    [
                        HUBSPOT_PHONE_INPUT
                    ],
                    [
                        getProductQuestionRow()
                    ],
                    [
                        getHubspotHowCanHelpInput(overrideParams)
                    ]
                ],
                submitButtonText: "contactSales.hubspotForm.form.submitButton"
            };
        }
        return {
            formTitle: formTitle,
            rows: [
                getFirstNameLastNameRow(),
                [
                    HUBSPOT_EMAIL_INPUT
                ],
                [
                    HUBSPOT_COMPANYSIZE_INPUT
                ]
            ],
            submitButtonText: "contactSales.hubspotForm.form.ContinueButton",
            privacyNoticeText: "forms.continuePrivacyNoticeShorten"
        };
    };
    var getMainFormConfig = function() {
        if (splitForm) {
            return getSplitFormConfig();
        } else {
            if (isV2) {
                return {
                    formTitle: formTitle,
                    rows: [
                        getFirstNameLastNameRow(true),
                        [
                            HUBSPOT_EMAIL_INPUT_WITH_PLACEHOLDER
                        ],
                        [
                            HUBSPOT_JOBTITLE_INPUT_WITH_PLACEHOLDER
                        ],
                        [
                            HUBSPOT_PHONE_INPUT
                        ],
                        [
                            HUBSPOT_COMPANY_INPUT_WITH_PLACEHOLDER,
                            HUBSPOT_COMPANYSIZE_INPUT_WITH_PLACEHOLDER
                        ],
                        [
                            getProductQuestionRow(true)
                        ],
                        [
                            getHubspotHowCanHelpInput(overrideParams)
                        ]
                    ],
                    submitButtonText: withSubmitNotice ? "contactSales.hubspotForm.form.submitButton" : "contactSales.hubspotForm.form.contactUsButton"
                };
            }
            return {
                formTitle: formTitle,
                rows: [
                    getFirstNameLastNameRow(),
                    [
                        HUBSPOT_EMAIL_INPUT,
                        HUBSPOT_JOBTITLE_INPUT
                    ],
                    [
                        HUBSPOT_PHONE_INPUT
                    ],
                    [
                        HUBSPOT_COMPANY_INPUT,
                        HUBSPOT_COMPANYSIZE_INPUT
                    ],
                    [
                        getProductQuestionRow()
                    ],
                    [
                        getHubspotHowCanHelpInput(overrideParams)
                    ]
                ],
                submitButtonText: withSubmitNotice ? "contactSales.hubspotForm.form.submitButton" : "contactSales.hubspotForm.form.contactUsButton"
            };
        }
    };
    switch(formId){
        case CONTACT_SALES_HUBSPOT_FORM_ID:
        case TEST_CONTACT_SALES_HUBSPOT_FORM_ID:
            return getMainFormConfig();
        case REQUEST_A_DEMO_HUBSPOT_FORM_ID:
            return {
                rows: [
                    getFirstNameLastNameRow(),
                    [
                        HUBSPOT_EMAIL_INPUT,
                        HUBSPOT_JOBTITLE_INPUT
                    ],
                    [
                        HUBSPOT_PHONE_INPUT
                    ],
                    [
                        HUBSPOT_COMPANY_INPUT,
                        HUBSPOT_COMPANYSIZE_INPUT
                    ],
                    [
                        getProductQuestionRow()
                    ],
                    [
                        HUBSPOT_HOWPLANUSE_INPUT
                    ]
                ]
            };
        case REPORT_FORM_ID:
            return {
                rows: [
                    getFirstNameLastNameRow(),
                    [
                        HUBSPOT_EMAIL_INPUT,
                        HUBSPOT_JOBTITLE_INPUT
                    ],
                    [
                        HUBSPOT_PHONE_INPUT
                    ],
                    [
                        HUBSPOT_COMPANY_INPUT,
                        HUBSPOT_COMPANYSIZE_INPUT
                    ]
                ],
                submitButtonText: "contactSales.hubspotForm.form.getReport"
            };
        case NURTURE_CONTACT_US_FORM_ID:
            return {
                rows: [
                    getFirstNameLastNameRow(),
                    [
                        HUBSPOT_EMAIL_INPUT
                    ],
                    [
                        getProductQuestionRow()
                    ],
                    [
                        getHubspotHowCanHelpInput(overrideParams)
                    ]
                ],
                submitButtonText: "contactSales.hubspotForm.form.getInTouch",
                privacyNoticeText: "forms.getInTouch.privacyNotice"
            };
        case EMAIL_ONLY_FORM_ID:
            return {
                rows: [
                    [
                        HUBSPOT_EMAIL_INPUT
                    ]
                ],
                submitButtonText: "Submit"
            };
        case EVENTS_HUBSPOT_FORM_ID:
            return {
                formTitle: formTitle,
                rows: [
                    getFirstNameLastNameRow(),
                    [
                        HUBSPOT_EMAIL_INPUT,
                        HUBSPOT_JOBTITLE_INPUT
                    ],
                    [
                        HUBSPOT_PHONE_INPUT
                    ],
                    [
                        HUBSPOT_COMPANY_INPUT,
                        HUBSPOT_COMPANYSIZE_INPUT
                    ]
                ],
                submitButtonText: "contactSales.hubspotForm.form.register"
            };
        default:
            return {
                rows: []
            };
    }
};
var getContactFormConfigById = function(param) {
    var formId = param.formId, _overrideCampaignId = param.overrideCampaignId, overrideCampaignId = _overrideCampaignId === void 0 ? null : _overrideCampaignId, _withSubmitNotice = param.withSubmitNotice, withSubmitNotice = _withSubmitNotice === void 0 ? true : _withSubmitNotice, formTitle = param.formTitle, lastNameFirst = param.lastNameFirst, isV2 = param.isV2, splitForm = param.splitForm, firstFormSubmitted = param.firstFormSubmitted;
    return getContactSalesConfig({
        formId: formId,
        overrideCampaignId: overrideCampaignId,
        withSubmitNotice: withSubmitNotice,
        formTitle: formTitle,
        lastNameFirst: lastNameFirst,
        isV2: isV2,
        splitForm: splitForm,
        firstFormSubmitted: firstFormSubmitted
    });
};


/***/ }),

/***/ 22638:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$G": function() { return /* binding */ HUBSPOT_API_COMPANY; },
/* harmony export */   "$K": function() { return /* binding */ HUBSPOT_API_VISITOR; },
/* harmony export */   "AB": function() { return /* binding */ NUMBER_OF_SEATS_PARAM; },
/* harmony export */   "L_": function() { return /* binding */ leadSourceConfigList; },
/* harmony export */   "Mj": function() { return /* binding */ HUBSPOT_API_CLUSTER; },
/* harmony export */   "TO": function() { return /* binding */ PII_PARAMS; },
/* harmony export */   "Ts": function() { return /* binding */ leadSourceDefaultValue; },
/* harmony export */   "W_": function() { return /* binding */ HUBSPOT_API_JOB; },
/* harmony export */   "Ys": function() { return /* binding */ productQuestionOptionsList; },
/* harmony export */   "_g": function() { return /* binding */ HUBSPOT_API_PRIVACY_CONSENT; },
/* harmony export */   "aH": function() { return /* binding */ HUBSPOT_API_LASTNAME; },
/* harmony export */   "cj": function() { return /* binding */ HUBSPOT_API_FROM; },
/* harmony export */   "dG": function() { return /* binding */ HUBSPOT_API_PHONE; },
/* harmony export */   "dP": function() { return /* binding */ HUBSPOT_API_EMAIL; },
/* harmony export */   "db": function() { return /* binding */ HUBSPOT_API_HOW_CAN_HELP; },
/* harmony export */   "eo": function() { return /* binding */ HUBSPOT_API_PRODUCT_QUESTION; },
/* harmony export */   "h4": function() { return /* binding */ HUBSPOT_API_COMPANY_SIZE; },
/* harmony export */   "lF": function() { return /* binding */ HUBSPOT_API_PRICING_VERSION; },
/* harmony export */   "rX": function() { return /* binding */ HUBSPOT_API_SOURCE; },
/* harmony export */   "sD": function() { return /* binding */ SALES_ENRICHMENT_PARAM_TYPES; },
/* harmony export */   "sy": function() { return /* binding */ URL_PARAM_FROM; },
/* harmony export */   "tT": function() { return /* binding */ HUBSPOT_API_RECENT_CONVERSION_URL; },
/* harmony export */   "uy": function() { return /* binding */ HUBSPOT_API_FIRSTNAME; },
/* harmony export */   "yM": function() { return /* binding */ HUBSPOT_API_RECENT_CONVERSION_REFERRER_PAGE; },
/* harmony export */   "zj": function() { return /* binding */ SALES_ENRICHMENT_PARAM_LIST; }
/* harmony export */ });
var leadSourceDefaultValue = "Website - Contact Sales";
var leadSourceConfigList = [
    {
        value: "Website - Contact Sales",
        text: "Website - Contact Sales"
    },
    {
        value: "Website - Request a Demo",
        text: "Website - Request a Demo"
    },
    {
        value: "Linkedin - Contact Sales",
        text: "Linkedin - Contact Sales"
    },
    {
        value: "Linkedin - Request a Demo",
        text: "Linkedin - Request a Demo"
    },
    {
        value: "Content",
        text: "Content"
    },
    {
        value: "Contact Sales - Tech Partner",
        text: "Contact Sales - Tech Partner"
    },
    {
        value: "Webinar",
        text: "Webinar"
    },
    {
        value: "Mobile - Contact Sales",
        text: "Mobile - Contact Sales"
    },
    {
        value: "Xing",
        text: "Xing"
    },
    {
        value: "Website - Nurture Contact Sales",
        text: "Website - Nurture Contact Sales"
    },
    {
        value: "Event",
        text: "Event"
    }
];
var HUBSPOT_API_FIRSTNAME = "firstname";
var HUBSPOT_API_LASTNAME = "lastname";
var HUBSPOT_API_EMAIL = "email";
var HUBSPOT_API_JOB = "jobtitle";
var HUBSPOT_API_PHONE = "phone";
var HUBSPOT_API_COMPANY = "company";
var HUBSPOT_API_COMPANY_SIZE = "company_size__c";
var HUBSPOT_API_PRODUCT_QUESTION = "product_question_hs_forms";
var HUBSPOT_API_HOW_CAN_HELP = "how_can_our_consulting_team_help_you";
var HUBSPOT_API_CLUSTER = "cluster_hs";
var HUBSPOT_API_VISITOR = "visitor_id";
var HUBSPOT_API_SOURCE = "leadsource";
var HUBSPOT_API_FROM = "from";
var HUBSPOT_API_PRIVACY_CONSENT = "seen_legal_disclaimer";
var HUBSPOT_API_PRICING_VERSION = "website_pricing_version";
var HUBSPOT_API_RECENT_CONVERSION_URL = "recent_conversion_url";
var HUBSPOT_API_RECENT_CONVERSION_REFERRER_PAGE = "recent_conversion_referrer_page";
var HUBSPOT_API_UTM_SOURCE = "utm_source";
var HUBSPOT_API_UTM_CAMPAIGN = "utm_campaign";
var HUBSPOT_API_UTM_BANNER = "utm_banner";
var HUBSPOT_API_UTM_CONTENT = "utm_content";
var HUBSPOT_API_UTM_ADGROUP = "utm_adgroup";
var HUBSPOT_API_UTM_MEDIUM = "utm_medium";
var HUBSPOT_API_UTM_KEYWORD = "utm_keyword";
var HUBSPOT_API_NUMBER_OF_SEATS = "number_of_seats_last_selected_pricing_page";
var URL_PARAM_FROM = "from";
var PII_PARAMS = [
    HUBSPOT_API_FIRSTNAME,
    HUBSPOT_API_LASTNAME,
    HUBSPOT_API_EMAIL,
    HUBSPOT_API_PHONE
];
/* this is {label: String, value: String} objects list to fit the react-select input,
changing the values will break the form (in hubspot) */ var productQuestionOptionsList = [
    {
        label: "contactSales.hubspotForm.form.productQuestion.workManagement",
        value: "Work & project management"
    },
    {
        label: "contactSales.hubspotForm.form.productQuestion.crm",
        value: "Sales & CRM"
    },
    {
        label: "contactSales.hubspotForm.form.productQuestion.dev",
        value: "Product & software development"
    },
    {
        label: "contactSales.hubspotForm.form.productQuestion.service",
        value: "Ticketing & service management"
    },
    {
        label: "contactSales.hubspotForm.form.productQuestion.other",
        value: "Other"
    }
];
// The UTM consts are used as both url param names and keys in the local storage
var UTM_SOURCE = "utm_source";
var UTM_CAMPAIGN = "utm_campaign";
var UTM_BANNER = "utm_banner";
var UTM_CONTENT = "utm_content";
var UTM_ADGROUP = "utm_adgroup";
var UTM_MEDIUM = "utm_medium";
var UTM_KEYWORD = "utm_keyword";
var NUMBER_OF_SEATS_PARAM = "number_of_seats_last_selected_pricing_page";
var SALES_ENRICHMENT_PARAM_TYPES = {
    URL_PARAM: "url_param"
};
var SALES_ENRICHMENT_PARAM_LIST = [
    {
        type: SALES_ENRICHMENT_PARAM_TYPES.URL_PARAM,
        hubspotApiName: HUBSPOT_API_UTM_SOURCE,
        paramName: UTM_SOURCE
    },
    {
        type: SALES_ENRICHMENT_PARAM_TYPES.URL_PARAM,
        hubspotApiName: HUBSPOT_API_UTM_CAMPAIGN,
        paramName: UTM_CAMPAIGN
    },
    {
        type: SALES_ENRICHMENT_PARAM_TYPES.URL_PARAM,
        hubspotApiName: HUBSPOT_API_UTM_BANNER,
        paramName: UTM_BANNER
    },
    {
        type: SALES_ENRICHMENT_PARAM_TYPES.URL_PARAM,
        hubspotApiName: HUBSPOT_API_UTM_CONTENT,
        paramName: UTM_CONTENT
    },
    {
        type: SALES_ENRICHMENT_PARAM_TYPES.URL_PARAM,
        hubspotApiName: HUBSPOT_API_UTM_ADGROUP,
        paramName: UTM_ADGROUP
    },
    {
        type: SALES_ENRICHMENT_PARAM_TYPES.URL_PARAM,
        hubspotApiName: HUBSPOT_API_UTM_MEDIUM,
        paramName: UTM_MEDIUM
    },
    {
        type: SALES_ENRICHMENT_PARAM_TYPES.URL_PARAM,
        hubspotApiName: HUBSPOT_API_UTM_KEYWORD,
        paramName: UTM_KEYWORD
    },
    {
        hubspotApiName: HUBSPOT_API_NUMBER_OF_SEATS,
        paramName: NUMBER_OF_SEATS_PARAM
    }
];


/***/ }),

/***/ 23155:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "OB": function() { return /* binding */ generateHiddenData; },
/* harmony export */   "Pw": function() { return /* binding */ sendHubspotForm; },
/* harmony export */   "WJ": function() { return /* binding */ submitHubspotForm; }
/* harmony export */ });
/* unused harmony export getSingleUrlParamToHubspotForm */
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(29815);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(10092);
/* harmony import */ var utils_url__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8339);
/* harmony import */ var utils_url__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(utils_url__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _services_cookies_service__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67798);
/* harmony import */ var _constants_cookies__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(13019);
/* harmony import */ var _constants_cookies__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_constants_cookies__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var services_sales_enrichment_sales_enrichment_service__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(29919);
/* harmony import */ var services_pricing_pricing_model_services__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(3223);
/* harmony import */ var _hubspot_constants__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(22638);


function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}






var HUBSPOT_FORM_URL = "https://api.hsforms.com/submissions/v3/integration/submit";
var submitHubspotForm = function() {
    var _ref = _async_to_generator(function(portalId, formId, emailValue) {
        var url, utmParams, data, serverResponse, err;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    url = "".concat(HUBSPOT_FORM_URL, "/").concat(portalId, "/").concat(formId);
                    utmParams = getUtmParams();
                    data = {
                        fields: [
                            {
                                name: "email",
                                value: emailValue
                            }
                        ].concat(utmParams)
                    };
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        4,
                        ,
                        5
                    ]);
                    return [
                        4,
                        fetch(url, {
                            method: "POST",
                            headers: {
                                "Content-Type": "application/json"
                            },
                            body: JSON.stringify(data)
                        })
                    ];
                case 2:
                    serverResponse = _state.sent();
                    if (serverResponse.status !== 200) {
                        throw new Error(serverResponse.statusText);
                    }
                    return [
                        4,
                        serverResponse.json()
                    ];
                case 3:
                    _state.sent();
                    return [
                        2,
                        true
                    ];
                case 4:
                    err = _state.sent();
                    console.log("err", err);
                    return [
                        2,
                        false
                    ];
                case 5:
                    return [
                        2
                    ];
            }
        });
    });
    return function submitHubspotForm(portalId, formId, emailValue) {
        return _ref.apply(this, arguments);
    };
}();
var getUtmParams = function() {
    var url = window.location;
    var queryString = (0,utils_url__WEBPACK_IMPORTED_MODULE_0__.getQueryStringAsHash)(url);
    var utmParams = [];
    var utm_source = queryString.marketing_source || queryString.utm_source;
    if (utm_source) utmParams.push({
        name: "utm_source",
        value: utm_source
    });
    var utm_campaign = queryString.marketing_campaign || queryString.utm_campaign;
    if (utm_campaign) utmParams.push({
        name: "utm_campaign",
        value: utm_campaign
    });
    var utm_banner = queryString.marketing_banner || queryString.utm_banner;
    if (utm_banner) utmParams.push({
        name: "utm_banner",
        value: utm_banner
    });
    var utm_content = queryString.marketing_content || queryString.utm_content;
    if (utm_content) utmParams.push({
        name: "utm_content",
        value: utm_content
    });
    var utm_cluster_id = (0,_services_cookies_service__WEBPACK_IMPORTED_MODULE_1__/* .getCookie */ .ej)(_constants_cookies__WEBPACK_IMPORTED_MODULE_2__.CLUSTER_COOKIE);
    if (utm_cluster_id) utmParams.push({
        name: "utm_cluster_id",
        value: utm_cluster_id
    });
    return utmParams;
};
var getSingleUrlParamToHubspotForm = function(location, urlParamName, hubspotApiName) {
    return {
        name: hubspotApiName,
        value: (0,utils_url__WEBPACK_IMPORTED_MODULE_0__.getDecodedParamFromQuery)(location, urlParamName)
    };
};
var sendHubspotForm = function() {
    var _ref = _async_to_generator(function(portalId, formId, fields) {
        var HUBSPOT_ENDPOINT, hubspotCookie, request, response;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!portalId || !formId) return [
                        2
                    ];
                    HUBSPOT_ENDPOINT = "https://api.hsforms.com/submissions/v3/integration/submit/".concat(portalId, "/").concat(formId);
                    hubspotCookie = (0,_services_cookies_service__WEBPACK_IMPORTED_MODULE_1__/* .getCookie */ .ej)("hubspotutk");
                    return [
                        4,
                        fetch(HUBSPOT_ENDPOINT, {
                            method: "POST",
                            body: JSON.stringify({
                                fields: fields,
                                context: {
                                    hutk: hubspotCookie
                                }
                            }),
                            headers: {
                                "content-type": "application/json"
                            }
                        })
                    ];
                case 1:
                    request = _state.sent();
                    return [
                        4,
                        request.json()
                    ];
                case 2:
                    response = _state.sent();
                    return [
                        2,
                        response
                    ];
            }
        });
    });
    return function sendHubspotForm(portalId, formId, fields) {
        return _ref.apply(this, arguments);
    };
}();
var generateHiddenData = function(param) {
    var withPrivacyNotice = param.withPrivacyNotice, source = param.source, overrideCampaignId = param.overrideCampaignId, abTests = param.abTests, cookies = param.cookies, cloudfrontViewerCountry = param.cloudfrontViewerCountry, isEnrichment = param.isEnrichment, referrePage = param.referrePage;
    var _window_location, _window;
    var UTM_CAMPAIGN_PARAM_NAME = "utm_campaign";
    var urlParams = (0,services_sales_enrichment_sales_enrichment_service__WEBPACK_IMPORTED_MODULE_3__/* .getEnrichmentEntriesForSales */ .Xk)();
    if (overrideCampaignId) {
        var urlParamsWithoutCampaign = urlParams.filter(function(param) {
            return (param === null || param === void 0 ? void 0 : param.name) !== UTM_CAMPAIGN_PARAM_NAME;
        });
        urlParamsWithoutCampaign.push({
            name: UTM_CAMPAIGN_PARAM_NAME,
            value: overrideCampaignId
        });
        urlParams = urlParamsWithoutCampaign;
    }
    var hiddenData = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(urlParams);
    var visitorId = (0,_services_cookies_service__WEBPACK_IMPORTED_MODULE_1__/* .getCookie */ .ej)(_constants_cookies__WEBPACK_IMPORTED_MODULE_2__.BIG_BRAIN_VISITOR_ID) || "";
    hiddenData.push({
        name: _hubspot_constants__WEBPACK_IMPORTED_MODULE_5__/* .HUBSPOT_API_VISITOR */ .$K,
        value: visitorId
    });
    var pricingVersion = (0,services_pricing_pricing_model_services__WEBPACK_IMPORTED_MODULE_4__/* .getPricingVersionForSales */ .qM)({
        cookies: cookies,
        abTests: abTests,
        countryCode: cloudfrontViewerCountry
    }) || "";
    hiddenData.push({
        name: _hubspot_constants__WEBPACK_IMPORTED_MODULE_5__/* .HUBSPOT_API_PRICING_VERSION */ .lF,
        value: pricingVersion
    });
    var clusterId = (0,_services_cookies_service__WEBPACK_IMPORTED_MODULE_1__/* .getCookie */ .ej)(_constants_cookies__WEBPACK_IMPORTED_MODULE_2__.CLUSTER_COOKIE) || "";
    hiddenData.push({
        name: _hubspot_constants__WEBPACK_IMPORTED_MODULE_5__/* .HUBSPOT_API_CLUSTER */ .Mj,
        value: clusterId
    });
    hiddenData.push({
        name: _hubspot_constants__WEBPACK_IMPORTED_MODULE_5__/* .HUBSPOT_API_SOURCE */ .rX,
        value: source
    });
    hiddenData.push({
        name: _hubspot_constants__WEBPACK_IMPORTED_MODULE_5__/* .HUBSPOT_API_PRIVACY_CONSENT */ ._g,
        value: withPrivacyNotice
    });
    hiddenData.push({
        name: _hubspot_constants__WEBPACK_IMPORTED_MODULE_5__/* .HUBSPOT_API_RECENT_CONVERSION_URL */ .tT,
        value: (_window = window) === null || _window === void 0 ? void 0 : (_window_location = _window.location) === null || _window_location === void 0 ? void 0 : _window_location.href
    });
    if (referrePage) {
        hiddenData.push({
            name: _hubspot_constants__WEBPACK_IMPORTED_MODULE_5__/* .HUBSPOT_API_RECENT_CONVERSION_REFERRER_PAGE */ .yM,
            value: referrePage
        });
    }
    var fromUrlParamObject = getSingleUrlParamToHubspotForm(window.location, _hubspot_constants__WEBPACK_IMPORTED_MODULE_5__/* .URL_PARAM_FROM */ .sy, _hubspot_constants__WEBPACK_IMPORTED_MODULE_5__/* .HUBSPOT_API_FROM */ .cj);
    if (isEnrichment) {
        if (fromUrlParamObject.value) {
            fromUrlParamObject.value += "-cs-enrichment-page";
        } else {
            fromUrlParamObject.value = "cs-enrichment-page";
        }
    }
    if (fromUrlParamObject.value) hiddenData.push(fromUrlParamObject);
    return hiddenData;
};


/***/ }),

/***/ 24961:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ asset_component; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./components/core/picture-with-link/picture-with-link-component.js
var picture_with_link_component = __webpack_require__(94640);
// EXTERNAL MODULE: ./components/core/video/video-component.js + 1 modules
var video_component = __webpack_require__(3773);
// EXTERNAL MODULE: ./server/services/files-service/files-service.js
var files_service = __webpack_require__(14688);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
// EXTERNAL MODULE: ./contexts/generic-config-context.js
var generic_config_context = __webpack_require__(3156);
// EXTERNAL MODULE: ./client/services/cluster-config-service/cluster-config-service.js
var cluster_config_service = __webpack_require__(79092);
// EXTERNAL MODULE: ./services/community/cloudinary-service.js
var cloudinary_service = __webpack_require__(40927);
;// CONCATENATED MODULE: ./client/services/dynamic-asset-param-service/dynamic-asset-param-service.js

var FALLBACK_IMAGE_FILENAME = "default.png"; // if you don't add this file to your path, you'll have weird "?" image instead in case of missing image
var env = "production";
var getImageUrl = function(folderPath, fileName) {
    var folderPathForEnv = "".concat(folderPath, "/").concat(env);
    var transformation = "".concat(cloudinary_service.FALLBACK_DEFAULT_IMAGE_TRANSFORMATION_PARAM, "_").concat(folderPathForEnv.replace(/\//g, ":"), ":").concat(FALLBACK_IMAGE_FILENAME, ",q_100");
    return "".concat(cloudinary_service.CLOUDINARY_IMAGE_PREFIX, "upload/").concat(transformation, "/").concat(folderPathForEnv, "/").concat(fileName);
};

// EXTERNAL MODULE: ./segments/desktop/core-components/window-mask/window-mask.js + 2 modules
var window_mask = __webpack_require__(26718);
// EXTERNAL MODULE: ./utils/react.js
var utils_react = __webpack_require__(12783);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
;// CONCATENATED MODULE: ./components/core/asset/asset-component.scss.js

var StyledAssetComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "eav27f90"
})("position:relative;.main-image{width:100%;display:flex;}.main-image.round{border-radius:50%;}img.with-window-mask,.with-window-mask > video{width:100%;border-bottom-left-radius:10px;border-bottom-right-radius:10px;}");

;// CONCATENATED MODULE: ./components/core/asset/asset-component.js
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}













var MP4 = "mp4";
var GIF = "gif";
var AssetComponent = function(props) {
    var getAssetsConfig = function() {
        var image = props.image, video = props.video, useDynamicAsset = props.useDynamicAsset, clusterConfig = props.clusterConfig, dynamicAssetParamPath = props.dynamicAssetParamPath, dynamicAssetParam = props.dynamicAssetParam, activePagePath = props.activePagePath;
        if (dynamicAssetParamPath && dynamicAssetParam) {
            return {
                image: _object_spread_props(_object_spread({}, image), {
                    src: getImageUrl(dynamicAssetParamPath, dynamicAssetParam)
                })
            };
        }
        var dynamicAssetConfig = useDynamicAsset && (0,cluster_config_service/* getDynamicAssetConfigForPath */.sP)(clusterConfig, activePagePath);
        if (!dynamicAssetConfig) {
            return {
                image: image,
                video: video
            };
        }
        if ((0,files_service.getFileExtension)(dynamicAssetConfig.src) === MP4) {
            return {
                video: _object_spread_props(_object_spread({}, video), {
                    src: {
                        formats: [
                            dynamicAssetConfig.src
                        ]
                    }
                })
            };
        }
        return {
            image: _object_spread({}, image, dynamicAssetConfig)
        };
    };
    var renderAsset = function() {
        var width = props.width, convertGifToVideo = props.convertGifToVideo, imageClassName = props.imageClassName, assetQuality = props.assetQuality, hideControls = props.hideControls, onStart = props.onStart, onEnded = props.onEnded, onDuration = props.onDuration, hideBlackBars = props.hideBlackBars, onImageLoad = props.onImageLoad;
        var ref = getAssetsConfig(), image = ref.image, video = ref.video;
        if (video === null || video === void 0 ? void 0 : video.src) {
            var formats = video.src.formats;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(video_component/* default */.Z, _object_spread_props(_object_spread({}, video, video.src), {
                formats: formats,
                assetQuality: assetQuality,
                hideControls: hideControls,
                poster: video === null || video === void 0 ? void 0 : video.poster,
                onStart: onStart,
                onEnded: onEnded,
                onDuration: onDuration,
                hideBlackBars: hideBlackBars
            }));
        }
        if (image === null || image === void 0 ? void 0 : image.src) {
            if ((0,files_service.getFileExtension)(image.src) === GIF && convertGifToVideo) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(video_component/* default */.Z, {
                    loop: true,
                    autoPlay: true,
                    formats: [
                        image.src
                    ],
                    assetQuality: assetQuality,
                    ariaLabel: image === null || image === void 0 ? void 0 : image.alt,
                    hideControls: hideControls
                });
            }
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(picture_with_link_component/* default */.Z, _object_spread_props(_object_spread({
                onImageLoad: onImageLoad,
                className: classnames_default()("main-image", imageClassName)
            }, image), {
                specificImageStyle: {
                    width: width
                },
                assetQuality: assetQuality
            }));
        }
        return null;
    };
    var width = props.width, className = props.className, style = props.style, useWindowMask = props.useWindowMask;
    var childrenWithWindowMaskClass = function(children) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(window_mask/* default */.Z, {
            children: react.Children.map(children, function(child) {
                return /*#__PURE__*/ (0,react.cloneElement)(child, {
                    className: "with-window-mask"
                });
            })
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledAssetComponent, {
        className: classnames_default()("asset-inner", className),
        style: _object_spread_props(_object_spread({}, style), {
            width: width
        }),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(utils_react/* ConditionalWrapper */.M, {
            condition: useWindowMask,
            wrapper: childrenWithWindowMaskClass,
            children: renderAsset()
        })
    });
};
AssetComponent.defaultProps = {
    convertGifToVideo: false,
    useWindowMask: false
};
/* harmony default export */ var asset_component = ((0,generic_config_context/* withGenericConfig */.P)((0,router.withRouter)(AssetComponent)));


/***/ }),

/***/ 36403:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ BigBrainScript; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(52951);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(88029);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 4 modules
var _create_super = __webpack_require__(60460);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./constants/clusters.js
var clusters = __webpack_require__(16961);
// EXTERNAL MODULE: ./constants/products.js
var products = __webpack_require__(84074);
;// CONCATENATED MODULE: ./components/core/head/products-service.js



var _obj;
var CLUSTER_TO_PRODUCT_ID = (_obj = {}, (0,_define_property/* default */.Z)(_obj, clusters.CONSTRUCTION, products/* WORK_MANAGEMENT_PRODUCT_ID */.py), (0,_define_property/* default */.Z)(_obj, clusters.HR, products/* WORK_MANAGEMENT_PRODUCT_ID */.py), (0,_define_property/* default */.Z)(_obj, clusters.OPERATIONS, products/* WORK_MANAGEMENT_PRODUCT_ID */.py), (0,_define_property/* default */.Z)(_obj, clusters.IT, products/* WORK_MANAGEMENT_PRODUCT_ID */.py), (0,_define_property/* default */.Z)(_obj, clusters.PMO, products/* WORK_MANAGEMENT_PRODUCT_ID */.py), (0,_define_property/* default */.Z)(_obj, clusters.PRODUCT_MANAGEMENT, products/* DEV_PRODUCT_ID */.xi), (0,_define_property/* default */.Z)(_obj, clusters.DESIGN_AND_CREATIVE, products/* WORK_MANAGEMENT_PRODUCT_ID */.py), (0,_define_property/* default */.Z)(_obj, clusters.TASKS_AND_TODOS, products/* WORK_MANAGEMENT_PRODUCT_ID */.py), (0,_define_property/* default */.Z)(_obj, clusters.FINANCE, products/* WORK_MANAGEMENT_PRODUCT_ID */.py), (0,_define_property/* default */.Z)(_obj, clusters.CREATIVE, products/* WORK_MANAGEMENT_PRODUCT_ID */.py), (0,_define_property/* default */.Z)(_obj, clusters.CRM, products/* CRM_PRODUCT_ID */.$), (0,_define_property/* default */.Z)(_obj, clusters.SOFTWARE, products/* DEV_PRODUCT_ID */.xi), (0,_define_property/* default */.Z)(_obj, clusters.WORK_MANAGEMENT, products/* WORK_MANAGEMENT_PRODUCT_ID */.py), (0,_define_property/* default */.Z)(_obj, clusters.MARKETING, products/* WORK_MANAGEMENT_PRODUCT_ID */.py), (0,_define_property/* default */.Z)(_obj, clusters.FUNDRAISING, products/* WORK_MANAGEMENT_PRODUCT_ID */.py), (0,_define_property/* default */.Z)(_obj, clusters.NON_PROFIT, products/* WORK_MANAGEMENT_PRODUCT_ID */.py), (0,_define_property/* default */.Z)(_obj, clusters.PROJECTS_FLOW, products/* WORK_MANAGEMENT_PRODUCT_ID */.py), _obj);
var getProductTypeFromCluster = function(clusterId) {
    return CLUSTER_TO_PRODUCT_ID[clusterId];
};

;// CONCATENATED MODULE: ./components/core/head/bigbrain-script.js







var BIGBRAIN_SCRIPT_URL = "https://informer-cdn2.monday.com/monday-informer-1.0.min.js";
var BIGBRAIN_URL = "https://data.bigbrain.me" || 0;
var BigBrainScript = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(BigBrainScript, PureComponent);
    var _super = (0,_create_super/* default */.Z)(BigBrainScript);
    function BigBrainScript() {
        (0,_class_call_check/* default */.Z)(this, BigBrainScript);
        return _super.apply(this, arguments);
    }
    (0,_create_class/* default */.Z)(BigBrainScript, [
        {
            key: "renderBigBrainTracker",
            value: function renderBigBrainTracker(template, isProduction, pageType, clusterId, subClusterId, preventPageView, createVisitor, crossDomain, emitVisitorId, emitTargetOrigin, segmentsList, pageProductId, exactPageAbTest) {
                var clusterIdToTrack = clusterId ? "".concat(clusterId).concat(subClusterId ? ",".concat(subClusterId) : "") : "";
                var exactPageAbTestTrack = exactPageAbTest ? "BigBrain('track', \"".concat(exactPageAbTest.name, '", { ab_test: "').concat(exactPageAbTest.variant, '" });') : "";
                return "\n      var brand_name = 'monday.com';\n      var template = '".concat(template, '\';\n\n      function add_general_event_props(args) {\n        event_props = {};\n        if(args.length == 3) {\n          event_props = args[2];\n        }\n\n        event_props[\'timestamp\'] = parseInt(new Date().getTime()/1000);\n        event_props["source"] = event_props["source"] || "monday_homepage";\n        event_props["group"] = "website";\n\n        if (args.length == 2) {\n          args.push(event_props);\n        }\n        else {\n          args[2] = event_props;\n        }\n        return args;\n      }\n\n      if (').concat(isProduction, ") {\n        window.BigBrainQ = window.BigBrainQ || [];\n        window.BigBrain = window.BigBrain || function(){\n          args = Array.prototype.slice.call(arguments)\n          if(args[0] == 'track'){\n            args = add_general_event_props(args)\n          }\n          window.BigBrainQ.push(args);\n        };\n\n        (function(d,u,callback){\n          if (window.BigBrainInit) return;\n          window.BigBrainInit = true;\n          var s = d.createElement('script');\n          s.type = 'text/javascript'\n          s.src = u;\n          s.async = true;\n          s.onreadystatechange = s.onload = function(){\n            var st = s.readyState;\n            if (!callback.done && (!st || /loaded|complete/.test(st))) {\n              callback.done = true;\n              callback();\n            }\n          };\n          (d.body || d.head).appendChild(s);\n        })(document, '").concat(BIGBRAIN_SCRIPT_URL, "', function() { \n            window.BigBrain = new BigBrainTracker({bigbrain_url: '").concat(BIGBRAIN_URL, "', send_immediately: true, create_visitor: ").concat(createVisitor, ", is_tracker_cross_domain: ").concat(!!crossDomain, ", emit_visitor_id: ").concat(!!emitVisitorId, ', emit_target_origin: "').concat(emitTargetOrigin, "\"});\n        });\n\n      } else {\n        window.BigBrain = function() {\n          args = Array.prototype.slice.call(arguments)\n          if(args[0] == 'track' || args[0] == 'set_utm_cluster_id'  ||  args[0] == 'set_utm_locale_id') {\n            args = add_general_event_props(args)\n            argsn = args.map(function(t) {\n              if (typeof(t) === 'object')\n                return JSON.stringify(t);\n              else\n                return t;\n            });\n            console.info(argsn);\n          }\n        }\n      }\n\n      if (").concat(!preventPageView, ") {\n        var type = document.getElementsByTagName('body')[0].dataset.pageType || '").concat(pageType, "';\n        if (type === undefined || (typeof (type) == 'string' && type.length == 0) || type == 'homepage'){\n          type = 'homepage';\n        } else {\n          type = '").concat(pageType, '\';\n        }\n        window.visitGuid = window.visitGuid || Math.ceil(Math.random() * 10000000);\n        var options = {\n          kind: location.pathname, \n          source: type, info2: template || "", \n          info3: location.href, \n          direct_object: window.visitGuid, \n          info1: "').concat(clusterIdToTrack, '", \n          data: {\n            segments: "').concat(segmentsList, '",\n            windowInnerWidth: window.innerWidth,\n            windowInnerHeight: window.innerHeight,\n            product: "').concat(pageProductId || getProductTypeFromCluster(clusterId), "\"\n          }\n        };\n        BigBrain('track', 'page_view', options);\n        ").concat(exactPageAbTestTrack, "\n      }\n  ");
            }
        },
        {
            key: "render",
            value: function render() {
                var _props = this.props, template = _props.template, isProduction = _props.isProduction, pageType = _props.pageType, clusterId = _props.clusterId, subClusterId = _props.subClusterId, preventPageView = _props.preventPageView, createVisitor = _props.createVisitor, crossDomain = _props.crossDomain, emitVisitorId = _props.emitVisitorId, emitTargetOrigin = _props.emitTargetOrigin, segmentsList = _props.segmentsList, pageProductId = _props.pageProductId, exactPageAbTest = _props.exactPageAbTest;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                    dangerouslySetInnerHTML: {
                        __html: this.renderBigBrainTracker(template, isProduction, pageType, clusterId, subClusterId, preventPageView, createVisitor, crossDomain, emitVisitorId, emitTargetOrigin, segmentsList, pageProductId, exactPageAbTest)
                    }
                });
            }
        }
    ]);
    return BigBrainScript;
}(react.PureComponent);

BigBrainScript.defaultProps = {
    pageType: "homepage",
    createVisitor: true
};


/***/ }),

/***/ 11094:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);

var FontsComponent = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "preload",
                href: "/static/fonts/poppins/poppins-v20-latin-300.woff2",
                as: "font",
                type: "font/woff2",
                crossOrigin: "anonymous"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "preload",
                href: "/static/fonts/poppins/poppins-v20-latin-regular.woff2",
                as: "font",
                type: "font/woff2",
                crossOrigin: "anonymous"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "preload",
                href: "/static/fonts/poppins/poppins-v20-latin-600.woff2",
                as: "font",
                type: "font/woff2",
                crossOrigin: "anonymous"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "preload",
                href: "/static/fonts/poppins/poppins-v20-latin-700.woff2",
                as: "font",
                type: "font/woff2",
                crossOrigin: "anonymous"
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (FontsComponent);


/***/ }),

/***/ 1909:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var constants_z_index__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(35257);

/* harmony default export */ __webpack_exports__["Z"] = ({
    footerText: "",
    shouldCloseOnEsc: true,
    shouldCloseOnOverlayClick: true,
    style: {
        overlay: {
            backgroundColor: "rgba(0, 0, 0, 0.75)",
            zIndex: "".concat(constants_z_index__WEBPACK_IMPORTED_MODULE_0__/* .MODAL_BACKGROUND */ .AE)
        },
        content: {
            top: "50%",
            left: "50%",
            right: "auto",
            bottom: "auto",
            transform: "translate(-50%, -50%)",
            padding: "0",
            border: "none",
            display: "flex",
            flexDirection: "column",
            backgroundColor: "transparent",
            minHeight: "630px",
            minWidth: "960px",
            overflow: "hidden",
            borderRadius: "16px"
        }
    },
    isOpen: false
});


/***/ }),

/***/ 35061:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "M9": function() { return /* binding */ BOLD_BLUE; },
  "LG": function() { return /* binding */ LG; },
  "MD": function() { return /* binding */ MD; },
  "SM": function() { return /* binding */ SM; },
  "Cj": function() { return /* binding */ WHITE; },
  "XS": function() { return /* binding */ XS; },
  "Mp": function() { return /* binding */ XXS; },
  "ZP": function() { return /* binding */ ButtonComponent; }
});

// UNUSED EXPORTS: BLUE, FULL, IRIS, MINT_GREEN

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_assert_this_initialized.mjs
var _assert_this_initialized = __webpack_require__(4111);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(52951);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(88029);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 4 modules
var _create_super = __webpack_require__(60460);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./styles/colors.js
var colors = __webpack_require__(12573);
// EXTERNAL MODULE: ./utils/react.js
var utils_react = __webpack_require__(12783);
// EXTERNAL MODULE: ./client/services/accessibility/accessibility-service.js
var accessibility_service = __webpack_require__(60696);
// EXTERNAL MODULE: ./segments/desktop/core-components/button/button-arrow/button-arrow.js + 1 modules
var button_arrow = __webpack_require__(37759);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
// EXTERNAL MODULE: ./styles/colors-utils.js
var colors_utils = __webpack_require__(61012);
// EXTERNAL MODULE: ./styles/color-consts.js
var color_consts = __webpack_require__(273);
;// CONCATENATED MODULE: ./components/core/new-button/button-component.scss.js




var getButtonTheme = function(color) {
    return "\n      &:not(.outline) {\n        background-color: ".concat(color, ";\n\n        &:hover {\n          background-color: darken(").concat(color, ", 5%);\n        }\n      }\n\n      &.outline {\n        color: ").concat(color, ";\n        border: 1px solid ").concat(color, " !important;\n        transition: background-color 200ms ease, color 200ms ease;\n\n        &:hover {\n          color: ").concat(colors/* default.white */.Z.white, " !important;\n          background-color: ").concat(color, ";\n          &.white {\n            color: ").concat(colors/* default.black */.Z.black, " !important;\n          }\n        }\n      }\n");
};
var StyledButtonComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "epmjo5x0"
})("display:inline-block;border-radius:100px;cursor:pointer;font-weight:300;user-select:none;transition:background-color 200ms ease;", function(param) {
    var accessibleColor = param.accessibleColor;
    return '\n  &[data-button-color="'.concat(accessibleColor, '"] {\n              &:not(.outline) {\n                background: ').concat(colors/* default */.Z[accessibleColor], ";\n                &:hover {\n                  background-color: ").concat((0,colors_utils/* getHoverColor */.n)(colors/* default */.Z[accessibleColor]), ";\n                  &.white {\n                    background-color: ").concat(colors/* default */.Z[color_consts.BACKGROUND_GRAY_COLOR_NAME], ";\n                  }\n                }\n              }\n            }\n  ");
}, "  &:hover{outline:0;}&.disabled{background-color:", colors/* default.dark-marble */.Z["dark-marble"], " !important;color:", colors/* default.brand-gray */.Z["brand-gray"], " !important;pointer-events:none;}// default size:md\n  font-size:0.8125rem;padding:12px 24px;&.with-arrow{padding-right:16px;}&.with-left-icon{height:40px;display:flex;align-items:center;}&.sm{font-size:0.6875rem;padding:8px 16px;&.with-arrow{padding-right:12px;}}&.md{font-size:0.8125rem;padding:12px 24px;&.min-padding{padding-right:10px;padding-left:10px;}&.with-arrow{padding-right:16px;}}&.lg{font-size:0.875rem;padding:16px 32px;&.with-arrow{padding-left:30px;padding-right:20px;}}&.full{font-size:0.875rem;padding:16px 0;width:100%;text-align:center;}&.blue{", getButtonTheme("#0085ff"), "}&.mint-green{", getButtonTheme("#25dbc5"), "}&.bold-blue{", getButtonTheme("#15bbe4"), "}&.purple{", getButtonTheme("#a358df"), "}&.iris{", getButtonTheme("#595ad4"), "}&.riverstone{", getButtonTheme("#f5f6f8"), "}&.royal{", getButtonTheme("#597bfc"), "}&.green{", getButtonTheme("#00ca72"), "}&.orange{", getButtonTheme("#fdab3d"), "}&.yellow{", getButtonTheme("#ffcb00"), "}&.pink{", getButtonTheme("#ff0476"), "}&.marketing-red-dark{", getButtonTheme("#ca0c6b"), "}&.dev-green-dark{", getButtonTheme("#037f4c"), "}&.projects-orange-dark{", getButtonTheme("#f86700"), "}&.crm-green-dark{", getButtonTheme("#00a0a0"), "}&.workos-iris{", getButtonTheme("#6161ff"), "}&.dark-color{", getButtonTheme("#181b34"), "}&.brand-wm-primary-color{", getButtonTheme("#6161ff"), "}&.crm-dark-tint-01{", getButtonTheme("#00889b"), "}&.brand-green-dark-tint-01{", getButtonTheme("#00854d"), "}&.white{", getButtonTheme("#ffffff"), "}&.black{", getButtonTheme("#000000"), "}&.workforms-red{", getButtonTheme("#c21e71"), "}&.service-dark-color{", getButtonTheme("#980131"), "}");

;// CONCATENATED MODULE: ./components/core/new-button/button-component.js





function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}








// BUTTON SIZES
var XXS = "xxs";
var XS = "xs";
var SM = "sm";
var MD = "md";
var LG = "lg";
var FULL = "full";
// BUTTON COLORS
var BLUE = "blue";
var MINT_GREEN = "mint-green";
var BOLD_BLUE = "bold-blue";
var WHITE = "white";
var IRIS = "iris";
var ButtonComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(ButtonComponent, PureComponent);
    var _super = (0,_create_super/* default */.Z)(ButtonComponent);
    function ButtonComponent(props) {
        (0,_class_call_check/* default */.Z)(this, ButtonComponent);
        var _this;
        _this = _super.call(this, props);
        _define_property((0,_assert_this_initialized/* default */.Z)(_this), "onClick", function(e) {
            var _props = _this.props, onClick = _props.onClick, disabled = _props.disabled;
            e === null || e === void 0 ? void 0 : e.target.blur(); //remove focus on mouse click
            if (disabled) return;
            onClick(e);
        });
        _define_property((0,_assert_this_initialized/* default */.Z)(_this), "linkWrapper", function(children) {
            var _props = _this.props, isOpenLinkInNewTab = _props.isOpenLinkInNewTab, seoFriendlyUrl = _props.seoFriendlyUrl;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                href: seoFriendlyUrl,
                target: isOpenLinkInNewTab ? "_blank" : "_self",
                children: children
            });
        });
        _this.onKeyDown = (0,accessibility_service/* generateOnKeyDownHandler */.vR)(_this.onClick);
        _this.state = {
            isHovered: false
        };
        return _this;
    }
    (0,_create_class/* default */.Z)(ButtonComponent, [
        {
            key: "getComponentInlineStyles",
            value: function getComponentInlineStyles() {
                var _props = this.props, outline = _props.outline, color = _props.color, textColor = _props.textColor;
                return {
                    color: outline ? colors/* default */.Z[color] : textColor
                };
            }
        },
        {
            key: "render",
            value: function render() {
                var _this = this;
                var _props = this.props, children = _props.children, className = _props.className, color = _props.color, size = _props.size, outline = _props.outline, disabled = _props.disabled, isWithArrow = _props.isWithArrow, iconRenderer = _props.iconRenderer, seoFriendlyUrl = _props.seoFriendlyUrl, minPadding = _props.minPadding;
                var isHovered = this.state.isHovered;
                var inlineComponentStyles = this.getComponentInlineStyles();
                var accessibleColor = (0,accessibility_service/* getAccessibleButtonColor */.ef)(color);
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(utils_react/* ConditionalWrapper */.M, {
                    condition: !!seoFriendlyUrl,
                    wrapper: this.linkWrapper,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledButtonComponent, {
                        accessibleColor: accessibleColor,
                        className: classnames_default()("button-component", className, size, accessibleColor, {
                            outline: outline,
                            disabled: disabled,
                            "with-arrow": isWithArrow,
                            "min-padding": minPadding,
                            "with-left-icon": iconRenderer != null
                        }),
                        onClick: this.onClick,
                        style: inlineComponentStyles,
                        onKeyDown: this.onKeyDown,
                        tabIndex: disabled ? -1 : 0,
                        role: "button",
                        onMouseEnter: function() {
                            return _this.setState({
                                isHovered: true
                            });
                        },
                        onMouseLeave: function() {
                            return _this.setState({
                                isHovered: false
                            });
                        },
                        "data-button-color": accessibleColor,
                        children: [
                            iconRenderer && iconRenderer(),
                            children,
                            isWithArrow && /*#__PURE__*/ (0,jsx_runtime.jsx)(button_arrow/* default */.Z, {
                                size: size,
                                hover: isHovered
                            })
                        ]
                    })
                });
            }
        }
    ]);
    return ButtonComponent;
}(react.PureComponent);

ButtonComponent.defaultProps = {
    className: "",
    color: BLUE,
    size: MD,
    outline: false,
    textColor: colors/* default.white */.Z.white,
    iconRenderer: null,
    minPadding: false,
    disabled: false
};


/***/ }),

/***/ 94640:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ PictureWithLinkComponent; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_assert_this_initialized_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(4111);
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(51438);
/* harmony import */ var _swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(52951);
/* harmony import */ var _swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(88029);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(29815);
/* harmony import */ var _swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(60460);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var components_core_picture_picture_component__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(82305);
/* harmony import */ var _constants_bigbrain_event_types__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(65023);






function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}




var PictureWithLinkComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(PictureWithLinkComponent, PureComponent);
    var _super = (0,_swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(PictureWithLinkComponent);
    function PictureWithLinkComponent() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(this, PictureWithLinkComponent);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(args)));
        _define_property((0,_swc_helpers_src_assert_this_initialized_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_this), "onClick", function(e) {
            var _props = _this.props, href = _props.href, src = _props.src;
            var isKeyboardEvent = (e === null || e === void 0 ? void 0 : e.screenX) === 0 && (e === null || e === void 0 ? void 0 : e.screenY) === 0;
            BigBrain("track", _constants_bigbrain_event_types__WEBPACK_IMPORTED_MODULE_8__.PICTURE_WITH_LINK_CLICKED, {
                kind: href,
                info1: isKeyboardEvent ? "keyboard" : "mouse",
                info2: src
            });
        });
        return _this;
    }
    (0,_swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(PictureWithLinkComponent, [
        {
            key: "render",
            value: function render() {
                var _this_props = this.props, href = _this_props.href, target = _this_props.target, otherProps = _object_without_properties(_this_props, [
                    "href",
                    "target"
                ]);
                if (href) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                        href: href,
                        target: target,
                        onClick: this.onClick,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_core_picture_picture_component__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, _object_spread({}, otherProps))
                    });
                }
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_core_picture_picture_component__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, _object_spread({}, otherProps));
            }
        }
    ]);
    return PictureWithLinkComponent;
}(react__WEBPACK_IMPORTED_MODULE_1__.PureComponent);

PictureWithLinkComponent.defaultProps = {
    target: "_self"
};


/***/ }),

/***/ 20525:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ TabComponent; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_assert_this_initialized.mjs
var _assert_this_initialized = __webpack_require__(4111);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(52951);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(88029);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 4 modules
var _create_super = __webpack_require__(60460);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./styles/colors.js
var colors = __webpack_require__(12573);
// EXTERNAL MODULE: ./client/services/accessibility/accessibility-service.js
var accessibility_service = __webpack_require__(60696);
// EXTERNAL MODULE: ./constants/bigbrain-event-types.js
var bigbrain_event_types = __webpack_require__(65023);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./segments/desktop/core-components/title/title.js + 1 modules
var title = __webpack_require__(91265);
// EXTERNAL MODULE: ./constants/sizes.js
var sizes = __webpack_require__(77869);
// EXTERNAL MODULE: ./styles/color-consts.js
var color_consts = __webpack_require__(273);
// EXTERNAL MODULE: ./segments/segments-service.js
var segments_service = __webpack_require__(861);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
;// CONCATENATED MODULE: ./components/core/tabs/tab/tab-component.scss.js

var LINE_WIDTH = 4;
var LINE_WIDTH_STRING = "".concat(LINE_WIDTH, "px");
var StyledTabComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "ergyzlu0"
})("position:relative;text-align:center;min-width:240px;cursor:pointer;padding:16px 24px;:hover{outline:0;background-color:var(--tab-background-color);.tab-label{color:var(--tab-color);}}&.active{background-color:var(--tab-background-color);.tab-underline-placeholder{background:var(--tab-background-color);.tab-underline{left:0;right:0;}}}&.small-labels{min-width:160px;.tab-label{font-size:0.875rem;}}&.half-screen-tabs{min-width:100px;display:flex;justify-content:center;padding:8px 5px;.title-wrapper{.title-and-icon-wrapper{.core-title-container .core-title{font-weight:300;}.icon-wrapper{.picture-icon-wrapper{height:20px;margin-bottom:4px;}}}}}.tab-label{font-weight:600;font-size:1.375rem;}.tab-underline-placeholder{position:absolute;height:", LINE_WIDTH_STRING, ";bottom:0;left:0;right:0;border-top-left-radius:", LINE_WIDTH_STRING, ";border-top-right-radius:", LINE_WIDTH_STRING, ";.tab-underline{position:absolute;top:0;bottom:0;left:50%;right:50%;transition:left 0.2s ease,right 0.2s ease;border-top-left-radius:", LINE_WIDTH_STRING, ";border-top-right-radius:", LINE_WIDTH_STRING, ";}}");

;// CONCATENATED MODULE: ./components/core/tabs/tab/tab-component.js






function _define_property1(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}











var TabComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(TabComponent, PureComponent);
    var _super = (0,_create_super/* default */.Z)(TabComponent);
    function TabComponent(props) {
        (0,_class_call_check/* default */.Z)(this, TabComponent);
        var _this;
        _this = _super.call(this, props);
        _define_property1((0,_assert_this_initialized/* default */.Z)(_this), "blurTab", function(e) {
            var _e_target_closest, _e_target;
            e === null || e === void 0 ? void 0 : (_e_target = e.target) === null || _e_target === void 0 ? void 0 : (_e_target_closest = _e_target.closest(".tab-component")) === null || _e_target_closest === void 0 ? void 0 : _e_target_closest.blur();
        });
        _define_property1((0,_assert_this_initialized/* default */.Z)(_this), "tabClickedAction", function() {
            var _props = _this.props, onClick = _props.onClick, index = _props.index, label = _props.label, labelTranslationKey = _props.labelTranslationKey, extraData = _props.extraData;
            BigBrain("track", bigbrain_event_types.TAB_CLICKED, {
                kind: label,
                info1: index,
                info2: labelTranslationKey,
                data: extraData
            });
            onClick(index);
        });
        _this.onTabClicked = _this.onTabClicked.bind((0,_assert_this_initialized/* default */.Z)(_this));
        _this.onKeyDown = (0,accessibility_service/* generateOnKeyDownHandler */.vR)(_this.tabClickedAction);
        return _this;
    }
    (0,_create_class/* default */.Z)(TabComponent, [
        {
            key: "onTabClicked",
            value: function onTabClicked(e) {
                this.blurTab(e);
                this.tabClickedAction();
            }
        },
        {
            key: "render",
            value: function render() {
                var _props = this.props, label = _props.label, hideLabel = _props.hideLabel, color = _props.color, backgroundColor = _props.backgroundColor, isActive = _props.isActive, useSmallLabels = _props.useSmallLabels, tabIcon = _props.tabIcon, useXSMLabels = _props.useXSMLabels, tabsWithIcons = _props.tabsWithIcons, tabClassName = _props.tabClassName, theme = _props.theme, unsetLabelColor = _props.unsetLabelColor;
                var tabColor = colors/* default */.Z[color];
                var tabLabel = hideLabel ? "" : label;
                var defaultTabLabelColor = (0,segments_service/* isDarkTheme */.$o)(theme) ? colors/* default */.Z[color_consts.WHITE_COLOR_NAME] : colors/* default.mud */.Z.mud;
                var tabLabelColor = isActive ? tabColor : defaultTabLabelColor;
                var unsetTabLabelcolor = function() {
                    return unsetLabelColor && (0,segments_service/* isDarkTheme */.$o)(theme) && !isActive;
                };
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledTabComponent, {
                    className: classnames_default()("tab-component", (0,_define_property/* default */.Z)({
                        active: isActive,
                        "small-labels": useSmallLabels,
                        "half-screen-tabs": useXSMLabels
                    }, tabClassName, tabClassName)),
                    style: {
                        "--tab-color": tabColor,
                        "--tab-background-color": colors/* default */.Z[backgroundColor] || colors/* default */.Z[color_consts.BACKGROUND_GRAY_COLOR_NAME]
                    },
                    onClick: this.onTabClicked,
                    role: "tab",
                    "aria-selected": isActive,
                    tabIndex: 0,
                    onKeyDown: this.onKeyDown,
                    children: [
                        !tabsWithIcons && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "tab-label",
                            style: unsetTabLabelcolor() ? {} : {
                                color: tabLabelColor
                            },
                            children: tabLabel
                        }),
                        tabsWithIcons && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "title-wrapper",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(title/* default */.Z, {
                                title: tabLabel,
                                titleIcon: tabIcon === null || tabIcon === void 0 ? void 0 : tabIcon.src,
                                titleSize: sizes/* XS_L */.L4
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "tab-underline-placeholder",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "tab-underline",
                                style: {
                                    background: tabColor
                                }
                            })
                        })
                    ]
                });
            }
        }
    ]);
    return TabComponent;
}(react.PureComponent);

TabComponent.defaultProps = {
    useSmallLabels: false
};


/***/ }),

/***/ 10873:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ tabs_component; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(10092);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./constants/align-types.js
var align_types = __webpack_require__(79409);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
// EXTERNAL MODULE: ./services/dom-utils-service.js
var dom_utils_service = __webpack_require__(44566);
// EXTERNAL MODULE: ./node_modules/querystring/index.js
var querystring = __webpack_require__(17673);
// EXTERNAL MODULE: ./constants/query-params.js
var query_params = __webpack_require__(54224);
// EXTERNAL MODULE: ./client/services/hooks/use-interval.js
var use_interval = __webpack_require__(32184);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
;// CONCATENATED MODULE: ./components/core/tabs/tabs-component.scss.js

var StyledTabsComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "edmslg20"
})("display:flex;flex-direction:column;&.left{align-items:flex-start;}&.center{align-items:center;}&.right{align-items:flex-end;}.tabs{display:flex;width:100%;justify-content:space-around;}.content{padding-top:48px;}");

;// CONCATENATED MODULE: ./components/core/tabs/tabs-component.js

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}










var TabsComponent = function(props) {
    var children = props.children, defaultActiveTabIndex = props.defaultActiveTabIndex, router = props.router, autoTransition = props.autoTransition, className = props.className, tabsAlign = props.tabsAlign, scrollSpeed = props.scrollSpeed, scrollOnTabClick = props.scrollOnTabClick, distanceFromTop = props.distanceFromTop, onTabClick = props.onTabClick;
    var getInitialActiveTabIndex = function() {
        try {
            var _router_asPath_split, _router_asPath;
            var params = querystring.parse(router === null || router === void 0 ? void 0 : (_router_asPath = router.asPath) === null || _router_asPath === void 0 ? void 0 : (_router_asPath_split = _router_asPath.split("?")) === null || _router_asPath_split === void 0 ? void 0 : _router_asPath_split[1]);
            var activeTabId = params === null || params === void 0 ? void 0 : params[query_params.ACTIVE_TAB_ID];
            if (activeTabId) {
                var activeTabIndexById = children === null || children === void 0 ? void 0 : children.findIndex(function(tab) {
                    var _tab_props;
                    return (tab === null || tab === void 0 ? void 0 : (_tab_props = tab.props) === null || _tab_props === void 0 ? void 0 : _tab_props.tabId) === activeTabId;
                });
                if (activeTabIndexById && activeTabIndexById >= 0) {
                    return activeTabIndexById;
                }
            }
        } catch (e) {
            return defaultActiveTabIndex;
        }
        return defaultActiveTabIndex;
    };
    var ref = (0,react.useState)(getInitialActiveTabIndex()), activeTabIndex = ref[0], setActiveTabIndex = ref[1];
    var contentNode = (0,react.useRef)();
    var autoTransitionAsNumber = Number(autoTransition || 0);
    (0,use_interval/* default */.Z)(function() {
        setActiveTabIndex((activeTabIndex + 1) % children.length);
    }, autoTransitionAsNumber > 0 ? autoTransitionAsNumber : null, [
        activeTabIndex
    ]);
    var handleTabClick = function() {
        var _ref = _async_to_generator(function(index) {
            var node, _tmp, e;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        node = contentNode === null || contentNode === void 0 ? void 0 : contentNode.current;
                        if (onTabClick) {
                            onTabClick(index);
                        }
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            4,
                            ,
                            5
                        ]);
                        _tmp = scrollOnTabClick && node;
                        if (!_tmp) return [
                            3,
                            3
                        ];
                        return [
                            4,
                            (0,dom_utils_service.isNodeFullyInView)(node)
                        ];
                    case 2:
                        _tmp = !_state.sent();
                        _state.label = 3;
                    case 3:
                        if (_tmp) {
                            (0,dom_utils_service.scrollTo)(contentNode.current.offsetTop - distanceFromTop, scrollSpeed);
                        }
                        return [
                            3,
                            5
                        ];
                    case 4:
                        e = _state.sent();
                        return [
                            3,
                            5
                        ];
                    case 5:
                        setActiveTabIndex(index);
                        return [
                            2
                        ];
                }
            });
        });
        return function handleTabClick(index) {
            return _ref.apply(this, arguments);
        };
    }();
    var tabsRenderer = function() {
        return children.map(function(child, index) {
            return /*#__PURE__*/ (0,react.cloneElement)(child, {
                onClick: handleTabClick,
                index: index,
                isActive: index === activeTabIndex
            });
        });
    };
    var contentRenderer = function() {
        if (children[activeTabIndex]) {
            return children[activeTabIndex].props.children;
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledTabsComponent, {
        className: classnames_default()("tabs-component", className, tabsAlign),
        ref: contentNode,
        role: "tablist",
        "aria-label": "documentation-navigation",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "tabs",
                style: {
                    "--tab-transition": autoTransition
                },
                children: tabsRenderer()
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "content",
                role: "tab",
                children: contentRenderer()
            })
        ]
    });
};
/* harmony default export */ var tabs_component = ((0,router.withRouter)(TabsComponent));
TabsComponent.defaultProps = {
    children: [],
    defaultActiveTabIndex: 0,
    autoTransition: "30000",
    scrollSpeed: 200,
    scrollOnTabClick: false,
    distanceFromTop: 0,
    className: "",
    tabsAlign: align_types.ALIGN_TYPES.CENTER
};


/***/ }),

/***/ 3773:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ video_component; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-player/lib/ReactPlayer.js
var ReactPlayer = __webpack_require__(70390);
// EXTERNAL MODULE: ./node_modules/react-visibility-sensor/visibility-sensor.js
var visibility_sensor = __webpack_require__(51529);
var visibility_sensor_default = /*#__PURE__*/__webpack_require__.n(visibility_sensor);
// EXTERNAL MODULE: ./services/community/cloudinary-service.js
var cloudinary_service = __webpack_require__(40927);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
;// CONCATENATED MODULE: ./components/core/video/video-component.scss.js

var StyledVideoComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1gu2uz00"
})("height:100%;outline:none;&.hide-black-bars{height:32vw;.react-player-video-component video{object-fit:cover;}}");

;// CONCATENATED MODULE: ./components/core/video/video-component.js
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}








var VideoComponent = function(props) {
    var ref = (0,react.useState)(false), isVisible = ref[0], setVisible = ref[1];
    var ref1 = (0,react.useState)(false), hovered = ref1[0], setHovered = ref1[1];
    var ref2 = (0,react.useState)(false), hadFocusWithKeyboardEvent = ref2[0], setHadFocusWithKeyboardEvent = ref2[1];
    /* Video configuration */ var shouldPlayVideo = function() {
        var playWhenVisible = props.playWhenVisible, autoPlay = props.autoPlay, disableAutoplay = props.disableAutoplay, hideControls = props.hideControls;
        if (!hideControls && disableAutoplay) {
            return false;
        }
        if (!playWhenVisible) {
            return autoPlay;
        }
        return isVisible;
    };
    var getUrl = function() {
        var url;
        if (props.singleUrl) {
            url = props.singleUrl;
        } else {
            // Only set urls on init so player is not refreshed on every update
            var formats = props.formats.filter(function(urlFormat) {
                return urlFormat;
            }); // clean undefined
            url = formats;
            if (formats.length > 0 && !(0,cloudinary_service.isCloudinaryUrl)(formats[0])) {
                url = (0,cloudinary_service.generateCloudinaryVideoUrl)(formats[0], {
                    assetQuality: props.assetQuality
                });
            }
        }
        return url;
    };
    var getPoster = function() {
        var poster = props.poster;
        var fixedPosterUrl;
        if (poster) {
            fixedPosterUrl = (0,cloudinary_service.generateCloudinaryImageUrl)(poster);
        } else {
            var formats = props.formats;
            var videoUrl = formats[0];
            if (videoUrl) {
                fixedPosterUrl = (0,cloudinary_service.generateCloudinaryVideoThumbnail)(videoUrl);
            }
        }
        return fixedPosterUrl;
    };
    var getConfig = function(poster) {
        var config = props.config, ariaLabel = props.ariaLabel;
        var newConfig = _object_spread({}, config);
        newConfig.file = config.file || {};
        newConfig.file.attributes = _object_spread_props(_object_spread({}, newConfig.file.attributes), {
            poster: poster,
            "aria-label": ariaLabel
        });
        return newConfig;
    };
    /* Events */ var onClick = function() {
        props.onClick && props.onClick();
    };
    var onMouseEnter = function() {
        setHovered(true);
    };
    var onMouseLeave = function() {
        setHovered(false);
    };
    var onFocus = function() {
        if (!hovered) {
            setHadFocusWithKeyboardEvent(true);
        }
    };
    var onVisibilityChange = function(isVisible) {
        setTimeout(function() {
            return setVisible(isVisible);
        }, 200);
    };
    var showControls = function() {
        if (hideControls === undefined) {
            return !loop;
        }
        if (hideControls) {
            return false;
        }
        return hovered || hadFocusWithKeyboardEvent;
    };
    var style = props.style, playWhenVisible = props.playWhenVisible, loop = props.loop, muted = props.muted, volume = props.volume, playsInline = props.playsInline, hideControls = props.hideControls;
    var singleUrl = props.singleUrl, formats = props.formats, assetQuality = props.assetQuality, poster = props.poster, config = props.config, ariaLabel = props.ariaLabel, className = props.className, videoPlayerRef = props.videoPlayerRef, onStart = props.onStart, onEnded = props.onEnded, onDuration = props.onDuration, hideBlackBars = props.hideBlackBars;
    var memoizedUrl = (0,react.useMemo)(function() {
        return getUrl();
    }, [
        singleUrl,
        formats,
        assetQuality
    ]);
    var memoizedPoster = (0,react.useMemo)(function() {
        return getPoster();
    }, [
        poster,
        formats
    ]);
    var memoizedConfig = (0,react.useMemo)(function() {
        return getConfig(memoizedPoster);
    }, [
        memoizedPoster,
        config,
        ariaLabel
    ]);
    var tabIndex = hideControls ? -1 : 0;
    var getStyle = function() {
        var height = props.height;
        return height ? {
            height: height
        } : {};
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((visibility_sensor_default()), {
        offset: {
            bottom: 100,
            top: 100
        },
        partialVisibility: true,
        onChange: onVisibilityChange,
        active: playWhenVisible,
        scrollCheck: playWhenVisible,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledVideoComponent, {
            className: classnames_default()("video-component", {
                "hide-black-bars": hideBlackBars
            }),
            style: getStyle(),
            onClick: onClick,
            onMouseEnter: onMouseEnter,
            onMouseLeave: onMouseLeave,
            onFocus: onFocus,
            tabIndex: tabIndex,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ReactPlayer/* default */.ZP, {
                ref: videoPlayerRef,
                className: classnames_default()("react-player-video-component", className),
                url: [
                    memoizedUrl
                ],
                style: style,
                playsinline: playsInline,
                playing: shouldPlayVideo(),
                config: memoizedConfig,
                muted: muted,
                volume: volume,
                loop: loop,
                controls: showControls(),
                width: "100%",
                height: "100%",
                onStart: onStart,
                onEnded: onEnded,
                onDuration: onDuration
            })
        })
    });
};
VideoComponent.defaultProps = {
    formats: [],
    autoPlay: true,
    playWhenVisible: true,
    muted: true,
    volume: 0,
    config: {},
    playsInline: true,
    ariaLabel: null,
    singleUrl: null,
    videoPlayerRef: null
};
/* harmony default export */ var video_component = (VideoComponent);


/***/ }),

/***/ 60202:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ YoutubeVideoModalComponent; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(52951);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(88029);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 4 modules
var _create_super = __webpack_require__(60460);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-modal/lib/index.js
var lib = __webpack_require__(83253);
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);
// EXTERNAL MODULE: ./node_modules/monday-ui-react-core/dist/Icon.js
var Icon = __webpack_require__(41114);
var Icon_default = /*#__PURE__*/__webpack_require__.n(Icon);
// EXTERNAL MODULE: ./node_modules/monday-ui-react-core/dist/icons/Close.js
var Close = __webpack_require__(55831);
var Close_default = /*#__PURE__*/__webpack_require__.n(Close);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_assert_this_initialized.mjs
var _assert_this_initialized = __webpack_require__(4111);
// EXTERNAL MODULE: ./components/core/signups/base-signup-form/signup-form-component.js + 2 modules
var signup_form_component = __webpack_require__(24494);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
// EXTERNAL MODULE: ./styles/colors.js
var colors = __webpack_require__(12573);
;// CONCATENATED MODULE: ./components/core/modal-with-signup/modal-footer/modal-footer-component.scss.js


var StyledModalFooterComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "ehv20jh0"
})("display:flex;align-items:center;justify-content:center;transform:scale(0.9);.modal-footer-text{color:", colors/* default.white */.Z.white, ";outline:none;font-size:1.125rem;}.modal-footer-signup-wrapper{width:55%;margin-left:16px;}");

;// CONCATENATED MODULE: ./components/core/modal-with-signup/modal-footer/modal-footer-component.js








var ModalFooterComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(ModalFooterComponent, PureComponent);
    var _super = (0,_create_super/* default */.Z)(ModalFooterComponent);
    function ModalFooterComponent() {
        (0,_class_call_check/* default */.Z)(this, ModalFooterComponent);
        return _super.apply(this, arguments);
    }
    (0,_create_class/* default */.Z)(ModalFooterComponent, [
        {
            key: "render",
            value: function render() {
                var footerText = this.props.footerText;
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledModalFooterComponent, {
                    className: "modal-footer",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "modal-footer-text",
                            children: footerText
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "modal-footer-signup-wrapper",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(signup_form_component/* default */.Z, {
                                focusOnLoad: true,
                                placement: "modal_footer"
                            })
                        })
                    ]
                });
            }
        }
    ]);
    return ModalFooterComponent;
}(react.PureComponent);


;// CONCATENATED MODULE: ./components/core/modal-with-signup/modal-content/modal-content-component.scss.js


var StyledModalWithSignupContentComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1buq9i0"
})("overflow:hidden;display:flex;flex-direction:column;justify-content:flex-end;border-radius:18px;.modal-footer-wrapper{background-color:", colors/* default.brand-dark-blue */.Z["brand-dark-blue"], ";padding:8px 0;width:100%;}");

// EXTERNAL MODULE: ./node_modules/react-onclickoutside/dist/react-onclickoutside.es.js
var react_onclickoutside_es = __webpack_require__(58949);
;// CONCATENATED MODULE: ./components/core/modal-with-signup/modal-content/modal-content-component.js










var ModalWithSignupContentComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(ModalWithSignupContentComponent, PureComponent);
    var _super = (0,_create_super/* default */.Z)(ModalWithSignupContentComponent);
    function ModalWithSignupContentComponent(props) {
        (0,_class_call_check/* default */.Z)(this, ModalWithSignupContentComponent);
        var _this;
        _this = _super.call(this, props);
        _this.handleClickOutside = _this.handleClickOutside.bind((0,_assert_this_initialized/* default */.Z)(_this));
        return _this;
    }
    (0,_create_class/* default */.Z)(ModalWithSignupContentComponent, [
        {
            key: "handleClickOutside",
            value: function handleClickOutside() {
                this.props.onCloseModal();
            }
        },
        {
            key: "render",
            value: function render() {
                var _props = this.props, children = _props.children, footerText = _props.footerText, onCloseModal = _props.onCloseModal, style = _props.style, withSignup = _props.withSignup;
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledModalWithSignupContentComponent, {
                    className: "modal-content-wrapper",
                    style: {
                        minHeight: style.content.minHeight,
                        minWidth: style.content.minWidth
                    },
                    children: [
                        children,
                        withSignup && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "modal-footer-wrapper",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalFooterComponent, {
                                footerText: footerText
                            })
                        })
                    ]
                });
            }
        }
    ]);
    return ModalWithSignupContentComponent;
}(react.PureComponent);
ModalWithSignupContentComponent.defaultProps = {
    withSignup: true
};
/* harmony default export */ var modal_content_component = ((0,react_onclickoutside_es/* default */.Z)(ModalWithSignupContentComponent));

;// CONCATENATED MODULE: ./components/core/modal-with-signup/modal-with-signup-component.scss.js

var StyledCloseButton = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1bcka210"
})("position:absolute;top:-24px;right:-24px;font-size:2.25rem;font-weight:400;opacity:0.7;transition:opacity 0.1s ease-in-out;cursor:pointer;outline:none;color:white;display:flex;&:hover{opacity:1;}");

// EXTERNAL MODULE: ./components/core/modal-with-signup/default-props.js
var default_props = __webpack_require__(1909);
;// CONCATENATED MODULE: ./components/core/modal-with-signup/modal-with-signup-component.js
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}








var ModalWithSignupComponent = function(props) {
    var onCloseModal = props.onCloseModal;
    (0,react.useEffect)(function() {
        lib_default().setAppElement("body");
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)((lib_default()), _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledCloseButton, {
                className: "close-button",
                onClick: onCloseModal,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((Icon_default()), {
                    iconType: (Icon_default()).type.SVG,
                    icon: (Close_default()),
                    iconSize: 24
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(modal_content_component, _object_spread({}, props))
        ]
    }));
};
ModalWithSignupComponent.defaultProps = default_props/* default */.Z;
/* harmony default export */ var modal_with_signup_component = (ModalWithSignupComponent);

// EXTERNAL MODULE: ./components/core/youtube-video/youtube-video-component.js + 1 modules
var youtube_video_component = __webpack_require__(14831);
;// CONCATENATED MODULE: ./components/core/youtube-video-modal/youtube-video-modal-component.scss.js

var StyledYoutubeVideoWrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e16vng0v0"
})("background-color:rgba(255,255,255,0.7);span{display:flex;}");

;// CONCATENATED MODULE: ./components/core/youtube-video-modal/youtube-video-modal-component.js




function youtube_video_modal_component_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function youtube_video_modal_component_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            youtube_video_modal_component_define_property(target, key, source[key]);
        });
    }
    return target;
}





var YoutubeVideoModalComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(YoutubeVideoModalComponent, PureComponent);
    var _super = (0,_create_super/* default */.Z)(YoutubeVideoModalComponent);
    function YoutubeVideoModalComponent() {
        (0,_class_call_check/* default */.Z)(this, YoutubeVideoModalComponent);
        return _super.apply(this, arguments);
    }
    (0,_create_class/* default */.Z)(YoutubeVideoModalComponent, [
        {
            key: "render",
            value: function render() {
                var _props = this.props, isOpen = _props.isOpen, onCloseModal = _props.onCloseModal, footerText = _props.footerText, style = _props.style, withSignup = _props.withSignup;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(modal_with_signup_component, {
                    style: style,
                    footerText: footerText,
                    isOpen: isOpen,
                    onCloseModal: onCloseModal,
                    withSignup: withSignup,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledYoutubeVideoWrapper, {
                        className: "youtube-video-wrapper",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(youtube_video_component/* default */.ZP, youtube_video_modal_component_object_spread({}, this.props))
                    })
                });
            }
        }
    ]);
    return YoutubeVideoModalComponent;
}(react.PureComponent);

YoutubeVideoModalComponent.defaultProps = {
    withSignup: true
};


/***/ }),

/***/ 14831:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ZP": function() { return /* binding */ youtube_video_component; }
});

// UNUSED EXPORTS: YOUTUBE_EMBEDED_HOST, YOUTUBE_EMBEDED_NOCOOKIE_HOST

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_assert_this_initialized.mjs
var _assert_this_initialized = __webpack_require__(4111);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(52951);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(88029);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 4 modules
var _create_super = __webpack_require__(60460);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
;// CONCATENATED MODULE: ./components/core/youtube-video/youtube-video-component.scss.js

var StyledYouTubeVideoComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "exohynt0"
})(".video-container{display:flex;flex-direction:column;text-align:center;align-items:center;justify-content:center;height:100%;width:100%;.content{display:flex;iframe{display:block;}&.with-shadow{box-shadow:0 2px 16px 0 rgba(0,0,0,0.2);}}}");

// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-youtube/dist/index.esm.js
var index_esm = __webpack_require__(5406);
// EXTERNAL MODULE: ./contexts/generic-config-context.js
var generic_config_context = __webpack_require__(3156);
// EXTERNAL MODULE: ./services/bigbrain-service.js
var bigbrain_service = __webpack_require__(65488);
// EXTERNAL MODULE: ./services/cookies-service.js
var cookies_service = __webpack_require__(67798);
// EXTERNAL MODULE: ./constants/cookies-categories.js
var cookies_categories = __webpack_require__(41140);
// EXTERNAL MODULE: ./constants/bigbrain-event-types.js
var bigbrain_event_types = __webpack_require__(65023);
;// CONCATENATED MODULE: ./components/core/youtube-video/youtube-video-component.js






function _define_property1(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property1(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}










var DEFAULT_PLAYER_VARS = {
    modestbranding: 1,
    controls: 1,
    rel: 0,
    frameBorder: 0,
    showinfo: 1,
    playsinline: 0
};
var DEFAULT_OPTS = {
    playerVars: DEFAULT_PLAYER_VARS
};
var YOUTUBE_EMBEDED_HOST = "https://www.youtube.com";
var YOUTUBE_EMBEDED_NOCOOKIE_HOST = "https://www.youtube-nocookie.com";
var YouTubeVideoComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(YouTubeVideoComponent, PureComponent);
    var _super = (0,_create_super/* default */.Z)(YouTubeVideoComponent);
    function YouTubeVideoComponent(props) {
        (0,_class_call_check/* default */.Z)(this, YouTubeVideoComponent);
        var _this;
        _this = _super.call(this, props);
        _define_property1((0,_assert_this_initialized/* default */.Z)(_this), "onPlay", function(event) {
            var _props = _this.props, onPlay = _props.onPlay, videoId = _props.videoId;
            (0,bigbrain_service.trackEvent)(bigbrain_event_types.YOUTUBE_VIDEO_STARTED, {
                kind: videoId
            });
            if (onPlay) onPlay(event);
        });
        _define_property1((0,_assert_this_initialized/* default */.Z)(_this), "onEnd", function(event) {
            var _props = _this.props, onEnd = _props.onEnd, videoId = _props.videoId;
            (0,bigbrain_service.trackEvent)(bigbrain_event_types.YOUTUBE_VIDEO_ENDED, {
                kind: videoId
            });
            if (onEnd) onEnd(event);
        });
        _this.onReady = _this.onReady.bind((0,_assert_this_initialized/* default */.Z)(_this));
        _this._player = null;
        return _this;
    }
    (0,_create_class/* default */.Z)(YouTubeVideoComponent, [
        {
            key: "onReady",
            value: function onReady(event) {
                var _props = this.props, onReady1 = _props.onReady, playing = _props.playing;
                this._player = event.target;
                this.toggleMute();
                this.setVolume();
                if (playing) {
                    // We want do to it only if playing = true so we don't pause the video.
                    this.togglePlay();
                }
                onReady1(event);
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps) {
                if (this.props.muted !== prevProps.muted) {
                    this.toggleMute();
                }
                if (this.props.playing !== prevProps.playing) {
                    this.togglePlay();
                }
                if (this.props.volume !== prevProps.volume) {
                    this.setVolume();
                }
            }
        },
        {
            key: "toggleMute",
            value: function toggleMute() {
                var muted = this.props.muted;
                if (!this._player) {
                    return;
                }
                if (muted) {
                    this._player.mute();
                } else {
                    this._player.unMute();
                }
            }
        },
        {
            key: "togglePlay",
            value: function togglePlay() {
                var playing = this.props.playing;
                if (!this._player) {
                    return;
                }
                if (playing) {
                    this._player.playVideo();
                } else {
                    this._player.pauseVideo();
                }
            }
        },
        {
            key: "setVolume",
            value: function setVolume() {
                var volume = this.props.volume;
                if (!this._player || volume === null) {
                    return;
                }
                this._player.setVolume(volume);
            }
        },
        {
            key: "getYoutubeHost",
            value: function getYoutubeHost() {
                return (0,cookies_service/* isInClientAndCookieCategoryNotApproved */.P0)(cookies_categories.COOKIE_CATEGORIES.MARKETING) //GDPR relevant - in other countries Marketing category is always approved
                 ? YOUTUBE_EMBEDED_NOCOOKIE_HOST : YOUTUBE_EMBEDED_HOST;
            }
        },
        {
            key: "generateOpts",
            value: function generateOpts() {
                var opts = this.props.opts;
                return _object_spread_props(_object_spread({}, opts), {
                    host: this.getYoutubeHost()
                });
            }
        },
        {
            key: "render",
            value: function render() {
                var _props = this.props, videoId = _props.videoId, background = _props.background, showShadow = _props.showShadow;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledYouTubeVideoComponent, {
                    className: "youtube-video-component",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: classnames_default()("video-container", (0,_define_property/* default */.Z)({}, background, background)),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: classnames_default()("content", {
                                "with-shadow": showShadow
                            }),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* default */.Z, _object_spread_props(_object_spread({}, this.props), {
                                videoId: videoId,
                                onReady: this.onReady,
                                opts: this.generateOpts(),
                                onEnd: this.onEnd,
                                onPlay: this.onPlay
                            }))
                        })
                    })
                });
            }
        }
    ]);
    return YouTubeVideoComponent;
}(react.PureComponent);
YouTubeVideoComponent.defaultProps = {
    playing: false,
    volume: null,
    muted: false,
    onReady: function() {},
    onEnd: function() {},
    onPlay: function() {},
    opts: DEFAULT_OPTS
};
/* harmony default export */ var youtube_video_component = ((0,generic_config_context/* withGenericConfig */.P)(YouTubeVideoComponent));


/***/ }),

/***/ 27190:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ withResponsiveHOC; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(52951);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(88029);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 4 modules
var _create_super = __webpack_require__(60460);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
// EXTERNAL MODULE: ./constants/vp-sizes.js
var vp_sizes = __webpack_require__(698);
;// CONCATENATED MODULE: ./components/enhancements/responsive-hoc/responsive-hoc-component.scss.js


var StyledResponsiveComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e19xbm3d0"
})(".desktop-wrapper{display:block;}.mobile-wrapper{display:none;}@media (max-width:", vp_sizes/* MOBILE_QUERY_MAX_WIDTH */.zD, "){.desktop-wrapper{display:none;}.mobile-wrapper{display:block;}}");

;// CONCATENATED MODULE: ./components/enhancements/responsive-hoc/responsive-hoc-component.js




function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}



function withResponsiveHOC(DesktopComponent, MobileComponent) {
    return /*#__PURE__*/ function(PureComponent) {
        "use strict";
        (0,_inherits/* default */.Z)(ResponsiveComponent, PureComponent);
        var _super = (0,_create_super/* default */.Z)(ResponsiveComponent);
        function ResponsiveComponent() {
            (0,_class_call_check/* default */.Z)(this, ResponsiveComponent);
            return _super.apply(this, arguments);
        }
        (0,_create_class/* default */.Z)(ResponsiveComponent, [
            {
                key: "render",
                value: function render() {
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledResponsiveComponent, {
                        className: "responsive-hoc-component",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "desktop-wrapper",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DesktopComponent, _object_spread({}, this.props))
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "mobile-wrapper",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MobileComponent, _object_spread({}, this.props))
                            })
                        ]
                    });
                }
            }
        ]);
        return ResponsiveComponent;
    }(react.PureComponent);
}


/***/ }),

/***/ 32109:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ BaseTemplate; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_assert_this_initialized.mjs
var _assert_this_initialized = __webpack_require__(4111);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(52951);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(88029);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 4 modules
var _create_super = __webpack_require__(60460);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(10092);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./contexts/generic-config-context.js
var generic_config_context = __webpack_require__(3156);
// EXTERNAL MODULE: ./contexts/ab-tests-context.js
var ab_tests_context = __webpack_require__(24492);
// EXTERNAL MODULE: ./client/services/gtm-service/gtm-service.js
var gtm_service = __webpack_require__(60775);
// EXTERNAL MODULE: ./services/community/cloudinary-service.js
var cloudinary_service = __webpack_require__(40927);
// EXTERNAL MODULE: ./constants/links.js + 20 modules
var links = __webpack_require__(27639);
;// CONCATENATED MODULE: ./components/core/head/google-structured-data/google-structured-data.js



var GoogleStructuredData = function() {
    var renderGoogleStructuredData = function() {
        return '\n      {\n        "@context": "http://schema.org",\n        "@type": "Organization",\n        "legalName": "monday.com Ltd",\n        "description": "monday.com Work OS is an open platform where anyone can create the tools they need to run every aspect of their work.",\n        "logo": "'.concat((0,cloudinary_service.generateCloudinaryImageUrl)(links/* MONDAY_SQUARE_LOGO_SRC */.GD), '",\n        "name": "monday.com",\n        "sameAs": [\n          "https://twitter.com/mondaydotcom",\n          "https://www.facebook.com/mondaydotcom/",\n          "https://www.linkedin.com/company/monday.com/",\n          "https://www.youtube.com/channel/UCA9UvBiKHly15rN8u_Km3BQ"\n        ],\n        "url": "https://monday.com"\n      }\n    ');
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
        type: "application/ld+json",
        dangerouslySetInnerHTML: {
            __html: renderGoogleStructuredData()
        }
    });
};
/* harmony default export */ var google_structured_data = (GoogleStructuredData);

// EXTERNAL MODULE: ./constants/localization.js
var localization = __webpack_require__(72632);
;// CONCATENATED MODULE: ./components/core/head/first-fold-images.js

var FirstFoldImages = function(preloadFirstFoldImages) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: preloadFirstFoldImages === null || preloadFirstFoldImages === void 0 ? void 0 : preloadFirstFoldImages.map(function(image, index) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                rel: "preload",
                href: image === null || image === void 0 ? void 0 : image.src,
                as: "image"
            }, "".concat(image === null || image === void 0 ? void 0 : image.src).concat(index));
        })
    });
};
/* harmony default export */ var first_fold_images = (FirstFoldImages);

// EXTERNAL MODULE: ./constants/templates-names.js
var templates_names = __webpack_require__(35015);
;// CONCATENATED MODULE: ./components/core/head/meta-tags.js


var NO_INDEX_STRING = "noindex";
var INDEX_STRING = "index";
var NO_FOLLOW_STRING = "nofollow";
var FOLLOW_STRING = "follow";
var NO_INDEX_LP_TEMPLATES = [
    templates_names.TEMPLATE_NAMES.OnePagerAssetTemplate,
    templates_names.TEMPLATE_NAMES.OnePagerWithImageTemplate,
    templates_names.TEMPLATE_NAMES.MobileOnePagerWithImageTemplate,
    templates_names.TEMPLATE_NAMES.OnePagerWithVideoTemplate,
    templates_names.TEMPLATE_NAMES.CompetitorTemplate
];
var isProduction = "production" === "production";
var getMetaTags = function(param) {
    var template = param.template, noIndex = param.noIndex, noFollow = param.noFollow;
    var shouldNoIndexOrNoFollow = function() {
        if (noIndex || noFollow) return true;
        return NO_INDEX_LP_TEMPLATES.includes(template);
    };
    var getRobotsContentText = function() {
        var indexStr = noIndex ? NO_INDEX_STRING : INDEX_STRING;
        var followStr = noFollow ? NO_FOLLOW_STRING : FOLLOW_STRING;
        return "".concat(indexStr, ", ").concat(followStr);
    };
    return [
        /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
            httpEquiv: "x-ua-compatible",
            content: "ie=edge"
        }),
        /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
            name: "viewport",
            content: "width=device-width, initial-scale=1.0"
        }),
        /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
            name: "theme-color",
            content: "#333333"
        }),
        /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
            name: "msapplication-navbutton-color",
            content: "#333333"
        }),
        /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
            name: "coverage",
            content: "Worldwide"
        }),
        /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
            name: "distribution",
            content: "Global"
        }),
        /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
            name: "rating",
            content: "General"
        }),
        isProduction && /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
            name: "facebook-domain-verification",
            content: "fp63743zc2gqopx7ds8uyh9aplxwa3"
        }),
        shouldNoIndexOrNoFollow() && /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
            name: "robots",
            content: getRobotsContentText()
        }),
        /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
            rel: "sitemap",
            type: "application/xml",
            title: "Sitemap",
            href: "/sitemap.xml"
        }),
        /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
            name: "p:domain_verify",
            content: "b23b9536c7fb460593afc0a4efb90c3f"
        }),
        /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
            name: "google-site-verification",
            content: "_um4GXuRDHUpvGCATPKd3z0pZFISWfjidYVj47c0bhA"
        })
    ];
};

// EXTERNAL MODULE: ./components/core/head/app-icons.js
var app_icons = __webpack_require__(95929);
;// CONCATENATED MODULE: ./components/core/head/social-meta-tags/facebook-meta.js

var MONDAY_BASE_PATH = "https://monday.com";
var getFacebookMetaTags = function(param) {
    var title = param.title, description = param.description, pagePath = param.pagePath, _imagePath = param.imagePath, imagePath = _imagePath === void 0 ? "https://s3.amazonaws.com/general-assets/monday-1200x628.png" : _imagePath, _imageType = param.imageType, imageType = _imageType === void 0 ? "image/png" : _imageType, _imageWidth = param.imageWidth, imageWidth = _imageWidth === void 0 ? "1200" : _imageWidth, _imageHeight = param.imageHeight, imageHeight = _imageHeight === void 0 ? "628" : _imageHeight;
    return [
        /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
            property: "og:title",
            content: title
        }),
        /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
            property: "og:type",
            content: "website"
        }),
        /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
            property: "og:url",
            content: "".concat(MONDAY_BASE_PATH).concat(pagePath)
        }),
        /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
            property: "og:description",
            content: description
        }),
        /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
            property: "og:site_name",
            content: "monday.com"
        }),
        /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
            property: "og:image",
            content: imagePath
        }),
        /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
            property: "og:image:type",
            content: imageType
        }),
        /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
            property: "og:image:width",
            content: imageWidth
        }),
        /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
            property: "og:image:height",
            content: imageHeight
        })
    ];
};

;// CONCATENATED MODULE: ./components/core/head/social-meta-tags/twitter-meta.js

var TWITTER_USER_ID = "912574397076123648";
var getTwitterMetaTags = function(param) {
    var title = param.title, description = param.description, _imagePath = param.imagePath, imagePath = _imagePath === void 0 ? "https://s3.amazonaws.com/general-assets/monday-800x418.png" : _imagePath;
    return [
        /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
            name: "twitter:card",
            content: "summary"
        }),
        /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
            name: "twitter:site",
            content: "@mondaydotcom"
        }),
        /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
            name: "twitter:title",
            content: title
        }),
        /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
            name: "twitter:description",
            content: description
        }),
        /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
            name: "twitter:image",
            content: imagePath
        }),
        /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
            property: "twitter:account_id",
            content: TWITTER_USER_ID
        })
    ];
};

// EXTERNAL MODULE: ./components/core/head/fonts-component.js
var fonts_component = __webpack_require__(11094);
// EXTERNAL MODULE: ./constants/marketing-keys.js
var marketing_keys = __webpack_require__(70890);
;// CONCATENATED MODULE: ./components/core/google-tag-manager/google-tag-manager-component.js


var GoogleTagManagerComponent = function(param) {
    var _loadBodyScript = param.loadBodyScript, loadBodyScript = _loadBodyScript === void 0 ? false : _loadBodyScript, _gtmId = param.gtmId, gtmId = _gtmId === void 0 ? marketing_keys/* GOOGLE_TAG_MANAGER_HOMEPAGE_CONTAINER */.g : _gtmId;
    var getHeaderScript = function() {
        return "(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':\n    new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],\n    j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.defer=true;j.src=\n    'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);\n    })(window,document,'script','dataLayer','".concat(gtmId, "');");
    };
    var getBodyNoScript = function() {
        return '<iframe src="https://www.googletagmanager.com/ns.html?id='.concat(gtmId, '"\n    height="0" width="0" style="display:none;visibility:hidden"></iframe>');
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            !loadBodyScript && /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                dangerouslySetInnerHTML: {
                    __html: getHeaderScript()
                }
            }),
            loadBodyScript && /*#__PURE__*/ (0,jsx_runtime.jsx)("noscript", {
                dangerouslySetInnerHTML: {
                    __html: getBodyNoScript()
                }
            })
        ]
    });
};
/* harmony default export */ var google_tag_manager_component = (GoogleTagManagerComponent);

// EXTERNAL MODULE: ./constants/cookies.js
var cookies = __webpack_require__(13019);
// EXTERNAL MODULE: ./services/monday-platform/existing-accounts-service.js
var existing_accounts_service = __webpack_require__(14124);
;// CONCATENATED MODULE: ./utils/inline-scripts.js


var cookieValueByNameInlineScript = "\n		const cookieValueByName = cookieName => {\n			if (!cookieName) return null;\n			var b = document.cookie.match('(^|;)\\\\s*' + cookieName + '\\\\s*=\\\\s*([^;]+)');\n			return b ? b.pop() : null;\n		}\n";
var setCookieInlineScript = '\n		const setCookie = (name, value, exdays) => {\n				const d = new Date();\n				d.setTime(d.getTime() + (exdays*24*60*60*1000));\n				var expires = "expires="+ d.toUTCString();\n				document.cookie = name + "=" + value + ";" + expires + ";domain='.concat(cookies.COOKIES_DOMAIN, ';path=/";\n		}\n');
var shouldRecordFromDrawInlineScript = "\n		const shouldRecordFromDraw = (recordEveryNth) => {\n		if (!recordEveryNth) return false;\n			return Math.ceil(Math.random() * recordEveryNth) === recordEveryNth;\n		}\n";
var bigBrainTrackEventInlineScript = '\n		const trackBigbrainEvent = (eventName, eventParams={}) => {\n		if (window.BigBrain) {\n			window.BigBrain("track", eventName, eventParams);\n			}\n		}\n';
var getSlugDataInlineScript = "\n		".concat(cookieValueByNameInlineScript, '\n		const onlyNewFirstUserSlug = (date) => {\n			try {\n				let slugsFromCookie = cookieValueByName("').concat(existing_accounts_service/* SLUG_DETAILS_COOKIE_NAME */.tV, '");\n				let slugs = [];\n				if (slugsFromCookie) {\n					slugsFromCookie = decodeURIComponent(slugsFromCookie);\n					slugs = JSON.parse(slugsFromCookie);\n				}\n				const newSlugs = slugs.filter((slug) => slug.ac && new Date(slug.ac) >= date && slug.us === 1);\n				return slugs.length > 0 && newSlugs.length === slugs.length;\n			}\n			catch {\n				return false\n			}\n		}\n');

;// CONCATENATED MODULE: ./components/core/head/redirect-to-platform-script/redirect-to-platform-script.js




var platformDomain = "monday.com";
var RedirectToPlatfromScript = function(param) {
    var persistantCookies = param.persistantCookies;
    var redirectToPlatformPricingIfNotPayingAccount = function() {
        if ((0,existing_accounts_service/* isExistingNonPayingAccount */.LM)(persistantCookies)) {
            // else we're not redirecting and not overriding appUrl
            return '\n          const platformPricingUrl = "//"+lastActiveSlug + ".'.concat(platformDomain, '/pricing_page";\n          window.location.replace(platformPricingUrl);\n      ');
        }
        return " // do nothing - not in redirect variant ";
    };
    var redirectToPlatformIfNeeded = function() {
        return "\n        ".concat(getSlugDataInlineScript, "\n        const lastActiveSlug = cookieValueByName('").concat(cookies.LAST_ACCOUNT_SLUG, "');  // cookieValueByName defined inside getSlugDataInlineScript\n \n        const preventRedirect = window.location.search.indexOf('no-redirect') > 0;\n\n        if(lastActiveSlug && !preventRedirect) {\n          var appUrl = \"//\"+lastActiveSlug + \".").concat(platformDomain, '";\n          var path = window.location.pathname.trim();;\n\n          const isPricingPage = path.includes("pricing");\n          if (isPricingPage) {\n            ').concat(redirectToPlatformPricingIfNotPayingAccount(), "\n          }\n          else {\n            window.location.replace(appUrl);\n          }\n        }\n    ");
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
        dangerouslySetInnerHTML: {
            __html: redirectToPlatformIfNeeded()
        }
    });
};
/* harmony default export */ var redirect_to_platform_script = (RedirectToPlatfromScript);

// EXTERNAL MODULE: ./utils/url.js
var utils_url = __webpack_require__(8339);
// EXTERNAL MODULE: ./constants/platform-links.js
var platform_links = __webpack_require__(16119);
;// CONCATENATED MODULE: ./constants/prefetch-constants.js
var prefetch_constants_PREFETCH_TYPES = {
    DNS_PREFETCH: "dns-prefetch",
    PREFETCH: "prefetch",
    PRECONNECT: "preconnect"
};
var prefetch_constants_isProduction = "production" === "production";
var PLATFORM_STAGING_CDN_URL = "https://multicdn.mondaystaging.com";
var PLATFORM_PROD_CDN_URL = "https://cdn.monday.com";
var PLATFORM_CDN_URL = (/* unused pure expression or super */ null && (prefetch_constants_isProduction ? PLATFORM_PROD_CDN_URL : PLATFORM_STAGING_CDN_URL));
var PLATFORM_DOMAIN = prefetch_constants_isProduction ? "monday.com" : "mondaystaging.com";
var PLATFORM_BUNDLES_ENDPOINT = "https://auth.".concat(PLATFORM_DOMAIN, "/layout/get_bundles_data");
var PLATFORM_BUNDLES_ASSETS_TO_FETCH = (/* unused pure expression or super */ null && ([
    "soft_signup",
    "signup",
    "main",
    "components",
    "vendors",
    "externals"
]));

// EXTERNAL MODULE: ./services/environment-service.js
var environment_service = __webpack_require__(56274);
// EXTERNAL MODULE: ./node_modules/@mondaydotcomorg/trident-skeleton/dist/Skeleton/index.js + 36 modules
var Skeleton = __webpack_require__(96842);
;// CONCATENATED MODULE: ./client/services/signup/prefetch-signup-service.js


function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}







var SIGNUP_CLOUDINARY_ASSETS_DIRECTORY = "https://dapulse-res.cloudinary.com/image/upload/monday_platform/signup";
var SIGNUP_BACKGROUND_IMAGE_SRC = "".concat(SIGNUP_CLOUDINARY_ASSETS_DIRECTORY, "/signup-background.png");
var SIGNUP_LOADER_IMAGE_SRC = "".concat(SIGNUP_CLOUDINARY_ASSETS_DIRECTORY, "/loader_transparent_new.gif");
var SET_UP_YOUR_ACCOUNT_RIGHT_SIDE_ASSET = "".concat(SIGNUP_CLOUDINARY_ASSETS_DIRECTORY, "/signup-right-side-assets/set-up-your-account-right-side-asset.png");
var COMPANY_AND_TEAM_SIZE_RIGHT_SIDE_ASSET = "".concat(SIGNUP_CLOUDINARY_ASSETS_DIRECTORY, "/signup-right-side-assets/company-and-team-size-right-side-asset.png");
var HOW_WOULD_YOU_LIKE_TO_USE_MONDAY_RIGHT_SIDE_ASSET = "".concat(SIGNUP_CLOUDINARY_ASSETS_DIRECTORY, "/signup-right-side-assets/how-would-you-like-to-use-monday-right-side-asset.png");
var WHAT_BRINGS_YOU_HERE_RIGHT_SIDE_ASSET = "".concat(SIGNUP_CLOUDINARY_ASSETS_DIRECTORY, "/signup-right-side-assets/what-brings-you-here-right-side-asset.png");
var STATIC_ASSETS_HREFS = [
    SIGNUP_BACKGROUND_IMAGE_SRC,
    SIGNUP_LOADER_IMAGE_SRC,
    SET_UP_YOUR_ACCOUNT_RIGHT_SIDE_ASSET,
    COMPANY_AND_TEAM_SIZE_RIGHT_SIDE_ASSET,
    HOW_WOULD_YOU_LIKE_TO_USE_MONDAY_RIGHT_SIDE_ASSET,
    WHAT_BRINGS_YOU_HERE_RIGHT_SIDE_ASSET
];
var PREFETCHED_DOMAINS = [
    (0,platform_links/* getPlatformLinkByEnvironment */.k)(links/* MONDAY_AUTH_DOMAIN */.NyZ)
];
var PRECONNECT_DOMAINS = PREFETCHED_DOMAINS;
var PrefetchedSignupAssetsContext = /*#__PURE__*/ (0,react.createContext)("PrefetchedSignupAssets");
var HOST_NAME = "homepage";
var SIGNUP_MF_NAME = "mf-platform-signup";
var PrefetchSignupAssetsProvider = function(props) {
    var children = props.children, signupDynamicAssetsLinks = props.signupDynamicAssetsLinks;
    var ref = (0,react.useState)([]), prefetchedSignupAssetsLinks = ref[0], setPrefetchedSignupAssetsLinks = ref[1];
    (0,react.useEffect)(function() {
        if (environment_service.isDevelopment) return;
        try {
            var skeleton = new Skeleton/* default */.Z({
                api: {},
                isDev: environment_service.isDevelopment,
                mfUrl: links/* MICRO_FRONTENDS_DOMAIN */.vM1,
                host: {
                    name: HOST_NAME,
                    environment: environment_service.env
                },
                isAssetsFlattened: true,
                shouldUseMfAssetsEndpoint: true,
                useMfAssetsFallback: true
            });
            skeleton.preFetchMF(SIGNUP_MF_NAME);
        } catch (e) {
        // just to keep it safe and quiet
        }
    }, []);
    (0,react.useEffect)(function() {
        var setData = function() {
            var _ref = _async_to_generator(function() {
                var // dynamic assets
                _signupAssetsLinks, signupAssetsLinks;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    signupAssetsLinks = [];
                    // dns prefetches
                    PREFETCHED_DOMAINS.forEach(function(href) {
                        signupAssetsLinks.push({
                            type: prefetch_constants_PREFETCH_TYPES.DNS_PREFETCH,
                            href: href
                        });
                    });
                    // pre-connects
                    PRECONNECT_DOMAINS.forEach(function(href) {
                        signupAssetsLinks.push({
                            type: prefetch_constants_PREFETCH_TYPES.PRECONNECT,
                            href: href
                        });
                    });
                    // static assets
                    STATIC_ASSETS_HREFS.forEach(function(href) {
                        signupAssetsLinks.push({
                            type: prefetch_constants_PREFETCH_TYPES.PREFETCH,
                            href: href
                        });
                    });
                    (_signupAssetsLinks = signupAssetsLinks).push.apply(_signupAssetsLinks, (0,_to_consumable_array/* default */.Z)(signupDynamicAssetsLinks));
                    setPrefetchedSignupAssetsLinks(signupAssetsLinks);
                    return [
                        2
                    ];
                });
            });
            return function setData() {
                return _ref.apply(this, arguments);
            };
        }();
        setData();
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(PrefetchedSignupAssetsContext.Provider, {
        value: prefetchedSignupAssetsLinks,
        children: children
    });
};
var usePrefetchedSignupAssets = function() {
    var prefetchedSignupAssetsLinks = (0,react.useContext)(PrefetchedSignupAssetsContext) || [];
    return prefetchedSignupAssetsLinks;
};

// EXTERNAL MODULE: ./node_modules/@sentry/core/esm/exports.js
var esm_exports = __webpack_require__(64487);
// EXTERNAL MODULE: ./constants/bigbrain-event-types.js
var bigbrain_event_types = __webpack_require__(65023);
// EXTERNAL MODULE: ./services/bigbrain-service.js
var bigbrain_service = __webpack_require__(65488);
;// CONCATENATED MODULE: ./components/core/head/signup-prefetched-assets-links-component.js
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}






var SignupPrefetchedAssetsLinksComponent = function() {
    var allPrefetchedSignupAssets = usePrefetchedSignupAssets();
    var numberOfLinksSuccessfullyPrefetched = 0;
    var dnsPrefetchedDomains = allPrefetchedSignupAssets.filter(function(asset) {
        return asset.type === prefetch_constants_PREFETCH_TYPES.DNS_PREFETCH;
    });
    var preConnectedDomains = allPrefetchedSignupAssets.filter(function(asset) {
        return asset.type === prefetch_constants_PREFETCH_TYPES.PRECONNECT;
    });
    var prefetchedSignupAssets = allPrefetchedSignupAssets.filter(function(asset) {
        return asset.type === prefetch_constants_PREFETCH_TYPES.PREFETCH;
    });
    var totalNumberOfAssetsToBePrefetched = prefetchedSignupAssets === null || prefetchedSignupAssets === void 0 ? void 0 : prefetchedSignupAssets.length;
    var PREFETCHED_LINK_ID = function(index) {
        return "prefetched_link_".concat(index);
    };
    var onLinkRendered = function(param) {
        var href = param.href, index = param.index;
        try {
            // setTimeout needed to ensure it's not run synchronously, and link elements were already rendered in the DOM
            setTimeout(function() {
                var linkElement = document.querySelector("link[id=".concat(PREFETCHED_LINK_ID(index), "]"));
                if (linkElement) {
                    linkElement.onload = function() {
                        (0,bigbrain_service.trackEvent)(bigbrain_event_types.PREFETCH_ASSET_COMPLETED, {
                            kind: href,
                            info1: index,
                            info2: numberOfLinksSuccessfullyPrefetched++,
                            info3: totalNumberOfAssetsToBePrefetched
                        });
                        if (numberOfLinksSuccessfullyPrefetched === totalNumberOfAssetsToBePrefetched) {
                            (0,bigbrain_service.trackEvent)(bigbrain_event_types.PREFETCH_ALL_ASSETS_COMPLETED, {
                                info3: totalNumberOfAssetsToBePrefetched
                            });
                        }
                    };
                    linkElement.onerror = function() {
                        esm_exports/* captureMessage */.uT("Prefetch of the following asset failed: ".concat(href));
                    };
                } else {
                    esm_exports/* captureMessage */.uT("Couldn't query link with id: ".concat(PREFETCHED_LINK_ID(index), " and href: ").concat(href));
                }
            });
        } catch (e) {
            esm_exports/* captureException */.Tb(e);
        }
    };
    return [
        dnsPrefetchedDomains === null || dnsPrefetchedDomains === void 0 ? void 0 : dnsPrefetchedDomains.map(function(prefetchedDomain, index) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                rel: prefetchedDomain.type,
                href: prefetchedDomain.href
            }, index);
        }),
        preConnectedDomains === null || preConnectedDomains === void 0 ? void 0 : preConnectedDomains.map(function(preConnectedDomain, index) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                rel: preConnectedDomain.type,
                href: preConnectedDomain.href
            }, index);
        }),
        prefetchedSignupAssets === null || prefetchedSignupAssets === void 0 ? void 0 : prefetchedSignupAssets.map(function(prefetchedAsset, index) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                id: PREFETCHED_LINK_ID(index),
                rel: prefetchedAsset.type,
                href: prefetchedAsset.href,
                onLoad: onLinkRendered(_object_spread_props(_object_spread({}, prefetchedAsset), {
                    index: index
                }))
            }, index);
        })
    ];
};
/* harmony default export */ var signup_prefetched_assets_links_component = (SignupPrefetchedAssetsLinksComponent);

;// CONCATENATED MODULE: ./components/core/head/faq-seo/faq-seo.js


var buildSeoFAQ = function(param) {
    var seoFAQ = param.seoFAQ, translate = param.translate;
    var res = null;
    try {
        var fixString = function(str) {
            return str.replace(/"/g, "'");
        };
        var renderFaqSeo = function() {
            return '\n{\n  "@context": "https://schema.org",\n  "@type": "FAQPage",\n  "mainEntity": ['.concat(seoFAQ.map(function(param) {
                var answer = param.answer, question = param.question;
                return '\n    {\n      "@type": "Question",\n      "name": "'.concat(fixString(translate(question)), '",\n      "acceptedAnswer": {\n        "@type": "Answer",\n        "text": "').concat(fixString(translate(answer)), '"\n      }\n    }');
            }), "]\n}\n      ");
        };
        if (seoFAQ) {
            res = /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                type: "application/ld+json",
                dangerouslySetInnerHTML: {
                    __html: renderFaqSeo()
                }
            });
        }
    } catch (error) {
        esm_exports/* captureException */.Tb(error);
        esm_exports/* captureMessage */.uT("Failed to inject FAQ data to header");
    }
    return res;
};
/* harmony default export */ var faq_seo = (buildSeoFAQ);

// EXTERNAL MODULE: ./constants/typeform-contact-sales.js
var typeform_contact_sales = __webpack_require__(13979);
// EXTERNAL MODULE: ./services/ab-tests/acquisition-ab-test-service.js
var acquisition_ab_test_service = __webpack_require__(77784);
;// CONCATENATED MODULE: ./client/services/typeform/prefetch-typeform-service.js

function prefetch_typeform_service_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function prefetch_typeform_service_async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                prefetch_typeform_service_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                prefetch_typeform_service_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}





var TYPEFORM_FONT_CSS_FILE = "https://font.typeform.com/dist/google/roboto/index.css";
var TYPEFORM_ROBOTO_400_FONT = "https://font.typeform.com/dist/google/roboto/files/roboto-latin-400-normal.woff2";
var TYPEFORM_ROBOTO_700_FONT = "https://font.typeform.com/dist/google/roboto/files/roboto-latin-700-normal.woff2";
var MONDAY_LOGO = "https://images.typeform.com/images/2GR8rmBChTYm";
var prefetch_typeform_service_STATIC_ASSETS_HREFS = [
    TYPEFORM_FONT_CSS_FILE,
    TYPEFORM_ROBOTO_400_FONT,
    TYPEFORM_ROBOTO_700_FONT,
    MONDAY_LOGO
];
var prefetch_typeform_service_PREFETCHED_DOMAINS = [
    "https://form.typeform.com"
];
var prefetch_typeform_service_PRECONNECT_DOMAINS = prefetch_typeform_service_PREFETCHED_DOMAINS;
var PrefetchedTypeformAssetsContext = /*#__PURE__*/ (0,react.createContext)("PrefetchedTypeformAssets");
var PrefetchTypeformAssetsProvider = function(props) {
    var children = props.children, cloudfrontViewerCountry = props.cloudfrontViewerCountry, useNewTypeformUSVariant = props.useNewTypeformUSVariant, abTests = props.abTests;
    var ref = (0,react.useState)([]), prefetchedTypeformAssetsLinks = ref[0], setPrefetchedTypeformAssetsLinks = ref[1];
    var getNewVariantForTest = useNewTypeformUSVariant || (0,acquisition_ab_test_service.shouldUseNewTypeformVariant)(abTests);
    (0,react.useEffect)(function() {
        var setData = function() {
            var _ref = prefetch_typeform_service_async_to_generator(function() {
                var typeformAssetsLinks, dynamicAssets;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    typeformAssetsLinks = [];
                    // dns prefetches
                    prefetch_typeform_service_PREFETCHED_DOMAINS.forEach(function(href) {
                        typeformAssetsLinks.push({
                            type: prefetch_constants_PREFETCH_TYPES.DNS_PREFETCH,
                            href: href
                        });
                    });
                    // pre-connects
                    prefetch_typeform_service_PRECONNECT_DOMAINS.forEach(function(href) {
                        typeformAssetsLinks.push({
                            type: prefetch_constants_PREFETCH_TYPES.PRECONNECT,
                            href: href
                        });
                    });
                    // static assets
                    prefetch_typeform_service_STATIC_ASSETS_HREFS.forEach(function(href) {
                        typeformAssetsLinks.push({
                            type: prefetch_constants_PREFETCH_TYPES.PREFETCH,
                            href: href
                        });
                    });
                    dynamicAssets = (0,typeform_contact_sales/* getTypeformImagesPrefetchByCountry */.Ks)(cloudfrontViewerCountry, getNewVariantForTest);
                    dynamicAssets && dynamicAssets.forEach(function(href) {
                        typeformAssetsLinks.push({
                            type: prefetch_constants_PREFETCH_TYPES.PREFETCH,
                            href: href
                        });
                    });
                    setPrefetchedTypeformAssetsLinks(typeformAssetsLinks);
                    return [
                        2
                    ];
                });
            });
            return function setData() {
                return _ref.apply(this, arguments);
            };
        }();
        setData();
    }, [
        cloudfrontViewerCountry
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(PrefetchedTypeformAssetsContext.Provider, {
        value: prefetchedTypeformAssetsLinks,
        children: children
    });
};
var prefetch_typeform_service_usePrefetchedTypeformAssets = function() {
    var prefetchedTypeformAssetsLinks = useContext(PrefetchedTypeformAssetsContext);
    return prefetchedTypeformAssetsLinks;
};

;// CONCATENATED MODULE: ./components/core/head/typeform-prefetched-assets-links-component.js



var TypeformPrefetchedAssetsLinksComponent = function() {
    var allPrefetchedAssets = usePrefetchedTypeformAssets();
    var dnsPrefetchedDomains = allPrefetchedAssets && allPrefetchedAssets.filter(function(asset) {
        return asset.type === PREFETCH_TYPES.DNS_PREFETCH;
    });
    var preConnectedDomains = allPrefetchedAssets && (allPrefetchedAssets === null || allPrefetchedAssets === void 0 ? void 0 : allPrefetchedAssets.filter(function(asset) {
        return asset.type === PREFETCH_TYPES.PRECONNECT;
    }));
    var prefetchedAssets = allPrefetchedAssets && (allPrefetchedAssets === null || allPrefetchedAssets === void 0 ? void 0 : allPrefetchedAssets.filter(function(asset) {
        return asset.type === PREFETCH_TYPES.PREFETCH;
    }));
    var PREFETCHED_LINK_ID = function(index) {
        return "typeform_prefetched_link_".concat(index);
    };
    return [
        dnsPrefetchedDomains === null || dnsPrefetchedDomains === void 0 ? void 0 : dnsPrefetchedDomains.map(function(prefetchedDomain, index) {
            return /*#__PURE__*/ _jsx("link", {
                rel: prefetchedDomain.type,
                href: prefetchedDomain.href
            }, index);
        }),
        preConnectedDomains === null || preConnectedDomains === void 0 ? void 0 : preConnectedDomains.map(function(preConnectedDomain) {
            return /*#__PURE__*/ _jsx("link", {
                rel: preConnectedDomain.type,
                href: preConnectedDomain.href
            });
        }),
        prefetchedAssets === null || prefetchedAssets === void 0 ? void 0 : prefetchedAssets.map(function(prefetchedAsset, index) {
            return /*#__PURE__*/ _jsx("link", {
                id: PREFETCHED_LINK_ID(index),
                rel: prefetchedAsset.type,
                href: prefetchedAsset.href
            });
        })
    ];
};
/* harmony default export */ var typeform_prefetched_assets_links_component = ((/* unused pure expression or super */ null && (TypeformPrefetchedAssetsLinksComponent)));

;// CONCATENATED MODULE: ./client/services/live-board/prefetch-liveboard-service.js

function prefetch_liveboard_service_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function prefetch_liveboard_service_async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                prefetch_liveboard_service_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                prefetch_liveboard_service_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}



var prefetch_liveboard_service_PREFETCHED_DOMAINS = [
    "https://views.monday.com"
];
var prefetch_liveboard_service_PRECONNECT_DOMAINS = prefetch_liveboard_service_PREFETCHED_DOMAINS;
var PrefetchedLiveBoardAssetsContext = /*#__PURE__*/ (0,react.createContext)("PrefetchedLiveBoardAssets");
var PrefetchLiveBoardAssetsProvider = function(props) {
    var children = props.children;
    var ref = (0,react.useState)([]), prefetchedLiveBoardAssetsLinks = ref[0], setPrefetchedLiveBoardAssetsLinks = ref[1];
    (0,react.useEffect)(function() {
        var setData = function() {
            var _ref = prefetch_liveboard_service_async_to_generator(function() {
                var LiveBoardAssetsLinks;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    LiveBoardAssetsLinks = [];
                    // dns prefetches
                    prefetch_liveboard_service_PREFETCHED_DOMAINS.forEach(function(href) {
                        LiveBoardAssetsLinks.push({
                            type: prefetch_constants_PREFETCH_TYPES.DNS_PREFETCH,
                            href: href
                        });
                    });
                    // pre-connects
                    prefetch_liveboard_service_PRECONNECT_DOMAINS.forEach(function(href) {
                        LiveBoardAssetsLinks.push({
                            type: prefetch_constants_PREFETCH_TYPES.PRECONNECT,
                            href: href
                        });
                    });
                    setPrefetchedLiveBoardAssetsLinks(LiveBoardAssetsLinks);
                    return [
                        2
                    ];
                });
            });
            return function setData() {
                return _ref.apply(this, arguments);
            };
        }();
        setData();
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(PrefetchedLiveBoardAssetsContext.Provider, {
        value: prefetchedLiveBoardAssetsLinks,
        children: children
    });
};
var usePrefetchedLiveBoardAssets = function() {
    var prefetchedLiveBoardAssetsLinks = (0,react.useContext)(PrefetchedLiveBoardAssetsContext);
    return prefetchedLiveBoardAssetsLinks;
};

;// CONCATENATED MODULE: ./components/core/head/liveboard-prefetched-assets-links-component.js



var LiveBoardPrefetchedAssetsLinksComponent = function() {
    var allPrefetchedLiveBoardAssets = usePrefetchedLiveBoardAssets();
    var dnsPrefetchedDomains = allPrefetchedLiveBoardAssets.filter(function(asset) {
        return asset.type === prefetch_constants_PREFETCH_TYPES.DNS_PREFETCH;
    });
    var preConnectedDomains = allPrefetchedLiveBoardAssets.filter(function(asset) {
        return asset.type === prefetch_constants_PREFETCH_TYPES.PRECONNECT;
    });
    return [
        dnsPrefetchedDomains === null || dnsPrefetchedDomains === void 0 ? void 0 : dnsPrefetchedDomains.map(function(prefetchedDomain, index) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                rel: prefetchedDomain.type,
                href: prefetchedDomain.href
            }, index);
        }),
        preConnectedDomains === null || preConnectedDomains === void 0 ? void 0 : preConnectedDomains.map(function(preConnectedDomain, index) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                rel: preConnectedDomain.type,
                href: preConnectedDomain.href
            }, index);
        })
    ];
};
/* harmony default export */ var liveboard_prefetched_assets_links_component = (LiveBoardPrefetchedAssetsLinksComponent);

;// CONCATENATED MODULE: ./components/core/head/preconnect-links-component.js


var preconnect_links_component_PRECONNECT_DOMAINS = [
    "https://dapulse-res.cloudinary.com"
];
// we add all preconnect domains to dns-prefetch as a fallback.
var DNS_PREFETCH_DOMAINS = (0,_to_consumable_array/* default */.Z)(preconnect_links_component_PRECONNECT_DOMAINS);
var PreconnectLinksComponent = function() {
    return [
        preconnect_links_component_PRECONNECT_DOMAINS.map(function(link, index) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                rel: "preconnect",
                href: link
            }, index);
        }),
        DNS_PREFETCH_DOMAINS.map(function(link, index) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                rel: "dns-prefetch",
                href: link
            }, index);
        })
    ];
};
/* harmony default export */ var preconnect_links_component = (PreconnectLinksComponent);

;// CONCATENATED MODULE: ./components/core/head/index.js

function head_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function head_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            head_define_property(target, key, source[key]);
        });
    }
    return target;
}























var DEFAULT_TITLE_KEY = "website.meta.title.default";
var DEFAULT_DESCRIPTION_KEY = "website.meta.description.default";
var head_isProduction = "production" === "production";
var HPHead = function(props) {
    var clusterId = props.clusterId, hasFreeTier = props.hasFreeTier, cloudfrontViewerCountry = props.cloudfrontViewerCountry, disableGTM = props.disableGTM, description = props.description, template = props.template, localeId = props.localeId, noIndex = props.noIndex, noFollow = props.noFollow, gtmContainerId = props.gtmContainerId, isMobileOrTabletBrowser = props.isMobileOrTabletBrowser, pagePath = props.pagePath, facebookMetaOverride = props.facebookMetaOverride, twitterMetaOverride = props.twitterMetaOverride, translate = props.translate, localizedPages = props.localizedPages, abTests = props.abTests, translateWithParam = props.translateWithParam, title = props.title, canonicalUrl = props.canonicalUrl, shouldGetSignupPrefetchedAssets = props.shouldGetSignupPrefetchedAssets, seoFAQ = props.seoFAQ, shouldGetTypeformPrefetchedAssets = props.shouldGetTypeformPrefetchedAssets, persistantCookies = props.persistantCookies, preloadFirstFoldImages = props.preloadFirstFoldImages, addLiveBoardExperience = props.addLiveBoardExperience;
    var shouldAddGTM = head_isProduction && !disableGTM;
    (0,react.useEffect)(function() {
        if (shouldAddGTM) {
            (0,gtm_service/* addGTMVariablesToWindow */.jJ)({
                localeId: localeId,
                clusterId: clusterId,
                hasFreeTier: hasFreeTier
            });
            (0,gtm_service/* updateDataLayerVariables */.LC)({
                country: cloudfrontViewerCountry
            });
        }
    }, []);
    var getCanonicalUrl = function() {
        return (0,utils_url.normalizeUrlForCanonical)(canonicalUrl || pagePath);
    };
    var getTitle = function() {
        if (typeof title === "object" && title.key && title.param) {
            return translateWithParam(title.key, title.param);
        }
        return translate(title);
    };
    var isHomepageOrPricingPage = function() {
        try {
            if (!pagePath) return false;
            var relevantNormalizedRoutes = [
                links/* ROOT_LINK */.yjY
            ].concat((0,_to_consumable_array/* default */.Z)((0,localization.getHomepageLocalizedRoutes)()), (0,_to_consumable_array/* default */.Z)(localization.LOCALIZED_PRICING_ROUTES));
            var normalizedPath = (0,utils_url.normalizeUrl)((0,utils_url.truncateQueryParams)(pagePath));
            return relevantNormalizedRoutes.includes(normalizedPath);
        } catch (e) {
            // TODO: talk with Barak - sentry is a pretty big import
            return false;
        }
    };
    var translatedTitle = getTitle();
    var translatedDescription = translate(description);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
            children: [
                !isMobileOrTabletBrowser && isHomepageOrPricingPage() && redirect_to_platform_script({
                    abTests: abTests,
                    persistantCookies: persistantCookies
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                    children: translatedTitle
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                    name: "description",
                    content: translatedDescription
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                    rel: "canonical",
                    href: getCanonicalUrl()
                }),
                (0,fonts_component/* default */.Z)(),
                getMetaTags({
                    template: template,
                    localeId: localeId,
                    noIndex: noIndex,
                    noFollow: noFollow
                }),
                (0,app_icons/* getAppIconsLinks */.J)(),
                getFacebookMetaTags(head_object_spread({
                    title: translatedTitle,
                    description: translatedDescription,
                    pagePath: pagePath
                }, facebookMetaOverride)),
                faq_seo({
                    seoFAQ: seoFAQ,
                    translate: translate
                }),
                getTwitterMetaTags(head_object_spread({
                    title: translatedTitle,
                    description: translatedDescription
                }, twitterMetaOverride)),
                google_structured_data(),
                shouldAddGTM && google_tag_manager_component({
                    gtmId: gtmContainerId
                }),
                localizedPages && localizedPages.map(function(tp, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "alternate",
                        hrefLang: tp.locale,
                        href: tp.path
                    }, index);
                }),
                shouldGetSignupPrefetchedAssets && signup_prefetched_assets_links_component(),
                addLiveBoardExperience && liveboard_prefetched_assets_links_component(),
                (preloadFirstFoldImages === null || preloadFirstFoldImages === void 0 ? void 0 : preloadFirstFoldImages.length) && first_fold_images(preloadFirstFoldImages),
                preconnect_links_component()
            ]
        })
    });
};
HPHead.defaultProps = {
    title: DEFAULT_TITLE_KEY,
    description: DEFAULT_DESCRIPTION_KEY,
    canonicalUrl: "",
    withIntercom: false,
    fontLazyLoad: false,
    disableGTM: false,
    facebookMetaOverride: {},
    twitterMetaOverride: {},
    localizedPages: []
};
/* harmony default export */ var core_head = ((0,ab_tests_context/* withAbTests */.k)((0,generic_config_context/* withGenericConfig */.P)(HPHead)));

// EXTERNAL MODULE: ./services/cookies-service.js
var cookies_service = __webpack_require__(67798);
;// CONCATENATED MODULE: ./services/cookies/coupon-cookies-service.js


var saveCouponCookie = function() {
    var coupon = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    coupon.code && (0,cookies_service/* setCookie */.d8)(cookies.COUPON_CODE, coupon.code, {
        expires: parseInt(coupon.daysToExpire) || cookies.COUPON_DAYS_EXPIRE_DEFAULT
    });
};

// EXTERNAL MODULE: ./services/clusters-service.js + 1 modules
var clusters_service = __webpack_require__(25866);
;// CONCATENATED MODULE: ./services/locales-service.js




var setLocaleIdAndTrackEventIfNeeded = function(localeId, reason, options) {
    (0,cookies_service/* setCookie */.d8)(cookies.LOCALE_COOKIE, localeId, {
        expires: cookies.COOKIE_EXPIRY_DAYS_FOR_LOCALIZATION
    });
    (0,bigbrain_service.setUtmLocaleId)(localeId);
    if (options.sendBigBrainEvent) {
        (0,bigbrain_service.trackEvent)(bigbrain_event_types.SET_LOCALE_ID_EVENT_NAME, {
            kind: localeId,
            info1: reason,
            info2: window.location.href
        });
    }
};
var setLocaleIdIfNeeded = function(configLocaleId) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    if (configLocaleId) {
        setLocaleIdAndTrackEventIfNeeded(configLocaleId, "set_locale_from_page_config", options);
    }
};

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var src_define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./services/community/constants-service.js
var constants_service = __webpack_require__(72137);
;// CONCATENATED MODULE: ./services/cookies/marketing-cookies-service.js





var windowLocationIEFix = function() {
    return window.location.protocol + "//" + window.location.hostname + (window.location.port ? ":" + window.location.port : "");
};
var setMarketingCookies = function(marketingCookies) {
    Object.keys(marketingCookies).forEach(function(key) {
        (0,cookies_service/* setCookieIfNeeded */.cr)(key, marketingCookies[key]);
    });
};
var saveMarketingCookies = function() {
    var url = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : window.location;
    try {
        // Parse URI, get query string hash
        var queryString = (0,utils_url.getQueryStringAsHash)(url);
        // IE doesn't have location.origin
        if (!window.location.origin) {
            window.location.origin = windowLocationIEFix();
        }
        var _obj;
        // Extract martketing parameters from url
        var marketingCookies = (_obj = {}, (0,src_define_property/* default */.Z)(_obj, cookies.M_CAMPAIGN, queryString.marketing_campaign || queryString.utm_campaign), (0,src_define_property/* default */.Z)(_obj, cookies.M_CAMPAIGN_ID, queryString.marketing_campaign_id || queryString.utm_campaign_id), (0,src_define_property/* default */.Z)(_obj, cookies.M_SOURCE, queryString.marketing_source || queryString.utm_source), (0,src_define_property/* default */.Z)(_obj, cookies.M_BANNER, queryString.marketing_banner || queryString.utm_banner), (0,src_define_property/* default */.Z)(_obj, cookies.M_MEDIUM, queryString.marketing_medium || queryString.utm_medium), (0,src_define_property/* default */.Z)(_obj, cookies.M_CONTENT, queryString.marketing_content || queryString.utm_content), (0,src_define_property/* default */.Z)(_obj, cookies.M_RETARGETING, queryString.marketing_retargeting || queryString.utm_retargeting), (0,src_define_property/* default */.Z)(_obj, cookies.M_REFERRER, queryString.utm_referrer || document.referrer), (0,src_define_property/* default */.Z)(_obj, cookies.M_VERTICAL, queryString.marketing_vertical || ""), (0,src_define_property/* default */.Z)(_obj, cookies.M_LANDING_PAGE, window.location.origin + window.location.pathname), (0,src_define_property/* default */.Z)(_obj, cookies.M_GIFT_SEND, queryString.gift_send), (0,src_define_property/* default */.Z)(_obj, cookies.M_AW_GRP, queryString.aw_grp), (0,src_define_property/* default */.Z)(_obj, cookies.M_AW_KW, queryString.aw_kw), (0,src_define_property/* default */.Z)(_obj, cookies.M_AW_AD, queryString.aw_ad), (0,src_define_property/* default */.Z)(_obj, constants_service.UserCampaignType.STORIES_CAMPAIGN, queryString.stories_campaign), (0,src_define_property/* default */.Z)(_obj, constants_service.UserCampaignType.STORIES_SOURCE, queryString.stories_source), (0,src_define_property/* default */.Z)(_obj, constants_service.UserCampaignType.STORIES_MEDIUM, queryString.stories_medium), (0,src_define_property/* default */.Z)(_obj, constants_service.UserCampaignType.STORIES_CONTENT, queryString.stories_content), (0,src_define_property/* default */.Z)(_obj, constants_service.UserCampaignType.STORIES_CAMPAIGN_DATE, queryString.stories_campaign_date), (0,src_define_property/* default */.Z)(_obj, constants_service.UserCampaignType.STORIES_SLUG, queryString.stories_slug), (0,src_define_property/* default */.Z)(_obj, constants_service.TemplateTypeCookie.STORIES_TEMPLATE_TYPE, queryString[constants_service.TemplateTypeCookie.STORIES_TEMPLATE_TYPE]), (0,src_define_property/* default */.Z)(_obj, constants_service.StoriesCookies.MONDAY_USER_ID, queryString[constants_service.StoriesCookies.MONDAY_USER_ID]), _obj);
        // Save marketing parameters into the cookie
        setMarketingCookies(marketingCookies);
    } catch (e) {
        console.log(e);
    }
};
var saveMarketingTemplateBoardIdsCookie = function(marketingTemplateBoardIds) {
    marketingTemplateBoardIds && (0,cookies_service/* setCookie */.d8)(cookies.MARKETING_TEMPLATE_BOARD_IDS, marketingTemplateBoardIds);
};

// EXTERNAL MODULE: ./node_modules/lodash/defer.js
var defer = __webpack_require__(81629);
var defer_default = /*#__PURE__*/__webpack_require__.n(defer);
// EXTERNAL MODULE: ./services/utils-service.js
var utils_service = __webpack_require__(20618);
;// CONCATENATED MODULE: ./services/performance/resources-load-tracking.js


function resources_load_tracking_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function resources_load_tracking_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            resources_load_tracking_define_property(target, key, source[key]);
        });
    }
    return target;
}

var RESOURCES_PATTERN_TO_TRACK = [
    "globe_top_people.png",
    "use.typekit.net",
    "dynamic-template-page.js"
]; //	checking if a string is part of the resource url
var ERROR_KINDS = {
    PERFORMANCE_OBSERVER: "performance_observer",
    GET_ENTRIES_BY_TYPE: "get_entries_by_type"
};
var ResourcesLoadTracking = /*#__PURE__*/ function() {
    "use strict";
    function ResourcesLoadTracking(pageLoadUniqueId) {
        (0,_class_call_check/* default */.Z)(this, ResourcesLoadTracking);
        this.pageLoadUniqueId = pageLoadUniqueId;
    }
    (0,_create_class/* default */.Z)(ResourcesLoadTracking, [
        {
            key: "shouldTrackResource",
            value: function shouldTrackResource(url) {
                return RESOURCES_PATTERN_TO_TRACK.some(function(resource) {
                    return url.includes(resource);
                });
            }
        },
        {
            key: "handleResources",
            value: function handleResources(resources) {
                var _this = this;
                resources.forEach(function(resource) {
                    var name = resource.name, responseEnd = resource.responseEnd, responseStart = resource.responseStart, requestStart = resource.requestStart, fetchStart = resource.fetchStart, startTime = resource.startTime, transferSize = resource.transferSize;
                    if (_this.shouldTrackResource(name)) {
                        var rawResourceData = resource.toJSON();
                        BigBrain("track", bigbrain_event_types.PAGE_PERFORMANCE_TRACKING_RESOURCES, {
                            placement: _this.pageLoadUniqueId,
                            kind: name,
                            direct_object_id: startTime,
                            info1: responseEnd,
                            info2: fetchStart,
                            info3: requestStart,
                            direct_object: responseStart,
                            board_kind: transferSize,
                            data: resources_load_tracking_object_spread({}, rawResourceData)
                        });
                    }
                });
            }
        },
        {
            key: "trackLoadedResources",
            value: function trackLoadedResources() {
                try {
                    var resources = window.performance.getEntriesByType("resource"); //	until now
                    this.handleResources(resources);
                } catch (error) {
                    this.trackError(ERROR_KINDS.GET_ENTRIES_BY_TYPE, error.message);
                }
            }
        },
        {
            key: "trackFutureResources",
            value: function trackFutureResources() {
                var _this = this;
                if (!window.PerformanceObserver) {
                    //	e.g.: not supported in IE
                    this.trackError(ERROR_KINDS.PERFORMANCE_OBSERVER, "not supported");
                    return;
                }
                try {
                    var observer = new PerformanceObserver(function(resources, observer) {
                        var resourceEntries = resources.getEntries();
                        _this.handleResources(resourceEntries);
                    });
                    observer.observe({
                        entryTypes: [
                            "resource"
                        ]
                    });
                } catch (error) {
                    this.trackError(ERROR_KINDS.PERFORMANCE_OBSERVER, error.message);
                }
            }
        },
        {
            key: "trackError",
            value: function trackError(kind, message) {
                BigBrain("track", bigbrain_event_types.PAGE_PERFORMANCE_TRACKING_RESOURCES_ERROR, {
                    placement: this.pageLoadUniqueId,
                    data: {
                        error: message
                    },
                    kind: kind
                });
            }
        },
        {
            key: "track",
            value: function track() {
                this.trackLoadedResources();
                this.trackFutureResources();
            }
        }
    ]);
    return ResourcesLoadTracking;
}();
//	*Important notes*:
//	some browsers may be blocked, so mind values are bigger than 0
//	some resources comes from cache (0 duration and transferSize, but mind it's not 100% working so probably should clean outliers)
//	mind some resources are loaded on page load (e.g. bundles, fonts, favicon) but some after being called through other scripts
//	times relative to page load


;// CONCATENATED MODULE: ./services/performance/page-load-tracking.js


function page_load_tracking_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function page_load_tracking_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            page_load_tracking_define_property(target, key, source[key]);
        });
    }
    return target;
}
function page_load_tracking_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function page_load_tracking_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        page_load_tracking_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}

var PageLoadTracking = /*#__PURE__*/ function() {
    "use strict";
    function PageLoadTracking(pageLoadUniqueId) {
        (0,_class_call_check/* default */.Z)(this, PageLoadTracking);
        this.pageLoadUniqueId = pageLoadUniqueId;
    }
    (0,_create_class/* default */.Z)(PageLoadTracking, [
        {
            key: "getPaintsData",
            value: function getPaintsData() {
                var paints = window.performance.getEntriesByType("paint");
                var paintsData = {};
                if (!paints) return paintsData;
                paints.map(function(paint) {
                    var name = paint.name, startTime = paint.startTime;
                    paintsData[name] = startTime;
                });
                return paintsData;
            }
        },
        {
            key: "getPerformenceData",
            value: function getPerformenceData(data) {
                var template = data.template, navigationStart = data.navigationStart, firstPaint = data["first-paint"], domInteractive = data.domInteractive, domContentLoadedEventEnd = data.domContentLoadedEventEnd, loadEventStart = data.loadEventStart;
                return {
                    template: template,
                    firstPaint: firstPaint,
                    timeToInteractive: domInteractive - navigationStart,
                    timeToContentLoad: domContentLoadedEventEnd - navigationStart,
                    timeToToalLoad: loadEventStart - navigationStart
                };
            }
        },
        {
            key: "getInfoData",
            value: function getInfoData(performanceData) {
                var template = performanceData.template, firstPaint = performanceData.firstPaint, timeToInteractive = performanceData.timeToInteractive, timeToContentLoad = performanceData.timeToContentLoad, timeToToalLoad = performanceData.timeToToalLoad;
                return {
                    kind: template,
                    info1: firstPaint,
                    info2: timeToInteractive,
                    info3: timeToContentLoad,
                    direct_object_id: timeToToalLoad // time to total load
                };
            }
        },
        {
            key: "setPerformenceOnWindow",
            value: function setPerformenceOnWindow(performenceData) {
                window.mondayPerformence = performenceData;
            }
        },
        {
            key: "track",
            value: function track(template) {
                try {
                    var timing = window.performance.timing.toJSON();
                    var navigation = window.performance.navigation;
                    var memory = window.performance.memory; //	not supported in firefox
                    var paintsData = this.getPaintsData();
                    var data = page_load_tracking_object_spread_props(page_load_tracking_object_spread(page_load_tracking_object_spread_props(page_load_tracking_object_spread({}, timing), {
                        redirectCount: navigation && navigation.redirectCount
                    }), paintsData), {
                        totalJSHeapSize: memory && memory.totalJSHeapSize,
                        template: template
                    });
                    var performanceData = this.getPerformenceData(data);
                    this.setPerformenceOnWindow(performanceData);
                    var infoData = this.getInfoData(performanceData);
                    BigBrain("track", bigbrain_event_types.PAGE_PERFORMANCE_TRACKING_DATA, page_load_tracking_object_spread_props(page_load_tracking_object_spread({
                        data: data
                    }, infoData), {
                        placement: this.pageLoadUniqueId
                    }));
                } catch (error) {
                    BigBrain("track", bigbrain_event_types.PAGE_PERFORMANCE_TRACKING_ERROR, {
                        data: {
                            error: error.message
                        },
                        placement: this.pageLoadUniqueId
                    });
                }
            }
        }
    ]);
    return PageLoadTracking;
}();


;// CONCATENATED MODULE: ./services/page-performance-tracking-events-service.js







var PagePerformanceEventsTracker = /*#__PURE__*/ function() {
    "use strict";
    function PagePerformanceEventsTracker() {
        (0,_class_call_check/* default */.Z)(this, PagePerformanceEventsTracker);
        this.pageLoadUniqueId = (0,utils_service.getRandomInt)(100000000);
        this.pageLoadTracking = new PageLoadTracking(this.pageLoadUniqueId);
        this.resourcesLoadTracking = new ResourcesLoadTracking(this.pageLoadUniqueId);
    }
    (0,_create_class/* default */.Z)(PagePerformanceEventsTracker, [
        {
            key: "track",
            value: function track(template) {
                try {
                    if (!window.performance) {
                        BigBrain("track", bigbrain_event_types.PAGE_PERFORMANCE_TRACKING_NOT_SUPPORTED);
                        return;
                    }
                    this.pageLoadTracking.track(template);
                    this.resourcesLoadTracking.track();
                } catch (error) {
                    BigBrain("track", bigbrain_event_types.PAGE_PERFORMANCE_TRACKING_GENERIC_ERROR, {
                        data: {
                            error: error.message
                        },
                        placement: this.pageLoadUniqueId
                    });
                }
            }
        }
    ]);
    return PagePerformanceEventsTracker;
}();
var trackPagePerformance = function(param) {
    var template = param.template;
    var pagePerformanceEventsTracker = new PagePerformanceEventsTracker();
    defer_default()(function() {
        return pagePerformanceEventsTracker.track(template);
    });
};

// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
var router_default = /*#__PURE__*/__webpack_require__.n(router);
;// CONCATENATED MODULE: ./services/cookies/extended-trial-cookies-service.js


var saveExtendTrialCookie = function() {
    var extendTrialCookie = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    extendTrialCookie.token && (0,cookies_service/* setCookie */.d8)(cookies.EXTEND_TRIAL_COOKIE_KEY, extendTrialCookie.token, {
        expires: parseInt(extendTrialCookie.daysToExpire) || cookies.EXTEND_TRIAL_COOKIE_DAYS_EXPIRE_DEFAULT
    });
};

;// CONCATENATED MODULE: ./services/platform-cookie-sync-service.js



var setSkipQuestionsCookieIfNeeded = function(skipClustersQuestion) {
    if (skipClustersQuestion) {
        (0,cookies_service/* setCookieIfNeeded */.cr)(cookies.SKIP_CLUSTER_QUESTION, "true", {
            expires: 3
        }, bigbrain_event_types.SET_SKIP_QUESTION_COOKIE);
    }
};

;// CONCATENATED MODULE: ./services/dom-observer-service.js

var WHITELISTED_CLASSES_PATTERNS = [
    "ReactModalPortal"
];
var WHITELISTED_IDS_PATTERNS = [
    "monday_tools_extension_id",
    "batBeacon",
    "_hjRemoteVarsFrame"
];
var WHITELISTED_SRC_PATTERNS = [
    "8175736.fls.doubleclick.net",
    "comeet.com"
];
var findPatternMatchInListForAttribute = function(list, attribute) {
    return list.some(function(pattern) {
        return attribute.includes(pattern);
    });
};
var shouldSkipNode = function(node) {
    var id = node.id;
    if (id && findPatternMatchInListForAttribute(WHITELISTED_IDS_PATTERNS, id)) return true;
    var classname = node.className;
    if (classname && findPatternMatchInListForAttribute(WHITELISTED_CLASSES_PATTERNS, classname)) return true;
    var src = node.src;
    if (src && findPatternMatchInListForAttribute(WHITELISTED_SRC_PATTERNS, src)) return true;
};
var initDomObserving = function() {
    // helping tracking changes in the page. Used for analysis of chrome extension iframes
    // paused as we done using it, but keep it in the code as it might be useful in the future for more stuff
    var shouldObserve =  true && false; // always/upon draw for certain %
    if (!shouldObserve) return;
    try {
        if (!window.MutationObserver) {
            BigBrain("track", bigbrain_event_types.DOM_CHANGED_UNAVAILABLE, {
                kind: "not supporting mutation observer"
            });
            return;
        }
        var loadedAt = new Date().getTime();
        var targetNode = document.body;
        var observerConfig = {
            childList: true
        };
        var observer = new MutationObserver(function(mutations) {
            mutations.forEach(function(mutation) {
                mutation.addedNodes && mutation.addedNodes.forEach(function(node) {
                    try {
                        if (shouldSkipNode(node)) return;
                        window.requestAnimationFrame(function() {
                            var boundingClientRect;
                            try {
                                boundingClientRect = node.getBoundingClientRect && node.getBoundingClientRect().toJSON();
                            } catch (e) {}
                            BigBrain("track", bigbrain_event_types.DOM_CHANGED, {
                                placement: node.id,
                                kind: node.className,
                                info1: node.href,
                                info2: node.src,
                                info3: node.type,
                                direct_object_id: new Date().getTime() - loadedAt,
                                direct_object: window.visitGuid,
                                board_kind: node.nodeName,
                                data: boundingClientRect
                            });
                        });
                    } catch (e) {
                        BigBrain("track", bigbrain_event_types.DOM_CHANGE_EVENT_FAILURE, {
                            kind: e.message || "n/a"
                        });
                    }
                });
            });
        });
        observer.observe(targetNode, observerConfig);
    } catch (e) {
        BigBrain("track", bigbrain_event_types.DOM_CHANGED_UNAVAILABLE, {
            kind: e.message || "n/a"
        });
    }
};

// EXTERNAL MODULE: ./services/dom-utils-service.js
var dom_utils_service = __webpack_require__(44566);
;// CONCATENATED MODULE: ./services/page-usage-duration-tracking.js

function page_usage_duration_tracking_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function page_usage_duration_tracking_async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                page_usage_duration_tracking_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                page_usage_duration_tracking_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}



var MAX_SECONDS = 60;
var TIMEOUT = 5 * 1000;
var TRACK_PERCENTAGE = 10;
var track = function(timeSinceStarted, scrollPercent) {
    BigBrain("track", bigbrain_event_types.PAGE_USAGE_DURATION, {
        kind: window.visitGuid,
        info1: timeSinceStarted,
        info2: scrollPercent,
        info3: location.href
    });
};
var iterateTracker = function() {
    var _ref = page_usage_duration_tracking_async_to_generator(function(startedAt) {
        var scrollPercent, secondsSinceStarted;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        (0,dom_utils_service.getScrollPercent)()
                    ];
                case 1:
                    scrollPercent = _state.sent();
                    secondsSinceStarted = Math.floor((new Date().getTime() - startedAt) / 1000);
                    track(secondsSinceStarted, scrollPercent);
                    if (!(MAX_SECONDS > secondsSinceStarted)) return [
                        3,
                        3
                    ];
                    return [
                        4,
                        (0,utils_service.sleep)(TIMEOUT)
                    ];
                case 2:
                    _state.sent();
                    iterateTracker(startedAt);
                    _state.label = 3;
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return function iterateTracker(startedAt) {
        return _ref.apply(this, arguments);
    };
}();
var shouldTrack = function() {
    return TRACK_PERCENTAGE > 100 * Math.random();
};
var initPageUsageDurationTracking = function(startedAt) {
    if (!shouldTrack()) return;
    iterateTracker(startedAt);
};

// EXTERNAL MODULE: ./constants/clusters/types.js
var types = __webpack_require__(10945);
;// CONCATENATED MODULE: ./services/bigbrain-visitor-experiment-sync-service.js




var fireBigbrainVisitorExperimentSyncEvent = function() {
    var experimentId = (0,cookies_service/* getCookie */.ej)(cookies.EXPERIMENT_VISITOR_ID);
    if (experimentId) {
        (0,bigbrain_service.trackEvent)(bigbrain_event_types.WEBSITE_SYNC_VISITOR_AND_AB_TEST_EXPERIMENT_ID, {
            kind: experimentId
        });
    }
};

;// CONCATENATED MODULE: ./services/header-scripts-service.js













var initHeaderScripts = function initHeaderScripts(param) {
    var coupon = param.coupon, extendTrialCookie = param.extendTrialCookie, marketingTemplateBoardIds = param.marketingTemplateBoardIds, clusterId = param.clusterId, subClusterId = param.subClusterId, clusterIdSource = param.clusterIdSource, subClusterIdSource = param.subClusterIdSource, localeId = param.localeId, template = param.template, skipClustersQuestion = param.skipClustersQuestion, enablePageUsageDurationTracking = param.enablePageUsageDurationTracking, isProduction = param.isProduction;
    var startedAt = new Date().getTime();
    saveMarketingCookies();
    saveCouponCookie(coupon);
    saveExtendTrialCookie(extendTrialCookie);
    saveMarketingTemplateBoardIdsCookie(marketingTemplateBoardIds);
    (0,clusters_service/* setClusterIdIfNeeded */.lc)(clusterId, subClusterId, {
        sendBigBrainEvent: true
    });
    (0,clusters_service/* setClusterForUser */.PH)(clusterId, types.CLUSTER_TYPE, clusterIdSource);
    (0,clusters_service/* setClusterForUser */.PH)(subClusterId, types.USE_CASE_TYPE, subClusterIdSource, {
        parent_cluster_id: clusterId
    }); //currently sub-cluster available only when setting also cluster
    setLocaleIdIfNeeded(localeId, {
        sendBigBrainEvent: true
    });
    setSkipQuestionsCookieIfNeeded(skipClustersQuestion);
    fireBigbrainVisitorExperimentSyncEvent();
    initDomObserving();
    if (isProduction && enablePageUsageDurationTracking) {
        initPageUsageDurationTracking(startedAt);
    }
    window.addEventListener("load", function() {
        trackPagePerformance({
            template: template
        });
    });
    (router_default()).onRouteChangeComplete = function(url) {
        trackPageView(url, clusterId, subClusterId);
    }; //Track changes on client routing
};
var trackPageView = function trackPageView(url, clusterId, subClusterId) {
    (0,bigbrain_service.trackBigBrainPageView)(url, clusterId, subClusterId);
};

;// CONCATENATED MODULE: ./components/core/head/polyfills.js






function polyfills_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}


var Polyfills = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(Polyfills, PureComponent);
    var _super = (0,_create_super/* default */.Z)(Polyfills);
    function Polyfills() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        (0,_class_call_check/* default */.Z)(this, Polyfills);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat((0,_to_consumable_array/* default */.Z)(args)));
        polyfills_define_property((0,_assert_this_initialized/* default */.Z)(_this), "renderClosestPolyfill", function() {
            return "\n      if (!Element.prototype.matches) {\n        Element.prototype.matches = Element.prototype.msMatchesSelector || \n                                    Element.prototype.webkitMatchesSelector;\n        }\n        \n      if (!Element.prototype.closest) {\n        Element.prototype.closest = function(s) {\n          var el = this;\n      \n          do {\n            if (el.matches(s)) return el;\n            el = el.parentElement || el.parentNode;\n          } while (el !== null && el.nodeType === 1);\n          return null;\n        };\n      }";
        });
        return _this;
    }
    (0,_create_class/* default */.Z)(Polyfills, [
        {
            //to add a new polyfill just add a new script tag inside the fragment
            key: "render",
            value: function render() {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                        dangerouslySetInnerHTML: {
                            __html: this.renderClosestPolyfill()
                        }
                    })
                });
            }
        }
    ]);
    return Polyfills;
}(react.PureComponent);


;// CONCATENATED MODULE: ./components/core/head/use-resource-performance-tracking.js

var useResourcePerformanceTracking = function(resourceName, onLoadComplete) {
    var ref = (0,react.useState)(null), resource = ref[0], setResource = ref[1];
    var observer = (0,react.useRef)(null);
    (0,react.useEffect)(function() {
        var _window;
        if (!((_window = window) === null || _window === void 0 ? void 0 : _window.PerformanceObserver)) {
            return;
        }
        observer.current = new PerformanceObserver(function(list) {
            var entry = list.getEntries().find(function(performanceEntry) {
                return performanceEntry.name.includes(resourceName);
            });
            if (entry) {
                onLoadComplete && onLoadComplete(entry.duration, entry.startTime, entry.transferSize);
                setResource(entry);
            }
        });
        observer.current.observe({
            type: "resource",
            buffered: true
        });
        return function() {
            observer.current.disconnect();
        };
    }, [
        onLoadComplete,
        resourceName
    ]);
    (0,react.useEffect)(function() {
        resource && observer.current.disconnect();
    }, [
        resource
    ]);
};
/* harmony default export */ var use_resource_performance_tracking = (useResourcePerformanceTracking);

;// CONCATENATED MODULE: ./components/core/head/dynamic-template-page-script-performance-tracker.js




var BUNDLE_SCRIPT_PREFIX = "dynamic-template-page";
var DynamicTemplatePageScriptPerformanceTracker = function() {
    var onLoadComplete = (0,react.useCallback)(function(loadingDurationTime, startTime, size) {
        (0,bigbrain_service.trackEvent)(bigbrain_event_types.PAGE_PERFORMANCE_TRACKING_RESOURCES, {
            kind: "".concat(BUNDLE_SCRIPT_PREFIX, " monitor"),
            info1: loadingDurationTime,
            info2: startTime,
            info3: size
        });
    }, []);
    use_resource_performance_tracking(BUNDLE_SCRIPT_PREFIX, onLoadComplete);
    return null;
};
/* harmony default export */ var dynamic_template_page_script_performance_tracker = (DynamicTemplatePageScriptPerformanceTracker);

// EXTERNAL MODULE: ./constants/localstorage.js
var localstorage = __webpack_require__(50663);
// EXTERNAL MODULE: ./utils/general.js
var general = __webpack_require__(56093);
;// CONCATENATED MODULE: ./components/core/head/landing-page-tracker.js



var LandingPageTracker = function() {
    (0,react.useEffect)(function() {
        if ((0,general/* isServerSide */.s$)()) {
            return;
        }
        var landingPage = window.location.pathname;
        // don't store landing page if it exists already
        if (localStorage.getItem(localstorage.LANDING_PAGE)) return;
        localStorage.setItem(localstorage.LANDING_PAGE, JSON.stringify({
            value: landingPage,
            timestamp: Date.now()
        }));
    }, []);
    return null;
};
/* harmony default export */ var landing_page_tracker = (LandingPageTracker);

// EXTERNAL MODULE: ./constants/data-layer-event-types.js
var data_layer_event_types = __webpack_require__(34496);
var data_layer_event_types_default = /*#__PURE__*/__webpack_require__.n(data_layer_event_types);
// EXTERNAL MODULE: ./services/ab-tests/lp-ab-tests-service.js
var lp_ab_tests_service = __webpack_require__(36233);
// EXTERNAL MODULE: ./components/core/head/bigbrain-script.js + 1 modules
var bigbrain_script = __webpack_require__(36403);
;// CONCATENATED MODULE: ./components/core/head/header-scripts-component.js
















var header_scripts_component_isProduction = "production" === "production";
var HeaderScriptsComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(HeaderScriptsComponent, PureComponent);
    var _super = (0,_create_super/* default */.Z)(HeaderScriptsComponent);
    function HeaderScriptsComponent(props) {
        (0,_class_call_check/* default */.Z)(this, HeaderScriptsComponent);
        var _this;
        _this = _super.call(this, props);
        var abTests = props.abTests, abTestExactEventName = props.abTestExactEventName;
        _this.exactPageAbTest = _this.getGenericAbTest(abTests, abTestExactEventName);
        return _this;
    }
    (0,_create_class/* default */.Z)(HeaderScriptsComponent, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                var _props = this.props, coupon = _props.coupon, extendTrialCookie = _props.extendTrialCookie, marketingTemplateBoardIds = _props.marketingTemplateBoardIds, clusterId = _props.clusterId, subClusterId = _props.subClusterId, clusterIdSource = _props.clusterIdSource, pageProductId = _props.pageProductId, subClusterIdSource = _props.subClusterIdSource, localeId = _props.localeId, template = _props.template, skipClustersQuestion = _props.skipClustersQuestion, enablePageUsageDurationTracking = _props.enablePageUsageDurationTracking, customHeadScript = _props.customHeadScript;
                (0,gtm_service/* fireGtmEvent */.k2)((data_layer_event_types_default()).META_DATA, {
                    page_type: pageProductId
                });
                initHeaderScripts({
                    isProduction: header_scripts_component_isProduction,
                    coupon: coupon,
                    marketingTemplateBoardIds: marketingTemplateBoardIds,
                    clusterId: clusterId,
                    subClusterId: subClusterId,
                    localeId: localeId,
                    extendTrialCookie: extendTrialCookie,
                    template: template,
                    skipClustersQuestion: skipClustersQuestion,
                    enablePageUsageDurationTracking: enablePageUsageDurationTracking,
                    clusterIdSource: clusterIdSource,
                    subClusterIdSource: subClusterIdSource
                });
            }
        },
        {
            key: "getGenericAbTest",
            value: function getGenericAbTest(abTests, abTestExactEventName) {
                var abTestVariant = (0,lp_ab_tests_service.getExactEventNameAbTestVariant)(abTestExactEventName, abTests);
                return abTestExactEventName && abTestVariant && {
                    name: abTestExactEventName,
                    variant: abTestVariant
                };
            }
        },
        {
            key: "render",
            value: function render() {
                var _props = this.props, pageType = _props.pageType, template = _props.template, clusterId = _props.clusterId, subClusterId = _props.subClusterId, customHeadScript = _props.customHeadScript, segmentsList = _props.segmentsList, pageProductId = _props.pageProductId;
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(bigbrain_script/* default */.Z, {
                            isProduction: header_scripts_component_isProduction,
                            pageType: pageType,
                            template: template,
                            clusterId: clusterId,
                            subClusterId: subClusterId,
                            segmentsList: segmentsList,
                            pageProductId: pageProductId,
                            exactPageAbTest: this.exactPageAbTest
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dynamic_template_page_script_performance_tracker, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(landing_page_tracker, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Polyfills, {}),
                        customHeadScript && /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                            dangerouslySetInnerHTML: {
                                __html: customHeadScript
                            }
                        })
                    ]
                });
            }
        }
    ]);
    return HeaderScriptsComponent;
}(react.PureComponent);
/* harmony default export */ var header_scripts_component = ((0,ab_tests_context/* withAbTests */.k)((0,generic_config_context/* withGenericConfig */.P)(HeaderScriptsComponent)));

;// CONCATENATED MODULE: ./components/core/head/fullstory-scripts/fullstory-script.js




function fullstory_script_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function fullstory_script_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            fullstory_script_define_property(target, key, source[key]);
        });
    }
    return target;
}








var FULLSTORY_RECORDING_FOR_VISITOR = "fullstory_recording_for_visitor";
var ALWAYS_RECORD_COOKIE_EXPIRY_DAYS = 3;
var DEFAULT_RAND_RECORD = 100;
var FullstoryScript = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(FullstoryScript, PureComponent);
    var _super = (0,_create_super/* default */.Z)(FullstoryScript);
    function FullstoryScript() {
        (0,_class_call_check/* default */.Z)(this, FullstoryScript);
        return _super.apply(this, arguments);
    }
    (0,_create_class/* default */.Z)(FullstoryScript, [
        {
            key: "getFullstoryBaseCode",
            value: function getFullstoryBaseCode() {
                return "\n        window['_fs_host'] = 'fullstory.com';\n        window['_fs_script'] = 'edge.fullstory.com/s/fs.js';\n        window['_fs_org'] = 'WSWD';\n        window['_fs_namespace'] = 'FS';\n        (function(m,n,e,t,l,o,g,y){\n            if (e in m) {if(m.console && m.console.log) { m.console.log('FullStory namespace conflict. Please set window[\"_fs_namespace\"].');} return;}\n            g=m[e]=function(a,b,s){g.q?g.q.push([a,b,s]):g._api(a,b,s);};g.q=[];\n            o=n.createElement(t);o.async=1;o.crossOrigin='anonymous';o.src='https://'+_fs_script;\n            y=n.getElementsByTagName(t)[0];y.parentNode.insertBefore(o,y);\n            g.identify=function(i,v,s){g(l,{uid:i},s);if(v)g(l,v,s)};g.setUserVars=function(v,s){g(l,v,s)};g.event=function(i,v,s){g('event',{n:i,p:v},s)};\n            g.anonymize=function(){g.identify(!!0)};\n            g.shutdown=function(){g(\"rec\",!1)};g.restart=function(){g(\"rec\",!0)};\n            g.log = function(a,b){g(\"log\",[a,b])};\n            g.consent=function(a){g(\"consent\",!arguments.length||a)};\n            g.identifyAccount=function(i,v){o='account';v=v||{};v.acctId=i;g(o,v)};\n            g.clearUserCookie=function(){};\n            g.setVars=function(n, p){g('setVars',[n,p]);};\n            g._w={};y='XMLHttpRequest';g._w[y]=m[y];y='fetch';g._w[y]=m[y];\n            if(m[y])m[y]=function(){return g._w[y].apply(this,arguments)};\n            g._v=\"1.3.0\";\n        })(window,document,window['_fs_namespace'],'script','user');";
            }
        },
        {
            // Do not add dynamic attributes - runtime variables (cookies, dynamic ab test, etc...)
            // Only use params that we are cache upon
            key: "prepareAbTestParams",
            value: function prepareAbTestParams() {
                var abTests = this.props.abTests;
                var abTestsParams = {};
                abTests.forEach(function(abTest) {
                    return abTestsParams["homepage_ab_test_".concat(abTest.name, "_str")] = abTest.variant;
                });
                return abTestsParams;
            }
        },
        {
            // If you need to send dynamic attributes use FS.event when needed
            key: "createAdditionalAttributes",
            value: function createAdditionalAttributes() {
                var _props = this.props, abTestExactEventName = _props.abTestExactEventName, clusterId = _props.clusterId, subClusterId = _props.subClusterId, hasFreeTier = _props.hasFreeTier, localeId = _props.localeId, abTests = _props.abTests;
                var abTestVariant = (0,lp_ab_tests_service.getExactEventNameAbTestVariant)(abTestExactEventName, abTests);
                var abTestsParams = this.prepareAbTestParams();
                return fullstory_script_object_spread({
                    lp_ab_test_str: abTestVariant,
                    clusterId_str: clusterId,
                    subClusterId_str: subClusterId,
                    hasFreeTier_bool: hasFreeTier,
                    localeId_str: localeId || localization.ENGLISH_LOCALE_ID
                }, abTestsParams);
            }
        },
        {
            key: "onError",
            value: function onError(error) {
                esm_exports/* captureException */.Tb(error);
                esm_exports/* captureMessage */.uT("Error occur on FS script");
            }
        },
        {
            key: "fullstoryScriptGenerator",
            value: function fullstoryScriptGenerator() {
                var _props = this.props, fullstoryRecordingFrequency = _props.fullstoryRecordingFrequency, clusterId = _props.clusterId;
                var attributes = this.createAdditionalAttributes();
                var recordEveryNth = fullstoryRecordingFrequency ? parseInt(fullstoryRecordingFrequency) : DEFAULT_RAND_RECORD;
                return "\n    	try {\n				if (!window.fs_appended) {\n					window.fs_appended = true;\n\n					".concat(cookieValueByNameInlineScript, "\n					").concat(setCookieInlineScript, "\n					").concat(shouldRecordFromDrawInlineScript, "\n\n					const shouldAlwaysRecord = cookieValueByName('").concat(cookies.ALWAYS_FS, "');\n\n					if (shouldAlwaysRecord || shouldRecordFromDraw(").concat(recordEveryNth, ")) {\n					// localstorage for testing on production\n\n						if (!shouldAlwaysRecord) {\n							//	no need to set twice\n							setCookie('").concat(cookies.ALWAYS_FS, "', true, ").concat(ALWAYS_RECORD_COOKIE_EXPIRY_DAYS, ");\n						}\n\n						").concat(this.getFullstoryBaseCode(), "\n\n						visitorId = cookieValueByName('").concat(cookies.BIG_BRAIN_VISITOR_ID, '\');\n						FS.setUserVars({"visitorId": visitorId});\n						FS.setUserVars(').concat(JSON.stringify(attributes), ');\n            window.FSSessionStartedAt = Date.now();\n						window.BigBrain("track","').concat(FULLSTORY_RECORDING_FOR_VISITOR, '", { kind: "').concat(clusterId || "", '", info1: "').concat(recordEveryNth, "\", data: '").concat(JSON.stringify(attributes), "' });\n					}\n        }\n			}\n			catch(e) {\n			}\n    ");
            }
        },
        {
            key: "render",
            value: function render() {
                var script = this.fullstoryScriptGenerator();
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                    async: true,
                    defer: true,
                    dangerouslySetInnerHTML: {
                        __html: script
                    }
                });
            }
        }
    ]);
    return FullstoryScript;
}(react.PureComponent);
/* harmony default export */ var fullstory_script = ((0,ab_tests_context/* withAbTests */.k)(FullstoryScript));

;// CONCATENATED MODULE: ./components/core/head/seo-scripts/trustpilot-script.js






var TrustpilotScript = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(TrustpilotScript, PureComponent);
    var _super = (0,_create_super/* default */.Z)(TrustpilotScript);
    function TrustpilotScript() {
        (0,_class_call_check/* default */.Z)(this, TrustpilotScript);
        return _super.apply(this, arguments);
    }
    (0,_create_class/* default */.Z)(TrustpilotScript, [
        {
            key: "render",
            value: function render() {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                    type: "text/javascript",
                    src: "//widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js",
                    async: true,
                    defer: true
                });
            }
        }
    ]);
    return TrustpilotScript;
}(react.PureComponent);


;// CONCATENATED MODULE: ./components/core/head/intercom-scripts/intercom-script.js






var INTERCOM_APP_ID = "pqqwlkj5";
var IntercomScript = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(IntercomScript, PureComponent);
    var _super = (0,_create_super/* default */.Z)(IntercomScript);
    function IntercomScript() {
        (0,_class_call_check/* default */.Z)(this, IntercomScript);
        return _super.apply(this, arguments);
    }
    (0,_create_class/* default */.Z)(IntercomScript, [
        {
            key: "intercomSettingsScriptGenerator",
            value: function intercomSettingsScriptGenerator(userData, isProduction) {
                var appId = INTERCOM_APP_ID;
                var userId = userData.userId, name = userData.name, email = userData.email, additionalData = userData.additionalData;
                var additionalDataStr = additionalData ? JSON.stringify(additionalData) : "{}";
                if (userId) {
                    // Logged in users
                    return "\n        window['intercomSettings'] = Object.assign({}, {\n          app_id: \"".concat(appId, '",\n          user_id: "').concat(userId, '",\n          name: "').concat(name, '", // Full name\n          email: "').concat(email, '" // Email address          \n        }, ').concat(additionalDataStr, ");\n        \n      ");
                } else {
                    return "\n        window['intercomSettings'] = {\n          app_id: \"".concat(appId, '"\n        };\n      ');
                }
            }
        },
        {
            key: "intercomScriptGenerator",
            value: function intercomScriptGenerator() {
                return "\n      (function(){var w=window;var ic=w.Intercom;if(typeof ic===\"function\"){ic('reattach_activator');ic('update',intercomSettings);}else{var d=document;var i=function(){i.c(arguments)};i.q=[];i.c=function(args){i.q.push(args)};w.Intercom=i;function l(){var s=d.createElement('script');s.type='text/javascript';s.async=true;s.src='https://widget.intercom.io/widget/pqqwlkj5';var x=d.getElementsByTagName('script')[0];x.parentNode.insertBefore(s,x);}if(w.attachEvent){w.attachEvent('onload',l);}else{w.addEventListener('load',l,false);}}})()\n    ";
            }
        },
        {
            key: "render",
            value: function render() {
                var _props = this.props, userData = _props.userData, isProduction = _props.isProduction;
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                            async: true,
                            defer: true,
                            dangerouslySetInnerHTML: {
                                __html: this.intercomSettingsScriptGenerator(userData, isProduction)
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                            async: true,
                            defer: true,
                            dangerouslySetInnerHTML: {
                                __html: this.intercomScriptGenerator()
                            }
                        })
                    ]
                });
            }
        }
    ]);
    return IntercomScript;
}(react.PureComponent);


// EXTERNAL MODULE: ./services/new-ab-tests/new-ab-tests-service.js
var new_ab_tests_service = __webpack_require__(41871);
;// CONCATENATED MODULE: ./services/body-scripts-service.js

var initBodyScripts = function initBodyScripts(param) {
    var abTests = param.abTests;
    (0,new_ab_tests_service.fireEventsOnServerRedirectTests)(abTests);
};

// EXTERNAL MODULE: ./client/services/hotjar-service/hotjar-service.js
var hotjar_service = __webpack_require__(96339);
;// CONCATENATED MODULE: ./components/core/head/hotjar-script.js








var HotjarScript = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(HotjarScript, PureComponent);
    var _super = (0,_create_super/* default */.Z)(HotjarScript);
    function HotjarScript() {
        (0,_class_call_check/* default */.Z)(this, HotjarScript);
        return _super.apply(this, arguments);
    }
    (0,_create_class/* default */.Z)(HotjarScript, [
        {
            key: "startHotjarSessionByVariant",
            value: function startHotjarSessionByVariant(abTestVariant) {
                return (0,hotjar_service/* fireHotjarEventScript */.jB)(abTestVariant);
            }
        },
        {
            key: "renderHotjarScript",
            value: function renderHotjarScript() {
                return "\n        (function(h,o,t,j,a,r){\n          h.hj=h.hj||function(){(h.hj.q=h.hj.q||[]).push(arguments)};\n          h._hjSettings={hjid:1566695,hjsv:6};\n          a=o.getElementsByTagName('head')[0];\n          r=o.createElement('script');r.async=1;\n          r.src=t+h._hjSettings.hjid+j+h._hjSettings.hjsv;\n          a.appendChild(r);\n    })(window,document,'https://static.hotjar.com/c/hotjar-','.js?sv=');\n  ";
            }
        },
        {
            key: "render",
            value: function render() {
                var _props = this.props, abTests = _props.abTests, abTestExactEventName = _props.abTestExactEventName;
                var abTestVariant = (0,lp_ab_tests_service.getExactEventNameAbTestVariant)(abTestExactEventName, abTests);
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                            dangerouslySetInnerHTML: {
                                __html: this.renderHotjarScript()
                            }
                        }),
                        abTestVariant && /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                            async: true,
                            dangerouslySetInnerHTML: {
                                __html: this.startHotjarSessionByVariant(abTestVariant)
                            }
                        })
                    ]
                });
            }
        }
    ]);
    return HotjarScript;
}(react.PureComponent);


// EXTERNAL MODULE: ./services/countries/countries-service.js
var countries_service = __webpack_require__(85010);
;// CONCATENATED MODULE: ./components/core/body-scripts/body-scripts-component.js















var body_scripts_component_isProduction = "production" === "production";
var HotjarWithAbTests = (0,ab_tests_context/* withAbTests */.k)(HotjarScript);
var BodyScriptsComponent = function(props) {
    var abTests = props.abTests, withFullstory = props.withFullstory, fullstoryRecordingFrequency = props.fullstoryRecordingFrequency, showTrustpilotReviews = props.showTrustpilotReviews, withIntercom = props.withIntercom, disableGTM = props.disableGTM, gtmContainerId = props.gtmContainerId, enableHotjar = props.enableHotjar, hotjarFinalDate = props.hotjarFinalDate, clusterId = props.clusterId, hasFreeTier = props.hasFreeTier, localeId = props.localeId, subClusterId = props.subClusterId, loggedInUser = props.loggedInUser, cloudfrontViewerCountry = props.cloudfrontViewerCountry, is404Page = props.is404Page, customBodyScript = props.customBodyScript;
    (0,react.useEffect)(function() {
        initBodyScripts({
            abTests: abTests
        });
    }, [
        abTests
    ]);
    var isCountrySupportedForChatbot = (0,react.useCallback)(function() {
        if (cloudfrontViewerCountry === countries_service.ISRAEL_ISO2 || cloudfrontViewerCountry === countries_service.UNITED_STATES_ISO2 || cloudfrontViewerCountry === countries_service.CANADA_ISO2) return true;
        return (0,countries_service.getCountriesByContinent)(countries_service.EUROPE).includes(cloudfrontViewerCountry);
    }, [
        cloudfrontViewerCountry
    ]);
    (0,react.useEffect)(function() {
        if (is404Page) {
            var _window_location, _window, _document;
            var href = (_window = window) === null || _window === void 0 ? void 0 : (_window_location = _window.location) === null || _window_location === void 0 ? void 0 : _window_location.href;
            var referrer = (_document = document) === null || _document === void 0 ? void 0 : _document.referrer;
            (0,bigbrain_service.trackEvent)(bigbrain_event_types.RETRIEVED_404_ERROR, {
                kind: href,
                info1: referrer
            });
        }
    }, [
        is404Page
    ]);
    var loggedInUserToUse = loggedInUser || {};
    var shouldAddHotjarScript = function() {
        return enableHotjar && (0,hotjar_service/* currentSmallerThanFinalDate */.FZ)(hotjarFinalDate);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: body_scripts_component_isProduction && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                !disableGTM && // This MUST be rendered in the body so componentDidMount will run
                /*#__PURE__*/ (0,jsx_runtime.jsx)(google_tag_manager_component, {
                    loadBodyScript: true,
                    gtmId: gtmContainerId
                }),
                withFullstory && /*#__PURE__*/ (0,jsx_runtime.jsx)(fullstory_script, {
                    clusterId: clusterId,
                    subClusterId: subClusterId,
                    fullstoryRecordingFrequency: fullstoryRecordingFrequency,
                    hasFreeTier: hasFreeTier,
                    localeId: localeId
                }),
                showTrustpilotReviews && /*#__PURE__*/ (0,jsx_runtime.jsx)(TrustpilotScript, {}),
                withIntercom && /*#__PURE__*/ (0,jsx_runtime.jsx)(IntercomScript, {
                    userData: {
                        userId: loggedInUserToUse.mondayUserId || loggedInUserToUse.id,
                        name: loggedInUserToUse.name,
                        email: loggedInUserToUse.email,
                        additionalData: loggedInUserToUse.intercomData
                    },
                    isProduction: body_scripts_component_isProduction
                }),
                shouldAddHotjarScript() && /*#__PURE__*/ (0,jsx_runtime.jsx)(HotjarWithAbTests, {}),
                customBodyScript && /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                    dangerouslySetInnerHTML: {
                        __html: customBodyScript
                    }
                })
            ]
        })
    });
};
/* harmony default export */ var body_scripts_component = ((0,generic_config_context/* withGenericConfig */.P)((0,ab_tests_context/* withAbTests */.k)((0,router.withRouter)(BodyScriptsComponent))));
BodyScriptsComponent.defaultProps = {
    withFullstory: false,
    showTrustpilotReviews: false,
    withIntercom: false,
    fontLazyLoad: false,
    disableGTM: false
};

// EXTERNAL MODULE: ./node_modules/lodash.throttle/index.js
var lodash_throttle = __webpack_require__(93096);
var lodash_throttle_default = /*#__PURE__*/__webpack_require__.n(lodash_throttle);
;// CONCATENATED MODULE: ./services/cookies/cloudfront-viewer-country-cookies-service.js


var saveCloudfrontViewerCountryCookie = function(cloudfrontViewerCountry) {
    cloudfrontViewerCountry && (0,cookies_service/* setCookie */.d8)(cookies.CLOUDFRONT_VIEWER_COUNTRY_COOKIE_NAME, cloudfrontViewerCountry);
};

// EXTERNAL MODULE: ./constants/element-ids.js
var element_ids = __webpack_require__(53219);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
;// CONCATENATED MODULE: ./components/accessibility/bypass-blocks-menu/bypass-block-menu.scss.js

var StyledBypassBlocksMenuComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("nav", {
    target: "e1o6bwvc0"
})(".menu-item{position:fixed;top:0;left:0;opacity:0;pointer-events:none;&:focus{opacity:1;pointer-events:auto;}}");

;// CONCATENATED MODULE: ./components/accessibility/bypass-blocks-menu/bypass-block-menu.js





var BypassBlocksMenuComponent = function(props) {
    var ref = (0,react.useState)(false), hasFooter = ref[0], setHasFooter = ref[1];
    (0,react.useEffect)(function() {
        var footer = document.querySelector(element_ids/* FOOTER_ID */.D);
        setHasFooter(!!footer);
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledBypassBlocksMenuComponent, {
        className: "bypass-block-menu-component",
        "aria-label": "Accessibility Menu",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                href: "#".concat(element_ids/* MAIN_ID */.k),
                className: "menu-item",
                children: props.translate("accessibility.blocksMenu.skipToMain")
            }),
            hasFooter && /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                href: "#".concat(element_ids/* FOOTER_ID */.D),
                className: "menu-item",
                children: props.translate("accessibility.blocksMenu.skipToFooter")
            })
        ]
    });
};
/* harmony default export */ var bypass_block_menu = ((0,generic_config_context/* withGenericConfig */.P)(BypassBlocksMenuComponent));

// EXTERNAL MODULE: ./constants/pricing-versions.js
var pricing_versions = __webpack_require__(78803);
var pricing_versions_default = /*#__PURE__*/__webpack_require__.n(pricing_versions);
// EXTERNAL MODULE: ./utils/react.js
var utils_react = __webpack_require__(12783);
// EXTERNAL MODULE: ./constants/z-index.js
var z_index = __webpack_require__(35257);
;// CONCATENATED MODULE: ./components/templates/base-template.scss.js


var StyledContactSalesStickyButtonWrapper = /*#__PURE__*/ (/* unused pure expression or super */ null && (styled("div", {
    target: "e1jq9k1o0"
})("position:fixed;top:80vh;right:0;width:230px;z-index:", ALWAYS_ON_TOP, ";")));
var StyledTemplateContentWrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1jq9k1o1"
})("position:relative;z-index:", z_index/* BASE_TEMPLATE_ROOT */.jP, ";&.with-background-color{background-color:white;}");
var StyledAccessibilityWrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1jq9k1o2"
})("position:relative;z-index:", z_index/* BASE_TEMPLATE_ROOT */.jP + 1, ";");

// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/react-modal/lib/index.js
var lib = __webpack_require__(83253);
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);
;// CONCATENATED MODULE: ./components/core/live-board-experience/live-board-modal.scss.js


var StylesLiveBoardPopupModal = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1b8yo6x0"
})(".live-board-modal{position:fixed;height:100vh;width:100vw;background-color:rgba(0,0,0,0.7);}.live-board-modal-overlay{position:fixed;top:100vh;opacity:0;z-index:", z_index/* ZERO */.xE, ";transition:opacity 1s;&.fullscreen-board{top:0;opacity:1;z-index:", z_index/* ALWAYS_ON_TOP */.OL, ";}}.modal-open{overflow-y:scroll;&.fullscreen-board{overflow-y:hidden;}}");

// EXTERNAL MODULE: ./static/svg/close.svg
var svg_close = __webpack_require__(1725);
// EXTERNAL MODULE: ./client/services/accessibility/accessibility-service.js
var accessibility_service = __webpack_require__(60696);
// EXTERNAL MODULE: ./styles/colors.js
var colors = __webpack_require__(12573);
// EXTERNAL MODULE: ./styles/color-consts.js
var color_consts = __webpack_require__(273);
// EXTERNAL MODULE: ./segments/desktop/core-components/embedded-board/embedded-board.js + 1 modules
var embedded_board = __webpack_require__(94598);
;// CONCATENATED MODULE: ./components/core/live-board-experience/tabs-content/views-tab-content/views-tab-component.scss.js

var StyledViewsTabContentComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1ivsiw00"
})(".live-board-tab-wrapper{.responsive-hoc-component{.desktop-wrapper{.flexible-cards-grid-desktop-component{.flexible-cards-grid-desktop-component-inner{.grid-paragraph-with-image-component-wrapper{.top-layer{.grid-paragraph-with-image{.grid-paragraph-wrapper{padding-bottom:0px;.full-paragraph{.title-wrapper{margin-bottom:0px;.core-title-container .core-title{font-size:1.2rem;}}}}}}}}}}}}");

// EXTERNAL MODULE: ./segments/desktop/core-components/grid-image-with-paragraph/grid-image-with-paragraph.js + 2 modules
var grid_image_with_paragraph = __webpack_require__(47755);
;// CONCATENATED MODULE: ./components/core/live-board-experience/tabs-content/live-board-tabs-service.js
function live_board_tabs_service_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function live_board_tabs_service_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            live_board_tabs_service_define_property(target, key, source[key]);
        });
    }
    return target;
}
function live_board_tabs_service_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function live_board_tabs_service_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        live_board_tabs_service_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}

var getGridImageWithParagraphProps = function(param) {
    var _imageSrc = param.imageSrc, imageSrc = _imageSrc === void 0 ? null : _imageSrc, _fullParagraphTitle = param.fullParagraphTitle, fullParagraphTitle = _fullParagraphTitle === void 0 ? null : _fullParagraphTitle, _fullParagraphBody = param.fullParagraphBody, fullParagraphBody = _fullParagraphBody === void 0 ? null : _fullParagraphBody, _fullParagraphTopic = param.fullParagraphTopic, fullParagraphTopic = _fullParagraphTopic === void 0 ? null : _fullParagraphTopic;
    var fullParagraph = live_board_tabs_service_object_spread_props(live_board_tabs_service_object_spread({}, grid_image_with_paragraph/* default.defaultProps.fullParagraph */.Z.defaultProps.fullParagraph), {
        topic: {
            text: fullParagraphTopic
        },
        title: fullParagraphTitle,
        body: fullParagraphBody
    });
    return live_board_tabs_service_object_spread_props(live_board_tabs_service_object_spread({}, grid_image_with_paragraph/* default.defaultProps */.Z.defaultProps), {
        src: imageSrc,
        fullParagraph: fullParagraph
    });
};

;// CONCATENATED MODULE: ./components/core/live-board-experience/tabs-content/views-tab-content/views-tab-consts.js

var firstRow = [
    getGridImageWithParagraphProps({
        imageSrc: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/live-board-2022/views/dashboard_views.png",
        fullParagraphTitle: "Dashboard"
    }),
    getGridImageWithParagraphProps({
        imageSrc: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/live-board-2022/views/gantt_views.png",
        fullParagraphTitle: "Gantt"
    }),
    getGridImageWithParagraphProps({
        imageSrc: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/live-board-2022/views/kanbann_views.png",
        fullParagraphTitle: "Kanban"
    }),
    getGridImageWithParagraphProps({
        imageSrc: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/live-board-2022/views/gallary_views.png",
        fullParagraphTitle: "Files Gallery"
    })
];
var secondRow = [
    getGridImageWithParagraphProps({
        imageSrc: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/live-board-2022/views/calendar_views.png",
        fullParagraphTitle: "Calendar"
    }),
    getGridImageWithParagraphProps({
        imageSrc: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/live-board-2022/views/workload_views.png",
        fullParagraphTitle: "Workload"
    }),
    getGridImageWithParagraphProps({
        imageSrc: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/live-board-2022/views/Timeline_views.png",
        fullParagraphTitle: "Timeline"
    }),
    getGridImageWithParagraphProps({
        imageSrc: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/live-board-2022/views/map_views.png",
        fullParagraphTitle: "Map"
    })
];
var thirdRow = [
    getGridImageWithParagraphProps({
        imageSrc: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/live-board-2022/views/form_views.png",
        fullParagraphTitle: "Form"
    }),
    getGridImageWithParagraphProps({
        imageSrc: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/live-board-2022/views/cards_views.png",
        fullParagraphTitle: "Cards"
    }),
    getGridImageWithParagraphProps({
        imageSrc: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/live-board-2022/views/chart_views.png",
        fullParagraphTitle: "Chart"
    }),
    getGridImageWithParagraphProps({
        imageSrc: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/live-board-2022/views/Files_views.png",
        fullParagraphTitle: "Files"
    })
];
var viewsGridItems = [
    firstRow,
    secondRow,
    thirdRow
];

;// CONCATENATED MODULE: ./components/core/live-board-experience/tabs-content/live-board-tab-component.scss.js

var StyledLiveBoardTabComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "efjqr30"
})("display:flex;justify-content:center;width:82vw;.tab-content{padding-bottom:200px;width:95%;cursor:default;.description-wrapper{text-align:center;padding-bottom:16px;}.responsive-hoc-component{.desktop-wrapper{.flexible-cards-grid-desktop-component{.flexible-cards-grid-desktop-component-inner{.grid-paragraph-with-image-component-wrapper{.top-layer{.grid-paragraph-with-image{cursor:pointer;&:not(:hover){box-shadow:unset;border:1px solid #dcdfec;border-radius:8px;}&:hover{border:unset;border-radius:8px;border:1px solid #dcdfec;}.grid-image-wrapper{.grid-image{.picture-component{img{border-bottom-right-radius:unset;border-bottom-left-radius:unset;}}}}}}}}}}}}&.hide-paragraph{.responsive-hoc-component{.desktop-wrapper{.flexible-cards-grid-desktop-component{.flexible-cards-grid-desktop-component-inner{.grid-paragraph-with-image-component-wrapper{.top-layer{.grid-paragraph-with-image{.grid-paragraph-wrapper{display:none;}}}}}}}}}");

// EXTERNAL MODULE: ./segments/desktop/core-components/paragraph/paragraph.js + 1 modules
var paragraph = __webpack_require__(75073);
// EXTERNAL MODULE: ./segments/desktop/grid/layouts/flexible-cards-grid/flexible-cards-grid-component.js + 5 modules
var flexible_cards_grid_component = __webpack_require__(38885);
// EXTERNAL MODULE: ./constants/align-types.js
var align_types = __webpack_require__(79409);
// EXTERNAL MODULE: ./components/core/asset/asset-component.js + 2 modules
var asset_component = __webpack_require__(24961);
;// CONCATENATED MODULE: ./components/core/live-board-experience/tabs-content/live-board-tab-component.js
function live_board_tab_component_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function live_board_tab_component_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            live_board_tab_component_define_property(target, key, source[key]);
        });
    }
    return target;
}
function live_board_tab_component_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function live_board_tab_component_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        live_board_tab_component_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}







var LiveBoardTabComponent = function(props) {
    var description = props.description, topAssetProps = props.topAssetProps, gridItems = props.gridItems, hideCardParagraph = props.hideCardParagraph, onCardClick = props.onCardClick, hideVideoControls = props.hideVideoControls, onAssetClick = props.onAssetClick;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledLiveBoardTabComponent, {
        className: classnames_default()("live-board-tab-wrapper", {
            "hide-paragraph": hideCardParagraph
        }),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "tab-content",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "description-wrapper",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(paragraph/* default */.Z, {
                        body: description
                    })
                }),
                topAssetProps && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "asset-wrapper",
                    onClick: onAssetClick,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(asset_component/* default */.Z, live_board_tab_component_object_spread_props(live_board_tab_component_object_spread({}, topAssetProps), {
                        hideControls: hideVideoControls
                    }))
                }),
                gridItems === null || gridItems === void 0 ? void 0 : gridItems.map(function(item) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "tab-cards-wrapper",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(flexible_cards_grid_component["default"], {
                            gridItems: item,
                            gridAlignment: align_types.ALIGN_TYPES.CENTER,
                            defaultCardClick: onCardClick
                        })
                    });
                })
            ]
        })
    });
};
/* harmony default export */ var live_board_tab_component = (LiveBoardTabComponent);

;// CONCATENATED MODULE: ./components/core/live-board-experience/tabs-content/views-tab-content/views-tab-component.js





var ViewsTabContentComponent = function(props) {
    var translate = props.translate, onCardClick = props.onCardClick;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledViewsTabContentComponent, {
        className: "views-tab-content",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(live_board_tab_component, {
            description: translate("liveBoard.viewsTab.description"),
            gridItems: viewsGridItems,
            onCardClick: onCardClick
        })
    });
};
/* harmony default export */ var views_tab_component = ((0,generic_config_context/* withGenericConfig */.P)(ViewsTabContentComponent));

;// CONCATENATED MODULE: ./components/core/live-board-experience/tabs-content/integrations-tab-content/integrations-tab-consts.js

var integrations_tab_consts_firstRow = [
    getGridImageWithParagraphProps({
        imageSrc: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/live-board-2022/integrations/gmail.png",
        fullParagraphTitle: "integrations - gmail"
    }),
    getGridImageWithParagraphProps({
        imageSrc: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/live-board-2022/integrations/slack.png",
        fullParagraphTitle: "integrations - slack"
    }),
    getGridImageWithParagraphProps({
        imageSrc: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/live-board-2022/integrations/zoom.png",
        fullParagraphTitle: "integrations - zoom"
    }),
    getGridImageWithParagraphProps({
        imageSrc: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/live-board-2022/integrations/zendesk.png",
        fullParagraphTitle: "integrations - zendesk"
    })
];
var integrations_tab_consts_secondRow = [
    getGridImageWithParagraphProps({
        imageSrc: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/live-board-2022/integrations/hubspot.png",
        fullParagraphTitle: "integrations - hubspot"
    }),
    getGridImageWithParagraphProps({
        imageSrc: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/live-board-2022/integrations/jira.png",
        fullParagraphTitle: "integrations - jira"
    }),
    getGridImageWithParagraphProps({
        imageSrc: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/live-board-2022/integrations/google_drive.png",
        fullParagraphTitle: "integrations - google drive"
    }),
    getGridImageWithParagraphProps({
        imageSrc: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/live-board-2022/integrations/microsoft_teams.png",
        fullParagraphTitle: "integrations - microsoft teams"
    })
];
var integrations_tab_consts_thirdRow = [
    getGridImageWithParagraphProps({
        imageSrc: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/live-board-2022/integrations/github.png",
        fullParagraphTitle: "integrations - github"
    }),
    getGridImageWithParagraphProps({
        imageSrc: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/live-board-2022/integrations/outlook.png",
        fullParagraphTitle: "integrations - outlook"
    }),
    getGridImageWithParagraphProps({
        imageSrc: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/live-board-2022/integrations/paypal.png",
        fullParagraphTitle: "integrations - paypal"
    }),
    getGridImageWithParagraphProps({
        imageSrc: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/live-board-2022/integrations/dropbox.png",
        fullParagraphTitle: "integrations - dropbox"
    })
];
var fourthRow = [
    getGridImageWithParagraphProps({
        imageSrc: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/live-board-2022/integrations/twiio.png",
        fullParagraphTitle: "integrations - twilio"
    }),
    getGridImageWithParagraphProps({
        imageSrc: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/live-board-2022/integrations/mailchimp.png",
        fullParagraphTitle: "integrations - mailchimp"
    }),
    getGridImageWithParagraphProps({
        imageSrc: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/live-board-2022/integrations/survey_monkey.png",
        fullParagraphTitle: "integrations - survey monkey"
    }),
    getGridImageWithParagraphProps({
        imageSrc: "https://dapulse-res.cloudinary.com/image/upload/200.png",
        fullParagraphTitle: "integrations - 200+"
    })
];
var integrationsGridItems = [
    integrations_tab_consts_firstRow,
    integrations_tab_consts_secondRow,
    integrations_tab_consts_thirdRow,
    fourthRow
];

;// CONCATENATED MODULE: ./components/core/live-board-experience/tabs-content/integrations-tab-content/integrations-tab-component.js




var IntegrationsTabContentComponent = function(props) {
    var translate = props.translate, onCardClick = props.onCardClick;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "integrations-tab-content",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(live_board_tab_component, {
            description: translate("liveBoard.integrationsTab.description"),
            gridItems: integrationsGridItems,
            hideCardParagraph: true,
            onCardClick: onCardClick
        })
    });
};
/* harmony default export */ var integrations_tab_component = ((0,generic_config_context/* withGenericConfig */.P)(IntegrationsTabContentComponent));

;// CONCATENATED MODULE: ./components/core/live-board-experience/tabs-content/automations-tab-content/automations-tab-consts.js
function automations_tab_consts_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function automations_tab_consts_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            automations_tab_consts_define_property(target, key, source[key]);
        });
    }
    return target;
}
function automations_tab_consts_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function automations_tab_consts_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        automations_tab_consts_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}

var TOP_VIDEO_PROPS = {
    video: {
        src: {
            singleUrl: "https://dapulse-res.cloudinary.com/video/upload/Generator_featured%20images/live-board-2022/automations/automation.mp4"
        },
        autoPlay: true,
        playWhenVisible: false,
        loop: true
    }
};
var automations_tab_consts_firstRow = [
    automations_tab_consts_object_spread_props(automations_tab_consts_object_spread({}, getGridImageWithParagraphProps({
        imageSrc: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/live-board-2022/automations/1_card_automation.png",
        fullParagraphTitle: "automations - row: 1 col: 1"
    })), {
        cardNumOfColumnsWidth: 1.33
    }),
    automations_tab_consts_object_spread_props(automations_tab_consts_object_spread({}, getGridImageWithParagraphProps({
        imageSrc: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/live-board-2022/automations/2_card_automation.png",
        fullParagraphTitle: "automations - row: 1 col: 2"
    })), {
        cardNumOfColumnsWidth: 1.33
    }),
    automations_tab_consts_object_spread_props(automations_tab_consts_object_spread({}, getGridImageWithParagraphProps({
        imageSrc: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/live-board-2022/automations/3_card_automation.png",
        fullParagraphTitle: "automations - row: 1 col: 3"
    })), {
        cardNumOfColumnsWidth: 1.33
    })
];
var automations_tab_consts_secondRow = [
    automations_tab_consts_object_spread_props(automations_tab_consts_object_spread({}, getGridImageWithParagraphProps({
        imageSrc: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/live-board-2022/automations/4_card_automation.png",
        fullParagraphTitle: "automations - row: 2 col: 1"
    })), {
        cardNumOfColumnsWidth: 1.33
    }),
    automations_tab_consts_object_spread_props(automations_tab_consts_object_spread({}, getGridImageWithParagraphProps({
        imageSrc: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/live-board-2022/automations/5_card_automation.png",
        fullParagraphTitle: "automations - row: 2 col: 2"
    })), {
        cardNumOfColumnsWidth: 1.33
    }),
    automations_tab_consts_object_spread_props(automations_tab_consts_object_spread({}, getGridImageWithParagraphProps({
        imageSrc: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/live-board-2022/automations/6_card_automation.png",
        fullParagraphTitle: "automations - row: 2 col: 3"
    })), {
        cardNumOfColumnsWidth: 1.33
    })
];
var automationsGridItems = [
    automations_tab_consts_firstRow,
    automations_tab_consts_secondRow
];

;// CONCATENATED MODULE: ./components/core/live-board-experience/tabs-content/automations-tab-content/automations-tab-component.js




var AutomationsTabContentComponent = function(props) {
    var translate = props.translate, onCardClick = props.onCardClick;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "automations-tab-content",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(live_board_tab_component, {
            description: translate("liveBoard.automationsTab.description"),
            gridItems: automationsGridItems,
            hideCardParagraph: true,
            onCardClick: onCardClick,
            topAssetProps: TOP_VIDEO_PROPS,
            hideVideoControls: true,
            onAssetClick: onCardClick
        })
    });
};
/* harmony default export */ var automations_tab_component = ((0,generic_config_context/* withGenericConfig */.P)(AutomationsTabContentComponent));

;// CONCATENATED MODULE: ./components/core/live-board-experience/tabs-content/invite-tab-content/invite-tab-consts.js
function invite_tab_consts_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function invite_tab_consts_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            invite_tab_consts_define_property(target, key, source[key]);
        });
    }
    return target;
}
function invite_tab_consts_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function invite_tab_consts_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        invite_tab_consts_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}

var invite_tab_consts_firstRow = [
    invite_tab_consts_object_spread_props(invite_tab_consts_object_spread({}, getGridImageWithParagraphProps({
        imageSrc: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/live-board-2022/invite/invite_image.png",
        fullParagraphTitle: "invite - row: 1"
    })), {
        cardNumOfColumnsWidth: 4
    })
];
var invite_tab_consts_secondRow = [
    invite_tab_consts_object_spread_props(invite_tab_consts_object_spread({}, getGridImageWithParagraphProps({
        imageSrc: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/live-board-2022/invite/1_invite_card.png",
        fullParagraphTitle: "invite - row: 2 col: 1"
    })), {
        cardNumOfColumnsWidth: 2
    }),
    invite_tab_consts_object_spread_props(invite_tab_consts_object_spread({}, getGridImageWithParagraphProps({
        imageSrc: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/live-board-2022/invite/2_invite_card.png",
        fullParagraphTitle: "invite - row: 2 col: 2"
    })), {
        cardNumOfColumnsWidth: 2
    })
];
var inviteGridItems = [
    invite_tab_consts_firstRow,
    invite_tab_consts_secondRow
];

;// CONCATENATED MODULE: ./components/core/live-board-experience/tabs-content/invite-tab-content/invite-tab-component.js




var InviteTabContentComponent = function(props) {
    var translate = props.translate, onCardClick = props.onCardClick;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "invite-tab-content",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(live_board_tab_component, {
            description: translate("liveBoard.inviteTab.description"),
            gridItems: inviteGridItems,
            hideCardParagraph: true,
            onCardClick: onCardClick
        })
    });
};
/* harmony default export */ var invite_tab_component = ((0,generic_config_context/* withGenericConfig */.P)(InviteTabContentComponent));

;// CONCATENATED MODULE: ./components/core/live-board-experience/tabs-content/notifications-tab-content/notifications-tab-consts.js
function notifications_tab_consts_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function notifications_tab_consts_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            notifications_tab_consts_define_property(target, key, source[key]);
        });
    }
    return target;
}
function notifications_tab_consts_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function notifications_tab_consts_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        notifications_tab_consts_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}

var notifications_tab_consts_firstRow = [
    notifications_tab_consts_object_spread_props(notifications_tab_consts_object_spread({}, getGridImageWithParagraphProps({
        imageSrc: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/live-board-2022/notifications/Notification_1.png",
        fullParagraphTitle: "notifications - row: 1"
    })), {
        cardNumOfColumnsWidth: 4
    })
];
var notifications_tab_consts_secondRow = [
    notifications_tab_consts_object_spread_props(notifications_tab_consts_object_spread({}, getGridImageWithParagraphProps({
        imageSrc: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/live-board-2022/notifications/Notification_2.png",
        fullParagraphTitle: "notifications - row: 2"
    })), {
        cardNumOfColumnsWidth: 4
    })
];
var notifications_tab_consts_thirdRow = [
    notifications_tab_consts_object_spread_props(notifications_tab_consts_object_spread({}, getGridImageWithParagraphProps({
        imageSrc: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/live-board-2022/notifications/Notification_3.png",
        fullParagraphTitle: "notifications - row: 3"
    })), {
        cardNumOfColumnsWidth: 4
    })
];
var notificationsGridItems = [
    notifications_tab_consts_firstRow,
    notifications_tab_consts_secondRow,
    notifications_tab_consts_thirdRow
];

;// CONCATENATED MODULE: ./components/core/live-board-experience/tabs-content/notifications-tab-content/notifications-tab-component.js




var NotificationsTabContentComponent = function(props) {
    var translate = props.translate, onCardClick = props.onCardClick;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "notifications-tab-content",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(live_board_tab_component, {
            description: translate("liveBoard.notificationsTab.description"),
            gridItems: notificationsGridItems,
            onCardClick: onCardClick,
            hideCardParagraph: true
        })
    });
};
/* harmony default export */ var notifications_tab_component = ((0,generic_config_context/* withGenericConfig */.P)(NotificationsTabContentComponent));

;// CONCATENATED MODULE: ./components/core/live-board-experience/tabs-content/dashboards-tab-content/dashboards-tab-consts.js
var dashboards_tab_consts_TOP_VIDEO_PROPS = {
    video: {
        src: {
            singleUrl: "https://dapulse-res.cloudinary.com/video/upload/Generator_featured%20images/live-board-2022/dashboards/Dashboars_Reports_2022.mp4"
        },
        autoPlay: true,
        playWhenVisible: false,
        loop: true
    }
};

;// CONCATENATED MODULE: ./components/core/live-board-experience/tabs-content/dashboards-tab-content/dashboards-tab-component.js




var DashboardsTabContentComponent = function(props) {
    var translate = props.translate, onCardClick = props.onCardClick;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "dashboards-tab-content",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(live_board_tab_component, {
            description: translate("liveBoard.dashboardsTab.description"),
            topAssetProps: dashboards_tab_consts_TOP_VIDEO_PROPS,
            hideVideoControls: true,
            onAssetClick: onCardClick
        })
    });
};
/* harmony default export */ var dashboards_tab_component = ((0,generic_config_context/* withGenericConfig */.P)(DashboardsTabContentComponent));

;// CONCATENATED MODULE: ./components/core/live-board-experience/live-board-consts.js







var MAIN_TABLE_TAB_ID = "MIAN_TABLE";
var tabs = [
    {
        tabLabel: "Main table",
        tabID: MAIN_TABLE_TAB_ID,
        image: {
            src: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/live-board-2022/2_icon_home.svg"
        },
        liveBoardTabComponent: embedded_board/* default */.Z,
        scrollVisible: true,
        componentProps: {
            hideTopFrame: true,
            isLiveBoard: true
        }
    },
    {
        tabLabel: "Dashboards",
        tabID: "DASHBOARDS",
        image: {
            src: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/live-board-2022/icon_dashboard.svg"
        },
        liveBoardTabComponent: dashboards_tab_component
    },
    {
        tabLabel: "Views",
        tabID: "VIEWS",
        image: {
            src: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/live-board-2022/2_icon_views.svg"
        },
        liveBoardTabComponent: views_tab_component
    },
    {
        tabLabel: "Integrations",
        tabID: "INTEGRATIONS",
        image: {
            src: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/live-board-2022/2_icon_integrations.svg"
        },
        liveBoardTabComponent: integrations_tab_component
    },
    {
        tabLabel: "Automations",
        tabID: "AUTOMATIONS",
        image: {
            src: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/live-board-2022/2_icon_automations.svg"
        },
        liveBoardTabComponent: automations_tab_component
    },
    {
        tabLabel: "Invite",
        tabID: "INVITE",
        image: {
            src: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/live-board-2022/2_icon_invite.svg"
        },
        liveBoardTabComponent: invite_tab_component
    },
    {
        tabLabel: "Notifications",
        tabID: "NOTIFICATIONS",
        image: {
            src: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/live-board-2022/2_icon_notifications.svg"
        },
        liveBoardTabComponent: notifications_tab_component
    }
];
var LIVE_BOARD_VW_WIDTH = 90;
var RIGHT_SECTION_VW_WIDTH = LIVE_BOARD_VW_WIDTH;
var RIGHT_SECTION_RIGHT_VW_MARGIN = 2;
var BANNER_RIGHT_VW_MARGIN = 3;
var BANNER_LEFT_VW_MARGIN = 1;
var BANNER_VW_WIDTH = LIVE_BOARD_VW_WIDTH - BANNER_LEFT_VW_MARGIN - BANNER_RIGHT_VW_MARGIN;
var LIVE_BOARD_BUTTON_CLOSE_ICON = "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/live-board-2022/button/close_icon.svg";

// EXTERNAL MODULE: ./constants/vp-sizes.js
var vp_sizes = __webpack_require__(698);
;// CONCATENATED MODULE: ./components/core/live-board-experience/live-board-screen-component.scss.js






var StyledLiveBoardScreenComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e16y0ma30"
})("display:flex;width:100%;height:100%;.live-board-open-button-wrapper{display:flex;align-items:center;.live-board-open-button-content{z-index:", z_index/* LAYER_ONE */.KW, ";padding-left:4px;@media (max-width:", vp_sizes/* LARGE_SCREEN_MIN_WIDTH */.vA, "){top:70vh;}.x-button-wrapper{display:none;}&:hover{.x-button-wrapper{display:unset;position:absolute;cursor:pointer;top:0;left:0;}}}}.live-board-close{position:absolute;top:16px;left:16px;cursor:pointer;z-index:", z_index/* ALWAYS_ON_TOP */.OL, ";}.close-icon{width:28px;height:22px;path{stroke:", colors/* default */.Z[color_consts.WHITE_COLOR_NAME], ";}}.live-board-content-wrapper{display:flex;border-top-left-radius:12px;border-top-right-radius:12px;width:", LIVE_BOARD_VW_WIDTH + "vw", ";height:98%;margin-top:2%;margin-left:5%;margin-right:5%;justify-content:center;background:", colors/* default */.Z[color_consts.WHITE_COLOR_NAME], ";pointer-events:auto;.right-section{width:", RIGHT_SECTION_VW_WIDTH + "vw", ";margin-right:", RIGHT_SECTION_RIGHT_VW_MARGIN + "vw", ";padding-left:1vw;.board-title-wrapper{display:flex;flex-direction:row;justify-content:space-between;padding-top:44px;padding-left:30px;.title-content{display:flex;flex-direction:row;gap:28px;align-items:baseline;.tag{padding:0 10px;margin:0 2px;font-weight:400;font-size:1rem;line-height:154%;border-radius:2px;width:fit-content;color:", colors/* default */.Z[color_consts.DARK_WORK_OS_IRIS_COLOR_NAME], ";background-color:", colors/* default */.Z[color_consts.BRAND_WORK_MANAGEMENT_LIGHTER_TINT_01], ";}}}.board-views-tab-component{padding-top:20px;padding-left:20px;height:100%;.tabs-component-wrapper{height:100%;.tabs-component{height:100%;.tabs{border-bottom:1px solid #c3c6d4;margin-left:20px;justify-content:left;gap:32px;.tab-component{.title-wrapper{.title-and-icon-wrapper{.icon-wrapper{margin-right:8px;.picture-icon-wrapper{height:25px;}}}}&.active{.tab-underline-placeholder{background:#0073ea;height:2px;}}}}@media (max-width:", vp_sizes/* MAX_DESKTOP_DYNAMIC_TEMPLATE_MAX_WIDTH */.po, "){.tabs{gap:16px;.tab-component{.title-wrapper{.title-and-icon-wrapper{.monday-markup-language-component{font-size:1rem;@media (max-width:", vp_sizes/* MACBOOK_PRO_MAX_WIDTH */.Wh, "){font-size:0.9rem;}}}}}}}.content{height:75%;padding-top:32px;.asset-wrapper{opacity:unset;min-height:unset;margin:16px 30px;.asset-inner{cursor:pointer;.video-component{.react-player-video-component{video{border-radius:12px;}}}}}@media (min-width:", vp_sizes/* X_LARGE_SCREEN_MIN_WIDTH */.M$, "){.asset-wrapper{margin:16px 60px;}}.tab-component{height:100%;padding:unset;overflow:scroll;:hover{background-color:unset;}.embedded-board{.tooltip-wrapper{justify-content:left;bottom:unset;top:230px;margin-left:10px;.tooltip{&:after{bottom:40px;transform:rotate(180deg);}}}.embedded-wrapper{border:unset;}}&.scroll-visible{overflow:visible;}}}}}}.banner-wrapper{position:fixed;opacity:0;transition-property:opacity;transition-duration:0.15s;z-index:", z_index/* ALWAYS_ON_TOP */.OL, ";bottom:2vh;margin-right:", BANNER_RIGHT_VW_MARGIN + "vw", ";margin-left:", BANNER_LEFT_VW_MARGIN + "vw", ";.shake{.banner{width:", BANNER_VW_WIDTH + "vw", ";border-radius:8px;.banner-content{.banner-text-and-cta{.banner-text-and-link{flex-direction:row;.banner-cta-wrapper{.button{.signup-button{.error-handling-component{.shake{.signup-form-core-component-wrapper{.signup-form{.signup-button-wrapper{.ladda-button{color:", colors/* default */.Z[color_consts.DARK_WORK_OS_IRIS_COLOR_NAME], ";}}}}}}}}}}}}}}}}}&.board-fully-visible{.live-board-content-wrapper{.right-section{.banner-wrapper{opacity:1;}}}}");

// EXTERNAL MODULE: ./segments/desktop/core-components/board-views-tab/board-views-tab.js + 1 modules
var board_views_tab = __webpack_require__(20959);
// EXTERNAL MODULE: ./components/core/tabs/tab/tab-component.js + 1 modules
var tab_component = __webpack_require__(20525);
// EXTERNAL MODULE: ./segments/desktop/core-components/title/title.js + 1 modules
var title = __webpack_require__(91265);
// EXTERNAL MODULE: ./segments/desktop/core-components/banner/banner.js + 2 modules
var banner = __webpack_require__(15814);
// EXTERNAL MODULE: ./segments/segments-service.js
var segments_service = __webpack_require__(861);
// EXTERNAL MODULE: ./components/enhancements/shake/shake-component.js + 1 modules
var shake_component = __webpack_require__(89868);
// EXTERNAL MODULE: ./segments/desktop/core-components/button/signup-button/signup-button.js + 1 modules
var signup_button = __webpack_require__(85850);
;// CONCATENATED MODULE: ./components/core/live-board-experience/default-props.js
/* harmony default export */ var default_props = ({
    bannerText: "Project Plan",
    embeddedBoardTitle: "Sign up for free to gain full access to all features",
    embeddedBoardLink: "https://view.monday.com/3565981122-91f9221ceff3c454e3b37cbc72ea5d33?r=use1"
});

;// CONCATENATED MODULE: ./components/core/live-board-experience/live-board-screen-component.js
function live_board_screen_component_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function live_board_screen_component_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            live_board_screen_component_define_property(target, key, source[key]);
        });
    }
    return target;
}
function live_board_screen_component_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function live_board_screen_component_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        live_board_screen_component_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
















var liveBoardScreenComponent = function(props) {
    var translate = props.translate, closeLiveBoard = props.closeLiveBoard, showLiveBoard = props.showLiveBoard, embeddedBoardLink = props.embeddedBoardLink, boardBannerText = props.boardBannerText, embeddedBoardTitle = props.embeddedBoardTitle, addSecondLiveBoardSignUpButton = props.addSecondLiveBoardSignUpButton, liveBoardToolTipText = props.liveBoardToolTipText;
    var ref = (0,react.useState)(false), shakerIsActive = ref[0], setIsActive = ref[1];
    var ref1 = (0,react.useState)(MAIN_TABLE_TAB_ID), currentTab = ref1[0], setCurrentTab = ref1[1];
    var LIVE_BOARD_BANNER_PLACEMENT = "live_board_banner_placement";
    var LIVE_BOARD_TOP_RIGHT_PLACEMENT = "live_board_top_right_placement";
    var LIVE_BOARD_TAB_LOCATION = "live_board_tab_placement";
    var TOOLTIP_DEFAULT_TEXT = "Start by adding a task";
    var startShaking = function(callback) {
        setIsActive(true);
        callback();
    };
    var shakeBanner = function() {
        startShaking(resetShaker);
    };
    var resetShaker = function() {
        setTimeout(function() {
            return setIsActive(false);
        }, 600);
    };
    var onTabClick = function(index) {
        var _tabs_index;
        setCurrentTab((_tabs_index = tabs[index]) === null || _tabs_index === void 0 ? void 0 : _tabs_index.tabID);
    };
    var onKeyDown = (0,accessibility_service/* generateOnKeyDownHandler */.vR)(closeLiveBoard);
    var renderCloseIcon = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "live-board-close",
            onClick: closeLiveBoard,
            onKeyDown: onKeyDown,
            tabIndex: 0,
            role: "button",
            "aria-label": translate("liveBoard.close"),
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(svg_close/* default */.Z, {
                className: "close-icon"
            })
        });
    };
    var tabsRenderer = function() {
        var theme = props.theme;
        return tabs === null || tabs === void 0 ? void 0 : tabs.map(function(tab, index) {
            var tabLabel = tab.tabLabel, hideLabel = tab.hideLabel, image = tab.image, LiveBoardTabComponent = tab.liveBoardTabComponent, scrollVisible = tab.scrollVisible, componentProps = tab.componentProps;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(tab_component/* default */.Z, {
                label: tabLabel,
                color: theme,
                useXSMLabels: true,
                tabIcon: image,
                tabsWithIcons: true,
                hideLabel: hideLabel,
                extraData: {
                    location: LIVE_BOARD_TAB_LOCATION
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: classnames_default()("tab-component", {
                        "scroll-visible": scrollVisible
                    }),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LiveBoardTabComponent, live_board_screen_component_object_spread_props(live_board_screen_component_object_spread({
                        onCardClick: shakeBanner
                    }, componentProps), {
                        sharableLink: embeddedBoardLink,
                        tooltipText: liveBoardToolTipText || TOOLTIP_DEFAULT_TEXT
                    }))
                })
            }, index);
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledLiveBoardScreenComponent, {
        className: classnames_default()("live-board-screen", {
            "board-fully-visible": showLiveBoard
        }),
        children: [
            showLiveBoard && renderCloseIcon(),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "live-board-content-wrapper",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "right-section",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "banner-wrapper",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(shake_component/* default */.Z, {
                                isActive: shakerIsActive,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(banner/* default */.Z, {
                                    buttonConfig: {
                                        buttonType: "Signup"
                                    },
                                    bannerCta: translate("signup.cta"),
                                    bannerText: boardBannerText,
                                    withCloseIcon: false,
                                    theme: segments_service/* BRAND_WORK_MANAGEMENT_PRIMARY_THEME_ID */.Qu,
                                    hideBanner: false,
                                    placement: LIVE_BOARD_BANNER_PLACEMENT,
                                    extraData: {
                                        live_board_tab_type: currentTab
                                    }
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "board-title-wrapper",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "title-content",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(title/* default */.Z, {
                                            title: embeddedBoardTitle
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "tag",
                                            children: translate("liveBoard.demoEnvironment")
                                        })
                                    ]
                                }),
                                addSecondLiveBoardSignUpButton && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "sign-up-button-wrapper",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(signup_button/* default */.Z, {
                                        extraData: {
                                            placement: LIVE_BOARD_TOP_RIGHT_PLACEMENT
                                        }
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(board_views_tab/* default */.Z, {
                            fullSizeContent: true,
                            tabsRenderer: tabsRenderer,
                            onTabClick: onTabClick
                        })
                    ]
                })
            })
        ]
    });
};
liveBoardScreenComponent.defaultProps = default_props;
/* harmony default export */ var live_board_screen_component = ((0,generic_config_context/* withGenericConfig */.P)(liveBoardScreenComponent));

;// CONCATENATED MODULE: ./components/core/live-board-experience/live-board-modal.js







var liveBoardPopupModal = function(props) {
    var showLiveBoard = props.showLiveBoard, closeLiveBoard = props.closeLiveBoard, translate = props.translate, isPreview = props.isPreview, embeddedBoardLink = props.embeddedBoardLink, boardBannerText = props.boardBannerText, embeddedBoardTitle = props.embeddedBoardTitle, addSecondLiveBoardSignUpButton = props.addSecondLiveBoardSignUpButton, liveBoardToolTipText = props.liveBoardToolTipText;
    (0,react.useEffect)(function() {
        document.body.classList.toggle("fullscreen-board", showLiveBoard);
    }, [
        showLiveBoard
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StylesLiveBoardPopupModal, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((lib_default()), {
            className: classnames_default()("live-board-modal", {
                "fullscreen-board": showLiveBoard
            }),
            overlayClassName: classnames_default()("live-board-modal-overlay", {
                "fullscreen-board": showLiveBoard
            }),
            bodyOpenClassName: "modal-open",
            isOpen: isPreview ? false : true,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(live_board_screen_component, {
                translate: translate,
                closeLiveBoard: closeLiveBoard,
                showLiveBoard: showLiveBoard,
                embeddedBoardLink: embeddedBoardLink,
                boardBannerText: boardBannerText,
                embeddedBoardTitle: embeddedBoardTitle,
                addSecondLiveBoardSignUpButton: addSecondLiveBoardSignUpButton,
                liveBoardToolTipText: liveBoardToolTipText
            })
        })
    });
};
/* harmony default export */ var live_board_modal = ((0,generic_config_context/* withGenericConfig */.P)(liveBoardPopupModal));

// EXTERNAL MODULE: ./constants/new-ab-tests.js
var new_ab_tests = __webpack_require__(60734);
// EXTERNAL MODULE: ./segments/desktop/header/layouts/base-header/base-header-service.js + 56 modules
var base_header_service = __webpack_require__(33054);
// EXTERNAL MODULE: ./services/sales-enrichment/sales-enrichment-service.js
var sales_enrichment_service = __webpack_require__(29919);
// EXTERNAL MODULE: ./services/typeform/typeform-service.js
var typeform_service = __webpack_require__(15728);
// EXTERNAL MODULE: ./services/ab-tests/monetization-ab-tests-service.js + 2 modules
var monetization_ab_tests_service = __webpack_require__(46724);
// EXTERNAL MODULE: ./contexts/careers-context.js
var careers_context = __webpack_require__(17581);
;// CONCATENATED MODULE: ./segments/desktop/core-components/scroll-to-top/scroll-to-top.scss.js


var StyledScrollToTop = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e44y95e0"
})("opacity:", function(param) {
    var isDisplayed = param.isDisplayed;
    return isDisplayed ? 1 : 0;
}, ";transition:transform 0.3s ease-in-out;position:fixed;cursor:", function(param) {
    var isDisplayed = param.isDisplayed;
    return isDisplayed ? "pointer" : "unset";
}, ";z-index:", z_index/* ALWAYS_ON_TOP */.OL, ";right:36px;bottom:36px;svg{height:60px;width:60px;}");

;// CONCATENATED MODULE: ./segments/desktop/core-components/scroll-to-top/default-props.js
/* harmony default export */ var scroll_to_top_default_props = ({});

;// CONCATENATED MODULE: ./segments/desktop/core-components/scroll-to-top/scroll-icon.js

var ScrollIcon = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "100",
        height: "100",
        viewBox: "0 0 100 100",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                cx: "50",
                cy: "50",
                r: "50",
                fill: "#6161FF"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M50.7071 33.2929C50.3166 32.9024 49.6834 32.9024 49.2929 33.2929L42.9289 39.6569C42.5384 40.0474 42.5384 40.6805 42.9289 41.0711C43.3195 41.4616 43.9526 41.4616 44.3431 41.0711L50 35.4142L55.6569 41.0711C56.0474 41.4616 56.6805 41.4616 57.0711 41.0711C57.4616 40.6805 57.4616 40.0474 57.0711 39.6569L50.7071 33.2929ZM51 72L51 34L49 34L49 72L51 72Z",
                fill: "white"
            })
        ]
    });
};

;// CONCATENATED MODULE: ./segments/desktop/core-components/scroll-to-top/scroll-to-top.js





var DEFAULT_SCROLL_OFFSET_TO_DISPLAY = 100;
var ScrollToTop = function(param) {
    var _scrollOffsetToDisplay = param.scrollOffsetToDisplay, scrollOffsetToDisplay = _scrollOffsetToDisplay === void 0 ? DEFAULT_SCROLL_OFFSET_TO_DISPLAY : _scrollOffsetToDisplay;
    var ref = (0,react.useState)(false), isDisplayed = ref[0], setIsDisplayed = ref[1];
    (0,react.useEffect)(function() {
        var handleScroll = function() {
            window.scrollY >= scrollOffsetToDisplay ? setIsDisplayed(true) : setIsDisplayed(false);
        };
        window.addEventListener("scroll", handleScroll);
        return function() {
            window.removeEventListener("scroll", handleScroll);
        };
    }, []);
    var onClick = function() {
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledScrollToTop, {
        onClick: onClick,
        className: "scroll-to-top",
        isDisplayed: isDisplayed,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ScrollIcon, {})
    });
};
/* harmony default export */ var scroll_to_top = (ScrollToTop);
ScrollToTop.defaultProps = scroll_to_top_default_props;

;// CONCATENATED MODULE: ./components/templates/base-template.js






function base_template_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function base_template_async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                base_template_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                base_template_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function base_template_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function base_template_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            base_template_define_property(target, key, source[key]);
        });
    }
    return target;
}
function base_template_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function base_template_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        base_template_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}




































var SCROLL_PERCENTAGE_THROTTLE_TIME = 1000; // Execute a method only once per THROTTLE_TIME
var SCROLL_PERCENTAGE_STEPS = 10;
var UTM_URL_TERM = "utm";
var BaseTemplate = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(BaseTemplate, PureComponent);
    var _super = (0,_create_super/* default */.Z)(BaseTemplate);
    function BaseTemplate(props) {
        (0,_class_call_check/* default */.Z)(this, BaseTemplate);
        var _this;
        _this = _super.call(this, props);
        base_template_define_property((0,_assert_this_initialized/* default */.Z)(_this), "openLiveBoard", function(props) {
            _this.setState({
                showLiveBoard: true,
                showLiveBoardImage: false,
                liveBoardProps: props
            });
            (0,bigbrain_service.trackEvent)(bigbrain_event_types.LIVE_BOARD_OPENED);
        });
        base_template_define_property((0,_assert_this_initialized/* default */.Z)(_this), "setIsFirstFoldVisible", function(state) {
            _this.setState({
                isFirstFoldVisible: state
            });
        });
        base_template_define_property((0,_assert_this_initialized/* default */.Z)(_this), "setStartShowingContactSalesButton", function(state) {
            _this.setState({
                startShowingContactSalesButton: state
            });
        });
        base_template_define_property((0,_assert_this_initialized/* default */.Z)(_this), "closeLiveBoard", function() {
            _this.setState({
                showLiveBoard: false,
                showLiveBoardImage: true,
                liveBoardClosed: true
            });
            (0,bigbrain_service.trackEvent)(bigbrain_event_types.LIVE_BOARD_CLOSED);
        });
        var _this1 = (0,_assert_this_initialized/* default */.Z)(_this);
        base_template_define_property((0,_assert_this_initialized/* default */.Z)(_this), "scrollingByPercentage", /*#__PURE__*/ base_template_async_to_generator(function() {
            var maxRecordedScrollPercentage, currentScrollPercentage, documentHeight, viewportHeight, e;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        maxRecordedScrollPercentage = _this1.state.maxRecordedScrollPercentage;
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            5,
                            ,
                            6
                        ]);
                        return [
                            4,
                            (0,dom_utils_service.getScrollPercent)()
                        ];
                    case 2:
                        currentScrollPercentage = _state.sent();
                        return [
                            4,
                            (0,dom_utils_service.getDocumentFullHeight)()
                        ];
                    case 3:
                        documentHeight = _state.sent();
                        return [
                            4,
                            (0,dom_utils_service.getViewportHeight)()
                        ];
                    case 4:
                        viewportHeight = _state.sent();
                        if (currentScrollPercentage > maxRecordedScrollPercentage + SCROLL_PERCENTAGE_STEPS) {
                            _this1.setState({
                                maxRecordedScrollPercentage: currentScrollPercentage
                            });
                            (0,bigbrain_service.trackEvent)(bigbrain_event_types.PAGE_SCROLL_BY_PERCENTAGE, {
                                kind: parseInt(currentScrollPercentage),
                                info1: viewportHeight,
                                info2: documentHeight,
                                info3: _this1.pageLoadUnique //	for easily find the last event per page load
                            });
                        }
                        return [
                            3,
                            6
                        ];
                    case 5:
                        e = _state.sent();
                        return [
                            3,
                            6
                        ];
                    case 6:
                        return [
                            2
                        ];
                }
            });
        }));
        base_template_define_property((0,_assert_this_initialized/* default */.Z)(_this), "setAbTestDebugCookieIfNeeded", function() {
            var asPath = _this.props.asPath;
            var abTestDebugParamValue = (0,utils_url.getUrlParamValue)(asPath, new_ab_tests.DEBUG_AB_TEST_PARAM_NAME);
            if (abTestDebugParamValue) {
                (0,cookies_service/* setCookie */.d8)(cookies.WEBSITE_AB_TEST_DEBUG_COOKIE_NAME, abTestDebugParamValue, {
                    expires: 1 / 24 // 1 hour
                });
            }
        });
        base_template_define_property((0,_assert_this_initialized/* default */.Z)(_this), "setMultiProductsTestCookieIfNeeded", function() {
            var _props = _this.props, abTestVariants = _props.abTestVariants, perceptionSurveyTests = _props.perceptionSurveyTests;
            var perceptionSurveyTestsNames = perceptionSurveyTests === null || perceptionSurveyTests === void 0 ? void 0 : perceptionSurveyTests.map(function(test) {
                return test.testName;
            });
            var multiProductsTest = abTestVariants === null || abTestVariants === void 0 ? void 0 : abTestVariants.find(function(abTest) {
                return perceptionSurveyTestsNames === null || perceptionSurveyTestsNames === void 0 ? void 0 : perceptionSurveyTestsNames.includes(abTest.name);
            });
            if (multiProductsTest) {
                (0,cookies_service/* setCookie */.d8)(cookies.MULTI_PRODUCTS_TEST_COOKIE_NAME, JSON.stringify({
                    id: multiProductsTest.id,
                    variant: multiProductsTest.versionNum
                }), {
                    expires: 1 // 24 hours
                });
            }
        });
        base_template_define_property((0,_assert_this_initialized/* default */.Z)(_this), "translate", function(key) {
            var translations = _this.props.translations;
            return translations[key] || key;
        });
        base_template_define_property((0,_assert_this_initialized/* default */.Z)(_this), "translateWithParam", function(key, parameter1) {
            var translation = _this.translate(key);
            var templateString = translation.replace("%param1%", parameter1);
            return templateString;
        });
        base_template_define_property((0,_assert_this_initialized/* default */.Z)(_this), "translateOrTranslateWithParam", function(keyToTranslate) {
            if (!keyToTranslate) return null;
            if (typeof keyToTranslate === "object") {
                var key = keyToTranslate.key, param = keyToTranslate.param;
                return _this.translateWithParam(key, param);
            }
            return _this.translate(keyToTranslate);
        });
        _this.pageLoadUnique = (0,utils_service.getRandomInt)(100000000);
        _this.passiveIfSupported = (0,dom_utils_service.getPassiveIfSupported)();
        _this.scrollPercentageEvent = lodash_throttle_default()(_this.scrollingByPercentage, SCROLL_PERCENTAGE_THROTTLE_TIME, {
            leading: false,
            trailing: true
        });
        _this.state = {
            maxRecordedScrollPercentage: 0,
            showLiveBoard: false,
            showLiveBoardImage: true,
            isFirstFoldVisible: true,
            startShowingContactSalesButton: false,
            liveBoardClosed: false,
            liveBoardProps: {}
        };
        return _this;
    }
    (0,_create_class/* default */.Z)(BaseTemplate, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                var _window_location_href, _window_location, _window;
                var _props = this.props, cloudfrontViewerCountry = _props.cloudfrontViewerCountry, persistantCookies = _props.persistantCookies, abTestVariants = _props.abTestVariants, isPricingPage = _props.isPricingPage, forcePricing = _props.forcePricing, isPreview = _props.isPreview, isV13PricingVersion = _props.isV13PricingVersion;
                window.addEventListener("scroll", this.scrollPercentageEvent, this.passiveIfSupported);
                saveCloudfrontViewerCountryCookie(cloudfrontViewerCountry);
                if ((_window = window) === null || _window === void 0 ? void 0 : (_window_location = _window.location) === null || _window_location === void 0 ? void 0 : (_window_location_href = _window_location.href) === null || _window_location_href === void 0 ? void 0 : _window_location_href.includes(UTM_URL_TERM)) {
                    (0,sales_enrichment_service/* StoreUTMDataForEnrichment */.GB)();
                }
                this.sendGenericAbTestEventIfNeeded();
                this.setAbTestDebugCookieIfNeeded();
                this.setMultiProductsTestCookieIfNeeded();
                if (isPricingPage && !isPreview && persistantCookies) {
                    (0,monetization_ab_tests_service/* enterV13TestIfNeeded */.p)(abTestVariants, persistantCookies, forcePricing, isV13PricingVersion);
                }
            }
        },
        {
            key: "sendGenericAbTestEventIfNeeded",
            value: function sendGenericAbTestEventIfNeeded() {
                var _props = this.props, abTestVariants = _props.abTestVariants, abTestExactEventName = _props.abTestExactEventName;
                var abTestVariant = (0,lp_ab_tests_service.getExactEventNameAbTestVariant)(abTestExactEventName, abTestVariants);
                if (abTestExactEventName && abTestVariant) {
                    // TODO: should move to head script (AbTestSplitEventScript) and remove this method. Right now it depended on initialization functions and 3rd party services that should also move to head script
                    (0,gtm_service/* fireGtmEvent */.k2)((data_layer_event_types_default()).IN_PAGE_AB_TEST_EVENT_NAME, {
                        abTestName: abTestExactEventName,
                        abTestVariant: abTestVariant
                    });
                }
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                window.removeEventListener("scroll", this.scrollPercentageEvent, this.passiveIfSupported);
            }
        },
        {
            key: "render",
            value: function render() {
                var extractTypes = function extractTypes(data) {
                    return data === null || data === void 0 ? void 0 : data.map(function(item) {
                        return item.type;
                    });
                };
                var _props = this.props, children = _props.children, title = _props.title, description = _props.description, canonicalUrl = _props.canonicalUrl, asPath = _props.asPath, fontLazyLoad = _props.fontLazyLoad, showHeaderScripts = _props.showHeaderScripts, marketingTemplateBoardIds = _props.marketingTemplateBoardIds, showTrustpilotReviews = _props.showTrustpilotReviews, coupon = _props.coupon, extendTrialCookie = _props.extendTrialCookie, clusterId = _props.clusterId, pageProductId = _props.pageProductId, pageClusterId = _props.pageClusterId, pageSubClusterId = _props.pageSubClusterId, pageClusterConfig = _props.pageClusterConfig, subClusterId = _props.subClusterId, clusterIdSource = _props.clusterIdSource, subClusterIdSource = _props.subClusterIdSource, clusterConfig = _props.clusterConfig, isClusterMiniSitePage = _props.isClusterMiniSitePage, useProductMiniSiteConfig = _props.useProductMiniSiteConfig, localeId = _props.localeId, userSelectedLanguage = _props.userSelectedLanguage, overrideLanguages = _props.overrideLanguages, withFullstory = _props.withFullstory, fullstoryRecordingFrequency = _props.fullstoryRecordingFrequency, abTestVariants = _props.abTestVariants, abTestExactEventName = _props.abTestExactEventName, template = _props.template, useExpandingSignup = _props.useExpandingSignup, disableGTM = _props.disableGTM, isMobileOrTabletBrowser = _props.isMobileOrTabletBrowser, isMobileBrowser = _props.isMobileBrowser, isTypeformDisabled = _props.isTypeformDisabled, positions = _props.positions, perceptionSurveyTests = _props.perceptionSurveyTests, imagesLazyLoad = _props.imagesLazyLoad, noIndex = _props.noIndex, noFollow = _props.noFollow, gtmContainerId = _props.gtmContainerId, useSectionsMenu = _props.useSectionsMenu, isPreview = _props.isPreview, currency = _props.currency, cloudfrontViewerCountry = _props.cloudfrontViewerCountry, useNewTranslationsApi = _props.useNewTranslationsApi, enableHotjar = _props.enableHotjar, hotjarFinalDate = _props.hotjarFinalDate, pricingVersion = _props.pricingVersion, hasFreeTier = _props.hasFreeTier, hideBannerWithBackground = _props.hideBannerWithBackground, cookies = _props.cookies, persistantCookies = _props.persistantCookies, lazyImages = _props.lazyImages, grantedFeatures = _props.grantedFeatures, freeTierForcePrevent = _props.freeTierForcePrevent, skipClustersQuestion = _props.skipClustersQuestion, forcePricing = _props.forcePricing, forceCurrency = _props.forceCurrency, hasStudentPlan = _props.hasStudentPlan, facebookMetaOverride = _props.facebookMetaOverride, twitterMetaOverride = _props.twitterMetaOverride, enablePageUsageDurationTracking = _props.enablePageUsageDurationTracking, dynamicAssetParam = _props.dynamicAssetParam, activePagePath = _props.activePagePath, activeOriginalPagePath = _props.activeOriginalPagePath, localizedPages = _props.localizedPages, pageBackgroundColorName = _props.pageBackgroundColorName, is404Page = _props.is404Page, isPricingPage = _props.isPricingPage, testTypeformContactSales = _props.testTypeformContactSales, forceTypeformContactSalesExperience = _props.forceTypeformContactSalesExperience, sendToSignupWithProductPage = _props.sendToSignupWithProductPage, seoFAQ = _props.seoFAQ, addLiveBoardExperience = _props.addLiveBoardExperience, preloadFirstFoldImages = _props.preloadFirstFoldImages, contactSalesTestMode = _props.contactSalesTestMode, shouldGetSignupPrefetchedAssets = _props.shouldGetSignupPrefetchedAssets, signupDynamicAssetsLinks = _props.signupDynamicAssetsLinks, embeddedBoardLink = _props.embeddedBoardLink, forceProductSignup = _props.forceProductSignup, customHeadScript = _props.customHeadScript, customBodyScript = _props.customBodyScript, getMobileSoftSignup = _props.getMobileSoftSignup, useNewTypeformUSVariant = _props.useNewTypeformUSVariant, isV13PricingVersion = _props.isV13PricingVersion, segments = _props.segments, isInContactSalesNoHeaderTest = _props.isInContactSalesNoHeaderTest, simulateContactSalesButtonInTheFooter = _props.simulateContactSalesButtonInTheFooter, simulateSwitcherForExistingUsers = _props.simulateSwitcherForExistingUsers, hideContactSalesInFooter = _props.hideContactSalesInFooter, showScrollToTop = _props.showScrollToTop;
                var _state = this.state, showLiveBoard = _state.showLiveBoard, showLiveBoardImage = _state.showLiveBoardImage, liveBoardClosed = _state.liveBoardClosed, liveBoardProps = _state.liveBoardProps;
                var isSecondaryMenuNeeded = (0,base_header_service/* shouldRenderSecondaryMenu */.Y0)(isClusterMiniSitePage, pageClusterConfig, useProductMiniSiteConfig);
                var shouldGetTypeformPrefetchedAssets = (0,typeform_service/* shouldGetTypeformExperience */.ap)({
                    abTests: abTestVariants,
                    isTypeformDisabled: isTypeformDisabled,
                    cloudfrontViewerCountry: cloudfrontViewerCountry,
                    testTypeformContactSales: testTypeformContactSales,
                    forceTypeformContactSalesExperience: forceTypeformContactSalesExperience
                });
                var prefetchTypeformAssetsProviderProps = {
                    cloudfrontViewerCountry: cloudfrontViewerCountry,
                    useNewTypeformUSVariant: useNewTypeformUSVariant,
                    abTests: abTestVariants
                };
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(generic_config_context/* GenericConfigContext.Provider */.Z.Provider, {
                    value: {
                        localeId: localeId,
                        clusterId: clusterId,
                        pageProductId: pageProductId,
                        pageClusterId: pageClusterId,
                        pageSubClusterId: pageSubClusterId,
                        pageClusterConfig: pageClusterConfig,
                        subClusterId: subClusterId,
                        clusterConfig: clusterConfig,
                        isClusterMiniSitePage: isClusterMiniSitePage,
                        useProductMiniSiteConfig: useProductMiniSiteConfig,
                        userSelectedLanguage: userSelectedLanguage,
                        overrideLanguages: overrideLanguages,
                        useExpandingSignup: useExpandingSignup,
                        isMobileOrTabletBrowser: isMobileOrTabletBrowser,
                        isMobileBrowser: isMobileBrowser,
                        imagesLazyLoad: imagesLazyLoad,
                        noIndex: noIndex,
                        noFollow: noFollow,
                        isPreview: isPreview,
                        hasFreeTier: hasFreeTier,
                        isTypeformDisabled: isTypeformDisabled,
                        positions: positions,
                        perceptionSurveyTests: perceptionSurveyTests,
                        pricingVersion: isPreview ? (pricing_versions_default()).DEFAULT_VERSION : pricingVersion,
                        cloudfrontViewerCountry: cloudfrontViewerCountry,
                        useNewTranslationsApi: useNewTranslationsApi,
                        lazyImages: lazyImages,
                        translate: this.translate,
                        translateWithParam: this.translateWithParam,
                        translateOrTranslateWithParam: this.translateOrTranslateWithParam,
                        hideBannerWithBackground: hideBannerWithBackground,
                        cookies: cookies,
                        persistantCookies: persistantCookies,
                        currency: currency,
                        grantedFeatures: grantedFeatures,
                        freeTierForcePrevent: freeTierForcePrevent,
                        forcePricing: forcePricing,
                        forceCurrency: forceCurrency,
                        hasStudentPlan: hasStudentPlan,
                        dynamicAssetParam: dynamicAssetParam,
                        activePagePath: activePagePath,
                        activeOriginalPagePath: activeOriginalPagePath,
                        useSectionsMenu: useSectionsMenu,
                        is404Page: is404Page,
                        isPricingPage: isPricingPage,
                        testTypeformContactSales: testTypeformContactSales,
                        forceTypeformContactSalesExperience: forceTypeformContactSalesExperience,
                        sendToSignupWithProductPage: sendToSignupWithProductPage,
                        isSecondaryMenuNeeded: isSecondaryMenuNeeded,
                        contactSalesTestMode: contactSalesTestMode,
                        addLiveBoardExperience: addLiveBoardExperience,
                        openLiveBoard: this.openLiveBoard,
                        showLiveBoardImage: showLiveBoardImage,
                        liveBoardClosed: liveBoardClosed,
                        forceProductSignup: forceProductSignup,
                        getMobileSoftSignup: getMobileSoftSignup,
                        useNewTypeformUSVariant: useNewTypeformUSVariant,
                        isV13PricingVersion: isV13PricingVersion,
                        setIsFirstFoldVisible: this.setIsFirstFoldVisible,
                        setStartShowingContactSalesButton: this.setStartShowingContactSalesButton,
                        isInContactSalesNoHeaderTest: isInContactSalesNoHeaderTest,
                        simulateContactSalesButtonInTheFooter: simulateContactSalesButtonInTheFooter,
                        simulateSwitcherForExistingUsers: simulateSwitcherForExistingUsers,
                        hideContactSalesInFooter: hideContactSalesInFooter
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ab_tests_context/* AbTestsContext.Provider */.s.Provider, {
                        value: {
                            abTestVariants: abTestVariants,
                            abTestExactEventName: abTestExactEventName
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(careers_context/* CareersProvider */.U, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(utils_react/* ConditionalWrapper */.M, {
                                condition: shouldGetSignupPrefetchedAssets,
                                wrapper: function(children) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(PrefetchSignupAssetsProvider, {
                                        signupDynamicAssetsLinks: signupDynamicAssetsLinks,
                                        children: children
                                    });
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(utils_react/* ConditionalWrapper */.M, {
                                    condition: shouldGetTypeformPrefetchedAssets,
                                    wrapper: function(children) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(PrefetchTypeformAssetsProvider, base_template_object_spread_props(base_template_object_spread({}, prefetchTypeformAssetsProviderProps), {
                                            children: children
                                        }));
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(utils_react/* ConditionalWrapper */.M, {
                                        condition: addLiveBoardExperience,
                                        wrapper: function(children) {
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(PrefetchLiveBoardAssetsProvider, {
                                                children: children
                                            });
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(core_head, {
                                                    title: title,
                                                    description: description,
                                                    canonicalUrl: canonicalUrl,
                                                    seoFAQ: seoFAQ,
                                                    fontLazyLoad: fontLazyLoad,
                                                    template: template,
                                                    disableGTM: disableGTM,
                                                    gtmContainerId: gtmContainerId,
                                                    isMobileOrTabletBrowser: isMobileOrTabletBrowser,
                                                    pagePath: asPath,
                                                    facebookMetaOverride: facebookMetaOverride,
                                                    twitterMetaOverride: twitterMetaOverride,
                                                    localizedPages: localizedPages,
                                                    shouldGetSignupPrefetchedAssets: shouldGetSignupPrefetchedAssets,
                                                    shouldGetTypeformPrefetchedAssets: shouldGetTypeformPrefetchedAssets,
                                                    addLiveBoardExperience: addLiveBoardExperience,
                                                    preloadFirstFoldImages: preloadFirstFoldImages
                                                }),
                                                showHeaderScripts && /*#__PURE__*/ (0,jsx_runtime.jsx)(header_scripts_component, {
                                                    coupon: coupon,
                                                    extendTrialCookie: extendTrialCookie,
                                                    marketingTemplateBoardIds: marketingTemplateBoardIds,
                                                    clusterId: clusterId,
                                                    subClusterId: subClusterId,
                                                    clusterIdSource: clusterIdSource,
                                                    subClusterIdSource: subClusterIdSource,
                                                    localeId: localeId,
                                                    template: template,
                                                    skipClustersQuestion: skipClustersQuestion,
                                                    enablePageUsageDurationTracking: enablePageUsageDurationTracking,
                                                    customHeadScript: customHeadScript,
                                                    segmentsList: extractTypes(segments)
                                                }),
                                                showScrollToTop && /*#__PURE__*/ (0,jsx_runtime.jsx)(scroll_to_top, {}),
                                                !isPreview && /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledAccessibilityWrapper, {
                                                    className: "accessibility-menu-wrapper",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(bypass_block_menu, {})
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledTemplateContentWrapper, {
                                                    className: classnames_default()("template-content-wrapper", {
                                                        "with-background-color": !!pageBackgroundColorName
                                                    }),
                                                    children: [
                                                        children,
                                                        addLiveBoardExperience && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: "live-board-popup-wrapper",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(live_board_modal, base_template_object_spread({
                                                                    showLiveBoard: showLiveBoard,
                                                                    closeLiveBoard: this.closeLiveBoard,
                                                                    translate: this.translate,
                                                                    openPeekToBoard: this.openPeekToBoard,
                                                                    closePeekToBoard: this.closePeekToBoard,
                                                                    embeddedBoardLink: embeddedBoardLink
                                                                }, liveBoardProps))
                                                            })
                                                        })
                                                    ]
                                                }),
                                                showHeaderScripts && /*#__PURE__*/ (0,jsx_runtime.jsx)(body_scripts_component, {
                                                    withFullstory: withFullstory,
                                                    fullstoryRecordingFrequency: fullstoryRecordingFrequency,
                                                    showTrustpilotReviews: showTrustpilotReviews,
                                                    pagePath: asPath,
                                                    fontLazyLoad: fontLazyLoad,
                                                    template: template,
                                                    disableGTM: disableGTM,
                                                    gtmContainerId: gtmContainerId,
                                                    enableHotjar: enableHotjar,
                                                    hotjarFinalDate: hotjarFinalDate,
                                                    clusterId: clusterId,
                                                    hasFreeTier: hasFreeTier,
                                                    localeId: localeId,
                                                    subClusterId: subClusterId,
                                                    isMobileOrTabletBrowser: isMobileOrTabletBrowser,
                                                    is404Page: is404Page,
                                                    customBodyScript: customBodyScript
                                                })
                                            ]
                                        })
                                    })
                                })
                            })
                        })
                    })
                });
            }
        }
    ]);
    return BaseTemplate;
}(react.PureComponent);

BaseTemplate.defaultProps = {
    showHeaderScripts: true,
    withFullstory: false,
    useExpandingSignup: false,
    translations: {},
    isPreview: false,
    skipClustersQuestion: false
};


/***/ }),

/***/ 79409:
/***/ (function(module) {


var ALIGN_TYPES = {
    LEFT: "left",
    CENTER: "center",
    RIGHT: "right"
};
var ALIGN_LABELS = {
    LEFT: "Left",
    CENTER: "Center",
    RIGHT: "Right"
};
module.exports = {
    ALIGN_TYPES: ALIGN_TYPES,
    ALIGN_LABELS: ALIGN_LABELS
};


/***/ }),

/***/ 31766:
/***/ (function(module, exports, __webpack_require__) {


Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _defineProperty = (__webpack_require__(79361)["default"]);
var MAIN_COUNTRY_CODES = (__webpack_require__(85010).MAIN_COUNTRY_CODES);
// ** FORM IDS **
var TYPEFORM_CONTACT_SALES_EMEA_SALES_AND_PARTNERS_FORM_ID = "Rb9pva6n";
var TYPEFORM_CONTACT_SALES_EMEA_SALES_ONLY_FORM_ID = "PlrwsC4F";
var TYPEFORM_CONTACT_SALES_EMEA_GERMAN_FORM_ID = "onptOGWz";
var TYPEFORM_CONTACT_SALES_FRENCH_FORM_ID = "B91EZP5w";
var TYPEFORM_CONTACT_SALES_PORTUGEESE_NO_SDR_FORM_ID = "fcCPz0Z1";
var TYPEFORM_CONTACT_SALES_SPANISH_NO_SDR_FORM_ID = "MCW2vdfv";
var TYPEFORM_CONTACT_SALES_ANZ_REGION_FORM_ID = "WYNld7NX";
var TYPEFORM_CONTACT_SALES_AMERICA_REGION_FORM_ID = "Fl3WSnnm";
var TYPEFORM_CONTACT_SALES_NO_SDR_FORM_ID = "idXP35wo";
// used for AB tests only
var TYPEFORM_CONTACT_SALES_AMERICA_REGION_TEST_VARIANT_FORM_ID = "xp0et7IG";
// used for testing only
var TEST_TYPEFORM_CONTACT_SALES_FORM_ID = "Qi8VILCS";
// ** SALES GEOGRAPHIC REGIONS **
var EMEA_GEO_REGION = "EMEA";
var AUSTRALIA_NEW_ZEALAND_GEO_REGION = "ANZ";
var AMERICA_GEO_REGION = "AMERICA";
var LATAM_GEO_REGION = "LATAM";
var REST_OF_THE_WORLD_GEO_REGION = "REST_OF_THE_WORLD";
var TEST_GEO_REGION = "TEST";
// *****************************
// **** FORM REGION TYPES: *******
// EMEA
var EMEA_SALES_AND_PARTNERS_REGION_TYPE = "EMEA_SALES_AND_PARTNERS";
var EMEA_SALES_ONLY_REGION_TYPE = "EMEA_SALES_ONLY";
var EMEA_PARTNERS_ONLY_REGION_TYPE = "EMEA_PARTNERS_ONLY";
var EMEA_FRENCH_SALES_AND_PARTNERS_REGION_TYPE = "EMEA_FRENCH_SALES_AND_PARTNERS";
var PORTUGAL_NO_SDR_TYPE = "PORTUGAL_NO_SDR";
var BRAZIL_NO_SDR_TYPE = "BRAZIL_NO_SDR";
var SPAIN_NO_SDR_TYPE = "SPAIN_NO_SDR";
var EMEA_GERMAN_SALES_AND_PARTNERS_REGION_TYPE = "EMEA_GERMAN_SALES_AND_PARTNERS_REGION";
var LATAM_SPANISH_REGIONS_NO_SDR_TYPE = "LATAM_SPANISH_NO_SDR";
// ANZ
var AUSTRALIA_NZ_SALES_ONLY_TYPE = "ANZ_SALES_ONLY";
// AMERICA
var AMERICA_SALES_ONLY_TYPE = "AMERICA_SALES_ONLY";
// DEFAULT
var DEFAULT_NO_SDR_TYPE = "DEFAULT_NO_SDR";
// TEST
var TEST_REGION_TYPE = "TEST_SALES_ONLY";
var _obj;
// *****************************
var CONTACT_SALES_REGIONS = (_obj = {}, _defineProperty(_obj, EMEA_SALES_AND_PARTNERS_REGION_TYPE, {
    countries: [
        MAIN_COUNTRY_CODES.NETHERLANDS_ISO2,
        MAIN_COUNTRY_CODES.BELGIUM_ISO2,
        MAIN_COUNTRY_CODES.SWEDEN_ISO2,
        MAIN_COUNTRY_CODES.NORWAY_ISO2,
        MAIN_COUNTRY_CODES.DENMARK_ISO2,
        MAIN_COUNTRY_CODES.LUXEMBOURG_ISO2,
        MAIN_COUNTRY_CODES.ICELAND_ISO2,
        MAIN_COUNTRY_CODES.FINLAND_ISO2
    ],
    formId: TYPEFORM_CONTACT_SALES_EMEA_SALES_AND_PARTNERS_FORM_ID,
    formType: EMEA_SALES_AND_PARTNERS_REGION_TYPE,
    region: EMEA_GEO_REGION,
    prefetchImages: [
        "https://images.typeform.com/images/Aw2xNHE6PiND/image/default",
        "https://images.typeform.com/images/Aw2xNHE6PiND/image/default-firstframe.png"
    ]
}), _defineProperty(_obj, EMEA_SALES_ONLY_REGION_TYPE, {
    countries: [
        MAIN_COUNTRY_CODES.UNITED_KINGDOM_ISO2,
        MAIN_COUNTRY_CODES.ISRAEL_ISO2,
        MAIN_COUNTRY_CODES.IRELAND_ISO2
    ],
    formId: TYPEFORM_CONTACT_SALES_EMEA_SALES_ONLY_FORM_ID,
    formType: EMEA_SALES_ONLY_REGION_TYPE,
    region: EMEA_GEO_REGION,
    prefetchImages: [
        "https://images.typeform.com/images/zQ2kQjnuBzW3/image/default",
        "https://images.typeform.com/images/zQ2kQjnuBzW3/image/default-firstframe.png"
    ]
}), _defineProperty(_obj, EMEA_GERMAN_SALES_AND_PARTNERS_REGION_TYPE, {
    countries: [
        MAIN_COUNTRY_CODES.GERMANY_ISO2,
        MAIN_COUNTRY_CODES.SWITZERLAND_ISO2,
        MAIN_COUNTRY_CODES.AUSTRIA_ISO2
    ],
    formId: TYPEFORM_CONTACT_SALES_EMEA_GERMAN_FORM_ID,
    formType: EMEA_GERMAN_SALES_AND_PARTNERS_REGION_TYPE,
    region: EMEA_GEO_REGION,
    prefetchImages: [
        "https://images.typeform.com/images/Jue6uWpkSzyq/image/default",
        "https://images.typeform.com/images/Jue6uWpkSzyq/image/default-firstframe.png"
    ]
}), _defineProperty(_obj, EMEA_PARTNERS_ONLY_REGION_TYPE, {
    // Can be removed and merged with DEFAULT_NO_SDR_TYPE once we release to entire world
    countries: [
        MAIN_COUNTRY_CODES.ARMENIA_ISO2,
        MAIN_COUNTRY_CODES.AZERBAIJAN_ISO2,
        MAIN_COUNTRY_CODES.BAHRAIN_ISO2,
        MAIN_COUNTRY_CODES.BELARUS_ISO2,
        MAIN_COUNTRY_CODES.BULGARIA_ISO2,
        MAIN_COUNTRY_CODES.CROATIA_ISO2,
        MAIN_COUNTRY_CODES.CYPRUS_ISO2,
        MAIN_COUNTRY_CODES.CZECHIA_ISO2,
        MAIN_COUNTRY_CODES.EGYPT_ISO2,
        MAIN_COUNTRY_CODES.ESTONIA_ISO2,
        MAIN_COUNTRY_CODES.GEORGIA_ISO2,
        MAIN_COUNTRY_CODES.GREECE_ISO2,
        MAIN_COUNTRY_CODES.HUNGARY_ISO2,
        MAIN_COUNTRY_CODES.ITALY_ISO2,
        MAIN_COUNTRY_CODES.KAZAKHSTAN_ISO2,
        MAIN_COUNTRY_CODES.KENYA_ISO2,
        MAIN_COUNTRY_CODES.KUWAIT_ISO2,
        MAIN_COUNTRY_CODES.LATVIA_ISO2,
        MAIN_COUNTRY_CODES.LITHUANIA_ISO2,
        MAIN_COUNTRY_CODES.MAURITIUS_ISO2,
        MAIN_COUNTRY_CODES.MOZAMBIQUE_ISO2,
        MAIN_COUNTRY_CODES.NIGERIA_ISO2,
        MAIN_COUNTRY_CODES.OMAN_ISO2,
        MAIN_COUNTRY_CODES.POLAND_ISO2,
        MAIN_COUNTRY_CODES.QATAR_ISO2,
        MAIN_COUNTRY_CODES.ROMANIA_ISO2,
        MAIN_COUNTRY_CODES.RUSSIA_ISO2,
        MAIN_COUNTRY_CODES.RWANDA_ISO2,
        MAIN_COUNTRY_CODES.SAUDI_ARABIA_ISO2,
        MAIN_COUNTRY_CODES.SLOVAKIA_ISO2,
        MAIN_COUNTRY_CODES.SLOVENIA_ISO2,
        MAIN_COUNTRY_CODES.SOUTH_AFRICA_ISO2,
        MAIN_COUNTRY_CODES.SOUTH_SUDAN_ISO2,
        MAIN_COUNTRY_CODES.TANZANIA_ISO2,
        MAIN_COUNTRY_CODES.TURKEY_ISO2,
        MAIN_COUNTRY_CODES.UGANDA_ISO2,
        MAIN_COUNTRY_CODES.UKRAINE_ISO2,
        MAIN_COUNTRY_CODES.UNITED_ARAB_EMIRATES_ISO2,
        MAIN_COUNTRY_CODES.UZBEKISTAN_ISO2
    ],
    formId: TYPEFORM_CONTACT_SALES_NO_SDR_FORM_ID,
    formType: EMEA_PARTNERS_ONLY_REGION_TYPE,
    region: EMEA_GEO_REGION,
    prefetchImages: [
        "https://images.typeform.com/images/2YTm6WS6wcLe/image/default",
        "https://images.typeform.com/images/2YTm6WS6wcLe/image/default-firstframe.png"
    ]
}), _defineProperty(_obj, EMEA_FRENCH_SALES_AND_PARTNERS_REGION_TYPE, {
    countries: [
        MAIN_COUNTRY_CODES.FRANCE_ISO2
    ],
    formId: TYPEFORM_CONTACT_SALES_FRENCH_FORM_ID,
    formType: EMEA_FRENCH_SALES_AND_PARTNERS_REGION_TYPE,
    region: EMEA_GEO_REGION,
    prefetchImages: [
        "https://images.typeform.com/images/rZDcCEwqLVtd/image/default",
        "https://images.typeform.com/images/rZDcCEwqLVtd/image/default-firstframe.png"
    ]
}), _defineProperty(_obj, AUSTRALIA_NZ_SALES_ONLY_TYPE, {
    countries: [
        MAIN_COUNTRY_CODES.AUSTRALIA_ISO2,
        MAIN_COUNTRY_CODES.NEW_ZEALAND_ISO2
    ],
    formId: TYPEFORM_CONTACT_SALES_ANZ_REGION_FORM_ID,
    formType: AUSTRALIA_NZ_SALES_ONLY_TYPE,
    region: AUSTRALIA_NEW_ZEALAND_GEO_REGION,
    prefetchImages: [
        "https://images.typeform.com/images/2wA8X5swymX2/image/default",
        "https://images.typeform.com/images/2wA8X5swymX2/image/default-firstframe.png"
    ]
}), _defineProperty(_obj, AMERICA_SALES_ONLY_TYPE, {
    countries: [
        MAIN_COUNTRY_CODES.UNITED_STATES_ISO2,
        MAIN_COUNTRY_CODES.CANADA_ISO2
    ],
    formId: TYPEFORM_CONTACT_SALES_AMERICA_REGION_FORM_ID,
    formType: AMERICA_SALES_ONLY_TYPE,
    region: AMERICA_GEO_REGION,
    prefetchImages: [
        "https://images.typeform.com/images/KCQAM5ifzaty/image/default",
        "https://images.typeform.com/images/KCQAM5ifzaty/image/default-firstframe.png"
    ],
    // Test variant
    variantFormId: TYPEFORM_CONTACT_SALES_AMERICA_REGION_TEST_VARIANT_FORM_ID,
    variantPrefetchImages: [
        "https://images.typeform.com/images/uJRuZPNTVcVz/image/default",
        "https://images.typeform.com/images/uJRuZPNTVcVz/image/default-firstframe.png"
    ]
}), _defineProperty(_obj, PORTUGAL_NO_SDR_TYPE, {
    countries: [
        MAIN_COUNTRY_CODES.PORTUGAL_ISO2
    ],
    formId: TYPEFORM_CONTACT_SALES_PORTUGEESE_NO_SDR_FORM_ID,
    formType: PORTUGAL_NO_SDR_TYPE,
    region: EMEA_GEO_REGION,
    prefetchImages: [
        "https://images.typeform.com/images/6NuLbnPVhJxy/image/default",
        "https://images.typeform.com/images/6NuLbnPVhJxy/image/default-firstframe.png"
    ]
}), _defineProperty(_obj, BRAZIL_NO_SDR_TYPE, {
    countries: [
        MAIN_COUNTRY_CODES.BRAZIL_ISO2
    ],
    formId: TYPEFORM_CONTACT_SALES_PORTUGEESE_NO_SDR_FORM_ID,
    formType: BRAZIL_NO_SDR_TYPE,
    region: LATAM_GEO_REGION,
    prefetchImages: [
        "https://images.typeform.com/images/6NuLbnPVhJxy/image/default",
        "https://images.typeform.com/images/6NuLbnPVhJxy/image/default-firstframe.png"
    ]
}), _defineProperty(_obj, SPAIN_NO_SDR_TYPE, {
    countries: [
        MAIN_COUNTRY_CODES.SPAIN_ISO2
    ],
    formId: TYPEFORM_CONTACT_SALES_SPANISH_NO_SDR_FORM_ID,
    formType: SPAIN_NO_SDR_TYPE,
    region: EMEA_GEO_REGION,
    prefetchImages: [
        "https://images.typeform.com/images/FV6CXnihkcXG/image/default",
        "https://images.typeform.com/images/FV6CXnihkcXG/image/default-firstframe.png"
    ]
}), _defineProperty(_obj, LATAM_SPANISH_REGIONS_NO_SDR_TYPE, {
    countries: [
        MAIN_COUNTRY_CODES.MEXICO_ISO2,
        MAIN_COUNTRY_CODES.COSTA_RICA_ISO2,
        MAIN_COUNTRY_CODES.EL_SALVADOR_ISO2,
        MAIN_COUNTRY_CODES.GUATEMALA_ISO2,
        MAIN_COUNTRY_CODES.HONDURAS_ISO2,
        MAIN_COUNTRY_CODES.NICARAGUA_ISO2,
        MAIN_COUNTRY_CODES.PANAMA_ISO2,
        MAIN_COUNTRY_CODES.CUBA_ISO2,
        MAIN_COUNTRY_CODES.DOMINICAN_REPUBLIC_ISO2,
        MAIN_COUNTRY_CODES.PUERTO_RICO_ISO2,
        MAIN_COUNTRY_CODES.ARGENTINA_ISO2,
        MAIN_COUNTRY_CODES.BOLIVIA_ISO2,
        MAIN_COUNTRY_CODES.CHILE_ISO2,
        MAIN_COUNTRY_CODES.COLUMBIA_ISO2,
        MAIN_COUNTRY_CODES.ECUADOR_ISO2,
        MAIN_COUNTRY_CODES.PARAGUAY_ISO2,
        MAIN_COUNTRY_CODES.PERU_ISO2,
        MAIN_COUNTRY_CODES.URUGUAY_ISO2,
        MAIN_COUNTRY_CODES.VENEZUELA_ISO2,
        MAIN_COUNTRY_CODES.EQUATORIAL_GUINEA_ISO2
    ],
    formId: TYPEFORM_CONTACT_SALES_SPANISH_NO_SDR_FORM_ID,
    formType: LATAM_SPANISH_REGIONS_NO_SDR_TYPE,
    region: LATAM_GEO_REGION,
    prefetchImages: [
        "https://images.typeform.com/images/FV6CXnihkcXG/image/default",
        "https://images.typeform.com/images/FV6CXnihkcXG/image/default-firstframe.png"
    ]
}), _defineProperty(_obj, DEFAULT_NO_SDR_TYPE, {
    countries: [],
    formId: TYPEFORM_CONTACT_SALES_NO_SDR_FORM_ID,
    formType: DEFAULT_NO_SDR_TYPE,
    region: REST_OF_THE_WORLD_GEO_REGION,
    excludeCountries: [
        MAIN_COUNTRY_CODES.JAPAN_ISO2
    ],
    prefetchImages: [
        "https://images.typeform.com/images/2YTm6WS6wcLe/image/default",
        "https://images.typeform.com/images/2YTm6WS6wcLe/image/default-firstframe.png"
    ]
}), _defineProperty(_obj, TEST_REGION_TYPE, {
    countries: [],
    formId: TEST_TYPEFORM_CONTACT_SALES_FORM_ID,
    formType: TEST_REGION_TYPE,
    region: TEST_GEO_REGION,
    prefetchImages: []
}), _obj);
module.exports = {
    CONTACT_SALES_REGIONS: CONTACT_SALES_REGIONS
};


/***/ }),

/***/ 53219:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D": function() { return /* binding */ FOOTER_ID; },
/* harmony export */   "k": function() { return /* binding */ MAIN_ID; }
/* harmony export */ });
var MAIN_ID = "main";
var FOOTER_ID = "footer";


/***/ }),

/***/ 42349:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$D": function() { return /* binding */ TIERS_STICKY_HEADER_OFFSET; },
/* harmony export */   "I$": function() { return /* binding */ TIER_CARD_PRICE_HEIGHT; },
/* harmony export */   "TR": function() { return /* binding */ CLEAN_FIRST_FOLD_MARGIN; },
/* harmony export */   "Ww": function() { return /* binding */ TIER_CARD_VIDEO_WIDTH; },
/* harmony export */   "ld": function() { return /* binding */ TIERS_STICKY_HEADER_BORDER_OFFSET; },
/* harmony export */   "m6": function() { return /* binding */ TIER_CARD_VIDEO_HEIGHT; },
/* harmony export */   "pP": function() { return /* binding */ PLANS_COMPONENT_WIDTH; }
/* harmony export */ });
/* unused harmony exports PLANS_HEADERS_OFFSET, FREE_TIER_PRICE_HEIGHT */
var HEADER_HEIGHT = 72;
var PLANS_HEADERS_OFFSET = (/* unused pure expression or super */ null && (HEADER_HEIGHT));
var TIERS_STICKY_HEADER_OFFSET = HEADER_HEIGHT;
var TIERS_STICKY_HEADER_BORDER_OFFSET = 107; // sticky header height (82) + first title height (25)
var PLANS_COMPONENT_WIDTH = 1225;
var TIER_CARD_PRICE_HEIGHT = 128;
var FREE_TIER_PRICE_HEIGHT = 142;
var TIER_CARD_VIDEO_WIDTH = 422;
var TIER_CARD_VIDEO_HEIGHT = 284;
var CLEAN_FIRST_FOLD_MARGIN = "10%";


/***/ }),

/***/ 78803:
/***/ (function(module) {


var VERSION_9 = "9";
var VERSION_10 = "10";
var VERSION_11 = "11";
var VERSION_12 = "12";
var VERSION_13 = "13";
var DEFAULT_VERSION = VERSION_13;
var ALLOWED_VERSIONS = [
    VERSION_9,
    VERSION_10,
    VERSION_11,
    VERSION_12,
    VERSION_13
];
module.exports = {
    VERSION_9: VERSION_9,
    VERSION_10: VERSION_10,
    VERSION_11: VERSION_11,
    VERSION_12: VERSION_12,
    VERSION_13: VERSION_13,
    DEFAULT_VERSION: DEFAULT_VERSION,
    ALLOWED_VERSIONS: ALLOWED_VERSIONS
};


/***/ }),

/***/ 55674:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F3": function() { return /* binding */ FREE_TIER_2021_SEATS_LIMIT; },
/* harmony export */   "F_": function() { return /* binding */ NUM_DEFAULT_DISPLAYED_PLANS; },
/* harmony export */   "Iy": function() { return /* binding */ TIERS; },
/* harmony export */   "Jb": function() { return /* binding */ PERIOD_TEXTS; },
/* harmony export */   "U1": function() { return /* binding */ FEATURES_IDS; },
/* harmony export */   "Us": function() { return /* binding */ PLAN_INFO_SEGMENT_NAME; },
/* harmony export */   "ck": function() { return /* binding */ SUPPORTED_CURRENCIES; },
/* harmony export */   "fY": function() { return /* binding */ MAX_TEAM_SIZE; },
/* harmony export */   "no": function() { return /* binding */ FREE_TIER_2022_SEATS_LIMIT; },
/* harmony export */   "yv": function() { return /* binding */ ORDERED_PERIOD_NAMES; },
/* harmony export */   "z5": function() { return /* binding */ PERIODS; }
/* harmony export */ });
/* unused harmony exports PLATFORM_PERIODS, STANDARD_DASHBOARDS_AMOUNT, PRO_DASHBOARDS_AMOUNT */
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(14924);

var TIERS = {
    FREE: "free",
    BASIC: "basic",
    STANDARD: "standard",
    PRO: "pro",
    ENTERPRISE: "enterprise"
};
var PERIODS = {
    yearly: "yearly",
    monthly: "monthly"
};
var _obj;
var PLATFORM_PERIODS = (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj, PERIODS.yearly, "YearlyPlan"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj, PERIODS.monthly, "MonthlyPlan"), _obj);
var _obj1;
var PERIOD_TEXTS = (_obj1 = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj1, PERIODS.yearly, {
    billed: "pricingPage.periods.yearly.billed",
    displayName: "pricingPage.periods.yearly.displayName"
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj1, PERIODS.monthly, {
    billed: "pricingPage.periods.monthly.billed",
    displayName: "pricingPage.periods.monthly.displayName"
}), _obj1);
var FEATURES_IDS = {
    STORAGE: "STORAGE"
};
var PLAN_INFO_SEGMENT_NAME = "PlanInfo";
var MAX_TEAM_SIZE = "200+";
var ORDERED_PERIOD_NAMES = [
    PERIODS.yearly,
    PERIODS.monthly
];
var STANDARD_DASHBOARDS_AMOUNT = 3;
var PRO_DASHBOARDS_AMOUNT = 10;
var NUM_DEFAULT_DISPLAYED_PLANS = 4;
var FREE_TIER_2021_SEATS_LIMIT = 2;
var FREE_TIER_2022_SEATS_LIMIT = 5;
var SUPPORTED_CURRENCIES = [
    {
        name: "usd",
        currencySign: "$",
        currencyShortText: "USD",
        shouldDisplayText: true
    },
    {
        name: "euro",
        currencySign: "€",
        currencyShortText: "EUR",
        shouldDisplayText: false
    },
    {
        name: "cad",
        currencySign: "$",
        currencyShortText: "CAD",
        shouldDisplayText: true
    },
    {
        name: "gbp",
        currencySign: "\xa3",
        currencyShortText: "GBP",
        shouldDisplayText: false
    },
    {
        name: "aud",
        currencySign: "$",
        currencyShortText: "AUD",
        shouldDisplayText: true
    },
    {
        name: "mxn",
        currencySign: "$",
        currencyShortText: "MXN",
        shouldDisplayText: true
    },
    {
        name: "brl",
        currencySign: "R$",
        currencyShortText: "BRL",
        shouldDisplayText: false
    },
    {
        name: "inr",
        currencySign: "₹",
        currencyShortText: "INR",
        shouldDisplayText: false
    },
    {
        name: "jpy",
        currencySign: "\xa5",
        currencyShortText: "JPY",
        shouldDisplayText: false
    }
];


/***/ }),

/***/ 61980:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ACCOUNT_PERMISSIONS": function() { return /* binding */ ACCOUNT_PERMISSIONS; },
  "ACTIVITY_LOG": function() { return /* binding */ ACTIVITY_LOG; },
  "ADVANCED_COLUMN_TYPES": function() { return /* binding */ ADVANCED_COLUMN_TYPES; },
  "ADVANCED_CUSTOMER_PROJECT_MANAGEMENT": function() { return /* binding */ ADVANCED_CUSTOMER_PROJECT_MANAGEMENT; },
  "APPROVED_GUEST": function() { return /* binding */ APPROVED_GUEST; },
  "AUDIT_LOG": function() { return /* binding */ AUDIT_LOG; },
  "AUTOMATIONS": function() { return /* binding */ AUTOMATIONS; },
  "BLOCK_DOMAINS": function() { return /* binding */ BLOCK_DOMAINS; },
  "BOARDS": function() { return /* binding */ BOARDS; },
  "BOARD_ADMINISTRATORS": function() { return /* binding */ features_BOARD_ADMINISTRATORS; },
  "CALENDAR": function() { return /* binding */ features_CALENDAR; },
  "CHART_VIEW": function() { return /* binding */ CHART_VIEW; },
  "COLLABORATIVE_WHITEBOARD": function() { return /* binding */ COLLABORATIVE_WHITEBOARD; },
  "COLUMN_TYPES": function() { return /* binding */ COLUMN_TYPES; },
  "COMMISSION_MANAGEMENT": function() { return /* binding */ COMMISSION_MANAGEMENT; },
  "COMMUNICATION_WITH_CONTEXT": function() { return /* binding */ COMMUNICATION_WITH_CONTEXT; },
  "CONTENT_DIRECTORY": function() { return /* binding */ CONTENT_DIRECTORY; },
  "CS_MANAGER": function() { return /* binding */ CS_MANAGER; },
  "CUSTOMER_PROJECT_MANAGEMENT": function() { return /* binding */ CUSTOMER_PROJECT_MANAGEMENT; },
  "CUSTOMIZABLE_NOTIFICATIONS": function() { return /* binding */ CUSTOMIZABLE_NOTIFICATIONS; },
  "CUSTOMIZABLE_SALES_PROCESS": function() { return /* binding */ CUSTOMIZABLE_SALES_PROCESS; },
  "CUSTOM_DASHBOARDS": function() { return /* binding */ CUSTOM_DASHBOARDS; },
  "CUSTOM_ROLES": function() { return /* binding */ CUSTOM_ROLES; },
  "DAILY_REPORTS": function() { return /* binding */ DAILY_REPORTS; },
  "DASHBOARDS": function() { return /* binding */ features_DASHBOARDS; },
  "DEADLINE_MANAGEMENT": function() { return /* binding */ DEADLINE_MANAGEMENT; },
  "DEPENDENCY_COLUMN": function() { return /* binding */ DEPENDENCY_COLUMN; },
  "EMAIL_SUPPORT": function() { return /* binding */ EMAIL_SUPPORT; },
  "EMBEDDED_BOARD": function() { return /* binding */ EMBEDDED_BOARD; },
  "EMBED_DOCUMENTS_AND_BRIEFS": function() { return /* binding */ EMBED_DOCUMENTS_AND_BRIEFS; },
  "FILES_MANAGEMENT": function() { return /* binding */ FILES_MANAGEMENT; },
  "FORMS": function() { return /* binding */ features_FORMS; },
  "FORMS_CUSTOMIZATION": function() { return /* binding */ FORMS_CUSTOMIZATION; },
  "FORMULA": function() { return /* binding */ FORMULA; },
  "GOOGLE": function() { return /* binding */ GOOGLE; },
  "GUESTS": function() { return /* binding */ features_GUESTS; },
  "HIPAA": function() { return /* binding */ HIPAA; },
  "IMPORT_EXPORT_EXCEL": function() { return /* binding */ IMPORT_EXPORT_EXCEL; },
  "IMPORT_FROM_OTHER_TOOLS": function() { return /* binding */ IMPORT_FROM_OTHER_TOOLS; },
  "INTEGRATIONS": function() { return /* binding */ features_INTEGRATIONS; },
  "INTEGRATIONS_WITH_GMAIL_AND_OUTLOOK": function() { return /* binding */ INTEGRATIONS_WITH_GMAIL_AND_OUTLOOK; },
  "INTEGRATION_PERMISSIONS": function() { return /* binding */ INTEGRATION_PERMISSIONS; },
  "IP_RESTRICTIONS": function() { return /* binding */ IP_RESTRICTIONS; },
  "ITEMS": function() { return /* binding */ ITEMS; },
  "KANBAN_VIEW": function() { return /* binding */ KANBAN_VIEW; },
  "KNOWLEDGE_BASE": function() { return /* binding */ KNOWLEDGE_BASE; },
  "LEAD_ASSIGNMENT": function() { return /* binding */ LEAD_ASSIGNMENT; },
  "MAP": function() { return /* binding */ MAP; },
  "MARKETING_CALENDAR": function() { return /* binding */ MARKETING_CALENDAR; },
  "MARKETING_DASHBOARDS": function() { return /* binding */ MARKETING_DASHBOARDS; },
  "MARKETING_INTEGRATIONS": function() { return /* binding */ MARKETING_INTEGRATIONS; },
  "MARKETING_REQUESTS_WITH_FORMS": function() { return /* binding */ MARKETING_REQUESTS_WITH_FORMS; },
  "MAXIMUM_SEATS": function() { return /* binding */ MAXIMUM_SEATS; },
  "MOBILE": function() { return /* binding */ MOBILE; },
  "PANIC_MODE": function() { return /* binding */ features_PANIC_MODE; },
  "PIVOT_ANALYSIS": function() { return /* binding */ PIVOT_ANALYSIS; },
  "PREMIUM_INTEGRATIONS": function() { return /* binding */ PREMIUM_INTEGRATIONS; },
  "PRIVATE_BOARDS": function() { return /* binding */ PRIVATE_BOARDS; },
  "PRIVATE_WORKSPACES": function() { return /* binding */ PRIVATE_WORKSPACES; },
  "READY_MADE_MARKETING_TEMPLATES": function() { return /* binding */ READY_MADE_MARKETING_TEMPLATES; },
  "SALESFORCE_INTEGRATION": function() { return /* binding */ SALESFORCE_INTEGRATION; },
  "SAML": function() { return /* binding */ SAML; },
  "SCHEDULED_DASHBOARD_DELIVERY": function() { return /* binding */ SCHEDULED_DASHBOARD_DELIVERY; },
  "SCIM": function() { return /* binding */ SCIM; },
  "SEARCH": function() { return /* binding */ SEARCH; },
  "SEATS_MANAGEMENT": function() { return /* binding */ SEATS_MANAGEMENT; },
  "SESSIONS": function() { return /* binding */ SESSIONS; },
  "SHARE_BOARD_WITH_EXTERNAL_GUESTS": function() { return /* binding */ SHARE_BOARD_WITH_EXTERNAL_GUESTS; },
  "SLA": function() { return /* binding */ SLA; },
  "SOC": function() { return /* binding */ SOC; },
  "STORAGE": function() { return /* binding */ STORAGE; },
  "TAGS": function() { return /* binding */ TAGS; },
  "TAILORED_ONBOARDING": function() { return /* binding */ TAILORED_ONBOARDING; },
  "TEAMS_INSIDE_TEAMS": function() { return /* binding */ TEAMS_INSIDE_TEAMS; },
  "TEMPLATES": function() { return /* binding */ TEMPLATES; },
  "TENANT_RESTRICTIONS": function() { return /* binding */ TENANT_RESTRICTIONS; },
  "TIMELINE": function() { return /* binding */ TIMELINE; },
  "TIME_TRACKING": function() { return /* binding */ TIME_TRACKING; },
  "TWO_FA": function() { return /* binding */ TWO_FA; },
  "TWO_WAY_EMAIL_SYNC": function() { return /* binding */ TWO_WAY_EMAIL_SYNC; },
  "UNLIMITED_BOARDS": function() { return /* binding */ UNLIMITED_BOARDS; },
  "UNLIMITED_BOARDS_WITH_FREE_TIER": function() { return /* binding */ UNLIMITED_BOARDS_WITH_FREE_TIER; },
  "UNLIMITED_DOCS": function() { return /* binding */ UNLIMITED_DOCS; },
  "UNLIMITED_VIEWERS": function() { return /* binding */ UNLIMITED_VIEWERS; },
  "UPDATES_SECTION": function() { return /* binding */ UPDATES_SECTION; },
  "VIEWERS": function() { return /* binding */ VIEWERS; },
  "WEBINARS": function() { return /* binding */ WEBINARS; },
  "WEB_TO_LEAD_CAPTURING": function() { return /* binding */ WEB_TO_LEAD_CAPTURING; },
  "WHITEBOARD": function() { return /* binding */ features_WHITEBOARD; },
  "WORKLOAD": function() { return /* binding */ WORKLOAD; },
  "WORK_PERFORMANCE_INSIGHTS": function() { return /* binding */ WORK_PERFORMANCE_INSIGHTS; },
  "ZOOM_INTEGRATION": function() { return /* binding */ ZOOM_INTEGRATION; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./constants/pricing.js
var pricing = __webpack_require__(55674);
// EXTERNAL MODULE: ./constants/cookies.js
var constants_cookies = __webpack_require__(13019);
;// CONCATENATED MODULE: ./constants/free-tier.js
var ITEM_RESOURCE_CREDIT_FOR_FREE_TIER = 200;
var USER_RESOURCE_CREDIT_FOR_FREE_TIER = 2; // every visitor to the homepage gets the same value, regardless of free tier version.

// EXTERNAL MODULE: ./services/dom-utils-service.js
var dom_utils_service = __webpack_require__(44566);
// EXTERNAL MODULE: ./services/cookies-service.js
var cookies_service = __webpack_require__(67798);
;// CONCATENATED MODULE: ./services/ab-tests/free-tier-item-resource-credit-sync-service.js




var getItemResourceCreditCount = function(abTests, cookies) {
    var forcedItemResourceCreditFromPlatform = cookies[constants_cookies.MONDAY_FREE_TIER_ACCOUNT_CREATION_ITEM_RESOURCE_CREDIT_COOKIE_NAME];
    if (forcedItemResourceCreditFromPlatform) return parseInt(forcedItemResourceCreditFromPlatform);
    var resourceCreditAmount = ITEM_RESOURCE_CREDIT_FOR_FREE_TIER;
    if ((0,dom_utils_service.isRunningInClient)()) (0,cookies_service/* setCookie */.d8)(constants_cookies.HOMEPAGE_ACCOUNT_CREATION_ITEM_RESOURCE_CREDIT_COOKIE_NAME, resourceCreditAmount);
    return resourceCreditAmount;
};

// EXTERNAL MODULE: ./services/ab-tests/monetization-ab-tests-service.js + 2 modules
var monetization_ab_tests_service = __webpack_require__(46724);
;// CONCATENATED MODULE: ./constants/pricing/pricing-page/features/features_tiers.js


var _obj;
var GENERIC_ALL_TRUE = (_obj = {}, (0,_define_property/* default */.Z)(_obj, pricing/* TIERS.FREE */.Iy.FREE, {
    value: true
}), (0,_define_property/* default */.Z)(_obj, pricing/* TIERS.BASIC */.Iy.BASIC, {
    value: true
}), (0,_define_property/* default */.Z)(_obj, pricing/* TIERS.STANDARD */.Iy.STANDARD, {
    value: true
}), (0,_define_property/* default */.Z)(_obj, pricing/* TIERS.PRO */.Iy.PRO, {
    value: true
}), (0,_define_property/* default */.Z)(_obj, pricing/* TIERS.ENTERPRISE */.Iy.ENTERPRISE, {
    value: true
}), _obj);
var _obj1;
var ENTERPRISE_ONLY = (_obj1 = {}, (0,_define_property/* default */.Z)(_obj1, pricing/* TIERS.FREE */.Iy.FREE, {
    value: false
}), (0,_define_property/* default */.Z)(_obj1, pricing/* TIERS.BASIC */.Iy.BASIC, {
    value: false
}), (0,_define_property/* default */.Z)(_obj1, pricing/* TIERS.STANDARD */.Iy.STANDARD, {
    value: false
}), (0,_define_property/* default */.Z)(_obj1, pricing/* TIERS.PRO */.Iy.PRO, {
    value: false
}), (0,_define_property/* default */.Z)(_obj1, pricing/* TIERS.ENTERPRISE */.Iy.ENTERPRISE, {
    value: true
}), _obj1);
var WHITEBOARD = GENERIC_ALL_TRUE;
var _obj2;
var INTEGRATIONS = (_obj2 = {}, (0,_define_property/* default */.Z)(_obj2, pricing/* TIERS.FREE */.Iy.FREE, {
    value: false
}), (0,_define_property/* default */.Z)(_obj2, pricing/* TIERS.BASIC */.Iy.BASIC, {
    value: false
}), (0,_define_property/* default */.Z)(_obj2, pricing/* TIERS.STANDARD */.Iy.STANDARD, {
    value: "pricingPage.features.plans.integrations_standard"
}), (0,_define_property/* default */.Z)(_obj2, pricing/* TIERS.PRO */.Iy.PRO, {
    value: "pricingPage.features.plans.integrations_pro"
}), (0,_define_property/* default */.Z)(_obj2, pricing/* TIERS.ENTERPRISE */.Iy.ENTERPRISE, {
    value: "pricingPage.features.plans.integrations_enterprise"
}), _obj2);
var FORMS = GENERIC_ALL_TRUE;
var _obj3;
var GUESTS = (_obj3 = {}, (0,_define_property/* default */.Z)(_obj3, pricing/* TIERS.FREE */.Iy.FREE, {
    value: false
}), (0,_define_property/* default */.Z)(_obj3, pricing/* TIERS.BASIC */.Iy.BASIC, {
    value: false
}), (0,_define_property/* default */.Z)(_obj3, pricing/* TIERS.STANDARD */.Iy.STANDARD, {
    value: "pricingPage.features.plans.guests_four_one"
}), (0,_define_property/* default */.Z)(_obj3, pricing/* TIERS.PRO */.Iy.PRO, {
    value: "pricingPage.features.plans.unlimited"
}), (0,_define_property/* default */.Z)(_obj3, pricing/* TIERS.ENTERPRISE */.Iy.ENTERPRISE, {
    value: "pricingPage.features.plans.unlimited"
}), _obj3);
var _obj4;
var DASHBOARDS = (_obj4 = {}, (0,_define_property/* default */.Z)(_obj4, pricing/* TIERS.FREE */.Iy.FREE, {
    value: "pricingPage.features.plans.dashboards_basic"
}), (0,_define_property/* default */.Z)(_obj4, pricing/* TIERS.BASIC */.Iy.BASIC, {
    value: "pricingPage.features.plans.dashboards_basic"
}), (0,_define_property/* default */.Z)(_obj4, pricing/* TIERS.STANDARD */.Iy.STANDARD, {
    value: "pricingPage.features.plans.dashboards_standard"
}), (0,_define_property/* default */.Z)(_obj4, pricing/* TIERS.PRO */.Iy.PRO, {
    value: "pricingPage.features.plans.dashboards_pro"
}), (0,_define_property/* default */.Z)(_obj4, pricing/* TIERS.ENTERPRISE */.Iy.ENTERPRISE, {
    value: "pricingPage.features.plans.dashboards_enterprise"
}), _obj4);
var _obj5;
var CALENDAR = (_obj5 = {}, (0,_define_property/* default */.Z)(_obj5, pricing/* TIERS.FREE */.Iy.FREE, {
    value: false
}), (0,_define_property/* default */.Z)(_obj5, pricing/* TIERS.BASIC */.Iy.BASIC, {
    value: false
}), (0,_define_property/* default */.Z)(_obj5, pricing/* TIERS.STANDARD */.Iy.STANDARD, {
    value: true
}), (0,_define_property/* default */.Z)(_obj5, pricing/* TIERS.PRO */.Iy.PRO, {
    value: true
}), (0,_define_property/* default */.Z)(_obj5, pricing/* TIERS.ENTERPRISE */.Iy.ENTERPRISE, {
    value: true
}), _obj5);
var _obj6;
var SCHEDULED_DASHBOARD_DELIVVERY = (_obj6 = {}, (0,_define_property/* default */.Z)(_obj6, pricing/* TIERS.FREE */.Iy.FREE, {
    value: false
}), (0,_define_property/* default */.Z)(_obj6, pricing/* TIERS.BASIC */.Iy.BASIC, {
    value: false
}), (0,_define_property/* default */.Z)(_obj6, pricing/* TIERS.STANDARD */.Iy.STANDARD, {
    value: false
}), (0,_define_property/* default */.Z)(_obj6, pricing/* TIERS.PRO */.Iy.PRO, {
    value: false
}), (0,_define_property/* default */.Z)(_obj6, pricing/* TIERS.ENTERPRISE */.Iy.ENTERPRISE, {
    value: true
}), _obj6);
var _obj7;
var BOARD_ADMINISTRATORS = (_obj7 = {}, (0,_define_property/* default */.Z)(_obj7, pricing/* TIERS.FREE */.Iy.FREE, {
    value: false
}), (0,_define_property/* default */.Z)(_obj7, pricing/* TIERS.BASIC */.Iy.BASIC, {
    value: false
}), (0,_define_property/* default */.Z)(_obj7, pricing/* TIERS.STANDARD */.Iy.STANDARD, {
    value: false
}), (0,_define_property/* default */.Z)(_obj7, pricing/* TIERS.PRO */.Iy.PRO, {
    value: true
}), (0,_define_property/* default */.Z)(_obj7, pricing/* TIERS.ENTERPRISE */.Iy.ENTERPRISE, {
    value: true
}), _obj7);
var _obj8;
var PANIC_MODE = (_obj8 = {}, (0,_define_property/* default */.Z)(_obj8, pricing/* TIERS.FREE */.Iy.FREE, {
    value: false
}), (0,_define_property/* default */.Z)(_obj8, pricing/* TIERS.BASIC */.Iy.BASIC, {
    value: false
}), (0,_define_property/* default */.Z)(_obj8, pricing/* TIERS.STANDARD */.Iy.STANDARD, {
    value: false
}), (0,_define_property/* default */.Z)(_obj8, pricing/* TIERS.PRO */.Iy.PRO, {
    value: false
}), (0,_define_property/* default */.Z)(_obj8, pricing/* TIERS.ENTERPRISE */.Iy.ENTERPRISE, {
    value: true
}), _obj8);

// EXTERNAL MODULE: ./services/ab-tests/acquisition-ab-test-service.js
var acquisition_ab_test_service = __webpack_require__(77784);
;// CONCATENATED MODULE: ./constants/pricing/pricing-page/features/features.js

function _define_property1(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property1(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}





var FILES_MANAGEMENT = {
    name: "pricingPage.features.titles.filesManagement",
    description: "pricingPage.features.descriptions.filesManagement",
    tiers: GENERIC_ALL_TRUE
};
var LEAD_ASSIGNMENT = {
    name: "pricingPage.features.titles.leadAssignment",
    description: "pricingPage.features.descriptions.leadAssignment",
    tiers: GENERIC_ALL_TRUE
};
var CUSTOMIZABLE_SALES_PROCESS = {
    name: "pricingPage.features.titles.customizableSalesProcess",
    description: "pricingPage.features.descriptions.customizableSalesProcess",
    tiers: GENERIC_ALL_TRUE
};
var CUSTOMER_PROJECT_MANAGEMENT = {
    name: "pricingPage.features.titles.customerProjectManagement",
    description: "pricingPage.features.descriptions.customerProjectManagement",
    tiers: GENERIC_ALL_TRUE
};
var WEB_TO_LEAD_CAPTURING = {
    name: "pricingPage.features.titles.webToLeadCapturing",
    description: "pricingPage.features.descriptions.webToLeadCapturing",
    tiers: GENERIC_ALL_TRUE
};
var CUSTOM_DASHBOARDS = {
    name: "pricingPage.features.titles.customDashboards",
    description: "pricingPage.features.descriptions.customDashboards",
    tiers: GENERIC_ALL_TRUE
};
var COMMUNICATION_WITH_CONTEXT = {
    name: "pricingPage.features.titles.communication_with_context",
    description: "pricingPage.features.descriptions.communication_with_context",
    tiers: GENERIC_ALL_TRUE
};
var COLLABORATIVE_WHITEBOARD = {
    name: "pricingPage.features.titles.collaborative_whiteboard",
    description: "pricingPage.features.descriptions.whiteboard",
    tiers: WHITEBOARD
};
var INTEGRATIONS_WITH_GMAIL_AND_OUTLOOK = {
    name: "pricingPage.features.titles.integrations_with_gmail_and_outlook",
    description: "pricingPage.features.descriptions.integrations_with_gmail_and_outlook",
    tiers: INTEGRATIONS
};
var IMPORT_FROM_OTHER_TOOLS = {
    name: "pricingPage.features.titles.importFromOtherTools",
    description: "pricingPage.features.descriptions.importFromOtherTools",
    tiers: GENERIC_ALL_TRUE
};
var EMBED_DOCUMENTS_AND_BRIEFS = {
    name: "pricingPage.features.titles.embed_documents_and_briefs",
    description: "pricingPage.features.descriptions.embed_documents_and_briefs",
    tiers: GENERIC_ALL_TRUE
};
var MARKETING_REQUESTS_WITH_FORMS = {
    name: "pricingPage.features.titles.marketing_requests_with_forms",
    description: "pricingPage.features.descriptions.marketing_requests_with_forms",
    tiers: FORMS
};
var READY_MADE_MARKETING_TEMPLATES = {
    name: "pricingPage.features.titles.ready_made_marketing_templates",
    description: "pricingPage.features.descriptions.ready_made_marketing_templates",
    tiers: GENERIC_ALL_TRUE
};
var TEMPLATES = {
    name: "pricingPage.features.titles.templates",
    description: "pricingPage.features.descriptions.templates",
    tiers: GENERIC_ALL_TRUE
};
var UPDATES_SECTION = {
    name: "pricingPage.features.titles.updatesSection",
    description: "pricingPage.features.descriptions.updatesSection",
    tiers: GENERIC_ALL_TRUE
};
var CUSTOMIZABLE_NOTIFICATIONS = {
    name: "pricingPage.features.titles.customizableNotifications",
    description: "pricingPage.features.descriptions.customizableNotifications",
    tiers: GENERIC_ALL_TRUE
};
var DEADLINE_MANAGEMENT = {
    name: "pricingPage.features.titles.deadline_management",
    description: "pricingPage.features.descriptions.deadline_management",
    tiers: GENERIC_ALL_TRUE
};
var SHARE_BOARD_WITH_EXTERNAL_GUESTS = {
    name: "pricingPage.features.titles.share_board_with_external_guests",
    description: "pricingPage.features.descriptions.guests",
    tiers: GUESTS
};
var MARKETING_INTEGRATIONS = {
    name: "pricingPage.features.titles.integrations",
    description: "pricingPage.features.descriptions.marketing_integrations",
    tiers: INTEGRATIONS
};
var MARKETING_DASHBOARDS = {
    name: "pricingPage.features.titles.dashboards",
    description: "pricingPage.features.descriptions.marketing_dashboards",
    tiers: DASHBOARDS
};
var MARKETING_CALENDAR = {
    name: "pricingPage.features.titles.calendar",
    description: "pricingPage.features.descriptions.marketing_calendar",
    tiers: CALENDAR
};
var DAILY_REPORTS = {
    name: "pricingPage.features.titles.daily_reports",
    description: "pricingPage.features.descriptions.daily_reports",
    tiers: SCHEDULED_DASHBOARD_DELIVVERY
};
var IMPORT_EXPORT_EXCEL = {
    name: "pricingPage.features.titles.import_export_excel",
    description: "pricingPage.features.descriptions.import_export_excel",
    tiers: GENERIC_ALL_TRUE
};
var features_WHITEBOARD = {
    name: "pricingPage.features.titles.whiteboard",
    description: "pricingPage.features.descriptions.whiteboard",
    tiers: WHITEBOARD
};
var EMBEDDED_BOARD = {
    name: "pricingPage.features.titles.embed_docs",
    description: "pricingPage.features.descriptions.embed_docs",
    tiers: GENERIC_ALL_TRUE
};
var features_obj;
var ZOOM_INTEGRATION = {
    name: "pricingPage.features.titles.zoom_integration",
    description: "pricingPage.features.descriptions.zoom_integration",
    tiers: (features_obj = {}, (0,_define_property/* default */.Z)(features_obj, pricing/* TIERS.FREE */.Iy.FREE, {
        value: false
    }), (0,_define_property/* default */.Z)(features_obj, pricing/* TIERS.BASIC */.Iy.BASIC, {
        value: false
    }), (0,_define_property/* default */.Z)(features_obj, pricing/* TIERS.STANDARD */.Iy.STANDARD, {
        value: true
    }), (0,_define_property/* default */.Z)(features_obj, pricing/* TIERS.PRO */.Iy.PRO, {
        value: true
    }), (0,_define_property/* default */.Z)(features_obj, pricing/* TIERS.ENTERPRISE */.Iy.ENTERPRISE, {
        value: true
    }), features_obj)
};
var TIMELINE = function(param) {
    var hasStudentPlan = param.hasStudentPlan;
    var _obj;
    return {
        name: "pricingPage.features.titles.timeline",
        description: "pricingPage.features.descriptions.timeline",
        tiers: (_obj = {}, (0,_define_property/* default */.Z)(_obj, pricing/* TIERS.FREE */.Iy.FREE, hasStudentPlan ? {
            value: true
        } : {
            value: false
        }), (0,_define_property/* default */.Z)(_obj, pricing/* TIERS.BASIC */.Iy.BASIC, {
            value: false
        }), (0,_define_property/* default */.Z)(_obj, pricing/* TIERS.STANDARD */.Iy.STANDARD, {
            value: true
        }), (0,_define_property/* default */.Z)(_obj, pricing/* TIERS.PRO */.Iy.PRO, {
            value: true
        }), (0,_define_property/* default */.Z)(_obj, pricing/* TIERS.ENTERPRISE */.Iy.ENTERPRISE, {
            value: true
        }), _obj)
    };
};
var features_CALENDAR = function(param) {
    var hasStudentPlan = param.hasStudentPlan;
    return {
        name: "pricingPage.features.titles.calendar",
        description: "pricingPage.features.descriptions.calendar",
        tiers: _object_spread_props(_object_spread({}, CALENDAR), (0,_define_property/* default */.Z)({}, pricing/* TIERS.FREE */.Iy.FREE, hasStudentPlan ? {
            value: true
        } : {
            value: false
        }))
    };
};
var features_GUESTS = {
    name: "pricingPage.features.titles.guests",
    description: "pricingPage.features.descriptions.guests",
    tiers: GUESTS
};
var KANBAN_VIEW = {
    name: "pricingPage.features.titles.kanbanView",
    description: "pricingPage.features.descriptions.kanbanView",
    tiers: GENERIC_ALL_TRUE
};
var WEBINARS = {
    name: "pricingPage.features.titles.webinars",
    description: "pricingPage.features.descriptions.webinars",
    tiers: GENERIC_ALL_TRUE
};
var features_FORMS = {
    name: "pricingPage.features.titles.forms",
    description: "pricingPage.features.descriptions.forms",
    tiers: FORMS
};
var features_obj1;
var MAP = {
    name: "pricingPage.features.titles.map",
    description: "pricingPage.features.descriptions.map",
    tiers: (features_obj1 = {}, (0,_define_property/* default */.Z)(features_obj1, pricing/* TIERS.FREE */.Iy.FREE, {
        value: false
    }), (0,_define_property/* default */.Z)(features_obj1, pricing/* TIERS.BASIC */.Iy.BASIC, {
        value: false
    }), (0,_define_property/* default */.Z)(features_obj1, pricing/* TIERS.STANDARD */.Iy.STANDARD, {
        value: true
    }), (0,_define_property/* default */.Z)(features_obj1, pricing/* TIERS.PRO */.Iy.PRO, {
        value: true
    }), (0,_define_property/* default */.Z)(features_obj1, pricing/* TIERS.ENTERPRISE */.Iy.ENTERPRISE, {
        value: true
    }), features_obj1)
};
var features_obj2;
var SEARCH = {
    name: "pricingPage.features.titles.search",
    description: "pricingPage.features.descriptions.search",
    tiers: (features_obj2 = {}, (0,_define_property/* default */.Z)(features_obj2, pricing/* TIERS.FREE */.Iy.FREE, {
        value: false
    }), (0,_define_property/* default */.Z)(features_obj2, pricing/* TIERS.BASIC */.Iy.BASIC, {
        value: false
    }), (0,_define_property/* default */.Z)(features_obj2, pricing/* TIERS.STANDARD */.Iy.STANDARD, {
        value: true
    }), (0,_define_property/* default */.Z)(features_obj2, pricing/* TIERS.PRO */.Iy.PRO, {
        value: true
    }), (0,_define_property/* default */.Z)(features_obj2, pricing/* TIERS.ENTERPRISE */.Iy.ENTERPRISE, {
        value: true
    }), features_obj2)
};
var features_obj3;
var IP_RESTRICTIONS = {
    name: "pricingPage.features.titles.ip_restrictions",
    description: "pricingPage.features.descriptions.ip_restrictions",
    tiers: (features_obj3 = {}, (0,_define_property/* default */.Z)(features_obj3, pricing/* TIERS.FREE */.Iy.FREE, {
        value: false
    }), (0,_define_property/* default */.Z)(features_obj3, pricing/* TIERS.BASIC */.Iy.BASIC, {
        value: false
    }), (0,_define_property/* default */.Z)(features_obj3, pricing/* TIERS.STANDARD */.Iy.STANDARD, {
        value: false
    }), (0,_define_property/* default */.Z)(features_obj3, pricing/* TIERS.PRO */.Iy.PRO, {
        value: false
    }), (0,_define_property/* default */.Z)(features_obj3, pricing/* TIERS.ENTERPRISE */.Iy.ENTERPRISE, {
        value: true
    }), features_obj3)
};
var features_obj4;
var CONTENT_DIRECTORY = {
    name: "pricingPage.features.titles.content_directory",
    description: "pricingPage.features.descriptions.content_directory",
    tiers: (features_obj4 = {}, (0,_define_property/* default */.Z)(features_obj4, pricing/* TIERS.FREE */.Iy.FREE, {
        value: false
    }), (0,_define_property/* default */.Z)(features_obj4, pricing/* TIERS.BASIC */.Iy.BASIC, {
        value: false
    }), (0,_define_property/* default */.Z)(features_obj4, pricing/* TIERS.STANDARD */.Iy.STANDARD, {
        value: false
    }), (0,_define_property/* default */.Z)(features_obj4, pricing/* TIERS.PRO */.Iy.PRO, {
        value: false
    }), (0,_define_property/* default */.Z)(features_obj4, pricing/* TIERS.ENTERPRISE */.Iy.ENTERPRISE, {
        value: true
    }), features_obj4)
};
var TEAMS_INSIDE_TEAMS = {
    name: "pricingPage.features.titles.teams_inside_teams",
    description: "pricingPage.features.descriptions.teams_inside_teams",
    tiers: ENTERPRISE_ONLY
};
var CUSTOM_ROLES = {
    name: "pricingPage.features.titles.custom_roles",
    description: "pricingPage.features.descriptions.custom_roles",
    tiers: ENTERPRISE_ONLY
};
var SEATS_MANAGEMENT = {
    name: "pricingPage.features.titles.seats_management",
    description: "pricingPage.features.descriptions.seats_management",
    tiers: ENTERPRISE_ONLY
};
var TENANT_RESTRICTIONS = {
    name: "pricingPage.features.titles.tenant_restrictions",
    description: "pricingPage.features.descriptions.tenant_restrictions",
    tiers: ENTERPRISE_ONLY
};
var APPROVED_GUEST = {
    name: "pricingPage.features.titles.approved_guest",
    description: "pricingPage.features.descriptions.approved_guest",
    tiers: ENTERPRISE_ONLY
};
var BLOCK_DOMAINS = {
    name: "pricingPage.features.titles.block_domains",
    description: "pricingPage.features.descriptions.block_domains",
    tiers: ENTERPRISE_ONLY
};
var FORMS_CUSTOMIZATION = function(param) {
    var hasStudentPlan = param.hasStudentPlan;
    var _obj;
    return {
        name: "pricingPage.features.titles.formsCustomization",
        description: "pricingPage.features.descriptions.formsCustomization",
        tiers: (_obj = {}, (0,_define_property/* default */.Z)(_obj, pricing/* TIERS.FREE */.Iy.FREE, hasStudentPlan ? {
            value: true
        } : {
            value: false
        }), (0,_define_property/* default */.Z)(_obj, pricing/* TIERS.BASIC */.Iy.BASIC, {
            value: false
        }), (0,_define_property/* default */.Z)(_obj, pricing/* TIERS.STANDARD */.Iy.STANDARD, {
            value: true
        }), (0,_define_property/* default */.Z)(_obj, pricing/* TIERS.PRO */.Iy.PRO, {
            value: true
        }), (0,_define_property/* default */.Z)(_obj, pricing/* TIERS.ENTERPRISE */.Iy.ENTERPRISE, {
            value: true
        }), _obj)
    };
};
var features_obj5;
var TWO_WAY_EMAIL_SYNC = {
    name: "pricingPage.features.titles.twoWayEmailSync",
    description: "pricingPage.features.descriptions.twoWayEmailSync",
    tiers: (features_obj5 = {}, (0,_define_property/* default */.Z)(features_obj5, pricing/* TIERS.FREE */.Iy.FREE, {
        value: false
    }), (0,_define_property/* default */.Z)(features_obj5, pricing/* TIERS.BASIC */.Iy.BASIC, {
        value: false
    }), (0,_define_property/* default */.Z)(features_obj5, pricing/* TIERS.STANDARD */.Iy.STANDARD, {
        value: true
    }), (0,_define_property/* default */.Z)(features_obj5, pricing/* TIERS.PRO */.Iy.PRO, {
        value: true
    }), (0,_define_property/* default */.Z)(features_obj5, pricing/* TIERS.ENTERPRISE */.Iy.ENTERPRISE, {
        value: true
    }), features_obj5)
};
var features_obj6;
var COMMISSION_MANAGEMENT = {
    name: "pricingPage.features.titles.commissionManagement",
    description: "pricingPage.features.descriptions.commissionManagement",
    tiers: (features_obj6 = {}, (0,_define_property/* default */.Z)(features_obj6, pricing/* TIERS.FREE */.Iy.FREE, {
        value: false
    }), (0,_define_property/* default */.Z)(features_obj6, pricing/* TIERS.BASIC */.Iy.BASIC, {
        value: false
    }), (0,_define_property/* default */.Z)(features_obj6, pricing/* TIERS.STANDARD */.Iy.STANDARD, {
        value: false
    }), (0,_define_property/* default */.Z)(features_obj6, pricing/* TIERS.PRO */.Iy.PRO, {
        value: true
    }), (0,_define_property/* default */.Z)(features_obj6, pricing/* TIERS.ENTERPRISE */.Iy.ENTERPRISE, {
        value: true
    }), features_obj6)
};
var features_obj7;
var ADVANCED_CUSTOMER_PROJECT_MANAGEMENT = {
    name: "pricingPage.features.titles.advancedCustomerProjectManagement",
    description: "pricingPage.features.descriptions.advancedCustomerProjectManagement",
    tiers: (features_obj7 = {}, (0,_define_property/* default */.Z)(features_obj7, pricing/* TIERS.FREE */.Iy.FREE, {
        value: false
    }), (0,_define_property/* default */.Z)(features_obj7, pricing/* TIERS.BASIC */.Iy.BASIC, {
        value: false
    }), (0,_define_property/* default */.Z)(features_obj7, pricing/* TIERS.STANDARD */.Iy.STANDARD, {
        value: false
    }), (0,_define_property/* default */.Z)(features_obj7, pricing/* TIERS.PRO */.Iy.PRO, {
        value: true
    }), (0,_define_property/* default */.Z)(features_obj7, pricing/* TIERS.ENTERPRISE */.Iy.ENTERPRISE, {
        value: true
    }), features_obj7)
};
var features_obj8;
var WORKLOAD = {
    name: "pricingPage.features.titles.workload",
    description: "pricingPage.features.descriptions.workload",
    tiers: (features_obj8 = {}, (0,_define_property/* default */.Z)(features_obj8, pricing/* TIERS.FREE */.Iy.FREE, {
        value: false
    }), (0,_define_property/* default */.Z)(features_obj8, pricing/* TIERS.BASIC */.Iy.BASIC, {
        value: false
    }), (0,_define_property/* default */.Z)(features_obj8, pricing/* TIERS.STANDARD */.Iy.STANDARD, {
        value: false
    }), (0,_define_property/* default */.Z)(features_obj8, pricing/* TIERS.PRO */.Iy.PRO, {
        value: true
    }), (0,_define_property/* default */.Z)(features_obj8, pricing/* TIERS.ENTERPRISE */.Iy.ENTERPRISE, {
        value: true
    }), features_obj8)
};
var _obj9;
var TIME_TRACKING = {
    name: "pricingPage.features.titles.timeTracking",
    description: "pricingPage.features.descriptions.timeTracking",
    tiers: (_obj9 = {}, (0,_define_property/* default */.Z)(_obj9, pricing/* TIERS.FREE */.Iy.FREE, {
        value: false
    }), (0,_define_property/* default */.Z)(_obj9, pricing/* TIERS.BASIC */.Iy.BASIC, {
        value: false
    }), (0,_define_property/* default */.Z)(_obj9, pricing/* TIERS.STANDARD */.Iy.STANDARD, {
        value: false
    }), (0,_define_property/* default */.Z)(_obj9, pricing/* TIERS.PRO */.Iy.PRO, {
        value: true
    }), (0,_define_property/* default */.Z)(_obj9, pricing/* TIERS.ENTERPRISE */.Iy.ENTERPRISE, {
        value: true
    }), _obj9)
};
var CHART_VIEW = function(param) {
    var hasStudentPlan = param.hasStudentPlan;
    var _obj;
    return {
        name: "pricingPage.features.titles.chartView",
        description: "pricingPage.features.descriptions.chartView",
        tiers: (_obj = {}, (0,_define_property/* default */.Z)(_obj, pricing/* TIERS.FREE */.Iy.FREE, hasStudentPlan ? {
            value: true
        } : {
            value: false
        }), (0,_define_property/* default */.Z)(_obj, pricing/* TIERS.BASIC */.Iy.BASIC, {
            value: false
        }), (0,_define_property/* default */.Z)(_obj, pricing/* TIERS.STANDARD */.Iy.STANDARD, {
            value: false
        }), (0,_define_property/* default */.Z)(_obj, pricing/* TIERS.PRO */.Iy.PRO, {
            value: true
        }), (0,_define_property/* default */.Z)(_obj, pricing/* TIERS.ENTERPRISE */.Iy.ENTERPRISE, {
            value: true
        }), _obj)
    };
};
var FORMULA = function(param) {
    var hasStudentPlan = param.hasStudentPlan;
    var _obj;
    return {
        name: "pricingPage.features.titles.formula",
        description: "pricingPage.features.descriptions.formula",
        tiers: (_obj = {}, (0,_define_property/* default */.Z)(_obj, pricing/* TIERS.FREE */.Iy.FREE, hasStudentPlan ? {
            value: true
        } : {
            value: false
        }), (0,_define_property/* default */.Z)(_obj, pricing/* TIERS.BASIC */.Iy.BASIC, {
            value: false
        }), (0,_define_property/* default */.Z)(_obj, pricing/* TIERS.STANDARD */.Iy.STANDARD, {
            value: false
        }), (0,_define_property/* default */.Z)(_obj, pricing/* TIERS.PRO */.Iy.PRO, {
            value: true
        }), (0,_define_property/* default */.Z)(_obj, pricing/* TIERS.ENTERPRISE */.Iy.ENTERPRISE, {
            value: true
        }), _obj)
    };
};
var _obj10;
var DEPENDENCY_COLUMN = {
    name: "pricingPage.features.titles.dependencyColumn",
    description: "pricingPage.features.descriptions.dependencyColumn",
    tiers: (_obj10 = {}, (0,_define_property/* default */.Z)(_obj10, pricing/* TIERS.FREE */.Iy.FREE, {
        value: false
    }), (0,_define_property/* default */.Z)(_obj10, pricing/* TIERS.BASIC */.Iy.BASIC, {
        value: false
    }), (0,_define_property/* default */.Z)(_obj10, pricing/* TIERS.STANDARD */.Iy.STANDARD, {
        value: false
    }), (0,_define_property/* default */.Z)(_obj10, pricing/* TIERS.PRO */.Iy.PRO, {
        value: true
    }), (0,_define_property/* default */.Z)(_obj10, pricing/* TIERS.ENTERPRISE */.Iy.ENTERPRISE, {
        value: true
    }), _obj10)
};
var _obj11;
var TAGS = {
    name: "pricingPage.features.titles.tags",
    description: "pricingPage.features.descriptions.tags",
    tiers: (_obj11 = {}, (0,_define_property/* default */.Z)(_obj11, pricing/* TIERS.FREE */.Iy.FREE, {
        value: false
    }), (0,_define_property/* default */.Z)(_obj11, pricing/* TIERS.BASIC */.Iy.BASIC, {
        value: false
    }), (0,_define_property/* default */.Z)(_obj11, pricing/* TIERS.STANDARD */.Iy.STANDARD, {
        value: false
    }), (0,_define_property/* default */.Z)(_obj11, pricing/* TIERS.PRO */.Iy.PRO, {
        value: true
    }), (0,_define_property/* default */.Z)(_obj11, pricing/* TIERS.ENTERPRISE */.Iy.ENTERPRISE, {
        value: true
    }), _obj11)
};
var _obj12;
var PRIVATE_BOARDS = {
    name: "pricingPage.features.titles.privateBoards",
    description: "pricingPage.features.descriptions.privateBoards",
    tiers: (_obj12 = {}, (0,_define_property/* default */.Z)(_obj12, pricing/* TIERS.FREE */.Iy.FREE, {
        value: false
    }), (0,_define_property/* default */.Z)(_obj12, pricing/* TIERS.BASIC */.Iy.BASIC, {
        value: false
    }), (0,_define_property/* default */.Z)(_obj12, pricing/* TIERS.STANDARD */.Iy.STANDARD, {
        value: false
    }), (0,_define_property/* default */.Z)(_obj12, pricing/* TIERS.PRO */.Iy.PRO, {
        value: true
    }), (0,_define_property/* default */.Z)(_obj12, pricing/* TIERS.ENTERPRISE */.Iy.ENTERPRISE, {
        value: true
    }), _obj12)
};
var features_INTEGRATIONS = {
    name: "pricingPage.features.titles.integrations",
    description: "pricingPage.features.descriptions.integrations",
    tiers: INTEGRATIONS
};
var _obj13;
var AUTOMATIONS = {
    name: "pricingPage.features.titles.automations",
    description: "pricingPage.features.descriptions.automations",
    tiers: (_obj13 = {}, (0,_define_property/* default */.Z)(_obj13, pricing/* TIERS.FREE */.Iy.FREE, {
        value: false
    }), (0,_define_property/* default */.Z)(_obj13, pricing/* TIERS.BASIC */.Iy.BASIC, {
        value: false
    }), (0,_define_property/* default */.Z)(_obj13, pricing/* TIERS.STANDARD */.Iy.STANDARD, {
        value: "pricingPage.features.plans.automations_standard"
    }), (0,_define_property/* default */.Z)(_obj13, pricing/* TIERS.PRO */.Iy.PRO, {
        value: "pricingPage.features.plans.automations_pro"
    }), (0,_define_property/* default */.Z)(_obj13, pricing/* TIERS.ENTERPRISE */.Iy.ENTERPRISE, {
        value: "pricingPage.features.plans.automations_enterprise"
    }), _obj13)
};
var _obj14;
var PREMIUM_INTEGRATIONS = {
    name: "pricingPage.features.titles.premiumIntegrations",
    description: "pricingPage.features.descriptions.premiumIntegrations",
    tiers: (_obj14 = {}, (0,_define_property/* default */.Z)(_obj14, pricing/* TIERS.FREE */.Iy.FREE, {
        value: false
    }), (0,_define_property/* default */.Z)(_obj14, pricing/* TIERS.BASIC */.Iy.BASIC, {
        value: false
    }), (0,_define_property/* default */.Z)(_obj14, pricing/* TIERS.STANDARD */.Iy.STANDARD, {
        value: false
    }), (0,_define_property/* default */.Z)(_obj14, pricing/* TIERS.PRO */.Iy.PRO, {
        value: false
    }), (0,_define_property/* default */.Z)(_obj14, pricing/* TIERS.ENTERPRISE */.Iy.ENTERPRISE, {
        value: true
    }), _obj14)
};
var features_DASHBOARDS = function(param) {
    var hasStudentPlan = param.hasStudentPlan;
    return {
        name: "pricingPage.features.titles.dashboards",
        description: "pricingPage.features.descriptions.dashboards",
        tiers: _object_spread_props(_object_spread({}, DASHBOARDS), (0,_define_property/* default */.Z)({}, pricing/* TIERS.FREE */.Iy.FREE, hasStudentPlan ? {
            value: "pricingPage.features.plans.dashboards_pro"
        } : {
            value: "pricingPage.features.plans.dashboards_basic"
        }))
    };
};
var TWO_FA = {
    name: "pricingPage.features.titles.twoFa",
    description: "pricingPage.features.descriptions.twoFa",
    tiers: GENERIC_ALL_TRUE
};
var _obj15;
var GOOGLE = {
    name: "pricingPage.features.titles.google",
    description: "pricingPage.features.descriptions.google",
    tiers: (_obj15 = {}, (0,_define_property/* default */.Z)(_obj15, pricing/* TIERS.FREE */.Iy.FREE, {
        value: false
    }), (0,_define_property/* default */.Z)(_obj15, pricing/* TIERS.BASIC */.Iy.BASIC, {
        value: false
    }), (0,_define_property/* default */.Z)(_obj15, pricing/* TIERS.STANDARD */.Iy.STANDARD, {
        value: false
    }), (0,_define_property/* default */.Z)(_obj15, pricing/* TIERS.PRO */.Iy.PRO, {
        value: true
    }), (0,_define_property/* default */.Z)(_obj15, pricing/* TIERS.ENTERPRISE */.Iy.ENTERPRISE, {
        value: true
    }), _obj15)
};
var features_BOARD_ADMINISTRATORS = {
    name: "pricingPage.features.titles.boardAdministrators",
    description: "pricingPage.features.descriptions.boardAdministrators",
    tiers: BOARD_ADMINISTRATORS
};
var _obj16;
var SAML = {
    name: "pricingPage.features.titles.saml",
    description: "pricingPage.features.descriptions.saml",
    tiers: (_obj16 = {}, (0,_define_property/* default */.Z)(_obj16, pricing/* TIERS.FREE */.Iy.FREE, {
        value: false
    }), (0,_define_property/* default */.Z)(_obj16, pricing/* TIERS.BASIC */.Iy.BASIC, {
        value: false
    }), (0,_define_property/* default */.Z)(_obj16, pricing/* TIERS.STANDARD */.Iy.STANDARD, {
        value: false
    }), (0,_define_property/* default */.Z)(_obj16, pricing/* TIERS.PRO */.Iy.PRO, {
        value: false
    }), (0,_define_property/* default */.Z)(_obj16, pricing/* TIERS.ENTERPRISE */.Iy.ENTERPRISE, {
        value: true
    }), _obj16)
};
var _obj17;
var SCIM = {
    name: "pricingPage.features.titles.scimProvisioning",
    description: "pricingPage.features.descriptions.scimProvisioning",
    tiers: (_obj17 = {}, (0,_define_property/* default */.Z)(_obj17, pricing/* TIERS.FREE */.Iy.FREE, {
        value: false
    }), (0,_define_property/* default */.Z)(_obj17, pricing/* TIERS.BASIC */.Iy.BASIC, {
        value: false
    }), (0,_define_property/* default */.Z)(_obj17, pricing/* TIERS.STANDARD */.Iy.STANDARD, {
        value: false
    }), (0,_define_property/* default */.Z)(_obj17, pricing/* TIERS.PRO */.Iy.PRO, {
        value: false
    }), (0,_define_property/* default */.Z)(_obj17, pricing/* TIERS.ENTERPRISE */.Iy.ENTERPRISE, {
        value: true
    }), _obj17)
};
var _obj18;
var AUDIT_LOG = {
    name: "pricingPage.features.titles.auditLog",
    description: "pricingPage.features.descriptions.auditLog",
    tiers: (_obj18 = {}, (0,_define_property/* default */.Z)(_obj18, pricing/* TIERS.FREE */.Iy.FREE, {
        value: false
    }), (0,_define_property/* default */.Z)(_obj18, pricing/* TIERS.BASIC */.Iy.BASIC, {
        value: false
    }), (0,_define_property/* default */.Z)(_obj18, pricing/* TIERS.STANDARD */.Iy.STANDARD, {
        value: false
    }), (0,_define_property/* default */.Z)(_obj18, pricing/* TIERS.PRO */.Iy.PRO, {
        value: false
    }), (0,_define_property/* default */.Z)(_obj18, pricing/* TIERS.ENTERPRISE */.Iy.ENTERPRISE, {
        value: true
    }), _obj18)
};
var _obj19;
var SESSIONS = {
    name: "pricingPage.features.titles.sessions",
    description: "pricingPage.features.descriptions.sessions",
    tiers: (_obj19 = {}, (0,_define_property/* default */.Z)(_obj19, pricing/* TIERS.FREE */.Iy.FREE, {
        value: false
    }), (0,_define_property/* default */.Z)(_obj19, pricing/* TIERS.BASIC */.Iy.BASIC, {
        value: false
    }), (0,_define_property/* default */.Z)(_obj19, pricing/* TIERS.STANDARD */.Iy.STANDARD, {
        value: false
    }), (0,_define_property/* default */.Z)(_obj19, pricing/* TIERS.PRO */.Iy.PRO, {
        value: false
    }), (0,_define_property/* default */.Z)(_obj19, pricing/* TIERS.ENTERPRISE */.Iy.ENTERPRISE, {
        value: true
    }), _obj19)
};
var features_PANIC_MODE = {
    name: "pricingPage.features.titles.panicMode",
    description: "pricingPage.features.descriptions.panicMode",
    tiers: PANIC_MODE
};
var _obj20;
var HIPAA = {
    name: "pricingPage.features.titles.hipaa",
    description: "pricingPage.features.descriptions.hipaa",
    tiers: (_obj20 = {}, (0,_define_property/* default */.Z)(_obj20, pricing/* TIERS.FREE */.Iy.FREE, {
        value: false
    }), (0,_define_property/* default */.Z)(_obj20, pricing/* TIERS.BASIC */.Iy.BASIC, {
        value: false
    }), (0,_define_property/* default */.Z)(_obj20, pricing/* TIERS.STANDARD */.Iy.STANDARD, {
        value: false
    }), (0,_define_property/* default */.Z)(_obj20, pricing/* TIERS.PRO */.Iy.PRO, {
        value: false
    }), (0,_define_property/* default */.Z)(_obj20, pricing/* TIERS.ENTERPRISE */.Iy.ENTERPRISE, {
        value: true
    }), _obj20)
};
var SOC = {
    name: "pricingPage.features.titles.soc",
    description: "pricingPage.features.descriptions.soc",
    tiers: GENERIC_ALL_TRUE
};
var _obj21;
var SLA = {
    name: "pricingPage.features.titles.sla",
    description: "pricingPage.features.descriptions.sla",
    tiers: (_obj21 = {}, (0,_define_property/* default */.Z)(_obj21, pricing/* TIERS.FREE */.Iy.FREE, {
        value: false
    }), (0,_define_property/* default */.Z)(_obj21, pricing/* TIERS.BASIC */.Iy.BASIC, {
        value: false
    }), (0,_define_property/* default */.Z)(_obj21, pricing/* TIERS.STANDARD */.Iy.STANDARD, {
        value: false
    }), (0,_define_property/* default */.Z)(_obj21, pricing/* TIERS.PRO */.Iy.PRO, {
        value: false
    }), (0,_define_property/* default */.Z)(_obj21, pricing/* TIERS.ENTERPRISE */.Iy.ENTERPRISE, {
        value: true
    }), _obj21)
};
var _obj22;
var CS_MANAGER = {
    name: "pricingPage.features.titles.csManager",
    description: "pricingPage.features.descriptions.csManager",
    tiers: (_obj22 = {}, (0,_define_property/* default */.Z)(_obj22, pricing/* TIERS.FREE */.Iy.FREE, {
        value: false
    }), (0,_define_property/* default */.Z)(_obj22, pricing/* TIERS.BASIC */.Iy.BASIC, {
        value: false
    }), (0,_define_property/* default */.Z)(_obj22, pricing/* TIERS.STANDARD */.Iy.STANDARD, {
        value: false
    }), (0,_define_property/* default */.Z)(_obj22, pricing/* TIERS.PRO */.Iy.PRO, {
        value: false
    }), (0,_define_property/* default */.Z)(_obj22, pricing/* TIERS.ENTERPRISE */.Iy.ENTERPRISE, {
        value: true
    }), _obj22)
};
var _obj23;
var INTEGRATION_PERMISSIONS = {
    name: "pricingPage.features.titles.integrationPermissions",
    description: "pricingPage.features.descriptions.integrationPermissions",
    tiers: (_obj23 = {}, (0,_define_property/* default */.Z)(_obj23, pricing/* TIERS.FREE */.Iy.FREE, {
        value: false
    }), (0,_define_property/* default */.Z)(_obj23, pricing/* TIERS.BASIC */.Iy.BASIC, {
        value: false
    }), (0,_define_property/* default */.Z)(_obj23, pricing/* TIERS.STANDARD */.Iy.STANDARD, {
        value: false
    }), (0,_define_property/* default */.Z)(_obj23, pricing/* TIERS.PRO */.Iy.PRO, {
        value: false
    }), (0,_define_property/* default */.Z)(_obj23, pricing/* TIERS.ENTERPRISE */.Iy.ENTERPRISE, {
        value: true
    }), _obj23)
};
var _obj24;
var SALESFORCE_INTEGRATION = {
    name: "pricingPage.features.titles.salesforceIntegration",
    description: "pricingPage.features.descriptions.salesforceIntegration",
    tiers: (_obj24 = {}, (0,_define_property/* default */.Z)(_obj24, pricing/* TIERS.FREE */.Iy.FREE, {
        value: false
    }), (0,_define_property/* default */.Z)(_obj24, pricing/* TIERS.BASIC */.Iy.BASIC, {
        value: false
    }), (0,_define_property/* default */.Z)(_obj24, pricing/* TIERS.STANDARD */.Iy.STANDARD, {
        value: false
    }), (0,_define_property/* default */.Z)(_obj24, pricing/* TIERS.PRO */.Iy.PRO, {
        value: false
    }), (0,_define_property/* default */.Z)(_obj24, pricing/* TIERS.ENTERPRISE */.Iy.ENTERPRISE, {
        value: true
    }), _obj24)
};
var _obj25;
var PRIVATE_WORKSPACES = {
    name: "pricingPage.features.titles.privateWorkspaces",
    description: "pricingPage.features.descriptions.privateWorkspaces",
    tiers: (_obj25 = {}, (0,_define_property/* default */.Z)(_obj25, pricing/* TIERS.FREE */.Iy.FREE, {
        value: false
    }), (0,_define_property/* default */.Z)(_obj25, pricing/* TIERS.BASIC */.Iy.BASIC, {
        value: false
    }), (0,_define_property/* default */.Z)(_obj25, pricing/* TIERS.STANDARD */.Iy.STANDARD, {
        value: false
    }), (0,_define_property/* default */.Z)(_obj25, pricing/* TIERS.PRO */.Iy.PRO, {
        value: false
    }), (0,_define_property/* default */.Z)(_obj25, pricing/* TIERS.ENTERPRISE */.Iy.ENTERPRISE, {
        value: true
    }), _obj25)
};
var _obj26;
var ACCOUNT_PERMISSIONS = {
    name: "pricingPage.features.titles.accountPermissions",
    description: "pricingPage.features.descriptions.accountPermissions",
    tiers: (_obj26 = {}, (0,_define_property/* default */.Z)(_obj26, pricing/* TIERS.FREE */.Iy.FREE, {
        value: false
    }), (0,_define_property/* default */.Z)(_obj26, pricing/* TIERS.BASIC */.Iy.BASIC, {
        value: false
    }), (0,_define_property/* default */.Z)(_obj26, pricing/* TIERS.STANDARD */.Iy.STANDARD, {
        value: false
    }), (0,_define_property/* default */.Z)(_obj26, pricing/* TIERS.PRO */.Iy.PRO, {
        value: false
    }), (0,_define_property/* default */.Z)(_obj26, pricing/* TIERS.ENTERPRISE */.Iy.ENTERPRISE, {
        value: true
    }), _obj26)
};
var _obj27;
var WORK_PERFORMANCE_INSIGHTS = {
    name: "pricingPage.features.titles.workPerformanceInsights",
    description: "pricingPage.features.descriptions.workPerformanceInsights",
    tiers: (_obj27 = {}, (0,_define_property/* default */.Z)(_obj27, pricing/* TIERS.FREE */.Iy.FREE, {
        value: false
    }), (0,_define_property/* default */.Z)(_obj27, pricing/* TIERS.BASIC */.Iy.BASIC, {
        value: false
    }), (0,_define_property/* default */.Z)(_obj27, pricing/* TIERS.STANDARD */.Iy.STANDARD, {
        value: false
    }), (0,_define_property/* default */.Z)(_obj27, pricing/* TIERS.PRO */.Iy.PRO, {
        value: false
    }), (0,_define_property/* default */.Z)(_obj27, pricing/* TIERS.ENTERPRISE */.Iy.ENTERPRISE, {
        value: true
    }), _obj27)
};
var SCHEDULED_DASHBOARD_DELIVERY = {
    name: "pricingPage.features.titles.dashboardEmailNotifications",
    description: "pricingPage.features.descriptions.dashboardEmailNotifications",
    tiers: SCHEDULED_DASHBOARD_DELIVVERY
};
var _obj28;
var PIVOT_ANALYSIS = {
    name: "pricingPage.features.titles.pivotAnalysis",
    description: "pricingPage.features.descriptions.pivotAnalysis",
    tiers: (_obj28 = {}, (0,_define_property/* default */.Z)(_obj28, pricing/* TIERS.FREE */.Iy.FREE, {
        value: false
    }), (0,_define_property/* default */.Z)(_obj28, pricing/* TIERS.BASIC */.Iy.BASIC, {
        value: false
    }), (0,_define_property/* default */.Z)(_obj28, pricing/* TIERS.STANDARD */.Iy.STANDARD, {
        value: false
    }), (0,_define_property/* default */.Z)(_obj28, pricing/* TIERS.PRO */.Iy.PRO, {
        value: false
    }), (0,_define_property/* default */.Z)(_obj28, pricing/* TIERS.ENTERPRISE */.Iy.ENTERPRISE, {
        value: true
    }), _obj28)
};
var KNOWLEDGE_BASE = {
    name: "pricingPage.features.titles.knowledgeBase",
    description: "pricingPage.features.descriptions.knowledgeBase",
    tiers: GENERIC_ALL_TRUE
};
var EMAIL_SUPPORT = {
    name: "pricingPage.features.titles.emailSupport",
    description: "pricingPage.features.descriptions.emailSupport",
    tiers: GENERIC_ALL_TRUE
};
var _obj29;
var TAILORED_ONBOARDING = {
    name: "pricingPage.features.titles.tailoredOnboarding",
    description: "pricingPage.features.descriptions.tailoredOnboarding",
    tiers: (_obj29 = {}, (0,_define_property/* default */.Z)(_obj29, pricing/* TIERS.FREE */.Iy.FREE, {
        value: false
    }), (0,_define_property/* default */.Z)(_obj29, pricing/* TIERS.BASIC */.Iy.BASIC, {
        value: false
    }), (0,_define_property/* default */.Z)(_obj29, pricing/* TIERS.STANDARD */.Iy.STANDARD, {
        value: false
    }), (0,_define_property/* default */.Z)(_obj29, pricing/* TIERS.PRO */.Iy.PRO, {
        value: false
    }), (0,_define_property/* default */.Z)(_obj29, pricing/* TIERS.ENTERPRISE */.Iy.ENTERPRISE, {
        value: true
    }), _obj29)
};
var _obj30;
var UNLIMITED_VIEWERS = {
    name: "pricingPage.features.titles.unlimitedViewers",
    description: "pricingPage.features.descriptions.viewers",
    tiers: (_obj30 = {}, (0,_define_property/* default */.Z)(_obj30, pricing/* TIERS.FREE */.Iy.FREE, {
        value: false
    }), (0,_define_property/* default */.Z)(_obj30, pricing/* TIERS.BASIC */.Iy.BASIC, {
        value: true
    }), (0,_define_property/* default */.Z)(_obj30, pricing/* TIERS.STANDARD */.Iy.STANDARD, {
        value: true
    }), (0,_define_property/* default */.Z)(_obj30, pricing/* TIERS.PRO */.Iy.PRO, {
        value: true
    }), (0,_define_property/* default */.Z)(_obj30, pricing/* TIERS.ENTERPRISE */.Iy.ENTERPRISE, {
        value: true
    }), _obj30)
};
var UNLIMITED_BOARDS = {
    name: "pricingPage.features.titles.unlimitedBoards",
    description: "pricingPage.features.descriptions.boards",
    tiers: GENERIC_ALL_TRUE
};
var UNLIMITED_DOCS = {
    name: "pricingPage.features.titles.unlimitedDocs",
    description: "pricingPage.features.descriptions.docs",
    tiers: GENERIC_ALL_TRUE
};
var COLUMN_TYPES = function(param) {
    var _cookies = param.cookies, cookies = _cookies === void 0 ? {} : _cookies;
    var _obj;
    return {
        name: "pricingPage.features.titles.columnTypes",
        description: "pricingPage.features.descriptions.columnTypes",
        tiers: (_obj = {}, (0,_define_property/* default */.Z)(_obj, pricing/* TIERS.FREE */.Iy.FREE, {
            value: (0,monetization_ab_tests_service/* getIsFreeOver20ColumnTypes */._n)({
                cookies: cookies
            })
        }), (0,_define_property/* default */.Z)(_obj, pricing/* TIERS.BASIC */.Iy.BASIC, {
            value: true
        }), (0,_define_property/* default */.Z)(_obj, pricing/* TIERS.STANDARD */.Iy.STANDARD, {
            value: true
        }), (0,_define_property/* default */.Z)(_obj, pricing/* TIERS.PRO */.Iy.PRO, {
            value: true
        }), (0,_define_property/* default */.Z)(_obj, pricing/* TIERS.ENTERPRISE */.Iy.ENTERPRISE, {
            value: true
        }), _obj)
    };
};
var _obj31;
var MAXIMUM_SEATS = {
    name: "pricingPage.features.titles.maximumSeats",
    description: "pricingPage.features.descriptions.maximumSeats",
    tiers: (_obj31 = {}, (0,_define_property/* default */.Z)(_obj31, pricing/* TIERS.FREE */.Iy.FREE, {
        value: {
            key: "pricingPage.upToXSeats",
            param: pricing/* FREE_TIER_2021_SEATS_LIMIT */.F3
        }
    }), (0,_define_property/* default */.Z)(_obj31, pricing/* TIERS.BASIC */.Iy.BASIC, {
        value: "pricingPage.features.plans.unlimited"
    }), (0,_define_property/* default */.Z)(_obj31, pricing/* TIERS.STANDARD */.Iy.STANDARD, {
        value: "pricingPage.features.plans.unlimited"
    }), (0,_define_property/* default */.Z)(_obj31, pricing/* TIERS.PRO */.Iy.PRO, {
        value: "pricingPage.features.plans.unlimited"
    }), (0,_define_property/* default */.Z)(_obj31, pricing/* TIERS.ENTERPRISE */.Iy.ENTERPRISE, {
        value: "pricingPage.features.plans.unlimited"
    }), _obj31)
};
var MOBILE = {
    name: "pricingPage.features.titles.mobile",
    description: "pricingPage.features.descriptions.mobile",
    tiers: GENERIC_ALL_TRUE
};
var STORAGE = function(param) {
    var cookies = param.cookies, abTests = param.abTests;
    return (0,acquisition_ab_test_service.shouldShowBiggerStorageInPricingFeatures)(abTests, cookies, false) ? BIGGER_STORAGE_FEATURE : STORAGE_FEATURE;
};
var _obj32;
var STORAGE_FEATURE = {
    name: "pricingPage.features.titles.storage",
    id: pricing/* FEATURES_IDS.STORAGE */.U1.STORAGE,
    description: "pricingPage.features.descriptions.storage",
    onVisible: {
        callback: function(param) {
            var abTests = param.abTests, cookies = param.cookies;
            return (0,acquisition_ab_test_service.shouldShowBiggerStorageInPricingFeatures)(abTests, cookies, true);
        },
        onlyOnce: true
    },
    tiers: (_obj32 = {}, (0,_define_property/* default */.Z)(_obj32, pricing/* TIERS.FREE */.Iy.FREE, {
        value: "pricingPage.features.plans.storage_free"
    }), (0,_define_property/* default */.Z)(_obj32, pricing/* TIERS.BASIC */.Iy.BASIC, {
        value: "pricingPage.features.plans.storage_basic"
    }), (0,_define_property/* default */.Z)(_obj32, pricing/* TIERS.STANDARD */.Iy.STANDARD, {
        value: "pricingPage.features.plans.storage_standard"
    }), (0,_define_property/* default */.Z)(_obj32, pricing/* TIERS.PRO */.Iy.PRO, {
        value: "pricingPage.features.plans.storage_pro"
    }), (0,_define_property/* default */.Z)(_obj32, pricing/* TIERS.ENTERPRISE */.Iy.ENTERPRISE, {
        value: "pricingPage.features.plans.storage_enterprise"
    }), _obj32)
};
var _obj33;
var BIGGER_STORAGE_FEATURE = {
    name: "pricingPage.features.titles.storage",
    description: "pricingPage.features.descriptions.storage",
    id: pricing/* FEATURES_IDS.STORAGE */.U1.STORAGE,
    onVisible: {
        callback: function(param) {
            var abTests = param.abTests, cookies = param.cookies;
            return (0,acquisition_ab_test_service.shouldShowBiggerStorageInPricingFeatures)(abTests, cookies, true);
        },
        onlyOnce: true
    },
    tiers: (_obj33 = {}, (0,_define_property/* default */.Z)(_obj33, pricing/* TIERS.FREE */.Iy.FREE, {
        value: "pricingPage.features.plans.storage_free"
    }), (0,_define_property/* default */.Z)(_obj33, pricing/* TIERS.BASIC */.Iy.BASIC, {
        value: "pricingPage.features.plans.storage_basic"
    }), (0,_define_property/* default */.Z)(_obj33, pricing/* TIERS.STANDARD */.Iy.STANDARD, {
        value: "pricingPage.features.plans.storage_standard"
    }), (0,_define_property/* default */.Z)(_obj33, pricing/* TIERS.PRO */.Iy.PRO, {
        value: "pricingPage.features.plans.storage_pro_bigger"
    }), (0,_define_property/* default */.Z)(_obj33, pricing/* TIERS.ENTERPRISE */.Iy.ENTERPRISE, {
        value: "pricingPage.features.plans.storage_enterprise_bigger"
    }), _obj33)
};
var _obj34;
var ACTIVITY_LOG = {
    name: "pricingPage.features.titles.activityLog",
    description: "pricingPage.features.descriptions.activityLog",
    tiers: (_obj34 = {}, (0,_define_property/* default */.Z)(_obj34, pricing/* TIERS.FREE */.Iy.FREE, {
        value: "pricingPage.features.plans.one_week"
    }), (0,_define_property/* default */.Z)(_obj34, pricing/* TIERS.BASIC */.Iy.BASIC, {
        value: "pricingPage.features.plans.one_week"
    }), (0,_define_property/* default */.Z)(_obj34, pricing/* TIERS.STANDARD */.Iy.STANDARD, {
        value: "pricingPage.features.plans.six_months"
    }), (0,_define_property/* default */.Z)(_obj34, pricing/* TIERS.PRO */.Iy.PRO, {
        value: "pricingPage.features.plans.one_year"
    }), (0,_define_property/* default */.Z)(_obj34, pricing/* TIERS.ENTERPRISE */.Iy.ENTERPRISE, {
        value: "pricingPage.features.plans.five_years"
    }), _obj34)
};
var _obj35;
var ADVANCED_COLUMN_TYPES = {
    name: "pricingPage.features.titles.advancedColumnTypes",
    description: "pricingPage.features.descriptions.columnTypes",
    tiers: (_obj35 = {}, (0,_define_property/* default */.Z)(_obj35, pricing/* TIERS.FREE */.Iy.FREE, {
        value: false
    }), (0,_define_property/* default */.Z)(_obj35, pricing/* TIERS.BASIC */.Iy.BASIC, {
        value: true
    }), (0,_define_property/* default */.Z)(_obj35, pricing/* TIERS.STANDARD */.Iy.STANDARD, {
        value: true
    }), (0,_define_property/* default */.Z)(_obj35, pricing/* TIERS.PRO */.Iy.PRO, {
        value: true
    }), (0,_define_property/* default */.Z)(_obj35, pricing/* TIERS.ENTERPRISE */.Iy.ENTERPRISE, {
        value: true
    }), _obj35)
};
var _obj36;
var VIEWERS = {
    name: "pricingPage.features.titles.viewers",
    description: "pricingPage.features.descriptions.viewers",
    tiers: (_obj36 = {}, (0,_define_property/* default */.Z)(_obj36, pricing/* TIERS.FREE */.Iy.FREE, {
        value: false
    }), (0,_define_property/* default */.Z)(_obj36, pricing/* TIERS.BASIC */.Iy.BASIC, {
        value: true
    }), (0,_define_property/* default */.Z)(_obj36, pricing/* TIERS.STANDARD */.Iy.STANDARD, {
        value: true
    }), (0,_define_property/* default */.Z)(_obj36, pricing/* TIERS.PRO */.Iy.PRO, {
        value: true
    }), (0,_define_property/* default */.Z)(_obj36, pricing/* TIERS.ENTERPRISE */.Iy.ENTERPRISE, {
        value: true
    }), _obj36)
};
var _obj37;
var BOARDS = {
    name: "pricingPage.features.titles.boards",
    description: "pricingPage.features.descriptions.boards",
    tiers: (_obj37 = {}, (0,_define_property/* default */.Z)(_obj37, pricing/* TIERS.FREE */.Iy.FREE, {
        value: "pricingPage.features.plans.unlimited"
    }), (0,_define_property/* default */.Z)(_obj37, pricing/* TIERS.BASIC */.Iy.BASIC, {
        value: "pricingPage.features.plans.unlimited"
    }), (0,_define_property/* default */.Z)(_obj37, pricing/* TIERS.STANDARD */.Iy.STANDARD, {
        value: "pricingPage.features.plans.unlimited"
    }), (0,_define_property/* default */.Z)(_obj37, pricing/* TIERS.PRO */.Iy.PRO, {
        value: "pricingPage.features.plans.unlimited"
    }), (0,_define_property/* default */.Z)(_obj37, pricing/* TIERS.ENTERPRISE */.Iy.ENTERPRISE, {
        value: "pricingPage.features.plans.unlimited"
    }), _obj37)
};
var ITEMS = function(param) {
    var abTests = param.abTests, cookies = param.cookies;
    var _obj;
    return {
        name: "pricingPage.features.titles.items",
        description: {
            key: "pricingPage.features.descriptions.items",
            param: getItemResourceCreditCount(abTests, cookies)
        },
        tiers: (_obj = {}, (0,_define_property/* default */.Z)(_obj, pricing/* TIERS.FREE */.Iy.FREE, {
            value: "pricingPage.features.plans.upToOneK"
        }), (0,_define_property/* default */.Z)(_obj, pricing/* TIERS.BASIC */.Iy.BASIC, {
            value: "pricingPage.features.plans.unlimited"
        }), (0,_define_property/* default */.Z)(_obj, pricing/* TIERS.STANDARD */.Iy.STANDARD, {
            value: "pricingPage.features.plans.unlimited"
        }), (0,_define_property/* default */.Z)(_obj, pricing/* TIERS.PRO */.Iy.PRO, {
            value: "pricingPage.features.plans.unlimited"
        }), (0,_define_property/* default */.Z)(_obj, pricing/* TIERS.ENTERPRISE */.Iy.ENTERPRISE, {
            value: "pricingPage.features.plans.unlimited"
        }), _obj)
    };
};
var UNLIMITED_BOARDS_WITH_FREE_TIER = function(param) {
    var _cookies = param.cookies, cookies = _cookies === void 0 ? {} : _cookies, _abTests = param.abTests, abTests = _abTests === void 0 ? [] : _abTests;
    var _obj;
    return {
        name: "pricingPage.features.titles.unlimitedBoards",
        description: "pricingPage.features.descriptions.boards",
        tiers: (_obj = {}, (0,_define_property/* default */.Z)(_obj, pricing/* TIERS.FREE */.Iy.FREE, {
            value: (0,monetization_ab_tests_service/* getIsUnlimitedBoards */.J6)({
                cookies: cookies,
                abTests: abTests
            })
        }), (0,_define_property/* default */.Z)(_obj, pricing/* TIERS.BASIC */.Iy.BASIC, {
            value: true
        }), (0,_define_property/* default */.Z)(_obj, pricing/* TIERS.STANDARD */.Iy.STANDARD, {
            value: true
        }), (0,_define_property/* default */.Z)(_obj, pricing/* TIERS.PRO */.Iy.PRO, {
            value: true
        }), (0,_define_property/* default */.Z)(_obj, pricing/* TIERS.ENTERPRISE */.Iy.ENTERPRISE, {
            value: true
        }), _obj)
    };
};


/***/ }),

/***/ 78217:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$4": function() { return /* binding */ ENTERPRISE_TIER_VALUE_FEATURES; },
/* harmony export */   "b5": function() { return /* binding */ STUDENT_PLAN_VALUE_FEATURES; },
/* harmony export */   "cN": function() { return /* binding */ BASIC_TIER_VALUE_FEATURES; },
/* harmony export */   "kh": function() { return /* binding */ STANDARD_TIER_VALUE_FEATURES; },
/* harmony export */   "tE": function() { return /* binding */ PRO_TIER_VALUE_FEATURES; },
/* harmony export */   "tL": function() { return /* binding */ FREE_TIER_VALUE_FEATURES; }
/* harmony export */ });
/* harmony import */ var constants_pricing__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(55674);
/* harmony import */ var _value_features__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(49127);


var FREE_TIER_VALUE_FEATURES = [
    _value_features__WEBPACK_IMPORTED_MODULE_1__.UNLIMITED_BOARDS,
    _value_features__WEBPACK_IMPORTED_MODULE_1__.UNLIMITED_DOCS,
    _value_features__WEBPACK_IMPORTED_MODULE_1__.OVER_200_TEMPLATES,
    _value_features__WEBPACK_IMPORTED_MODULE_1__.COLUMN_TYPES,
    _value_features__WEBPACK_IMPORTED_MODULE_1__.UP_TO_X_TEAM_MEMBERS(constants_pricing__WEBPACK_IMPORTED_MODULE_0__/* .FREE_TIER_2021_SEATS_LIMIT */ .F3),
    _value_features__WEBPACK_IMPORTED_MODULE_1__.MOBILE
];
var BASIC_TIER_VALUE_FEATURES = function(param) {
    var hasFreeTier = param.hasFreeTier;
    if (hasFreeTier) {
        return [
            _value_features__WEBPACK_IMPORTED_MODULE_1__.UNLIMITED_VIEWERS,
            _value_features__WEBPACK_IMPORTED_MODULE_1__.UNLIMITED_ITEMS,
            _value_features__WEBPACK_IMPORTED_MODULE_1__.FIVE_GB_STORAGE,
            _value_features__WEBPACK_IMPORTED_MODULE_1__.PRIORITISED_CUSTOMER_SUPPORT,
            _value_features__WEBPACK_IMPORTED_MODULE_1__.SINGLE_DASHBOARD
        ];
    }
    return [
        _value_features__WEBPACK_IMPORTED_MODULE_1__.UNLIMITED_BOARDS,
        _value_features__WEBPACK_IMPORTED_MODULE_1__.UNLIMITED_DOCS,
        _value_features__WEBPACK_IMPORTED_MODULE_1__.OVER_200_TEMPLATES,
        _value_features__WEBPACK_IMPORTED_MODULE_1__.COLUMN_TYPES,
        _value_features__WEBPACK_IMPORTED_MODULE_1__.UNLIMITED_VIEWERS,
        _value_features__WEBPACK_IMPORTED_MODULE_1__.MOBILE,
        _value_features__WEBPACK_IMPORTED_MODULE_1__.SINGLE_DASHBOARD
    ];
};
var STANDARD_TIER_VALUE_FEATURES = function(param) {
    var withoutBasic = param.withoutBasic, hasFreeTier = param.hasFreeTier;
    return withoutBasic ? hasFreeTier ? [
        _value_features__WEBPACK_IMPORTED_MODULE_1__.UNLIMITED_VIEWERS,
        _value_features__WEBPACK_IMPORTED_MODULE_1__.UNLIMITED_ITEMS,
        _value_features__WEBPACK_IMPORTED_MODULE_1__.PRIORITISED_CUSTOMER_SUPPORT,
        _value_features__WEBPACK_IMPORTED_MODULE_1__.TIMELINE_AND_GANTT_VIEWS,
        _value_features__WEBPACK_IMPORTED_MODULE_1__.CALENDAR,
        _value_features__WEBPACK_IMPORTED_MODULE_1__.GUESTS,
        _value_features__WEBPACK_IMPORTED_MODULE_1__.STANDARD_AUTOMATIONS,
        _value_features__WEBPACK_IMPORTED_MODULE_1__.STANDARD_INTEGRATIONS,
        _value_features__WEBPACK_IMPORTED_MODULE_1__.STANDARD_DASHBOARDS
    ] : [
        _value_features__WEBPACK_IMPORTED_MODULE_1__.UNLIMITED_BOARDS,
        _value_features__WEBPACK_IMPORTED_MODULE_1__.UNLIMITED_DOCS,
        _value_features__WEBPACK_IMPORTED_MODULE_1__.UNLIMITED_VIEWERS,
        _value_features__WEBPACK_IMPORTED_MODULE_1__.OVER_200_TEMPLATES,
        _value_features__WEBPACK_IMPORTED_MODULE_1__.COLUMN_TYPES,
        _value_features__WEBPACK_IMPORTED_MODULE_1__.TIMELINE_AND_GANTT_VIEWS,
        _value_features__WEBPACK_IMPORTED_MODULE_1__.CALENDAR,
        _value_features__WEBPACK_IMPORTED_MODULE_1__.GUESTS,
        _value_features__WEBPACK_IMPORTED_MODULE_1__.STANDARD_AUTOMATIONS,
        _value_features__WEBPACK_IMPORTED_MODULE_1__.STANDARD_INTEGRATIONS,
        _value_features__WEBPACK_IMPORTED_MODULE_1__.STANDARD_DASHBOARDS,
        _value_features__WEBPACK_IMPORTED_MODULE_1__.MOBILE
    ] : [
        _value_features__WEBPACK_IMPORTED_MODULE_1__.TIMELINE_AND_GANTT_VIEWS,
        _value_features__WEBPACK_IMPORTED_MODULE_1__.CALENDAR,
        _value_features__WEBPACK_IMPORTED_MODULE_1__.GUESTS,
        _value_features__WEBPACK_IMPORTED_MODULE_1__.STANDARD_AUTOMATIONS,
        _value_features__WEBPACK_IMPORTED_MODULE_1__.STANDARD_INTEGRATIONS,
        _value_features__WEBPACK_IMPORTED_MODULE_1__.STANDARD_DASHBOARDS
    ];
};
var PRO_TIER_VALUE_FEATURES = [
    _value_features__WEBPACK_IMPORTED_MODULE_1__.PRIVATE_BOARDS,
    _value_features__WEBPACK_IMPORTED_MODULE_1__.CHART_VIEW,
    _value_features__WEBPACK_IMPORTED_MODULE_1__.TIME_TRACKING,
    _value_features__WEBPACK_IMPORTED_MODULE_1__.FORMULA,
    _value_features__WEBPACK_IMPORTED_MODULE_1__.DEPENDENCY,
    _value_features__WEBPACK_IMPORTED_MODULE_1__.PRO_AUTOMATIONS,
    _value_features__WEBPACK_IMPORTED_MODULE_1__.PRO_INTEGRATIONS,
    _value_features__WEBPACK_IMPORTED_MODULE_1__.PRO_DASHBOARDS
];
var STUDENT_PLAN_VALUE_FEATURES = [
    _value_features__WEBPACK_IMPORTED_MODULE_1__.UNLIMITED_BOARDS,
    _value_features__WEBPACK_IMPORTED_MODULE_1__.OVER_200_TEMPLATES,
    _value_features__WEBPACK_IMPORTED_MODULE_1__.COLUMN_TYPES,
    _value_features__WEBPACK_IMPORTED_MODULE_1__.UNLIMITED_VIEWERS,
    _value_features__WEBPACK_IMPORTED_MODULE_1__.MOBILE,
    _value_features__WEBPACK_IMPORTED_MODULE_1__.CHART_VIEW
];
var ENTERPRISE_TIER_VALUE_FEATURES = [
    _value_features__WEBPACK_IMPORTED_MODULE_1__.ENTERPRISE_SCALE_AUTOMATIONS,
    _value_features__WEBPACK_IMPORTED_MODULE_1__.ENTERPRISE_GRADE_SECURITY,
    _value_features__WEBPACK_IMPORTED_MODULE_1__.ADVANCED_REPORTING,
    _value_features__WEBPACK_IMPORTED_MODULE_1__.MULTI_LEVEL_PERMISSIONS,
    _value_features__WEBPACK_IMPORTED_MODULE_1__.TAILORED_ONBOARDING,
    _value_features__WEBPACK_IMPORTED_MODULE_1__.PREMIUM_SUPPORT,
    _value_features__WEBPACK_IMPORTED_MODULE_1__.ENTERPRISE_DASHBOARDS
];


/***/ }),

/***/ 49127:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ADOBE_CREATIVE_CLOUD_PLUGIN": function() { return /* binding */ ADOBE_CREATIVE_CLOUD_PLUGIN; },
/* harmony export */   "ADVANCED_FORMULA_CAPABILITIES": function() { return /* binding */ ADVANCED_FORMULA_CAPABILITIES; },
/* harmony export */   "ADVANCED_PERMISSIONS": function() { return /* binding */ ADVANCED_PERMISSIONS; },
/* harmony export */   "ADVANCED_PROJECT_PORTFOLIO_MANAGEMENT": function() { return /* binding */ ADVANCED_PROJECT_PORTFOLIO_MANAGEMENT; },
/* harmony export */   "ADVANCED_REPORTING": function() { return /* binding */ ADVANCED_REPORTING; },
/* harmony export */   "ADVANCED_REPORTS": function() { return /* binding */ ADVANCED_REPORTS; },
/* harmony export */   "AGILE_REPORTING": function() { return /* binding */ AGILE_REPORTING; },
/* harmony export */   "API_ACCESS": function() { return /* binding */ API_ACCESS; },
/* harmony export */   "ASSETS_AND_FILE_MANAGEMENT": function() { return /* binding */ ASSETS_AND_FILE_MANAGEMENT; },
/* harmony export */   "BASIC_ANALYTICS_AND_DASHBOARDS": function() { return /* binding */ BASIC_ANALYTICS_AND_DASHBOARDS; },
/* harmony export */   "BOARD_PERMISSIONS": function() { return /* binding */ BOARD_PERMISSIONS; },
/* harmony export */   "BUILT_IN_WORKOCS": function() { return /* binding */ BUILT_IN_WORKOCS; },
/* harmony export */   "CALENDAR": function() { return /* binding */ CALENDAR; },
/* harmony export */   "CALENDAR_SYNC": function() { return /* binding */ CALENDAR_SYNC; },
/* harmony export */   "CAMPAIGN_MANAGEMENT": function() { return /* binding */ CAMPAIGN_MANAGEMENT; },
/* harmony export */   "CHART_VIEW": function() { return /* binding */ CHART_VIEW; },
/* harmony export */   "COLUMN_TYPES": function() { return /* binding */ COLUMN_TYPES; },
/* harmony export */   "COMMUNICATION_WITH_CONTEXT": function() { return /* binding */ COMMUNICATION_WITH_CONTEXT; },
/* harmony export */   "CUSTOMIZED_NOTIFICATIONS": function() { return /* binding */ CUSTOMIZED_NOTIFICATIONS; },
/* harmony export */   "CUSTOM_NOTIFICATIONS_AND_REMINDERS": function() { return /* binding */ CUSTOM_NOTIFICATIONS_AND_REMINDERS; },
/* harmony export */   "DEADLINE_MANAGEMENT": function() { return /* binding */ DEADLINE_MANAGEMENT; },
/* harmony export */   "DEPENDENCY": function() { return /* binding */ DEPENDENCY; },
/* harmony export */   "DEV_FEEDBACK_FORMS": function() { return /* binding */ DEV_FEEDBACK_FORMS; },
/* harmony export */   "DEV_TEMPLATES": function() { return /* binding */ DEV_TEMPLATES; },
/* harmony export */   "DOCUMENT_MANAGEMENT": function() { return /* binding */ DOCUMENT_MANAGEMENT; },
/* harmony export */   "EMAIL_INTEGRATION": function() { return /* binding */ EMAIL_INTEGRATION; },
/* harmony export */   "ENTERPRISE_DASHBOARDS": function() { return /* binding */ ENTERPRISE_DASHBOARDS; },
/* harmony export */   "ENTERPRISE_GRADE_SECURITY": function() { return /* binding */ ENTERPRISE_GRADE_SECURITY; },
/* harmony export */   "ENTERPRISE_INTEGRATIONS": function() { return /* binding */ ENTERPRISE_INTEGRATIONS; },
/* harmony export */   "ENTERPRISE_SCALE_AUTOMATIONS": function() { return /* binding */ ENTERPRISE_SCALE_AUTOMATIONS; },
/* harmony export */   "ENTERPRISE_SPECIFIC_INTEGRATIONS": function() { return /* binding */ ENTERPRISE_SPECIFIC_INTEGRATIONS; },
/* harmony export */   "FILE_MANAGEMENT": function() { return /* binding */ FILE_MANAGEMENT; },
/* harmony export */   "FILTERS": function() { return /* binding */ FILTERS; },
/* harmony export */   "FIVE_GB_STORAGE": function() { return /* binding */ FIVE_GB_STORAGE; },
/* harmony export */   "FORMS": function() { return /* binding */ FORMS; },
/* harmony export */   "FORMULA": function() { return /* binding */ FORMULA; },
/* harmony export */   "FULL_MOBILE_CRM": function() { return /* binding */ FULL_MOBILE_CRM; },
/* harmony export */   "GANTT_CHARTS": function() { return /* binding */ GANTT_CHARTS; },
/* harmony export */   "GIT_INTEGRATIONS": function() { return /* binding */ GIT_INTEGRATIONS; },
/* harmony export */   "GUESTS": function() { return /* binding */ GUESTS; },
/* harmony export */   "HIGH_LEVEL_MARKETING_PLANNING": function() { return /* binding */ HIGH_LEVEL_MARKETING_PLANNING; },
/* harmony export */   "IMPORT_EXPORT_EXCEL": function() { return /* binding */ IMPORT_EXPORT_EXCEL; },
/* harmony export */   "KANBAN_MANAGEMENT": function() { return /* binding */ KANBAN_MANAGEMENT; },
/* harmony export */   "KANBAN_VIEW": function() { return /* binding */ KANBAN_VIEW; },
/* harmony export */   "LEAD_MANAGEMENT": function() { return /* binding */ LEAD_MANAGEMENT; },
/* harmony export */   "LIMITED_COLUMN_TYPES": function() { return /* binding */ LIMITED_COLUMN_TYPES; },
/* harmony export */   "MAILCHIMP_INTEGRATION": function() { return /* binding */ MAILCHIMP_INTEGRATION; },
/* harmony export */   "MARKETING_ACTIVITY_MANAGEMENT": function() { return /* binding */ MARKETING_ACTIVITY_MANAGEMENT; },
/* harmony export */   "MARKETING_ANALYTICS": function() { return /* binding */ MARKETING_ANALYTICS; },
/* harmony export */   "MARKETING_REQUESTS_WITH_FORMS": function() { return /* binding */ MARKETING_REQUESTS_WITH_FORMS; },
/* harmony export */   "MARKETING_TEMPLATES": function() { return /* binding */ MARKETING_TEMPLATES; },
/* harmony export */   "MILESTONES_MANAGEMENT": function() { return /* binding */ MILESTONES_MANAGEMENT; },
/* harmony export */   "MOBILE": function() { return /* binding */ MOBILE; },
/* harmony export */   "MULTI_LEVEL_PERMISSIONS": function() { return /* binding */ MULTI_LEVEL_PERMISSIONS; },
/* harmony export */   "OVER_200_TEMPLATES": function() { return /* binding */ OVER_200_TEMPLATES; },
/* harmony export */   "POWERFUL_ANALYTICS_AND_DASHBOARDS": function() { return /* binding */ POWERFUL_ANALYTICS_AND_DASHBOARDS; },
/* harmony export */   "PREMIUM_SUPPORT": function() { return /* binding */ PREMIUM_SUPPORT; },
/* harmony export */   "PRIORITISED_CUSTOMER_SUPPORT": function() { return /* binding */ PRIORITISED_CUSTOMER_SUPPORT; },
/* harmony export */   "PRIVATE_BOARDS": function() { return /* binding */ PRIVATE_BOARDS; },
/* harmony export */   "PRO_AUTOMATIONS": function() { return /* binding */ PRO_AUTOMATIONS; },
/* harmony export */   "PRO_DASHBOARDS": function() { return /* binding */ PRO_DASHBOARDS; },
/* harmony export */   "PRO_INTEGRATIONS": function() { return /* binding */ PRO_INTEGRATIONS; },
/* harmony export */   "RESOURCE_ALLOCATION": function() { return /* binding */ RESOURCE_ALLOCATION; },
/* harmony export */   "SALES_ANALYTICS": function() { return /* binding */ SALES_ANALYTICS; },
/* harmony export */   "SALES_GOALS": function() { return /* binding */ SALES_GOALS; },
/* harmony export */   "SEARCH": function() { return /* binding */ SEARCH; },
/* harmony export */   "SHARABLE_DEV_BOARDS": function() { return /* binding */ SHARABLE_DEV_BOARDS; },
/* harmony export */   "SHARE_INSIGHTS_WITH_GUESTS": function() { return /* binding */ SHARE_INSIGHTS_WITH_GUESTS; },
/* harmony export */   "SIMPLE_PROJECT_PORTFOLIO_MANAGEMENT": function() { return /* binding */ SIMPLE_PROJECT_PORTFOLIO_MANAGEMENT; },
/* harmony export */   "SINGLE_DASHBOARD": function() { return /* binding */ SINGLE_DASHBOARD; },
/* harmony export */   "SLACK_MSTEAMS_TODOIST_INTEGRATIONS": function() { return /* binding */ SLACK_MSTEAMS_TODOIST_INTEGRATIONS; },
/* harmony export */   "SOCIAL_CALENDAR": function() { return /* binding */ SOCIAL_CALENDAR; },
/* harmony export */   "SPRINT_MANAGEMENT": function() { return /* binding */ SPRINT_MANAGEMENT; },
/* harmony export */   "STANDARD_AUTOMATIONS": function() { return /* binding */ STANDARD_AUTOMATIONS; },
/* harmony export */   "STANDARD_DASHBOARDS": function() { return /* binding */ STANDARD_DASHBOARDS; },
/* harmony export */   "STANDARD_INTEGRATIONS": function() { return /* binding */ STANDARD_INTEGRATIONS; },
/* harmony export */   "TAILORED_ONBOARDING": function() { return /* binding */ TAILORED_ONBOARDING; },
/* harmony export */   "TASK_AND_PROJECT_DEPENDENCIES": function() { return /* binding */ TASK_AND_PROJECT_DEPENDENCIES; },
/* harmony export */   "TIMELINE": function() { return /* binding */ TIMELINE; },
/* harmony export */   "TIMELINE_AND_CALENDAR": function() { return /* binding */ TIMELINE_AND_CALENDAR; },
/* harmony export */   "TIMELINE_AND_GANTT_VIEWS": function() { return /* binding */ TIMELINE_AND_GANTT_VIEWS; },
/* harmony export */   "TIME_TRACKING": function() { return /* binding */ TIME_TRACKING; },
/* harmony export */   "UNLIMITED_BOARDS": function() { return /* binding */ UNLIMITED_BOARDS; },
/* harmony export */   "UNLIMITED_CONTACTS": function() { return /* binding */ UNLIMITED_CONTACTS; },
/* harmony export */   "UNLIMITED_CUSTOM_FIELDS": function() { return /* binding */ UNLIMITED_CUSTOM_FIELDS; },
/* harmony export */   "UNLIMITED_DOCS": function() { return /* binding */ UNLIMITED_DOCS; },
/* harmony export */   "UNLIMITED_GUESTS": function() { return /* binding */ UNLIMITED_GUESTS; },
/* harmony export */   "UNLIMITED_ITEMS": function() { return /* binding */ UNLIMITED_ITEMS; },
/* harmony export */   "UNLIMITED_PIPELINES": function() { return /* binding */ UNLIMITED_PIPELINES; },
/* harmony export */   "UNLIMITED_PRIVATE_BOARDS": function() { return /* binding */ UNLIMITED_PRIVATE_BOARDS; },
/* harmony export */   "UNLIMITED_PROJECTS_ITEMS_SUBITEMS": function() { return /* binding */ UNLIMITED_PROJECTS_ITEMS_SUBITEMS; },
/* harmony export */   "UNLIMITED_SHAREABLE_FORMS": function() { return /* binding */ UNLIMITED_SHAREABLE_FORMS; },
/* harmony export */   "UNLIMITED_TEMPLATES": function() { return /* binding */ UNLIMITED_TEMPLATES; },
/* harmony export */   "UNLIMITED_VIEWERS": function() { return /* binding */ UNLIMITED_VIEWERS; },
/* harmony export */   "UP_TO_THREE_BOARDS": function() { return /* binding */ UP_TO_THREE_BOARDS; },
/* harmony export */   "UP_TO_X_TEAM_MEMBERS": function() { return /* binding */ UP_TO_X_TEAM_MEMBERS; },
/* harmony export */   "WHITEBOARD": function() { return /* binding */ WHITEBOARD; },
/* harmony export */   "WORKFLOW_AND_APPROVAL_AUTOMATION": function() { return /* binding */ WORKFLOW_AND_APPROVAL_AUTOMATION; },
/* harmony export */   "WORK_PERFORMANCE_INSIGHTS": function() { return /* binding */ WORK_PERFORMANCE_INSIGHTS; }
/* harmony export */ });
/* harmony import */ var constants_pricing_sizes__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(42349);

var UNLIMITED_BOARDS = {
    name: "pricingPage.features.titles.unlimitedBoards",
    text: "pricingPage.features.descriptions.boards"
};
var UP_TO_THREE_BOARDS = {
    name: "pricingPage.features.titles.upTo3Boards",
    text: "pricingPage.features.descriptions.boards"
};
var UNLIMITED_DOCS = {
    name: "pricingPage.features.titles.unlimitedDocs",
    text: "pricingPage.features.descriptions.docs"
};
var UNLIMITED_ITEMS = {
    name: "pricingPage.features.titles.unlimitedItems",
    text: "pricingPage.features.descriptions.unlimitedItems"
};
var FIVE_GB_STORAGE = {
    name: "pricingPage.features.titles.fiveGBStorage",
    text: "pricingPage.features.descriptions.storage"
};
var UP_TO_X_TEAM_MEMBERS = function(teamMembersCount) {
    return {
        name: {
            key: "pricingPage.features.titles.upToXMembers",
            param: teamMembersCount
        },
        text: {
            key: "pricingPage.features.descriptions.upToXMembers",
            param: teamMembersCount
        }
    };
};
var PRIORITISED_CUSTOMER_SUPPORT = {
    name: "pricingPage.features.titles.prioritisedCustomerSupport",
    text: "pricingPage.features.descriptions.prioritisedCustomerSupport"
};
var OVER_200_TEMPLATES = {
    name: "pricingPage.features.titles.templates",
    text: "pricingPage.features.descriptions.templates"
};
var COLUMN_TYPES = {
    name: "pricingPage.features.titles.columnTypes",
    text: "pricingPage.features.descriptions.columnTypes"
};
var LIMITED_COLUMN_TYPES = {
    name: "pricingPage.features.titles.limitedColumnTypes",
    text: "pricingPage.features.descriptions.columnTypes"
};
var COMMUNICATION_WITH_CONTEXT = {
    name: "pricingPage.features.titles.communication_with_context",
    text: "pricingPage.features.descriptions.communication_with_context",
    videoPath: "https://dapulse-res.cloudinary.com/video/upload/w_".concat(constants_pricing_sizes__WEBPACK_IMPORTED_MODULE_0__/* .TIER_CARD_VIDEO_WIDTH */ .Ww, ",h_").concat(constants_pricing_sizes__WEBPACK_IMPORTED_MODULE_0__/* .TIER_CARD_VIDEO_HEIGHT */ .m6, ",c_fit/remote_mondaycom_static/developers/features/Communication_-_updates.mp4")
};
var FORMS = {
    name: "pricingPage.features.titles.forms.simple",
    text: "pricingPage.features.descriptions.forms",
    videoPath: "https://dapulse-res.cloudinary.com/video/upload/w_".concat(constants_pricing_sizes__WEBPACK_IMPORTED_MODULE_0__/* .TIER_CARD_VIDEO_WIDTH */ .Ww, ",h_").concat(constants_pricing_sizes__WEBPACK_IMPORTED_MODULE_0__/* .TIER_CARD_VIDEO_HEIGHT */ .m6, ",c_fit/remote_mondaycom_static/developers/features/Form.mp4")
};
var KANBAN_VIEW = {
    name: "pricingPage.features.titles.kanbanView",
    text: "pricingPage.features.descriptions.kanbanView"
};
var WHITEBOARD = {
    name: "pricingPage.features.titles.whiteboard",
    text: "pricingPage.features.descriptions.whiteboard"
};
var MOBILE = {
    name: "pricingPage.features.titles.mobile",
    text: "pricingPage.features.descriptions.mobile"
};
var UNLIMITED_VIEWERS = {
    name: "pricingPage.features.titles.unlimitedViewers",
    text: "pricingPage.features.descriptions.viewers"
};
var LEAD_MANAGEMENT = {
    name: "pricingPage.features.titles.leadManagement",
    text: "pricingPage.features.descriptions.leadManagement"
};
var UNLIMITED_PIPELINES = {
    name: "pricingPage.features.titles.unlimitedPipelines",
    text: "pricingPage.features.descriptions.unlimitedPipelines"
};
var UNLIMITED_CONTACTS = {
    name: "pricingPage.features.titles.unlimitedContacts",
    text: "pricingPage.features.descriptions.unlimitedContacts"
};
var UNLIMITED_CUSTOM_FIELDS = {
    name: "pricingPage.features.titles.unlimitedCustomFields",
    text: "pricingPage.features.descriptions.unlimitedCustomFields"
};
var FULL_MOBILE_CRM = {
    name: "pricingPage.features.titles.fullMobileCRM",
    text: "pricingPage.features.descriptions.fullMobileCRM"
};
var DOCUMENT_MANAGEMENT = {
    name: "pricingPage.features.titles.documentManagement",
    text: "pricingPage.features.descriptions.documentManagement"
};
var API_ACCESS = {
    name: "pricingPage.features.titles.apiAccess",
    text: "pricingPage.features.descriptions.apiAccess"
};
var SINGLE_DASHBOARD = {
    name: "pricingPage.features.titles.basicDashboards",
    text: "pricingPage.features.descriptions.dashboards"
};
var TIMELINE_AND_GANTT_VIEWS = {
    name: "pricingPage.features.titles.timelineAndGanttView",
    text: "pricingPage.features.descriptions.timelineAndGanttView"
};
var TIMELINE = {
    name: "pricingPage.features.titles.timeline",
    text: "pricingPage.features.descriptions.timeline"
};
var CALENDAR = {
    name: "pricingPage.features.titles.calendar",
    text: "pricingPage.features.descriptions.calendar"
};
var TIMELINE_AND_CALENDAR = {
    name: "pricingPage.features.titles.timelineAndCalendarView",
    text: "pricingPage.features.descriptions.timelineAndCalendarView",
    videoPath: "https://dapulse-res.cloudinary.com/video/upload/w_".concat(constants_pricing_sizes__WEBPACK_IMPORTED_MODULE_0__/* .TIER_CARD_VIDEO_WIDTH */ .Ww, ",h_").concat(constants_pricing_sizes__WEBPACK_IMPORTED_MODULE_0__/* .TIER_CARD_VIDEO_HEIGHT */ .m6, "/remote_mondaycom_static/developers/features/Timeline_view.mp4")
};
var FILTERS = {
    name: "pricingPage.features.titles.filters",
    text: "pricingPage.features.descriptions.filters"
};
var SEARCH = {
    name: "pricingPage.features.titles.search",
    text: "pricingPage.features.descriptions.search"
};
var GUESTS = {
    name: "pricingPage.features.titles.guests",
    text: "pricingPage.features.descriptions.guests"
};
var EMAIL_INTEGRATION = {
    name: "pricingPage.features.titles.emailIntegration",
    text: "pricingPage.features.descriptions.emailIntegration"
};
var SALES_ANALYTICS = {
    name: "pricingPage.features.titles.salesAnalytics",
    text: "pricingPage.features.descriptions.salesAnalytics"
};
var MAILCHIMP_INTEGRATION = {
    name: "pricingPage.features.titles.mailchimpIntegration",
    text: "pricingPage.features.descriptions.mailchimpIntegration"
};
var SALES_GOALS = {
    name: "pricingPage.features.titles.salesGoals",
    text: "pricingPage.features.descriptions.salesGoals"
};
var STANDARD_DASHBOARDS = {
    name: "pricingPage.features.titles.standardDashboards",
    text: "pricingPage.features.descriptions.dashboards",
    videoPath: "https://dapulse-res.cloudinary.com/video/upload/w_".concat(constants_pricing_sizes__WEBPACK_IMPORTED_MODULE_0__/* .TIER_CARD_VIDEO_WIDTH */ .Ww, ",h_").concat(constants_pricing_sizes__WEBPACK_IMPORTED_MODULE_0__/* .TIER_CARD_VIDEO_HEIGHT */ .m6, ",c_fit/remote_mondaycom_static/developers/features/Dashboard_standard.mp4")
};
var STANDARD_AUTOMATIONS = {
    name: "pricingPage.valueFeatures.titles.automations.standard",
    text: "pricingPage.features.descriptions.automations",
    link: "https://support.monday.com/hc/en-us/articles/360002826680",
    videoPath: "https://dapulse-res.cloudinary.com/video/upload/w_".concat(constants_pricing_sizes__WEBPACK_IMPORTED_MODULE_0__/* .TIER_CARD_VIDEO_WIDTH */ .Ww, ",h_").concat(constants_pricing_sizes__WEBPACK_IMPORTED_MODULE_0__/* .TIER_CARD_VIDEO_HEIGHT */ .m6, ",c_fit/remote_mondaycom_static/developers/features/Automations.mp4")
};
var STANDARD_INTEGRATIONS = {
    name: "pricingPage.valueFeatures.titles.integrations.standard",
    text: "pricingPage.features.descriptions.integrations",
    link: "https://support.monday.com/hc/en-us/articles/360002826680",
    videoPath: "https://dapulse-res.cloudinary.com/video/upload/w_".concat(constants_pricing_sizes__WEBPACK_IMPORTED_MODULE_0__/* .TIER_CARD_VIDEO_WIDTH */ .Ww, ",h_").concat(constants_pricing_sizes__WEBPACK_IMPORTED_MODULE_0__/* .TIER_CARD_VIDEO_HEIGHT */ .m6, ",c_fit/remote_mondaycom_static/developers/features/Integrations.mp4")
};
var PRIVATE_BOARDS = {
    name: "pricingPage.features.titles.privateBoards",
    text: "pricingPage.features.descriptions.privateBoards",
    videoPath: "https://dapulse-res.cloudinary.com/video/upload/w_".concat(constants_pricing_sizes__WEBPACK_IMPORTED_MODULE_0__/* .TIER_CARD_VIDEO_WIDTH */ .Ww, ",h_").concat(constants_pricing_sizes__WEBPACK_IMPORTED_MODULE_0__/* .TIER_CARD_VIDEO_HEIGHT */ .m6, ",c_fit/remote_mondaycom_static/developers/features/Private_board.mp4")
};
var BOARD_PERMISSIONS = {
    name: "pricingPage.features.titles.boardPermissions",
    text: "pricingPage.features.descriptions.boardPermissions",
    videoPath: "https://dapulse-res.cloudinary.com/video/upload/w_".concat(constants_pricing_sizes__WEBPACK_IMPORTED_MODULE_0__/* .TIER_CARD_VIDEO_WIDTH */ .Ww, ",h_").concat(constants_pricing_sizes__WEBPACK_IMPORTED_MODULE_0__/* .TIER_CARD_VIDEO_HEIGHT */ .m6, ",c_fit/remote_mondaycom_static/developers/features/Board_permission.mp4")
};
var CHART_VIEW = {
    name: "pricingPage.features.titles.chartView",
    text: "pricingPage.features.descriptions.chartView",
    videoPath: "https://dapulse-res.cloudinary.com/video/upload/w_".concat(constants_pricing_sizes__WEBPACK_IMPORTED_MODULE_0__/* .TIER_CARD_VIDEO_WIDTH */ .Ww, ",h_").concat(constants_pricing_sizes__WEBPACK_IMPORTED_MODULE_0__/* .TIER_CARD_VIDEO_HEIGHT */ .m6, ",c_fit/remote_mondaycom_static/developers/features/Chart_view.mp4")
};
var TIME_TRACKING = {
    name: "pricingPage.features.titles.timeTracking",
    text: "pricingPage.features.descriptions.timeTracking"
};
var FORMULA = {
    name: "pricingPage.features.titles.formula",
    text: "pricingPage.features.descriptions.formula"
};
var DEPENDENCY = {
    name: "pricingPage.features.titles.dependencyColumn",
    text: "pricingPage.features.descriptions.dependencyColumn"
};
var UNLIMITED_GUESTS = {
    name: "pricingPage.features.titles.unlimitedGuests",
    text: ""
};
var CUSTOMIZED_NOTIFICATIONS = {
    name: "pricingPage.features.titles.customizedNotifications",
    text: "pricingPage.features.descriptions.customizedNotifications"
};
var MARKETING_ACTIVITY_MANAGEMENT = {
    name: "pricingPage.features.titles.marketingActivityManagement",
    text: "pricingPage.features.descriptions.marketingActivityManagement"
};
var ADVANCED_PERMISSIONS = {
    name: "pricingPage.features.titles.advancedPermissions",
    text: "pricingPage.features.descriptions.boardPermissions"
};
var WORKFLOW_AND_APPROVAL_AUTOMATION = {
    name: "pricingPage.features.titles.workflowAndApprovalAutomation",
    text: "pricingPage.features.descriptions.workflowAndApprovalAutomation"
};
var ADVANCED_REPORTS = {
    name: "pricingPage.features.titles.advancedReports",
    text: "pricingPage.features.descriptions.dashboards"
};
var PRO_DASHBOARDS = {
    name: "pricingPage.features.titles.proDashboards",
    text: "pricingPage.features.descriptions.dashboards",
    videoPath: "https://dapulse-res.cloudinary.com/video/upload/w_".concat(constants_pricing_sizes__WEBPACK_IMPORTED_MODULE_0__/* .TIER_CARD_VIDEO_WIDTH */ .Ww, ",h_").concat(constants_pricing_sizes__WEBPACK_IMPORTED_MODULE_0__/* .TIER_CARD_VIDEO_HEIGHT */ .m6, ",c_fit/remote_mondaycom_static/developers/features/Dashboard.mp4")
};
var PRO_AUTOMATIONS = {
    name: "pricingPage.valueFeatures.titles.automations.pro",
    text: "pricingPage.features.descriptions.automations",
    link: "https://support.monday.com/hc/en-us/articles/360002826680",
    videoPath: "https://dapulse-res.cloudinary.com/video/upload/w_".concat(constants_pricing_sizes__WEBPACK_IMPORTED_MODULE_0__/* .TIER_CARD_VIDEO_WIDTH */ .Ww, ",h_").concat(constants_pricing_sizes__WEBPACK_IMPORTED_MODULE_0__/* .TIER_CARD_VIDEO_HEIGHT */ .m6, ",c_fit/remote_mondaycom_static/developers/features/Automations.mp4")
};
var PRO_INTEGRATIONS = {
    name: "pricingPage.valueFeatures.titles.integrations.pro",
    text: "pricingPage.features.descriptions.integrations",
    link: "https://support.monday.com/hc/en-us/articles/360002826680",
    videoPath: "https://dapulse-res.cloudinary.com/video/upload/w_".concat(constants_pricing_sizes__WEBPACK_IMPORTED_MODULE_0__/* .TIER_CARD_VIDEO_WIDTH */ .Ww, ",h_").concat(constants_pricing_sizes__WEBPACK_IMPORTED_MODULE_0__/* .TIER_CARD_VIDEO_HEIGHT */ .m6, ",c_fit/remote_mondaycom_static/developers/features/Integrations.mp4")
};
var ENTERPRISE_SCALE_AUTOMATIONS = {
    name: "pricingPage.features.titles.enterpriseScaleAutomations",
    text: "pricingPage.features.descriptions.enterpriseScaleAutomations",
    link: "https://support.monday.com/hc/en-us/articles/360002826680"
};
var ENTERPRISE_SPECIFIC_INTEGRATIONS = {
    name: "pricingPage.features.titles.enterpriseSpecificIntegrations",
    text: "pricingPage.features.descriptions.enterpriseSpecifciIntegrations"
};
var ENTERPRISE_GRADE_SECURITY = {
    name: "pricingPage.features.titles.enterpriseGradeSecurity",
    text: "pricingPage.features.descriptions.enterpriseGradeSecurity"
};
var ADVANCED_REPORTING = {
    name: "pricingPage.features.titles.advancedReporting",
    text: "pricingPage.features.descriptions.advancedReporting"
};
var MULTI_LEVEL_PERMISSIONS = {
    name: "pricingPage.features.titles.multiLevelPermissions",
    text: "pricingPage.features.descriptions.multiLevelPermissions"
};
var TAILORED_ONBOARDING = {
    name: "pricingPage.features.titles.tailoredOnboarding",
    text: "pricingPage.features.descriptions.tailoredOnboarding"
};
var PREMIUM_SUPPORT = {
    name: "pricingPage.features.titles.premiumSupport",
    text: "pricingPage.features.descriptions.premiumSupport"
};
var ENTERPRISE_DASHBOARDS = {
    name: "pricingPage.features.titles.enterpriseDashboards",
    text: "pricingPage.features.descriptions.fiftyDashboards"
};
// added for marketing:
var MARKETING_TEMPLATES = {
    name: "pricingPage.features.titles.ready_made_marketing_templates",
    text: "pricingPage.features.descriptions.ready_made_marketing_templates"
};
var MARKETING_REQUESTS_WITH_FORMS = {
    name: "pricingPage.features.titles.marketing_requests_with_forms",
    text: "pricingPage.features.descriptions.marketing_requests_with_forms"
};
var UNLIMITED_TEMPLATES = {
    name: "pricingPage.features.titles.unlimited_templates",
    text: "pricingPage.features.descriptions.ready_made_marketing_templates"
};
var WORK_PERFORMANCE_INSIGHTS = {
    name: "pricingPage.features.titles.workPerformanceInsights",
    text: "pricingPage.features.descriptions.workPerformanceInsights"
};
var ASSETS_AND_FILE_MANAGEMENT = {
    name: "pricingPage.features.titles.assets_and_file_management",
    text: "pricingPage.features.descriptions.embed_documents_and_briefs"
};
var IMPORT_EXPORT_EXCEL = {
    name: "pricingPage.features.titles.import_export_excel",
    text: "pricingPage.features.descriptions.import_export_excel"
};
var SOCIAL_CALENDAR = {
    name: "pricingPage.features.titles.social_calendar",
    text: "pricingPage.features.descriptions.marketing_calendar"
};
var SHARE_INSIGHTS_WITH_GUESTS = {
    name: "pricingPage.features.titles.share_insights_with_guests",
    text: "pricingPage.features.descriptions.guests"
};
var MARKETING_ANALYTICS = {
    name: "pricingPage.features.titles.marketing_analytics",
    text: "pricingPage.features.descriptions.marketing_dashboards"
};
var DEADLINE_MANAGEMENT = {
    name: "pricingPage.features.titles.deadline_management",
    text: "pricingPage.features.descriptions.deadline_management"
};
var CAMPAIGN_MANAGEMENT = {
    name: "pricingPage.features.titles.campaign_management",
    text: "pricingPage.features.descriptions.campaign_management"
};
var HIGH_LEVEL_MARKETING_PLANNING = {
    name: "pricingPage.features.titles.high_level_marketing_planning",
    text: "pricingPage.features.descriptions.high_level_marketing_planning"
};
var ADOBE_CREATIVE_CLOUD_PLUGIN = {
    name: "pricingPage.features.titles.adobe_creative_cloud_plugin",
    text: "pricingPage.features.descriptions.adobe_creative_cloud_plugin"
};
var UNLIMITED_PROJECTS_ITEMS_SUBITEMS = {
    name: "pricingPage.features.titles.unlimitedProjectsItemsSubitems",
    text: "pricingPage.features.descriptions.unlimitedProjectsItemsSubitems"
};
var UNLIMITED_SHAREABLE_FORMS = {
    name: "pricingPage.features.titles.unlimitedShareableForms",
    text: "pricingPage.features.descriptions.unlimitedShareableForms"
};
var FILE_MANAGEMENT = {
    name: "pricingPage.features.titles.fileManagement",
    text: "pricingPage.features.descriptions.fileManagement"
};
var GANTT_CHARTS = {
    name: "pricingPage.features.titles.ganttCharts",
    text: "pricingPage.features.descriptions.ganttCharts"
};
var CUSTOM_NOTIFICATIONS_AND_REMINDERS = {
    name: "pricingPage.features.titles.customNotificationsAndReminders",
    text: "pricingPage.features.descriptions.customNotificationsAndReminders"
};
var SIMPLE_PROJECT_PORTFOLIO_MANAGEMENT = {
    name: "pricingPage.features.titles.projectPortfolioManagement",
    text: "pricingPage.features.descriptions.projectPortfolioManagement"
};
var CALENDAR_SYNC = {
    name: "pricingPage.features.titles.calendarSync",
    text: "pricingPage.features.descriptions.calendarSync"
};
var BASIC_ANALYTICS_AND_DASHBOARDS = {
    name: "pricingPage.features.titles.basicAnalytics",
    text: "pricingPage.features.descriptions.basicAnalytics"
};
var TASK_AND_PROJECT_DEPENDENCIES = {
    name: "pricingPage.features.titles.taskAndProjectDependencies",
    text: "pricingPage.features.descriptions.taskAndProjectDependencies"
};
var MILESTONES_MANAGEMENT = {
    name: "pricingPage.features.titles.milestonesManagement",
    text: "pricingPage.features.descriptions.milestonesManagement"
};
var RESOURCE_ALLOCATION = {
    name: "pricingPage.features.titles.resourceAllocation",
    text: "pricingPage.features.descriptions.resourceAllocation"
};
var POWERFUL_ANALYTICS_AND_DASHBOARDS = {
    name: "pricingPage.features.titles.powerfulAnalytics",
    text: "pricingPage.features.descriptions.powerfulAnalytics"
};
var UNLIMITED_PRIVATE_BOARDS = {
    name: "pricingPage.features.titles.unlimitedPrivateBoards",
    text: "pricingPage.features.descriptions.privateBoards"
};
var ADVANCED_FORMULA_CAPABILITIES = {
    name: "pricingPage.features.titles.advancedFormulaCapabilities",
    text: "pricingPage.features.descriptions.formula"
};
var SLACK_MSTEAMS_TODOIST_INTEGRATIONS = {
    name: "pricingPage.features.titles.slackMSTeamsTodoistIntegrations",
    text: "pricingPage.features.descriptions.slackMSTeamsTodoistIntegrations"
};
var ADVANCED_PROJECT_PORTFOLIO_MANAGEMENT = {
    name: "pricingPage.features.titles.advancedProjectPortfolioManagement",
    text: "pricingPage.features.descriptions.advancedProjectPortfolioManagement"
};
var ENTERPRISE_INTEGRATIONS = {
    name: "pricingPage.features.titles.enterpriseIntegrations",
    text: "pricingPage.features.descriptions.enterpriseIntegrations"
};
var SPRINT_MANAGEMENT = {
    name: "pricingPage.features.titles.sprint_management",
    text: "pricingPage.features.descriptions.sprint_management"
};
var KANBAN_MANAGEMENT = {
    name: "pricingPage.features.titles.kanban_management",
    text: "pricingPage.features.descriptions.kanban_management"
};
var DEV_TEMPLATES = {
    name: "pricingPage.features.titles.dev_templates",
    text: "pricingPage.features.descriptions.dev_templates"
};
var BUILT_IN_WORKOCS = {
    name: "pricingPage.features.titles.workdocs",
    text: "pricingPage.features.descriptions.workdocs"
};
var SHARABLE_DEV_BOARDS = {
    name: "pricingPage.products.software.featuresList.shareableBoardsWithExternalStakeholders",
    text: "pricingPage.products.software.featuresList.shareableBoardsWithExternalStakeholders.description"
};
var GIT_INTEGRATIONS = {
    name: "pricingPage.features.titles.git_integrations",
    text: "pricingPage.features.descriptions.git_integrations"
};
var AGILE_REPORTING = {
    name: "pricingPage.features.titles.agile_reporting",
    text: "pricingPage.features.descriptions.agile_reporting"
};
var DEV_FEEDBACK_FORMS = {
    name: "pricingPage.products.software.featuresList.customerFeedbackAndRequests",
    text: "pricingPage.products.software.featuresList.customerFeedbackAndRequests.description"
};


/***/ }),

/***/ 16168:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "K8": function() { return /* binding */ SECURITY_AND_PRIVACY; },
/* harmony export */   "Kk": function() { return /* binding */ CUSTOMER_FAVORITES; },
/* harmony export */   "QA": function() { return /* binding */ SUPPORT_NEW; },
/* harmony export */   "RV": function() { return /* binding */ REMOTE_WORK_FEATURES_SECTION; },
/* harmony export */   "UO": function() { return /* binding */ ADVANCED; },
/* harmony export */   "VG": function() { return /* binding */ getDefaultSections; },
/* harmony export */   "Xn": function() { return /* binding */ ADMINISTRATION_AND_CONTROL; },
/* harmony export */   "_h": function() { return /* binding */ SECURITY_NEW; },
/* harmony export */   "iz": function() { return /* binding */ COLLABORATION; },
/* harmony export */   "k3": function() { return /* binding */ ADVANCED_REPORTING; },
/* harmony export */   "lG": function() { return /* binding */ SECURITY; },
/* harmony export */   "nD": function() { return /* binding */ PRODUCTIVITY; },
/* harmony export */   "uK": function() { return /* binding */ VIEWS_AND_REPORTING; },
/* harmony export */   "wL": function() { return /* binding */ SUPPORT; },
/* harmony export */   "zw": function() { return /* binding */ ENTERPRISE_REPORTING_AND_ANALYTICS; }
/* harmony export */ });
/* unused harmony export NEW_PRICING_PAGE_DEFAULT_SECTIONS */
/* harmony import */ var _features_features__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(61980);

var CUSTOMER_FAVORITES = function(param) {
    var hasStudentPlan = param.hasStudentPlan, cookies = param.cookies;
    return {
        sectionName: "pricingPage.features.sections.customer_favorites",
        features: [
            _features_features__WEBPACK_IMPORTED_MODULE_0__.UNLIMITED_BOARDS,
            _features_features__WEBPACK_IMPORTED_MODULE_0__.TEMPLATES,
            _features_features__WEBPACK_IMPORTED_MODULE_0__.COLUMN_TYPES({
                cookies: cookies
            }),
            _features_features__WEBPACK_IMPORTED_MODULE_0__.UNLIMITED_VIEWERS,
            _features_features__WEBPACK_IMPORTED_MODULE_0__.FORMS,
            _features_features__WEBPACK_IMPORTED_MODULE_0__.MOBILE,
            _features_features__WEBPACK_IMPORTED_MODULE_0__.IMPORT_FROM_OTHER_TOOLS,
            _features_features__WEBPACK_IMPORTED_MODULE_0__.TIMELINE({
                hasStudentPlan: hasStudentPlan
            }),
            _features_features__WEBPACK_IMPORTED_MODULE_0__.PRIVATE_BOARDS,
            _features_features__WEBPACK_IMPORTED_MODULE_0__.AUTOMATIONS
        ]
    };
};
var COLLABORATION = function(param) {
    var cookies = param.cookies, abTests = param.abTests, hasFreeTier = param.hasFreeTier, hasStudentPlan = param.hasStudentPlan;
    var featuresList = [
        _features_features__WEBPACK_IMPORTED_MODULE_0__.EMBEDDED_BOARD,
        _features_features__WEBPACK_IMPORTED_MODULE_0__.WHITEBOARD,
        _features_features__WEBPACK_IMPORTED_MODULE_0__.UPDATES_SECTION,
        _features_features__WEBPACK_IMPORTED_MODULE_0__.ZOOM_INTEGRATION,
        _features_features__WEBPACK_IMPORTED_MODULE_0__.GUESTS
    ];
    if (!(hasFreeTier || hasStudentPlan)) {
        // otherwise, the following features already appear via the 'ESSENTIALS' section.
        featuresList.unshift(_features_features__WEBPACK_IMPORTED_MODULE_0__.UNLIMITED_VIEWERS);
        featuresList.push(_features_features__WEBPACK_IMPORTED_MODULE_0__.STORAGE({
            cookies: cookies,
            abTests: abTests
        }));
    }
    return {
        sectionName: "pricingPage.features.sections.collaboration",
        features: featuresList
    };
};
var PRODUCTIVITY = function(param) {
    var hasStudentPlan = param.hasStudentPlan;
    return {
        sectionName: "pricingPage.features.sections.productivity",
        features: [
            _features_features__WEBPACK_IMPORTED_MODULE_0__.MOBILE,
            _features_features__WEBPACK_IMPORTED_MODULE_0__.FORMS,
            _features_features__WEBPACK_IMPORTED_MODULE_0__.CUSTOMIZABLE_NOTIFICATIONS,
            _features_features__WEBPACK_IMPORTED_MODULE_0__.INTEGRATIONS,
            _features_features__WEBPACK_IMPORTED_MODULE_0__.AUTOMATIONS,
            _features_features__WEBPACK_IMPORTED_MODULE_0__.PREMIUM_INTEGRATIONS,
            _features_features__WEBPACK_IMPORTED_MODULE_0__.TIME_TRACKING,
            _features_features__WEBPACK_IMPORTED_MODULE_0__.FORMULA({
                hasStudentPlan: hasStudentPlan
            }),
            _features_features__WEBPACK_IMPORTED_MODULE_0__.DEPENDENCY_COLUMN
        ]
    };
};
var VIEWS_AND_REPORTING = function(param) {
    var hasStudentPlan = param.hasStudentPlan;
    return {
        sectionName: "pricingPage.features.sections.views_and_reporting",
        features: [
            _features_features__WEBPACK_IMPORTED_MODULE_0__.ACTIVITY_LOG,
            _features_features__WEBPACK_IMPORTED_MODULE_0__.DASHBOARDS({
                hasStudentPlan: hasStudentPlan
            }),
            _features_features__WEBPACK_IMPORTED_MODULE_0__.KANBAN_VIEW,
            _features_features__WEBPACK_IMPORTED_MODULE_0__.TIMELINE({
                hasStudentPlan: hasStudentPlan
            }),
            _features_features__WEBPACK_IMPORTED_MODULE_0__.CALENDAR({
                hasStudentPlan: hasStudentPlan
            }),
            _features_features__WEBPACK_IMPORTED_MODULE_0__.MAP,
            _features_features__WEBPACK_IMPORTED_MODULE_0__.CHART_VIEW({
                hasStudentPlan: hasStudentPlan
            }),
            _features_features__WEBPACK_IMPORTED_MODULE_0__.WORKLOAD
        ]
    };
};
// Newest, winning version.
var SUPPORT_NEW = {
    sectionName: "pricingPage.features.sections.support",
    features: [
        _features_features__WEBPACK_IMPORTED_MODULE_0__.KNOWLEDGE_BASE,
        _features_features__WEBPACK_IMPORTED_MODULE_0__.EMAIL_SUPPORT,
        _features_features__WEBPACK_IMPORTED_MODULE_0__.WEBINARS,
        _features_features__WEBPACK_IMPORTED_MODULE_0__.CS_MANAGER,
        _features_features__WEBPACK_IMPORTED_MODULE_0__.SLA
    ]
};
// New, winning version.
var SECURITY_AND_PRIVACY = {
    sectionName: "pricingPage.features.sections.security_and_privacy",
    features: [
        _features_features__WEBPACK_IMPORTED_MODULE_0__.SOC,
        _features_features__WEBPACK_IMPORTED_MODULE_0__.TWO_FA,
        _features_features__WEBPACK_IMPORTED_MODULE_0__.PRIVATE_BOARDS,
        _features_features__WEBPACK_IMPORTED_MODULE_0__.GOOGLE,
        _features_features__WEBPACK_IMPORTED_MODULE_0__.SAML,
        _features_features__WEBPACK_IMPORTED_MODULE_0__.HIPAA,
        _features_features__WEBPACK_IMPORTED_MODULE_0__.INTEGRATION_PERMISSIONS,
        _features_features__WEBPACK_IMPORTED_MODULE_0__.IP_RESTRICTIONS,
        _features_features__WEBPACK_IMPORTED_MODULE_0__.CONTENT_DIRECTORY,
        _features_features__WEBPACK_IMPORTED_MODULE_0__.TEAMS_INSIDE_TEAMS,
        _features_features__WEBPACK_IMPORTED_MODULE_0__.CUSTOM_ROLES,
        _features_features__WEBPACK_IMPORTED_MODULE_0__.SEATS_MANAGEMENT,
        _features_features__WEBPACK_IMPORTED_MODULE_0__.TENANT_RESTRICTIONS,
        _features_features__WEBPACK_IMPORTED_MODULE_0__.APPROVED_GUEST,
        _features_features__WEBPACK_IMPORTED_MODULE_0__.BLOCK_DOMAINS
    ]
};
var ADMINISTRATION_AND_CONTROL = {
    sectionName: "pricingPage.features.sections.administration_and_control",
    features: [
        _features_features__WEBPACK_IMPORTED_MODULE_0__.MAXIMUM_SEATS,
        _features_features__WEBPACK_IMPORTED_MODULE_0__.BOARD_ADMINISTRATORS,
        _features_features__WEBPACK_IMPORTED_MODULE_0__.SCIM,
        _features_features__WEBPACK_IMPORTED_MODULE_0__.AUDIT_LOG,
        _features_features__WEBPACK_IMPORTED_MODULE_0__.SESSIONS,
        _features_features__WEBPACK_IMPORTED_MODULE_0__.PANIC_MODE,
        _features_features__WEBPACK_IMPORTED_MODULE_0__.PRIVATE_WORKSPACES,
        _features_features__WEBPACK_IMPORTED_MODULE_0__.ACCOUNT_PERMISSIONS
    ]
};
var ENTERPRISE_REPORTING_AND_ANALYTICS = {
    sectionName: "pricingPage.features.sections.enterprise_reporting_and_analytics",
    features: [
        _features_features__WEBPACK_IMPORTED_MODULE_0__.WORK_PERFORMANCE_INSIGHTS,
        _features_features__WEBPACK_IMPORTED_MODULE_0__.SCHEDULED_DASHBOARD_DELIVERY,
        _features_features__WEBPACK_IMPORTED_MODULE_0__.PIVOT_ANALYSIS
    ]
};
var NEW_PRICING_PAGE_DEFAULT_SECTIONS = function(param) {
    var cookies = param.cookies, abTests = param.abTests, hasStudentPlan = param.hasStudentPlan, hasFreeTier = param.hasFreeTier;
    return [
        CUSTOMER_FAVORITES({
            hasStudentPlan: hasStudentPlan,
            cookies: cookies
        }),
        COLLABORATION({
            cookies: cookies,
            abTests: abTests,
            hasStudentPlan: hasStudentPlan,
            hasFreeTier: hasFreeTier
        }),
        PRODUCTIVITY({
            hasStudentPlan: hasStudentPlan
        }),
        VIEWS_AND_REPORTING({
            hasStudentPlan: hasStudentPlan
        }),
        SUPPORT_NEW,
        SECURITY_AND_PRIVACY,
        ADMINISTRATION_AND_CONTROL,
        ENTERPRISE_REPORTING_AND_ANALYTICS
    ];
};
var REMOTE_WORK_FEATURES_SECTION = function(param) {
    var hasStudentPlan = param.hasStudentPlan;
    return {
        sectionName: "pricingPage.features.sections.remote_work",
        features: [
            _features_features__WEBPACK_IMPORTED_MODULE_0__.WHITEBOARD,
            _features_features__WEBPACK_IMPORTED_MODULE_0__.EMBEDDED_BOARD,
            _features_features__WEBPACK_IMPORTED_MODULE_0__.ZOOM_INTEGRATION,
            _features_features__WEBPACK_IMPORTED_MODULE_0__.TIMELINE({
                hasStudentPlan: hasStudentPlan
            }),
            _features_features__WEBPACK_IMPORTED_MODULE_0__.CALENDAR({
                hasStudentPlan: hasStudentPlan
            })
        ]
    };
};
var ADVANCED = function(param) {
    var hasStudentPlan = param.hasStudentPlan;
    return {
        sectionName: "pricingPage.features.sections.advanced",
        features: [
            _features_features__WEBPACK_IMPORTED_MODULE_0__.GUESTS,
            _features_features__WEBPACK_IMPORTED_MODULE_0__.KANBAN_VIEW,
            _features_features__WEBPACK_IMPORTED_MODULE_0__.FORMS,
            _features_features__WEBPACK_IMPORTED_MODULE_0__.MAP,
            _features_features__WEBPACK_IMPORTED_MODULE_0__.SEARCH,
            _features_features__WEBPACK_IMPORTED_MODULE_0__.FORMS_CUSTOMIZATION({
                hasStudentPlan: hasStudentPlan
            }),
            _features_features__WEBPACK_IMPORTED_MODULE_0__.WORKLOAD,
            _features_features__WEBPACK_IMPORTED_MODULE_0__.TIME_TRACKING,
            _features_features__WEBPACK_IMPORTED_MODULE_0__.CHART_VIEW({
                hasStudentPlan: hasStudentPlan
            }),
            _features_features__WEBPACK_IMPORTED_MODULE_0__.FORMULA({
                hasStudentPlan: hasStudentPlan
            }),
            _features_features__WEBPACK_IMPORTED_MODULE_0__.DEPENDENCY_COLUMN,
            _features_features__WEBPACK_IMPORTED_MODULE_0__.TAGS,
            _features_features__WEBPACK_IMPORTED_MODULE_0__.PRIVATE_BOARDS,
            _features_features__WEBPACK_IMPORTED_MODULE_0__.INTEGRATIONS,
            _features_features__WEBPACK_IMPORTED_MODULE_0__.AUTOMATIONS,
            _features_features__WEBPACK_IMPORTED_MODULE_0__.PREMIUM_INTEGRATIONS,
            _features_features__WEBPACK_IMPORTED_MODULE_0__.DASHBOARDS({
                hasStudentPlan: hasStudentPlan
            })
        ]
    };
};
// Old version, before any tests. Kept here until we're 100% sure none of the clusters use it.
var SECURITY = {
    sectionName: "pricingPage.features.sections.security",
    features: [
        _features_features__WEBPACK_IMPORTED_MODULE_0__.TWO_FA,
        _features_features__WEBPACK_IMPORTED_MODULE_0__.GOOGLE,
        _features_features__WEBPACK_IMPORTED_MODULE_0__.SAML,
        _features_features__WEBPACK_IMPORTED_MODULE_0__.SCIM,
        _features_features__WEBPACK_IMPORTED_MODULE_0__.AUDIT_LOG,
        _features_features__WEBPACK_IMPORTED_MODULE_0__.SESSIONS,
        _features_features__WEBPACK_IMPORTED_MODULE_0__.HIPAA,
        _features_features__WEBPACK_IMPORTED_MODULE_0__.SLA,
        _features_features__WEBPACK_IMPORTED_MODULE_0__.INTEGRATION_PERMISSIONS,
        _features_features__WEBPACK_IMPORTED_MODULE_0__.PRIVATE_WORKSPACES,
        _features_features__WEBPACK_IMPORTED_MODULE_0__.ACCOUNT_PERMISSIONS
    ]
};
var ADVANCED_REPORTING = {
    sectionName: "pricingPage.features.sections.advancedReporting",
    features: [
        _features_features__WEBPACK_IMPORTED_MODULE_0__.WORK_PERFORMANCE_INSIGHTS,
        _features_features__WEBPACK_IMPORTED_MODULE_0__.SCHEDULED_DASHBOARD_DELIVERY,
        _features_features__WEBPACK_IMPORTED_MODULE_0__.PIVOT_ANALYSIS
    ]
};
// Old version, kept until we're certain none of the clusters use it.
var SUPPORT = {
    sectionName: "pricingPage.features.sections.support",
    features: [
        _features_features__WEBPACK_IMPORTED_MODULE_0__.KNOWLEDGE_BASE,
        _features_features__WEBPACK_IMPORTED_MODULE_0__.EMAIL_SUPPORT,
        _features_features__WEBPACK_IMPORTED_MODULE_0__.TAILORED_ONBOARDING
    ]
};
// Newer version, of a successful test.
var SECURITY_NEW = {
    sectionName: "pricingPage.features.sections.security_new",
    features: [
        _features_features__WEBPACK_IMPORTED_MODULE_0__.TWO_FA,
        _features_features__WEBPACK_IMPORTED_MODULE_0__.SOC,
        _features_features__WEBPACK_IMPORTED_MODULE_0__.GOOGLE,
        _features_features__WEBPACK_IMPORTED_MODULE_0__.SAML,
        _features_features__WEBPACK_IMPORTED_MODULE_0__.HIPAA,
        _features_features__WEBPACK_IMPORTED_MODULE_0__.INTEGRATION_PERMISSIONS,
        _features_features__WEBPACK_IMPORTED_MODULE_0__.IP_RESTRICTIONS,
        _features_features__WEBPACK_IMPORTED_MODULE_0__.CONTENT_DIRECTORY
    ]
};
var getDefaultSections = function(param) {
    var cookies = param.cookies, abTests = param.abTests, hasStudentPlan = param.hasStudentPlan, hasFreeTier = param.hasFreeTier;
    return NEW_PRICING_PAGE_DEFAULT_SECTIONS({
        cookies: cookies,
        abTests: abTests,
        hasStudentPlan: hasStudentPlan,
        hasFreeTier: hasFreeTier
    });
};


/***/ }),

/***/ 8876:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "b": function() { return /* binding */ getFreeTierEssentials; }
/* harmony export */ });
/* harmony import */ var _features_features__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(61980);

var getFreeTierEssentials = function(abTests, cookies) {
    return {
        sectionName: "pricingPage.features.sections.essentials",
        features: [
            _features_features__WEBPACK_IMPORTED_MODULE_0__.MAXIMUM_SEATS,
            _features_features__WEBPACK_IMPORTED_MODULE_0__.ITEMS({
                abTests: abTests,
                cookies: cookies
            }),
            _features_features__WEBPACK_IMPORTED_MODULE_0__.STORAGE({
                abTests: abTests,
                cookies: cookies
            }),
            _features_features__WEBPACK_IMPORTED_MODULE_0__.ACTIVITY_LOG,
            _features_features__WEBPACK_IMPORTED_MODULE_0__.UNLIMITED_BOARDS_WITH_FREE_TIER({
                abTests: abTests,
                cookies: cookies
            }),
            _features_features__WEBPACK_IMPORTED_MODULE_0__.UNLIMITED_DOCS,
            _features_features__WEBPACK_IMPORTED_MODULE_0__.COLUMN_TYPES({
                cookies: cookies
            }),
            _features_features__WEBPACK_IMPORTED_MODULE_0__.TEMPLATES,
            _features_features__WEBPACK_IMPORTED_MODULE_0__.MOBILE,
            _features_features__WEBPACK_IMPORTED_MODULE_0__.UNLIMITED_VIEWERS
        ]
    };
};


/***/ }),

/***/ 87529:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O": function() { return /* binding */ getDefaultTierDescriptions; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(14924);
/* harmony import */ var constants_pricing__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(55674);

function _define_property1(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property1(target, key, source[key]);
        });
    }
    return target;
}

var _obj;
var DEFAULT_TIER_DESCRIPTIONS = (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, constants_pricing__WEBPACK_IMPORTED_MODULE_0__/* .TIERS.FREE */ .Iy.FREE, "pricingPage.tierDescriptions.individual.new"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, constants_pricing__WEBPACK_IMPORTED_MODULE_0__/* .TIERS.BASIC */ .Iy.BASIC, "pricingPage.tierDescriptions.basic.new"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, constants_pricing__WEBPACK_IMPORTED_MODULE_0__/* .TIERS.STANDARD */ .Iy.STANDARD, "pricingPage.tierDescriptions.standard.new"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, constants_pricing__WEBPACK_IMPORTED_MODULE_0__/* .TIERS.PRO */ .Iy.PRO, "pricingPage.tierDescriptions.pro.new"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, constants_pricing__WEBPACK_IMPORTED_MODULE_0__/* .TIERS.ENTERPRISE */ .Iy.ENTERPRISE, "pricingPage.tierDescriptions.enterprise.new"), _obj);
var getDefaultTierDescriptions = function(param) {
    var hasStudentPlan = param.hasStudentPlan;
    var tierDescriptions = _object_spread({}, DEFAULT_TIER_DESCRIPTIONS);
    if (hasStudentPlan) {
        tierDescriptions[constants_pricing__WEBPACK_IMPORTED_MODULE_0__/* .TIERS.FREE */ .Iy.FREE] = "pricingPage.tierDescriptions.student";
    }
    return tierDescriptions;
};


/***/ }),

/***/ 69078:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": function() { return /* binding */ DEFAULT_VALUE_FEATURES_PER_TIER; },
/* harmony export */   "v": function() { return /* binding */ getDefaultValueFeatures; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(14924);
/* harmony import */ var _pricing__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(55674);
/* harmony import */ var _features_value_feature_collections__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(78217);
/* harmony import */ var services_ab_tests_monetization_ab_tests_service__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(46724);




var DEFAULT_VALUE_FEATURES_PER_TIER = function(param) {
    var hasStudentPlan = param.hasStudentPlan, hasFreeTier = param.hasFreeTier, abTests = param.abTests, cookies = param.cookies, forcePricing = param.forcePricing;
    var withoutBasic = (0,services_ab_tests_monetization_ab_tests_service__WEBPACK_IMPORTED_MODULE_2__/* .shouldHideBasic */ .gd)({
        abTests: abTests,
        cookies: cookies,
        forcePricing: forcePricing
    });
    var _obj;
    return _obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_obj, _pricing__WEBPACK_IMPORTED_MODULE_0__/* .TIERS.FREE */ .Iy.FREE, hasStudentPlan ? _features_value_feature_collections__WEBPACK_IMPORTED_MODULE_1__/* .STUDENT_PLAN_VALUE_FEATURES */ .b5 : (0,services_ab_tests_monetization_ab_tests_service__WEBPACK_IMPORTED_MODULE_2__/* .getFreeTierFeaturesByAbTest */ .EF)({
        cookies: cookies,
        forcePricing: forcePricing
    })), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_obj, _pricing__WEBPACK_IMPORTED_MODULE_0__/* .TIERS.BASIC */ .Iy.BASIC, (0,_features_value_feature_collections__WEBPACK_IMPORTED_MODULE_1__/* .BASIC_TIER_VALUE_FEATURES */ .cN)({
        hasFreeTier: hasFreeTier
    })), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_obj, _pricing__WEBPACK_IMPORTED_MODULE_0__/* .TIERS.STANDARD */ .Iy.STANDARD, (0,_features_value_feature_collections__WEBPACK_IMPORTED_MODULE_1__/* .STANDARD_TIER_VALUE_FEATURES */ .kh)({
        withoutBasic: withoutBasic,
        hasFreeTier: hasFreeTier
    })), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_obj, _pricing__WEBPACK_IMPORTED_MODULE_0__/* .TIERS.PRO */ .Iy.PRO, _features_value_feature_collections__WEBPACK_IMPORTED_MODULE_1__/* .PRO_TIER_VALUE_FEATURES */ .tE), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_obj, _pricing__WEBPACK_IMPORTED_MODULE_0__/* .TIERS.ENTERPRISE */ .Iy.ENTERPRISE, _features_value_feature_collections__WEBPACK_IMPORTED_MODULE_1__/* .ENTERPRISE_TIER_VALUE_FEATURES */ .$4), _obj;
};
var getDefaultValueFeatures = function(param) {
    var hasStudentPlan = param.hasStudentPlan, hasFreeTier = param.hasFreeTier, abTests = param.abTests, cookies = param.cookies, forcePricing = param.forcePricing;
    return DEFAULT_VALUE_FEATURES_PER_TIER({
        hasStudentPlan: hasStudentPlan,
        hasFreeTier: hasFreeTier,
        abTests: abTests,
        cookies: cookies,
        forcePricing: forcePricing
    });
};


/***/ }),

/***/ 44363:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Q": function() { return /* binding */ IPO_CAMPAIGN_ID; },
/* harmony export */   "S": function() { return /* binding */ GARTNER_CAMPAIGN_ID; }
/* harmony export */ });
var IPO_CAMPAIGN_ID = "ipo_promotion";
var GARTNER_CAMPAIGN_ID = "gartner_campaign";


/***/ }),

/***/ 35015:
/***/ (function(module) {


var TEMPLATE_NAMES = {
    OnePagerAssetTemplate: "OnePagerAssetTemplate",
    OnePagerWithImageTemplate: "OnePagerWithImageTemplate",
    MobileOnePagerWithImageTemplate: "MobileOnePagerWithImageTemplate",
    OnePagerWithVideoTemplate: "OnePagerWithVideoTemplate",
    CompetitorTemplate: "CompetitorTemplate",
    LongTemplate: "LongTemplate",
    SegmentsTemplate: "SegmentsTemplate",
    FixedLongLpTemplate: "FixedLongLpTemplate",
    ArticleTemplate: "ArticleTemplate",
    DirectoryImagesTemplate: "DirectoryImagesTemplate",
    MultipleDirectoryImagesTemplate: "MultipleDirectoryImagesTemplate",
    DynamicTemplate: "DynamicTemplate",
    MobileDynamicTemplate: "MobileDynamicTemplate",
    DevelopersCenterTemplate: "DevelopersCenterTemplate",
    WelcomeNewJoinersTemplate: "WelcomeNewJoinersTemplate",
    RemoteWorkTemplate: "RemoteWorkTemplate"
};
var isFixedLpTemplate = function(template) {
    return template === TEMPLATE_NAMES.FixedLongLpTemplate || template === TEMPLATE_NAMES.DynamicTemplate;
};
module.exports = {
    TEMPLATE_NAMES: TEMPLATE_NAMES,
    isFixedLpTemplate: isFixedLpTemplate
};


/***/ }),

/***/ 13979:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "FC": function() { return /* binding */ isTypeformFullyReleasedForCountry; },
/* harmony export */   "Ks": function() { return /* binding */ getTypeformImagesPrefetchByCountry; },
/* harmony export */   "PM": function() { return /* binding */ TYPEFORM_DESKTOP_DEVICE_TYPE; },
/* harmony export */   "Ux": function() { return /* binding */ AMERICA_GEO_REGION; },
/* harmony export */   "Wz": function() { return /* binding */ getContactSalesRegionByCountry; },
/* harmony export */   "ZZ": function() { return /* binding */ EMEA_GEO_REGION; },
/* harmony export */   "_X": function() { return /* binding */ openContactSalesTypeform; },
/* harmony export */   "hr": function() { return /* binding */ AUSTRALIA_NEW_ZEALAND_GEO_REGION; },
/* harmony export */   "nk": function() { return /* binding */ isTypeformDisabledForRegion; }
/* harmony export */ });
/* unused harmony export TYPEFORM_MOBILE_DEVICE_TYPE */
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(14924);
/* harmony import */ var _typeform_embed__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59018);
/* harmony import */ var _typeform_embed__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_typeform_embed__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _typeform_embed_build_css_popup_css__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(56051);
/* harmony import */ var _typeform_embed_build_css_popup_css__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_typeform_embed_build_css_popup_css__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _services_bigbrain_service__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(65488);
/* harmony import */ var _services_cookies_service__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67798);
/* harmony import */ var services_ab_tests_monetization_ab_tests_service__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(46724);
/* harmony import */ var _constants_cookies__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(13019);
/* harmony import */ var _constants_cookies__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_constants_cookies__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var constants_bigbrain_event_types__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(65023);
/* harmony import */ var client_services_hubspot_service_hubspot_constants__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(22638);
/* harmony import */ var services_sales_enrichment_sales_enrichment_service__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(29919);
/* harmony import */ var services_pricing_pricing_model_services__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(3223);
/* harmony import */ var services_typeform_form_service__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(6941);
/* harmony import */ var services_typeform_form_service__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(services_typeform_form_service__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var services_monday_platform_existing_accounts_service__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(14124);

function _define_property1(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property1(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}












var TYPEFORM_DESKTOP_DEVICE_TYPE = "Desktop";
var TYPEFORM_MOBILE_DEVICE_TYPE = "Mobile";
// ** TYPEFORM PARAMS **
var TYPEFORM_CONTACT_SALES_VISITOR_ID_PARAM = "visitor_id";
var TYPEFORM_CONTACT_SALES_COUNTRY_PARAM = "country";
var TYPEFORM_CONTACT_SALES_REGION_PARAM = "region";
var TYPEFORM_CONTACT_SALES_KEEP_SESSION_PARAM = "keepSession";
var TYPEFORM_CONTACT_SALES_DEVICE_PARAM = "Device";
var TYPEFORM_CONTACT_SALES_LEAD_SOURCE_PARAM = "lead_source";
var TYPEFORM_CONTACT_SALES_PRICING_VERSION = "website_pricing_version";
var TYPEFORM_FORM_TYPE_PARAM = "form_type_typeform";
var TYPEFORM_HUBSPOT_UTK_PARAM = "hubspot_utk";
var TYPEFORM_HUBSPOT_PAGE_URL_PARAM = "hubspot_page_url";
var TYPEFORM_HUBSPOT_PAGE_NAME_PARAM = "hubspot_page_name";
// *****************************
// ** SALES GEOGRAPHIC REGIONS **
var EMEA_GEO_REGION = "EMEA";
var AUSTRALIA_NEW_ZEALAND_GEO_REGION = "ANZ";
var AMERICA_GEO_REGION = "AMERICA";
var getContactSalesRegionByCountry = function(countryCode) {
    var typeformData = (0,services_typeform_form_service__WEBPACK_IMPORTED_MODULE_9__.getTypeformContactSalesData)({
        country: countryCode
    });
    return typeformData === null || typeformData === void 0 ? void 0 : typeformData.region;
};
var isTypeformDisabledForRegion = function(countryCode) {
    // const typeformData = getTypeformContactSalesData({ country: countryCode });
    // disable for EMEA - "Iron Swords"
    // if (typeformData?.region === EMEA_GEO_REGION) return true;
    return false;
};
var isTypeformFullyReleasedForCountry = function(countryCode) {
    var _typeformData_excludeCountries;
    var typeformData = (0,services_typeform_form_service__WEBPACK_IMPORTED_MODULE_9__.getTypeformContactSalesData)({
        country: countryCode
    });
    if (typeformData === null || typeformData === void 0 ? void 0 : (_typeformData_excludeCountries = typeformData.excludeCountries) === null || _typeformData_excludeCountries === void 0 ? void 0 : _typeformData_excludeCountries.includes(countryCode)) return false;
    return true; // Fully released to all traffic except specific exclusions
};
var getTypeformImagesPrefetchByCountry = function(countryCode, getNewVariantForTest) {
    var typeformData = (0,services_typeform_form_service__WEBPACK_IMPORTED_MODULE_9__.getTypeformContactSalesData)({
        country: countryCode,
        getNewVariantForTest: getNewVariantForTest
    });
    return (typeformData === null || typeformData === void 0 ? void 0 : typeformData.prefetchImages) || [];
};
var openContactSalesTypeform = function(param) {
    var country = param.country, deviceType = param.deviceType, _isTest = param.isTest, isTest = _isTest === void 0 ? false : _isTest, getNewVariantForTest = param.getNewVariantForTest, pricingData = param.pricingData, onCloseCallback = param.onCloseCallback, onSubmitCallback = param.onSubmitCallback, onReadyCallback = param.onReadyCallback;
    var typeformData = (0,services_typeform_form_service__WEBPACK_IMPORTED_MODULE_9__.getTypeformContactSalesData)({
        country: country,
        isTest: isTest,
        getNewVariantForTest: getNewVariantForTest
    });
    var formId = typeformData.formId, region = typeformData.region, formType = typeformData.formType;
    // fire AB test
    var visitorId = (0,_services_cookies_service__WEBPACK_IMPORTED_MODULE_3__/* .getCookie */ .ej)(_constants_cookies__WEBPACK_IMPORTED_MODULE_5__.BIG_BRAIN_VISITOR_ID) || "";
    var pricingVersion = (0,services_pricing_pricing_model_services__WEBPACK_IMPORTED_MODULE_8__/* .getPricingVersionForSales */ .qM)(pricingData);
    var enrichmentData = (0,services_sales_enrichment_sales_enrichment_service__WEBPACK_IMPORTED_MODULE_7__/* .getEnrichmentEntriesForSales */ .Xk)();
    var _obj;
    var hidden = _object_spread_props(_object_spread({}, enrichmentData.reduce(function(data, item) {
        return data[item.name] = item.value, data;
    }, {})), (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(_obj, TYPEFORM_CONTACT_SALES_REGION_PARAM, region), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(_obj, TYPEFORM_CONTACT_SALES_COUNTRY_PARAM, country), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(_obj, TYPEFORM_CONTACT_SALES_KEEP_SESSION_PARAM, "true"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(_obj, TYPEFORM_CONTACT_SALES_VISITOR_ID_PARAM, visitorId), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(_obj, TYPEFORM_CONTACT_SALES_DEVICE_PARAM, deviceType), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(_obj, TYPEFORM_CONTACT_SALES_LEAD_SOURCE_PARAM, client_services_hubspot_service_hubspot_constants__WEBPACK_IMPORTED_MODULE_6__/* .leadSourceDefaultValue */ .Ts), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(_obj, TYPEFORM_CONTACT_SALES_PRICING_VERSION, pricingVersion), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(_obj, TYPEFORM_FORM_TYPE_PARAM, formType), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(_obj, TYPEFORM_HUBSPOT_UTK_PARAM, (0,_services_cookies_service__WEBPACK_IMPORTED_MODULE_3__/* .getCookie */ .ej)("hubspotutk")), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(_obj, TYPEFORM_HUBSPOT_PAGE_URL_PARAM, window.location.href), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(_obj, TYPEFORM_HUBSPOT_PAGE_NAME_PARAM, document.title), _obj));
    var toggle = (0,_typeform_embed__WEBPACK_IMPORTED_MODULE_0__.createPopup)(formId, {
        onQuestionChanged: function(data) {
            (0,_services_bigbrain_service__WEBPACK_IMPORTED_MODULE_2__.trackEvent)(constants_bigbrain_event_types__WEBPACK_IMPORTED_MODULE_12__.TYPEFORM_CONTACT_SALES_QUESTION_CHANGED, {
                kind: data === null || data === void 0 ? void 0 : data.ref,
                info1: formId,
                info2: country,
                info3: (0,services_monday_platform_existing_accounts_service__WEBPACK_IMPORTED_MODULE_10__/* .isExistingAccount */ .vn)()
            });
        },
        onSubmit: function(data) {
            (0,_services_bigbrain_service__WEBPACK_IMPORTED_MODULE_2__.trackEvent)(constants_bigbrain_event_types__WEBPACK_IMPORTED_MODULE_12__.TYPEFORM_CONTACT_SALES_FORM_SUBMITTED, {
                kind: data === null || data === void 0 ? void 0 : data.responseId,
                info1: formId,
                info2: country,
                info3: (0,services_monday_platform_existing_accounts_service__WEBPACK_IMPORTED_MODULE_10__/* .isExistingAccount */ .vn)()
            });
            if (pricingData) {
                var abTests = pricingData.abTests, cookies = pricingData.cookies, forcePricing = pricingData.forcePricing, isV13PricingVersion = pricingData.isV13PricingVersion;
                (0,services_ab_tests_monetization_ab_tests_service__WEBPACK_IMPORTED_MODULE_4__/* .enterV13TestIfNeeded */ .p)(abTests, cookies, forcePricing, isV13PricingVersion);
            }
            onSubmitCallback === null || onSubmitCallback === void 0 ? void 0 : onSubmitCallback();
        },
        onReady: function() {
            (0,_services_bigbrain_service__WEBPACK_IMPORTED_MODULE_2__.trackEvent)(constants_bigbrain_event_types__WEBPACK_IMPORTED_MODULE_12__.TYPEFORM_CONTACT_SALES_FORM_LOADED, {
                info1: formId,
                info2: country,
                info3: (0,services_monday_platform_existing_accounts_service__WEBPACK_IMPORTED_MODULE_10__/* .isExistingAccount */ .vn)()
            });
            onReadyCallback === null || onReadyCallback === void 0 ? void 0 : onReadyCallback();
        },
        onClose: function() {
            (0,_services_bigbrain_service__WEBPACK_IMPORTED_MODULE_2__.trackEvent)(constants_bigbrain_event_types__WEBPACK_IMPORTED_MODULE_12__.TYPEFORM_CONTACT_SALES_FORM_CLOSED, {
                info1: formId,
                info2: country,
                info3: (0,services_monday_platform_existing_accounts_service__WEBPACK_IMPORTED_MODULE_10__/* .isExistingAccount */ .vn)()
            });
            onCloseCallback === null || onCloseCallback === void 0 ? void 0 : onCloseCallback();
        },
        hidden: hidden
    }).toggle;
    toggle();
};


/***/ }),

/***/ 29238:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C": function() { return /* binding */ VIDEO_OPTS; }
/* harmony export */ });
var VIDEO_OPTS = {
    width: 970,
    height: 546,
    playerVars: {
        autoplay: 1,
        rel: 0,
        showinfo: 0
    }
};


/***/ }),

/***/ 17581:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "U": function() { return /* binding */ CareersProvider; },
/* harmony export */   "m": function() { return /* binding */ useFilters; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


var CareersContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.createContext)({});
var CareersProvider = function(param) {
    var children = param.children;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(""), search = ref[0], setSearch = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null), department = ref1[0], setDepartment = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null), location = ref2[0], setLocation = ref2[1];
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)({}), positionsPerLocation = ref3[0], setPositionsPerLocation = ref3[1];
    var updatePositionsPerLocation = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function(positions) {
        var numberOfPositionsPerLocation = positions === null || positions === void 0 ? void 0 : positions.reduce(function(acc, param) {
            var location = param.location;
            acc[location.name] = (acc[location.name] || 0) + 1;
            return acc;
        }, {});
        setPositionsPerLocation(numberOfPositionsPerLocation);
    }, []);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(CareersContext.Provider, {
        value: {
            search: search,
            setSearch: setSearch,
            department: department,
            setDepartment: setDepartment,
            location: location,
            setLocation: setLocation,
            updatePositionsPerLocation: updatePositionsPerLocation,
            positionsPerLocation: positionsPerLocation
        },
        children: children
    });
};
var useFilters = function() {
    return (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(CareersContext);
};


/***/ }),

/***/ 93833:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$Y": function() { return /* binding */ buttonStyles; },
/* harmony export */   "Is": function() { return /* binding */ buttonColors; },
/* harmony export */   "u_": function() { return /* binding */ ELEVATE_BUTTON_COLLOR_NAME; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(14924);
/* harmony import */ var styles_colors__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(12573);
/* harmony import */ var styles_color_consts__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(273);



var ELEVATE_BUTTON_COLLOR_NAME = styles_color_consts__WEBPACK_IMPORTED_MODULE_1__.ELEVATE_BUTTON_GRADIANT_COLOR_NAME;
var buttonColors = [
    styles_color_consts__WEBPACK_IMPORTED_MODULE_1__.WORK_OS_IRIS_COLOR_NAME,
    styles_color_consts__WEBPACK_IMPORTED_MODULE_1__.WHITE_COLOR_NAME,
    styles_color_consts__WEBPACK_IMPORTED_MODULE_1__.BRAND_BLACK_TEXT_COLOR,
    styles_color_consts__WEBPACK_IMPORTED_MODULE_1__.WORKFORMS_RED_COLOR_NAME
]; // after removing old colors - change to:  Object.keys(buttonStyles);
var _obj;
var buttonStyles = (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, styles_color_consts__WEBPACK_IMPORTED_MODULE_1__.IRIS_COLOR_NAME, {
    textColor: styles_colors__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z[styles_color_consts__WEBPACK_IMPORTED_MODULE_1__.WHITE_COLOR_NAME],
    backgroundColorName: styles_color_consts__WEBPACK_IMPORTED_MODULE_1__.IRIS_COLOR_NAME
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, styles_color_consts__WEBPACK_IMPORTED_MODULE_1__.WORK_OS_IRIS_COLOR_NAME, {
    textColor: styles_colors__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z[styles_color_consts__WEBPACK_IMPORTED_MODULE_1__.WHITE_COLOR_NAME],
    backgroundColorName: styles_color_consts__WEBPACK_IMPORTED_MODULE_1__.WORK_OS_IRIS_COLOR_NAME
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, styles_color_consts__WEBPACK_IMPORTED_MODULE_1__.BLUE_COLOR_NAME, {
    textColor: styles_colors__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z[styles_color_consts__WEBPACK_IMPORTED_MODULE_1__.WHITE_COLOR_NAME],
    backgroundColorName: styles_color_consts__WEBPACK_IMPORTED_MODULE_1__.BLUE_COLOR_NAME
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, styles_color_consts__WEBPACK_IMPORTED_MODULE_1__.DODGER_BLUE_COLOR_NAME, {
    textColor: styles_colors__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z[styles_color_consts__WEBPACK_IMPORTED_MODULE_1__.WHITE_COLOR_NAME],
    backgroundColorName: styles_color_consts__WEBPACK_IMPORTED_MODULE_1__.DODGER_BLUE_COLOR_NAME
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, styles_color_consts__WEBPACK_IMPORTED_MODULE_1__.SPACE_BLUE_COLOR_NAME, {
    textColor: styles_colors__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z[styles_color_consts__WEBPACK_IMPORTED_MODULE_1__.WHITE_COLOR_NAME],
    backgroundColorName: styles_color_consts__WEBPACK_IMPORTED_MODULE_1__.SPACE_BLUE_COLOR_NAME
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, styles_color_consts__WEBPACK_IMPORTED_MODULE_1__.BRAND_BLACK_TEXT_COLOR, {
    textColor: styles_colors__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z[styles_color_consts__WEBPACK_IMPORTED_MODULE_1__.WHITE_COLOR_NAME],
    backgroundColorName: styles_color_consts__WEBPACK_IMPORTED_MODULE_1__.BRAND_BLACK_TEXT_COLOR
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, styles_color_consts__WEBPACK_IMPORTED_MODULE_1__.WHITE_COLOR_NAME, {
    textColor: styles_colors__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z[styles_color_consts__WEBPACK_IMPORTED_MODULE_1__.BRAND_BLACK_TEXT_COLOR],
    backgroundColorName: styles_color_consts__WEBPACK_IMPORTED_MODULE_1__.WHITE_COLOR_NAME
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, styles_color_consts__WEBPACK_IMPORTED_MODULE_1__.WORKFORMS_RED_COLOR_NAME, {
    textColor: styles_colors__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z[styles_color_consts__WEBPACK_IMPORTED_MODULE_1__.WHITE_COLOR_NAME],
    backgroundColorName: styles_color_consts__WEBPACK_IMPORTED_MODULE_1__.WORKFORMS_RED_COLOR_NAME
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, styles_color_consts__WEBPACK_IMPORTED_MODULE_1__.DARK_CRM_GREEN_COLOR_NAME, {
    textColor: styles_colors__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z[styles_color_consts__WEBPACK_IMPORTED_MODULE_1__.WHITE_COLOR_NAME],
    backgroundColorName: styles_color_consts__WEBPACK_IMPORTED_MODULE_1__.DARK_CRM_GREEN_COLOR_NAME
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, styles_color_consts__WEBPACK_IMPORTED_MODULE_1__.DARK_MARKETING_RED_COLOR_NAME, {
    textColor: styles_colors__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z[styles_color_consts__WEBPACK_IMPORTED_MODULE_1__.WHITE_COLOR_NAME],
    backgroundColorName: styles_color_consts__WEBPACK_IMPORTED_MODULE_1__.DARK_MARKETING_RED_COLOR_NAME
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, styles_color_consts__WEBPACK_IMPORTED_MODULE_1__.DARK_PROJECTS_ORANGE_COLOR_NAME, {
    textColor: styles_colors__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z[styles_color_consts__WEBPACK_IMPORTED_MODULE_1__.WHITE_COLOR_NAME],
    backgroundColorName: styles_color_consts__WEBPACK_IMPORTED_MODULE_1__.DARK_PROJECTS_ORANGE_COLOR_NAME
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, styles_color_consts__WEBPACK_IMPORTED_MODULE_1__.DARK_DEV_GREEN_COLOR_NAME, {
    textColor: styles_colors__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z[styles_color_consts__WEBPACK_IMPORTED_MODULE_1__.WHITE_COLOR_NAME],
    backgroundColorName: styles_color_consts__WEBPACK_IMPORTED_MODULE_1__.DARK_DEV_GREEN_COLOR_NAME
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, ELEVATE_BUTTON_COLLOR_NAME, {
    textColor: styles_colors__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z[styles_color_consts__WEBPACK_IMPORTED_MODULE_1__.BRAND_BLACK_TEXT_COLOR],
    backgroundColorName: styles_color_consts__WEBPACK_IMPORTED_MODULE_1__.ELEVATE_BUTTON_GRADIANT_COLOR_NAME
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, styles_color_consts__WEBPACK_IMPORTED_MODULE_1__.BRAND_GREEN_DARK_TINT_01_COLOR_NAME, {
    textColor: styles_colors__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z[styles_color_consts__WEBPACK_IMPORTED_MODULE_1__.BRAND_GREEN_DARK_TINT_01_COLOR_NAME],
    backgroundColorName: styles_color_consts__WEBPACK_IMPORTED_MODULE_1__.BRAND_GREEN_DARK_TINT_01_COLOR_NAME
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, styles_color_consts__WEBPACK_IMPORTED_MODULE_1__.BRAND_DARK_COLOR_NAME, {
    textColor: styles_colors__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z[styles_color_consts__WEBPACK_IMPORTED_MODULE_1__.BRAND_DARK_COLOR_NAME],
    backgroundColorName: styles_color_consts__WEBPACK_IMPORTED_MODULE_1__.BRAND_DARK_COLOR_NAME
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, styles_color_consts__WEBPACK_IMPORTED_MODULE_1__.CRM_DARK_TINT_01_COLOR_NAME, {
    textColor: styles_colors__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z[styles_color_consts__WEBPACK_IMPORTED_MODULE_1__.CRM_DARK_TINT_01_COLOR_NAME],
    backgroundColorName: styles_color_consts__WEBPACK_IMPORTED_MODULE_1__.CRM_DARK_TINT_01_COLOR_NAME
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, styles_color_consts__WEBPACK_IMPORTED_MODULE_1__.BRAND_WORK_MANAGEMENT_PRIMARY_COLOR_NAME, {
    textColor: styles_colors__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z[styles_color_consts__WEBPACK_IMPORTED_MODULE_1__.BRAND_WORK_MANAGEMENT_PRIMARY_COLOR_NAME],
    backgroundColorName: styles_color_consts__WEBPACK_IMPORTED_MODULE_1__.BRAND_WORK_MANAGEMENT_PRIMARY_COLOR_NAME
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, styles_color_consts__WEBPACK_IMPORTED_MODULE_1__.BRAND_SERVICE_DARK_COLOR_NAME, {
    textColor: styles_colors__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z[styles_color_consts__WEBPACK_IMPORTED_MODULE_1__.BRAND_SERVICE_DARK_COLOR_NAME],
    backgroundColorName: styles_color_consts__WEBPACK_IMPORTED_MODULE_1__.BRAND_SERVICE_DARK_COLOR_NAME
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, styles_color_consts__WEBPACK_IMPORTED_MODULE_1__.BRAND_SERVICE_PRIMARY_COLOR_NAME, {
    textColor: styles_colors__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z[styles_color_consts__WEBPACK_IMPORTED_MODULE_1__.WHITE_COLOR_NAME],
    backgroundColorName: styles_color_consts__WEBPACK_IMPORTED_MODULE_1__.BRAND_SERVICE_PRIMARY_COLOR_NAME
}), // old colors - kept for supporting old page configs:
(0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, "pink", {
    textColor: styles_colors__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z[styles_color_consts__WEBPACK_IMPORTED_MODULE_1__.WHITE_COLOR_NAME],
    backgroundColorName: "pink"
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, "purple", {
    textColor: styles_colors__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z[styles_color_consts__WEBPACK_IMPORTED_MODULE_1__.WHITE_COLOR_NAME],
    backgroundColorName: "purple"
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, "royal", {
    textColor: styles_colors__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z[styles_color_consts__WEBPACK_IMPORTED_MODULE_1__.WHITE_COLOR_NAME],
    backgroundColorName: "royal"
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, "green", {
    textColor: styles_colors__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z[styles_color_consts__WEBPACK_IMPORTED_MODULE_1__.WHITE_COLOR_NAME],
    backgroundColorName: "green"
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, "yellow", {
    textColor: styles_colors__WEBPACK_IMPORTED_MODULE_0__/* ["default"].mud */ .Z.mud,
    backgroundColorName: "yellow"
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, "orange", {
    textColor: styles_colors__WEBPACK_IMPORTED_MODULE_0__/* ["default"].mud */ .Z.mud,
    backgroundColorName: "orange"
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, "light-blue", {
    textColor: styles_colors__WEBPACK_IMPORTED_MODULE_0__/* ["default"].mud */ .Z.mud,
    backgroundColorName: "light-blue-video-background"
}), _obj);


/***/ }),

/***/ 73759:
/***/ (function(module, exports) {


Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "COMPONENTS_SHADOW_PROPS", ({
    enumerable: true,
    get: function() {
        return COMPONENTS_SHADOW_PROPS;
    }
}));
var BODY_CONTENT_HORIZONTAL_PADDING = 96;
var COMPONENTS_SHADOW_PROPS = {
    offsetX: 0,
    offsetY: 8,
    blurRadius: 48,
    defaultOpacity: 0.16,
    hoverOpacity: 0.32
};
var getComponentBoxShadow = function(opacity) {
    return "box-shadow: 0px ".concat(COMPONENTS_SHADOW_PROPS.offsetY, "px ").concat(COMPONENTS_SHADOW_PROPS.blurRadius / 2, "px 0 rgba(29, 140, 242, ").concat(opacity, ");");
};
var getComponentShadowFilter = function() {
    var opacity = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : COMPONENTS_SHADOW_PROPS.defaultOpacity;
    return "filter: drop-shadow(0px ".concat(COMPONENTS_SHADOW_PROPS.offsetY, "px ").concat(COMPONENTS_SHADOW_PROPS.blurRadius / 2, "px rgba(29, 140, 242, ").concat(opacity, "));");
};
var getMobileComponentShadowFilter = function(opacity) {
    return "filter: drop-shadow(0px ".concat(COMPONENTS_SHADOW_PROPS.offsetY, "px ").concat(COMPONENTS_SHADOW_PROPS.blurRadius / 3, "px rgba(29, 140, 242, ").concat(opacity, "));");
};
var getComponentShadow = function() {
    return getComponentBoxShadow(COMPONENTS_SHADOW_PROPS.defaultOpacity);
};
var getComponentShadowWithHoverEffect = function() {
    return getComponentBoxShadow(COMPONENTS_SHADOW_PROPS.hoverOpacity);
};
var COMPONENTS_SHADOW_FILTER = getComponentShadowFilter(0.5);
var MOBILE_COMPONENTS_SHADOW_FILTER = getMobileComponentShadowFilter(0.3);
module.exports = {
    BODY_CONTENT_HORIZONTAL_PADDING: BODY_CONTENT_HORIZONTAL_PADDING,
    COMPONENTS_SHADOW_PROPS: COMPONENTS_SHADOW_PROPS,
    COMPONENTS_SHADOW_FILTER: COMPONENTS_SHADOW_FILTER,
    MOBILE_COMPONENTS_SHADOW_FILTER: MOBILE_COMPONENTS_SHADOW_FILTER,
    getComponentShadow: getComponentShadow,
    getComponentShadowWithHoverEffect: getComponentShadowWithHoverEffect,
    getComponentShadowFilter: getComponentShadowFilter,
    getMobileComponentShadowFilter: getMobileComponentShadowFilter
};


/***/ }),

/***/ 15814:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ banner; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./client/components/system/monday-markup-language/monday-markup-language-component.js + 11 modules
var monday_markup_language_component = __webpack_require__(36239);
// EXTERNAL MODULE: ./components/core/picture/picture-component.js + 3 modules
var picture_component = __webpack_require__(82305);
// EXTERNAL MODULE: ./segments/desktop/core-components/button/button.js + 17 modules
var button_button = __webpack_require__(11068);
// EXTERNAL MODULE: ./static/svg/icons/close.svg
var icons_close = __webpack_require__(2002);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./services/cookies-service.js
var cookies_service = __webpack_require__(67798);
// EXTERNAL MODULE: ./constants/cookies.js
var cookies = __webpack_require__(13019);
// EXTERNAL MODULE: ./services/bigbrain-service.js
var bigbrain_service = __webpack_require__(65488);
// EXTERNAL MODULE: ./constants/bigbrain-event-types.js
var bigbrain_event_types = __webpack_require__(65023);
// EXTERNAL MODULE: ./segments/segments-service.js
var segments_service = __webpack_require__(861);
// EXTERNAL MODULE: ./styles/colors.js
var colors = __webpack_require__(12573);
// EXTERNAL MODULE: ./segments/desktop/core-components/button/button-consts.js
var button_consts = __webpack_require__(75650);
// EXTERNAL MODULE: ./components/core/new-button/button-component.js + 1 modules
var button_component = __webpack_require__(35061);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
// EXTERNAL MODULE: ./constants/vp-sizes.js
var vp_sizes = __webpack_require__(698);
// EXTERNAL MODULE: ./segments/desktop/header/layouts/components/basic-header/constants.js
var constants = __webpack_require__(72428);
;// CONCATENATED MODULE: ./segments/desktop/core-components/banner/banner.scss.js




var bannerHeight = "72px";
var bannerTextLinHeight = "24px";
var StyledBanner = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1o7tdaf0"
})("height:", bannerHeight, ";display:flex;justify-content:center;position:relative;&.top-margin{margin-top:", constants/* default.SECONDARY_HEADER_HEIGHT */.Z.SECONDARY_HEADER_HEIGHT, "px;}.banner-content{display:flex;width:", vp_sizes/* MAX_DESKTOP_DYNAMIC_TEMPLATE_WIDTH */.Ld, "px;.image-wrapper{display:flex;flex-grow:0;.banner-image{height:", bannerHeight, ";}}&.with-sticky-images{width:auto;align-items:center;.banner-image{height:", bannerTextLinHeight, ";}}.banner-text-and-cta{display:flex;justify-content:center;align-items:center;flex-grow:1;.banner-text-and-link{display:flex;align-items:center;.banner-text{display:inline;font-size:1rem;line-height:", bannerTextLinHeight, ";text-align:center;}.banner-icon-wrapper{display:flex;margin-right:8px;.picture-component{display:flex;}}}.banner-cta-wrapper{display:inline-block;margin-left:24px;min-width:190px;.ladda-button{padding:12px 20px;background:", colors/* default.white */.Z.white, ";", function(param) {
    var buttonTextColor = param.buttonTextColor;
    return buttonTextColor && "color: ".concat(colors/* default */.Z[buttonTextColor], ";");
}, "}}}}.close-icon-wrapper{position:absolute;top:10px;right:10px;cursor:pointer;svg{width:12px;height:12px;path{fill:", colors/* default.white */.Z.white, ";}}}&.hide-banner{display:none;}@media (max-width:", vp_sizes/* MIN_HEADER_DESKTOP_MENU */.dD, "px){&.top-margin{margin-top:0px;}.banner-content{width:initial;.image-wrapper{.banner-picture{display:flex;align-items:center;.banner-image{height:50px;}}}.banner-text-and-cta{margin-left:20px;margin-right:35px;justify-content:center;flex-grow:0;flex-direction:column;.banner-cta-wrapper{margin-left:0;min-width:unset;align-self:start;.secondary-button{font-size:0.8125rem;}}.banner-text-and-link{display:flex;align-items:center;flex-direction:column;gap:10px;.banner-text{font-size:1rem;text-align:left;font-weight:400;}.banner-link{font-size:1rem;}}}}}@media (max-width:600px){.banner-content{.banner-text-and-cta{.banner-text-and-link{display:inline-block;text-align:center;max-width:274px;.banner-text{font-size:0.8125rem;}.banner-link{font-size:0.8125rem;}.banner-cta-wrapper{margin-left:16px;}}}}}");

;// CONCATENATED MODULE: ./segments/desktop/core-components/banner/default-props.js

/* harmony default export */ var default_props = ({
    bannerText: "<monday-bold>Is your team working from home?</monday-bold> Use monday.com to get remote work done",
    bannerCta: "Start Collaborating",
    withCloseIcon: true,
    theme: "dodger-blue",
    buttonConfig: {
        buttonSize: button_component.SM
    },
    extraData: {}
});

// EXTERNAL MODULE: ./contexts/generic-config-context.js
var generic_config_context = __webpack_require__(3156);
;// CONCATENATED MODULE: ./segments/desktop/core-components/banner/banner.js
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}


















var BANNER_EXPIRE_DAYS = 7;
var SIGNUP_BANNER_PLACEMENT = "top_with_background_banner";
var Banner = function(props) {
    var bannerText = props.bannerText, bannerLinkData = props.bannerLinkData, bannerCta = props.bannerCta, bannerleftImage = props.bannerleftImage, bannerRightImage = props.bannerRightImage, withCloseIcon = props.withCloseIcon, theme = props.theme, buttonConfig = props.buttonConfig, isMobileOrTabletBrowser = props.isMobileOrTabletBrowser, isSecondaryMenuNeeded = props.isSecondaryMenuNeeded, placement = props.placement, hideBannerWithBackground = props.hideBannerWithBackground, stickImagesToText = props.stickImagesToText, extraData = props.extraData, bannerHeight = props.bannerHeight, mobileBannerText = props.mobileBannerText, bannerIcon = props.bannerIcon, bannerIconHeight = props.bannerIconHeight;
    var ref = (0,react.useState)(hideBannerWithBackground && withCloseIcon), hideBanner = ref[0], setHideBanner = ref[1]; // for now only banner that can be closed use the cookie
    var getThemes = function() {
        return _object_spread_props(_object_spread({}, segments_service/* themes */.np), {
            "dodger-blue": {
                color: colors/* default.white */.Z.white,
                background: colors/* default.dodger-blue */.Z["dodger-blue"]
            }
        });
    };
    var getThemeStyle = function() {
        return getThemes()[theme] || {};
    };
    var themeStyle = getThemeStyle();
    var onCloseBanner = function() {
        (0,bigbrain_service.trackEvent)(bigbrain_event_types.TOP_BANNER_CLOSED_CLICK);
        (0,cookies_service/* setCookie */.d8)(cookies.HIDE_BANNER_WITH_BACKGROUND_COOKIE_NAME, true, {
            expires: BANNER_EXPIRE_DAYS
        });
        setHideBanner(true);
    };
    var onBannerLinkClicked = function(link) {
        (0,bigbrain_service.trackEvent)(bigbrain_event_types.BANNER_LINK_CLICKED, {
            kind: link
        });
    };
    var getBannerButtonProps = function() {
        var buttonProps = {
            ctaText: bannerCta,
            placement: placement || SIGNUP_BANNER_PLACEMENT,
            buttonSpinnerColor: themeStyle.background,
            parentSegment: "Banner",
            useCtaText: true,
            extraData: extraData
        };
        if (isMobileOrTabletBrowser) {
            var MOBILE_NOT_ALLOWED_BUTTON_TYPES = [
                button_consts/* REGULAR_BUTTON_TYPE */.ys
            ];
            var buttonType = buttonConfig.buttonType;
            var buttonDisplayType = buttonConfig.buttonDisplayType;
            var extraButtonProps = {};
            if (MOBILE_NOT_ALLOWED_BUTTON_TYPES.includes(buttonType)) {
                extraButtonProps.buttonType = button_consts/* SECONDARY_BUTTON_TYPE */.jE;
            }
            if (buttonConfig.buttonType === button_consts/* YOUTUBE_POPUP_LINK_TYPE */.F9 && MOBILE_NOT_ALLOWED_BUTTON_TYPES.includes(buttonDisplayType)) {
                extraButtonProps.buttonDisplayType = button_consts/* SECONDARY_BUTTON_TYPE */.jE;
            }
            buttonProps = _object_spread_props(_object_spread({}, buttonProps, extraButtonProps), {
                buttonSize: button_component.SM
            });
        }
        return buttonProps;
    };
    var getBannerText = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(monday_markup_language_component/* default */.Z, {
            className: "banner-text",
            text: mobileBannerText && isMobileOrTabletBrowser ? mobileBannerText : bannerText,
            style: bannerIcon ? {
                textAlign: "left"
            } : {}
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledBanner, {
        className: classnames_default()("banner", {
            "hide-banner": hideBanner,
            "top-margin": isSecondaryMenuNeeded
        }),
        buttonTextColor: theme,
        style: bannerHeight ? _object_spread_props(_object_spread({}, themeStyle), {
            height: bannerHeight
        }) : themeStyle,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: classnames_default()("banner-content", {
                    "with-sticky-images": stickImagesToText
                }),
                children: [
                    bannerleftImage && !isMobileOrTabletBrowser && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "image-wrapper",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(picture_component/* default */.Z, {
                            src: bannerleftImage,
                            className: "banner-image",
                            pictureClass: "banner-picture"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "banner-text-and-cta",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "banner-text-and-link",
                            style: bannerIcon ? {
                                display: "flex",
                                "flex-direction": "row"
                            } : {},
                            children: [
                                bannerIcon && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "banner-icon-wrapper",
                                    style: {
                                        height: bannerIconHeight
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(picture_component/* default */.Z, {
                                        src: bannerIcon
                                    })
                                }),
                                getBannerText(),
                                bannerLinkData && /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    className: "banner-link",
                                    href: bannerLinkData.src,
                                    style: {
                                        color: themeStyle.color
                                    },
                                    target: "_blank",
                                    rel: "noreferrer",
                                    onClick: function() {
                                        return onBannerLinkClicked(bannerLinkData.src);
                                    },
                                    children: bannerLinkData.text
                                }),
                                buttonConfig && buttonConfig.buttonType && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "banner-cta-wrapper",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(button_button/* default */.Z, _object_spread({}, buttonConfig, getBannerButtonProps()))
                                })
                            ]
                        })
                    }),
                    bannerRightImage && !isMobileOrTabletBrowser && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "image-wrapper",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(picture_component/* default */.Z, {
                            src: bannerRightImage,
                            className: "banner-image",
                            pictureClass: "banner-picture"
                        })
                    })
                ]
            }),
            withCloseIcon && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "close-icon-wrapper",
                onClick: onCloseBanner,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_close/* default */.Z, {})
            })
        ]
    });
};
Banner.defaultProps = default_props;
/* harmony default export */ var banner = ((0,generic_config_context/* withGenericConfig */.P)(Banner));


/***/ }),

/***/ 20959:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ board_views_tab; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/styled-jsx/style.js
var style = __webpack_require__(60357);
var style_default = /*#__PURE__*/__webpack_require__.n(style);
// EXTERNAL MODULE: ./components/core/tabs/tabs-component.js + 1 modules
var tabs_component = __webpack_require__(10873);
// EXTERNAL MODULE: ./components/core/tabs/tab/tab-component.js + 1 modules
var tab_component = __webpack_require__(20525);
// EXTERNAL MODULE: ./components/core/asset/asset-component.js + 2 modules
var asset_component = __webpack_require__(24961);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./constants/vp-sizes.js
var vp_sizes = __webpack_require__(698);
;// CONCATENATED MODULE: ./segments/desktop/core-components/board-views-tab/board-views-tab.scss.js

var LINE_WIDTH = 4;
var LINE_WIDTH_STRING = "".concat(LINE_WIDTH, "px");
var componentStyles = new String(".board-views-tab-component{padding-top:60px;margin:auto;.tabs-component-wrapper{.tabs-component{.content{.asset-wrapper{min-height:350px;opacity:0;&.animation-active{opacity:1;-webkit-transition:opacity 1s ease;-moz-transition:opacity 1s ease;-o-transition:opacity 1s ease;transition:opacity 1s ease}}}}.tab-component{.tab-underline-placeholder{height:0px}&.active{background-color:unset;.tab-underline-placeholder{height:".concat(LINE_WIDTH_STRING, "}}}}.tabs-component-wrapper{&.full-size-content{.tabs-component{.content{width:100%;height:100%}}}}}"));
componentStyles.__hash = "b40de9e2347e1569";

// EXTERNAL MODULE: ./segments/desktop/core-components/board-views-tab/default-props.js
var default_props = __webpack_require__(2536);
;// CONCATENATED MODULE: ./segments/desktop/core-components/board-views-tab/board-views-tab.js
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}










var BoardViewsTab = function(props) {
    var distanceFromTop = props.distanceFromTop, activeTabId = props.activeTabId, fullSizeContent = props.fullSizeContent, tabsRenderer = props.tabsRenderer, onTabClick = props.onTabClick;
    var ref = (0,react.useState)(true), animationActive = ref[0], setAnimationActive = ref[1];
    var onTabClickCallBack = function(index) {
        setAnimationActive(false);
        setTimeout(function() {
            return setAnimationActive(true);
        }, 0);
        if (onTabClick) {
            onTabClick(index);
        }
    };
    var defaultTabsRenderer = function() {
        var tabs = props.tabs, theme = props.theme;
        return tabs === null || tabs === void 0 ? void 0 : tabs.map(function(tab, index) {
            var tabLabel = tab.tabLabel, asset = tab.asset, tabId = tab.tabId, image = tab.image;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(tab_component/* default */.Z, {
                tabId: tabId,
                label: tabLabel,
                color: theme,
                useXSMLabels: true,
                tabIcon: image,
                tabsWithIcons: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: classnames_default()("asset-wrapper", {
                        "animation-active": animationActive
                    }),
                    children: /*#__PURE__*/ (0,react.createElement)(asset_component/* default */.Z, _object_spread_props(_object_spread({}, asset), {
                        key: index
                    }))
                })
            }, index);
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "jsx-".concat(componentStyles.__hash) + " " + "board-views-tab-component",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "jsx-".concat(componentStyles.__hash) + " " + (classnames_default()("tabs-component-wrapper", {
                    "full-size-content": fullSizeContent
                }) || ""),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(tabs_component/* default */.Z, {
                    onTabClick: onTabClickCallBack,
                    distanceFromTop: distanceFromTop,
                    activeTabId: activeTabId,
                    autoTransition: false,
                    role: "tabpanel",
                    children: tabsRenderer ? tabsRenderer() : defaultTabsRenderer()
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)((style_default()), {
                id: componentStyles.__hash,
                children: componentStyles
            })
        ]
    });
};
BoardViewsTab.defaultProps = default_props/* default */.Z;
/* harmony default export */ var board_views_tab = (BoardViewsTab);


/***/ }),

/***/ 2536:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var styles_color_consts__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(273);

/* harmony default export */ __webpack_exports__["Z"] = ({
    theme: styles_color_consts__WEBPACK_IMPORTED_MODULE_0__.WORK_OS_IRIS_COLOR_NAME,
    tabs: [
        {
            tabLabel: "Main table",
            image: {
                src: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/work%20management_new%20product%20page/view/Table.png"
            },
            asset: {
                image: {
                    src: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/work%20management_new%20product%20page/view/Maintable_2.png",
                    alt: "Main table view"
                }
            }
        },
        {
            tabLabel: "Gantt",
            image: {
                src: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/work%20management_new%20product%20page/view/Gantt.png"
            },
            asset: {
                image: {
                    src: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/work%20management_new%20product%20page/view/Gantt_2.png",
                    alt: "Gantt view"
                }
            }
        },
        {
            tabLabel: "Kanban",
            image: {
                src: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/work%20management_new%20product%20page/view/Kanban.png"
            },
            asset: {
                image: {
                    src: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/work%20management_new%20product%20page/view/Kanban_2.png",
                    alt: "Kanban view"
                }
            }
        },
        {
            tabLabel: "Calendar",
            image: {
                src: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/work%20management_new%20product%20page/view/Calendar.png"
            },
            asset: {
                image: {
                    src: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/work%20management_new%20product%20page/view/calender_2.png",
                    alt: "Calendar view"
                }
            }
        },
        {
            tabLabel: "Dashboard",
            image: {
                src: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/work%20management_new%20product%20page/view/Dashboard.png"
            },
            asset: {
                image: {
                    src: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/work%20management_new%20product%20page/view/Dashboard_2.png",
                    alt: "Dashboard view"
                }
            }
        }
    ]
});


/***/ }),

/***/ 96143:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

/* harmony default export */ __webpack_exports__["Z"] = ({
    bulletsDirection: "row",
    bulletTextSize: "0.875rem",
    bullets: [
        {
            bulletText: "Support ticket management"
        },
        {
            bulletText: "Creative requests"
        }
    ]
});


/***/ }),

/***/ 11068:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Button; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(52951);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(88029);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 4 modules
var _create_super = __webpack_require__(60460);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./segments/desktop/core-components/button/regular-button/regular-button.js + 1 modules
var regular_button = __webpack_require__(35662);
// EXTERNAL MODULE: ./segments/desktop/core-components/button/secondary-button/secondary-button.js + 1 modules
var secondary_button = __webpack_require__(95736);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./segments/desktop/core-components/button/secondary-button/default-props.js
var default_props = __webpack_require__(28601);
// EXTERNAL MODULE: ./segments/desktop/core-components/button/regular-button/default-props.js
var regular_button_default_props = __webpack_require__(57578);
// EXTERNAL MODULE: ./components/core/new-button/button-component.js + 1 modules
var button_component = __webpack_require__(35061);
;// CONCATENATED MODULE: ./segments/desktop/core-components/button/two-link-buttons-button/default-props.js
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}



/* harmony default export */ var two_link_buttons_button_default_props = ({
    secondaryButtonConfig: _object_spread_props(_object_spread({}, default_props/* default */.Z), {
        buttonText: "Learn more"
    }),
    regularButtonConfig: _object_spread_props(_object_spread({}, regular_button_default_props/* default */.Z), {
        buttonText: "Get a demo",
        buttonSize: button_component.LG
    })
});

// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
// EXTERNAL MODULE: ./constants/vp-sizes.js
var vp_sizes = __webpack_require__(698);
;// CONCATENATED MODULE: ./segments/desktop/core-components/button/two-link-buttons-button/two-link-buttons-button.scss.js


var StyledTwoLinkButtonsButton = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "euz44uy0"
})("display:flex;align-items:center;gap:24px;&.swap-buttons-order{flex-direction:row-reverse;}@media (max-width:", vp_sizes/* MOBILE_QUERY_MAX_WIDTH_M */.TI, "){flex-direction:column-reverse;gap:24px;&.swap-buttons-order{flex-direction:column;}}");

;// CONCATENATED MODULE: ./segments/desktop/core-components/button/two-link-buttons-button/two-link-buttons-button.js




function two_link_buttons_button_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function two_link_buttons_button_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            two_link_buttons_button_define_property(target, key, source[key]);
        });
    }
    return target;
}







var TwoLinkButtonsButton = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(TwoLinkButtonsButton, PureComponent);
    var _super = (0,_create_super/* default */.Z)(TwoLinkButtonsButton);
    function TwoLinkButtonsButton() {
        (0,_class_call_check/* default */.Z)(this, TwoLinkButtonsButton);
        return _super.apply(this, arguments);
    }
    (0,_create_class/* default */.Z)(TwoLinkButtonsButton, [
        {
            key: "render",
            value: function render() {
                var _props = this.props, secondaryButtonConfig = _props.secondaryButtonConfig, regularButtonConfig = _props.regularButtonConfig, swapButtonsOrder = _props.swapButtonsOrder;
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledTwoLinkButtonsButton, {
                    className: classnames_default()("two-link-buttons-button", {
                        "swap-buttons-order": swapButtonsOrder
                    }),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "secondary-button-wrapper",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(secondary_button/* default */.Z, two_link_buttons_button_object_spread({}, secondaryButtonConfig))
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "regular-button-wrapper",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(regular_button/* default */.Z, two_link_buttons_button_object_spread({}, regularButtonConfig))
                        })
                    ]
                });
            }
        }
    ]);
    return TwoLinkButtonsButton;
}(react.PureComponent);

TwoLinkButtonsButton.defaultProps = two_link_buttons_button_default_props;

// EXTERNAL MODULE: ./segments/desktop/core-components/button/signup-button/signup-button.js + 1 modules
var signup_button = __webpack_require__(85850);
// EXTERNAL MODULE: ./segments/desktop/core-components/button/signup-button/default-props.js
var signup_button_default_props = __webpack_require__(47436);
;// CONCATENATED MODULE: ./segments/desktop/core-components/signup-combo-buttons-button/default-props.js
function default_props_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function default_props_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            default_props_define_property(target, key, source[key]);
        });
    }
    return target;
}
function default_props_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function default_props_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        default_props_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}


/* harmony default export */ var signup_combo_buttons_button_default_props = ({
    signupButtonConfig: signup_button_default_props/* default */.Z,
    secondaryButtonConfig: default_props_object_spread_props(default_props_object_spread({}, default_props/* default */.Z), {
        buttonText: "Learn more"
    })
});

;// CONCATENATED MODULE: ./segments/desktop/core-components/signup-combo-buttons-button/signup-combo-buttons-button.scss.js


var StyledSignupComboButtonsButton = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e19ejvdf0"
})("display:flex;align-items:center;gap:24px;&.swap-buttons-order{flex-direction:row-reverse;}@media (max-width:", vp_sizes/* MOBILE_QUERY_MAX_WIDTH_M */.TI, "){&.swap-buttons-order{flex-direction:column;}}");

;// CONCATENATED MODULE: ./segments/desktop/core-components/signup-combo-buttons-button/signup-combo-buttons-button.js




function signup_combo_buttons_button_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function signup_combo_buttons_button_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            signup_combo_buttons_button_define_property(target, key, source[key]);
        });
    }
    return target;
}







var SignupComboButtonsButton = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(SignupComboButtonsButton, PureComponent);
    var _super = (0,_create_super/* default */.Z)(SignupComboButtonsButton);
    function SignupComboButtonsButton() {
        (0,_class_call_check/* default */.Z)(this, SignupComboButtonsButton);
        return _super.apply(this, arguments);
    }
    (0,_create_class/* default */.Z)(SignupComboButtonsButton, [
        {
            key: "render",
            value: function render() {
                var _props = this.props, secondaryButtonConfig = _props.secondaryButtonConfig, signupButtonConfig = _props.signupButtonConfig, swapButtonsOrder = _props.swapButtonsOrder;
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledSignupComboButtonsButton, {
                    className: classnames_default()("signup-combo-buttons-button", swapButtonsOrder && "swap-buttons-order"),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "signup-button-wrapper",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(signup_button/* default */.Z, signup_combo_buttons_button_object_spread({}, signupButtonConfig))
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "secondary-button-wrapper",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(secondary_button/* default */.Z, signup_combo_buttons_button_object_spread({}, secondaryButtonConfig))
                        })
                    ]
                });
            }
        }
    ]);
    return SignupComboButtonsButton;
}(react.PureComponent);

SignupComboButtonsButton.defaultProps = signup_combo_buttons_button_default_props;

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_assert_this_initialized.mjs
var _assert_this_initialized = __webpack_require__(4111);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(10092);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
// EXTERNAL MODULE: ./client/services/hubspot-service/hubspot-service.js
var hubspot_service = __webpack_require__(23155);
// EXTERNAL MODULE: ./contexts/generic-config-context.js
var generic_config_context = __webpack_require__(3156);
// EXTERNAL MODULE: ./constants/bigbrain-event-types.js
var bigbrain_event_types = __webpack_require__(65023);
// EXTERNAL MODULE: ./components/core/button/button-component.js + 5 modules
var button_button_component = __webpack_require__(20776);
// EXTERNAL MODULE: ./components/core/inputs/email-input-component.js + 1 modules
var email_input_component = __webpack_require__(89766);
;// CONCATENATED MODULE: ./segments/desktop/core-components/button/email-button/default-props.js
/* harmony default export */ var email_button_default_props = ({});

// EXTERNAL MODULE: ./components/enhancements/input-error-handler/input-error-handler.js + 1 modules
var input_error_handler = __webpack_require__(84640);
// EXTERNAL MODULE: ./styles/colors.js
var colors = __webpack_require__(12573);
// EXTERNAL MODULE: ./styles/color-consts.js
var color_consts = __webpack_require__(273);
;// CONCATENATED MODULE: ./segments/desktop/core-components/button/email-button/email-button.scss.js




var StyledEmailButton = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1mjlvrz0"
})("margin:8px 0px;width:100%;.email-button-inner{display:flex;justify-content:center;height:50px;input{font-size:0.875rem;line-height:8px;padding:12px 24px;border-radius:40px;font-size:1rem;-webkit-appearance:none;//Remove shadow from input in mobile safari\n\n      background-color:", colors/* default.light-grey */.Z["light-grey"], ";color:", colors/* default.black */.Z.black, ";border:1px solid;border-color:", colors/* default.grey */.Z.grey, ";outline:none;text-align:left;transition:border-color 0.1s ease-in-out;margin-right:16px;&:hover::placeholder,&:focus::placeholder{color:", colors/* default */.Z[color_consts.WORK_OS_IRIS_COLOR_NAME], ";}&:focus{border-color:", colors/* default */.Z[color_consts.WORK_OS_IRIS_COLOR_NAME], ";background-color:", colors/* default.white */.Z.white, ";}}&.error input,&.error input:focus{border-color:", colors/* default.error */.Z.error, ";}button.ladda-button.sm{font-size:0.875rem;}.only-button{min-width:300px;}.email-button-wrapper{.email-button-class{min-width:130px;.email-button-arrow-wrapper{padding-left:18px;svg{fill:currentColor;height:12px;}}}}}.notice-text-wrapper{margin-top:8px;padding-left:24px;font-size:0.8125rem;}@media (max-width:", vp_sizes/* TABLET_QUERY_MAX_WIDTH */.y, "){&:not(.force-horizontal){.email-button-inner{flex-direction:column;text-align:center;input{margin-bottom:16px;font-size:0.875rem;padding:16px 8px;margin-right:0;text-align:center;min-width:264px;}.email-button-wrapper{width:100%;button{font-size:0.875rem;padding:16px 48px;width:100%;}}}}}");

;// CONCATENATED MODULE: ./segments/desktop/core-components/button/email-button/email-button.js





function email_button_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}










var DEFAULT_CTA_KEY = "signup.cta";
var EmailButton = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(EmailButton, PureComponent);
    var _super = (0,_create_super/* default */.Z)(EmailButton);
    function EmailButton(props) {
        (0,_class_call_check/* default */.Z)(this, EmailButton);
        var _this;
        _this = _super.call(this, props);
        email_button_define_property((0,_assert_this_initialized/* default */.Z)(_this), "focusOnInput", function() {
            _this._emailInput && _this._emailInput.focus();
        });
        _this._emailInput = null;
        _this.updateEmail = _this.updateEmail.bind((0,_assert_this_initialized/* default */.Z)(_this));
        _this.handleOnClickIfNeeded = _this.handleOnClickIfNeeded.bind((0,_assert_this_initialized/* default */.Z)(_this));
        _this.onClick = _this.onClick.bind((0,_assert_this_initialized/* default */.Z)(_this));
        return _this;
    }
    (0,_create_class/* default */.Z)(EmailButton, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                var _props = this.props, focusOnLoad = _props.focusOnLoad, isFirstSegment = _props.isFirstSegment, isPreview = _props.isPreview;
                if (isPreview) return;
                var shouldFocus = focusOnLoad || isFirstSegment;
                shouldFocus && this.focusOnInput();
            }
        },
        {
            key: "updateEmail",
            value: function updateEmail(event) {
                var _props = this.props, errorStateCallback = _props.errorStateCallback, onEmailChange = _props.onEmailChange;
                errorStateCallback(false);
                onEmailChange(event.target.value);
            }
        },
        {
            key: "getButtonText",
            value: function getButtonText() {
                var _props = this.props, buttonText = _props.buttonText, translate = _props.translate;
                return buttonText || translate(DEFAULT_CTA_KEY); //removed from default props because of localization
            }
        },
        {
            key: "getPlaceholderText",
            value: function getPlaceholderText() {
                var _props = this.props, placeholder = _props.placeholder, translate = _props.translate;
                return placeholder || translate("signup.emailInputPlaceholder");
            }
        },
        {
            key: "onClick",
            value: function onClick() {
                var _props = this.props, errorStateCallback = _props.errorStateCallback, onButtonClick = _props.onButtonClick, emailValue = _props.emailValue;
                if (!emailValue) {
                    BigBrain("track", bigbrain_event_types.CLICKED_SIGNUP_WITHOUT_INSERTING_EMAIL);
                }
                if (!this._emailInput.isValid()) {
                    errorStateCallback(true);
                    return;
                }
                onButtonClick();
            }
        },
        {
            key: "handleOnClickIfNeeded",
            value: function handleOnClickIfNeeded(event) {
                if (event.key === "Enter") {
                    this.onClick();
                    event.preventDefault();
                }
            }
        },
        {
            key: "render",
            value: function render() {
                var _this = this;
                var _props = this.props, emailValue = _props.emailValue, buttonColor = _props.buttonColor, buttonSize = _props.buttonSize, isErrorState = _props.isErrorState, className = _props.className, borderColor = _props.borderColor, disableButtonAnimation = _props.disableButtonAnimation, placeholderFocusColor = _props.placeholderFocusColor, withButtonArrow = _props.withButtonArrow, buttonSpinnerColor = _props.buttonSpinnerColor, isLoading = _props.isLoading, noticeText = _props.noticeText;
                var buttonTextToUse = this.getButtonText();
                var placeholderToUse = this.getPlaceholderText();
                var clickAction = this.onClick;
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledEmailButton, {
                    className: classnames_default()("email-button", className, {
                        error: isErrorState
                    }),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "email-button-inner",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(email_input_component/* default */.Z, {
                                    className: "email-button-input",
                                    ref: function(el) {
                                        return _this._emailInput = el;
                                    },
                                    value: emailValue,
                                    onChange: this.updateEmail,
                                    placeholder: placeholderToUse,
                                    onKeyPress: this.handleOnClickIfNeeded,
                                    autoComplete: "on",
                                    placeholderFocusColor: placeholderFocusColor,
                                    style: {
                                        borderColor: borderColor
                                    }
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "email-button-wrapper",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(button_button_component/* default */.Z, {
                                        className: "email-button-class",
                                        color: buttonColor,
                                        size: buttonSize,
                                        isLoading: isLoading,
                                        onClickCallback: clickAction,
                                        disableAnimation: disableButtonAnimation,
                                        dataSpinnerColor: buttonSpinnerColor,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "button-text",
                                                children: buttonTextToUse
                                            }),
                                            withButtonArrow && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "email-button-arrow-wrapper",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RightArrow, {})
                                            })
                                        ]
                                    })
                                })
                            ]
                        }),
                        noticeText && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "notice-text-wrapper",
                            children: noticeText
                        })
                    ]
                });
            }
        }
    ]);
    return EmailButton;
}(react.PureComponent);
EmailButton.defaultProps = email_button_default_props;
/* harmony default export */ var email_button = ((0,input_error_handler/* default */.Z)((0,generic_config_context/* withGenericConfig */.P)(EmailButton)));

// EXTERNAL MODULE: ./client/services/hubspot-service/contact-form-config.js + 1 modules
var contact_form_config = __webpack_require__(49228);
;// CONCATENATED MODULE: ./segments/desktop/core-components/button/subscribe-button/default-props.js
/* harmony default export */ var subscribe_button_default_props = ({
    buttonText: "Subscribe"
});

;// CONCATENATED MODULE: ./segments/desktop/core-components/button/subscribe-button/subscribe-button.scss.js

var StyledSubscribeButton = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "etj7kzy0"
})();

;// CONCATENATED MODULE: ./segments/desktop/core-components/button/subscribe-button/subscribe-button.js






function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function subscribe_button_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function subscribe_button_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            subscribe_button_define_property(target, key, source[key]);
        });
    }
    return target;
}
function subscribe_button_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function subscribe_button_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        subscribe_button_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}










var FORM_GUID = "e13c9bb3-29ee-4ef1-b5b9-78d946c95502";
var SubscribeButton = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(SubscribeButton, PureComponent);
    var _super = (0,_create_super/* default */.Z)(SubscribeButton);
    function SubscribeButton(props) {
        (0,_class_call_check/* default */.Z)(this, SubscribeButton);
        var _this;
        _this = _super.call(this, props);
        var _this1 = (0,_assert_this_initialized/* default */.Z)(_this);
        subscribe_button_define_property((0,_assert_this_initialized/* default */.Z)(_this), "onButtonClick", /*#__PURE__*/ _async_to_generator(function() {
            var _state, subscribed, emailValue, res;
            return (0,tslib_es6.__generator)(this, function(_state1) {
                switch(_state1.label){
                    case 0:
                        _state = _this1.state, subscribed = _state.subscribed, emailValue = _state.emailValue;
                        _this1.trackEvent(bigbrain_event_types.CLICKED_SUBSCRIBE_BUTTON);
                        if (!!subscribed) return [
                            3,
                            2
                        ];
                        _this1.setState({
                            isButtonLoading: true
                        });
                        _this1.trackEvent(bigbrain_event_types.SUBSCRIPTION_REQUESTED);
                        return [
                            4,
                            (0,hubspot_service/* submitHubspotForm */.WJ)(contact_form_config/* PORTAL_ID */.Im, FORM_GUID, emailValue)
                        ];
                    case 1:
                        res = _state1.sent();
                        if (res) {
                            _this1.trackEvent(bigbrain_event_types.SUBSCRIPTION_SUCCESS);
                            _this1.setState({
                                isButtonLoading: false,
                                subscribed: true,
                                emailValue: ""
                            });
                        }
                        _state1.label = 2;
                    case 2:
                        return [
                            2
                        ];
                }
            });
        }));
        subscribe_button_define_property((0,_assert_this_initialized/* default */.Z)(_this), "onEmailChange", function(emailValue) {
            _this.setState({
                emailValue: emailValue,
                subscribed: false
            });
        });
        _this.state = {
            isButtonLoading: false,
            subscribed: false,
            emailValue: ""
        };
        return _this;
    }
    (0,_create_class/* default */.Z)(SubscribeButton, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this.trackEvent(bigbrain_event_types.SUBSCRIBE_BUTTON_RENDERED);
            }
        },
        {
            key: "trackEvent",
            value: function trackEvent(eventName) {
                var router = this.props.router;
                BigBrain("track", bigbrain_event_types.SUBSCRIBE_BUTTON_BIGBRAIN_EVENT_NAME, {
                    kind: eventName,
                    placement: router.asPath
                });
            }
        },
        {
            key: "render",
            value: function render() {
                var _state = this.state, isButtonLoading = _state.isButtonLoading, subscribed = _state.subscribed, emailValue = _state.emailValue;
                var translate = this.props.translate;
                var noticeText = subscribed && !emailValue ? translate("button.thankYou") : "";
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledSubscribeButton, {
                    className: "signup-button",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(email_button, subscribe_button_object_spread_props(subscribe_button_object_spread({}, this.props), {
                        emailValue: emailValue,
                        onButtonClick: this.onButtonClick,
                        onEmailChange: this.onEmailChange,
                        isLoading: isButtonLoading,
                        borderColor: "gray",
                        noticeText: noticeText
                    }))
                });
            }
        }
    ]);
    return SubscribeButton;
}(react.PureComponent);
SubscribeButton.defaultProps = subscribe_button_default_props;
/* harmony default export */ var subscribe_button = ((0,generic_config_context/* withGenericConfig */.P)((0,router.withRouter)(SubscribeButton)));

// EXTERNAL MODULE: ./segments/desktop/core-components/button/youtube-popup-button/youtube-popup-button.js + 3 modules
var youtube_popup_button = __webpack_require__(25101);
// EXTERNAL MODULE: ./segments/desktop/core-components/button/youtube-popup-button/default-props.js
var youtube_popup_button_default_props = __webpack_require__(62129);
;// CONCATENATED MODULE: ./segments/desktop/core-components/button/signup-and-youtube-combo-button/default-props.js
function signup_and_youtube_combo_button_default_props_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function signup_and_youtube_combo_button_default_props_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            signup_and_youtube_combo_button_default_props_define_property(target, key, source[key]);
        });
    }
    return target;
}


/* harmony default export */ var signup_and_youtube_combo_button_default_props = ({
    signupButtonConfig: signup_and_youtube_combo_button_default_props_object_spread({}, signup_button_default_props/* default */.Z),
    youtubePopupButtonConfig: signup_and_youtube_combo_button_default_props_object_spread({}, youtube_popup_button_default_props/* default */.Z)
});

;// CONCATENATED MODULE: ./segments/desktop/core-components/button/signup-and-youtube-combo-button/signup-and-youtube-combo-button.scss.js


var StyledSignupAndYoutubeComboButton = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "ewfh8mi0"
})("display:flex;align-items:flex-start;gap:24px;.secondary-button-wrapper{height:50px;display:flex;align-items:center;}@media (max-width:", vp_sizes/* MOBILE_QUERY_MAX_WIDTH_M */.TI, "){flex-direction:column;align-items:center;}");

;// CONCATENATED MODULE: ./segments/desktop/core-components/button/signup-and-youtube-combo-button/signup-and-youtube-combo-button.js




function signup_and_youtube_combo_button_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function signup_and_youtube_combo_button_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            signup_and_youtube_combo_button_define_property(target, key, source[key]);
        });
    }
    return target;
}






var SignupAndYoutubeComboButton = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(SignupAndYoutubeComboButton, PureComponent);
    var _super = (0,_create_super/* default */.Z)(SignupAndYoutubeComboButton);
    function SignupAndYoutubeComboButton() {
        (0,_class_call_check/* default */.Z)(this, SignupAndYoutubeComboButton);
        return _super.apply(this, arguments);
    }
    (0,_create_class/* default */.Z)(SignupAndYoutubeComboButton, [
        {
            key: "render",
            value: function render() {
                var _props = this.props, youtubePopupButtonConfig = _props.youtubePopupButtonConfig, signupButtonConfig = _props.signupButtonConfig;
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledSignupAndYoutubeComboButton, {
                    className: "signup-and-youtube-combo-button",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "regular-button-wrapper",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(signup_button/* default */.Z, signup_and_youtube_combo_button_object_spread({}, signupButtonConfig))
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "secondary-button-wrapper",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(youtube_popup_button/* default */.Z, signup_and_youtube_combo_button_object_spread({}, youtubePopupButtonConfig))
                        })
                    ]
                });
            }
        }
    ]);
    return SignupAndYoutubeComboButton;
}(react.PureComponent);

SignupAndYoutubeComboButton.defaultProps = signup_and_youtube_combo_button_default_props;

;// CONCATENATED MODULE: ./segments/desktop/core-components/button/button.scss.js

var StyledButtton = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "eo7hf3m0"
})();

// EXTERNAL MODULE: ./segments/desktop/core-components/button/button-consts.js
var button_consts = __webpack_require__(75650);
;// CONCATENATED MODULE: ./segments/desktop/core-components/button/default-props.js

/* harmony default export */ var button_default_props = ({
    buttonType: button_consts/* REGULAR_BUTTON_TYPE */.ys
});

;// CONCATENATED MODULE: ./segments/desktop/core-components/button/button.js




function button_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function button_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            button_define_property(target, key, source[key]);
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}













var Button = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(Button, PureComponent);
    var _super = (0,_create_super/* default */.Z)(Button);
    function Button() {
        (0,_class_call_check/* default */.Z)(this, Button);
        return _super.apply(this, arguments);
    }
    (0,_create_class/* default */.Z)(Button, [
        {
            key: "getButtonComponent",
            value: function getButtonComponent() {
                var buttonType = this.props.buttonType;
                switch(buttonType){
                    case button_consts/* REGULAR_BUTTON_TYPE */.ys:
                        return regular_button/* default */.Z;
                    case button_consts/* SECONDARY_BUTTON_TYPE */.jE:
                        return secondary_button/* default */.Z;
                    case button_consts/* SIGNUP_BUTTON_TYPE */.ge:
                        return signup_button/* default */.Z;
                    case button_consts/* TWO_LINK_BUTTONS_TYPE */.Q_:
                        return TwoLinkButtonsButton;
                    case button_consts/* SIGNUP_COMBO_BUTTONS_TYPE */.ae:
                        return SignupComboButtonsButton;
                    case button_consts/* SUBSCRIBE_BUTTON_TYPE */.$j:
                        return subscribe_button;
                    case button_consts/* YOUTUBE_POPUP_LINK_TYPE */.F9:
                        return youtube_popup_button/* default */.Z;
                    case button_consts/* SIGNUP_AND_YOUTUBE_COMBO_BUTTONS_TYPE */.iF:
                        return SignupAndYoutubeComboButton;
                    default:
                        return null;
                }
            }
        },
        {
            key: "render",
            value: function render() {
                var ButtonComponent = this.getButtonComponent();
                if (!ButtonComponent) return null;
                var _this_props = this.props, buttonType = _this_props.buttonType, restButtonConfig = _object_without_properties(_this_props, [
                    "buttonType"
                ]);
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledButtton, {
                    className: "button",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonComponent, button_object_spread({}, restButtonConfig))
                });
            }
        }
    ]);
    return Button;
}(react.PureComponent);

Button.defaultProps = button_default_props;


/***/ }),

/***/ 57578:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var components_core_new_button_button_component__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(35061);
/* harmony import */ var styles_color_consts__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(273);
/* harmony import */ var constants_button_additional_text_position__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(87154);



/* harmony default export */ __webpack_exports__["Z"] = ({
    buttonSize: components_core_new_button_button_component__WEBPACK_IMPORTED_MODULE_0__.MD,
    buttonText: "Button",
    isOpenLinkInNewTab: false,
    onClick: null,
    color: styles_color_consts__WEBPACK_IMPORTED_MODULE_1__.WORK_OS_IRIS_COLOR_NAME,
    isWithArrow: true,
    minPadding: false,
    additionalText: null,
    additionalTextPosition: constants_button_additional_text_position__WEBPACK_IMPORTED_MODULE_2__/* .BELOW */ ._,
    additionalTextMaxWidth: null,
    iconRenderer: null,
    extraEventData: {}
});


/***/ }),

/***/ 35662:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ regular_button; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_assert_this_initialized.mjs
var _assert_this_initialized = __webpack_require__(4111);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(52951);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(88029);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 4 modules
var _create_super = __webpack_require__(60460);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./components/core/new-button/button-component.js + 1 modules
var button_component = __webpack_require__(35061);
// EXTERNAL MODULE: ./segments/button-service.js
var button_service = __webpack_require__(93833);
// EXTERNAL MODULE: ./constants/bigbrain-event-types.js
var bigbrain_event_types = __webpack_require__(65023);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./styles/color-consts.js
var color_consts = __webpack_require__(273);
// EXTERNAL MODULE: ./contexts/ab-tests-context.js
var ab_tests_context = __webpack_require__(24492);
// EXTERNAL MODULE: ./constants/links.js + 20 modules
var links = __webpack_require__(27639);
// EXTERNAL MODULE: ./contexts/generic-config-context.js
var generic_config_context = __webpack_require__(3156);
// EXTERNAL MODULE: ./utils/url.js
var utils_url = __webpack_require__(8339);
// EXTERNAL MODULE: ./client/components/system/monday-markup-language/monday-markup-language-component.js + 11 modules
var monday_markup_language_component = __webpack_require__(36239);
// EXTERNAL MODULE: ./services/bigbrain-service.js
var bigbrain_service = __webpack_require__(65488);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
;// CONCATENATED MODULE: ./segments/desktop/core-components/button/regular-button/regular-button.scss.js

var StyledRegularButton = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e633rko0"
})("&.full{width:100%;}.additional-button-text{margin-top:8px;}");

// EXTERNAL MODULE: ./segments/desktop/core-components/button/regular-button/default-props.js
var default_props = __webpack_require__(57578);
;// CONCATENATED MODULE: ./segments/desktop/core-components/button/regular-button/regular-button.js





function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}















var isSeoFriendlyUrl = function(url) {
    var res = false;
    if (url && url.indexOf(links/* MONDAY_AUTH_DOMAIN */.NyZ) < 0) {
        res = true;
    }
    return res;
};
var RegularButton = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(RegularButton, PureComponent);
    var _super = (0,_create_super/* default */.Z)(RegularButton);
    function RegularButton(props) {
        (0,_class_call_check/* default */.Z)(this, RegularButton);
        var _this;
        _this = _super.call(this, props);
        _define_property((0,_assert_this_initialized/* default */.Z)(_this), "onClick", function(e) {
            var _props = _this.props, buttonText = _props.buttonText, url = _props.url, isOpenLinkInNewTab = _props.isOpenLinkInNewTab, onClick = _props.onClick, extraEventData = _props.extraEventData;
            var isKeyboardEvent = (e === null || e === void 0 ? void 0 : e.screenX) === 0 && (e === null || e === void 0 ? void 0 : e.screenY) === 0;
            (0,bigbrain_service.trackEvent)(bigbrain_event_types.REGULAR_BUTTON_CLICKED, {
                kind: buttonText,
                info1: isKeyboardEvent ? "keyboard" : "mouse",
                info2: url,
                info3: (0,utils_url.getLastPartOfUrl)(url),
                data: extraEventData
            });
            if (onClick) {
                onClick(e);
            }
            if (url && !_this.isSeoFriendlyUrl) {
                if (isOpenLinkInNewTab) {
                    window.open(url);
                } else {
                    window.location.href = url;
                }
            }
        });
        _define_property((0,_assert_this_initialized/* default */.Z)(_this), "getButtonBackgroundColor", function(color) {
            if (color === color_consts.DODGER_BLUE_COLOR_NAME || color === color_consts.SPACE_BLUE_COLOR_NAME) {
                return color_consts.WORK_OS_IRIS_COLOR_NAME;
            }
            return color;
        });
        _define_property((0,_assert_this_initialized/* default */.Z)(_this), "getButtonStrippedText", function() {
            var buttonText = _this.props.buttonText;
            var disallowedButtonChars = [
                /\s*>/g
            ];
            var strippedButtonText = buttonText;
            disallowedButtonChars.forEach(function(ending) {
                strippedButtonText = strippedButtonText.replace(ending, "");
            });
            return strippedButtonText;
        });
        _this.isSeoFriendlyUrl = isSeoFriendlyUrl(props.url);
        return _this;
    }
    (0,_create_class/* default */.Z)(RegularButton, [
        {
            key: "render",
            value: function render() {
                var _props = this.props, buttonSize = _props.buttonSize, color = _props.color, outline = _props.outline, isWithArrow = _props.isWithArrow, iconRenderer = _props.iconRenderer, minPadding = _props.minPadding, url = _props.url, isOpenLinkInNewTab = _props.isOpenLinkInNewTab, additionalText = _props.additionalText, additionalTextPosition = _props.additionalTextPosition, additionalTextMaxWidth = _props.additionalTextMaxWidth, className = _props.className;
                var buttonStyle = button_service/* buttonStyles */.$Y[color] || {};
                var textColor = buttonStyle.textColor, backgroundColorName = buttonStyle.backgroundColorName;
                var buttonColor = this.getButtonBackgroundColor(backgroundColorName);
                var buttonStrippedText = this.getButtonStrippedText();
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledRegularButton, {
                    className: classnames_default()("regular-button", buttonSize, additionalText && "additional-text additional-text-".concat(additionalTextPosition)),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(button_component/* default */.ZP, {
                            seoFriendlyUrl: this.isSeoFriendlyUrl && url,
                            isOpenLinkInNewTab: isOpenLinkInNewTab,
                            size: buttonSize,
                            onClick: this.onClick,
                            color: buttonColor,
                            textColor: textColor,
                            outline: outline,
                            isWithArrow: isWithArrow,
                            className: className,
                            iconRenderer: iconRenderer,
                            minPadding: minPadding,
                            children: buttonStrippedText
                        }),
                        additionalText && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: classnames_default()("additional-button-text", this.additionalTextPosition),
                            style: {
                                maxWidth: additionalTextMaxWidth
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(monday_markup_language_component/* default */.Z, {
                                text: additionalText
                            })
                        })
                    ]
                });
            }
        }
    ]);
    return RegularButton;
}(react.PureComponent);
RegularButton.defaultProps = default_props/* default */.Z;
/* harmony default export */ var regular_button = ((0,generic_config_context/* withGenericConfig */.P)((0,ab_tests_context/* withAbTests */.k)(RegularButton)));


/***/ }),

/***/ 28601:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

/* harmony default export */ __webpack_exports__["Z"] = ({
    buttonText: "Button",
    isWithArrow: true,
    color: "black",
    onClick: undefined,
    withoutUnderline: false
});


/***/ }),

/***/ 95736:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ secondary_button; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./styles/colors.js
var colors = __webpack_require__(12573);
// EXTERNAL MODULE: ./constants/bigbrain-event-types.js
var bigbrain_event_types = __webpack_require__(65023);
// EXTERNAL MODULE: ./client/services/accessibility/accessibility-service.js
var accessibility_service = __webpack_require__(60696);
// EXTERNAL MODULE: ./styles/color-consts.js
var color_consts = __webpack_require__(273);
// EXTERNAL MODULE: ./contexts/ab-tests-context.js
var ab_tests_context = __webpack_require__(24492);
// EXTERNAL MODULE: ./utils/url.js
var utils_url = __webpack_require__(8339);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./static/svg/arrow-right-3.svg
var arrow_right_3 = __webpack_require__(58462);
// EXTERNAL MODULE: ./utils/general.js
var general = __webpack_require__(56093);
// EXTERNAL MODULE: ./services/monday-platform/existing-accounts-service.js
var existing_accounts_service = __webpack_require__(14124);
// EXTERNAL MODULE: ./services/bigbrain-service.js
var bigbrain_service = __webpack_require__(65488);
// EXTERNAL MODULE: ./segments/desktop/core-components/button/secondary-button/default-props.js
var default_props = __webpack_require__(28601);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
// EXTERNAL MODULE: ./segments/desktop/core-components/button/button-consts.js
var button_consts = __webpack_require__(75650);
;// CONCATENATED MODULE: ./segments/desktop/core-components/button/secondary-button/secondary-button.scss.js


var StyledSecondaryButton = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1f4h8u20"
})("font-size:0.875rem;font-weight:700;line-height:24px;display:flex;a{display:flex;align-items:center;text-decoration:none;&.with-underline{background:linear-gradient(to right,var(--underline-color-with-opacity),var(--underline-color-with-opacity)),linear-gradient(to right,var(--underline-color),var(--underline-color),var(--underline-color));background-size:100% 1px,0 1px;background-position:100% 100%,0 100%;background-repeat:no-repeat;transition:", button_consts/* UNDERLINE_TRANSITION */.Mw, ";&.with-icon{background-size:calc(100% - 48px) 1px,0px 1px;background-position:100% 100%,48px 100%;}&.with-icon-instead-of-arrow{background-size:100% 1px,0px 1px;background-position:100% 100%,0px 100%;}&:hover,&:focus{background-size:0 1px,100% 1px;}}}.left-side-icon{margin-right:16px;}.arrow-wrapper{padding-left:8px;padding-right:4px;margin-right:-4px;transition:", button_consts/* ARROW_TRANSITION */.NY, ";svg{fill:currentColor;height:10px;width:12px;}}.icon-instead-of-arrow-wrapper{display:flex;padding-left:8px;.play-wrapper{padding-right:0;svg{width:16px;}}}&:hover{.arrow-wrapper{padding-left:12px;padding-right:0px;}}");

// EXTERNAL MODULE: ./components/core/asset/asset-component.js + 2 modules
var asset_component = __webpack_require__(24961);
;// CONCATENATED MODULE: ./segments/desktop/core-components/button/secondary-button/secondary-button.js
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}















var SecondaryButton = function(props) {
    var buttonText = props.buttonText, url = props.url, isOpenLinkInNewTab = props.isOpenLinkInNewTab, color = props.color, isWithArrow = props.isWithArrow, iconRenderer = props.iconRenderer, isWithIconInsteadOfArrow = props.isWithIconInsteadOfArrow, withoutUnderline = props.withoutUnderline, onClick = props.onClick, platformUrl = props.platformUrl, leftSideIcon = props.leftSideIcon;
    var buttonUrl = platformUrl && (0,existing_accounts_service/* isExistingAccount */.vn)() ? (0,existing_accounts_service/* getMondayUrl */.Xm)(platformUrl) : url;
    var onButtonClick = function(e) {
        var isKeyboardEvent = (e === null || e === void 0 ? void 0 : e.screenX) === 0 && (e === null || e === void 0 ? void 0 : e.screenY) === 0;
        (0,bigbrain_service.trackEvent)(bigbrain_event_types.SECONDARY_BUTTON_CLICKED, {
            kind: buttonText,
            info1: isKeyboardEvent ? "keyboard" : "mouse",
            info2: buttonUrl,
            info3: (0,utils_url.getLastPartOfUrl)(buttonUrl)
        });
        if (onClick) {
            onClick(e);
        }
    };
    var getButtonColor = function(accessibleColor) {
        if (accessibleColor === color_consts.DODGER_BLUE_COLOR_NAME) return color_consts.SPACE_BLUE_COLOR_NAME;
        if (accessibleColor === color_consts.ELEVATE_BUTTON_GRADIANT_COLOR_NAME) return color_consts.WHITE_COLOR_NAME;
        return accessibleColor;
    };
    var accessibleColor = (0,accessibility_service/* getAccessibleButtonColor */.ef)(color);
    var finalColor = getButtonColor(accessibleColor);
    var showIcon = iconRenderer && !isWithIconInsteadOfArrow;
    var showArrow = isWithArrow && !isWithIconInsteadOfArrow;
    var showIconInsteadOfArrow = isWithIconInsteadOfArrow && iconRenderer;
    var aProps = {
        style: {
            color: colors/* default */.Z[finalColor],
            "--underline-color": colors/* default */.Z[finalColor],
            "--underline-color-with-opacity": (0,general/* hexToRgba */.a7)(colors/* default */.Z[finalColor], 0.4)
        }
    };
    if (buttonUrl) {
        aProps = _object_spread_props(_object_spread({}, aProps), {
            href: buttonUrl,
            target: isOpenLinkInNewTab ? "_blank" : "_self"
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledSecondaryButton, {
        className: "secondary-button",
        children: [
            leftSideIcon && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: "left-side-icon",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(asset_component/* default */.Z, {
                    image: {
                        src: leftSideIcon === null || leftSideIcon === void 0 ? void 0 : leftSideIcon.src
                    },
                    width: leftSideIcon === null || leftSideIcon === void 0 ? void 0 : leftSideIcon.size
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", _object_spread_props(_object_spread({}, aProps), {
                onClick: onButtonClick,
                className: classnames_default()({
                    "with-icon": iconRenderer,
                    "with-icon-instead-of-arrow": showIconInsteadOfArrow,
                    "with-underline": !withoutUnderline
                }),
                children: [
                    showIcon && iconRenderer(),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "secondary-button-text",
                        children: buttonText
                    }),
                    showArrow && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "arrow-wrapper",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(arrow_right_3/* default */.Z, {})
                    }),
                    showIconInsteadOfArrow && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "icon-instead-of-arrow-wrapper",
                        children: iconRenderer()
                    })
                ]
            }))
        ]
    });
};
SecondaryButton.defaultProps = default_props/* default */.Z;
/* harmony default export */ var secondary_button = ((0,ab_tests_context/* withAbTests */.k)(SecondaryButton));


/***/ }),

/***/ 47436:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _constants_button_additional_text_position__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(87154);

/* harmony default export */ __webpack_exports__["Z"] = ({
    withButtonArrow: true,
    additionalText: null,
    additionalTextPosition: _constants_button_additional_text_position__WEBPACK_IMPORTED_MODULE_0__/* .BELOW */ ._,
    additionalTextMaxWidth: null
});


/***/ }),

/***/ 85850:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ SignupButton; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(52951);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(88029);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 4 modules
var _create_super = __webpack_require__(60460);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./components/core/signups/regular-signup-component/regular-signup-component.js + 1 modules
var regular_signup_component = __webpack_require__(74115);
// EXTERNAL MODULE: ./segments/desktop/core-components/button/signup-button/default-props.js
var default_props = __webpack_require__(47436);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
;// CONCATENATED MODULE: ./segments/desktop/core-components/button/signup-button/signup-button.scss.js

var StyledSignupButton = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "eb0ljuq0"
})();

;// CONCATENATED MODULE: ./segments/desktop/core-components/button/signup-button/signup-button.js




function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}





var SignupButton = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(SignupButton, PureComponent);
    var _super = (0,_create_super/* default */.Z)(SignupButton);
    function SignupButton() {
        (0,_class_call_check/* default */.Z)(this, SignupButton);
        return _super.apply(this, arguments);
    }
    (0,_create_class/* default */.Z)(SignupButton, [
        {
            key: "render",
            value: function render() {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledSignupButton, {
                    className: "signup-button",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(regular_signup_component/* default */.Z, _object_spread({
                        withButtonArrow: false
                    }, this.props))
                });
            }
        }
    ]);
    return SignupButton;
}(react.PureComponent);

SignupButton.defaultProps = default_props/* default */.Z;


/***/ }),

/***/ 62129:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

/* harmony default export */ __webpack_exports__["Z"] = ({
    buttonText: "Button",
    isWithArrow: true,
    color: "black",
    isWithIcon: false,
    iconColor: "green",
    isWithIconInsteadOfArrow: false,
    outline: false,
    minPadding: false
});


/***/ }),

/***/ 25101:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ youtube_popup_button; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_assert_this_initialized.mjs
var _assert_this_initialized = __webpack_require__(4111);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(52951);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(88029);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 4 modules
var _create_super = __webpack_require__(60460);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./components/core/youtube-video-modal/youtube-video-modal-component.js + 7 modules
var youtube_video_modal_component = __webpack_require__(60202);
// EXTERNAL MODULE: ./constants/bigbrain-event-types.js
var bigbrain_event_types = __webpack_require__(65023);
// EXTERNAL MODULE: ./segments/desktop/core-components/button/secondary-button/secondary-button.js + 1 modules
var secondary_button = __webpack_require__(95736);
;// CONCATENATED MODULE: ./static/svg/videos/video-play-core-button-v4.svg
var _circle, _path;
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}

var SvgVideoPlayCoreButtonV4 = function SvgVideoPlayCoreButtonV4(props) {
    return /*#__PURE__*/ react.createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 32,
        height: 32,
        fill: "none",
        viewBox: "0 0 32 32"
    }, props), _circle || (_circle = /*#__PURE__*/ react.createElement("circle", {
        cx: 16,
        cy: 16,
        r: 15.3,
        stroke: "#323338",
        strokeWidth: 1.4
    })), _path || (_path = /*#__PURE__*/ react.createElement("path", {
        fill: "#323338",
        d: "M23.833 15.134a1 1 0 0 1 0 1.732l-11 6.35a1 1 0 0 1-1.5-.865V9.649a1 1 0 0 1 1.5-.866z"
    })));
};
/* harmony default export */ var video_play_core_button_v4 = (SvgVideoPlayCoreButtonV4);

// EXTERNAL MODULE: ./styles/colors.js
var colors = __webpack_require__(12573);
// EXTERNAL MODULE: ./client/services/accessibility/accessibility-service.js
var accessibility_service = __webpack_require__(60696);
// EXTERNAL MODULE: ./segments/desktop/core-components/button/button-consts.js
var button_consts = __webpack_require__(75650);
// EXTERNAL MODULE: ./segments/desktop/core-components/button/regular-button/regular-button.js + 1 modules
var regular_button = __webpack_require__(35662);
// EXTERNAL MODULE: ./components/core/modal-with-signup/default-props.js
var default_props = __webpack_require__(1909);
// EXTERNAL MODULE: ./constants/youtube-modal.js
var youtube_modal = __webpack_require__(29238);
;// CONCATENATED MODULE: ./static/svg/icons/play.svg
var play_path, _path2;
function play_extends() {
    play_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return play_extends.apply(this, arguments);
}

var SvgPlay = function SvgPlay(props) {
    return /*#__PURE__*/ react.createElement("svg", play_extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        fill: "none",
        viewBox: "0 0 20 20"
    }, props), play_path || (play_path = /*#__PURE__*/ react.createElement("path", {
        fill: "#fff",
        d: "m8.79 12.924 3.947-2.437a.583.583 0 0 0 0-.974L8.789 7.076C8.44 6.86 8 7.13 8 7.564v4.873c0 .433.439.703.79.487"
    })), _path2 || (_path2 = /*#__PURE__*/ react.createElement("path", {
        fill: "#fff",
        fillRule: "evenodd",
        d: "M10 2a8 8 0 1 0 0 16 8 8 0 0 0 0-16M5.404 5.404a6.5 6.5 0 1 1 9.192 9.192 6.5 6.5 0 0 1-9.192-9.192",
        clipRule: "evenodd"
    })));
};
/* harmony default export */ var play = (SvgPlay);

// EXTERNAL MODULE: ./contexts/generic-config-context.js
var generic_config_context = __webpack_require__(3156);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./segments/desktop/core-components/button/youtube-popup-button/default-props.js
var youtube_popup_button_default_props = __webpack_require__(62129);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
;// CONCATENATED MODULE: ./segments/desktop/core-components/button/youtube-popup-button/youtube-popup-button.scss.js

var StyledYouTubePopUpButton = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "ej8vwev0"
})(".secondary-button-wrapper{&:hover{outline:0;}}.play-wrapper{padding-right:16px;svg{display:block;circle{stroke:currentColor;}path{fill:currentColor;}}&.regular-button{padding-right:4px;}}");

;// CONCATENATED MODULE: ./segments/desktop/core-components/button/youtube-popup-button/youtube-popup-button.js





function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}

















var MIN_HEIGHT = 546;
var WINDOW_INITIAL_WIDTH = 780;
var WINDOW_INITIAL_HEIGHT = 928;
var YouTubePopUpButton = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(YouTubePopUpButton, PureComponent);
    var _super = (0,_create_super/* default */.Z)(YouTubePopUpButton);
    function YouTubePopUpButton(props) {
        (0,_class_call_check/* default */.Z)(this, YouTubePopUpButton);
        var _this;
        _this = _super.call(this, props);
        _define_property((0,_assert_this_initialized/* default */.Z)(_this), "getVideoOpts", function() {
            var _state = _this.state, windowHeight = _state.windowHeight, windowWidth = _state.windowWidth;
            var isMobileOrTabletBrowser = _this.props.isMobileOrTabletBrowser;
            var videoOpts = _object_spread_props(_object_spread({}, youtube_modal/* VIDEO_OPTS */.C), {
                height: windowHeight
            });
            if (isMobileOrTabletBrowser) {
                videoOpts = _object_spread_props(_object_spread({}, videoOpts), {
                    width: windowWidth
                });
            }
            return videoOpts;
        });
        _define_property((0,_assert_this_initialized/* default */.Z)(_this), "getModalStyle", function() {
            var isMobileOrTabletBrowser = _this.props.isMobileOrTabletBrowser;
            var style = default_props/* default.style */.Z.style;
            var minWidthProp = isMobileOrTabletBrowser ? {
                minWidth: "unset",
                minHeight: "unset"
            } : {
                minWidth: "960px"
            };
            return _object_spread_props(_object_spread({}, style), {
                content: _object_spread(_object_spread_props(_object_spread({}, style.content), {
                    overflow: "visible"
                }), minWidthProp)
            });
        });
        _this.state = {
            openModal: false,
            windowWidth: WINDOW_INITIAL_WIDTH,
            windowHeight: WINDOW_INITIAL_HEIGHT
        };
        _this.onPlayButtonClicked = _this.onPlayButtonClicked.bind((0,_assert_this_initialized/* default */.Z)(_this));
        _this.closeModal = _this.closeModal.bind((0,_assert_this_initialized/* default */.Z)(_this));
        _this.getVideoIconRenderer = _this.getVideoIconRenderer.bind((0,_assert_this_initialized/* default */.Z)(_this));
        _this.onKeyDown = (0,accessibility_service/* generateOnKeyDownHandler */.vR)(_this.onPlayButtonClicked);
        return _this;
    }
    (0,_create_class/* default */.Z)(YouTubePopUpButton, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this.setState({
                    windowHeight: window.innerHeight,
                    windowWidth: window.innerWidth
                });
            }
        },
        {
            key: "onPlayButtonClicked",
            value: function onPlayButtonClicked() {
                var _this = this;
                var videoId = this.props.videoId;
                BigBrain("track", bigbrain_event_types.YOUTUBE_MODAL_OPEN_SECONDARY, {
                    kind: videoId
                });
                this.setState({
                    windowHeight: window.innerHeight - 100,
                    windowWidth: window.innerWidth - 100
                }, function() {
                    return _this.setState({
                        openModal: true
                    });
                });
            }
        },
        {
            key: "closeModal",
            value: function closeModal() {
                var videoId = this.props.videoId;
                BigBrain("track", bigbrain_event_types.YOUTUBE_MODAL_CLOSE_SECONDARY, {
                    kind: videoId
                });
                this.setState({
                    openModal: false
                });
            }
        },
        {
            key: "getVideoIconRenderer",
            value: function getVideoIconRenderer(buttonDisplayType) {
                if (buttonDisplayType === button_consts/* REGULAR_BUTTON_TYPE */.ys) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        role: "button",
                        "aria-label": "Video button icon",
                        className: classnames_default()("play-wrapper", "regular-button"),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(play, {})
                    });
                }
                var iconColor = this.props.iconColor;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: "play-wrapper",
                    style: {
                        color: colors/* default */.Z[iconColor]
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(video_play_core_button_v4, {})
                });
            }
        },
        {
            key: "renderButtonComponent",
            value: function renderButtonComponent() {
                var _this = this;
                var _props = this.props, buttonSize = _props.buttonSize, buttonDisplayType = _props.buttonDisplayType, buttonText = _props.buttonText, color = _props.color, isWithArrow = _props.isWithArrow, isWithIcon = _props.isWithIcon, isWithIconInsteadOfArrow = _props.isWithIconInsteadOfArrow, outline = _props.outline, minPadding = _props.minPadding, extraEventData = _props.extraEventData, withoutUnderline = _props.withoutUnderline;
                var buttonProps = {
                    buttonSize: buttonSize,
                    buttonText: buttonText,
                    isWithArrow: isWithArrow,
                    color: color,
                    iconRenderer: isWithIcon && function() {
                        return _this.getVideoIconRenderer(buttonDisplayType);
                    },
                    minPadding: minPadding,
                    onClick: this.onPlayButtonClicked,
                    isWithIconInsteadOfArrow: isWithIconInsteadOfArrow,
                    outline: outline,
                    extraEventData: extraEventData,
                    withoutUnderline: withoutUnderline
                };
                var ButtonComponent = buttonDisplayType === button_consts/* REGULAR_BUTTON_TYPE */.ys ? regular_button/* default */.Z : secondary_button/* default */.Z;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonComponent, _object_spread({}, buttonProps));
            }
        },
        {
            key: "render",
            value: function render() {
                var openModal = this.state.openModal;
                var videoId = this.props.videoId;
                var videoOpts = this.getVideoOpts();
                var modalStyle = this.getModalStyle();
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledYouTubePopUpButton, {
                    className: "you-tube-pop-up-button-component",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "secondary-button-wrapper",
                            tabIndex: 0,
                            onKeyDown: this.onKeyDown,
                            role: "button",
                            children: this.renderButtonComponent()
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(youtube_video_modal_component/* default */.Z, {
                            videoId: videoId,
                            minHeight: MIN_HEIGHT,
                            isOpen: openModal,
                            opts: videoOpts,
                            onCloseModal: this.closeModal,
                            withSignup: false,
                            style: modalStyle
                        })
                    ]
                });
            }
        }
    ]);
    return YouTubePopUpButton;
}(react.PureComponent);
YouTubePopUpButton.defaultProps = youtube_popup_button_default_props/* default */.Z;
/* harmony default export */ var youtube_popup_button = ((0,generic_config_context/* withGenericConfig */.P)(YouTubePopUpButton));


/***/ }),

/***/ 28391:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ carousel; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/react-slick/lib/index.js
var lib = __webpack_require__(46066);
// EXTERNAL MODULE: ./node_modules/lodash.throttle/index.js
var lodash_throttle = __webpack_require__(93096);
var lodash_throttle_default = /*#__PURE__*/__webpack_require__.n(lodash_throttle);
// EXTERNAL MODULE: ./segments/desktop/core-components/carousel/default-props.js
var default_props = __webpack_require__(26687);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
// EXTERNAL MODULE: ./styles/color-consts.js
var color_consts = __webpack_require__(273);
// EXTERNAL MODULE: ./styles/colors.js
var colors = __webpack_require__(12573);
// EXTERNAL MODULE: ./constants/z-index.js
var z_index = __webpack_require__(35257);
;// CONCATENATED MODULE: ./segments/desktop/core-components/carousel/slick.scss.js
var slickStyle = '\n  .slick-slider {\n    position: relative;\n    display: block;\n    box-sizing: border-box;\n    -webkit-touch-callout: none;\n    -webkit-user-select: none;\n    -khtml-user-select: none;\n    -moz-user-select: none;\n    -ms-user-select: none;\n    user-select: none;\n    -ms-touch-action: pan-y;\n    touch-action: pan-y;\n    -webkit-tap-highlight-color: transparent;\n  }\n  \n  .slick-loading .slick-slide {\n    visibility: hidden;\n  }\n    \n  .slick-list {\n    position: relative;\n    overflow: hidden;\n    display: block;\n    margin: 0;\n    padding: 0;\n\n    &:focus {\n      outline: none;\n    }\n\n    &.dragging {\n      cursor: pointer;\n      cursor: hand;\n    }\n  }\n  .slick-slider .slick-track,\n  .slick-slider .slick-list {\n    -webkit-transform: translate3d(0, 0, 0);\n    -moz-transform: translate3d(0, 0, 0);\n    -ms-transform: translate3d(0, 0, 0);\n    -o-transform: translate3d(0, 0, 0);\n    transform: translate3d(0, 0, 0);\n  }\n\n  .slick-track {\n    position: relative;\n    left: 0;\n    top: 0;\n    display: block;\n    margin-left: auto;\n    margin-right: auto;\n\n    &:before,\n    &:after {\n      content: "";\n      display: table;\n    }\n\n    &:after {\n      clear: both;\n    }\n\n    .slick-loading & {\n      visibility: hidden;\n    }\n  }\n  \n  .slick-slide {\n    float: left;\n    height: 100%;\n    min-height: 1px;\n    [dir="rtl"] & {\n      float: right;\n    }\n    \n    img {\n      display: block;\n    }\n    \n    &.slick-loading img {\n      display: none;\n    }\n\n    display: none;\n\n    &.dragging img {\n      pointer-events: none;\n    }\n\n    & {\n      display: block;\n    }\n\n    .slick-vertical & {\n      display: block;\n      height: auto;\n      border: 1px solid transparent;\n    }\n  }\n  \n  .slick-arrow {\n    &.slick-hidden {\n      display: none;\n    }\n    \n    &.slick-prev,\n    &.slick-next {\n      &:focus {\n        outline: solid 2px #015ecc;\n        border-radius: 4px;\n      }\n    }\n  }\n';

;// CONCATENATED MODULE: ./segments/desktop/core-components/carousel/slick-theme.scss.js
var SLICK_OPACITY_ON_HOVER = 1;
var SLICK_OPACITY_NOT_ACTIVE = 0.25;
var SLICK_OPACITY_DEFAULT = 0.75;
var SLICK_DOT_SIZE = 0.338;
var SLICK_NEXT_CHARACTER = "→";
var SLICK_PREV_CHARACTER = "←";
var SLICK_DOT_CHARACTER = "•";
var slickThemeStyle = '\n  .slick-list {\n    .slick-loading & {\n      background: #fff url("./ajax-loader.gif") center center no-repeat;\n    }\n  }\n\n  .slick-prev,\n  .slick-next {\n    position: absolute;\n    display: block;\n    height: 20px;\n    width: 20px;\n    line-height: 0;\n    font-size: 0;\n    cursor: pointer;\n    background: transparent;\n    color: transparent;\n    top: 50%;\n    -webkit-transform: translate(0, -50%);\n    -ms-transform: translate(0, -50%);\n    transform: translate(0, -50%);\n    padding: 0;\n    border: none;\n    outline: none;\n\n    &:hover,\n    &:focus {\n      outline: none;\n      background: transparent;\n      color: transparent;\n\n      &:before {\n        opacity: '.concat(SLICK_OPACITY_ON_HOVER, ";\n      }\n    }\n\n    &.slick-disabled:before {\n      opacity: ").concat(SLICK_OPACITY_NOT_ACTIVE, ";\n    }\n\n    &:before {\n      font-size: 1.125rem;\n      line-height: 1;\n      color: white;\n      opacity: ").concat(SLICK_OPACITY_DEFAULT, ';\n      -webkit-font-smoothing: antialiased;\n      -moz-osx-font-smoothing: grayscale;\n    }\n  }\n\n  .slick-prev {\n    left: -25px;\n\n    [dir="rtl"] & {\n      left: auto;\n      right: -25px;\n    }\n\n    &:before {\n      content: ').concat(SLICK_NEXT_CHARACTER, ';\n\n      [dir="rtl"] & {\n        content: ').concat(SLICK_PREV_CHARACTER, ';\n      }\n    }\n  }\n\n  .slick-next {\n    right: -25px;\n\n    [dir="rtl"] & {\n      left: -25px;\n      right: auto;\n    }\n\n    &:before {\n      content: ').concat(SLICK_PREV_CHARACTER, ';\n\n      [dir="rtl"] & {\n        content: ').concat(SLICK_NEXT_CHARACTER, ";\n      }\n    }\n  }\n\n  .slick-dotted.slick-slider {\n    margin-bottom: 30px;\n  }\n\n  .slick-dots {\n    position: absolute;\n    bottom: -25px;\n    list-style: none;\n    display: block;\n    text-align: center;\n    padding: 0;\n    margin: 0;\n    width: 100%;\n\n    li {\n      position: relative;\n      display: inline-block;\n      height: 20px;\n      width: 20px;\n      margin: 0 5px;\n      padding: 0;\n      cursor: pointer;\n\n      button {\n        border: 0;\n        background: transparent;\n        display: block;\n        height: 20px;\n        width: 20px;\n        outline: none;\n        line-height: 0;\n        font-size: 0;\n        color: transparent;\n        padding: 5px;\n        cursor: pointer;\n\n        &:hover,\n        &:focus {\n          outline: none;\n\n          &:before {\n            opacity: ").concat(SLICK_OPACITY_ON_HOVER, ";\n          }\n        }\n\n        &:before {\n          position: absolute;\n          top: 0;\n          left: 0;\n          content: ").concat(SLICK_DOT_CHARACTER, ";\n          width: 20px;\n          height: 20px;\n          font-size: ").concat(SLICK_DOT_SIZE, ";\n          line-height: 20px;\n          text-align: center;\n          color: black;\n          opacity: ").concat(SLICK_OPACITY_NOT_ACTIVE, ";\n          -webkit-font-smoothing: antialiased;\n          -moz-osx-font-smoothing: grayscale;\n        }\n      }\n\n      &.slick-active button:before {\n        color: black;\n        opacity: ").concat(SLICK_OPACITY_DEFAULT, ";\n      }\n    }\n  }\n");

;// CONCATENATED MODULE: ./segments/desktop/core-components/carousel/carousel.scss.js






var StyledCarousel = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "en6i2u80"
})(slickStyle, " ", slickThemeStyle, "  \n  .slick-slider{.slick-dots{z-index:", z_index/* LAYER_ONE */.KW, ";li{margin:0 4px;button{display:inline-block;width:11px;height:11px;border-radius:50%;border:1px solid ", colors/* default.asphalt */.Z.asphalt, ";opacity:1;background-color:transparent;&::before{display:none;}}&.slick-active{button{background-color:", colors/* default */.Z[color_consts.WORK_OS_IRIS_COLOR_NAME], ";border-color:", colors/* default */.Z[color_consts.WORK_OS_IRIS_COLOR_NAME], ";}}&:not(.slick-active):hover{button{background-color:#c5c7d0;}}}}}.slick-slider.focus{.slick-list{.slick-track{padding:48px 0;.slick-slide{.carousel-item{outline:none;transition:opacity 0.5s ease,transform 0.5s ease;transform:scale(1);opacity:0.3;}&.slick-active{&.slick-center{.carousel-item{transform:scale(1.175);}}.carousel-item{opacity:1;}}}}}}");

;// CONCATENATED MODULE: ./segments/desktop/core-components/carousel/carousel.js


function _define_property1(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property1(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}







var GO_TO_SPEED_MILLISECONDS = 500;
var GO_TO_ANIMATION_THROTTLE_DELAY = 100;
var PAUSE_AFTER_SWIPE_DELAY = 5000;
var ConditionalWrapper = function(param) {
    var condition = param.condition, wrapper = param.wrapper, children = param.children;
    return condition ? wrapper(children) : children;
};
var Carousel = /*#__PURE__*/ (0,react.forwardRef)(function(props, externalRef) {
    var slider = (0,react.useRef)(null);
    (0,react.useImperativeHandle)(externalRef, function() {
        return {
            scrollToSlide: function scrollToSlide(index) {
                slider === null || slider === void 0 ? void 0 : slider.current.slickGoTo(index);
            },
            pause: function pause() {
                slider === null || slider === void 0 ? void 0 : slider.current.slickPause();
            },
            play: function play() {
                slider === null || slider === void 0 ? void 0 : slider.current.slickPlay();
            }
        };
    }, []);
    // Items props
    var items = props.items, selectedIndex = props.selectedIndex, itemRenderer = props.itemRenderer, onSwipe = props.onSwipe, onChange = props.onChange, itemScale = props.itemScale, lazyLoad = props.lazyLoad;
    // Carousel props
    var autoplay = props.autoplay, autoplaySpeed = props.autoplaySpeed, infinite = props.infinite, slidesToShow = props.slidesToShow, easing = props.easing, arrows = props.arrows, nextArrow = props.nextArrow, prevArrow = props.prevArrow, dots = props.dots, className = props.className, responsive = props.responsive;
    // Advanced carousel props
    var centerMode = props.centerMode, centerPadding = props.centerPadding, defaultIndex = props.defaultIndex, swipeToSlide = props.swipeToSlide, showFocusEffect = props.showFocusEffect, defaultImage = props.defaultImage, carouselClassName = props.carouselClassName, onRefSet = props.onRefSet, focusAfterSwipe = props.focusAfterSwipe, disableSlideOnStartClick = props.disableSlideOnStartClick, speed = props.speed, beforeChange = props.beforeChange, draggable = props.draggable, _slidesToScroll = props.slidesToScroll, slidesToScroll = _slidesToScroll === void 0 ? 1 : _slidesToScroll, _focusOnSelect = props.focusOnSelect, focusOnSelect = _focusOnSelect === void 0 ? true : _focusOnSelect;
    if (!items) return null;
    // Arrange items in right format and order
    var defaultIndexNumber = Math.min(parseInt(defaultIndex), items.length);
    var hasDefault = defaultImage && defaultImage.src;
    var slides = (0,_to_consumable_array/* default */.Z)(items);
    if (hasDefault) {
        slides = (0,_to_consumable_array/* default */.Z)(items.slice(0, defaultIndexNumber)).concat([
            defaultImage
        ], (0,_to_consumable_array/* default */.Z)(items.slice(defaultIndexNumber)));
    }
    var handleSwipe = function(direction) {
        slider.current.slickPause();
        if (autoplay) {
            setTimeout(function() {
                return slider.current.slickPlay();
            }, PAUSE_AFTER_SWIPE_DELAY);
        }
        if (onSwipe) {
            onSwipe(direction);
        }
    };
    var handleChange = function(current) {
        if (onChange) {
            onChange(current);
        }
        if (focusAfterSwipe) {
            var _slider_current_innerSlider_list, _slider_current_innerSlider, _slider_current;
            slider === null || slider === void 0 ? void 0 : (_slider_current = slider.current) === null || _slider_current === void 0 ? void 0 : (_slider_current_innerSlider = _slider_current.innerSlider) === null || _slider_current_innerSlider === void 0 ? void 0 : (_slider_current_innerSlider_list = _slider_current_innerSlider.list) === null || _slider_current_innerSlider_list === void 0 ? void 0 : _slider_current_innerSlider_list.click();
        }
    };
    var focusSlider = function() {
        var _slider_current_innerSlider, _slider_current;
        if (slider === null || slider === void 0 ? void 0 : (_slider_current = slider.current) === null || _slider_current === void 0 ? void 0 : (_slider_current_innerSlider = _slider_current.innerSlider) === null || _slider_current_innerSlider === void 0 ? void 0 : _slider_current_innerSlider.list) {
            slider.current.innerSlider.list.setAttribute("tabindex", 0);
            slider.current.innerSlider.list.focus();
        }
    };
    var settings = {
        // Default settings
        className: classnames_default()((0,_define_property/* default */.Z)({
            center: centerMode,
            focus: showFocusEffect
        }, className, className)),
        speed: speed || GO_TO_SPEED_MILLISECONDS,
        dots: dots,
        focusOnSelect: focusOnSelect,
        onSwipe: handleSwipe,
        afterChange: handleChange,
        beforeChange: beforeChange,
        // User props
        infinite: infinite,
        slidesToScroll: slidesToScroll,
        arrows: arrows,
        nextArrow: nextArrow,
        prevArrow: prevArrow,
        swipeToSlide: swipeToSlide,
        slidesToShow: Math.min(slidesToShow, slides.length),
        centerPadding: centerPadding,
        easing: easing,
        centerMode: centerMode,
        autoplay: autoplay,
        autoplaySpeed: parseInt(autoplaySpeed),
        lazyLoad: lazyLoad,
        draggable: draggable
    };
    var onIndexChanged = function(selectedIndex) {
        var newIndex;
        if (selectedIndex !== null && centerMode) {
            newIndex = selectedIndex >= defaultIndexNumber && hasDefault ? selectedIndex + 1 : selectedIndex;
        } else {
            newIndex = defaultIndexNumber;
        }
        slider.current.slickGoTo(newIndex);
    };
    // Throttle and give some delay (100ms) because when the index changes
    // `slickGoTo` does not work properly when changing fast
    var throttledOnIndexChanged = (0,react.useCallback)(lodash_throttle_default()(onIndexChanged, GO_TO_SPEED_MILLISECONDS + GO_TO_ANIMATION_THROTTLE_DELAY, {
        trailing: true
    }), []);
    (0,react.useEffect)(function() {
        throttledOnIndexChanged(selectedIndex);
    }, [
        selectedIndex
    ]);
    (0,react.useEffect)(function() {
        if (slider === null || slider === void 0 ? void 0 : slider.current) {
            if (onRefSet) {
                onRefSet(slider.current);
            }
        }
    }, [
        slider
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledCarousel, {
        className: classnames_default()("carousel", carouselClassName),
        onTouchStart: disableSlideOnStartClick ? null : focusSlider,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(lib/* default */.Z, _object_spread_props(_object_spread({
            ref: slider
        }, settings), {
            initialSlide: defaultIndexNumber,
            responsive: responsive,
            children: slides.map(function(item, index) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "carousel-item",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ConditionalWrapper, {
                        condition: itemScale != 1,
                        wrapper: function(children) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                style: {
                                    transform: "scale(".concat(itemScale, ")")
                                },
                                children: children
                            });
                        },
                        children: itemRenderer(item, index)
                    })
                }, "slide_".concat(index));
            })
        }))
    });
});
Carousel.defaultProps = default_props/* default */.Z;
/* harmony default export */ var carousel = (Carousel);


/***/ }),

/***/ 26687:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

/* harmony default export */ __webpack_exports__["Z"] = ({
    infinite: true,
    arrows: false,
    autoplay: false,
    defaultIndex: 2,
    slidesToShow: 3,
    easing: "cubic",
    itemScale: 1,
    autoplaySpeed: 3000,
    centerMode: true,
    centerPadding: "10%",
    swipeToSlide: true,
    showFocusEffect: true,
    pauseOnFocus: true,
    lazyLoad: false,
    dots: false,
    reducedVerticalPadding: false // TODO: barben i don't know if the current 48px you added in the css is a must, but it's much more then i need
});


/***/ }),

/***/ 24459:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

/* harmony default export */ __webpack_exports__["Z"] = ({
    boardIdAndToken: "581657007-136aa9fd1bbac5c25f0cf5bac147d93d",
    tooltipText: "Try it out here",
    liveBoard: false
});


/***/ }),

/***/ 94598:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ EmbeddedBoard; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_assert_this_initialized.mjs
var _assert_this_initialized = __webpack_require__(4111);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(52951);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(88029);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 4 modules
var _create_super = __webpack_require__(60460);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./constants/links.js + 20 modules
var links = __webpack_require__(27639);
// EXTERNAL MODULE: ./components/core/picture/picture-component.js + 3 modules
var picture_component = __webpack_require__(82305);
// EXTERNAL MODULE: ./constants/bigbrain-event-types.js
var bigbrain_event_types = __webpack_require__(65023);
// EXTERNAL MODULE: ./components/enhancements/tooltip/tooltip-component.js + 1 modules
var tooltip_component = __webpack_require__(31590);
// EXTERNAL MODULE: ./components/enhancements/tooltip/tooltip-constants.js
var tooltip_constants = __webpack_require__(24984);
// EXTERNAL MODULE: ./services/cookies-service.js
var cookies_service = __webpack_require__(67798);
// EXTERNAL MODULE: ./constants/cookies.js
var cookies = __webpack_require__(13019);
// EXTERNAL MODULE: ./utils/url.js
var utils_url = __webpack_require__(8339);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
// EXTERNAL MODULE: ./styles/colors.js
var colors = __webpack_require__(12573);
;// CONCATENATED MODULE: ./segments/desktop/core-components/embedded-board/embedded-board.scss.js


var StyledEmbeddedBoard = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "esnye570"
})("width:100%;height:100%;display:flex;flex-direction:column;@keyframes tooltip-toggle{0%{transform:translateY(0);}25%{transform:translateY(-5px);}50%{transform:translateY(-10px);}75%{transform:translateY(-5px);}100%{transform:translateY(0);}}.tooltip-wrapper{display:flex;justify-content:center;bottom:60px;position:relative;animation-name:tooltip-toggle;animation-iteration-count:infinite;animation-timing-function:ease-in;animation-duration:1s;transition:bottom 3s linear;}.embedded-wrapper{border-radius:8px;-moz-border-radius:8px;overflow:hidden;border:", "1px solid ".concat(colors/* default.border-gray */.Z["border-gray"]), ";box-sizing:border-box;display:flex;flex-direction:column;height:100%;.embedded-board-top-frame{background-color:", colors/* default.riverstone */.Z.riverstone, ";height:48px;display:flex;cursor:default;justify-content:flex-end;.powered-by-wrapper{margin-right:16px;font-size:0.8125rem;line-height:22px;display:flex;align-items:center;.monday-logo-image{margin-left:8px;padding-top:6px;width:100px;}}}.board-iframe-content-wrapper{height:100%;width:100%;.board-iframe{height:100%;width:100%;border-width:0;}}}");

// EXTERNAL MODULE: ./segments/desktop/core-components/embedded-board/default-props.js
var default_props = __webpack_require__(24459);
;// CONCATENATED MODULE: ./segments/desktop/core-components/embedded-board/embedded-board.js





function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}












var IFRAME_CLASS_NAME = "board-iframe";
var FULL_STORY_EMBEDDED_PARAM = "fullstory";
var PLATFORM_REGION_PARAM_NAME = "r";
var IS_LIVE_BOARD_PLATFORM_PARAM = "live_board";
var EmbeddedBoard = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(EmbeddedBoard, PureComponent);
    var _super = (0,_create_super/* default */.Z)(EmbeddedBoard);
    function EmbeddedBoard(props) {
        (0,_class_call_check/* default */.Z)(this, EmbeddedBoard);
        var _this;
        _this = _super.call(this, props);
        _define_property((0,_assert_this_initialized/* default */.Z)(_this), "getBoardEmbeddedURL", function() {
            var _props = _this.props, sharableLink = _props.sharableLink, boardIdAndToken = _props.boardIdAndToken, isLiveBoard = _props.isLiveBoard;
            var boardIdAndTokenProp = boardIdAndToken; // Old prop support
            var region;
            if (sharableLink) {
                region = (0,utils_url.getUrlParamValue)(sharableLink, PLATFORM_REGION_PARAM_NAME);
                boardIdAndTokenProp = (0,utils_url.getLastPartOfUrl)(sharableLink);
            }
            var url = "https://view.monday.com/embed/".concat(boardIdAndTokenProp, "?hide_footer=true&allow_edit=true");
            if (region) {
                url = (0,utils_url.addParamToURL)(url, PLATFORM_REGION_PARAM_NAME, region);
            }
            if (isLiveBoard) {
                url = (0,utils_url.addParamToURL)(url, IS_LIVE_BOARD_PLATFORM_PARAM, "true");
            }
            return url;
        });
        _define_property((0,_assert_this_initialized/* default */.Z)(_this), "getIframeUrl", function() {
            var url = _this.getBoardEmbeddedURL();
            var fullStoryActiveForPage = !!(0,cookies_service/* getCookie */.ej)(cookies.ALWAYS_FS);
            if (fullStoryActiveForPage) {
                url = (0,utils_url.addParamToURL)(url, FULL_STORY_EMBEDDED_PARAM, true);
            }
            return url;
        });
        _define_property((0,_assert_this_initialized/* default */.Z)(_this), "blurAction", function() {
            if (document.getElementsByClassName(IFRAME_CLASS_NAME)[0] === document.activeElement) {
                var boardIdAndToken = _this.props.boardIdAndToken;
                BigBrain("track", bigbrain_event_types.EMBEDDED_BOARD_INITIAL_INTERACTION, {
                    info1: boardIdAndToken
                });
                _this.setState({
                    showTooltip: false
                });
                window.removeEventListener("blur", _this.blurAction);
            }
        });
        _define_property((0,_assert_this_initialized/* default */.Z)(_this), "renderTooltipIfNeeded", function() {
            var showTooltip = _this.state.showTooltip;
            var tooltipText = _this.props.tooltipText;
            if (!showTooltip) return null;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "tooltip-wrapper",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(tooltip_component/* default */.Z, {
                    theme: tooltip_constants.DARK_THEME,
                    children: tooltipText
                })
            });
        });
        _this.state = {
            showTooltip: !!props.tooltipText
        };
        return _this;
    }
    (0,_create_class/* default */.Z)(EmbeddedBoard, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                window.addEventListener("blur", this.blurAction);
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                window.removeEventListener("blur", this.blurAction);
            }
        },
        {
            key: "render",
            value: function render() {
                var hideTopFrame = this.props.hideTopFrame;
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledEmbeddedBoard, {
                    className: "embedded-board",
                    children: [
                        this.renderTooltipIfNeeded(),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "embedded-wrapper",
                            children: [
                                !hideTopFrame && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "embedded-board-top-frame",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "powered-by-wrapper",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                children: "Powered by"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(picture_component/* default */.Z, {
                                                src: links/* MONDAY_LOGO_SMALL_SRC */.Vm0,
                                                className: "monday-logo-image"
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "board-iframe-content-wrapper",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("iframe", {
                                        src: this.getIframeUrl(),
                                        className: IFRAME_CLASS_NAME
                                    })
                                })
                            ]
                        })
                    ]
                });
            }
        }
    ]);
    return EmbeddedBoard;
}(react.PureComponent);

EmbeddedBoard.defaultProps = default_props/* default */.Z;


/***/ }),

/***/ 7484:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var segments_desktop_core_components_title_default_props__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(51261);
/* harmony import */ var segments_desktop_core_components_paragraph_default_props__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(14066);
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}


/* harmony default export */ __webpack_exports__["Z"] = (_object_spread_props(_object_spread({
    topic: {
        text: "Lorem ipsum dolor",
        color: "brand-blue"
    }
}, segments_desktop_core_components_title_default_props__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z, segments_desktop_core_components_paragraph_default_props__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z), {
    textAlign: "left",
    mobileTextAlign: null // has to be null so it will default to regular text align
}));


/***/ }),

/***/ 13211:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "xe": function() { return /* binding */ PARAGRAPH_HORIZONTAL_PADDING_STRING; },
  "ZP": function() { return /* binding */ full_paragraph; }
});

// UNUSED EXPORTS: PARAGRAPH_HORIZONTAL_PADDING

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_assert_this_initialized.mjs
var _assert_this_initialized = __webpack_require__(4111);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(52951);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(88029);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 4 modules
var _create_super = __webpack_require__(60460);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./segments/desktop/core-components/button/button.js + 17 modules
var button_button = __webpack_require__(11068);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./utils/react.js
var utils_react = __webpack_require__(12783);
// EXTERNAL MODULE: ./styles/colors.js
var colors = __webpack_require__(12573);
;// CONCATENATED MODULE: ./segments/desktop/core-components/bullets/bullet-checked-icon.js


var BulletCheckedIcon = function(param) {
    var color = param.color, checkColor = param.checkColor;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                cx: "10",
                cy: "10",
                r: "10",
                fill: colors/* default */.Z[color] || "#CAF4E2",
                className: "circle"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                className: "mark",
                d: "M6.27162 9.83382C5.98072 9.54874 5.50908 9.54874 5.21818 9.83382C4.92727 10.1189 4.92727 10.5811 5.21818 10.8662L8.19777 13.7862C8.48867 14.0713 8.96031 14.0713 9.25121 13.7862L15.2104 7.9462C15.5013 7.66112 15.5013 7.19891 15.2104 6.91382C14.9195 6.62874 14.4479 6.62874 14.1569 6.91382L8.72449 12.2376L6.27162 9.83382Z",
                fill: colors/* default */.Z[checkColor] || "#037F4C"
            })
        ]
    });
};
/* harmony default export */ var bullet_checked_icon = (BulletCheckedIcon);

// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
// EXTERNAL MODULE: ./constants/vp-sizes.js
var vp_sizes = __webpack_require__(698);
;// CONCATENATED MODULE: ./segments/desktop/core-components/bullets/bullets.scss.js


var BULLET_SIZE = 16;
var BULLET_SIZE_STRING = "".concat(BULLET_SIZE, "px");
var StyledBullets = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e3pqfjj0"
})("display:flex;flex-wrap:wrap;&.column{flex-direction:column;}.bullet-anchor-wrapper{text-decoration:none;color:unset;cursor:pointer;}.bullet{display:flex;align-items:flex-start;.bullet-icon{height:", BULLET_SIZE_STRING, ";width:", BULLET_SIZE_STRING, ";padding-top:8px;svg{height:", BULLET_SIZE_STRING, ";width:", BULLET_SIZE_STRING, ";}}.bullet-text{margin-left:8px;line-height:31px;padding-right:24px;}}@media (max-width:", vp_sizes/* MOBILE_QUERY_MAX_WIDTH */.zD, "){.bullet{width:100%;}}");

// EXTERNAL MODULE: ./segments/desktop/core-components/bullets/default-props.js
var default_props = __webpack_require__(96143);
;// CONCATENATED MODULE: ./segments/desktop/core-components/bullets/bullets.js






var Bullets = function(props) {
    var bullets = props.bullets, alternativeIcon = props.alternativeIcon, bulletsDirection = props.bulletsDirection, bulletTextSize = props.bulletTextSize, bulletsColor = props.bulletsColor, checkColor = props.checkColor;
    var renderBullet = function(bullet, bulletIndex) {
        var href = bullet.href, openInNewTab = bullet.openInNewTab;
        var anchorWrapper = function(children) {
            var target = openInNewTab ? "_blank" : undefined;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                className: "bullet-anchor-wrapper",
                href: href,
                target: target,
                children: children
            });
        };
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(utils_react/* ConditionalWrapper */.M, {
            condition: href,
            wrapper: anchorWrapper,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "bullet",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "bullet-icon",
                        children: alternativeIcon || /*#__PURE__*/ (0,jsx_runtime.jsx)(bullet_checked_icon, {
                            color: bulletsColor,
                            checkColor: checkColor
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "bullet-text",
                        style: {
                            fontSize: bulletTextSize
                        },
                        children: bullet.bulletText
                    })
                ]
            }, bulletIndex)
        });
    };
    if (!bullets) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledBullets, {
        className: classnames_default()("bullets", bulletsDirection),
        children: bullets.map(function(bullet, bulletIndex) {
            return renderBullet(bullet, bulletIndex);
        })
    });
};
Bullets.defaultProps = default_props/* default */.Z;
/* harmony default export */ var bullets = (Bullets);

// EXTERNAL MODULE: ./contexts/segment-context.js
var segment_context = __webpack_require__(39944);
// EXTERNAL MODULE: ./segments/desktop/core-components/title/title.js + 1 modules
var title_title = __webpack_require__(91265);
// EXTERNAL MODULE: ./segments/desktop/core-components/paragraph/paragraph.js + 1 modules
var paragraph = __webpack_require__(75073);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
// EXTERNAL MODULE: ./contexts/generic-config-context.js
var generic_config_context = __webpack_require__(3156);
// EXTERNAL MODULE: ./client/services/cluster-config-service/cluster-config-service.js
var cluster_config_service = __webpack_require__(79092);
// EXTERNAL MODULE: ./components/core/picture/picture-component.js + 3 modules
var picture_component = __webpack_require__(82305);
// EXTERNAL MODULE: ./client/components/system/monday-markup-language/monday-markup-language-component.js + 11 modules
var monday_markup_language_component = __webpack_require__(36239);
;// CONCATENATED MODULE: ./segments/desktop/core-components/icons/icons.scss.js


var StyledIcons = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1tcrf5n0"
})("display:flex;.icon-wrapper{display:flex;gap:8px;width:100%;img{max-height:32px;}.icon-texts-wrapper{display:flex;flex-direction:column;gap:8px;.title{.monday-markup-language-component{font-size:1.463rem;line-height:26px;font-weight:500;}}.subtitle{.monday-markup-language-component{font-size:1rem;line-height:20px;}}}}@media (max-width:", vp_sizes/* MOBILE_QUERY_MAX_WIDTH */.zD, "){display:flex;.icon-wrapper{flex-direction:column;align-items:center;padding-bottom:35px;.icon-texts-wrapper{align-items:center;text-align:center;.title{.monday-markup-language-component{font-size:1.125rem;}}.subtitle{.monday-markup-language-component{font-size:0.8125rem;}}}}}");

// EXTERNAL MODULE: ./segments/desktop/core-components/icons/default-props.js
var icons_default_props = __webpack_require__(80564);
;// CONCATENATED MODULE: ./segments/desktop/core-components/icons/icons.js
function icons_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            icons_define_property(target, key, source[key]);
        });
    }
    return target;
}





var Icons = function(props) {
    var icons = props.icons;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledIcons, {
        className: "icons",
        children: icons.map(function(icon, index) {
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "icon-wrapper",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(picture_component/* default */.Z, _object_spread({}, icon.image)),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "icon-texts-wrapper",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "title",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(monday_markup_language_component/* default */.Z, {
                                    text: icon.title
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "subtitle",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(monday_markup_language_component/* default */.Z, {
                                    text: icon.subtitle
                                })
                            })
                        ]
                    })
                ]
            }, index);
        })
    });
};
/* harmony default export */ var icons = (Icons);
Icons.defaultProps = icons_default_props/* default */.Z;

// EXTERNAL MODULE: ./components/core/picture-with-link/picture-with-link-component.js
var picture_with_link_component = __webpack_require__(94640);
// EXTERNAL MODULE: ./segments/desktop/core-components/full-paragraph/default-props.js
var full_paragraph_default_props = __webpack_require__(7484);
;// CONCATENATED MODULE: ./segments/desktop/core-components/full-paragraph/full-paragraph.scss.js


var StyledFullParagraph = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "eo3on790"
})("word-break:break-word;width:100%;display:flex;flex-direction:column;&.align-items-left{align-items:flex-start;}&.align-items-center{align-items:center;.title-wrapper{width:100%;}}&.align-items-right{align-items:flex-end;}&.with-left-line{border-width:2px;border-style:solid;padding-left:32px;}.full-paragraph-topic-image-and-text-wrapper{display:flex;flex-direction:column;}.full-paragraph-topic-image-wrapper{margin-bottom:40px;}.full-paragraph-topic{font-size:0.875rem;margin-bottom:16px;}.title-wrapper{margin-top:16px;margin-bottom:16px;}.paragraph-body-wrapper{}.icons-wrapper{margin-top:40px;margin-bottom:64px;}.bullets-wrapper{margin-top:32px;display:flex;@media (max-width:", vp_sizes/* MOBILE_QUERY_MAX_WIDTH */.zD, "){&.no-mobile-margin{margin-top:0;}}&.left{justify-content:flex-start;.bullets{justify-content:flex-start;}}&.center{justify-content:center;.bullets{justify-content:center;}}&.right{justify-content:flex-end;.bullets{justify-content:flex-end;}}}.full-paragraph-topic-image-wrapper{&.left{:global(.picture-component){justify-content:left;}}&.center{:global(.picture-component){justify-content:center;}}&.right{:global(.picture-component){justify-content:right;}}}.button-wrapper{margin-top:32px;display:flex;&.left{justify-content:flex-start;}&.center{justify-content:center;}&.right{justify-content:flex-end;}}");

;// CONCATENATED MODULE: ./segments/desktop/core-components/full-paragraph/full-paragraph.js







function _define_property1(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function full_paragraph_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property1(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}


















var PARAGRAPH_HORIZONTAL_PADDING = 32;
var PARAGRAPH_HORIZONTAL_PADDING_STRING = "".concat(PARAGRAPH_HORIZONTAL_PADDING, "px");
var FullParagraph = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(FullParagraph, PureComponent);
    var _super = (0,_create_super/* default */.Z)(FullParagraph);
    function FullParagraph() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        (0,_class_call_check/* default */.Z)(this, FullParagraph);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat((0,_to_consumable_array/* default */.Z)(args)));
        _define_property1((0,_assert_this_initialized/* default */.Z)(_this), "getTextAlignBasedOnDeviceType", function() {
            var _props = _this.props, isMobileBrowser = _props.isMobileBrowser, textAlign = _props.textAlign, mobileTextAlign = _props.mobileTextAlign;
            if (!isMobileBrowser) return textAlign;
            return mobileTextAlign || textAlign;
        });
        _define_property1((0,_assert_this_initialized/* default */.Z)(_this), "getTitleStyle", function() {
            var _props = _this.props, titleMinWidth = _props.titleMinWidth, titleWidth = _props.titleWidth, topicText = _props.topicText, spaceFromParagraph = _props.spaceFromParagraph;
            var style = {
                maxWidth: "min(".concat(titleWidth, ", ").concat(vp_sizes/* MAX_DESKTOP_DYNAMIC_TEMPLATE_MAX_WIDTH */.po, ")")
            };
            if (!topicText) {
                style = _object_spread_props(full_paragraph_object_spread({}, style), {
                    marginTop: 0
                });
            }
            if (spaceFromParagraph) {
                style = _object_spread_props(full_paragraph_object_spread({}, style), {
                    marginBottom: spaceFromParagraph
                });
            }
            if (_this.getTextAlignBasedOnDeviceType() === "center") {
                var minWidth = "min(".concat(titleMinWidth, ", ").concat(vp_sizes/* MAX_DESKTOP_DYNAMIC_TEMPLATE_MAX_WIDTH */.po, ", calc(100vw - ").concat(PARAGRAPH_HORIZONTAL_PADDING_STRING, "))");
                style = _object_spread_props(full_paragraph_object_spread({}, style), {
                    minWidth: minWidth
                });
            }
            return style;
        });
        _define_property1((0,_assert_this_initialized/* default */.Z)(_this), "getButtonWrapperStyle", function() {
            var buttonTopMargin = _this.props.buttonTopMargin;
            if (!buttonTopMargin) return null;
            return {
                marginTop: buttonTopMargin
            };
        });
        _define_property1((0,_assert_this_initialized/* default */.Z)(_this), "renderTopicImage", function(removeMargin) {
            var _props = _this.props, topic = _props.topic, topicBottomMargin = _props.topicBottomMargin;
            var image = topic.image;
            if ((image === null || image === void 0 ? void 0 : image.src) || (image === null || image === void 0 ? void 0 : image.href)) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: classnames_default()("full-paragraph-topic-image-wrapper", _this.getTextAlignBasedOnDeviceType()),
                    style: {
                        marginBottom: !removeMargin && topicBottomMargin
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(picture_with_link_component/* default */.Z, _object_spread_props(full_paragraph_object_spread({}, image), {
                        pictureComponentHeight: image === null || image === void 0 ? void 0 : image.height
                    }))
                });
            }
            return null;
        });
        _define_property1((0,_assert_this_initialized/* default */.Z)(_this), "renderTopicText", function(removeMargin) {
            var _props = _this.props, topic = _props.topic, topicBottomMargin = _props.topicBottomMargin;
            var topicText = topic.text, color = topic.color, borderColor = topic.borderColor;
            if (topicText) {
                var borderStyles = borderColor && {
                    border: "1px solid ".concat(colors/* default */.Z[borderColor]),
                    borderRadius: "8px",
                    padding: "6px 12px"
                };
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "full-paragraph-topic",
                    style: full_paragraph_object_spread({
                        color: colors/* default */.Z[color],
                        marginBottom: !removeMargin && topicBottomMargin
                    }, borderStyles),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(monday_markup_language_component/* default */.Z, {
                        text: topicText
                    })
                });
            }
            return null;
        });
        _define_property1((0,_assert_this_initialized/* default */.Z)(_this), "renderTopic", function() {
            var _props = _this.props, topic = _props.topic, topicBottomMargin = _props.topicBottomMargin;
            var allowTextAndImage = topic.allowTextAndImage, gap = topic.gap;
            if (allowTextAndImage) {
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "full-paragraph-topic-image-and-text-wrapper",
                    style: {
                        gap: gap,
                        marginBottom: topicBottomMargin
                    },
                    children: [
                        _this.renderTopicImage(true),
                        _this.renderTopicText(true)
                    ]
                });
            }
            return _this.renderTopicImage() || _this.renderTopicText();
        });
        return _this;
    }
    (0,_create_class/* default */.Z)(FullParagraph, [
        {
            key: "getComponentInlineStyles",
            value: function getComponentInlineStyles() {
                var _props = this.props, textColor = _props.textColor, paragraphVerticalColoredLineColor = _props.paragraphVerticalColoredLineColor;
                var verticalLeftLineColor = colors/* default */.Z[paragraphVerticalColoredLineColor];
                var inlineStyles = {
                    textAlign: this.getTextAlignBasedOnDeviceType(),
                    color: textColor
                };
                if (paragraphVerticalColoredLineColor) {
                    inlineStyles = _object_spread_props(full_paragraph_object_spread({}, inlineStyles), {
                        borderImage: "linear-gradient(to bottom, ".concat(verticalLeftLineColor, ", transparent) 0 0 0 1")
                    });
                }
                return inlineStyles;
            }
        },
        {
            key: "render",
            value: function render() {
                var _props = this.props, body = _props.body, bodyColor = _props.bodyColor, buttonConfig = _props.buttonConfig, bulletsConfig = _props.bulletsConfig, textSize = _props.textSize, titleSize = _props.titleSize, titleColor = _props.titleColor, isFirstSegment = _props.isFirstSegment, withDynamicParagraphTitle = _props.withDynamicParagraphTitle, withDynamicParagraphSubtitle = _props.withDynamicParagraphSubtitle, title = _props.title, titleClassName = _props.titleClassName, clusterConfig = _props.clusterConfig, activePagePath = _props.activePagePath, titleIcon = _props.titleIcon, iconsConfig = _props.iconsConfig, paragraphVerticalColoredLineColor = _props.paragraphVerticalColoredLineColor, textAlign = _props.textAlign, textWidth = _props.textWidth, removeBulletsMobileMarginTop = _props.removeBulletsMobileMarginTop, openLiveBoardExperience = _props.openLiveBoardExperience, renderButton = _props.renderButton;
                var inlineComponentStyles = this.getComponentInlineStyles();
                var titleToUse = withDynamicParagraphTitle && (0,cluster_config_service/* getDynamicTitleConfigForPath */.Dp)(clusterConfig, activePagePath) || title;
                var subTitleToUse = withDynamicParagraphSubtitle && (0,cluster_config_service/* getDynamicSubTitleConfigForPath */.ER)(clusterConfig, activePagePath) || body;
                var alignItemsClassName = "align-items-".concat(textAlign);
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledFullParagraph, {
                    className: classnames_default()("full-paragraph", (0,_define_property/* default */.Z)({
                        "with-left-line": paragraphVerticalColoredLineColor
                    }, alignItemsClassName, textAlign)),
                    style: inlineComponentStyles,
                    children: [
                        this.renderTopic(),
                        titleToUse && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "title-wrapper",
                            style: this.getTitleStyle(),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(title_title/* default */.Z, {
                                title: titleToUse,
                                titleSize: titleSize,
                                titleColor: titleColor,
                                titleIcon: titleIcon,
                                isFirstSegment: isFirstSegment,
                                titleClassName: titleClassName
                            })
                        }),
                        subTitleToUse && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "paragraph-body-wrapper",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(paragraph/* default */.Z, {
                                body: subTitleToUse,
                                bodyColor: bodyColor,
                                textSize: textSize,
                                isFirstSegment: isFirstSegment,
                                textWidth: textWidth
                            })
                        }),
                        bulletsConfig && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: classnames_default()("bullets-wrapper", this.getTextAlignBasedOnDeviceType(), {
                                "no-mobile-margin": removeBulletsMobileMarginTop
                            }),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(bullets, full_paragraph_object_spread({}, bulletsConfig))
                        }),
                        iconsConfig && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: classnames_default()("icons-wrapper", this.getTextAlignBasedOnDeviceType()),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons, full_paragraph_object_spread({}, iconsConfig))
                        }),
                        buttonConfig && buttonConfig.buttonType && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: classnames_default()("button-wrapper", this.getTextAlignBasedOnDeviceType()),
                            style: this.getButtonWrapperStyle(),
                            children: renderButton && renderButton() || /*#__PURE__*/ (0,jsx_runtime.jsx)(button_button/* default */.Z, full_paragraph_object_spread({}, buttonConfig, openLiveBoardExperience ? {
                                onClick: openLiveBoardExperience
                            } : {}))
                        })
                    ]
                });
            }
        }
    ]);
    return FullParagraph;
}(react.PureComponent);
FullParagraph.defaultProps = full_paragraph_default_props/* default */.Z;
/* harmony default export */ var full_paragraph = ((0,segment_context/* withSegmentsData */.c)((0,router.withRouter)((0,generic_config_context/* withGenericConfig */.P)(FullParagraph))));


/***/ }),

/***/ 47755:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ GridImageWithParagraph; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_assert_this_initialized.mjs
var _assert_this_initialized = __webpack_require__(4111);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(52951);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(88029);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 4 modules
var _create_super = __webpack_require__(60460);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./constants/bigbrain-event-types.js
var bigbrain_event_types = __webpack_require__(65023);
// EXTERNAL MODULE: ./segments/desktop/core-components/grid-image/grid-image.js + 1 modules
var grid_image = __webpack_require__(94351);
// EXTERNAL MODULE: ./segments/desktop/core-components/title/title.js + 1 modules
var title_title = __webpack_require__(91265);
// EXTERNAL MODULE: ./segments/desktop/core-components/paragraph/paragraph.js + 1 modules
var paragraph = __webpack_require__(75073);
// EXTERNAL MODULE: ./segments/desktop/core-components/button/secondary-button/secondary-button.js + 1 modules
var secondary_button = __webpack_require__(95736);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
// EXTERNAL MODULE: ./styles/colors.js
var colors = __webpack_require__(12573);
// EXTERNAL MODULE: ./segments/desktop/constants.js
var constants = __webpack_require__(73759);
;// CONCATENATED MODULE: ./segments/desktop/core-components/grid-image-with-paragraph/grid-image-with-paragraph.scss.js



var StyledGridImageWithParagraph = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("a", {
    target: "e13wd3ew0"
})("text-decoration:none;color:", colors/* default.black */.Z.black, ";height:100%;&.without-link{.grid-image-with-paragraph{cursor:initial;&:hover{transform:none;}}}.grid-image-with-paragraph{display:flex;flex-direction:column;height:100%;width:100%;cursor:pointer;padding:16px;background-color:", colors/* default.white */.Z.white, ";transition:transform 300ms ease;", (0,constants.getComponentShadow)(), "    &:hover{", (0,constants.getComponentShadowWithHoverEffect)(), "}&:hover{transform:scale(1.05);}.grid-paragraph-wrapper{height:100%;margin-top:16px;display:flex;flex-direction:column;.title-wrapper{width:100%;margin-bottom:16px;height:64px;overflow:hidden;}.paragraph-body-wrapper{flex-grow:1;}.button-wrapper{margin-top:32px;}}}");

// EXTERNAL MODULE: ./segments/desktop/core-components/grid-image/default-props.js
var default_props = __webpack_require__(80651);
// EXTERNAL MODULE: ./segments/desktop/core-components/title/default-props.js
var title_default_props = __webpack_require__(51261);
// EXTERNAL MODULE: ./segments/desktop/core-components/paragraph/default-props.js
var paragraph_default_props = __webpack_require__(14066);
;// CONCATENATED MODULE: ./segments/desktop/core-components/grid-image-with-paragraph/default-props.js
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}



/* harmony default export */ var grid_image_with_paragraph_default_props = (_object_spread_props(_object_spread({}, _object_spread_props(_object_spread({}, default_props/* default */.Z), {
    src: "/static/img/segment-layout-default-images/grid/man-with-blue-shirt.png"
})), {
    fullParagraph: _object_spread({}, title_default_props/* default */.Z, paragraph_default_props/* default */.Z)
}));

;// CONCATENATED MODULE: ./segments/desktop/core-components/grid-image-with-paragraph/grid-image-with-paragraph.js






function grid_image_with_paragraph_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function grid_image_with_paragraph_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            grid_image_with_paragraph_define_property(target, key, source[key]);
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}










var GridImageWithParagraph = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(GridImageWithParagraph, PureComponent);
    var _super = (0,_create_super/* default */.Z)(GridImageWithParagraph);
    function GridImageWithParagraph() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        (0,_class_call_check/* default */.Z)(this, GridImageWithParagraph);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat((0,_to_consumable_array/* default */.Z)(args)));
        grid_image_with_paragraph_define_property((0,_assert_this_initialized/* default */.Z)(_this), "handleClick", function() {
            var fullParagraph = _this.props.fullParagraph;
            var buttonConfig = fullParagraph.buttonConfig, title = fullParagraph.title;
            var ref = buttonConfig || {}, url = ref.url, buttonText = ref.buttonText;
            BigBrain("track", bigbrain_event_types.GRID_CARD_CLICKED, {
                kind: buttonText,
                info1: title,
                info2: url
            });
        });
        grid_image_with_paragraph_define_property((0,_assert_this_initialized/* default */.Z)(_this), "handleHover", function() {
            var fullParagraph = _this.props.fullParagraph;
            var buttonConfig = fullParagraph.buttonConfig, title = fullParagraph.title;
            var ref = buttonConfig || {}, url = ref.url, buttonText = ref.buttonText;
            BigBrain("track", bigbrain_event_types.GRID_CARD_HOVERED, {
                kind: buttonText,
                info1: title,
                info2: url
            });
        });
        grid_image_with_paragraph_define_property((0,_assert_this_initialized/* default */.Z)(_this), "renderParagraph", function() {
            var _props = _this.props, fullParagraph = _props.fullParagraph, titleSize = _props.titleSize, textSize = _props.textSize, width = _props.width, hideButton = _props.hideButton;
            var title = fullParagraph.title, body = fullParagraph.body, buttonConfig = fullParagraph.buttonConfig;
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "grid-paragraph-wrapper",
                style: {
                    width: width
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "title-wrapper",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(title_title/* default */.Z, {
                            title: title,
                            titleSize: titleSize
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "paragraph-body-wrapper",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(paragraph/* default */.Z, {
                            body: body,
                            textSize: textSize
                        })
                    }),
                    !hideButton && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "button-wrapper",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(secondary_button/* default */.Z, grid_image_with_paragraph_object_spread({}, buttonConfig))
                    })
                ]
            });
        });
        return _this;
    }
    (0,_create_class/* default */.Z)(GridImageWithParagraph, [
        {
            key: "renderComponent",
            value: function renderComponent() {
                var _this_props = this.props, fullParagraph = _this_props.fullParagraph, titleSize = _this_props.titleSize, textSize = _this_props.textSize, restImageProps = _object_without_properties(_this_props, [
                    "fullParagraph",
                    "titleSize",
                    "textSize"
                ]);
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "grid-image-with-paragraph",
                    children: [
                        (restImageProps === null || restImageProps === void 0 ? void 0 : restImageProps.src) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "grid-image-wrapper",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(grid_image/* default */.Z, grid_image_with_paragraph_object_spread({}, restImageProps))
                        }),
                        this.renderParagraph()
                    ]
                });
            }
        },
        {
            key: "render",
            value: function render() {
                var fullParagraph = this.props.fullParagraph;
                var buttonConfig = fullParagraph.buttonConfig;
                var ref = buttonConfig || {}, url = ref.url, isOpenLinkInNewTab = ref.isOpenLinkInNewTab;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledGridImageWithParagraph, {
                    className: classnames_default()("card-grid-link", {
                        "without-link": !url
                    }),
                    href: url,
                    onClick: this.handleClick,
                    onMouseEnter: this.handleHover,
                    target: isOpenLinkInNewTab ? "_blank" : "_self",
                    children: this.renderComponent()
                });
            }
        }
    ]);
    return GridImageWithParagraph;
}(react.PureComponent);

GridImageWithParagraph.defaultProps = grid_image_with_paragraph_default_props;


/***/ }),

/***/ 80651:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

/* harmony default export */ __webpack_exports__["Z"] = ({
    height: 300,
    width: 300,
    link: {}
});


/***/ }),

/***/ 94351:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ GridImage; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(52951);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(88029);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 4 modules
var _create_super = __webpack_require__(60460);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./components/core/picture-with-link/picture-with-link-component.js
var picture_with_link_component = __webpack_require__(94640);
// EXTERNAL MODULE: ./segments/desktop/core-components/images-grid/images-grid-service.js
var images_grid_service = __webpack_require__(72898);
// EXTERNAL MODULE: ./segments/desktop/core-components/grid-image/default-props.js
var default_props = __webpack_require__(80651);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
;// CONCATENATED MODULE: ./segments/desktop/core-components/grid-image/grid-image.scss.js

var StyledGridImage = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "ezk0g6e0"
})("display:flex;.image{width:100%;}");

;// CONCATENATED MODULE: ./segments/desktop/core-components/grid-image/grid-image.js




function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}






var GridImage = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(GridImage, PureComponent);
    var _super = (0,_create_super/* default */.Z)(GridImage);
    function GridImage() {
        (0,_class_call_check/* default */.Z)(this, GridImage);
        return _super.apply(this, arguments);
    }
    (0,_create_class/* default */.Z)(GridImage, [
        {
            key: "renderPicture",
            value: function renderPicture() {
                var _props = this.props, src = _props.src, alt = _props.alt, isDecorative = _props.isDecorative, link = _props.link, imageStyle = _props.imageStyle;
                var href = link.href, isNewTab = link.isNewTab;
                var target = isNewTab ? "_blank" : "_self";
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(picture_with_link_component/* default */.Z, {
                    src: src,
                    alt: alt,
                    isDecorative: isDecorative,
                    className: "image",
                    target: target,
                    href: href,
                    specificImageStyle: imageStyle
                });
            }
        },
        {
            key: "render",
            value: function render() {
                var _props = this.props, height = _props.height, width = _props.width, imagePosition = _props.imagePosition;
                var imagePositionStyles = (0,images_grid_service/* getImagePositionStyles */.y)(imagePosition);
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledGridImage, {
                    className: "grid-image",
                    style: _object_spread({
                        height: height,
                        width: width
                    }, imagePositionStyles),
                    children: this.renderPicture()
                });
            }
        }
    ]);
    return GridImage;
}(react.PureComponent);

GridImage.defaultProps = default_props/* default */.Z;


/***/ }),

/***/ 32627:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ grid_paragraph_with_image; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./constants/bigbrain-event-types.js
var bigbrain_event_types = __webpack_require__(65023);
// EXTERNAL MODULE: ./segments/desktop/core-components/grid-image/grid-image.js + 1 modules
var grid_image = __webpack_require__(94351);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./styles/colors.js
var colors = __webpack_require__(12573);
// EXTERNAL MODULE: ./segments/desktop/core-components/full-paragraph/full-paragraph.js + 6 modules
var full_paragraph = __webpack_require__(13211);
// EXTERNAL MODULE: ./services/bigbrain-service.js
var bigbrain_service = __webpack_require__(65488);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
// EXTERNAL MODULE: ./segments/desktop/constants.js
var constants = __webpack_require__(73759);
// EXTERNAL MODULE: ./styles/color-consts.js
var color_consts = __webpack_require__(273);
;// CONCATENATED MODULE: ./segments/desktop/core-components/grid-paragraph-with-image/grid-paragraph-with-image.scss.js




var StyledGridParagraphWithImage = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e17e2hrn0"
})("text-decoration:none;color:", colors/* default */.Z[color_consts.BRAND_BLACK_TEXT_COLOR], ";height:100%;width:100%;display:flex;&.without-link{.grid-paragraph-with-image{cursor:initial;}}.grid-paragraph-with-image{display:flex;flex-direction:column;height:100%;width:100%;cursor:pointer;border-radius:18px;overflow:hidden;&.top{justify-content:flex-start;}&.center{justify-content:center;}&.bottom{justify-content:flex-end;}.tag{border-style:solid;border-width:2px;position:absolute;top:10px;right:10px;padding:3px 5px;}&:not(.without-shadow-hover):hover{", (0,constants.getComponentShadow)(), "}&.shadow{", (0,constants.getComponentShadow)(), "      &:not(.without-shadow-hover):hover{", (0,constants.getComponentShadowWithHoverEffect)(), "}}.grid-image-wrapper{.grid-image{.picture-component{display:flex;img{border-bottom-right-radius:16px;border-bottom-left-radius:16px;}}}}.grid-paragraph-wrapper{height:100%;padding:24px 24px 40px 24px;display:flex;flex-direction:column;.full-paragraph-topic-image-wrapper.left .picture-component > img{object-fit:contain;}.footer{display:flex;align-items:center;margin-top:10px;gap:10px;.footer-image{width:", function(param) {
    var footerImageWidth = param.footerImageWidth;
    return footerImageWidth !== null && footerImageWidth !== void 0 ? footerImageWidth : "auto";
}, ";height:auto;}}}}&.disabled-hover-effect{cursor:initial;.grid-paragraph-with-image{cursor:initial;&:hover{box-shadow:none;}}}");

// EXTERNAL MODULE: ./segments/desktop/core-components/grid-image/default-props.js
var default_props = __webpack_require__(80651);
// EXTERNAL MODULE: ./segments/desktop/core-components/title/default-props.js
var title_default_props = __webpack_require__(51261);
// EXTERNAL MODULE: ./segments/desktop/core-components/paragraph/default-props.js
var paragraph_default_props = __webpack_require__(14066);
;// CONCATENATED MODULE: ./segments/desktop/core-components/grid-paragraph-with-image/default-props.js
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}




/* harmony default export */ var grid_paragraph_with_image_default_props = (_object_spread_props(_object_spread({}, default_props/* default */.Z), {
    showParagraph: true,
    fullParagraph: _object_spread({}, title_default_props/* default */.Z, paragraph_default_props/* default */.Z),
    cardColor: color_consts.WHITE_COLOR_NAME
}));

// EXTERNAL MODULE: ./utils/general.js
var general = __webpack_require__(56093);
// EXTERNAL MODULE: ./components/core/picture/picture-component.js + 3 modules
var picture_component = __webpack_require__(82305);
// EXTERNAL MODULE: ./client/components/system/monday-markup-language/monday-markup-language-component.js + 11 modules
var monday_markup_language_component = __webpack_require__(36239);
;// CONCATENATED MODULE: ./segments/desktop/core-components/grid-paragraph-with-image/grid-paragraph-with-image.js
function grid_paragraph_with_image_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function grid_paragraph_with_image_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            grid_paragraph_with_image_define_property(target, key, source[key]);
        });
    }
    return target;
}
function grid_paragraph_with_image_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function grid_paragraph_with_image_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        grid_paragraph_with_image_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}












var GridParagraphWithImage = function(props) {
    var borderColor = props.borderColor, showParagraph = props.showParagraph, fullParagraph = props.fullParagraph, titleSize = props.titleSize, textSize = props.textSize, cardTagText = props.cardTagText, contentVerticalAlignment = props.contentVerticalAlignment, paragraphVerticalColoredLineColor = props.paragraphVerticalColoredLineColor, padding = props.padding, backgroundImage = props.backgroundImage, cardColor = props.cardColor, borderOpacity = props.borderOpacity, cardWidthForCss = props.cardWidthForCss, disableHoverStyle = props.disableHoverStyle, footer = props.footer;
    var ref = (fullParagraph === null || fullParagraph === void 0 ? void 0 : fullParagraph.buttonConfig) || {}, url = ref.url, isOpenLinkInNewTab = ref.isOpenLinkInNewTab, buttonText = ref.buttonText;
    var handleClick = function() {
        (0,bigbrain_service.trackEvent)(bigbrain_event_types.FLEXIBLE_GRID_CARD_CLICKED, {
            kind: buttonText,
            info1: fullParagraph === null || fullParagraph === void 0 ? void 0 : fullParagraph.title,
            info2: url
        });
        url && window.open(url, isOpenLinkInNewTab ? "_blank" : "_self");
    };
    var getParagraphStyle = function() {
        return {
            padding: padding
        };
    };
    var getStyle = function() {
        var color = colors/* default */.Z[cardColor];
        var borderRgbaColor = borderColor && (0,general/* hexToRgba */.a7)(colors/* default */.Z[borderColor], parseFloat(borderOpacity) || 1);
        var style = {
            backgroundColor: color,
            maxWidth: cardWidthForCss,
            border: "1px solid ".concat(borderRgbaColor)
        };
        if (backgroundImage === null || backgroundImage === void 0 ? void 0 : backgroundImage.src) {
            style = grid_paragraph_with_image_object_spread_props(grid_paragraph_with_image_object_spread({}, style), {
                backgroundImage: "url(".concat(backgroundImage === null || backgroundImage === void 0 ? void 0 : backgroundImage.src, ")"),
                backgroundRepeat: "no-repeat",
                backgroundSize: "cover",
                backgroundPosition: (backgroundImage === null || backgroundImage === void 0 ? void 0 : backgroundImage.backgroundPosition) || "center"
            });
        }
        return style;
    };
    var renderParagraph = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: showParagraph && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: classnames_default()("grid-paragraph-wrapper"),
                style: getParagraphStyle(),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(full_paragraph/* default */.ZP, grid_paragraph_with_image_object_spread_props(grid_paragraph_with_image_object_spread({
                        titleSize: titleSize,
                        textSize: textSize
                    }, fullParagraph), {
                        paragraphVerticalColoredLineColor: paragraphVerticalColoredLineColor
                    })),
                    (footer === null || footer === void 0 ? void 0 : footer.showFooter) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "footer",
                        children: [
                            (footer === null || footer === void 0 ? void 0 : footer.image) && /*#__PURE__*/ (0,jsx_runtime.jsx)(picture_component/* default */.Z, {
                                className: "footer-image",
                                src: footer === null || footer === void 0 ? void 0 : footer.image
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(monday_markup_language_component/* default */.Z, {
                                className: "footer-text",
                                text: footer === null || footer === void 0 ? void 0 : footer.text
                            })
                        ]
                    })
                ]
            })
        });
    };
    var renderComponent = function() {
        var shadowCards = props.shadowCards, removeShadowOnHover = props.removeShadowOnHover, src = props.src, cardTagColor = props.cardTagColor, restImageProps = _object_without_properties(props, [
            "shadowCards",
            "removeShadowOnHover",
            "src",
            "cardTagColor"
        ]);
        var tagColor = colors/* default */.Z[cardTagColor];
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: classnames_default()("grid-paragraph-with-image", {
                shadow: shadowCards,
                "without-shadow-hover": removeShadowOnHover
            }, contentVerticalAlignment),
            style: getStyle(),
            children: [
                cardTagText && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "tag",
                    style: {
                        borderColor: tagColor,
                        color: tagColor
                    },
                    children: cardTagText
                }),
                renderParagraph(),
                src && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "grid-image-wrapper",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(grid_image/* default */.Z, grid_paragraph_with_image_object_spread({
                        src: src
                    }, restImageProps))
                })
            ]
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledGridParagraphWithImage, {
        className: classnames_default()("card-grid-link", {
            "without-link": !url,
            "disabled-hover-effect": disableHoverStyle
        }),
        onClick: handleClick,
        rel: "noreferrer",
        footerImageWidth: footer === null || footer === void 0 ? void 0 : footer.imageWidth,
        children: renderComponent()
    });
};
/* harmony default export */ var grid_paragraph_with_image = (GridParagraphWithImage);
GridParagraphWithImage.defaultProps = grid_paragraph_with_image_default_props;


/***/ }),

/***/ 80564:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

/* harmony default export */ __webpack_exports__["Z"] = ({
    icons: [
        {
            image: {
                src: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/Home%20Page%20-%202022%20Rebrand/customer-support/phone.png",
                alt: "Telephone icon"
            },
            title: "24/7",
            subtitle: "support anytime,<br>anywhere"
        },
        {
            image: {
                src: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/Home%20Page%20-%202022%20Rebrand/customer-support/heart.png",
                alt: "Heart icon"
            },
            title: "Voted #1",
            subtitle: "Most Loved by<br>customers on G2"
        },
        {
            image: {
                src: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/Home%20Page%20-%202022%20Rebrand/customer-support/fast.png",
                alt: "Fast clock icon"
            },
            title: "2 hour",
            subtitle: "average<br>response time"
        }
    ]
});


/***/ }),

/***/ 72898:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "b": function() { return /* binding */ positionTypes; },
/* harmony export */   "y": function() { return /* binding */ getImagePositionStyles; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(14924);

var positionTypes = {
    TOP_LEFT: "TOP_LEFT",
    TOP_CENTER: "TOP_CENTER",
    TOP_RIGHT: "TOP_RIGHT",
    CENTER_LEFT: "CENTER_LEFT",
    CENTER_CENTER: "CENTER_CENTER",
    CENTER_RIGHT: "CENTER_RIGHT",
    BOTTOM_LEFT: "BOTTOM_LEFT",
    BOTTOM_CENTER: "BOTTOM_CENTER",
    BOTTOM_RIGHT: "BOTTOM_RIGHT"
};
var _obj;
var imagePositionStylesMapping = (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj, positionTypes.TOP_LEFT, {
    justifyContent: "flex-start",
    alignItems: "flex-start"
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj, positionTypes.TOP_CENTER, {
    justifyContent: "center",
    alignItems: "flex-start"
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj, positionTypes.TOP_RIGHT, {
    justifyContent: "flex-end",
    alignItems: "flex-start"
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj, positionTypes.CENTER_LEFT, {
    justifyContent: "flex-start",
    alignItems: "center"
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj, positionTypes.CENTER_CENTER, {
    justifyContent: "center",
    alignItems: "center"
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj, positionTypes.CENTER_RIGHT, {
    justifyContent: "flex-end",
    alignItems: "center"
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj, positionTypes.BOTTOM_LEFT, {
    justifyContent: "flex-start",
    alignItems: "flex-end"
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj, positionTypes.BOTTOM_CENTER, {
    justifyContent: "center",
    alignItems: "flex-end"
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj, positionTypes.BOTTOM_RIGHT, {
    justifyContent: "flex-end",
    alignItems: "flex-end"
}), _obj);
var getImagePositionStyles = function(imagePosition) {
    return imagePositionStylesMapping[imagePosition];
};


/***/ }),

/***/ 14066:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

/* harmony default export */ __webpack_exports__["Z"] = ({
    body: "monday.com, ranked #1 for productivity, helps teams manage and execute projects that deliver results on time."
});


/***/ }),

/***/ 75073:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Paragraph; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_assert_this_initialized.mjs
var _assert_this_initialized = __webpack_require__(4111);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(52951);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(88029);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 4 modules
var _create_super = __webpack_require__(60460);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./styles/colors.js
var colors = __webpack_require__(12573);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./utils/strings.js
var strings = __webpack_require__(11685);
// EXTERNAL MODULE: ./client/components/system/monday-markup-language/monday-markup-language-component.js + 11 modules
var monday_markup_language_component = __webpack_require__(36239);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
;// CONCATENATED MODULE: ./segments/desktop/core-components/paragraph/paragraph.scss.js

var StyledParagraph = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "ehzaxgp0"
})(".paragraph-body{font-size:1.125rem;line-height:32px;margin:0;//overide h3 global definition\n    word-break:break-word;&.xs{font-size:0.8125rem;line-height:20px;}&.sm{font-size:0.875rem;line-height:22px;}&.ms{font-size:1rem;line-height:24px;}&.md{font-size:1.125rem;line-height:32px;}&.lg{font-size:1.375rem;line-height:40px;}}");

// EXTERNAL MODULE: ./segments/desktop/core-components/paragraph/default-props.js
var default_props = __webpack_require__(14066);
;// CONCATENATED MODULE: ./segments/desktop/core-components/paragraph/paragraph.js






function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}








var Paragraph = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(Paragraph, PureComponent);
    var _super = (0,_create_super/* default */.Z)(Paragraph);
    function Paragraph() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        (0,_class_call_check/* default */.Z)(this, Paragraph);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat((0,_to_consumable_array/* default */.Z)(args)));
        _define_property((0,_assert_this_initialized/* default */.Z)(_this), "getStyle", function() {
            var _props = _this.props, bodyColor = _props.bodyColor, textWidth = _props.textWidth;
            var customStyle = {
                maxWidth: textWidth
            };
            if (bodyColor && colors/* default */.Z[bodyColor]) {
                customStyle = _object_spread_props(_object_spread({}, customStyle), {
                    color: colors/* default */.Z[bodyColor]
                });
            }
            return customStyle;
        });
        return _this;
    }
    (0,_create_class/* default */.Z)(Paragraph, [
        {
            key: "render",
            value: function render() {
                var _props = this.props, body = _props.body, textSize = _props.textSize, isFirstSegment = _props.isFirstSegment;
                var CustomTag = isFirstSegment ? "h2" : "div";
                var style = this.getStyle();
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledParagraph, {
                    className: "paragraph-wrapper",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(monday_markup_language_component/* default */.Z, {
                        tagName: CustomTag,
                        className: classnames_default()("paragraph-body", textSize),
                        text: (0,strings.encloseBoldTag)(body),
                        style: style
                    })
                });
            }
        }
    ]);
    return Paragraph;
}(react.PureComponent);

Paragraph.defaultProps = default_props/* default */.Z;


/***/ }),

/***/ 62414:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ starsClusters; }
/* harmony export */ });
/* harmony import */ var constants_clusters__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(16961);
/* harmony import */ var constants_clusters__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(constants_clusters__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var styles_color_consts__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(273);


var starsClusters = [
    {
        text: "Creative & design",
        image: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/Home%20Page%20-%202022%20Rebrand/first_fold/icons/design_icon.png",
        colorName: "sofia-pink",
        clusterId: constants_clusters__WEBPACK_IMPORTED_MODULE_0__.DESIGN_AND_CREATIVE
    },
    {
        text: "IT",
        image: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/Home%20Page%20-%202022%20Rebrand/first_fold/icons/it_icon.png",
        colorName: "purple-v2",
        clusterId: constants_clusters__WEBPACK_IMPORTED_MODULE_0__.IT
    },
    {
        text: "Software development",
        image: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/Home%20Page%20-%202022%20Rebrand/first_fold/icons/dev_icon.png",
        colorName: styles_color_consts__WEBPACK_IMPORTED_MODULE_1__.DEV_GREEN_COLOR_NAME,
        clusterId: constants_clusters__WEBPACK_IMPORTED_MODULE_0__.SOFTWARE
    },
    {
        text: "Marketing",
        image: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/Home%20Page%20-%202022%20Rebrand/first_fold/icons/marketing_icon.png",
        colorName: styles_color_consts__WEBPACK_IMPORTED_MODULE_1__.MARKETING_RED_COLOR_NAME,
        clusterId: constants_clusters__WEBPACK_IMPORTED_MODULE_0__.MARKETING
    },
    {
        text: "Project management",
        image: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/Home%20Page%20-%202022%20Rebrand/first_fold/icons/pmo_icon.png",
        colorName: styles_color_consts__WEBPACK_IMPORTED_MODULE_1__.PROJECTS_ORANGE_COLOR_NAME,
        clusterId: constants_clusters__WEBPACK_IMPORTED_MODULE_0__.GENERIC_CLUSTER,
        useCaseId: constants_clusters__WEBPACK_IMPORTED_MODULE_0__.PROJECT_MANAGEMENT_USE_CASE
    },
    {
        text: "Sales & CRM",
        image: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/Home%20Page%20-%202022%20Rebrand/first_fold/icons/crm_icon.png",
        colorName: styles_color_consts__WEBPACK_IMPORTED_MODULE_1__.CRM_GREEN_COLOR_NAME,
        clusterId: constants_clusters__WEBPACK_IMPORTED_MODULE_0__.CRM
    },
    {
        text: "Task management",
        image: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/Home%20Page%20-%202022%20Rebrand/first_fold/icons/task_icon.png",
        colorName: "light-blue-v2",
        clusterId: constants_clusters__WEBPACK_IMPORTED_MODULE_0__.GENERIC_CLUSTER
    },
    {
        text: "HR",
        image: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/Home%20Page%20-%202022%20Rebrand/first_fold/icons/hr_icon.png",
        colorName: "sunset",
        clusterId: constants_clusters__WEBPACK_IMPORTED_MODULE_0__.HR
    },
    {
        text: "Operations",
        image: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/Home%20Page%20-%202022%20Rebrand/first_fold/icons/operations_icon.png",
        colorName: "aquamarine",
        clusterId: constants_clusters__WEBPACK_IMPORTED_MODULE_0__.OPERATIONS
    }
];
/* harmony default export */ __webpack_exports__["Z"] = ({
    tagsWidth: "140px",
    clusters: starsClusters,
    buttonConfig: {
        buttonColor: styles_color_consts__WEBPACK_IMPORTED_MODULE_1__.IRIS_COLOR_NAME
    }
});


/***/ }),

/***/ 76416:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "x": function() { return /* binding */ PRESELECTED_TAG_PARAM_NAME; },
  "Z": function() { return /* binding */ square_tags; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./styles/color-consts.js
var color_consts = __webpack_require__(273);
// EXTERNAL MODULE: ./styles/colors.js
var colors = __webpack_require__(12573);
// EXTERNAL MODULE: ./constants/clusters/types.js
var types = __webpack_require__(10945);
// EXTERNAL MODULE: ./services/clusters-service.js + 1 modules
var clusters_service = __webpack_require__(25866);
// EXTERNAL MODULE: ./constants/clusters.js
var constants_clusters = __webpack_require__(16961);
// EXTERNAL MODULE: ./segments/desktop/core-components/button/signup-button/signup-button.js + 1 modules
var signup_button = __webpack_require__(85850);
// EXTERNAL MODULE: ./segments/desktop/core-components/button/secondary-button/secondary-button.js + 1 modules
var secondary_button = __webpack_require__(95736);
// EXTERNAL MODULE: ./styles/colors-utils.js
var colors_utils = __webpack_require__(61012);
// EXTERNAL MODULE: ./client/services/hotjar-service/hotjar-service.js
var hotjar_service = __webpack_require__(96339);
// EXTERNAL MODULE: ./utils/url.js
var url = __webpack_require__(8339);
// EXTERNAL MODULE: ./segments/segments-service.js
var segments_service = __webpack_require__(861);
// EXTERNAL MODULE: ./services/utils-service.js
var utils_service = __webpack_require__(20618);
// EXTERNAL MODULE: ./components/core/picture/picture-component.js + 3 modules
var picture_component = __webpack_require__(82305);
// EXTERNAL MODULE: ./constants/bigbrain-event-types.js
var bigbrain_event_types = __webpack_require__(65023);
// EXTERNAL MODULE: ./services/bigbrain-service.js
var bigbrain_service = __webpack_require__(65488);
// EXTERNAL MODULE: ./client/services/accessibility/accessibility-service.js
var accessibility_service = __webpack_require__(60696);
// EXTERNAL MODULE: ./constants/data-layer-event-types.js
var data_layer_event_types = __webpack_require__(34496);
var data_layer_event_types_default = /*#__PURE__*/__webpack_require__.n(data_layer_event_types);
// EXTERNAL MODULE: ./client/services/gtm-service/gtm-service.js
var gtm_service = __webpack_require__(60775);
// EXTERNAL MODULE: ./node_modules/monday-ui-react-core/dist/icons/Check.js
var Check = __webpack_require__(74565);
var Check_default = /*#__PURE__*/__webpack_require__.n(Check);
;// CONCATENATED MODULE: ./segments/desktop/core-components/square-tags/square-tag/components/tag-checkbox.js





var TagCheckbox = function(param) {
    var checkColor = param.checkColor, isSelected = param.isSelected, selectedBorderColor = param.selectedBorderColor, tagBorderColor = param.tagBorderColor, selectedBackgroundColor = param.selectedBackgroundColor;
    var checkboxColor = (0,react.useMemo)(function() {
        return checkColor && colors/* default */.Z[checkColor];
    }, [
        checkColor
    ]);
    var checkboxBorderColor = (0,react.useMemo)(function() {
        return isSelected && selectedBorderColor ? colors/* default */.Z[selectedBorderColor] : colors/* default */.Z[tagBorderColor];
    }, [
        isSelected,
        selectedBorderColor,
        tagBorderColor
    ]);
    var checkboxBackgroundColor = (0,react.useMemo)(function() {
        return isSelected && selectedBackgroundColor && colors/* default */.Z[selectedBackgroundColor];
    }, [
        selectedBackgroundColor,
        isSelected
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: classnames_default()("checkbox", {
            "custom-check-color": checkColor
        }),
        style: {
            color: checkboxColor,
            borderColor: checkboxBorderColor,
            backgroundColor: checkboxBackgroundColor
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((Check_default()), {})
    });
};
/* harmony default export */ var tag_checkbox = (TagCheckbox);

// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
// EXTERNAL MODULE: ./constants/z-index.js
var z_index = __webpack_require__(35257);
// EXTERNAL MODULE: ./segments/desktop/constants.js
var constants = __webpack_require__(73759);
// EXTERNAL MODULE: ./utils/general.js
var general = __webpack_require__(56093);
;// CONCATENATED MODULE: ./segments/desktop/core-components/square-tags/square-tag/square-tag-component.scss.js






var BORDER_COLOR = (0,general/* hexToRgba */.a7)(colors/* default */.Z[color_consts.LIGHT_WORK_OS_IRIS_COLOR_NAME], 0.5);
var StyledSquareTagComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1h5ozrm0"
})("display:flex;flex-direction:column;align-items:center;position:relative;justify-content:center;z-index:", z_index/* TOP_LAYER */.nA, ";cursor:pointer;.background-circle{transition:opacity 100ms ease-in-out;position:absolute;width:80px;height:80px;border-radius:50%;background-color:currentColor;opacity:0%;filter:blur(30px);z-index:", z_index/* ZERO */.xE, ";}.star-image{.star-picture{display:flex;.star-icon{height:40px;}}}.star-text{transition:opacity 100ms ease-in-out;text-align:center;font-size:0.875rem;color:", colors/* default */.Z[color_consts.WHITE_COLOR_NAME], ";opacity:85%;padding-top:4px;padding-right:8px;padding-left:8px;}&:active{outline:none;}&.selected,&:hover{.background-circle{opacity:40%;}.star-text{opacity:100%;z-index:", z_index/* LAYER_ONE */.KW, ";}}&.selectable-cluster{justify-content:unset;border:1px solid rgba(255,255,255,0.3);border-radius:8px;margin:8px;padding:8px 8px 16px 8px;height:calc(100% - 16px);transition:border 0.1s ease-in-out;.checkbox{border:1px solid rgba(255,255,255,0.3);transition:all 0.05s ease-in-out;width:20px;height:20px;border-radius:4px;align-self:start;svg{path{fill:transparent;}}}&.selected,&:hover{transition:border 0.1s ease-in-out;border-color:currentColor;.background-circle{opacity:0;}.checkbox{border-color:currentColor;}}&.selected{.checkbox{background-color:currentColor;svg{path{fill:", colors/* default */.Z[color_consts.SPACE_BLUE_COLOR_NAME], ';}}}.checkbox.custom-check-color{svg{path{fill:currentColor;}}}}&.cluster-selected{animation:breatheIn 0.3s linear;}}&.light-theme::after{position:absolute;content:"";background:white;z-index:-1;top:0;bottom:0;left:0;right:0;border-radius:8px;', (0,constants.getComponentShadow)(), "}&.light-theme{border-color:transparent;&.show-border-in-light-theme{&::after{box-shadow:none;}&:not(.selected):not(.hovered){border-color:", colors/* default */.Z[color_consts.UI_BORDER_LIGHT_COLOR_NAME], ";.checkbox{border-color:", colors/* default */.Z[color_consts.UI_BORDER_LIGHT_COLOR_NAME], ";}}}// remove buggy drop-shadow filter behavior in safari in hover interaction and use border instead\n    @media not all and (min-resolution:0.001dpcm){@supports (-webkit-appearance:none){border-color:", BORDER_COLOR, ";&::after{filter:none;}}}.checkbox{border-color:", BORDER_COLOR, ";svg{path{fill:", colors/* default */.Z[color_consts.WHITE_COLOR_NAME], ";}}}.star-text{color:", colors/* default */.Z[color_consts.BRAND_BLACK_TEXT_COLOR], ";}&.selected{.checkbox{background-color:currentColor;svg{path{fill:", colors/* default */.Z[color_consts.WHITE_COLOR_NAME], ";}}}}}@keyframes breatheIn{0%{transform:scale(1);}15%{transform:scale(0.995);}20%{transform:scale(0.99);}25%{transform:scale(0.985);}32%{transform:scale(0.98);}50%{transform:scale(0.975);}68%{transform:scale(0.98);}75%{transform:scale(0.985);}80%{transform:scale(0.99);}85%{transform:scale(0.995);}100%{transform:scale(1);}}");

;// CONCATENATED MODULE: ./segments/desktop/core-components/square-tags/square-tag/square-tag-component.js
function square_tag_component_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            square_tag_component_define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}













var SquareTagComponent = function(props) {
    var CLUSTER_CLICK_ANIMATION_TIME = 300;
    var ref = (0,react.useState)(false), isHovered = ref[0], setIsHovered = ref[1];
    var ref1 = (0,react.useState)(false), wasClusterSelected = ref1[0], setWasClusterSelected = ref1[1];
    var starText = props.starText, starImage = props.starImage, starColorName = props.starColorName, onStarClick = props.onStarClick, tagScheme = props.tagScheme, isSelected = props.isSelected, isDarkTheme = props.isDarkTheme, checkboxScheme = props.checkboxScheme, textScheme = props.textScheme, showBorderInLightTheme = props.showBorderInLightTheme, productType = props.productType;
    var blurTag = function(e) {
        var _e_target_closest, _e_target;
        e === null || e === void 0 ? void 0 : (_e_target = e.target) === null || _e_target === void 0 ? void 0 : (_e_target_closest = _e_target.closest(".square-tag-component")) === null || _e_target_closest === void 0 ? void 0 : _e_target_closest.blur();
    };
    var getCurrentColor = (0,react.useCallback)(function(selectedColor, hoverColor, baseColor) {
        if (isSelected) return colors/* default */.Z[selectedColor];
        return isHovered ? colors/* default */.Z[hoverColor] : colors/* default */.Z[baseColor];
    }, [
        isHovered,
        isSelected
    ]);
    var tagBackgroundColor = (0,react.useMemo)(function() {
        return getCurrentColor(tagScheme === null || tagScheme === void 0 ? void 0 : tagScheme.selectedBackgroundColor, tagScheme === null || tagScheme === void 0 ? void 0 : tagScheme.hoverColor, null);
    }, [
        getCurrentColor,
        tagScheme === null || tagScheme === void 0 ? void 0 : tagScheme.hoverColor,
        tagScheme === null || tagScheme === void 0 ? void 0 : tagScheme.selectedBackgroundColor
    ]);
    var tagTextColor = (0,react.useMemo)(function() {
        return getCurrentColor(textScheme === null || textScheme === void 0 ? void 0 : textScheme.selectedColor, textScheme === null || textScheme === void 0 ? void 0 : textScheme.hoverColor, textScheme === null || textScheme === void 0 ? void 0 : textScheme.color);
    }, [
        getCurrentColor,
        textScheme === null || textScheme === void 0 ? void 0 : textScheme.selectedColor,
        textScheme === null || textScheme === void 0 ? void 0 : textScheme.hoverColor,
        textScheme === null || textScheme === void 0 ? void 0 : textScheme.color
    ]);
    var onClick = function(e) {
        blurTag(e);
        onTagSelection();
        (0,bigbrain_service.trackEvent)(bigbrain_event_types.GRID_TAG_CLICKED, {
            kind: starText,
            info1: productType
        });
        (0,gtm_service/* fireGtmEvent */.k2)((data_layer_event_types_default()).TAG_SELECTED, {
            name: starText
        });
    };
    var onTagSelection = function() {
        setWasClusterSelected(true);
        setTimeout(function() {
            return setWasClusterSelected(false);
        }, CLUSTER_CLICK_ANIMATION_TIME);
        onStarClick && onStarClick();
    };
    var tagBorderColor = (0,react.useMemo)(function() {
        if ((tagScheme === null || tagScheme === void 0 ? void 0 : tagScheme.selectedBackgroundColor) && isSelected) return colors/* default */.Z[tagScheme.selectedBackgroundColor];
        return (tagScheme === null || tagScheme === void 0 ? void 0 : tagScheme.hoverColor) && isHovered ? colors/* default */.Z[tagScheme.hoverColor] : colors/* default */.Z[tagScheme === null || tagScheme === void 0 ? void 0 : tagScheme.borderColor];
    }, [
        isHovered,
        isSelected,
        tagScheme === null || tagScheme === void 0 ? void 0 : tagScheme.borderColor,
        tagScheme === null || tagScheme === void 0 ? void 0 : tagScheme.hoverColor,
        tagScheme === null || tagScheme === void 0 ? void 0 : tagScheme.selectedBackgroundColor
    ]);
    var onMouseOver = function() {
        setIsHovered(true);
        (0,bigbrain_service.trackEvent)(bigbrain_event_types.GRID_TAG_HOVERED, {
            kind: starText
        });
    };
    var onMouseLeave = function() {
        return setIsHovered(false);
    };
    var starColor = colors/* default */.Z[tagScheme === null || tagScheme === void 0 ? void 0 : tagScheme.selectedBackgroundColor] || colors/* default */.Z[starColorName] || colors/* default */.Z[color_consts.WORK_OS_IRIS_COLOR_NAME];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledSquareTagComponent, {
        className: classnames_default()("square-tag-component", {
            selected: isSelected,
            hovered: isHovered,
            "selectable-cluster": true,
            "light-theme": !isDarkTheme,
            "cluster-selected": wasClusterSelected,
            "show-border-in-light-theme": showBorderInLightTheme
        }),
        style: {
            color: starColor,
            borderColor: tagBorderColor,
            backgroundColor: tagBackgroundColor
        },
        onMouseOver: onMouseOver,
        onMouseLeave: onMouseLeave,
        onClick: onClick,
        onKeyDown: (0,accessibility_service/* generateOnKeyDownHandler */.vR)(onTagSelection),
        tabIndex: 0,
        role: "checkbox",
        "aria-checked": isSelected,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "background-circle"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(tag_checkbox, _object_spread_props(_object_spread({}, checkboxScheme), {
                isSelected: isSelected,
                tagBorderColor: tagScheme === null || tagScheme === void 0 ? void 0 : tagScheme.borderColor
            })),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "star-image",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(picture_component/* default */.Z, {
                    className: "star-icon",
                    pictureClass: "star-picture",
                    src: starImage
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "star-text",
                style: {
                    color: tagTextColor
                },
                children: starText
            })
        ]
    });
};
/* harmony default export */ var square_tag_component = (SquareTagComponent);
SquareTagComponent.defaultProps = {
    starText: "Marketing",
    starImage: "https://dapulse-res.cloudinary.com/image/upload/remote_mondaycom_static/products/product-icons/icons_3d/Marketing_icon_circle.png",
    starColorName: "marketing-red"
};

// EXTERNAL MODULE: ./segments/desktop/core-components/square-tags/default-props.js
var default_props = __webpack_require__(62414);
;// CONCATENATED MODULE: ./segments/desktop/core-components/square-tags/square-tags.scss.js




var StyledSquareTags = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "estbk6w0"
})("margin:auto;display:flex;flex-direction:column;position:relative;align-items:center;justify-content:center;.clusters-stars{margin-top:48px;margin-bottom:56px;display:flex;.star-wrapper{width:140px;position:relative;user-select:none;max-width:170px;min-width:140px;}}.buttons-wrapper{display:flex;align-items:center;.signup-button-wrapper{transform:scale(1);button.signup-button{background-image:var(--background);color:var(--text-color);&:hover{background-image:var(--background-hover);}&:disabled{background-image:var(--background);color:var(--text-color);}}&.cluster-selected{animation:breatheOut 0.3s linear;}.sign-up-combo-with-text-underline{.sign-up-combo-wrapper{.signup-combo-buttons-button{justify-content:center;.secondary-button-wrapper{.secondary-button{.with-underline{background:unset;.secondary-button-text{padding-left:8px;}}}&:hover{.secondary-button{.with-underline{.secondary-button-text{transition:color 0.15 ease-in-out;color:", (0,general/* hexToRgba */.a7)(colors/* default */.Z[color_consts.WHITE_COLOR_NAME], 0.8), ";}svg path{transition:fill 0.15 ease-in-out;fill:", (0,general/* hexToRgba */.a7)(colors/* default */.Z[color_consts.WHITE_COLOR_NAME], 0.8), ";}}}}}}}.text-wrapper{margin-top:32px;font-size:0.8125rem;text-align:center;padding-left:3px;}}}}@keyframes breatheOut{0%{transform:scale(1);}15%{transform:scale(1.01);}20%{transform:scale(1.02);}25%{transform:scale(1.03);}32%{transform:scale(1.04);}50%{transform:scale(1.05);}68%{transform:scale(1.04);}75%{transform:scale(1.03);}80%{transform:scale(1.02);}85%{transform:scale(1.01);}100%{transform:scale(1);}}");

// EXTERNAL MODULE: ./contexts/generic-config-context.js
var generic_config_context = __webpack_require__(3156);
// EXTERNAL MODULE: ./node_modules/lodash/shuffle.js
var shuffle = __webpack_require__(69983);
var shuffle_default = /*#__PURE__*/__webpack_require__.n(shuffle);
;// CONCATENATED MODULE: ./segments/desktop/core-components/square-tags/square-tags.js

function _define_property1(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function square_tags_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property1(target, key, source[key]);
        });
    }
    return target;
}
function square_tags_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function square_tags_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        square_tags_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}




















var DARK_THEME_BUTTON_OPACITY = "cc";
var LIGHT_THEME_BUTTON_OPACITY = "ee";
var SIGNUP_BUTTON_ANIMATION_START_TIME = 100;
var SIGNUP_BUTTON_ANIMATION_END_TIME = 400;
var PRESELECTED_TAG_PARAM_NAME = "selectedTag";
var getSelectedTagsInitialState = function(clusters) {
    var initialState = {};
    clusters.forEach(function(sc) {
        return initialState[sc.text] = false;
    });
    return initialState;
};
var SquareTags = function(props) {
    var buttonConfig = props.buttonConfig, clusters = props.clusters, theme = props.theme, secondaryButtonConfig = props.secondaryButtonConfig, tagsWidth = props.tagsWidth, marginTop = props.marginTop, palette = props.palette, showBorderInLightTheme = props.showBorderInLightTheme, randomizeTags = props.randomizeTags, productType = props.productType;
    var ref = (0,react.useState)(getSelectedTagsInitialState(clusters)), selectedTags = ref[0], setSelectedTags = ref[1];
    var ref1 = (0,react.useState)(false), wasClusterSelected = ref1[0], setWasClusterSelected = ref1[1];
    var getSelectedTagFromUrl = function() {
        var selectedTagId = (0,url.getUrlParamValueFromCurrentLocation)(PRESELECTED_TAG_PARAM_NAME);
        if (!selectedTagId) return;
        var selectedTag = clusters.find(function(cluster) {
            return cluster.clusterId === selectedTagId || cluster.useCaseId === selectedTagId;
        });
        return selectedTag;
    };
    var getSelectedTagsMarkedWithInitiallySelected = function() {
        var selectedClusters = clusters.reduce(function(acc, obj) {
            if (obj.initiallySelected) {
                acc[obj.text] = true;
            }
            return acc;
        }, {});
        return selectedClusters;
    };
    var renderedClusters = (0,react.useMemo)(function() {
        return randomizeTags ? shuffle_default()(clusters) : clusters;
    }, [
        clusters,
        randomizeTags
    ]);
    (0,react.useEffect)(function() {
        var selectedTagFromUrl = getSelectedTagFromUrl() || {};
        setSelectedTags(square_tags_object_spread_props(square_tags_object_spread({}, selectedTags, getSelectedTagsMarkedWithInitiallySelected()), (0,_define_property/* default */.Z)({}, selectedTagFromUrl.text, true)));
    }, []);
    var onTagComponentClick = function(star) {
        setSelectedTags(square_tags_object_spread_props(square_tags_object_spread({}, selectedTags), (0,_define_property/* default */.Z)({}, star.text, !selectedTags[star.text])));
        setTimeout(function() {
            return setWasClusterSelected(true);
        }, SIGNUP_BUTTON_ANIMATION_START_TIME);
        setTimeout(function() {
            return setWasClusterSelected(false);
        }, SIGNUP_BUTTON_ANIMATION_END_TIME);
    };
    var renderSquareTags = function() {
        return renderedClusters === null || renderedClusters === void 0 ? void 0 : renderedClusters.map(function(cluster) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "star-wrapper",
                style: {
                    width: tagsWidth
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(square_tag_component, {
                    starText: cluster.text,
                    starImage: cluster.image,
                    tagScheme: palette === null || palette === void 0 ? void 0 : palette.tagScheme,
                    checkboxScheme: palette === null || palette === void 0 ? void 0 : palette.checkboxScheme,
                    textScheme: palette === null || palette === void 0 ? void 0 : palette.textScheme,
                    starColorName: cluster.colorName,
                    onStarClick: function() {
                        return onTagComponentClick(cluster);
                    },
                    isSelected: selectedTags[cluster === null || cluster === void 0 ? void 0 : cluster.text],
                    isSelectableMode: true,
                    isDarkTheme: isDarkTheme,
                    showBorderInLightTheme: showBorderInLightTheme,
                    productType: productType
                })
            }, cluster.text);
        });
    };
    var getSelectedClusters = function() {
        return renderedClusters.filter(function(c) {
            return selectedTags[c.text];
        });
    };
    var isAtLeastOneClusterSelected = function() {
        return Object.values(selectedTags).map(function(star) {
            return star;
        }).reduce(function(acc, s) {
            return acc || s;
        }, false);
    };
    var getButtonColorBySelectedClusters = function(isDarkTheme, isHover) {
        var _buttonColor = buttonConfig.buttonColor, buttonColor = _buttonColor === void 0 ? color_consts.GRADIANT_WORKOS_IRIS_COLOR_NAME : _buttonColor, removeGradient = buttonConfig.removeGradient;
        if (removeGradient) return colors/* default */.Z[buttonColor];
        var OPACITY_VALUE = isDarkTheme ? DARK_THEME_BUTTON_OPACITY : LIGHT_THEME_BUTTON_OPACITY;
        var selectedClusters = getSelectedClusters();
        if (!isAtLeastOneClusterSelected || selectedClusters.length === 0) {
            return isHover ? (0,colors_utils/* getHoverColor */.n)(colors/* default */.Z[buttonColor]) : colors/* default */.Z[buttonColor];
        }
        // if only 1 cluster was selected, fill the button with a gradient built of the same color
        if (selectedClusters.length === 1) {
            var colorName = selectedClusters[0].colorName;
            var color = isHover ? (0,colors_utils/* getHoverColor */.n)(colors/* default */.Z[colorName]) : colors/* default */.Z[colorName];
            return "linear-gradient(90deg, ".concat(color).concat(OPACITY_VALUE, " 0%, ").concat(color).concat(OPACITY_VALUE, " 100%)");
        }
        var colorsString = "";
        var chunkSize = 100 / (selectedClusters.length - 1);
        // building the linear gradient string
        // for example, if 3 clusters are selected, the linear gradient stop locations should be 0%, 50% and 100%
        selectedClusters.forEach(function(selectedStarsItem, index) {
            // add separator in every chunk instead of last chunk
            var separator = index === selectedClusters.length - 1 ? "" : ", ";
            var starItemColor = isHover ? (0,colors_utils/* getHoverColor */.n)(colors/* default */.Z[selectedStarsItem.colorName]) : colors/* default */.Z[selectedStarsItem.colorName];
            colorsString += "".concat(starItemColor).concat(OPACITY_VALUE, " ").concat(chunkSize * index, "%").concat(separator);
        });
        return "linear-gradient(90deg, ".concat(colorsString, ")");
    };
    var getButtonTextColor = function() {
        var buttonColor = buttonConfig.buttonColor, removeGradient = buttonConfig.removeGradient;
        if (removeGradient) {
            return buttonColor === color_consts.WHITE_COLOR_NAME ? colors/* default */.Z[color_consts.BRAND_BLACK_BACKGROUND_COLOR] : colors/* default */.Z[color_consts.WHITE_COLOR_NAME];
        }
        var selectedClusters = getSelectedClusters();
        if (buttonColor === color_consts.WHITE_COLOR_NAME && selectedClusters.length === 0) {
            return colors/* default */.Z[color_consts.SPACE_BLUE_COLOR_NAME];
        }
        return colors/* default */.Z[color_consts.WHITE_COLOR_NAME];
    };
    var saveClustersOnSignup = function() {
        var selectedClusters = getSelectedClusters();
        var clustersToUpdate = selectedClusters.map(function(cluster) {
            var clusterId = cluster.clusterId, useCaseId = cluster.useCaseId;
            var res = [];
            if (clusterId) {
                res.push({
                    clusterId: clusterId,
                    clusterType: types.CLUSTER_TYPE
                });
            }
            if (useCaseId) {
                var extraData = clusterId ? {
                    parent_cluster_id: clusterId
                } : {};
                res.push({
                    clusterId: useCaseId,
                    clusterType: types.USE_CASE_TYPE,
                    extraData: extraData
                });
            }
            return res;
        });
        var flattenedArray = clustersToUpdate.flat();
        if (flattenedArray.length > 0) {
            // fire each cluster id as an event, so filtering can be fully customized on Hotjar side
            (0,hotjar_service/* fireHotjarEvents */.no)(flattenedArray.map(function(cluster) {
                return "tag_selected_".concat(cluster.clusterType, "_").concat(cluster.clusterId);
            }));
            (0,clusters_service/* updateUserClustersListWithMultipleClusters */.aC)(flattenedArray, constants_clusters.HP_TAGS_SELECTION);
        }
    };
    var isDarkTheme = (0,react.useMemo)(function() {
        return [
            segments_service/* SPACE_BLUE_GRADIANT_THEME_ID */.I7,
            segments_service/* BRAND_DARK_COLOR_THEME_ID */.qp
        ].includes(theme) || !(0,utils_service.isEmpty)(palette);
    }, [
        palette,
        theme
    ]);
    var additionalSignUpButtonConfig = {
        beforeSubmitCallback: saveClustersOnSignup,
        displayedOnDarkTheme: isDarkTheme
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledSquareTags, {
        className: "square-tags",
        style: {
            "--background": getButtonColorBySelectedClusters(isDarkTheme),
            "--background-hover": getButtonColorBySelectedClusters(isDarkTheme, true),
            "--text-color": getButtonTextColor()
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "clusters-stars",
                role: "group",
                style: {
                    marginTop: marginTop
                },
                children: renderSquareTags()
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "buttons-wrapper",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: classnames_default()("signup-button-wrapper", {
                            "cluster-selected": wasClusterSelected
                        }),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(signup_button/* default */.Z, square_tags_object_spread({}, buttonConfig, additionalSignUpButtonConfig))
                    }),
                    secondaryButtonConfig && /*#__PURE__*/ (0,jsx_runtime.jsx)(secondary_button/* default */.Z, square_tags_object_spread({}, secondaryButtonConfig))
                ]
            })
        ]
    });
};
SquareTags.defaultProps = default_props/* default */.Z;
/* harmony default export */ var square_tags = ((0,generic_config_context/* withGenericConfig */.P)(SquareTags));


/***/ }),

/***/ 49929:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "DJ": function() { return /* binding */ titleLineHeights; },
/* harmony export */   "mo": function() { return /* binding */ titleFontSizes; },
/* harmony export */   "t_": function() { return /* binding */ titleFontSizeNumber; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(14924);
/* harmony import */ var constants_sizes__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(77869);


var _obj;
var titleFontSizeNumber = (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj, constants_sizes__WEBPACK_IMPORTED_MODULE_1__/* .XXS */ .Mp, 0.6875), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj, constants_sizes__WEBPACK_IMPORTED_MODULE_1__/* .XS_M */ .g4, 0.875), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj, constants_sizes__WEBPACK_IMPORTED_MODULE_1__/* .XS_ML */ .l$, 1), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj, constants_sizes__WEBPACK_IMPORTED_MODULE_1__/* .XS_L */ .L4, 1.125), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj, constants_sizes__WEBPACK_IMPORTED_MODULE_1__.XS, 1.375), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj, constants_sizes__WEBPACK_IMPORTED_MODULE_1__.SM, 1.75), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj, constants_sizes__WEBPACK_IMPORTED_MODULE_1__.MD, 2.25), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj, constants_sizes__WEBPACK_IMPORTED_MODULE_1__.LG, 2.75), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj, constants_sizes__WEBPACK_IMPORTED_MODULE_1__/* .LGR */ .Re, 3.375), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj, constants_sizes__WEBPACK_IMPORTED_MODULE_1__.XL, 4), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj, constants_sizes__WEBPACK_IMPORTED_MODULE_1__/* .XXL */ .T3, 4.5), _obj);
var _obj1;
var titleLineHeights = (_obj1 = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj1, constants_sizes__WEBPACK_IMPORTED_MODULE_1__/* .XXS */ .Mp, "32px"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj1, constants_sizes__WEBPACK_IMPORTED_MODULE_1__/* .XS_M */ .g4, "32px"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj1, constants_sizes__WEBPACK_IMPORTED_MODULE_1__/* .XS_ML */ .l$, "32px"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj1, constants_sizes__WEBPACK_IMPORTED_MODULE_1__/* .XS_L */ .L4, "32px"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj1, constants_sizes__WEBPACK_IMPORTED_MODULE_1__.XS, "32px"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj1, constants_sizes__WEBPACK_IMPORTED_MODULE_1__.SM, "40px"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj1, constants_sizes__WEBPACK_IMPORTED_MODULE_1__.MD, "48px"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj1, constants_sizes__WEBPACK_IMPORTED_MODULE_1__.LG, "60px"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj1, constants_sizes__WEBPACK_IMPORTED_MODULE_1__/* .LGR */ .Re, "68px"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj1, constants_sizes__WEBPACK_IMPORTED_MODULE_1__.XL, "72px"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj1, constants_sizes__WEBPACK_IMPORTED_MODULE_1__/* .XXL */ .T3, "85px"), _obj1);
var _obj2;
var titleFontSizes = (_obj2 = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj2, constants_sizes__WEBPACK_IMPORTED_MODULE_1__/* .XXS */ .Mp, "".concat(titleFontSizeNumber[constants_sizes__WEBPACK_IMPORTED_MODULE_1__/* .XXS */ .Mp], "rem")), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj2, constants_sizes__WEBPACK_IMPORTED_MODULE_1__/* .XS_M */ .g4, "".concat(titleFontSizeNumber[constants_sizes__WEBPACK_IMPORTED_MODULE_1__/* .XS_M */ .g4], "rem")), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj2, constants_sizes__WEBPACK_IMPORTED_MODULE_1__/* .XS_ML */ .l$, "".concat(titleFontSizeNumber[constants_sizes__WEBPACK_IMPORTED_MODULE_1__/* .XS_ML */ .l$], "rem")), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj2, constants_sizes__WEBPACK_IMPORTED_MODULE_1__/* .XS_L */ .L4, "".concat(titleFontSizeNumber[constants_sizes__WEBPACK_IMPORTED_MODULE_1__/* .XS_L */ .L4], "rem")), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj2, constants_sizes__WEBPACK_IMPORTED_MODULE_1__.XS, "".concat(titleFontSizeNumber[constants_sizes__WEBPACK_IMPORTED_MODULE_1__.XS], "rem")), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj2, constants_sizes__WEBPACK_IMPORTED_MODULE_1__.SM, "".concat(titleFontSizeNumber[constants_sizes__WEBPACK_IMPORTED_MODULE_1__.SM], "rem")), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj2, constants_sizes__WEBPACK_IMPORTED_MODULE_1__.MD, "".concat(titleFontSizeNumber[constants_sizes__WEBPACK_IMPORTED_MODULE_1__.MD], "rem")), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj2, constants_sizes__WEBPACK_IMPORTED_MODULE_1__.LG, "".concat(titleFontSizeNumber[constants_sizes__WEBPACK_IMPORTED_MODULE_1__.LG], "rem")), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj2, constants_sizes__WEBPACK_IMPORTED_MODULE_1__/* .LGR */ .Re, "".concat(titleFontSizeNumber[constants_sizes__WEBPACK_IMPORTED_MODULE_1__/* .LGR */ .Re], "rem")), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj2, constants_sizes__WEBPACK_IMPORTED_MODULE_1__.XL, "".concat(titleFontSizeNumber[constants_sizes__WEBPACK_IMPORTED_MODULE_1__.XL], "rem")), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj2, constants_sizes__WEBPACK_IMPORTED_MODULE_1__/* .XXL */ .T3, "".concat(titleFontSizeNumber[constants_sizes__WEBPACK_IMPORTED_MODULE_1__/* .XXL */ .T3], "rem") // 72px
), _obj2);


/***/ }),

/***/ 51261:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

/* harmony default export */ __webpack_exports__["Z"] = ({
    title: "Lorem ipsum dolor sit amet, consectetur adipiscing elit."
});


/***/ }),

/***/ 91265:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ title; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./client/components/system/monday-markup-language/monday-markup-language-component.js + 11 modules
var monday_markup_language_component = __webpack_require__(36239);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./utils/strings.js
var strings = __webpack_require__(11685);
// EXTERNAL MODULE: ./components/core/picture/picture-component.js + 3 modules
var picture_component = __webpack_require__(82305);
// EXTERNAL MODULE: ./styles/colors.js
var colors = __webpack_require__(12573);
// EXTERNAL MODULE: ./utils/react.js
var react = __webpack_require__(12783);
// EXTERNAL MODULE: ./segments/desktop/core-components/title/default-props.js
var default_props = __webpack_require__(51261);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
// EXTERNAL MODULE: ./constants/vp-sizes.js
var vp_sizes = __webpack_require__(698);
// EXTERNAL MODULE: ./constants/sizes.js
var sizes = __webpack_require__(77869);
// EXTERNAL MODULE: ./segments/desktop/core-components/title/consts.js
var consts = __webpack_require__(49929);
;// CONCATENATED MODULE: ./segments/desktop/core-components/title/title.scss.js




var StyledTitle = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e168hrcx0"
})(".core-title{font-size:2.25rem;font-weight:400;line-height:48px;word-break:break-word;&.xss{font-size:", consts/* titleFontSizes */.mo[sizes/* XXS */.Mp], ";line-height:32px;font-weight:400;}&.xs_m{font-size:", consts/* titleFontSizes */.mo[sizes/* XS_M */.g4], ";line-height:32px;font-weight:400;}&.xs_ml{font-size:", consts/* titleFontSizes */.mo[sizes/* XS_ML */.l$], ";line-height:32px;font-weight:400;}&.xs_l{font-size:", consts/* titleFontSizes */.mo[sizes/* XS_L */.L4], ";line-height:32px;font-weight:400;}&.xs{font-size:", consts/* titleFontSizes */.mo[sizes.XS], ";line-height:32px;font-weight:400;}&.sm{font-size:", consts/* titleFontSizes */.mo[sizes.SM], ";line-height:40px;font-weight:400;}&.md{font-size:", consts/* titleFontSizes */.mo[sizes.MD], ";line-height:48px;font-weight:400;}&.lg{font-size:", consts/* titleFontSizes */.mo[sizes.LG], ";line-height:60px;font-weight:700;}&.lgr{font-size:", consts/* titleFontSizes */.mo[sizes/* LGR */.Re], ";line-height:68px;font-weight:700;}&.xl{font-size:", consts/* titleFontSizes */.mo[sizes.XL], ";line-height:72px;font-weight:700;}&.xxl{font-size:", consts/* titleFontSizes */.mo[sizes/* XXL */.T3], ";line-height:85px;font-weight:700;}}.title-and-icon-wrapper{display:flex;.icon-wrapper{margin-right:14px;display:flex;align-items:center;.picture-icon-wrapper{display:flex;height:32px;.title-icon{height:100%;}}&.xss{.picture-icon-wrapper{height:8px;}}&.xs_m{.picture-icon-wrapper{height:12px;}}&.xs{.picture-icon-wrapper{height:18px;}}&.sm{.picture-icon-wrapper{height:24px;}}&.md{.picture-icon-wrapper{height:32px;}}&.lg{.picture-icon-wrapper{height:38px;}}&.lgr{.picture-icon-wrapper{height:44px;}}&.xl{.picture-icon-wrapper{height:56px;}}&.xxl{.picture-icon-wrapper{height:62px;}}&.lgr,&.xl,&.xxl{margin-right:20px;}}}@media (max-width:", vp_sizes/* MOBILE_QUERY_MAX_WIDTH_M */.TI, "){.core-title-container .core-title{font-size:2.25rem;line-height:48px;font-weight:400;&.md,&.lg{font-size:1.75rem;line-height:40px;font-weight:700;}&.xl,&.lgr{font-size:2.25rem;line-height:48px;font-weight:700;}&.xxl{font-size:2.75rem;line-height:48px;font-weight:700;}}.title-and-icon-wrapper{.icon-wrapper{.picture-icon-wrapper{height:32px;}&.md,&.lg,&.xl{.picture-icon-wrapper{height:24px;}}}}}");

;// CONCATENATED MODULE: ./segments/desktop/core-components/title/title.js









var Title = function(props) {
    var title = props.title, titleSize = props.titleSize, titleColor = props.titleColor, isFirstSegment = props.isFirstSegment, titleIcon = props.titleIcon, titleClassName = props.titleClassName;
    var getTitleStyle = function() {
        if (!titleColor) {
            return null;
        }
        var titleStyle = {
            color: colors/* default */.Z[titleColor]
        };
        return titleStyle;
    };
    var renderIcon = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: classnames_default()("icon-wrapper", titleSize),
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(picture_component/* default */.Z, {
                src: titleIcon,
                alt: "",
                className: "title-icon",
                pictureClass: "picture-icon-wrapper"
            })
        });
    };
    var titleAndIconWrapper = function(children) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
            className: "title-and-icon-wrapper",
            children: children
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTitle, {
        className: "core-title-container",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(react/* ConditionalWrapper */.M, {
            condition: !!titleIcon,
            wrapper: titleAndIconWrapper,
            children: [
                titleIcon && renderIcon(),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(monday_markup_language_component/* default */.Z, {
                    tagName: isFirstSegment ? "h1" : "h2",
                    className: classnames_default()("core-title", titleSize, titleClassName),
                    text: (0,strings.encloseBoldTag)(title),
                    style: getTitleStyle()
                })
            ]
        })
    });
};
Title.defaultProps = default_props/* default */.Z;
/* harmony default export */ var title = (Title);


/***/ }),

/***/ 26718:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ window_mask; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
// EXTERNAL MODULE: ./styles/colors.js
var colors = __webpack_require__(12573);
// EXTERNAL MODULE: ./segments/desktop/constants.js
var constants = __webpack_require__(73759);
// EXTERNAL MODULE: ./constants/vp-sizes.js
var vp_sizes = __webpack_require__(698);
;// CONCATENATED MODULE: ./segments/desktop/core-components/window-mask/window-mask.scss.js




var StyledWindowMask = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e8c38dm0"
})("display:flex;flex-direction:column;padding:", constants.COMPONENTS_SHADOW_PROPS.blurRadius + constants.COMPONENTS_SHADOW_PROPS.offsetY, "px\n    ", constants.COMPONENTS_SHADOW_PROPS.blurRadius + constants.COMPONENTS_SHADOW_PROPS.offsetX, "px;", constants.COMPONENTS_SHADOW_FILTER, "  .window-header{display:flex;height:15px;border-top-left-radius:8px;border-top-right-radius:8px;background:rgba(255,255,255,0.4);.circle-wrapper{display:flex;align-items:center;margin-left:8px;.circle{background:", colors/* default.white */.Z.white, ";height:5px;width:5px;border-radius:50%;margin-right:4px;}}}.content-wrapper{display:flex;flex-grow:1;}@media (max-width:", vp_sizes/* MOBILE_QUERY_MAX_WIDTH */.zD, "){padding:28px 8px;", constants.MOBILE_COMPONENTS_SHADOW_FILTER, "    .window-header{height:10px;border-top-left-radius:4px;border-top-right-radius:4px;.circle-wrapper{margin-left:4px;.circle{width:2.5px;height:2.5px;margin-right:3px;}}}img,video{border-bottom-left-radius:4px;border-bottom-right-radius:4px;}}");

;// CONCATENATED MODULE: ./segments/desktop/core-components/window-mask/default-props.js
/* harmony default export */ var default_props = ({});

;// CONCATENATED MODULE: ./segments/desktop/core-components/window-mask/window-mask.js



var WindowMask = function(props) {
    var children = props.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledWindowMask, {
        className: "window-mask",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "window-header",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "circle-wrapper",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "circle"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "circle"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "circle"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "content-wrapper",
                children: children
            })
        ]
    });
};
/* harmony default export */ var window_mask = (WindowMask);
WindowMask.defaultProps = default_props;


/***/ }),

/***/ 71021:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "K": function() { return /* binding */ MARGIN_BETWEEN_CARDS; },
/* harmony export */   "p": function() { return /* binding */ COLUMN_WIDTH; }
/* harmony export */ });
/* harmony import */ var constants_vp_sizes__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(698);

var MARGIN_BETWEEN_CARDS = 30;
var COLUMN_WIDTH = (constants_vp_sizes__WEBPACK_IMPORTED_MODULE_0__/* .MAX_DESKTOP_DYNAMIC_TEMPLATE_WIDTH */ .Ld - 5 * MARGIN_BETWEEN_CARDS) / 4;


/***/ }),

/***/ 38885:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ flexible_cards_grid_component; }
});

// EXTERNAL MODULE: ./components/enhancements/responsive-hoc/responsive-hoc-component.js + 1 modules
var responsive_hoc_component = __webpack_require__(27190);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./segments/desktop/core-components/grid-paragraph-with-image/grid-paragraph-with-image.js + 2 modules
var grid_paragraph_with_image = __webpack_require__(32627);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./segments/desktop/header/layouts/components/basic-header/constants.js
var constants = __webpack_require__(72428);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
// EXTERNAL MODULE: ./constants/vp-sizes.js
var vp_sizes = __webpack_require__(698);
// EXTERNAL MODULE: ./constants/z-index.js
var z_index = __webpack_require__(35257);
;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/flexible-cards-grid/components/flexible-cards-grid-desktop/flexible-cards-grid-desktop-component.scss.js



var StyledFlexibleCardsGridDesktopComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "evb99rm0"
})("max-width:", vp_sizes/* MAX_DESKTOP_DYNAMIC_TEMPLATE_WIDTH */.Ld, "px;height:100%;margin:auto;display:flex;flex-wrap:wrap;justify-content:var(--component-alignment);.flexible-cards-grid-desktop-component-inner{display:flex;justify-content:inherit;.grid-paragraph-with-image-component-wrapper{width:var(--flexible-grid-card-width);margin:var(--cards-margin);z-index:", z_index/* TOP_LAYER */.nA, ";position:relative;display:flex;.top-layer{width:100%;}&.has-background-paragraph{.top-layer{opacity:1;transition:opacity 0.25s ease-in-out;}.back-layer{position:absolute;opacity:0;height:100%;width:100%;transition:opacity 0.25s ease-in-out;}&:hover{.top-layer{opacity:0;}.back-layer{opacity:1;}}}.grid-paragraph-wrapper{display:flex;.full-paragraph{height:100%;}}}}");

// EXTERNAL MODULE: ./segments/desktop/core-components/grid-image-with-paragraph/grid-image-with-paragraph.js + 2 modules
var grid_image_with_paragraph = __webpack_require__(47755);
// EXTERNAL MODULE: ./constants/sizes.js
var sizes = __webpack_require__(77869);
;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/flexible-cards-grid/components/default-props.js
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}


var getGridImageWithParagraphProps = function(imageSrc, fullParagraphTitle, fullParagraphBody) {
    var fullParagraph = _object_spread_props(_object_spread({}, grid_image_with_paragraph/* default.defaultProps.fullParagraph */.Z.defaultProps.fullParagraph), {
        title: fullParagraphTitle,
        body: fullParagraphBody
    });
    return _object_spread_props(_object_spread({}, grid_image_with_paragraph/* default.defaultProps */.Z.defaultProps), {
        src: imageSrc,
        mobileImage: {
            src: imageSrc
        },
        fullParagraph: fullParagraph,
        cardNumOfColumnsWidth: 1
    });
};
/* harmony default export */ var default_props = ({
    shadowCards: true,
    removeShadowOnHover: false,
    gridAlignment: "center",
    gridItems: [
        getGridImageWithParagraphProps("https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/Grid/small-placeholder-image.png", "Cross-functional collab blog", "Look at your data differently with multiple View options from Calendar to Map."),
        getGridImageWithParagraphProps("https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/Grid/small-placeholder-image.png", "Relevant story/video", "Automate repetitive tasks and have more time for the work that motivates you."),
        getGridImageWithParagraphProps("https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/Grid/small-placeholder-image.png", "Productivity blog or marketing blog", "Get a high-level overview at a glance and make smarter decisions, faster."),
        getGridImageWithParagraphProps("https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/Grid/small-placeholder-image.png", "Productivity blog or marketing blog", "Get a high-level overview at a glance and make smarter decisions, faster.")
    ],
    paddingTop: "64px",
    paddingBottom: "64px",
    titleSize: sizes.XS,
    textSize: sizes.MD
});

// EXTERNAL MODULE: ./segments/desktop/grid/layouts/flexible-cards-grid/flexible-cards-consts.js
var flexible_cards_consts = __webpack_require__(71021);
// EXTERNAL MODULE: ./client/services/accessibility/accessibility-service.js
var accessibility_service = __webpack_require__(60696);
// EXTERNAL MODULE: ./services/bigbrain-service.js
var bigbrain_service = __webpack_require__(65488);
// EXTERNAL MODULE: ./constants/bigbrain-event-types.js
var bigbrain_event_types = __webpack_require__(65023);
;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/flexible-cards-grid/components/flexible-cards-grid-desktop/flexible-cards-grid-desktop-component.js
function flexible_cards_grid_desktop_component_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function flexible_cards_grid_desktop_component_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            flexible_cards_grid_desktop_component_define_property(target, key, source[key]);
        });
    }
    return target;
}
function flexible_cards_grid_desktop_component_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function flexible_cards_grid_desktop_component_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        flexible_cards_grid_desktop_component_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}










var IMAGE_HEIGHT = "100%";
var IMAGE_WIDTH = "100%";
var margin = "".concat(flexible_cards_consts/* MARGIN_BETWEEN_CARDS */.K / 2, "px");
var FlexibleCardsGridDesktopComponent = function(props) {
    var renderGridItems = function() {
        var shadowCards = props.shadowCards, removeShadowOnHover = props.removeShadowOnHover, gridItems = props.gridItems, titleSize = props.titleSize, textSize = props.textSize, topicBottomMargin = props.topicBottomMargin, spaceFromParagraph = props.spaceFromParagraph, buttonTopMargin = props.buttonTopMargin, innerPadding = props.innerPadding, defaultCardClick = props.defaultCardClick, borderColor = props.borderColor;
        return gridItems.map(function(gridItem, index) {
            var textColor = gridItem.textColor, cardColor = gridItem.cardColor, backgroundImage = gridItem.backgroundImage, cardNumOfColumnsWidth = gridItem.cardNumOfColumnsWidth, fullParagraph = gridItem.fullParagraph, addBackLayerContent = gridItem.addBackLayerContent, cardBackLayerContent = gridItem.cardBackLayerContent, cardTagText = gridItem.cardTagText, cardTagColor = gridItem.cardTagColor, paragraphVerticalColoredLineColor = gridItem.paragraphVerticalColoredLineColor, onCardClick = gridItem.onCardClick, resImageProps = _object_without_properties(gridItem, [
                "textColor",
                "cardColor",
                "backgroundImage",
                "cardNumOfColumnsWidth",
                "fullParagraph",
                "addBackLayerContent",
                "cardBackLayerContent",
                "cardTagText",
                "cardTagColor",
                "paragraphVerticalColoredLineColor",
                "onCardClick"
            ]);
            var flexibleCardHovered = function() {
                (0,bigbrain_service.trackEvent)(bigbrain_event_types.FLEXIBLE_GRID_CARD_HOVERED, {
                    kind: (fullParagraph === null || fullParagraph === void 0 ? void 0 : fullParagraph.title) || (fullParagraph === null || fullParagraph === void 0 ? void 0 : fullParagraph.body)
                });
            };
            var columnWidthForCss = "".concat(flexible_cards_consts/* COLUMN_WIDTH */.p, "px");
            var cardWidthForCss;
            if (cardNumOfColumnsWidth) {
                var cardWidth = cardNumOfColumnsWidth * flexible_cards_consts/* COLUMN_WIDTH */.p + (cardNumOfColumnsWidth - 1) * flexible_cards_consts/* MARGIN_BETWEEN_CARDS */.K;
                cardWidthForCss = "".concat(cardWidth, "px");
            }
            var onClickCallBack = onCardClick || defaultCardClick;
            var isCardClickable = onClickCallBack;
            var onKeyDown = isCardClickable ? (0,accessibility_service/* generateOnKeyDownHandler */.vR)(onClickCallBack) : null;
            var cardAccesibilityProps = isCardClickable ? {
                onKeyDown: onKeyDown,
                tabIndex: 0
            } : {};
            var layersSharedProps = {
                topicBottomMargin: topicBottomMargin,
                spaceFromParagraph: spaceFromParagraph,
                buttonTopMargin: buttonTopMargin
            };
            var fullParagraphFullProps = flexible_cards_grid_desktop_component_object_spread({}, layersSharedProps, fullParagraph);
            var backLayerparagraphProps = flexible_cards_grid_desktop_component_object_spread({}, layersSharedProps, cardBackLayerContent === null || cardBackLayerContent === void 0 ? void 0 : cardBackLayerContent.backLayerFullParagraph);
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", flexible_cards_grid_desktop_component_object_spread_props(flexible_cards_grid_desktop_component_object_spread({
                className: classnames_default()("grid-paragraph-with-image-component-wrapper", {
                    "has-background-paragraph": addBackLayerContent
                }),
                style: {
                    "--flexible-grid-card-width": cardWidthForCss || columnWidthForCss,
                    "--cards-margin": margin
                },
                onClick: onClickCallBack
            }, cardAccesibilityProps), {
                role: "listitem",
                onMouseEnter: flexibleCardHovered,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "top-layer",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(grid_paragraph_with_image/* default */.Z, flexible_cards_grid_desktop_component_object_spread_props(flexible_cards_grid_desktop_component_object_spread({}, resImageProps), {
                            borderColor: borderColor,
                            fullParagraph: fullParagraphFullProps,
                            width: IMAGE_WIDTH,
                            height: IMAGE_HEIGHT,
                            titleSize: titleSize,
                            textSize: textSize,
                            cardColor: cardColor,
                            textColor: textColor,
                            shadowCards: shadowCards,
                            removeShadowOnHover: removeShadowOnHover,
                            cardWidthForCss: cardWidthForCss,
                            backgroundImage: backgroundImage,
                            cardTagText: cardTagText,
                            cardTagColor: cardTagColor,
                            paragraphVerticalColoredLineColor: paragraphVerticalColoredLineColor,
                            padding: innerPadding
                        }))
                    }),
                    addBackLayerContent && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "back-layer",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(grid_paragraph_with_image/* default */.Z, {
                            fullParagraph: backLayerparagraphProps,
                            width: IMAGE_WIDTH,
                            height: IMAGE_HEIGHT,
                            titleSize: titleSize,
                            textSize: textSize,
                            cardColor: cardColor,
                            textColor: textColor,
                            shadowCards: shadowCards,
                            borderColor: borderColor,
                            removeShadowOnHover: removeShadowOnHover,
                            cardWidthForCss: cardWidthForCss,
                            contentVerticalAlignment: cardBackLayerContent === null || cardBackLayerContent === void 0 ? void 0 : cardBackLayerContent.contentVerticalAlignment,
                            padding: innerPadding,
                            backgroundImage: cardBackLayerContent === null || cardBackLayerContent === void 0 ? void 0 : cardBackLayerContent.backSideBackgroundImage
                        })
                    })
                ]
            }), index);
        });
    };
    var gridAlignment = props.gridAlignment;
    var componentWidthWithoutHeaderPadding = "calc(100% - ".concat(constants/* default.HEADER_CONTENT_HORIZONTAL_PADDING */.Z.HEADER_CONTENT_HORIZONTAL_PADDING * 2 - flexible_cards_consts/* MARGIN_BETWEEN_CARDS */.K, "px)");
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledFlexibleCardsGridDesktopComponent, {
        className: "flexible-cards-grid-desktop-component",
        style: {
            "--component-alignment": gridAlignment
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "flexible-cards-grid-desktop-component-inner",
            style: {
                width: componentWidthWithoutHeaderPadding
            },
            role: "list",
            children: renderGridItems()
        })
    });
};
FlexibleCardsGridDesktopComponent.defaultProps = default_props;
/* harmony default export */ var flexible_cards_grid_desktop_component = (FlexibleCardsGridDesktopComponent);

// EXTERNAL MODULE: ./node_modules/styled-jsx/style.js
var style = __webpack_require__(60357);
var style_default = /*#__PURE__*/__webpack_require__.n(style);
// EXTERNAL MODULE: ./segments/desktop/core-components/carousel/carousel.js + 3 modules
var carousel = __webpack_require__(28391);
;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/flexible-cards-grid/components/flexible-cards-grid-mobile/flexible-cards-grid-mobile-component.scss.js
var componentStyles = new String(".flexible-cards-grid-mobile-component{.carousel-wrapper{margin-top:30px;width:auto;&.no-margin{margin-top:0px}.carousel{.slick-slider{.slick-dots{bottom:0px}}.grid-paragraph-with-image-component-wrapper{overflow:hidden;-webkit-border-radius:8px;-moz-border-radius:8px;border-radius:8px;padding:25px 20px;display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-webkit-flex-direction:column;-moz-box-orient:vertical;-moz-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center;width:100%;.grid-paragraph-with-image{.grid-paragraph-wrapper{padding-right:20px;padding-left:20px;.full-paragraph{.full-paragraph-topic{font-size:.6875rem;margin-bottom:8px}.title-wrapper{font-size:.875rem;margin-bottom:10px}.paragraph-body-wrapper{.paragraph-wrapper .paragraph-body{font-size:.8125rem;line-height:24px}}}}}}}}}");
componentStyles.__hash = "f0260ba55678d501";

;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/flexible-cards-grid/components/flexible-cards-grid-mobile/flexible-cards-grid-mobile-component.js
function flexible_cards_grid_mobile_component_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function flexible_cards_grid_mobile_component_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            flexible_cards_grid_mobile_component_define_property(target, key, source[key]);
        });
    }
    return target;
}
function flexible_cards_grid_mobile_component_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function flexible_cards_grid_mobile_component_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        flexible_cards_grid_mobile_component_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}






var FlexibleCardsGridMobileComponent = function(props) {
    var gridItems = props.gridItems, titleSize = props.titleSize, textSize = props.textSize, shadowCards = props.shadowCards, removeShadowOnHover = props.removeShadowOnHover, cancelMobileMarginTop = props.cancelMobileMarginTop;
    var itemRenderer = function(gridItem) {
        var mobileImage = gridItem.mobileImage, textColor = gridItem.textColor, cardColor = gridItem.cardColor, fullParagraph = gridItem.fullParagraph, footer = gridItem.footer;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "grid-paragraph-with-image-component-wrapper",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(grid_paragraph_with_image/* default */.Z, flexible_cards_grid_mobile_component_object_spread_props(flexible_cards_grid_mobile_component_object_spread({}, mobileImage), {
                fullParagraph: fullParagraph,
                width: "100%",
                height: "auto",
                titleSize: titleSize,
                textSize: textSize,
                cardColor: cardColor,
                textColor: textColor,
                shadowCards: shadowCards,
                removeShadowOnHover: removeShadowOnHover,
                footer: footer
            }))
        });
    };
    var carouselProps = {
        items: gridItems,
        itemRenderer: itemRenderer,
        defaultIndex: 0,
        infinite: false,
        slidesToShow: 1,
        dots: true,
        centerPadding: "10%",
        focusAfterSwipe: true
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "jsx-".concat(componentStyles.__hash) + " " + "flexible-cards-grid-mobile-component",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "jsx-".concat(componentStyles.__hash) + " " + (classnames_default()("carousel-wrapper", {
                    "no-margin": cancelMobileMarginTop
                }) || ""),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(carousel/* default */.Z, flexible_cards_grid_mobile_component_object_spread({}, carouselProps))
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)((style_default()), {
                id: componentStyles.__hash,
                children: componentStyles
            })
        ]
    });
};
/* harmony default export */ var flexible_cards_grid_mobile_component = (FlexibleCardsGridMobileComponent);

;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/flexible-cards-grid/flexible-cards-grid-component.js




var FlexibleCardGridComponent = (0,responsive_hoc_component/* default */.Z)(flexible_cards_grid_desktop_component, flexible_cards_grid_mobile_component);
/* harmony default export */ var flexible_cards_grid_component = (FlexibleCardGridComponent);
FlexibleCardGridComponent.defaultProps = default_props;


/***/ }),

/***/ 33054:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "xN": function() { return /* binding */ CUSTOMERS_MENU_ID; },
  "Nl": function() { return /* binding */ DESKTOP_HEADER_BASE_CLASS_NAME; },
  "Qc": function() { return /* binding */ FEATURES_MENU_ID; },
  "Yp": function() { return /* binding */ ICON_TYPES; },
  "wP": function() { return /* binding */ PLATFORM_MENU_ID; },
  "VG": function() { return /* binding */ PRODUCTS_MENU_ID; },
  "Gu": function() { return /* binding */ RESOURCES_MENU_ID; },
  "e1": function() { return /* binding */ SOLUTIONS_MENU_ID; },
  "tS": function() { return /* binding */ SectionsHeadersMenuItemsMapping; },
  "jm": function() { return /* binding */ StructuredHeaderMenuComponentMapping; },
  "M2": function() { return /* binding */ StructuredHeaderMenuMapping; },
  "qq": function() { return /* binding */ TAG_TYPES; },
  "$Q": function() { return /* binding */ TEAMS_MENU_ID; },
  "sI": function() { return /* binding */ USE_CASES_MENU_ID; },
  "EH": function() { return /* binding */ isDesktopMinisiteSecondaryMenuActive; },
  "VK": function() { return /* binding */ mobileProductsSectionMenuItems; },
  "Y0": function() { return /* binding */ shouldRenderSecondaryMenu; }
});

// UNUSED EXPORTS: ADD_ONS_SECTION_ID, BY_BUSINESS_SIZE_SECTION_ID, BY_INDUSTRY_SECTION_ID, BY_TEAM_SECTION_ID, CRM_SECTION_ID, DEV_SECTION_ID, GET_INVOLVED_SECTION_ID, INTEGRATIONS_SECTION_ID, KEY_FEATURES_SECTION_ID, LEADING_COMPANIES_SECTION_ID, MENU_SECTION_CLASSNAMES, MENU_SECTION_ITEM_TYPE, PRODUCTS_MORE_SECTION_ID, PRODUCTS_PRODUCTS_SECTION_ID, RESOURCES_BUILD_SECTION_ID, RESOURCES_CONNECT_SECTION_ID, RESOURCES_EXPLORE_SECTION_ID, RESOURCES_LEARN_SECTION_ID, SERVICE_SECTION_ID, TOP_STORIES_SECTION_ID, WORK_MANAGEMENT_SECTION_ID

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./static/svg/header/workcanvas_colored.svg
var _g, _defs;
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}

var SvgWorkcanvasColored = function SvgWorkcanvasColored(props) {
    return /*#__PURE__*/ react.createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        fill: "none",
        viewBox: "0 0 20 20"
    }, props), _g || (_g = /*#__PURE__*/ react.createElement("g", {
        clipPath: "url(#clip0_10556_100)"
    }, /*#__PURE__*/ react.createElement("path", {
        fill: "#fff",
        d: "M1.936 1.953h16.128v16.282H1.936z"
    }), /*#__PURE__*/ react.createElement("path", {
        fill: "#113357",
        fillRule: "evenodd",
        d: "M17.195 2.831H2.805v14.526h14.39zM1.936 1.953v16.282h16.128V1.953z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ react.createElement("path", {
        fill: "#fff",
        d: "M15.484 0H20v4.559h-4.516z"
    }), /*#__PURE__*/ react.createElement("path", {
        fill: "#113357",
        fillRule: "evenodd",
        d: "M19.13.878h-2.776V3.68h2.776zM15.484 0v4.559H20V0z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ react.createElement("path", {
        fill: "#fff",
        d: "M0 0h4.516v4.559H0z"
    }), /*#__PURE__*/ react.createElement("path", {
        fill: "#113357",
        fillRule: "evenodd",
        d: "M3.646.878H.87V3.68h2.776zM0 0v4.559h4.516V0z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ react.createElement("path", {
        fill: "#fff",
        d: "M15.484 15.441H20V20h-4.516z"
    }), /*#__PURE__*/ react.createElement("path", {
        fill: "#113357",
        fillRule: "evenodd",
        d: "M19.13 16.319h-2.776v2.803h2.776zm-3.646-.878V20H20v-4.559z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ react.createElement("path", {
        fill: "#fff",
        d: "M0 15.441h4.516V20H0z"
    }), /*#__PURE__*/ react.createElement("path", {
        fill: "#113357",
        fillRule: "evenodd",
        d: "M3.646 16.319H.87v2.803h2.776zM0 15.44V20h4.516v-4.559z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ react.createElement("path", {
        fill: "#113357",
        d: "M10.208 14.694q-1.111 0-1.94-.363a4 4 0 0 1-1.362-1.011 4.2 4.2 0 0 1-.814-1.422 5.3 5.3 0 0 1-.266-1.66v-.3q0-.885.282-1.69a4.4 4.4 0 0 1 .83-1.454 3.85 3.85 0 0 1 1.36-.995q.83-.363 1.895-.363 1.158 0 2.05.458.893.442 1.424 1.248.532.805.595 1.849h-2.457a1.55 1.55 0 0 0-.47-.98q-.391-.41-1.142-.41-.626 0-1.05.315-.405.315-.61.87-.203.552-.203 1.31 0 .695.188 1.265a1.8 1.8 0 0 0 .595.869q.422.3 1.095.3.501 0 .845-.174.36-.19.564-.506a1.7 1.7 0 0 0 .266-.758h2.442q-.048 1.074-.595 1.896a3.8 3.8 0 0 1-1.456 1.264q-.908.442-2.066.442"
    }))), _defs || (_defs = /*#__PURE__*/ react.createElement("defs", null, /*#__PURE__*/ react.createElement("clipPath", {
        id: "clip0_10556_100"
    }, /*#__PURE__*/ react.createElement("path", {
        fill: "#fff",
        d: "M0 0h20v20H0z"
    })))));
};
/* harmony default export */ var workcanvas_colored = (SvgWorkcanvasColored);

;// CONCATENATED MODULE: ./static/svg/header/workforms_colored.svg
var _path, _path2, workforms_colored_defs;
function workforms_colored_extends() {
    workforms_colored_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return workforms_colored_extends.apply(this, arguments);
}

var SvgWorkformsColored = function SvgWorkformsColored(props) {
    return /*#__PURE__*/ react.createElement("svg", workforms_colored_extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 15,
        height: 20,
        fill: "none",
        viewBox: "0 0 15 20"
    }, props), _path || (_path = /*#__PURE__*/ react.createElement("path", {
        fill: "url(#paint0_linear_642_352343)",
        fillRule: "evenodd",
        d: "M2.885 0a2.885 2.885 0 0 0 0 5.77h9.23a2.885 2.885 0 0 0 0-5.77zm0 6.92a2.885 2.885 0 0 0 0 5.77h5.192a2.885 2.885 0 0 0 0-5.77z",
        clipRule: "evenodd"
    })), _path2 || (_path2 = /*#__PURE__*/ react.createElement("path", {
        fill: "url(#paint1_linear_642_352343)",
        fillRule: "evenodd",
        d: "M5.77 2.885a2.885 2.885 0 1 1-5.77 0 2.885 2.885 0 0 1 5.77 0m0 6.92a2.885 2.885 0 1 1-5.77 0 2.885 2.885 0 0 1 5.77 0m-2.885 9.81a2.885 2.885 0 1 0 0-5.77 2.885 2.885 0 0 0 0 5.77",
        clipRule: "evenodd"
    })), workforms_colored_defs || (workforms_colored_defs = /*#__PURE__*/ react.createElement("defs", null, /*#__PURE__*/ react.createElement("linearGradient", {
        id: "paint0_linear_642_352343",
        x1: -5.192,
        x2: 1.082,
        y1: -4.326,
        y2: 18.73,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ react.createElement("stop", {
        stopColor: "#DE0B76"
    }), /*#__PURE__*/ react.createElement("stop", {
        offset: 1,
        stopColor: "#F58A25",
        stopOpacity: 0
    })), /*#__PURE__*/ react.createElement("linearGradient", {
        id: "paint1_linear_642_352343",
        x1: 2.308,
        x2: 16.418,
        y1: -1.154,
        y2: 21.548,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ react.createElement("stop", {
        stopColor: "#C21E71"
    }), /*#__PURE__*/ react.createElement("stop", {
        offset: 1,
        stopColor: "#DE5948",
        stopOpacity: 0.457
    })))));
};
/* harmony default export */ var workforms_colored = (SvgWorkformsColored);

;// CONCATENATED MODULE: ./static/svg/header/marketing_colored.svg
var marketing_colored_path, marketing_colored_path2;
function marketing_colored_extends() {
    marketing_colored_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return marketing_colored_extends.apply(this, arguments);
}

var SvgMarketingColored = function SvgMarketingColored(props) {
    return /*#__PURE__*/ react.createElement("svg", marketing_colored_extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 28,
        height: 28,
        fill: "none",
        viewBox: "0 0 28 28"
    }, props), marketing_colored_path || (marketing_colored_path = /*#__PURE__*/ react.createElement("path", {
        stroke: "#000",
        strokeLinecap: "round",
        strokeWidth: 2.5,
        d: "M1.25-1.25h2.707",
        transform: "matrix(.34684 .93793 -.95008 .312 10.22 17.544)"
    })), marketing_colored_path2 || (marketing_colored_path2 = /*#__PURE__*/ react.createElement("path", {
        stroke: "#000",
        strokeLinejoin: "round",
        strokeWidth: 2.5,
        d: "M7.942 17.543 7 14.435 18.306 6l3.062 10.729z"
    })));
};
/* harmony default export */ var marketing_colored = (SvgMarketingColored);

;// CONCATENATED MODULE: ./static/svg/header/dev_colored.svg
var dev_colored_path;
function dev_colored_extends() {
    dev_colored_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return dev_colored_extends.apply(this, arguments);
}

var SvgDevColored = function SvgDevColored(props) {
    return /*#__PURE__*/ react.createElement("svg", dev_colored_extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 28,
        height: 28,
        fill: "none",
        viewBox: "0 0 28 28"
    }, props), dev_colored_path || (dev_colored_path = /*#__PURE__*/ react.createElement("path", {
        stroke: "#000",
        strokeLinecap: "round",
        strokeWidth: 2.175,
        d: "m10.835 8.999-4.834 4.826M10.897 18.688l-4.834-4.826M16.914 8.999l4.833 4.826M16.851 18.688l4.834-4.826"
    })));
};
/* harmony default export */ var dev_colored = (SvgDevColored);

;// CONCATENATED MODULE: ./static/svg/header/it_colored_1.svg
var it_colored_1_path;
function it_colored_1_extends() {
    it_colored_1_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return it_colored_1_extends.apply(this, arguments);
}

var SvgItColored1 = function SvgItColored1(props) {
    return /*#__PURE__*/ react.createElement("svg", it_colored_1_extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 28,
        height: 28,
        fill: "none",
        viewBox: "0 0 28 28"
    }, props), it_colored_1_path || (it_colored_1_path = /*#__PURE__*/ react.createElement("path", {
        stroke: "#000",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M6 19h15M21 10H6M19 8v4M10 17v4"
    })));
};
/* harmony default export */ var it_colored_1 = (SvgItColored1);

;// CONCATENATED MODULE: ./static/svg/header/operations_colored.svg
var _circle, _circle2;
function operations_colored_extends() {
    operations_colored_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return operations_colored_extends.apply(this, arguments);
}

var SvgOperationsColored = function SvgOperationsColored(props) {
    return /*#__PURE__*/ react.createElement("svg", operations_colored_extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 28,
        height: 28,
        fill: "none",
        viewBox: "0 0 28 28"
    }, props), _circle || (_circle = /*#__PURE__*/ react.createElement("circle", {
        cx: 14,
        cy: 15,
        r: 6,
        stroke: "#000",
        strokeWidth: 2
    })), _circle2 || (_circle2 = /*#__PURE__*/ react.createElement("circle", {
        cx: 14,
        cy: 15,
        r: 2.1,
        stroke: "#000",
        strokeWidth: 1.8
    })));
};
/* harmony default export */ var operations_colored = (SvgOperationsColored);

;// CONCATENATED MODULE: ./static/svg/header/pmo_colored.svg
var pmo_colored_path;
function pmo_colored_extends() {
    pmo_colored_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return pmo_colored_extends.apply(this, arguments);
}

var SvgPmoColored = function SvgPmoColored(props) {
    return /*#__PURE__*/ react.createElement("svg", pmo_colored_extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 28,
        height: 28,
        fill: "none",
        viewBox: "0 0 28 28"
    }, props), pmo_colored_path || (pmo_colored_path = /*#__PURE__*/ react.createElement("path", {
        stroke: "#000",
        strokeLinecap: "round",
        strokeWidth: 2.5,
        d: "M7.434 7.401h8.922M11.444 14.302h8.923M7.25 21.203h8.923"
    })));
};
/* harmony default export */ var pmo_colored = (SvgPmoColored);

;// CONCATENATED MODULE: ./static/svg/header/sales_colored_1.svg
var sales_colored_1_path;
function sales_colored_1_extends() {
    sales_colored_1_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return sales_colored_1_extends.apply(this, arguments);
}

var SvgSalesColored1 = function SvgSalesColored1(props) {
    return /*#__PURE__*/ react.createElement("svg", sales_colored_1_extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 28,
        height: 28,
        fill: "none",
        viewBox: "0 0 28 28"
    }, props), sales_colored_1_path || (sales_colored_1_path = /*#__PURE__*/ react.createElement("path", {
        stroke: "#000",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2.5,
        d: "M5 20.5 9.5 15l5 3 6-10m0 0L15 9.5M20.5 8l1.5 5"
    })));
};
/* harmony default export */ var sales_colored_1 = (SvgSalesColored1);

;// CONCATENATED MODULE: ./static/svg/header/hr_colored_1.svg
var hr_colored_1_path;
function hr_colored_1_extends() {
    hr_colored_1_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return hr_colored_1_extends.apply(this, arguments);
}

var SvgHrColored1 = function SvgHrColored1(props) {
    return /*#__PURE__*/ react.createElement("svg", hr_colored_1_extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 28,
        height: 28,
        fill: "none",
        viewBox: "0 0 28 28"
    }, props), hr_colored_1_path || (hr_colored_1_path = /*#__PURE__*/ react.createElement("path", {
        stroke: "#000",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2.5,
        d: "M18 22v-9M10 22v-9M18 8V7M10 8V7"
    })));
};
/* harmony default export */ var hr_colored_1 = (SvgHrColored1);

;// CONCATENATED MODULE: ./static/svg/header/enterprise_colored_1.svg
var enterprise_colored_1_path;
function enterprise_colored_1_extends() {
    enterprise_colored_1_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return enterprise_colored_1_extends.apply(this, arguments);
}

var SvgEnterpriseColored1 = function SvgEnterpriseColored1(props) {
    return /*#__PURE__*/ react.createElement("svg", enterprise_colored_1_extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 28,
        height: 28,
        fill: "none",
        viewBox: "0 0 28 28"
    }, props), enterprise_colored_1_path || (enterprise_colored_1_path = /*#__PURE__*/ react.createElement("path", {
        stroke: "#000",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeMiterlimit: 10,
        strokeWidth: 1.5,
        d: "M2.857 25.143h22.286M18.434 6.733h-8.72v18.41h8.72zM23.019 15.453h-3.876v9.69h3.876zM9.304 15.453H5.43v9.69h3.875zM15.714 3.714h-3.428v2.572h3.428zM14 3.714V2M14.857 10.571h-1.714M14.857 14h-1.714M14.857 17.429h-1.714"
    })));
};
/* harmony default export */ var enterprise_colored_1 = (SvgEnterpriseColored1);

;// CONCATENATED MODULE: ./static/svg/header/retail_colored.svg
var retail_colored_g, retail_colored_defs;
function retail_colored_extends() {
    retail_colored_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return retail_colored_extends.apply(this, arguments);
}

var SvgRetailColored = function SvgRetailColored(props) {
    return /*#__PURE__*/ react.createElement("svg", retail_colored_extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        fill: "none",
        viewBox: "0 0 20 20"
    }, props), retail_colored_g || (retail_colored_g = /*#__PURE__*/ react.createElement("g", {
        stroke: "#6161FF",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 1.5,
        clipPath: "url(#clip0_878_1279)"
    }, /*#__PURE__*/ react.createElement("path", {
        d: "M2.143 12.143v6.429a.715.715 0 0 0 .714.714h14.286a.715.715 0 0 0 .714-.715v-6.428M11.428 12.143v7.143M2.143 14.286h9.285M.714 5.714l2.143-5h14.286l2.143 5zM6.828 5.714v1.429A2.857 2.857 0 0 1 3.971 10h-.4A2.857 2.857 0 0 1 .714 7.143V5.714"
    }), /*#__PURE__*/ react.createElement("path", {
        d: "M13.214 5.714v1.429A2.857 2.857 0 0 1 10.357 10h-.715a2.857 2.857 0 0 1-2.857-2.857V5.714M19.286 5.714v1.429A2.857 2.857 0 0 1 16.428 10h-.357a2.857 2.857 0 0 1-2.857-2.857V5.714"
    }))), retail_colored_defs || (retail_colored_defs = /*#__PURE__*/ react.createElement("defs", null, /*#__PURE__*/ react.createElement("clipPath", {
        id: "clip0_878_1279"
    }, /*#__PURE__*/ react.createElement("path", {
        fill: "#fff",
        d: "M0 0h20v20H0z"
    })))));
};
/* harmony default export */ var retail_colored = (SvgRetailColored);

;// CONCATENATED MODULE: ./static/svg/header/construction_colored.svg
var construction_colored_path;
function construction_colored_extends() {
    construction_colored_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return construction_colored_extends.apply(this, arguments);
}

var SvgConstructionColored = function SvgConstructionColored(props) {
    return /*#__PURE__*/ react.createElement("svg", construction_colored_extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 22,
        height: 22,
        fill: "none",
        viewBox: "0 0 22 22"
    }, props), construction_colored_path || (construction_colored_path = /*#__PURE__*/ react.createElement("path", {
        stroke: "#6161FF",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeMiterlimit: 10,
        strokeWidth: 1.5,
        d: "M18.394 21c-1.091-3.152-4.121-5.455-7.636-5.455C7.242 15.545 4.09 17.848 3 21M10.636 4.636V1M3.97 8.152h13.333M5.667 9.485c.12 2.667 2.303 4.848 4.97 4.848 2.787 0 4.969-2.181 4.969-4.97V7.183c0-2.788-2.182-4.97-4.97-4.97-2.666 0-4.848 2.182-4.97 4.849z"
    })));
};
/* harmony default export */ var construction_colored = (SvgConstructionColored);

;// CONCATENATED MODULE: ./static/svg/header/media_colored.svg
var media_colored_g, media_colored_defs;
function media_colored_extends() {
    media_colored_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return media_colored_extends.apply(this, arguments);
}

var SvgMediaColored = function SvgMediaColored(props) {
    return /*#__PURE__*/ react.createElement("svg", media_colored_extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        fill: "none",
        viewBox: "0 0 20 20"
    }, props), media_colored_g || (media_colored_g = /*#__PURE__*/ react.createElement("g", {
        stroke: "#6161FF",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 1.5,
        clipPath: "url(#clip0_878_1292)"
    }, /*#__PURE__*/ react.createElement("path", {
        d: "M5 9.286A4.286 4.286 0 1 0 5 .714a4.286 4.286 0 0 0 0 8.572M15 9.286a2.857 2.857 0 1 0 0-5.714 2.857 2.857 0 0 0 0 5.714M14.286 12.857H6.429c-.79 0-1.429.64-1.429 1.429v3.571c0 .79.64 1.429 1.429 1.429h7.857c.789 0 1.428-.64 1.428-1.429v-3.571c0-.79-.64-1.429-1.428-1.429M19.286 14.286v3.571"
    }))), media_colored_defs || (media_colored_defs = /*#__PURE__*/ react.createElement("defs", null, /*#__PURE__*/ react.createElement("clipPath", {
        id: "clip0_878_1292"
    }, /*#__PURE__*/ react.createElement("path", {
        fill: "#fff",
        d: "M0 0h20v20H0z"
    })))));
};
/* harmony default export */ var media_colored = (SvgMediaColored);

;// CONCATENATED MODULE: ./static/svg/header/small_business_colored_1.svg
var small_business_colored_1_path, small_business_colored_1_path2;
function small_business_colored_1_extends() {
    small_business_colored_1_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return small_business_colored_1_extends.apply(this, arguments);
}

var SvgSmallBusinessColored1 = function SvgSmallBusinessColored1(props) {
    return /*#__PURE__*/ react.createElement("svg", small_business_colored_1_extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 28,
        height: 28,
        fill: "none",
        viewBox: "0 0 28 28"
    }, props), small_business_colored_1_path || (small_business_colored_1_path = /*#__PURE__*/ react.createElement("path", {
        stroke: "#000",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeMiterlimit: 10,
        strokeWidth: 1.5,
        d: "M22 6H7v16h15zM13 11h3"
    })), small_business_colored_1_path2 || (small_business_colored_1_path2 = /*#__PURE__*/ react.createElement("path", {
        stroke: "#000",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 1.5,
        d: "M12 22v-7h5v7"
    })));
};
/* harmony default export */ var small_business_colored_1 = (SvgSmallBusinessColored1);

;// CONCATENATED MODULE: ./static/svg/header/nonprofit_colored.svg
var nonprofit_colored_path;
function nonprofit_colored_extends() {
    nonprofit_colored_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return nonprofit_colored_extends.apply(this, arguments);
}

var SvgNonprofitColored = function SvgNonprofitColored(props) {
    return /*#__PURE__*/ react.createElement("svg", nonprofit_colored_extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 28,
        height: 28,
        fill: "none",
        viewBox: "0 0 28 28"
    }, props), nonprofit_colored_path || (nonprofit_colored_path = /*#__PURE__*/ react.createElement("path", {
        stroke: "#000",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 1.703,
        d: "m14.212 13.387-4.197-3.883c-2.288-2.298 1.05-6.748 4.197-3.148 3.149-3.589 6.518.86 4.198 3.148zM10.678 18.637c.516.258 2.28.774 3.097.774 1.806 0 2.394-.318 3.097-.516 1.032-.292 1.458-.997 1.568-1.324m0 0c.074-.223.125.276 0-.225-.517-2.064-2.6-.291-4.665-.55-2.065-.257-4.646-1.514-5.678-1.514S5 16.022 5 17.346c0 1 .774 2.065 2.065 3.064s3.87 1.806 6.452 1.806c3.145 0 4.645-1.066 5.935-1.806.448-.257 3.613-2.84 3.871-3.613.333-1-.234-1.311-.774-1.515-.774-.292-1.419.5-2.064.999-1.29.999-1.29 1.066-2.045 1.29"
    })));
};
/* harmony default export */ var nonprofit_colored = (SvgNonprofitColored);

;// CONCATENATED MODULE: ./static/svg/header/docs_colored.svg
var docs_colored_path, docs_colored_path2, _path3;
function docs_colored_extends() {
    docs_colored_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return docs_colored_extends.apply(this, arguments);
}

var SvgDocsColored = function SvgDocsColored(props) {
    return /*#__PURE__*/ react.createElement("svg", docs_colored_extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 22,
        height: 22,
        fill: "none",
        viewBox: "0 0 22 22"
    }, props), docs_colored_path || (docs_colored_path = /*#__PURE__*/ react.createElement("path", {
        stroke: "#000",
        d: "M5 17.273V4a1 1 0 0 1 1-1h6.728a1 1 0 0 1 .753.342l3.272 3.74A1 1 0 0 1 17 7.74v9.533a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1Z"
    })), docs_colored_path2 || (docs_colored_path2 = /*#__PURE__*/ react.createElement("path", {
        stroke: "#000",
        d: "M13.143 7.114V3.447c0-.157.194-.232.299-.115L16.742 7c.1.11.021.286-.127.286h-3.3a.17.17 0 0 1-.172-.172Z"
    })), _path3 || (_path3 = /*#__PURE__*/ react.createElement("path", {
        stroke: "#000",
        strokeLinecap: "round",
        d: "M7.857 9.962h4.104M7.682 13.409h5.545"
    })));
};
/* harmony default export */ var docs_colored = (SvgDocsColored);

;// CONCATENATED MODULE: ./static/svg/header/files_colored.svg
var _rect, files_colored_path, files_colored_path2;
function files_colored_extends() {
    files_colored_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return files_colored_extends.apply(this, arguments);
}

var SvgFilesColored = function SvgFilesColored(props) {
    return /*#__PURE__*/ React.createElement("svg", files_colored_extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 22,
        height: 22,
        fill: "none",
        viewBox: "0 0 22 22"
    }, props), _rect || (_rect = /*#__PURE__*/ React.createElement("rect", {
        width: 10.667,
        height: 11.833,
        x: 6.833,
        y: 3.5,
        stroke: "#000",
        rx: 0.667
    })), files_colored_path || (files_colored_path = /*#__PURE__*/ React.createElement("path", {
        stroke: "#000",
        strokeLinecap: "round",
        d: "M15.167 7h-6M15.167 10.5h-6"
    })), files_colored_path2 || (files_colored_path2 = /*#__PURE__*/ React.createElement("path", {
        stroke: "#000",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeMiterlimit: 1.414,
        d: "M4 7.667v10.266c0 .129.104.233.233.233h7.934"
    })));
};
/* harmony default export */ var files_colored = ((/* unused pure expression or super */ null && (SvgFilesColored)));

;// CONCATENATED MODULE: ./static/svg/header/forms_icon_new.svg
var forms_icon_new_path, forms_icon_new_path2, forms_icon_new_path3, _path4, _path5, _path6, _path7, _path8, _path9;
function forms_icon_new_extends() {
    forms_icon_new_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return forms_icon_new_extends.apply(this, arguments);
}

var SvgFormsIconNew = function SvgFormsIconNew(props) {
    return /*#__PURE__*/ react.createElement("svg", forms_icon_new_extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 22,
        height: 22,
        fill: "none",
        viewBox: "0 0 22 22"
    }, props), forms_icon_new_path || (forms_icon_new_path = /*#__PURE__*/ react.createElement("path", {
        fill: "#6C6CFF",
        stroke: "#6C6CFF",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 0.5,
        d: "M5 6.405a.405.405 0 1 0 .81 0 .405.405 0 0 0-.81 0"
    })), forms_icon_new_path2 || (forms_icon_new_path2 = /*#__PURE__*/ react.createElement("path", {
        fill: "#6C6CFF",
        d: "M8.218 6.405H18Z"
    })), forms_icon_new_path3 || (forms_icon_new_path3 = /*#__PURE__*/ react.createElement("path", {
        stroke: "#6C6CFF",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 0.5,
        d: "M8.218 6.405H18"
    })), _path4 || (_path4 = /*#__PURE__*/ react.createElement("path", {
        fill: "#6C6CFF",
        stroke: "#6C6CFF",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 0.5,
        d: "M5 10.804a.405.405 0 1 0 .81 0 .405.405 0 0 0-.81 0"
    })), _path5 || (_path5 = /*#__PURE__*/ react.createElement("path", {
        fill: "#6C6CFF",
        d: "M8.218 10.804H18Z"
    })), _path6 || (_path6 = /*#__PURE__*/ react.createElement("path", {
        stroke: "#6C6CFF",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 0.5,
        d: "M8.218 10.804H18"
    })), _path7 || (_path7 = /*#__PURE__*/ react.createElement("path", {
        fill: "#6C6CFF",
        stroke: "#6C6CFF",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 0.5,
        d: "M5 15.203a.405.405 0 1 0 .81 0 .405.405 0 0 0-.81 0"
    })), _path8 || (_path8 = /*#__PURE__*/ react.createElement("path", {
        fill: "#6C6CFF",
        d: "M8.218 15.203H18Z"
    })), _path9 || (_path9 = /*#__PURE__*/ react.createElement("path", {
        stroke: "#6C6CFF",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 0.5,
        d: "M8.218 15.203H18"
    })));
};
/* harmony default export */ var forms_icon_new = (SvgFormsIconNew);

;// CONCATENATED MODULE: ./static/svg/header/gantt_colored.svg
var gantt_colored_path;
function gantt_colored_extends() {
    gantt_colored_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return gantt_colored_extends.apply(this, arguments);
}

var SvgGanttColored = function SvgGanttColored(props) {
    return /*#__PURE__*/ react.createElement("svg", gantt_colored_extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 22,
        height: 22,
        fill: "none",
        viewBox: "0 0 22 22"
    }, props), gantt_colored_path || (gantt_colored_path = /*#__PURE__*/ react.createElement("path", {
        stroke: "#000",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M9 6H2M14 11H6M19.242 16H12"
    })));
};
/* harmony default export */ var gantt_colored = (SvgGanttColored);

;// CONCATENATED MODULE: ./static/svg/header/ai-icon.svg
var ai_icon_path, ai_icon_path2;
function ai_icon_extends() {
    ai_icon_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return ai_icon_extends.apply(this, arguments);
}

var SvgAiIcon = function SvgAiIcon(props) {
    return /*#__PURE__*/ react.createElement("svg", ai_icon_extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 22,
        height: 22,
        fill: "none",
        viewBox: "0 0 22 22"
    }, props), ai_icon_path || (ai_icon_path = /*#__PURE__*/ react.createElement("path", {
        stroke: "#6161FF",
        d: "M8.797 6.616a.213.213 0 0 1 .406 0l1.496 4.55a.21.21 0 0 0 .136.135l4.549 1.496a.213.213 0 0 1 0 .406l-4.55 1.496a.21.21 0 0 0-.135.136l-1.496 4.549a.213.213 0 0 1-.406 0l-1.496-4.55a.21.21 0 0 0-.136-.135l-4.549-1.496a.213.213 0 0 1 0-.406l4.55-1.496a.21.21 0 0 0 .135-.136z"
    })), ai_icon_path2 || (ai_icon_path2 = /*#__PURE__*/ react.createElement("path", {
        fill: "#6161FF",
        d: "M16.297 2.616a.213.213 0 0 1 .406 0l.63 1.915a.21.21 0 0 0 .136.136l1.915.63a.213.213 0 0 1 0 .406l-1.915.63a.21.21 0 0 0-.137.136l-.63 1.915a.213.213 0 0 1-.405 0l-.63-1.915a.21.21 0 0 0-.136-.136l-1.915-.63a.213.213 0 0 1 0-.406l1.915-.63a.21.21 0 0 0 .136-.136z"
    })));
};
/* harmony default export */ var ai_icon = (SvgAiIcon);

;// CONCATENATED MODULE: ./static/svg/header/kanban_colored.svg
var kanban_colored_path, kanban_colored_rect;
function kanban_colored_extends() {
    kanban_colored_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return kanban_colored_extends.apply(this, arguments);
}

var SvgKanbanColored = function SvgKanbanColored(props) {
    return /*#__PURE__*/ react.createElement("svg", kanban_colored_extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 22,
        height: 22,
        fill: "none",
        viewBox: "0 0 22 22"
    }, props), kanban_colored_path || (kanban_colored_path = /*#__PURE__*/ react.createElement("path", {
        stroke: "#000",
        strokeLinejoin: "round",
        d: "M4 3.5h4.5V14a.5.5 0 0 1-.5.5H4a.5.5 0 0 1-.5-.5V4a.5.5 0 0 1 .5-.5ZM13.5 3.5H18a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-.5.5h-4a.5.5 0 0 1-.5-.5z"
    })), kanban_colored_rect || (kanban_colored_rect = /*#__PURE__*/ react.createElement("rect", {
        width: 5,
        height: 15,
        x: 8.5,
        y: 3.5,
        stroke: "#000",
        strokeLinejoin: "round",
        rx: 0.5
    })));
};
/* harmony default export */ var kanban_colored = (SvgKanbanColored);

;// CONCATENATED MODULE: ./static/svg/header/automations_colored.svg
var automations_colored_rect, automations_colored_path, automations_colored_path2, automations_colored_path3;
function automations_colored_extends() {
    automations_colored_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return automations_colored_extends.apply(this, arguments);
}

var SvgAutomationsColored = function SvgAutomationsColored(props) {
    return /*#__PURE__*/ react.createElement("svg", automations_colored_extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 22,
        height: 22,
        fill: "none",
        viewBox: "0 0 22 22"
    }, props), automations_colored_rect || (automations_colored_rect = /*#__PURE__*/ react.createElement("rect", {
        width: 12.047,
        height: 10.951,
        x: 5.183,
        y: 6.287,
        stroke: "#000",
        rx: 2.259
    })), automations_colored_path || (automations_colored_path = /*#__PURE__*/ react.createElement("path", {
        stroke: "#000",
        strokeLinecap: "round",
        d: "M8.974 10.072v2.285M13.35 10.072v2.285"
    })), automations_colored_path2 || (automations_colored_path2 = /*#__PURE__*/ react.createElement("path", {
        stroke: "#000",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M3 10.701c0-.624.506-1.13 1.13-1.13h1.06v4.381H4.13A1.13 1.13 0 0 1 3 12.823zM17.234 9.572h1.061c.624 0 1.13.505 1.13 1.13v2.121a1.13 1.13 0 0 1-1.13 1.13h-1.06z"
    })), automations_colored_path3 || (automations_colored_path3 = /*#__PURE__*/ react.createElement("path", {
        stroke: "#000",
        strokeLinecap: "round",
        d: "M11.162 3.5v2.285"
    })));
};
/* harmony default export */ var automations_colored = (SvgAutomationsColored);

;// CONCATENATED MODULE: ./static/svg/header/integrations_colored.svg
var integrations_colored_path, integrations_colored_path2, integrations_colored_path3;
function integrations_colored_extends() {
    integrations_colored_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return integrations_colored_extends.apply(this, arguments);
}

var SvgIntegrationsColored = function SvgIntegrationsColored(props) {
    return /*#__PURE__*/ react.createElement("svg", integrations_colored_extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 22,
        height: 22,
        fill: "none",
        viewBox: "0 0 22 22"
    }, props), integrations_colored_path || (integrations_colored_path = /*#__PURE__*/ react.createElement("path", {
        stroke: "#000",
        strokeLinecap: "round",
        d: "m3.5 8.735 3.036 3.036M7.738 4.5l3.036 3.036M14.393 14.981l2.753 2.754"
    })), integrations_colored_path2 || (integrations_colored_path2 = /*#__PURE__*/ react.createElement("path", {
        stroke: "#000",
        d: "m5.745 12.735 6.78-6.78 3.67 3.671c.89.89.89 2.333 0 3.223l-3.556 3.556a2.28 2.28 0 0 1-3.223 0z"
    })), integrations_colored_path3 || (integrations_colored_path3 = /*#__PURE__*/ react.createElement("path", {
        stroke: "#000",
        strokeLinecap: "round",
        d: "m4.031 14.342 9.5-9.328"
    })));
};
/* harmony default export */ var integrations_colored = (SvgIntegrationsColored);

;// CONCATENATED MODULE: ./static/svg/header/dashboards_colored.svg
var dashboards_colored_rect, dashboards_colored_path;
function dashboards_colored_extends() {
    dashboards_colored_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return dashboards_colored_extends.apply(this, arguments);
}

var SvgDashboardsColored = function SvgDashboardsColored(props) {
    return /*#__PURE__*/ react.createElement("svg", dashboards_colored_extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 22,
        height: 22,
        fill: "none",
        viewBox: "0 0 22 22"
    }, props), dashboards_colored_rect || (dashboards_colored_rect = /*#__PURE__*/ react.createElement("rect", {
        width: 14,
        height: 14,
        x: 3.5,
        y: 3.5,
        stroke: "#000",
        rx: 1.375
    })), dashboards_colored_path || (dashboards_colored_path = /*#__PURE__*/ react.createElement("path", {
        stroke: "#000",
        strokeLinecap: "round",
        d: "M7.183 14.687V11M10.936 14.687V8.188M14.69 14.687V6.312"
    })));
};
/* harmony default export */ var dashboards_colored = (SvgDashboardsColored);

;// CONCATENATED MODULE: ./static/svg/header/project_management_colored_2.svg
var project_management_colored_2_path, project_management_colored_2_path2, project_management_colored_2_rect;
function project_management_colored_2_extends() {
    project_management_colored_2_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return project_management_colored_2_extends.apply(this, arguments);
}

var SvgProjectManagementColored2 = function SvgProjectManagementColored2(props) {
    return /*#__PURE__*/ react.createElement("svg", project_management_colored_2_extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 28,
        height: 28,
        fill: "none",
        viewBox: "0 0 28 28"
    }, props), project_management_colored_2_path || (project_management_colored_2_path = /*#__PURE__*/ react.createElement("path", {
        stroke: "#000",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 1.5,
        d: "M11.403 17.439H8.258A1.265 1.265 0 0 1 7 16.176V6.628a1.256 1.256 0 0 1 1.258-1.262h11.32c.335 0 .654.132.89.369s.369.558.369.893V9.21M7.33 9.184h10.377"
    })), project_management_colored_2_path2 || (project_management_colored_2_path2 = /*#__PURE__*/ react.createElement("path", {
        stroke: "#000",
        strokeLinecap: "round",
        strokeWidth: 1.5,
        d: "M10.657 4.809v1.358M17.982 4.75v1.358"
    })), project_management_colored_2_rect || (project_management_colored_2_rect = /*#__PURE__*/ react.createElement("rect", {
        width: 6,
        height: 6,
        x: 15,
        y: 14,
        stroke: "#000",
        strokeWidth: 1.5,
        rx: 0.804
    })));
};
/* harmony default export */ var project_management_colored_2 = (SvgProjectManagementColored2);

;// CONCATENATED MODULE: ./static/svg/header/monday_work_management_square.svg
var monday_work_management_square_path, monday_work_management_square_path2, monday_work_management_square_path3, monday_work_management_square_defs;
function monday_work_management_square_extends() {
    monday_work_management_square_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return monday_work_management_square_extends.apply(this, arguments);
}

var SvgMondayWorkManagementSquare = function SvgMondayWorkManagementSquare(props) {
    return /*#__PURE__*/ react.createElement("svg", monday_work_management_square_extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 72,
        height: 72,
        fill: "none",
        viewBox: "0 0 72 72"
    }, props), monday_work_management_square_path || (monday_work_management_square_path = /*#__PURE__*/ react.createElement("path", {
        fill: "#6C6CFF",
        d: "M16.367 52.545c-2.709-1.847-3.367-5.482-1.47-8.12l16.007-22.259c1.172-1.63 3.045-2.497 4.945-2.486 1.896-.008 3.766.86 4.936 2.486l16.012 22.266c1.896 2.637 1.238 6.272-1.47 8.119-2.71 1.846-6.442 1.205-8.339-1.432L35.844 35.623l-11.139 15.49c-1.896 2.637-5.63 3.278-8.338 1.432"
    })), monday_work_management_square_path2 || (monday_work_management_square_path2 = /*#__PURE__*/ react.createElement("path", {
        fill: "url(#paint0_linear_2108_574604)",
        d: "M16.372 18.724c-2.709 1.847-3.367 5.482-1.47 8.119l16 22.25c1.168 1.624 3.032 2.49 4.925 2.486 1.904.015 3.783-.853 4.958-2.486l16-22.25c1.897-2.637 1.239-6.272-1.47-8.119s-6.442-1.206-8.338 1.432L35.843 35.637 24.71 20.156c-1.897-2.638-5.63-3.279-8.338-1.432"
    })), monday_work_management_square_path3 || (monday_work_management_square_path3 = /*#__PURE__*/ react.createElement("path", {
        fill: "#7E7EFF",
        d: "m28.532 25.47-7.31 10.163 7.31 10.164 7.31-10.164z"
    })), monday_work_management_square_defs || (monday_work_management_square_defs = /*#__PURE__*/ react.createElement("defs", null, /*#__PURE__*/ react.createElement("linearGradient", {
        id: "paint0_linear_2108_574604",
        x1: 39.285,
        x2: 37.456,
        y1: 34.624,
        y2: 52.175,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ react.createElement("stop", {
        stopColor: "#8F8FFF"
    }), /*#__PURE__*/ react.createElement("stop", {
        offset: 1,
        stopColor: "#BABAFD"
    })))));
};
/* harmony default export */ var monday_work_management_square = (SvgMondayWorkManagementSquare);

// EXTERNAL MODULE: ./static/svg/header/monday_crm_square.svg
var monday_crm_square = __webpack_require__(91276);
// EXTERNAL MODULE: ./static/svg/header/monday_marketer_square.svg
var monday_marketer_square = __webpack_require__(93216);
// EXTERNAL MODULE: ./static/svg/header/monday_projects_square.svg
var monday_projects_square = __webpack_require__(52165);
// EXTERNAL MODULE: ./static/svg/header/monday_dev_square.svg
var monday_dev_square = __webpack_require__(1828);
;// CONCATENATED MODULE: ./static/svg/header/wm_logo.svg
var wm_logo_path, wm_logo_path2, wm_logo_path3, wm_logo_path4, wm_logo_path5, wm_logo_path6, wm_logo_path7, wm_logo_defs;
function wm_logo_extends() {
    wm_logo_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return wm_logo_extends.apply(this, arguments);
}

var SvgWmLogo = function SvgWmLogo(props) {
    return /*#__PURE__*/ react.createElement("svg", wm_logo_extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 25,
        height: 25,
        fill: "none",
        viewBox: "0 0 25 25"
    }, props), wm_logo_path || (wm_logo_path = /*#__PURE__*/ react.createElement("path", {
        fill: "url(#paint0_linear_1860_128182)",
        d: "M15.436 2.592c0-1.421-1.097-2.573-2.45-2.573s-2.45 1.152-2.45 2.573v2.829c0 1.421 1.096 2.574 2.45 2.574 1.353 0 2.45-1.153 2.45-2.574z"
    })), wm_logo_path2 || (wm_logo_path2 = /*#__PURE__*/ react.createElement("path", {
        fill: "url(#paint1_linear_1860_128182)",
        d: "M5.846 6.202c-1.288-.44-2.67.3-3.089 1.65-.418 1.352.287 2.803 1.575 3.243l2.562.874c1.288.439 2.67-.3 3.09-1.651.417-1.352-.288-2.803-1.575-3.242z"
    })), wm_logo_path3 || (wm_logo_path3 = /*#__PURE__*/ react.createElement("path", {
        fill: "url(#paint2_linear_1860_128182)",
        d: "M6.148 16.894c-.796 1.15-.553 2.759.541 3.594s2.628.58 3.424-.57l1.584-2.289c.796-1.15.553-2.759-.542-3.594-1.094-.835-2.627-.58-3.423.57z"
    })), wm_logo_path4 || (wm_logo_path4 = /*#__PURE__*/ react.createElement("path", {
        fill: "url(#paint3_linear_1860_128182)",
        d: "M15.93 19.889c.796 1.15 2.329 1.405 3.424.57s1.337-2.444.54-3.594l-1.583-2.289c-.796-1.15-2.328-1.405-3.423-.57s-1.338 2.444-.542 3.594z"
    })), wm_logo_path5 || (wm_logo_path5 = /*#__PURE__*/ react.createElement("path", {
        fill: "#6161FF",
        d: "M13.01 13.86c1.342 0 2.43-1.143 2.43-2.553s-1.088-2.552-2.43-2.552-2.432 1.142-2.432 2.552 1.089 2.553 2.432 2.553M5.077 11.206c1.35 0 2.445-1.15 2.445-2.566 0-1.418-1.094-2.567-2.445-2.567S2.633 7.223 2.633 8.64s1.094 2.566 2.444 2.566M12.986 5.142c1.353 0 2.449-1.151 2.449-2.571S14.339 0 12.986 0s-2.449 1.151-2.449 2.57c0 1.42 1.096 2.572 2.45 2.572M8.129 20.986c1.355 0 2.453-1.153 2.453-2.576 0-1.422-1.098-2.575-2.453-2.575s-2.453 1.153-2.453 2.575 1.098 2.576 2.453 2.576M17.92 20.959c1.352 0 2.448-1.15 2.448-2.57s-1.095-2.57-2.447-2.57-2.448 1.15-2.448 2.57 1.096 2.57 2.448 2.57"
    })), wm_logo_path6 || (wm_logo_path6 = /*#__PURE__*/ react.createElement("path", {
        fill: "url(#paint4_linear_1860_128182)",
        d: "M20.154 6.201c1.288-.439 2.67.3 3.089 1.651.418 1.352-.287 2.803-1.575 3.242l-2.562.874c-1.288.44-2.671-.3-3.09-1.65-.417-1.352.288-2.803 1.575-3.243z"
    })), wm_logo_path7 || (wm_logo_path7 = /*#__PURE__*/ react.createElement("path", {
        fill: "#6161FF",
        d: "M20.923 11.206c-1.35 0-2.445-1.15-2.445-2.567s1.095-2.566 2.445-2.566 2.444 1.149 2.444 2.566c0 1.418-1.094 2.567-2.444 2.567"
    })), wm_logo_defs || (wm_logo_defs = /*#__PURE__*/ react.createElement("defs", null, /*#__PURE__*/ react.createElement("linearGradient", {
        id: "paint0_linear_1860_128182",
        x1: 12.97,
        x2: 13.029,
        y1: -4.924,
        y2: 8.508,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ react.createElement("stop", {
        offset: 0.411,
        stopColor: "#6C6CFF",
        stopOpacity: 0.9
    }), /*#__PURE__*/ react.createElement("stop", {
        offset: 1,
        stopColor: "#6C6CFF",
        stopOpacity: 0.1
    })), /*#__PURE__*/ react.createElement("linearGradient", {
        id: "paint1_linear_1860_128182",
        x1: -1.726,
        x2: 10.566,
        y1: 6.341,
        y2: 10.092,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ react.createElement("stop", {
        offset: 0.411,
        stopColor: "#6C6CFF",
        stopOpacity: 0.9
    }), /*#__PURE__*/ react.createElement("stop", {
        offset: 1,
        stopColor: "#6C6CFF",
        stopOpacity: 0.1
    })), /*#__PURE__*/ react.createElement("linearGradient", {
        id: "paint2_linear_1860_128182",
        x1: 3.935,
        x2: 11.898,
        y1: 24.497,
        y2: 13.963,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ react.createElement("stop", {
        offset: 0.411,
        stopColor: "#6C6CFF",
        stopOpacity: 0.9
    }), /*#__PURE__*/ react.createElement("stop", {
        offset: 1,
        stopColor: "#6C6CFF",
        stopOpacity: 0.1
    })), /*#__PURE__*/ react.createElement("linearGradient", {
        id: "paint3_linear_1860_128182",
        x1: 22.134,
        x2: 14.085,
        y1: 24.448,
        y2: 13.987,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ react.createElement("stop", {
        offset: 0.411,
        stopColor: "#6C6CFF",
        stopOpacity: 0.9
    }), /*#__PURE__*/ react.createElement("stop", {
        offset: 1,
        stopColor: "#6C6CFF",
        stopOpacity: 0.1
    })), /*#__PURE__*/ react.createElement("linearGradient", {
        id: "paint4_linear_1860_128182",
        x1: 27.726,
        x2: 15.434,
        y1: 6.341,
        y2: 10.091,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ react.createElement("stop", {
        offset: 0.411,
        stopColor: "#6C6CFF",
        stopOpacity: 0.9
    }), /*#__PURE__*/ react.createElement("stop", {
        offset: 1,
        stopColor: "#6C6CFF",
        stopOpacity: 0.1
    })))));
};
/* harmony default export */ var wm_logo = (SvgWmLogo);

;// CONCATENATED MODULE: ./static/svg/header/mobile_crm_logo.svg
var mobile_crm_logo_path, _ellipse, _ellipse2, mobile_crm_logo_path2, mobile_crm_logo_defs;
function mobile_crm_logo_extends() {
    mobile_crm_logo_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return mobile_crm_logo_extends.apply(this, arguments);
}

var SvgMobileCrmLogo = function SvgMobileCrmLogo(props) {
    return /*#__PURE__*/ react.createElement("svg", mobile_crm_logo_extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 25,
        height: 25,
        fill: "none",
        viewBox: "0 0 25 25"
    }, props), mobile_crm_logo_path || (mobile_crm_logo_path = /*#__PURE__*/ react.createElement("path", {
        fill: "#00A0A0",
        d: "M16.646 12.818a.563.563 0 0 1-.572.595H8.926a.563.563 0 0 0-.572.595 8.46 8.46 0 0 0 1.87 4.743 8.32 8.32 0 0 0 4.817 2.914 8.26 8.26 0 0 0 5.554-.832 8.4 8.4 0 0 0 3.77-4.2c.739-1.798.836-3.8.276-5.662a8.4 8.4 0 0 0-3.345-4.553 8.27 8.27 0 0 0-7.124-1.032 8.3 8.3 0 0 0-1.691.747 8.4 8.4 0 0 1 3.079 3.131l.002-.036.017.03a8.5 8.5 0 0 1 1.067 3.56"
    })), _ellipse || (_ellipse = /*#__PURE__*/ react.createElement("ellipse", {
        cx: 8.333,
        cy: 13.414,
        fill: "#fff",
        rx: 8.333,
        ry: 8.413
    })), _ellipse2 || (_ellipse2 = /*#__PURE__*/ react.createElement("ellipse", {
        cx: 8.333,
        cy: 13.414,
        fill: "url(#paint0_linear_1_20)",
        rx: 8.333,
        ry: 8.413
    })), mobile_crm_logo_path2 || (mobile_crm_logo_path2 = /*#__PURE__*/ react.createElement("path", {
        fill: "url(#paint1_linear_1_20)",
        d: "M12.502 20.7a8.43 8.43 0 0 0 4.165-7.287c.007-.34-.021-.595-.021-.595a.57.57 0 0 1-.572.595H8.926a.563.563 0 0 0-.572.595 8.46 8.46 0 0 0 1.87 4.743 8.4 8.4 0 0 0 2.278 1.95"
    })), mobile_crm_logo_defs || (mobile_crm_logo_defs = /*#__PURE__*/ react.createElement("defs", null, /*#__PURE__*/ react.createElement("linearGradient", {
        id: "paint0_linear_1_20",
        x1: 2.538,
        x2: 16.723,
        y1: 8.363,
        y2: 15.544,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ react.createElement("stop", {
        stopColor: "#00D2D2"
    }), /*#__PURE__*/ react.createElement("stop", {
        offset: 1,
        stopColor: "#00D2D2",
        stopOpacity: 0.29
    })), /*#__PURE__*/ react.createElement("linearGradient", {
        id: "paint1_linear_1_20",
        x1: 17.571,
        x2: 4.308,
        y1: 17.755,
        y2: 15.018,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ react.createElement("stop", {
        stopColor: "#00A0A0"
    }), /*#__PURE__*/ react.createElement("stop", {
        offset: 1,
        stopColor: "#00D2D2"
    })))));
};
/* harmony default export */ var mobile_crm_logo = (SvgMobileCrmLogo);

;// CONCATENATED MODULE: ./static/svg/header/mobile_marketer_logo.svg
var mobile_marketer_logo_g, mobile_marketer_logo_defs;
function mobile_marketer_logo_extends() {
    mobile_marketer_logo_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return mobile_marketer_logo_extends.apply(this, arguments);
}

var SvgMobileMarketerLogo = function SvgMobileMarketerLogo(props) {
    return /*#__PURE__*/ react.createElement("svg", mobile_marketer_logo_extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 25,
        height: 25,
        fill: "none",
        viewBox: "0 0 25 25"
    }, props), mobile_marketer_logo_g || (mobile_marketer_logo_g = /*#__PURE__*/ react.createElement("g", {
        clipPath: "url(#clip0_1_21)"
    }, /*#__PURE__*/ react.createElement("path", {
        fill: "#CA0C6B",
        d: "M9.455 11.386v9.679c0 .36.292.653.653.653h4.784a.654.654 0 0 0 .654-.654v-8.791a1.681 1.681 0 0 1 3.363 0v8.792c0 .36.293.653.654.653h4.783a.654.654 0 0 0 .654-.654v-9.678C25 7.307 21.52 4 17.227 4s-7.772 3.307-7.772 7.386"
    }), /*#__PURE__*/ react.createElement("path", {
        fill: "url(#paint0_linear_1_21)",
        d: "M0 11.386v9.679c0 .36.293.653.654.653h4.783a.654.654 0 0 0 .654-.654v-8.791a1.681 1.681 0 0 1 3.363 0v8.792c0 .36.293.653.654.653h4.784a.654.654 0 0 0 .654-.654v-9.678C15.546 7.307 12.066 4 7.773 4S0 7.307 0 11.386"
    }), /*#__PURE__*/ react.createElement("path", {
        fill: "#F8C3DD",
        d: "M0 16.026h6.09v5.153a.54.54 0 0 1-.54.54H.54a.54.54 0 0 1-.54-.54zM9.455 16.026h6.09v5.153a.54.54 0 0 1-.539.54H9.995a.54.54 0 0 1-.54-.54zM18.91 16.026H25v5.153a.54.54 0 0 1-.539.54h-5.01a.54.54 0 0 1-.54-.54z"
    }))), mobile_marketer_logo_defs || (mobile_marketer_logo_defs = /*#__PURE__*/ react.createElement("defs", null, /*#__PURE__*/ react.createElement("linearGradient", {
        id: "paint0_linear_1_21",
        x1: -0.507,
        x2: 24.777,
        y1: 20.464,
        y2: 17.216,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ react.createElement("stop", {
        stopColor: "#FF158A"
    }), /*#__PURE__*/ react.createElement("stop", {
        offset: 0.766,
        stopColor: "#FF158A",
        stopOpacity: 0.5
    })), /*#__PURE__*/ react.createElement("clipPath", {
        id: "clip0_1_21"
    }, /*#__PURE__*/ react.createElement("path", {
        fill: "#fff",
        d: "M0 0h25v25H0z"
    })))));
};
/* harmony default export */ var mobile_marketer_logo = (SvgMobileMarketerLogo);

;// CONCATENATED MODULE: ./static/svg/header/mobile_projects_logo.svg
var mobile_projects_logo_path, mobile_projects_logo_path2, mobile_projects_logo_path3, mobile_projects_logo_defs;
function mobile_projects_logo_extends() {
    mobile_projects_logo_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return mobile_projects_logo_extends.apply(this, arguments);
}

var SvgMobileProjectsLogo = function SvgMobileProjectsLogo(props) {
    return /*#__PURE__*/ react.createElement("svg", mobile_projects_logo_extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 25,
        height: 25,
        fill: "none",
        viewBox: "0 0 25 25"
    }, props), /*#__PURE__*/ react.createElement("g", {
        clipPath: "url(#clip0_1_23)"
    }, mobile_projects_logo_path || (mobile_projects_logo_path = /*#__PURE__*/ react.createElement("path", {
        fill: "url(#paint0_linear_1_23)",
        d: "M6.25 4.333c0-.583.308-1.12.807-1.412L11.693.218a1.6 1.6 0 0 1 1.614 0l4.636 2.703c.5.291.807.83.807 1.412v6.347l-6.25 3.643-6.25-3.643z"
    })), mobile_projects_logo_path2 || (mobile_projects_logo_path2 = /*#__PURE__*/ react.createElement("path", {
        fill: "url(#paint1_linear_1_23)",
        d: "M6.25 10.68c-1.81 1.062-3.628 2.112-5.443 3.17-.5.291-.807.83-.807 1.412v5.405c0 .582.308 1.12.807 1.412l4.636 2.703c.5.29 1.115.29 1.614 0l5.443-3.17v-7.288z"
    })), mobile_projects_logo_path3 || (mobile_projects_logo_path3 = /*#__PURE__*/ react.createElement("path", {
        fill: "url(#paint2_linear_1_23)",
        d: "M24.193 13.85c.5.29.807.83.807 1.412v5.405c0 .582-.308 1.12-.807 1.412l-4.636 2.703c-.5.29-1.115.29-1.614 0l-5.443-3.17v-7.288l6.25-3.644c1.811 1.062 3.629 2.112 5.443 3.17"
    })), /*#__PURE__*/ react.createElement("path", {
        fill: "url(#paint3_linear_1_23)",
        d: "M6.25 11.15c0-.29.154-.56.404-.706l5.443-3.173a.8.8 0 0 1 .807 0l5.442 3.173c.25.146.404.415.404.706v6.347c0 .291-.154.56-.404.706l-5.442 3.173a.8.8 0 0 1-.807 0l-5.443-3.173a.82.82 0 0 1-.404-.706z",
        style: {
            mixBlendMode: "multiply"
        }
    })), mobile_projects_logo_defs || (mobile_projects_logo_defs = /*#__PURE__*/ react.createElement("defs", null, /*#__PURE__*/ react.createElement("linearGradient", {
        id: "paint0_linear_1_23",
        x1: 6.25,
        x2: 18.806,
        y1: 3.401,
        y2: 10.585,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ react.createElement("stop", {
        stopColor: "#FB9000"
    }), /*#__PURE__*/ react.createElement("stop", {
        offset: 1,
        stopColor: "#FFCB00"
    })), /*#__PURE__*/ react.createElement("linearGradient", {
        id: "paint1_linear_1_23",
        x1: 12.5,
        x2: -0.056,
        y1: 14.318,
        y2: 21.502,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ react.createElement("stop", {
        stopColor: "#FB9000"
    }), /*#__PURE__*/ react.createElement("stop", {
        offset: 1,
        stopColor: "#FFCB00"
    })), /*#__PURE__*/ react.createElement("linearGradient", {
        id: "paint2_linear_1_23",
        x1: 12.5,
        x2: 25.056,
        y1: 14.317,
        y2: 21.502,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ react.createElement("stop", {
        stopColor: "#FB9000"
    }), /*#__PURE__*/ react.createElement("stop", {
        offset: 1,
        stopColor: "#FFCB00"
    })), /*#__PURE__*/ react.createElement("linearGradient", {
        id: "paint3_linear_1_23",
        x1: 12.5,
        x2: 12.5,
        y1: 7.162,
        y2: 21.485,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ react.createElement("stop", {
        stopColor: "#FDAB3D"
    }), /*#__PURE__*/ react.createElement("stop", {
        offset: 1,
        stopColor: "#FFCB00",
        stopOpacity: 0.51
    })), /*#__PURE__*/ react.createElement("clipPath", {
        id: "clip0_1_23"
    }, /*#__PURE__*/ react.createElement("path", {
        fill: "#fff",
        d: "M0 0h25v25H0z"
    })))));
};
/* harmony default export */ var mobile_projects_logo = (SvgMobileProjectsLogo);

;// CONCATENATED MODULE: ./static/svg/header/dev_logo_new.svg
var dev_logo_new_path, dev_logo_new_path2, dev_logo_new_path3, dev_logo_new_defs;
function dev_logo_new_extends() {
    dev_logo_new_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return dev_logo_new_extends.apply(this, arguments);
}

var SvgDevLogoNew = function SvgDevLogoNew(props) {
    return /*#__PURE__*/ react.createElement("svg", dev_logo_new_extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 25,
        height: 18,
        fill: "none",
        viewBox: "0 0 25 18"
    }, props), dev_logo_new_path || (dev_logo_new_path = /*#__PURE__*/ react.createElement("path", {
        fill: "url(#paint0_linear_2426_1287)",
        fillRule: "evenodd",
        d: "M9.415 2.535C9.415 1.135 10.55 0 11.95 0a8.54 8.54 0 0 1 8.54 8.54 8.54 8.54 0 0 1-8.54 8.542H2.535a2.535 2.535 0 0 1 0-5.07h9.415a3.47 3.47 0 0 0 3.47-3.471 3.47 3.47 0 0 0-3.47-3.47 2.535 2.535 0 0 1-2.535-2.536",
        clipRule: "evenodd"
    })), dev_logo_new_path2 || (dev_logo_new_path2 = /*#__PURE__*/ react.createElement("path", {
        fill: "#00CA72",
        fillRule: "evenodd",
        d: "M3.55 8.54A8.54 8.54 0 0 1 12.093 0a2.535 2.535 0 1 1 0 5.07 3.47 3.47 0 0 0-3.47 3.47 3.47 3.47 0 0 0 3.47 3.471h10.407v5.07H12.092a8.54 8.54 0 0 1-8.541-8.54",
        clipRule: "evenodd"
    })), dev_logo_new_path3 || (dev_logo_new_path3 = /*#__PURE__*/ react.createElement("path", {
        fill: "#00CA72",
        d: "M24.747 13.943a.86.86 0 0 1 0 1.219l-1.683 1.673c-.542.54-1.466.155-1.466-.61V12.88c0-.765.924-1.149 1.466-.61z"
    })), dev_logo_new_defs || (dev_logo_new_defs = /*#__PURE__*/ react.createElement("defs", null, /*#__PURE__*/ react.createElement("linearGradient", {
        id: "paint0_linear_2426_1287",
        x1: 15.536,
        x2: 14.014,
        y1: 5.721,
        y2: 12.798,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ react.createElement("stop", {
        stopColor: "#00CA72"
    }), /*#__PURE__*/ react.createElement("stop", {
        offset: 0.906,
        stopColor: "#00CA72",
        stopOpacity: 0.6
    })))));
};
/* harmony default export */ var dev_logo_new = (SvgDevLogoNew);

;// CONCATENATED MODULE: ./static/svg/header/service_logo.svg
var service_logo_path, service_logo_path2, service_logo_defs;
function service_logo_extends() {
    service_logo_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return service_logo_extends.apply(this, arguments);
}

var SvgServiceLogo = function SvgServiceLogo(props) {
    return /*#__PURE__*/ react.createElement("svg", service_logo_extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 23,
        height: 23,
        fill: "none",
        viewBox: "0 0 23 23"
    }, props), service_logo_path || (service_logo_path = /*#__PURE__*/ react.createElement("path", {
        fill: "#FF4D77",
        fillRule: "evenodd",
        d: "M4.835 4.715C3.01 5.484 2.12 7.406 2.948 9.37c1.068 2.538 5.77 3.979 5.992 4.01.198.032.43-.083.43-.303s-.43-2.043-.43-2.172.072-.245.197-.297c.124-.051 5.577-2.363 7.385-3.123a3.523 3.523 0 0 0 1.887-4.654C17.63.983 15.573.178 13.755.943s-7.096 3.005-8.92 3.772",
        clipRule: "evenodd"
    })), service_logo_path2 || (service_logo_path2 = /*#__PURE__*/ react.createElement("path", {
        fill: "url(#paint0_linear_162_137261)",
        fillRule: "evenodd",
        d: "M17.468 18.595c1.824-.769 2.713-2.691 1.887-4.654-1.07-2.538-5.771-3.97-5.992-4.002-.2-.03-.432.084-.432.304s.432 2.033.432 2.162c0 .13-.073.246-.197.298s-5.578 2.363-7.386 3.123a3.523 3.523 0 0 0-1.887 4.654c.778 1.848 2.836 2.652 4.654 1.887 1.82-.765 7.096-3.006 8.92-3.772",
        clipRule: "evenodd"
    })), service_logo_defs || (service_logo_defs = /*#__PURE__*/ react.createElement("defs", null, /*#__PURE__*/ react.createElement("linearGradient", {
        id: "paint0_linear_162_137261",
        x1: 14.58,
        x2: 14.211,
        y1: 23.441,
        y2: 10.321,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ react.createElement("stop", {
        stopColor: "#FF4D77"
    }), /*#__PURE__*/ react.createElement("stop", {
        offset: 0.47,
        stopColor: "#FF4D77",
        stopOpacity: 0.85
    }), /*#__PURE__*/ react.createElement("stop", {
        offset: 1,
        stopColor: "#FF4D77",
        stopOpacity: 0.4
    })))));
};
/* harmony default export */ var service_logo = (SvgServiceLogo);

;// CONCATENATED MODULE: ./static/svg/header/solutions/team.svg
var team_path, team_path2, team_path3, team_defs;
function team_extends() {
    team_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return team_extends.apply(this, arguments);
}

var SvgTeam = function SvgTeam(props) {
    return /*#__PURE__*/ react.createElement("svg", team_extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 25,
        height: 22,
        fill: "none",
        viewBox: "0 0 25 22"
    }, props), team_path || (team_path = /*#__PURE__*/ react.createElement("path", {
        stroke: "#6C6CFF",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 1.583,
        d: "M9.008 8.812c1.577 0 2.855-1.234 2.855-2.757 0-1.522-1.278-2.756-2.855-2.756S6.153 4.533 6.153 6.055c0 1.523 1.278 2.757 2.855 2.757"
    })), team_path2 || (team_path2 = /*#__PURE__*/ react.createElement("path", {
        stroke: "url(#paint0_linear_2492_172907)",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 1.583,
        d: "M14.718 18H3.298v-1.225c0-1.462.602-2.864 1.673-3.898a5.81 5.81 0 0 1 4.037-1.615c1.515 0 2.967.58 4.038 1.615a5.42 5.42 0 0 1 1.672 3.898z"
    })), team_path3 || (team_path3 = /*#__PURE__*/ react.createElement("path", {
        stroke: "#6161FF",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 1.583,
        d: "M14.082 3.299c.757 0 1.483.29 2.019.807a2.7 2.7 0 0 1 .836 1.95c0 .73-.301 1.431-.836 1.948a2.9 2.9 0 0 1-2.019.808M16.112 11.495a5.7 5.7 0 0 1 2.669 2.02 5.4 5.4 0 0 1 1.01 3.125V18H17.89"
    })), team_defs || (team_defs = /*#__PURE__*/ react.createElement("defs", null, /*#__PURE__*/ react.createElement("linearGradient", {
        id: "paint0_linear_2492_172907",
        x1: 5.107,
        x2: 8.823,
        y1: 12.395,
        y2: 18.121,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ react.createElement("stop", {
        stopColor: "#6C6CFF"
    })))));
};
/* harmony default export */ var team = (SvgTeam);

;// CONCATENATED MODULE: ./static/svg/header/solutions/company.svg
var company_path, company_path2, company_path3, company_path4;
function company_extends() {
    company_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return company_extends.apply(this, arguments);
}

var SvgCompany = function SvgCompany(props) {
    return /*#__PURE__*/ react.createElement("svg", company_extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 25,
        height: 23,
        fill: "none",
        viewBox: "0 0 25 23"
    }, props), company_path || (company_path = /*#__PURE__*/ react.createElement("path", {
        stroke: "#6C6CFF",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeMiterlimit: 10,
        strokeWidth: 1.583,
        d: "M18.943 19.082V6.415l-6.846-2.2L5.096 6.5l.13 12.582z"
    })), company_path2 || (company_path2 = /*#__PURE__*/ react.createElement("path", {
        stroke: "#6C6CFF",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeMiterlimit: 10,
        strokeWidth: 1.188,
        d: "M10.907 9.64h2.375"
    })), company_path3 || (company_path3 = /*#__PURE__*/ react.createElement("path", {
        stroke: "#6C6CFF",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 1.188,
        d: "M10.116 19.083V13.54h3.959v5.543"
    })), company_path4 || (company_path4 = /*#__PURE__*/ react.createElement("path", {
        stroke: "#6C6CFF",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeMiterlimit: 10,
        strokeWidth: 1.583,
        d: "M19.032 11.165h3.959v7.917h-3.959M5.158 11.165H1.199v7.917h3.959"
    })));
};
/* harmony default export */ var company = (SvgCompany);

;// CONCATENATED MODULE: ./static/svg/header/solutions/industry2.svg
var industry2_path, industry2_path2;
function industry2_extends() {
    industry2_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return industry2_extends.apply(this, arguments);
}

var SvgIndustry2 = function SvgIndustry2(props) {
    return /*#__PURE__*/ react.createElement("svg", industry2_extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 22,
        height: 22,
        fill: "none",
        viewBox: "0 0 22 22"
    }, props), industry2_path || (industry2_path = /*#__PURE__*/ react.createElement("path", {
        stroke: "#6161FF",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 1.25,
        d: "M3.2 6.8h15.6S20 6.8 20 8v9.6s0 1.2-1.2 1.2H3.2S2 18.8 2 17.6V8s0-1.2 1.2-1.2M14.6 6.8a3.6 3.6 0 0 0-7.2 0M2 11.6h7.2M12.8 11.6H20"
    })), industry2_path2 || (industry2_path2 = /*#__PURE__*/ react.createElement("path", {
        stroke: "#6161FF",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 1.25,
        d: "M9.2 12.4a1.8 1.8 0 1 0 3.6 0v-.96a1.8 1.8 0 0 0-3.6 0z"
    })));
};
/* harmony default export */ var industry2 = (SvgIndustry2);

;// CONCATENATED MODULE: ./static/svg/header/platform/keyFeatures.svg
var keyFeatures_path, keyFeatures_path2, keyFeatures_path3;
function keyFeatures_extends() {
    keyFeatures_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return keyFeatures_extends.apply(this, arguments);
}

var SvgKeyFeatures = function SvgKeyFeatures(props) {
    return /*#__PURE__*/ react.createElement("svg", keyFeatures_extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 25,
        height: 23,
        fill: "none",
        viewBox: "0 0 25 23"
    }, props), keyFeatures_path || (keyFeatures_path = /*#__PURE__*/ react.createElement("path", {
        stroke: "#6C6CFF",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 1.3,
        d: "M17.818 4.016H7.182a1.56 1.56 0 0 0-1.241.672L3.28 8.369a1.534 1.534 0 0 0 .088 1.885l7.977 9.189a1.462 1.462 0 0 0 2.308 0l7.977-9.19a1.53 1.53 0 0 0 .087-1.884L19.06 4.688a1.56 1.56 0 0 0-1.241-.672"
    })), keyFeatures_path2 || (keyFeatures_path2 = /*#__PURE__*/ react.createElement("path", {
        stroke: "#6C6CFF",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 1.3,
        d: "M11.744 4 8.18 9.522l4.324 10.446"
    })), keyFeatures_path3 || (keyFeatures_path3 = /*#__PURE__*/ react.createElement("path", {
        stroke: "#6C6CFF",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 1.3,
        d: "m13.304 4 3.55 5.522L12.5 19.968M3.04 9.521h18.932"
    })));
};
/* harmony default export */ var keyFeatures = (SvgKeyFeatures);

;// CONCATENATED MODULE: ./static/svg/header/platform/integrations_1.svg
var integrations_1_path;
function integrations_1_extends() {
    integrations_1_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return integrations_1_extends.apply(this, arguments);
}

var SvgIntegrations1 = function SvgIntegrations1(props) {
    return /*#__PURE__*/ react.createElement("svg", integrations_1_extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 25,
        height: 23,
        fill: "none",
        viewBox: "0 0 25 23"
    }, props), integrations_1_path || (integrations_1_path = /*#__PURE__*/ react.createElement("path", {
        fill: "#6C6CFF",
        fillRule: "evenodd",
        d: "M8.427 2.249a.85.85 0 0 1 1.201 0l3.215 3.215.5-.5 1.2-1.2.01.008.876-.876a.85.85 0 0 1 1.2 1.2l-.876.877 3.708 3.708a3.396 3.396 0 0 1 0 4.803l-1.802 1.802 3.137 3.137a.85.85 0 1 1-1.2 1.2l-3.138-3.136-1.343 1.343a3.396 3.396 0 0 1-4.803 0l-3.708-3.708-.764.764a.85.85 0 1 1-1.2-1.201l.763-.764-.008-.009 1.07-1.07-3.216-3.216a.85.85 0 0 1 1.2-1.2l3.217 3.215 3.976-3.977L8.427 3.45a.85.85 0 0 1 0-1.2M7.805 12.92l3.708 3.708a1.7 1.7 0 0 0 2.402 0l4.345-4.346a1.7 1.7 0 0 0 0-2.401l-3.708-3.708z",
        clipRule: "evenodd"
    })));
};
/* harmony default export */ var integrations_1 = (SvgIntegrations1);

;// CONCATENATED MODULE: ./static/svg/header/platform/addOns_1.svg
var addOns_1_path;
function addOns_1_extends() {
    addOns_1_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return addOns_1_extends.apply(this, arguments);
}

var SvgAddOns1 = function SvgAddOns1(props) {
    return /*#__PURE__*/ react.createElement("svg", addOns_1_extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 25,
        height: 23,
        fill: "none",
        viewBox: "0 0 25 23"
    }, props), addOns_1_path || (addOns_1_path = /*#__PURE__*/ react.createElement("path", {
        fill: "#6C6CFF",
        fillRule: "evenodd",
        d: "M7.344 5.42a3.42 3.42 0 1 1 6.839.054h1.94a2.4 2.4 0 0 1 2.401 2.403v1.94h.056a3.42 3.42 0 1 1-.056 6.84v1.94A2.4 2.4 0 0 1 16.122 21H5.402A2.4 2.4 0 0 1 3 18.598v-2.903a.814.814 0 0 1 1.086-.768q.279.1.597.102a1.791 1.791 0 1 0-.597-3.481A.814.814 0 0 1 3 10.78V7.877a2.4 2.4 0 0 1 2.402-2.403h1.942zm3.42-1.791a1.79 1.79 0 0 0-1.69 2.388.814.814 0 0 1-.768 1.086H5.402a.774.774 0 0 0-.774.774v1.94h.055a3.42 3.42 0 1 1-.055 6.84v1.94c0 .428.347.774.774.774h10.72a.774.774 0 0 0 .774-.773v-2.904a.814.814 0 0 1 1.086-.767q.28.1.598.102a1.791 1.791 0 1 0-.598-3.481.814.814 0 0 1-1.086-.768V7.877a.774.774 0 0 0-.774-.774h-2.901a.814.814 0 0 1-.768-1.086q.1-.28.102-.597c0-.99-.802-1.791-1.791-1.791",
        clipRule: "evenodd"
    })));
};
/* harmony default export */ var addOns_1 = (SvgAddOns1);

;// CONCATENATED MODULE: ./static/svg/header/platform/github.svg
var github_g, _g2, github_defs;
function github_extends() {
    github_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return github_extends.apply(this, arguments);
}

var SvgGithub = function SvgGithub(props) {
    return /*#__PURE__*/ react.createElement("svg", github_extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 39,
        height: 43,
        fill: "none",
        viewBox: "0 0 39 43"
    }, props), github_g || (github_g = /*#__PURE__*/ react.createElement("g", {
        filter: "url(#filter0_d_2306_173474)"
    }, /*#__PURE__*/ react.createElement("path", {
        fill: "#000",
        stroke: "#fff",
        strokeWidth: 1.346,
        d: "m21.035 3.05 12.161 7.038a2.81 2.81 0 0 1 1.4 2.433V26.6a2.81 2.81 0 0 1-1.4 2.433l-12.161 7.039a2.79 2.79 0 0 1-2.8 0L6.074 29.032a2.81 2.81 0 0 1-1.4-2.433V12.52a2.81 2.81 0 0 1 1.4-2.433l12.161-7.039a2.79 2.79 0 0 1 2.8 0Z"
    }))), _g2 || (_g2 = /*#__PURE__*/ react.createElement("g", {
        clipPath: "url(#clip0_2306_173474)"
    }, /*#__PURE__*/ react.createElement("path", {
        fill: "#fff",
        fillRule: "evenodd",
        d: "M19.88 9.932a9.67 9.67 0 0 0-6.306 2.334 9.82 9.82 0 0 0-3.3 5.9 9.87 9.87 0 0 0 1.281 6.65 9.74 9.74 0 0 0 5.251 4.224c.49.09.663-.217.663-.476v-1.667c-2.716.596-3.289-1.318-3.289-1.318a2.62 2.62 0 0 0-1.08-1.438c-.877-.602.072-.602.072-.602a2.04 2.04 0 0 1 1.486 1.011 2.1 2.1 0 0 0 1.246 1.002 2.06 2.06 0 0 0 1.583-.183c.037-.495.249-.96.596-1.312-2.16-.247-4.428-1.09-4.428-4.815a3.8 3.8 0 0 1 .997-2.63 3.6 3.6 0 0 1 .096-2.594s.817-.264 2.673 1.005a9.1 9.1 0 0 1 4.87 0c1.855-1.27 2.667-1.005 2.667-1.005.358.814.4 1.733.12 2.576a3.8 3.8 0 0 1 .996 2.63c0 3.767-2.274 4.592-4.44 4.815a2.32 2.32 0 0 1 .662 1.805v2.69c0 .32.174.566.669.47a9.74 9.74 0 0 0 5.177-4.24 9.87 9.87 0 0 0 1.249-6.607 9.82 9.82 0 0 0-3.267-5.864 9.67 9.67 0 0 0-6.244-2.361",
        clipRule: "evenodd"
    }))), github_defs || (github_defs = /*#__PURE__*/ react.createElement("defs", null, /*#__PURE__*/ react.createElement("clipPath", {
        id: "clip0_2306_173474"
    }, /*#__PURE__*/ react.createElement("path", {
        fill: "#fff",
        d: "M9.904 9.687h19.614V29.3H9.904z"
    })), /*#__PURE__*/ react.createElement("filter", {
        id: "filter0_d_2306_173474",
        width: 38.403,
        height: 42.252,
        x: 0.434,
        y: 0.217,
        colorInterpolationFilters: "sRGB",
        filterUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ react.createElement("feFlood", {
        floodOpacity: 0,
        result: "BackgroundImageFix"
    }), /*#__PURE__*/ react.createElement("feColorMatrix", {
        "in": "SourceAlpha",
        result: "hardAlpha",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
    }), /*#__PURE__*/ react.createElement("feOffset", {
        dy: 1.783
    }), /*#__PURE__*/ react.createElement("feGaussianBlur", {
        stdDeviation: 1.783
    }), /*#__PURE__*/ react.createElement("feColorMatrix", {
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.200691 0"
    }), /*#__PURE__*/ react.createElement("feBlend", {
        in2: "BackgroundImageFix",
        result: "effect1_dropShadow_2306_173474"
    }), /*#__PURE__*/ react.createElement("feBlend", {
        "in": "SourceGraphic",
        in2: "effect1_dropShadow_2306_173474",
        result: "shape"
    })))));
};
/* harmony default export */ var github = (SvgGithub);

;// CONCATENATED MODULE: ./static/svg/header/platform/gitlab_1.svg
var gitlab_1_g, gitlab_1_g2, gitlab_1_defs;
function gitlab_1_extends() {
    gitlab_1_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return gitlab_1_extends.apply(this, arguments);
}

var SvgGitlab1 = function SvgGitlab1(props) {
    return /*#__PURE__*/ react.createElement("svg", gitlab_1_extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 39,
        height: 43,
        fill: "none",
        viewBox: "0 0 39 43"
    }, props), gitlab_1_g || (gitlab_1_g = /*#__PURE__*/ react.createElement("g", {
        filter: "url(#filter0_d_2411_171105)"
    }, /*#__PURE__*/ react.createElement("path", {
        fill: "#6B4FBB",
        stroke: "#fff",
        strokeWidth: 1.34,
        d: "m21.036 3.046 12.161 7.04A2.81 2.81 0 0 1 34.6 12.52V26.6a2.81 2.81 0 0 1-1.403 2.436l-12.16 7.039a2.8 2.8 0 0 1-2.803 0l-12.162-7.04A2.81 2.81 0 0 1 4.67 26.6V12.52c0-1.005.535-1.934 1.402-2.436l12.162-7.039a2.8 2.8 0 0 1 2.802 0Z"
    }))), gitlab_1_g2 || (gitlab_1_g2 = /*#__PURE__*/ react.createElement("g", {
        fillRule: "evenodd",
        clipPath: "url(#clip0_2411_171105)",
        clipRule: "evenodd"
    }, /*#__PURE__*/ react.createElement("path", {
        fill: "#E24329",
        d: "m19.5 28.25 3.498-10.769h-6.996z"
    }), /*#__PURE__*/ react.createElement("path", {
        fill: "#FC6D26",
        d: "m19.5 28.25-3.498-10.769h-4.904z"
    }), /*#__PURE__*/ react.createElement("path", {
        fill: "#FCA326",
        d: "m11.099 17.481-1.063 3.275a.72.72 0 0 0 .263.81L19.5 28.25z"
    }), /*#__PURE__*/ react.createElement("path", {
        fill: "#E24329",
        d: "M11.098 17.481h4.903L13.894 11a.362.362 0 0 0-.688 0z"
    }), /*#__PURE__*/ react.createElement("path", {
        fill: "#FC6D26",
        d: "m19.5 28.25 3.498-10.769h4.904z"
    }), /*#__PURE__*/ react.createElement("path", {
        fill: "#FCA326",
        d: "m27.902 17.481 1.062 3.272a.72.72 0 0 1-.263.81L19.5 28.25z"
    }), /*#__PURE__*/ react.createElement("path", {
        fill: "#E24329",
        d: "M27.902 17.481h-4.904l2.108-6.485a.362.362 0 0 1 .688 0z"
    }))), gitlab_1_defs || (gitlab_1_defs = /*#__PURE__*/ react.createElement("defs", null, /*#__PURE__*/ react.createElement("clipPath", {
        id: "clip0_2411_171105"
    }, /*#__PURE__*/ react.createElement("path", {
        fill: "#fff",
        d: "M10 10h19v19H10z"
    })), /*#__PURE__*/ react.createElement("filter", {
        id: "filter0_d_2411_171105",
        width: 38.37,
        height: 42.22,
        x: 0.45,
        y: 0.225,
        colorInterpolationFilters: "sRGB",
        filterUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ react.createElement("feFlood", {
        floodOpacity: 0,
        result: "BackgroundImageFix"
    }), /*#__PURE__*/ react.createElement("feColorMatrix", {
        "in": "SourceAlpha",
        result: "hardAlpha",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
    }), /*#__PURE__*/ react.createElement("feOffset", {
        dy: 1.775
    }), /*#__PURE__*/ react.createElement("feGaussianBlur", {
        stdDeviation: 1.775
    }), /*#__PURE__*/ react.createElement("feColorMatrix", {
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.200691 0"
    }), /*#__PURE__*/ react.createElement("feBlend", {
        in2: "BackgroundImageFix",
        result: "effect1_dropShadow_2411_171105"
    }), /*#__PURE__*/ react.createElement("feBlend", {
        "in": "SourceGraphic",
        in2: "effect1_dropShadow_2411_171105",
        result: "shape"
    })))));
};
/* harmony default export */ var gitlab_1 = (SvgGitlab1);

;// CONCATENATED MODULE: ./static/svg/header/platform/googleads_1.svg
var googleads_1_g, googleads_1_path, googleads_1_path2, googleads_1_path3, googleads_1_path4, googleads_1_path5, googleads_1_defs;
function googleads_1_extends() {
    googleads_1_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return googleads_1_extends.apply(this, arguments);
}

var SvgGoogleads1 = function SvgGoogleads1(props) {
    return /*#__PURE__*/ react.createElement("svg", googleads_1_extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 40,
        height: 43,
        fill: "none",
        viewBox: "0 0 40 43"
    }, props), googleads_1_g || (googleads_1_g = /*#__PURE__*/ react.createElement("g", {
        filter: "url(#filter0_d_2243_200375)"
    }, /*#__PURE__*/ react.createElement("path", {
        fill: "#F5F6F8",
        stroke: "#fff",
        strokeWidth: 1.427,
        d: "m21.014 3.087 12.16 7.04a2.77 2.77 0 0 1 1.382 2.398v14.08a2.77 2.77 0 0 1-1.381 2.399l-12.161 7.04a2.75 2.75 0 0 1-2.759 0l-12.161-7.04a2.77 2.77 0 0 1-1.38-2.399v-14.08c0-.99.526-1.904 1.38-2.398l12.161-7.04a2.75 2.75 0 0 1 2.759 0Z"
    }))), googleads_1_path || (googleads_1_path = /*#__PURE__*/ react.createElement("path", {
        fill: "#3C8BD9",
        d: "M17.105 13.726c.145-.38.344-.731.64-1.015a2.508 2.508 0 0 1 3.945.586c.604 1.1 1.244 2.175 1.866 3.262l3.118 5.425c.864 1.516-.073 3.431-1.788 3.69-1.052.158-2.036-.325-2.58-1.268l-2.743-4.76q-.028-.053-.066-.097c-.097-.078-.14-.193-.2-.296l-2.017-3.498a2.5 2.5 0 0 1-.332-1.328c.018-.242.048-.484.157-.701"
    })), googleads_1_path2 || (googleads_1_path2 = /*#__PURE__*/ react.createElement("path", {
        fill: "#FABC04",
        d: "M17.105 13.726a3.5 3.5 0 0 0-.115.664 2.6 2.6 0 0 0 .362 1.42l1.988 3.437c.06.103.108.206.169.302l-1.093 1.879-1.529 2.634c-.024 0-.03-.012-.036-.03-.006-.049.012-.09.024-.14.248-.905.042-1.709-.58-2.398a2.3 2.3 0 0 0-1.42-.73c-.725-.103-1.365.084-1.939.537-.102.079-.169.194-.29.254q-.035-.002-.042-.03l.864-1.505 3.594-6.228c.012-.024.03-.042.043-.066"
    })), googleads_1_path3 || (googleads_1_path3 = /*#__PURE__*/ react.createElement("path", {
        fill: "#34A852",
        d: "m12.628 21.542.345-.308c1.467-1.16 3.672-.32 3.993 1.517.078.44.036.863-.097 1.286a1 1 0 0 1-.024.103c-.054.097-.103.2-.163.296-.538.888-1.33 1.33-2.368 1.263-1.19-.085-2.127-.979-2.29-2.163a2.42 2.42 0 0 1 .332-1.607c.06-.109.133-.205.2-.314.03-.024.018-.073.072-.073"
    })), googleads_1_path4 || (googleads_1_path4 = /*#__PURE__*/ react.createElement("path", {
        fill: "#FABC04",
        d: "M12.628 21.543c-.024.024-.024.066-.066.072-.006-.042.018-.066.042-.096z"
    })), googleads_1_path5 || (googleads_1_path5 = /*#__PURE__*/ react.createElement("path", {
        fill: "#E1C025",
        d: "M16.845 24.14c-.024-.041 0-.072.024-.102l.024.024z"
    })), googleads_1_defs || (googleads_1_defs = /*#__PURE__*/ react.createElement("defs", null, /*#__PURE__*/ react.createElement("filter", {
        id: "filter0_d_2243_200375",
        width: 38.83,
        height: 42.685,
        x: 0.219,
        y: 0.113,
        colorInterpolationFilters: "sRGB",
        filterUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ react.createElement("feFlood", {
        floodOpacity: 0,
        result: "BackgroundImageFix"
    }), /*#__PURE__*/ react.createElement("feColorMatrix", {
        "in": "SourceAlpha",
        result: "hardAlpha",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
    }), /*#__PURE__*/ react.createElement("feOffset", {
        dy: 1.89
    }), /*#__PURE__*/ react.createElement("feGaussianBlur", {
        stdDeviation: 1.89
    }), /*#__PURE__*/ react.createElement("feColorMatrix", {
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.200691 0"
    }), /*#__PURE__*/ react.createElement("feBlend", {
        in2: "BackgroundImageFix",
        result: "effect1_dropShadow_2243_200375"
    }), /*#__PURE__*/ react.createElement("feBlend", {
        "in": "SourceGraphic",
        in2: "effect1_dropShadow_2243_200375",
        result: "shape"
    })))));
};
/* harmony default export */ var googleads_1 = (SvgGoogleads1);

;// CONCATENATED MODULE: ./static/svg/header/platform/drive.svg
var drive_g, drive_g2, drive_defs;
function drive_extends() {
    drive_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return drive_extends.apply(this, arguments);
}

var SvgDrive = function SvgDrive(props) {
    return /*#__PURE__*/ react.createElement("svg", drive_extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 40,
        height: 43,
        fill: "none",
        viewBox: "0 0 40 43"
    }, props), drive_g || (drive_g = /*#__PURE__*/ react.createElement("g", {
        filter: "url(#filter0_d_2264_200045)"
    }, /*#__PURE__*/ react.createElement("path", {
        fill: "#F5F6F8",
        stroke: "#fff",
        strokeWidth: 1.427,
        d: "m21.014 3.087 12.16 7.04a2.77 2.77 0 0 1 1.382 2.398v14.08c0 .99-.527 1.904-1.381 2.399l-12.161 7.04a2.75 2.75 0 0 1-2.759 0l-12.161-7.04a2.77 2.77 0 0 1-1.38-2.399v-14.08c0-.99.526-1.904 1.38-2.398l12.161-7.04a2.75 2.75 0 0 1 2.759 0Z"
    }))), drive_g2 || (drive_g2 = /*#__PURE__*/ react.createElement("g", {
        clipPath: "url(#clip0_2264_200045)"
    }, /*#__PURE__*/ react.createElement("path", {
        fill: "#0066DA",
        d: "m13.21 24.252.705 1.219c.147.257.358.458.605.605l2.52-4.362H12c0 .284.073.568.22.825z"
    }), /*#__PURE__*/ react.createElement("path", {
        fill: "#00AC47",
        d: "m20 16.583-2.52-4.362a1.66 1.66 0 0 0-.605.604L12.22 20.89a1.66 1.66 0 0 0-.22.824h5.04z"
    }), /*#__PURE__*/ react.createElement("path", {
        fill: "#EA4335",
        d: "M25.48 26.076c.247-.147.458-.348.605-.605l.293-.504 1.402-2.428c.147-.257.22-.541.22-.825h-5.04l1.072 2.108z"
    }), /*#__PURE__*/ react.createElement("path", {
        fill: "#00832D",
        d: "m20 16.582 2.52-4.362a1.6 1.6 0 0 0-.825-.22h-3.39c-.293 0-.578.082-.825.22z"
    }), /*#__PURE__*/ react.createElement("path", {
        fill: "#2684FC",
        d: "M22.96 21.714h-5.92l-2.52 4.362c.247.146.532.22.825.22h9.31c.293 0 .578-.083.825-.22z"
    }), /*#__PURE__*/ react.createElement("path", {
        fill: "#FFBA00",
        d: "m25.453 16.858-2.328-4.033a1.66 1.66 0 0 0-.605-.604L20 16.583l2.96 5.131h5.03a1.66 1.66 0 0 0-.22-.824z"
    }))), drive_defs || (drive_defs = /*#__PURE__*/ react.createElement("defs", null, /*#__PURE__*/ react.createElement("clipPath", {
        id: "clip0_2264_200045"
    }, /*#__PURE__*/ react.createElement("path", {
        fill: "#fff",
        d: "M12 12h16v14.296H12z"
    })), /*#__PURE__*/ react.createElement("filter", {
        id: "filter0_d_2264_200045",
        width: 38.83,
        height: 42.685,
        x: 0.219,
        y: 0.113,
        colorInterpolationFilters: "sRGB",
        filterUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ react.createElement("feFlood", {
        floodOpacity: 0,
        result: "BackgroundImageFix"
    }), /*#__PURE__*/ react.createElement("feColorMatrix", {
        "in": "SourceAlpha",
        result: "hardAlpha",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
    }), /*#__PURE__*/ react.createElement("feOffset", {
        dy: 1.89
    }), /*#__PURE__*/ react.createElement("feGaussianBlur", {
        stdDeviation: 1.89
    }), /*#__PURE__*/ react.createElement("feColorMatrix", {
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.200691 0"
    }), /*#__PURE__*/ react.createElement("feBlend", {
        in2: "BackgroundImageFix",
        result: "effect1_dropShadow_2264_200045"
    }), /*#__PURE__*/ react.createElement("feBlend", {
        "in": "SourceGraphic",
        in2: "effect1_dropShadow_2264_200045",
        result: "shape"
    })))));
};
/* harmony default export */ var drive = (SvgDrive);

;// CONCATENATED MODULE: ./static/svg/header/platform/hubspot.svg
var hubspot_g, hubspot_path, hubspot_defs;
function hubspot_extends() {
    hubspot_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return hubspot_extends.apply(this, arguments);
}

var SvgHubspot = function SvgHubspot(props) {
    return /*#__PURE__*/ react.createElement("svg", hubspot_extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 39,
        height: 43,
        fill: "none",
        viewBox: "0 0 39 43"
    }, props), hubspot_g || (hubspot_g = /*#__PURE__*/ react.createElement("g", {
        filter: "url(#filter0_d_2411_171060)"
    }, /*#__PURE__*/ react.createElement("path", {
        fill: "#FF7A59",
        stroke: "#fff",
        strokeWidth: 1.345,
        d: "m21.035 3.046 12.161 7.039a2.81 2.81 0 0 1 1.401 2.433v14.078a2.81 2.81 0 0 1-1.4 2.434l-12.162 7.038a2.8 2.8 0 0 1-2.8 0L6.074 29.03a2.81 2.81 0 0 1-1.401-2.434V12.518c0-1.004.534-1.932 1.4-2.433l12.162-7.04a2.8 2.8 0 0 1 2.8 0Z"
    }))), hubspot_path || (hubspot_path = /*#__PURE__*/ react.createElement("path", {
        fill: "#fff",
        d: "M24.965 17.708v-2.01a1.55 1.55 0 0 0 .908-1.394v-.046a1.56 1.56 0 0 0-.466-1.096 1.57 1.57 0 0 0-1.108-.45h-.047a1.57 1.57 0 0 0-1.108.45c-.295.29-.463.683-.467 1.096v.046a1.54 1.54 0 0 0 .909 1.394v2.01a4.5 4.5 0 0 0-2.124.922l-5.622-4.298q.06-.213.063-.435c0-.468-.188-.918-.52-1.249a1.78 1.78 0 0 0-2.513 0c-.333.331-.52.78-.52 1.249a1.75 1.75 0 0 0 .89 1.51 1.78 1.78 0 0 0 1.761-.002l5.53 4.22a4.33 4.33 0 0 0 .069 4.956l-1.684 1.655a1.44 1.44 0 0 0-1.577.567 1.422 1.422 0 0 0 .764 2.17 1.44 1.44 0 0 0 1.589-.535 1.42 1.42 0 0 0 .267-.836 1.4 1.4 0 0 0-.068-.41l1.664-1.632a4.52 4.52 0 0 0 2.72.905c2.48 0 4.49-1.973 4.49-4.405 0-2.203-1.65-4.023-3.802-4.35zm-.69 6.61a2.3 2.3 0 0 1-1.256-.396 2.247 2.247 0 0 1-.313-3.473 2.28 2.28 0 0 1 2.473-.477 2.27 2.27 0 0 1 1.016.833c.248.37.38.807.38 1.252a2.26 2.26 0 0 1-.68 1.604 2.3 2.3 0 0 1-1.62.656"
    })), hubspot_defs || (hubspot_defs = /*#__PURE__*/ react.createElement("defs", null, /*#__PURE__*/ react.createElement("filter", {
        id: "filter0_d_2411_171060",
        width: 38.397,
        height: 42.247,
        x: 0.436,
        y: 0.215,
        colorInterpolationFilters: "sRGB",
        filterUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ react.createElement("feFlood", {
        floodOpacity: 0,
        result: "BackgroundImageFix"
    }), /*#__PURE__*/ react.createElement("feColorMatrix", {
        "in": "SourceAlpha",
        result: "hardAlpha",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
    }), /*#__PURE__*/ react.createElement("feOffset", {
        dy: 1.782
    }), /*#__PURE__*/ react.createElement("feGaussianBlur", {
        stdDeviation: 1.782
    }), /*#__PURE__*/ react.createElement("feColorMatrix", {
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.200691 0"
    }), /*#__PURE__*/ react.createElement("feBlend", {
        in2: "BackgroundImageFix",
        result: "effect1_dropShadow_2411_171060"
    }), /*#__PURE__*/ react.createElement("feBlend", {
        "in": "SourceGraphic",
        in2: "effect1_dropShadow_2411_171060",
        result: "shape"
    })))));
};
/* harmony default export */ var hubspot = (SvgHubspot);

;// CONCATENATED MODULE: ./static/svg/header/platform/jira_1.svg
var jira_1_g, jira_1_g2, jira_1_defs;
function jira_1_extends() {
    jira_1_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return jira_1_extends.apply(this, arguments);
}

var SvgJira1 = function SvgJira1(props) {
    return /*#__PURE__*/ react.createElement("svg", jira_1_extends({
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        width: 39,
        height: 43,
        fill: "none",
        viewBox: "0 0 39 43"
    }, props), jira_1_g || (jira_1_g = /*#__PURE__*/ react.createElement("g", {
        filter: "url(#filter0_d_2411_171128)"
    }, /*#__PURE__*/ react.createElement("path", {
        fill: "#0460E7",
        stroke: "#fff",
        strokeWidth: 1.303,
        d: "m21.045 3.03 12.162 7.04a2.83 2.83 0 0 1 1.411 2.451V26.6a2.83 2.83 0 0 1-1.411 2.452l-12.162 7.038a2.81 2.81 0 0 1-2.82 0L6.063 29.051a2.83 2.83 0 0 1-1.411-2.452V12.52c0-1.012.538-1.946 1.411-2.452l12.162-7.038a2.82 2.82 0 0 1 2.82 0Z"
    }))), jira_1_g2 || (jira_1_g2 = /*#__PURE__*/ react.createElement("g", {
        clipPath: "url(#clip0_2411_171128)"
    }, /*#__PURE__*/ react.createElement("path", {
        fill: "url(#pattern0)",
        d: "M10.747 12.848h17.761V28.89H10.747z"
    }))), jira_1_defs || (jira_1_defs = /*#__PURE__*/ react.createElement("defs", null, /*#__PURE__*/ react.createElement("clipPath", {
        id: "clip0_2411_171128"
    }, /*#__PURE__*/ react.createElement("path", {
        fill: "#fff",
        d: "M10.747 10.474h18.99v18.99h-18.99z"
    })), /*#__PURE__*/ react.createElement("pattern", {
        id: "pattern0",
        width: 1,
        height: 1,
        patternContentUnits: "objectBoundingBox"
    }, /*#__PURE__*/ react.createElement("use", {
        xlinkHref: "#image0_2411_171128",
        transform: "scale(.00616 .00685)"
    })), /*#__PURE__*/ react.createElement("filter", {
        id: "filter0_d_2411_171128",
        width: 38.175,
        height: 42.025,
        x: 0.547,
        y: 0.274,
        colorInterpolationFilters: "sRGB",
        filterUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ react.createElement("feFlood", {
        floodOpacity: 0,
        result: "BackgroundImageFix"
    }), /*#__PURE__*/ react.createElement("feColorMatrix", {
        "in": "SourceAlpha",
        result: "hardAlpha",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
    }), /*#__PURE__*/ react.createElement("feOffset", {
        dy: 1.726
    }), /*#__PURE__*/ react.createElement("feGaussianBlur", {
        stdDeviation: 1.726
    }), /*#__PURE__*/ react.createElement("feColorMatrix", {
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.200691 0"
    }), /*#__PURE__*/ react.createElement("feBlend", {
        in2: "BackgroundImageFix",
        result: "effect1_dropShadow_2411_171128"
    }), /*#__PURE__*/ react.createElement("feBlend", {
        "in": "SourceGraphic",
        in2: "effect1_dropShadow_2411_171128",
        result: "shape"
    })), /*#__PURE__*/ react.createElement("image", {
        xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAaoAAACSCAYAAAAU0Y6CAAAMSGlDQ1BJQ0MgUHJvZmlsZQAASImVVwdUU8kanltSSWiBCEgJvYlSpEsJoUUQkA42QhJIKDEmBBE7y6KCaxcRsKGrIoquBZC1Yi+LYu8PdVFZWRcLNlTepMC6et575/3nzJ0v//zz/SVz584AoFPLk0rzUF0A8iUFsviIEFZqWjqL9AhQARmgwA448PhyKTsuLhpAGez/KW9vAETZX3VRcn0//l9FTyCU8wFA4iDOFMj5+RDvBwAv5UtlBQAQfaDeenqBVIknQmwggwFCLFXibDUuVeJMNa5S2STGcyDeCQCZxuPJsgHQboF6ViE/G/Jo34LYVSIQSwDQIUMcyBfxBBBHQjwiP3+qEkM74JD5FU/2Pzgzhzh5vOwhrM5FJeRQsVyax5vxf5bjf0t+nmLQhx1sNJEsMl6ZM6zbrdypUUpMg7hHkhkTC7E+xO/FApU9xChVpIhMUtujpnw5B9YMMCF2FfBCoyA2hThckhcTrdFnZonDuRDDFYIWiQu4iZq5C4XysAQNZ61sanzsIM6ScdiauY08mcqv0v6kIjeJreG/JRJyB/nfFIsSU9QxY9RCcXIMxNoQM+W5CVFqG8ymWMSJGbSRKeKV8dtA7CeURISo+bHJWbLweI29LF8+mC+2UCTmxmhwdYEoMVLDs5PPU8VvBHGLUMJOGuQRylOjB3MRCEPD1Lljl4WSJE2+WKe0ICReM/eVNC9OY49ThXkRSr0VxKbywgTNXDywAC5INT8eIy2IS1THiWfm8MbGqePBi0A04IBQwAIK2DLBVJADxO09zT3wl3okHPCADGQDIXDRaAZnpKhGJPCZAIrBnxAJgXxoXohqVAgKof7zkFb9dAFZqtFC1Yxc8ATifBAF8uBvhWqWZMhbMvgdasTfeefDWPNgU459r2NDTbRGoxjkZekMWhLDiKHESGI40RE3wQNxfzwaPoNhc8d9cN/BaP+2JzwhdBAeEa4TOgm3p4hLZN/kwwLjQCf0EK7JOfPrnHE7yOqJh+ABkB9y40zcBLjgo6EnNh4EfXtCLUcTuTL7b7n/kcNXVdfYUVwpKGUYJZji8O1MbSdtzyEWZU2/rpA61syhunKGRr71z/mq0gLYR31riS3E9mFnsOPYOewQ1gxY2FGsBbuIHVbioVX0u2oVDXqLV8WTC3nE3/njaXwqKyl3bXDtdv2kHisQFin3R8CZKp0hE2eLClhsuPMLWVwJf+QIlrurG9y1ld8R9Tb1mqn6PiDM83/rSgoBCHAcGBg49Lcu2heA/XAfpXb/rXOAe5y2BQBnF/IVskK1Dlc+CPALpQPfKGNgDqyBA8zHHXgBfxAMwsBYEAsSQRqYDKssgutZBqaDWWA+KAMVYBlYDarBBrAZbAe7wF7QDA6B4+A0uAAug+vgLlw9XeA56AVvQT+CICSEjjAQY8QCsUWcEXfEBwlEwpBoJB5JQzKQbESCKJBZyA9IBbICqUY2IfXIL8hB5DhyDulAbiMPkW7kFfIRxVAaaoCaoXboKNQHZaNRaCI6Cc1Gp6HFaCm6BK1C69CdaBN6HL2AXkc70edoHwYwLYyJWWIumA/GwWKxdCwLk2FzsHKsEqvDGrFW+D9fxTqxHuwDTsQZOAt3gSs4Ek/C+fg0fA6+GK/Gt+NN+En8Kv4Q78W/EOgEU4IzwY/AJaQSsgnTCWWESsJWwgHCKfg2dRHeEolEJtGe6A3fxjRiDnEmcTFxHXE38Rixg/iY2EcikYxJzqQAUiyJRyoglZHWknaSjpKukLpI78laZAuyOzmcnE6WkEvIleQd5CPkK+Sn5H6KLsWW4keJpQgoMyhLKVsorZRLlC5KP1WPak8NoCZSc6jzqVXURuop6j3qay0tLSstX63xWmKteVpVWnu0zmo91PpA06c50Ti0iTQFbQltG+0Y7TbtNZ1Ot6MH09PpBfQl9Hr6CfoD+ntthvZIba62QHuudo12k/YV7Rc6FB1bHbbOZJ1inUqdfTqXdHp0Kbp2uhxdnu4c3Rrdg7o3dfv0GHpuerF6+XqL9XbondN7pk/St9MP0xfol+pv1j+h/5iBMawZHAaf8QNjC+MUo8uAaGBvwDXIMagw2GXQbtBrqG842jDZsMiwxvCwYScTY9oxucw85lLmXuYN5sdhZsPYw4TDFg1rHHZl2Duj4UbBRkKjcqPdRteNPhqzjMOMc42XGzcb3zfBTZxMxptMN1lvcsqkZ7jBcP/h/OHlw/cOv2OKmjqZxpvONN1setG0z8zcLMJMarbW7IRZjznTPNg8x3yV+RHzbguGRaCF2GKVxVGLP1iGLDYrj1XFOsnqtTS1jLRUWG6ybLfst7K3SrIqsdptdd+aau1jnWW9yrrNutfGwmaczSybBps7thRbH1uR7RrbM7bv7OztUuwW2DXbPbM3sufaF9s32N9zoDsEOUxzqHO45kh09HHMdVzneNkJdfJ0EjnVOF1yRp29nMXO65w7RhBG+I6QjKgbcdOF5sJ2KXRpcHk4kjkyemTJyOaRL0bZjEoftXzUmVFfXD1d81y3uN5103cb61bi1ur2yt3Jne9e437Ng+4R7jHXo8Xj5Wjn0cLR60ff8mR4jvNc4Nnm+dnL20vm1ejV7W3jneFd633Tx8Anzmexz1lfgm+I71zfQ74f/Lz8Cvz2+v3l7+Kf67/D/9kY+zHCMVvGPA6wCuAFbAroDGQFZgRuDOwMsgziBdUFPQq2DhYEbw1+ynZk57B3sl+EuIbIQg6EvOP4cWZzjoVioRGh5aHtYfphSWHVYQ/CrcKzwxvCeyM8I2ZGHIskREZFLo+8yTXj8rn13N6x3mNnjz0ZRYtKiKqOehTtFC2Lbh2Hjhs7buW4ezG2MZKY5lgQy41dGXs/zj5uWtyv44nj48bXjH8S7xY/K/5MAiNhSsKOhLeJIYlLE+8mOSQpktqSdZInJtcnv0sJTVmR0pk6KnV26oU0kzRxWks6KT05fWt634SwCasndE30nFg28cYk+0lFk85NNpmcN/nwFJ0pvCn7MggZKRk7Mj7xYnl1vL5MbmZtZi+fw1/Dfy4IFqwSdAsDhCuET7MCslZkPcsOyF6Z3S0KElWKesQccbX4ZU5kzoacd7mxudtyB/JS8nbnk/Mz8g9K9CW5kpNTzacWTe2QOkvLpJ3T/KatntYri5JtlSPySfKWAgN4YL+ocFD8qHhYGFhYU/h+evL0fUV6RZKiizOcZiya8bQ4vPjnmfhM/sy2WZaz5s96OJs9e9McZE7mnLa51nNL53bNi5i3fT51fu7830pcS1aUvPkh5YfWUrPSeaWPf4z4saFMu0xWdnOB/4INC/GF4oXtizwWrV30pVxQfr7CtaKy4tNi/uLzP7n9VPXTwJKsJe1LvZauX0ZcJll2Y3nQ8u0r9FYUr3i8ctzKplWsVeWr3qyesvpc5ejKDWuoaxRrOquiq1rW2qxdtvZTtaj6ek1Ize5a09pFte/WCdZdWR+8vnGD2YaKDR83ijfe2hSxqanOrq5yM3Fz4eYnW5K3nPnZ5+f6rSZbK7Z+3ibZ1rk9fvvJeu/6+h2mO5Y2oA2Khu6dE3de3hW6q6XRpXHTbubuij1gj2LPH79k/HJjb9Tetn0++xr32+6vPcA4UN6ENM1o6m0WNXe2pLV0HBx7sK3Vv/XAryN/3XbI8lDNYcPDS49Qj5QeGThafLTvmPRYz/Hs44/bprTdPZF64trJ8SfbT0WdOns6/PSJM+wzR88GnD10zu/cwfM+55sveF1ouuh58cBvnr8daPdqb7rkfanlsu/l1o4xHUeuBF05fjX06ulr3GsXrsdc77iRdOPWzYk3O28Jbj27nXf75Z3CO/13590j3Cu/r3u/8oHpg7p/Of5rd6dX5+GHoQ8vPkp4dPcx//Hz3+W/f+oqfUJ/UvnU4mn9M/dnh7rDuy//MeGPrufS5/09ZX/q/Vn7wuHF/r+C/7rYm9rb9VL2cuDV4tfGr7e9Gf2mrS+u78Hb/Lf978rfG7/f/sHnw5mPKR+f9k//RPpU9dnxc+uXqC/3BvIHBqQ8GU91FMBgQ7OyAHi1DQB6GgCMy/D8MEF9z1MJor6bqhD4T1h9F1SJFwCNsFMe1znHANgDmx1s9GAAlEf1xGCAengMNY3Iszzc1Vw0eOMhvB8YeG0GAKkVgM+ygYH+dQMDn7fAYG8DcGya+n6pFCK8G2xUcVxhzk4F38i/AWeVfpxslGIkAAAfpElEQVR4Ae1dvY4cSXJeng4yBAE7ECDjzple51zOQpYAAax15O7sE0zzCXbWlsHmE+zwCbb5BGo+wdY4cm/onnM9znnC9UJyJOiO+r5hxrA6mVWdVZn1O18AMVmZGREZ+VVVfpXVzeazLyS1CHz48KGs7XzaHQdMf/fs2bPt04ZBsxcCQmAIBJ4NMchcxwBRfZhr7gPlfY9xLkFYdwONp2GEgBB4ggiIqBpOuoiqAZxPXb/gsBBZfQJER0JACORF4Fd5wy0uGncMkmYEvkT3TbOJeoWAEBAC3REQUTVjt2/uVq9D4AV2nyuhIQSEgBDoAwERVTOq++Zu9VYQKCrHOhQCQkAIZENARNUMpb4k0IxPtXdVrehYCAgBIZALARFVM5IiqmZ81CsEhIAQ6B0BEVUDxPgmW4lufqtNIgSEgBAQAiMhIKI6DXx52kQWQmDeCODLMGfQNXQLLaEmBxywzvb1vGep7IXAQhHgzQmVnEZgs9BLYPHTwqndQElIMUK768WDoglOCgHtqE6fjh1M9PrvNE6ymBkCIBzuovg57Cso/z1cjNDuR/hxl3UW4yAbIZCKgIjqBIL4nOoAE5KVRAgsBgFHMiUm9LzjpF7Aj/4SIdA7AiKqOIg3cWayEgKzQWCDTLuSlE3yOQiPcSRCoFcERFQR8GJXtYfZbYSpTITA5BEAuayQ5PeZEn3l4mUKpzBC4HMEfv15k1pqEFij/Y81fWoWAo0IYDFfw4DaVe7wwHTd1dnzyxXHwl7i4MYqKoVAbgREVJGIcleFxeYNzHM9iUaOLLOFILDCPPi5zhSExJJTRFQ50VSszxDQq7/PIGls2KBX3wBshEidU0YAD1tnyO88c45TIeDM01K4qSAgompxJtw3AHM/jbbIQKZCIBmBi+QICiAEBkZARNUScJBVCRe+ApQIASHgEMBOrRAYQqAvBERUHZB1H2rrW4AdsJPLYhG4W+zMNLHRERBRdT8FfAX4vru7PIXAKAgc+hjVvRbvI7RiCoEvRFQdLwJ3YxZwF1l1xFBuwyOA67aPnc/98DPRiE8JARFVwtkWWSWAJ9cxEXiXefAyczyFEwJHCIiojuBoX6mQVe6bv30y8hACcQjs4syirXLHix5Yhk8DARFVhvNMsoJeItTrDOEUQgj0igCu1S0GyPW67j3iiah6PWMKLqLKeA3ght0g3NdQfW6VEVeF6gWBdaaoueJkSkdhloiAiCrzWQVZ8TfZLhCWu6tfModXOCGQBQFcoyUCvUwM9pLXe2IMuQuBkwiIqE5C1M0AN/AGniuoCAsgSKaHAK7RLbL6Dtr2geoePt84fxxKhEC/CIioesQXNzI/u9pgiBX0B+h7qEQITAYBXJ/8fGkF5QMVCahJ2M/r+AJ+ZZOh+oRATgT06+k50ayJRcJC1w0VPzWzQnnpVD/mCSAk4yLgrs8Nsti463OF4wJqUuJgD7u9NagUAkMiIKIaEm2M5W72B9Li0FgYLlCsoCwpxcPfbn9EfN1wk5dDwF2fe1RL16RCCIyOgIhq5FOAheEOKVB3qamA9D6kxpC/EBACQmBqCOgzqqmdEeUjBISAEBACRwiIqI7gUEUICAEhIASmhsCkXv3hzdUZALroABJfedlrLzu2kuHsOGRzqr+Ljx8zNgb96uR/8JrwP+s61S4EhIAQWCoCkyIqgEyS+rkj2H+Bn6//F2jzbU7Vh45RO30Q+X+j8z/cB961duoQAkJACCwJgakRVQq2f1Pj/Azt1BQZMgaJs07+Hh3/CsIqQVZ/qDNSuxAQAkJgSQhMjagOieDWkZWFHZJwbMxQeSqPJrJivIK7K5DVn0LB1SYEhIAQWBICkyIqLLx3WIBT8T1FVhb/FFmYXVOZK0ZojFNk9U9wElGFkFObEBACi0JgUkTlkOXvjn2ZiHIsWSUOc+SeSloh/yay+s3R6KoIASEgBBaKwBSJ6g5Yv8iAd1uyChFFhjQ6h2A+lFqywu7zt3r99xEk/RUCfSKAe+0M8fllLwpL1n3hz0xt/cYx6sh3hXGpBbSaO6pH6yt/f/TARsje6R1K/i8QrE9ClkxUBLgtWdlJyUFaRjQWs21ZJajqcds4shcCQQQqi1mw/1QjFrLylE2X/sS8+EPQXGiTBDlcIsAFtHBlzFueW9huoYML8j3DoAWUebM8h8bI84rR0QYBMe/RV0J3wHRXsWt9mHpOp0hUBOb71kjUO3QlK4uYSlqp/syDMUhWyR/gMZhECDgE1ihfJaDB67IPWSNo17xu4VtAW4sjpzUcv23tPJIDci4w9Bp6Bc0t5wjIuFcYhx/JkKw2HXdaa/h2PqdTJSrMKauQrHIRRkpiqTmIrFLQl68Q8BDAAsydyBp6DeXCPAtB3mskuoEOlTN3lEZafBi4zrFzRZwo+VWU1YBGmPwBw73rYUjOlYRFcqbyuIua/1gxSHYSISAEEhFwi/0dwvwIHWrBT8oaOfOfpjDnn0bM+QXG/j3y4H9bdJY0oUjnyRGVy3sXmX9bMyMrI6wuRFX1MbKystoXe9yF+ERWbc+87IWAQwCL6wpaojrmYt/qfJAQoFs4/Qx93sq5P+PvEXqPvIr+hvgY+akRFWftk5URRSyx+HZGUlb6/W3qFsPKJt8QWfEbPBIhIARqEHCLKnck3BXMQio5X00wYb4S/Bk5bvrMbZJE5V7/ve1x4lWyMjIgOZhaW9vS/GOIpi62+VpZZ8d2Xw5+g+pCQAh8RACL6RpH3JFwcZ2FVHI+n3jCr5Drtq8cJ0lUbrKbvibt4obIykghF+FYHIvbtjT/OtLyd1V8UpQIASHgIeAW/J+85klX3cI/p5yv+iIrLoCTFH4FEpPmruqqxwRjiZqE4JNC27SGiCGiantWZL94BLCOrDHJOS34X7gFv8+1r6/zfoXcv8D6TcyzyWSJys1wg/IS2udWPZasXErZvubeB/GVlqRKISAE8A8PP/7DXZHUsBcDyYq/0rHJNWzbRTrXuFFxuKuC4U2UcZoRcejyWo4+da/lYuLR1zTG3rc5IjuH130aFPIWAstAAIvlCjPZzmk2yHmDfOe4k/JhfoW5FH5j1/qkiYqTcqw8xLfZxiIrIx8jrDbEd0RU7iLYdb0Y5CcEFoYA74U+38ZkhQsL+xoBX2UNOm6wHeZ0liOFyROVm+QaJX/Co2/pQlYpRGO+fhlLViGi2vYNkuILgakjgAVygxyfTz1Pyw/5XuD4xuoLKfmQkGVOXBAnL9hV8f+pukaiQ7xrJlmRAEIk0AarUWI4rO6R6HmbZGUrBJaCANaKFebC9WJOskWyQ+3++IbqAC2hITlD4wV0BU1dR65wPraIkySzICrOEAvw1l2AQ2yNSTLc5VBGIZyPQx/9DeXBtpDcoPHHUIfahMATQGCDOaYu+reIsXeK4uiYdYot6B9rHf9iXdvA9XlH9xg3EtMWyv+6o0QZLciNc7yEFq7sgusGviW0s8yGqDhDgLxxZHXVecbxjiQBIyvzCpGF9cWWuWJwPMYKyRaNG2iXiwpuEiEwWwQukPmLltnzY4USumOJdWaPMlbo01l6fPjmnG6g25bzOZoLfA+MQa2Q1gb1NjuttucD4Y9lVkTF1AHcGoDx8Ip/epYQWdmQOQnHYrYtg0TFiwsY8SJ91Tag7IXAzBFo83B2i7lyId+OOOfcYxtB3TiSyTY1F4/5krSuUW6gsXgnkdVcvkwBPD4JAFuj9vpTS69HJAP/yw7VOsm+Wm97bP5WtvEPEpVDg0R1745VCAEh8AkB3hffYB0poNtPzcMeYbEvMGLSAu5lfIv6Bea0gXIn1JsgPteXFZRj9i6zJCqiwpOB4iWUTxB9yzMM0EQgJBnTJru6PiMpK+vs/PbaebsLlU89EiEgBD4h8Br3xgpafmoa7YiLfS55gzmRePe5Ap6Kg7EOHBN2r0/ZpvbPlqg4cYC0RXEBfQ/tW06RlZFICmExhvnHkBZzqhXgs0Pnu1oDdQiBp4MAH2i/wT2xmcKU3W7qeaZcXmJeoz2UOkxfZppLMMysiYozAkh7KMmKrN737iqWrNoSjpGcX54irUaiIj6QNbRvXDiORAhMFQFe/9xtlBNKcJMpl5eY1zZTrM5hXA69kdXsicqQBVAbHJOw3lpbT2UbsjLiOUU4ZtdUhmKcJCrgcgAORU9YKKwQmAMCl7gP7qaSKHZTXKdyfDbF133bqczL5fKmj3wWQ1QEB0Bxd7XG4VdQAtbXTqILWRkJhQjH+mJLi3GSqIABceFN+pLHEiHwxBB4jeu/nNicrzPkc4t55YiTIZVPIVxOt59a8hwtiqgMEoBFwrqGnqGNC/Q768tYkiRiiaXOjoTDPivr7Orao6cDLLYwFllFIybDBSDwHtf9ZoLzuEzMiQ/g68QYfbozt6ybBC6Qixa3QG85SfcBZoHDC+gKmvphJsmKGLJMkb90dG41LrEABhzqp47jyU0IzAmBye04cP+RpGL/7VEd1je4l/d1nWO3MzfM8wZ5vMqVy+KJqgoUACxRpx4JQD1Dw8VRY1yFPj9CueOhkDhakceD1/GfNjFajyWyOgZbtcUicOvu96lN8DIxoXvMa5MYYwj3GwxyDU0l5YdcnxRR1Z0dnPgD+sq6/rp2tzuxbiMrq7chHPPxy1MxWhMVB8B8ubPa43AHzXIhIY5ECEwJge2Ukqnkclk57nK46eI0tA/X1Jy7qkV+RjX0SamMF/osiQ8DpqH+mDbzZ1m1rwzd7hAXUgmPFfQWKhECS0OAD2GTEizcBRJKeTD8hQ+Zk5pUczI36M7yWZWIqhnoLr1VIvGP6wjHt2uqV2N02lHZpPjUAy1QfwnNckFZbJVCYEQE3vHaHnH8uqGLuo7I9m2k3STM3DnI8sDwa7D8GrOinhJ+Cv9Xp/zwn8dss2Prq5bWF7Jjn8VssrN4ZmP1ahmKVe23Y4vh54NUgvJfaP0DAP9TsLe+kUQTIySaFLJJ8X3MD/Pjq0BeUNfQV48dOhAC80SgnGjaRWJe20T/Mdy5rlylDsyn8xX0RWQgW+C54JuSBOy4Wobap9wWguA3aPwdFvE9yhIL+v+GjGraYsmqxj2qOQtRcST39LPBXG9QJWFRU15TwF0iBEZB4G6UUU8PGrvOhiLd4x6d6rxC+T60IWf+d/S1/bEdfPV3iDWGHRdG+nARNmXdb2PfmG3+2H7d8qu2I+VaWaGnqO2t7zCMYsrqK70Ye9pkIyqbAgkLuoGeoe0l9J31qRQCc0AA1245tTyxWBeJOe0S/cd0T15DuDi2ZWku7qkSS7Ehu1BbbD6nfLkjrJMVLrbf4Sb4Q51BTTsJpYuQhLITUZtEMNct7KlfuButwOGF03OUEiEwNQSm+lnrKhGoMtF/THdyzLcpCZCoukgTWYXIINQWGjfWLrdvNV4jWcGwLVExdleysrzqSGswInNPqaUlZGXlSXFvbSqFwIgItH3wHipVPuClSJniPLIvc3+VksOvuQBhsekSw8iqk3OXASN9YvMJ2VlbHVn9NjKHkJm9qksll6p/9Tg0Zu9tjsB6H0cDCIGZI5BCVPwpqMOM55/88GA7qnuAcN4BCCOrNq5GBqd8QnahtlNxrL+tb4is/taCdSyreKWSDP1TY3SchtyEgBBoicCqpX3VfF+tzO2YJNtxM/Q4VSMqMt75Y2u7g+riGyKDUFtohFi73L6heGxjPvyWYm6p4pUaW0SViqD8hcAwCJwnDJO8I0kYO5frLQK96BrMiKpEgJQPu3IuvrFzCRFbqC0UL2QXaqPvEGSl3VHoLKlNCCwAAewmzhKnsU/0n727EdUOM/kxcTYxZFVHBv7QIbtQm+9XV0/xZcwhyMpyb0Na2lEZaiqFwHQRuEhMbZ/oPwX3Q0oSD0SFd4h7sP57BHqeEgy+PlnFEkSsXZv0UmKGfIckK5vnKdISURlSKoXAchFIWuQnAssd8uj81s52VJzLFpq6q2Icn6zYlltCRBJqC40bsgu1hXx9sspxAcXiFSItEVXoLKlNCEwLgbOUdLCR4CL/pKUPoiKgocU3lgxCdqG20U8cL6DUb7O4SYTwappfiLSa7NUnBITAeAhcjDf0MkZ+JCr3FcK3mNZVpqnFLr59kFBKzJBvqM1gusfBuVUSyli8qkNoR1VFQ8dCQAgsEoFHonKz26C8yjjTNotvExlUUwrZhdqqPnYcsgu1mX1MyW35eYxhhE0bvBhORBUBqkyEgBCYNwJHCyO/VIHpvMk8JY5B5S8zmPr1uvaQL21D/m3afFu/3jQGhj+S3O+PQ7kYPn4pojo6FaoIASGwRAS4KPqyQUPuH3YMLfwcO7Qop7b5/n7dFnu/nfWYNpgdSXlUy1NhHtztUi3fUCmiyoO3oggBITBhBPxXfw//LxG+ILBGzv+eOW8utHUS+/otZBdqC40TaxfyrW3DLpS/lUhi/7LWqFsHScgw47FIqRuO8hICQmDmCPDJ/TPB4rtD47vPOtIbuPD6uxbbKfjtrPttdf5t7Hxbv25j+O2sU0NCvPoQIyvDyHZZttMSefWBumIKASEwKQTqFl4muYbe8yCz1BGBtduibKVPGE12vq1fr4tJu5BtqC0ER19ExbF8srI5kKxEVKGzoTYhIAQWhcBnr/5sdu7r6peol9Dcr7W42JrEvpIL2YXaLG61jLWr+kQfcweK138k9fNop3aGRla+l4jKR0R1ITA9BO6ml9K8MuKOoVawABNgklUfYjsDlv7OhXW/LWTXts2P6dctnt/OurXVYXFT15Gp3ciKOZqKqDKBqzBCoEcEDimx8RC8SvFfgi8X30YBWZUweNlo1L3TFtwmgqjamF2ozYjE+vx6XTvtQrZ1bXWz3aIj97cl/bF8svL7VRcCQmB5CKwWMKUiZQ5cjE8KyGoLo++gfSzERiBW+gTBekwb/bvahXzr2jDM5wKM+NS0+bwne0uVrLSjyg6vAgqB7Agk7aiyZzPDgFzYowQL8Q6GBXQMsqojDZ+Ymux8W79uvn4769U2VMMCjG7Q8z7cm7XVyEpElRVWBRMC+RHAunCXGLVI9J+C+1lKElyAo8UBvoLDbbRTvGGVDIw0WFbVtzE7v511v81s/XgxdlXfUzO6PmWQqZ8kJaLKBKbCCIEJI5C0yE9kXs9T8uAi3UpAVgdoAacfoDl3V1x0fdJgPaatSiQ+EVXrOeyQUr0AmxK9b+ot1CMEhMATRCDl4f5iznjl+DJIa6IywLAg3+CYAL61tgxliKyMXEKEFUtCsb4hO7/t5DSBzTWMhngFeDIXGQgBITAJBA4JWbxI8J2CK3kiSbgIdxYsyHvoGgG+guYirDqyMsKqkhPz94kk1BbrG7Lz2zBklBSwyrnjjBpURotFYL/YmT2Nid2lTBO7kuTFPmX8RN8i0f9hkU+Nwd8HrBLWawS8TwxqZOWTkE8arA/ZxnyiBJjwCaqAiqyiEJPRCQT2J/rVPW0EkogKUyumPb3G7JJzj154G9NwnY6wNihXaPoaStK6hXYRkpWREPM0UrK2at3aQnahtq6+9IsW4MCLs4CKrKJRW6whrwPJ00XgSRKV+3wq6YsUvGRqf0Ip9Xpyi/TjyXFb1zPELVrG5s8fUf/qyn9B+c9QCtu7Sopv9JjEAXMv4FBCc/8UFUJKZoIAr/0U2ac4y3dcBLAO7LEO8IG16xpQjDuDzqNfdvasOPZGVJUxHg4dcfG4fGjo+Acn+9/gSrIaWjoTmyOrCyS8gyY/XQw9cY2XBYHU877PkoWCjIlAicG/7ZjAl1j7LrGWcA2Zk1znSJavxeYm9kqw+vqO86DGtFVteBzra7ad8OITFRwL6Fuo5AkhwAUmw3QPGWIoxLgIlInDrxP9B3XHdV9gwPMcg3KRnpsYsbAMkc6pNvM/ZWfE5Nt1xgtkxX+DtkaA76D63KozkrNzLFIzxnVzlxpD/qMjUCZm8C0W/1VijCHdN7kG46I9N6nuqNqQlW/r1+uIiXZV22S8sOjsEGQFfZMcTAHmgEDqjur9HCapHJsRcA8b981WJ3uvT1pMwMDtpl7kSoUL8NykSlRGLlUiqWuzdpamPgmZjR/P2llmEVy03F3xovsK+jZLUAWZHAK4YddIKvX1x93kJqaEuiJQdnV0fuuZ7Kq2ifM8cp8jUXECPllViYTHpk2EYzbm69v6dbM7AjC1ArLK/W/QUlOSf14ENhnCiagygDiRELvEPPitwU1ijF7dQaTML/Xh7CjHuRIVJ9GGrHzSYd1vMyI6RWBHAOaqOMLK9W/QcqWlOAkI4IbljjnHDVsmpCHXCSGA+5xElfr59BWurWJC03pMxeX16rEh08FgX0/PlK8fhmQVItsPvuGc6riY+QRNfRCc/AscrKAsKSunB1Yk00PAnbNNhsx+cddDhlAKMREEtsjj+8RcdrjGVrg2JrMGuGt+lzivoPvciYqTChFVcLINjbHEFmvXMFT7rgpx9XIRtM9IHk0I4IY9Qz/PFV/TpIrOeSqC0/O/QUqpRMVrq8S1VkyBrBxJlcgpxzWPMMeSY5E/jjhOjfOgVl/b2as8v73JtupfZzfODDXqLBBwN+wdkj3PlLCIKhOQUwkDYtkjl9sM+TxHDJLeqNI3SXFyXIyXIkYsLKuEY4SVq20peD2JeeAm2kD5TamzvieMMa4xRgnNRVJ87Sei6vvEjRN/k2nYK1x3/Jm23q/vUL4Yd432EtrLTgpxH2RJRMUJGUlZWSWnuja/3a8b0Vn7R+T0dy4IFEj0J+ifcVPxvX72r/e6mHuM8SM05w27RTzJAhHAA0iJaeXYVREd7qxIVhesDCEY6wzKhyjeWzmv+WD6S/iMyp8YCcXkgx1UylBbpfvxMNbu0UEHk0fgW2RI/QI32T2Ku4ry37WVqJ8UtyBwUSigl9C+btQbxJYsF4ENpvZzpumdI87vcW2+RnmDa/mQKe5RGMQ/Q8O1076u+6MxWVkiUXFeVbJiXSIEfAR4Y1MfiIuduAlZUEhiex54skKdPkPIWyw2+yEG0hjjIMAHI1xz3FW9yJjBK8S6Rlw+5GxzXUOIt0K8NZQk1YWg3sLvCtpJlkpUBCOGrD5EohZrFxlOZhNH4Bz5UceUzZiDa+zBEFhjpD9mHo1E8ooKgnmHsqSCtO5QRgt8CxhTL6HPoV2Fu7wkmSNRlZgxT0KM+GT1IcYJNrF2keFkJgRaIfA215Nwq1FlPDgCPM8gBC7ksWta2xz5xoBqbwy4gztA60irQN8ZNIWY4P4o9zi6gV4/tnQ4mCNRtZ2mT1Zt/WUvBIZEgL9akHRTD5msxkpHAGS1AVldIlIucmhK6oXrfCCvJsNMfWvM74D5JYWb3SKOSZcdZsx5+t8ADLVVbfxv+1lfh+HlIgSiEXi4saOtZbgUBEhUqT+tNDUs3nRcrz+bx+yIys3g/WczOd3gE5MRkRGQ1U/ZnR5JFkKgGwK8sXfdXOU1ZwRw3vfIfz3nOXi5v8ecsr0ZmCtRlR4osdVTJGSkRTvf1uqxY8lOCLRBIOuN3WZg2U4DAfeQ8nIa2SRlwc+liqQInjMX3zlKmZA052ykUyUmO66WIbuEoeUqBIII8A1BEexR45NCAGS1xYR/mPGk+fryEvM45JzDXL9MUSaCQDIKSdonfqGIahMCzQg8kFTuG7t5SPVOGQFcCzf48gEX+p+mnGcgN5JUgfzvAn1JTdwxzE7cTf0uMXGSlb9jsja/vVpPHFbuQuARgbc44o2d9enzMboOZosAroktkp/Ta0A+cK36ICmexFkSFROHbB/+pv0xYmLpa5WczG7OeKUhJe/cCPyAm1rf8MuN6oLiObL6GlPiTmXK0vsD12wXXpzEHc4cP7RLlSoJnSIr9kuEQAoCt3D+CtfvTUoQ+T4NBHCd8DXaCpr6BqkPwEig3yHH3h+4ZktUDvVNJvSNoIgH1eos/XqmIRVmIASm8lqNBPUNbuoCuh9o7hpmAQjgeuEPJl9iKt9Bczyc50DlLYKskNcuR7BTMWZNVABpiwnmOnFN5FQlsFOYqn9CCLgb/Guk9Ab6foTUeEN/gzxIUOUI42vIhSCA62cHXWE6L6G51j2EaiW8nr9CHmvoYA+Bc/3WXxXZDSq5vh1DsqqKvgVYRWOmx7ih7pD6NdPHt6nOUBROL1BSv4TmEi4gJXTHcsibGeNJngACuKa2mOYW1/IaJfUFtE/hNb2lYuw9ysHl2eAj9jAgTliJsDlP1l8Qr6p/tTpO1D/iWLIgBBx5kbBWTjk71s940CAH9N1BrbwTMTWgpa5eEMD1u0LgS2jhNMeD1y1ilVDu4niNjypLIaoVUCSYOU6QnZAqUfH4gaxw0v7BDFQKASEgBKaGAIjrAjlRVxXFYa3s0WPKh63RicnPdBFExUnh5KxR5HoF+BASfx53Ujh+ICucxJxkyHEkQkAICAEh0IDArL9MUZ0XCGSL+ttqW+IxSZz4+F+ySAwrdyEgBISAEGiDwGJ2VDZp7KxKHOf8vOoD4j3urECIf2djqRQCQkAICIH+EVjMjqoC1SWOc34N2d9ZVYbSoRAQAkJACPSNwOKICjueA0AroH2Q1eLw6vsCU3whIASEQCoCi1x4K2T1LhWgij93Vv6/s6p061AICAEhIASEQAcE8JnVBppNOqQgFyEgBISAEBACzQiApQroPgdbNY+kXiEgBISAEBACHREASZ1B+R+SJUnH4eUmBISAEBACQiAOAbDUBbTsylZxo8hKCAgBISAEhEAiAo6wtm0JK3FYuQsBISAEhIAQaIcAiIqvBNfQXQxptYsuayEgBISAEEhFYHG/TJECCEkL/hfQwpUrlM+hj4KvvguzRzR0IASEgBDoH4H/ByB8TRXCvla5AAAAAElFTkSuQmCC",
        id: "image0_2411_171128",
        width: 426,
        height: 146
    }))));
};
/* harmony default export */ var jira_1 = (SvgJira1);

;// CONCATENATED MODULE: ./static/svg/header/platform/mailchimp.svg
var mailchimp_g, mailchimp_path, mailchimp_path2, mailchimp_defs;
function mailchimp_extends() {
    mailchimp_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return mailchimp_extends.apply(this, arguments);
}

var SvgMailchimp = function SvgMailchimp(props) {
    return /*#__PURE__*/ react.createElement("svg", mailchimp_extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 39,
        height: 43,
        fill: "none",
        viewBox: "0 0 39 43"
    }, props), mailchimp_g || (mailchimp_g = /*#__PURE__*/ react.createElement("g", {
        filter: "url(#filter0_d_2411_171071)"
    }, /*#__PURE__*/ react.createElement("path", {
        fill: "#FFE102",
        stroke: "#fff",
        strokeWidth: 1.345,
        d: "m21.035 3.046 12.161 7.039a2.81 2.81 0 0 1 1.401 2.433v14.078a2.81 2.81 0 0 1-1.4 2.434l-12.162 7.038a2.8 2.8 0 0 1-2.8 0L6.074 29.03a2.81 2.81 0 0 1-1.401-2.434V12.518c0-1.004.534-1.932 1.4-2.433l12.162-7.04a2.8 2.8 0 0 1 2.8 0Z"
    }))), mailchimp_path || (mailchimp_path = /*#__PURE__*/ react.createElement("path", {
        fill: "#1A1919",
        fillRule: "evenodd",
        d: "M23.877 18.935q.196-.025.368 0c.066-.152.078-.414.018-.699-.088-.423-.208-.68-.455-.64s-.257.347-.168.77c.05.239.138.442.237.569M21.753 19.27c.177.078.286.129.328.084.028-.028.02-.082-.023-.15a1.04 1.04 0 0 0-.457-.37 1.25 1.25 0 0 0-1.214.147c-.118.086-.23.207-.215.28.006.023.023.04.065.047.098.01.439-.162.832-.186.277-.017.507.07.684.148M21.397 19.473c-.23.036-.358.112-.44.183-.07.06-.112.128-.112.175 0 .023.01.036.018.042q.015.015.038.015c.052 0 .168-.047.168-.047.321-.115.533-.1.742-.077.116.013.171.02.196-.02.008-.01.017-.036-.006-.073-.054-.088-.287-.236-.604-.198M23.16 20.218c.156.077.328.047.384-.067s-.025-.269-.182-.346c-.156-.077-.328-.047-.385.067-.056.115.026.27.182.346M24.165 19.34c-.127-.003-.232.137-.235.31-.003.175.098.318.225.32s.232-.137.235-.311c.003-.175-.098-.318-.225-.32M15.625 22.483c-.032-.04-.084-.027-.134-.016a.5.5 0 0 1-.118.017.26.26 0 0 1-.218-.11c-.058-.089-.054-.222.01-.373l.03-.068c.101-.23.272-.612.08-.977a.87.87 0 0 0-.662-.482.85.85 0 0 0-.73.263c-.28.31-.324.733-.27.882.02.055.051.07.074.073.048.006.118-.028.163-.148l.012-.038c.02-.064.057-.18.117-.275a.51.51 0 0 1 .708-.147c.197.128.273.37.189.6-.043.12-.114.347-.098.534.031.38.264.532.473.548.204.007.346-.107.382-.19.022-.05.004-.08-.008-.093",
        clipRule: "evenodd"
    })), mailchimp_path2 || (mailchimp_path2 = /*#__PURE__*/ react.createElement("path", {
        fill: "#1A1919",
        fillRule: "evenodd",
        d: "M17.56 15.525c.664-.767 1.482-1.434 2.214-1.809.025-.013.052.015.038.04-.058.105-.17.33-.205.501-.006.027.023.047.046.032.455-.31 1.248-.644 1.943-.686.03-.002.044.036.02.054a1.7 1.7 0 0 0-.306.307.03.03 0 0 0 .024.047c.488.004 1.176.175 1.624.426.03.017.009.076-.025.068-.678-.155-1.79-.273-2.943.008-1.03.251-1.816.64-2.39 1.056-.029.021-.063-.017-.04-.044m6.045 7.757a.05.05 0 0 0 .031-.053.05.05 0 0 0-.055-.045s-1.417.21-2.755-.28c.146-.474.533-.303 1.12-.256a8.2 8.2 0 0 0 2.702-.292c.606-.174 1.402-.517 2.02-1.005.21.458.283.963.283.963s.162-.03.296.054c.128.078.221.241.157.663-.13.788-.464 1.428-1.027 2.016-.343.369-.759.69-1.235.922a5 5 0 0 1-.806.34c-2.122.694-4.294-.068-4.994-1.704a2.6 2.6 0 0 1-.14-.387c-.299-1.078-.046-2.371.746-3.186.05-.052.099-.113.099-.19 0-.064-.04-.132-.076-.18-.277-.402-1.237-1.086-1.044-2.411.138-.952.97-1.623 1.747-1.583l.196.011c.337.02.63.063.907.075.463.02.88-.047 1.374-.459.166-.138.3-.259.526-.297.023-.004.082-.025.2-.02.121.007.236.04.339.109.395.263.451.9.472 1.367.012.266.044.91.055 1.096.025.423.136.482.361.556.127.042.244.073.417.121.524.148.834.297 1.03.488.117.12.171.247.188.369.062.45-.35 1.007-1.44 1.513-1.19.552-2.635.692-3.633.581l-.35-.04c-.799-.107-1.254.925-.775 1.632.309.456 1.15.753 1.992.753 1.93 0 3.413-.824 3.965-1.536a1 1 0 0 0 .044-.063c.027-.04.005-.064-.029-.04-.45.308-2.453 1.533-4.595 1.164 0 0-.26-.042-.498-.135-.189-.073-.584-.255-.632-.66 1.729.534 2.817.029 2.817.029m-9.494-4.108a2.3 2.3 0 0 0-1.455.928c-.194-.162-.554-.474-.618-.596-.517-.982.564-2.892 1.32-3.97 1.868-2.666 4.793-4.683 6.147-4.317.22.062.95.908.95.908s-1.354.75-2.61 1.797c-1.69 1.303-2.968 3.196-3.734 5.25m1.01 4.507q-.136.022-.277.02c-.905-.025-1.882-.84-1.979-1.805-.107-1.068.438-1.889 1.404-2.084.115-.023.255-.037.405-.029.541.03 1.339.445 1.52 1.624.162 1.044-.094 2.107-1.073 2.274m12.253-1.89c-.008-.028-.058-.212-.127-.434a4 4 0 0 0-.142-.38c.279-.416.284-.788.247-1a1.26 1.26 0 0 0-.368-.714c-.22-.23-.669-.466-1.3-.643l-.33-.092c-.002-.014-.017-.78-.032-1.11-.01-.237-.03-.609-.146-.974-.137-.496-.377-.929-.675-1.206.824-.854 1.338-1.795 1.337-2.603-.002-1.552-1.909-2.022-4.259-1.049l-.498.211-.913-.895c-2.68-2.336-11.055 6.974-8.377 9.235l.585.496a2.9 2.9 0 0 0-.163 1.329c.063.622.384 1.218.904 1.68.494.437 1.143.714 1.774.713 1.042 2.402 3.423 3.875 6.215 3.958 2.995.09 5.509-1.316 6.562-3.84.069-.178.361-.976.361-1.68 0-.709-.4-1.002-.655-1.002",
        clipRule: "evenodd"
    })), mailchimp_defs || (mailchimp_defs = /*#__PURE__*/ react.createElement("defs", null, /*#__PURE__*/ react.createElement("filter", {
        id: "filter0_d_2411_171071",
        width: 38.397,
        height: 42.247,
        x: 0.437,
        y: 0.215,
        colorInterpolationFilters: "sRGB",
        filterUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ react.createElement("feFlood", {
        floodOpacity: 0,
        result: "BackgroundImageFix"
    }), /*#__PURE__*/ react.createElement("feColorMatrix", {
        "in": "SourceAlpha",
        result: "hardAlpha",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
    }), /*#__PURE__*/ react.createElement("feOffset", {
        dy: 1.782
    }), /*#__PURE__*/ react.createElement("feGaussianBlur", {
        stdDeviation: 1.782
    }), /*#__PURE__*/ react.createElement("feColorMatrix", {
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.200691 0"
    }), /*#__PURE__*/ react.createElement("feBlend", {
        in2: "BackgroundImageFix",
        result: "effect1_dropShadow_2411_171071"
    }), /*#__PURE__*/ react.createElement("feBlend", {
        "in": "SourceGraphic",
        in2: "effect1_dropShadow_2411_171071",
        result: "shape"
    })))));
};
/* harmony default export */ var mailchimp = (SvgMailchimp);

;// CONCATENATED MODULE: ./static/svg/header/platform/mt_1.svg
var mt_1_g, mt_1_path, mt_1_path2, mt_1_path3, mt_1_path4, mt_1_path5, mt_1_path6, mt_1_path7, mt_1_path8, mt_1_defs;
function mt_1_extends() {
    mt_1_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return mt_1_extends.apply(this, arguments);
}

var SvgMt1 = function SvgMt1(props) {
    return /*#__PURE__*/ react.createElement("svg", mt_1_extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 40,
        height: 43,
        fill: "none",
        viewBox: "0 0 40 43"
    }, props), mt_1_g || (mt_1_g = /*#__PURE__*/ react.createElement("g", {
        filter: "url(#filter0_d_2306_173568)"
    }, /*#__PURE__*/ react.createElement("path", {
        fill: "#fff",
        stroke: "#fff",
        strokeWidth: 1.427,
        d: "m21.014 3.087 12.16 7.04a2.77 2.77 0 0 1 1.382 2.398v14.08a2.77 2.77 0 0 1-1.381 2.399l-12.161 7.04a2.75 2.75 0 0 1-2.759 0l-12.161-7.04a2.77 2.77 0 0 1-1.38-2.399v-14.08c0-.99.526-1.904 1.38-2.398l12.161-7.04a2.75 2.75 0 0 1 2.759 0Z"
    }))), mt_1_path || (mt_1_path = /*#__PURE__*/ react.createElement("path", {
        fill: "#5059C9",
        d: "M23.008 23.243v-4.468q0-.168.12-.286a.4.4 0 0 1 .292-.118h4.62a.79.79 0 0 1 .727.476.8.8 0 0 1 .06.296v4.1a2.8 2.8 0 0 1-.489 1.578 2.85 2.85 0 0 1-.8.783 2.9 2.9 0 0 1-1.61.479h-.021a2.95 2.95 0 0 1-2.05-.832 2.85 2.85 0 0 1-.793-1.454 2.8 2.8 0 0 1-.056-.554M27.8 15.52a1.8 1.8 0 0 1-.317 1.025 1.85 1.85 0 0 1-.845.679 1.9 1.9 0 0 1-1.088.105 1.9 1.9 0 0 1-1.198-.784 1.84 1.84 0 0 1-.317-1.025 1.8 1.8 0 0 1 .317-1.025 1.85 1.85 0 0 1 .845-.679 1.9 1.9 0 0 1 1.088-.105 1.9 1.9 0 0 1 1.198.784 1.83 1.83 0 0 1 .317 1.025M25.75 26.294l-.027-.001z"
    })), mt_1_path2 || (mt_1_path2 = /*#__PURE__*/ react.createElement("path", {
        fill: "#7B83EB",
        d: "M22.665 14.683a2.62 2.62 0 0 1-.461 1.49 2.7 2.7 0 0 1-.756.74 2.8 2.8 0 0 1-.987.4 2.8 2.8 0 0 1-2.056-.4 2.7 2.7 0 0 1-1.008-1.204 2.63 2.63 0 0 1 .253-2.517 2.7 2.7 0 0 1 .755-.74 2.8 2.8 0 0 1 .987-.4 2.8 2.8 0 0 1 2.056.4 2.7 2.7 0 0 1 1.009 1.204 2.6 2.6 0 0 1 .208 1.026M24.263 18.371h-7.987a.8.8 0 0 0-.736.477.8.8 0 0 0-.062.297v4.643a4.6 4.6 0 0 0 .38 1.78 4.65 4.65 0 0 0 1.042 1.506 4.8 4.8 0 0 0 1.548 1.004 4.9 4.9 0 0 0 1.822.353 4.9 4.9 0 0 0 2.646-.78 4.8 4.8 0 0 0 1.32-1.28 4.7 4.7 0 0 0 .725-1.675q.096-.45.101-.908v-4.643a.76.76 0 0 0-.236-.549.8.8 0 0 0-.563-.225"
    })), mt_1_path3 || (mt_1_path3 = /*#__PURE__*/ react.createElement("path", {
        fill: "#000",
        fillOpacity: 0.2,
        d: "M19.928 18.371v6.931a.6.6 0 0 1-.014.134.76.76 0 0 1-.27.465.8.8 0 0 1-.514.183h-3.023a4 4 0 0 1-.18-.336 4.472 4.472 0 0 1-.448-1.962v-4.64a.76.76 0 0 1 .233-.55.8.8 0 0 1 .563-.225zM19.927 16.47v.896a2.778 2.778 0 0 1-1.67-.557 2.7 2.7 0 0 1-.87-1.12h1.742a.8.8 0 0 1 .738.482q.06.144.06.3"
    })), mt_1_path4 || (mt_1_path4 = /*#__PURE__*/ react.createElement("path", {
        fill: "#000",
        fillOpacity: 0.098,
        d: "M20.27 18.371v6.26q-.002.222-.09.426-.087.205-.247.361-.16.157-.369.242a1.2 1.2 0 0 1-.434.088h-3.204a4.472 4.472 0 0 1-.448-1.962v-4.64a.76.76 0 0 1 .234-.55.8.8 0 0 1 .563-.225zM20.269 16.47v.875a2.782 2.782 0 0 1-2.012-.537 2.7 2.7 0 0 1-.983-1.454h1.855a1.15 1.15 0 0 1 1.052.69q.087.204.088.426"
    })), mt_1_path5 || (mt_1_path5 = /*#__PURE__*/ react.createElement("path", {
        fill: "#000",
        fillOpacity: 0.2,
        d: "M19.928 18.371v6.26a.76.76 0 0 1-.234.553.8.8 0 0 1-.564.229h-3.351a4.5 4.5 0 0 1-.301-1.626v-4.641a.76.76 0 0 1 .234-.55.8.8 0 0 1 .563-.225zM19.927 16.47v.896a2.778 2.778 0 0 1-1.67-.557 2.7 2.7 0 0 1-.87-1.12h1.742a.8.8 0 0 1 .738.482q.06.144.06.3"
    })), mt_1_path6 || (mt_1_path6 = /*#__PURE__*/ react.createElement("path", {
        fill: "#000",
        fillOpacity: 0.098,
        d: "M19.585 16.47v.876a2.8 2.8 0 0 1-1.328-.537 2.7 2.7 0 0 1-.87-1.12h1.4a.8.8 0 0 1 .738.482q.06.144.06.3M16.275 18.371h3.31v6.26a.76.76 0 0 1-.233.553.8.8 0 0 1-.564.229h-3.01a4.5 4.5 0 0 1-.3-1.626v-4.641a.76.76 0 0 1 .234-.55.8.8 0 0 1 .563-.225"
    })), mt_1_path7 || (mt_1_path7 = /*#__PURE__*/ react.createElement("path", {
        fill: "#4B53BC",
        d: "M10.799 15.69h7.987a.8.8 0 0 1 .738.482q.06.144.06.3v7.824a.76.76 0 0 1-.234.553.8.8 0 0 1-.564.229h-7.987a.81.81 0 0 1-.738-.483.8.8 0 0 1-.061-.3v-7.823a.76.76 0 0 1 .234-.554.8.8 0 0 1 .565-.229"
    })), mt_1_path8 || (mt_1_path8 = /*#__PURE__*/ react.createElement("path", {
        fill: "#fff",
        d: "M16.849 18.549h-1.563v4.368h-.995v-4.368h-1.556V17.7h4.114z"
    })), mt_1_defs || (mt_1_defs = /*#__PURE__*/ react.createElement("defs", null, /*#__PURE__*/ react.createElement("filter", {
        id: "filter0_d_2306_173568",
        width: 38.83,
        height: 42.685,
        x: 0.219,
        y: 0.113,
        colorInterpolationFilters: "sRGB",
        filterUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ react.createElement("feFlood", {
        floodOpacity: 0,
        result: "BackgroundImageFix"
    }), /*#__PURE__*/ react.createElement("feColorMatrix", {
        "in": "SourceAlpha",
        result: "hardAlpha",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
    }), /*#__PURE__*/ react.createElement("feOffset", {
        dy: 1.89
    }), /*#__PURE__*/ react.createElement("feGaussianBlur", {
        stdDeviation: 1.89
    }), /*#__PURE__*/ react.createElement("feColorMatrix", {
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.200691 0"
    }), /*#__PURE__*/ react.createElement("feBlend", {
        in2: "BackgroundImageFix",
        result: "effect1_dropShadow_2306_173568"
    }), /*#__PURE__*/ react.createElement("feBlend", {
        "in": "SourceGraphic",
        in2: "effect1_dropShadow_2306_173568",
        result: "shape"
    })))));
};
/* harmony default export */ var mt_1 = (SvgMt1);

;// CONCATENATED MODULE: ./static/svg/header/platform/outlook.svg
var outlook_g, outlook_path, outlook_g2, outlook_path2, outlook_defs;
function outlook_extends() {
    outlook_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return outlook_extends.apply(this, arguments);
}

var SvgOutlook = function SvgOutlook(props) {
    return /*#__PURE__*/ react.createElement("svg", outlook_extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 40,
        height: 43,
        fill: "none",
        viewBox: "0 0 40 43"
    }, props), outlook_g || (outlook_g = /*#__PURE__*/ react.createElement("g", {
        filter: "url(#filter0_d_2306_173508)"
    }, /*#__PURE__*/ react.createElement("path", {
        fill: "#276BA6",
        stroke: "#fff",
        strokeWidth: 1.427,
        d: "m21.014 3.087 12.16 7.04a2.77 2.77 0 0 1 1.382 2.398v14.08a2.77 2.77 0 0 1-1.381 2.399l-12.161 7.04a2.75 2.75 0 0 1-2.759 0l-12.161-7.04a2.77 2.77 0 0 1-1.38-2.399v-14.08c0-.99.526-1.904 1.38-2.398l12.161-7.04a2.75 2.75 0 0 1 2.759 0Z"
    }))), /*#__PURE__*/ react.createElement("mask", {
        id: "mask0_2306_173508",
        width: 16,
        height: 16,
        x: 12,
        y: 12,
        maskUnits: "userSpaceOnUse",
        style: {
            maskType: "alpha"
        }
    }, outlook_path || (outlook_path = /*#__PURE__*/ react.createElement("path", {
        fill: "#fff",
        fillRule: "evenodd",
        d: "M12 12h15.537v15.84H12z",
        clipRule: "evenodd"
    }))), outlook_g2 || (outlook_g2 = /*#__PURE__*/ react.createElement("g", {
        fill: "#fff",
        fillRule: "evenodd",
        clipRule: "evenodd",
        mask: "url(#mask0_2306_173508)"
    }, /*#__PURE__*/ react.createElement("path", {
        d: "M12 26.026V13.6l9.119-1.6v15.843zm3.669-6.117c0 .944.456 1.709 1.02 1.709.563 0 1.02-.765 1.02-1.71 0-.943-.457-1.708-1.02-1.708-.564 0-1.02.765-1.02 1.709m-1.077.004c0-1.593.95-2.884 2.122-2.884s2.12 1.291 2.12 2.884-.949 2.884-2.12 2.884-2.121-1.291-2.121-2.884M21.686 19.544v4.167h5.156s.755-.106.692-1.113l.004-5.445-3.777 2.6s-1.07.877-2.075-.21"
    }))), outlook_path2 || (outlook_path2 = /*#__PURE__*/ react.createElement("path", {
        fill: "#fff",
        fillRule: "evenodd",
        d: "M21.76 15.032h5.185s.61-.044.61.659l-4.687 3.305-1.108-.747z",
        clipRule: "evenodd"
    })), outlook_defs || (outlook_defs = /*#__PURE__*/ react.createElement("defs", null, /*#__PURE__*/ react.createElement("filter", {
        id: "filter0_d_2306_173508",
        width: 38.83,
        height: 42.685,
        x: 0.219,
        y: 0.113,
        colorInterpolationFilters: "sRGB",
        filterUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ react.createElement("feFlood", {
        floodOpacity: 0,
        result: "BackgroundImageFix"
    }), /*#__PURE__*/ react.createElement("feColorMatrix", {
        "in": "SourceAlpha",
        result: "hardAlpha",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
    }), /*#__PURE__*/ react.createElement("feOffset", {
        dy: 1.89
    }), /*#__PURE__*/ react.createElement("feGaussianBlur", {
        stdDeviation: 1.89
    }), /*#__PURE__*/ react.createElement("feColorMatrix", {
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.200691 0"
    }), /*#__PURE__*/ react.createElement("feBlend", {
        in2: "BackgroundImageFix",
        result: "effect1_dropShadow_2306_173508"
    }), /*#__PURE__*/ react.createElement("feBlend", {
        "in": "SourceGraphic",
        in2: "effect1_dropShadow_2306_173508",
        result: "shape"
    })))));
};
/* harmony default export */ var outlook = (SvgOutlook);

;// CONCATENATED MODULE: ./static/svg/header/platform/pagerduty_1.svg
var pagerduty_1_g, pagerduty_1_defs;
function pagerduty_1_extends() {
    pagerduty_1_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return pagerduty_1_extends.apply(this, arguments);
}

var SvgPagerduty1 = function SvgPagerduty1(props) {
    return /*#__PURE__*/ react.createElement("svg", pagerduty_1_extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 39,
        height: 43,
        fill: "none",
        viewBox: "0 0 39 43"
    }, props), pagerduty_1_g || (pagerduty_1_g = /*#__PURE__*/ react.createElement("g", {
        filter: "url(#filter0_d_2411_171116)"
    }, /*#__PURE__*/ react.createElement("path", {
        fill: "#06AC38",
        stroke: "#fff",
        strokeWidth: 1.346,
        d: "m21.035 3.05 12.161 7.038a2.81 2.81 0 0 1 1.4 2.433V26.6a2.81 2.81 0 0 1-1.4 2.433l-12.161 7.039a2.79 2.79 0 0 1-2.8 0L6.074 29.032a2.81 2.81 0 0 1-1.4-2.433V12.52a2.81 2.81 0 0 1 1.4-2.433l12.161-7.039a2.79 2.79 0 0 1 2.8 0Z"
    }), /*#__PURE__*/ react.createElement("path", {
        fill: "#fff",
        d: "M18.448 22.01h-1.843v3.224h1.843zM23.056 14.066c-.916-.498-1.558-.579-3.062-.579h-3.39v7.14h3.377c1.337 0 2.34-.08 3.222-.673.963-.639 1.464-1.709 1.464-2.947 0-1.333-.615-2.403-1.61-2.941m-2.68 5.067h-2.053v-4.118L20.262 15c1.765-.013 2.647.606 2.647 2.026 0 1.528-1.096 2.106-2.534 2.106"
    }))), pagerduty_1_defs || (pagerduty_1_defs = /*#__PURE__*/ react.createElement("defs", null, /*#__PURE__*/ react.createElement("filter", {
        id: "filter0_d_2411_171116",
        width: 38.403,
        height: 42.252,
        x: 0.434,
        y: 0.217,
        colorInterpolationFilters: "sRGB",
        filterUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ react.createElement("feFlood", {
        floodOpacity: 0,
        result: "BackgroundImageFix"
    }), /*#__PURE__*/ react.createElement("feColorMatrix", {
        "in": "SourceAlpha",
        result: "hardAlpha",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
    }), /*#__PURE__*/ react.createElement("feOffset", {
        dy: 1.783
    }), /*#__PURE__*/ react.createElement("feGaussianBlur", {
        stdDeviation: 1.783
    }), /*#__PURE__*/ react.createElement("feColorMatrix", {
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.200691 0"
    }), /*#__PURE__*/ react.createElement("feBlend", {
        in2: "BackgroundImageFix",
        result: "effect1_dropShadow_2411_171116"
    }), /*#__PURE__*/ react.createElement("feBlend", {
        "in": "SourceGraphic",
        in2: "effect1_dropShadow_2411_171116",
        result: "shape"
    })))));
};
/* harmony default export */ var pagerduty_1 = (SvgPagerduty1);

;// CONCATENATED MODULE: ./static/svg/header/platform/slack_1.svg
var slack_1_g, slack_1_defs;
function slack_1_extends() {
    slack_1_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return slack_1_extends.apply(this, arguments);
}

var SvgSlack1 = function SvgSlack1(props) {
    return /*#__PURE__*/ react.createElement("svg", slack_1_extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 39,
        height: 43,
        fill: "none",
        viewBox: "0 0 39 43"
    }, props), slack_1_g || (slack_1_g = /*#__PURE__*/ react.createElement("g", {
        filter: "url(#filter0_d_2315_173531)"
    }, /*#__PURE__*/ react.createElement("path", {
        fill: "#4A154B",
        stroke: "#fff",
        strokeWidth: 1.369,
        d: "M21.029 3.061 33.19 10.1a2.8 2.8 0 0 1 1.395 2.423v14.078a2.8 2.8 0 0 1-1.395 2.423l-12.161 7.04c-.863.498-1.925.498-2.788 0L6.08 29.023a2.8 2.8 0 0 1-1.396-2.423V12.523A2.8 2.8 0 0 1 6.08 10.1L18.24 3.06c.863-.5 1.925-.5 2.788 0Z"
    }), /*#__PURE__*/ react.createElement("g", {
        fillRule: "evenodd",
        clipPath: "url(#clip0_2315_173531)",
        clipRule: "evenodd"
    }, /*#__PURE__*/ react.createElement("path", {
        fill: "#E01E5A",
        d: "M15.312 21.283a1.89 1.89 0 0 1-1.892 1.887 1.89 1.89 0 0 1-1.892-1.888 1.89 1.89 0 0 1 1.892-1.888h1.892zM15.806 21.283a1.89 1.89 0 0 1 1.892-1.889 1.89 1.89 0 0 1 1.892 1.889v4.72a1.89 1.89 0 0 1-1.892 1.888 1.89 1.89 0 0 1-1.892-1.888z"
    }), /*#__PURE__*/ react.createElement("path", {
        fill: "#36C5F0",
        d: "M17.698 14.716a1.89 1.89 0 0 1-1.892-1.888 1.89 1.89 0 0 1 1.892-1.888 1.89 1.89 0 0 1 1.892 1.888v1.888zM17.698 15.212A1.89 1.89 0 0 1 19.59 17.1a1.89 1.89 0 0 1-1.892 1.888h-4.73a1.89 1.89 0 0 1-1.892-1.888 1.89 1.89 0 0 1 1.892-1.888z"
    }), /*#__PURE__*/ react.createElement("path", {
        fill: "#2EB67D",
        d: "M24.348 17.1a1.89 1.89 0 0 1 1.892-1.888 1.89 1.89 0 0 1 1.892 1.888 1.89 1.89 0 0 1-1.892 1.888h-1.892zM23.854 17.1a1.89 1.89 0 0 1-1.892 1.889A1.89 1.89 0 0 1 20.07 17.1v-4.72a1.89 1.89 0 0 1 1.892-1.889 1.89 1.89 0 0 1 1.892 1.888z"
    }), /*#__PURE__*/ react.createElement("path", {
        fill: "#ECB22E",
        d: "M21.962 23.667a1.89 1.89 0 0 1 1.892 1.888 1.89 1.89 0 0 1-1.892 1.888 1.89 1.89 0 0 1-1.892-1.888v-1.888zM21.962 23.17a1.89 1.89 0 0 1-1.892-1.888 1.89 1.89 0 0 1 1.892-1.888h4.73a1.89 1.89 0 0 1 1.892 1.889 1.89 1.89 0 0 1-1.892 1.887z"
    })))), slack_1_defs || (slack_1_defs = /*#__PURE__*/ react.createElement("defs", null, /*#__PURE__*/ react.createElement("clipPath", {
        id: "clip0_2315_173531"
    }, /*#__PURE__*/ react.createElement("path", {
        fill: "#fff",
        d: "M10.615 10.032h18.43v18.426h-18.43z"
    })), /*#__PURE__*/ react.createElement("filter", {
        id: "filter0_d_2315_173531",
        width: 38.524,
        height: 42.376,
        x: 0.373,
        y: 0.187,
        colorInterpolationFilters: "sRGB",
        filterUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ react.createElement("feFlood", {
        floodOpacity: 0,
        result: "BackgroundImageFix"
    }), /*#__PURE__*/ react.createElement("feColorMatrix", {
        "in": "SourceAlpha",
        result: "hardAlpha",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
    }), /*#__PURE__*/ react.createElement("feOffset", {
        dy: 1.813
    }), /*#__PURE__*/ react.createElement("feGaussianBlur", {
        stdDeviation: 1.813
    }), /*#__PURE__*/ react.createElement("feColorMatrix", {
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.200691 0"
    }), /*#__PURE__*/ react.createElement("feBlend", {
        in2: "BackgroundImageFix",
        result: "effect1_dropShadow_2315_173531"
    }), /*#__PURE__*/ react.createElement("feBlend", {
        "in": "SourceGraphic",
        in2: "effect1_dropShadow_2315_173531",
        result: "shape"
    })))));
};
/* harmony default export */ var slack_1 = (SvgSlack1);

;// CONCATENATED MODULE: ./static/svg/header/platform/surveymonkey.svg
var surveymonkey_g, surveymonkey_g2, surveymonkey_defs;
function surveymonkey_extends() {
    surveymonkey_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return surveymonkey_extends.apply(this, arguments);
}

var SvgSurveymonkey = function SvgSurveymonkey(props) {
    return /*#__PURE__*/ react.createElement("svg", surveymonkey_extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 40,
        height: 43,
        fill: "none",
        viewBox: "0 0 40 43"
    }, props), surveymonkey_g || (surveymonkey_g = /*#__PURE__*/ react.createElement("g", {
        filter: "url(#filter0_d_2315_173498)"
    }, /*#__PURE__*/ react.createElement("path", {
        fill: "#00BF6F",
        stroke: "#fff",
        strokeWidth: 1.415,
        d: "m21.017 3.076 12.162 7.039a2.78 2.78 0 0 1 1.383 2.403v14.078c0 .992-.528 1.908-1.383 2.404l-12.162 7.038a2.76 2.76 0 0 1-2.765 0L6.091 29a2.78 2.78 0 0 1-1.384-2.404V12.518c0-.992.528-1.908 1.384-2.403l12.161-7.04a2.76 2.76 0 0 1 2.765 0Z"
    }))), surveymonkey_g2 || (surveymonkey_g2 = /*#__PURE__*/ react.createElement("g", {
        clipPath: "url(#clip0_2315_173498)"
    }, /*#__PURE__*/ react.createElement("path", {
        fill: "#fff",
        d: "M27.152 19.914q-.288 0-.568.071a7.4 7.4 0 0 0-2.105-3.589 7.3 7.3 0 0 0-4.062-1.924c.021-.698.054-1.507 1.072-2.232l-.158-.41s-1.982.622-2.21 2.338c-.099-.467-1.024-1.051-1.481-1.161l-.228.371a1.6 1.6 0 0 1 .744 1.15 7.3 7.3 0 0 0-3.693 1.869 7.4 7.4 0 0 0-2.106 3.59 2.35 2.35 0 0 0-2.096.49c-.287.242-.513.55-.66.897a2.42 2.42 0 0 0 .143 2.169c.19.325.455.6.77.801a2.36 2.36 0 0 0 2.143.205c.203.512.461.999.772 1.452l1.97-1.343-.016-.023c-.521-.677-.842-1.674-.894-2.666-.058-1.094.205-2.181.897-2.82 1.42-1.227 2.978-.67 3.945.508h.262c.973-1.175 2.526-1.735 3.946-.509.692.638.957 1.727.897 2.821-.054.992-.373 1.989-.893 2.666l-.018.023L25.497 26c.31-.453.569-.94.771-1.452a2.35 2.35 0 0 0 2.011-.134c.305-.17.57-.406.774-.69a2.41 2.41 0 0 0 .381-2 2.4 2.4 0 0 0-.464-.932 2.38 2.38 0 0 0-1.818-.88m-15.404 3.108a.7.7 0 0 1-.496-.208.71.71 0 0 1 0-1.001.7.7 0 0 1 .889-.085q.008.56.074 1.117a.7.7 0 0 1-.467.177m15.452 0a.7.7 0 0 1-.474-.182q.066-.556.074-1.116a.694.694 0 0 1 .995.22c.065.11.1.238.099.366a.71.71 0 0 1-.201.501.7.7 0 0 1-.494.21"
    }))), surveymonkey_defs || (surveymonkey_defs = /*#__PURE__*/ react.createElement("defs", null, /*#__PURE__*/ react.createElement("clipPath", {
        id: "clip0_2315_173498"
    }, /*#__PURE__*/ react.createElement("path", {
        fill: "#fff",
        d: "M9.153 10.026h20.612v20.612H9.153z"
    })), /*#__PURE__*/ react.createElement("filter", {
        id: "filter0_d_2315_173498",
        width: 38.765,
        height: 42.615,
        x: 0.252,
        y: 0.123,
        colorInterpolationFilters: "sRGB",
        filterUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ react.createElement("feFlood", {
        floodOpacity: 0,
        result: "BackgroundImageFix"
    }), /*#__PURE__*/ react.createElement("feColorMatrix", {
        "in": "SourceAlpha",
        result: "hardAlpha",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
    }), /*#__PURE__*/ react.createElement("feOffset", {
        dy: 1.874
    }), /*#__PURE__*/ react.createElement("feGaussianBlur", {
        stdDeviation: 1.874
    }), /*#__PURE__*/ react.createElement("feColorMatrix", {
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.200691 0"
    }), /*#__PURE__*/ react.createElement("feBlend", {
        in2: "BackgroundImageFix",
        result: "effect1_dropShadow_2315_173498"
    }), /*#__PURE__*/ react.createElement("feBlend", {
        "in": "SourceGraphic",
        in2: "effect1_dropShadow_2315_173498",
        result: "shape"
    })))));
};
/* harmony default export */ var surveymonkey = (SvgSurveymonkey);

;// CONCATENATED MODULE: ./static/svg/header/platform/twilio_1.svg
var twilio_1_g, twilio_1_path, twilio_1_path2, twilio_1_defs;
function twilio_1_extends() {
    twilio_1_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return twilio_1_extends.apply(this, arguments);
}

var SvgTwilio1 = function SvgTwilio1(props) {
    return /*#__PURE__*/ react.createElement("svg", twilio_1_extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 40,
        height: 43,
        fill: "none",
        viewBox: "0 0 40 43"
    }, props), twilio_1_g || (twilio_1_g = /*#__PURE__*/ react.createElement("g", {
        filter: "url(#filter0_d_2253_200036)"
    }, /*#__PURE__*/ react.createElement("path", {
        fill: "#FF043D",
        stroke: "#fff",
        strokeWidth: 1.427,
        d: "m21.014 3.087 12.16 7.04a2.77 2.77 0 0 1 1.382 2.398v14.08a2.77 2.77 0 0 1-1.381 2.399l-12.161 7.04a2.75 2.75 0 0 1-2.759 0l-12.161-7.04a2.77 2.77 0 0 1-1.38-2.399v-14.08c0-.99.526-1.904 1.38-2.398l12.161-7.04a2.75 2.75 0 0 1 2.759 0Z"
    }))), twilio_1_path || (twilio_1_path = /*#__PURE__*/ react.createElement("path", {
        fill: "#fff",
        d: "M20 25.155a5.155 5.155 0 1 1 0-10.31 5.155 5.155 0 0 1 0 10.31M20 13a7 7 0 1 0 0 14 7 7 0 0 0 0-14"
    })), twilio_1_path2 || (twilio_1_path2 = /*#__PURE__*/ react.createElement("path", {
        fill: "#fff",
        d: "M20.288 18.257a1.456 1.456 0 1 1 2.91 0 1.456 1.456 0 0 1-2.91 0m0 3.487a1.456 1.456 0 1 1 2.91 0 1.456 1.456 0 0 1-2.91 0m-3.487 0a1.456 1.456 0 1 1 2.911 0 1.456 1.456 0 0 1-2.91 0m0-3.487a1.456 1.456 0 1 1 2.911 0 1.456 1.456 0 0 1-2.91 0"
    })), twilio_1_defs || (twilio_1_defs = /*#__PURE__*/ react.createElement("defs", null, /*#__PURE__*/ react.createElement("filter", {
        id: "filter0_d_2253_200036",
        width: 38.83,
        height: 42.685,
        x: 0.219,
        y: 0.113,
        colorInterpolationFilters: "sRGB",
        filterUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ react.createElement("feFlood", {
        floodOpacity: 0,
        result: "BackgroundImageFix"
    }), /*#__PURE__*/ react.createElement("feColorMatrix", {
        "in": "SourceAlpha",
        result: "hardAlpha",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
    }), /*#__PURE__*/ react.createElement("feOffset", {
        dy: 1.89
    }), /*#__PURE__*/ react.createElement("feGaussianBlur", {
        stdDeviation: 1.89
    }), /*#__PURE__*/ react.createElement("feColorMatrix", {
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.200691 0"
    }), /*#__PURE__*/ react.createElement("feBlend", {
        in2: "BackgroundImageFix",
        result: "effect1_dropShadow_2253_200036"
    }), /*#__PURE__*/ react.createElement("feBlend", {
        "in": "SourceGraphic",
        in2: "effect1_dropShadow_2253_200036",
        result: "shape"
    })))));
};
/* harmony default export */ var twilio_1 = (SvgTwilio1);

;// CONCATENATED MODULE: ./static/svg/header/platform/zendesk.svg
var zendesk_g, zendesk_path, zendesk_defs;
function zendesk_extends() {
    zendesk_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return zendesk_extends.apply(this, arguments);
}

var SvgZendesk = function SvgZendesk(props) {
    return /*#__PURE__*/ react.createElement("svg", zendesk_extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 40,
        height: 43,
        fill: "none",
        viewBox: "0 0 40 43"
    }, props), zendesk_g || (zendesk_g = /*#__PURE__*/ react.createElement("g", {
        filter: "url(#filter0_d_2301_173445)"
    }, /*#__PURE__*/ react.createElement("path", {
        fill: "#02363D",
        stroke: "#fff",
        strokeWidth: 1.438,
        d: "m21.012 3.089 12.16 7.039a2.77 2.77 0 0 1 1.379 2.393V26.6c0 .988-.526 1.9-1.378 2.393l-12.161 7.039a2.75 2.75 0 0 1-2.754 0l-12.16-7.039A2.77 2.77 0 0 1 4.718 26.6V12.52c0-.988.526-1.9 1.378-2.393l12.161-7.039a2.75 2.75 0 0 1 2.754 0Z"
    }))), zendesk_path || (zendesk_path = /*#__PURE__*/ react.createElement("path", {
        fill: "#fff",
        d: "M19.099 16.646v9.22h-7.637zM19.099 13.337a3.818 3.818 0 0 1-7.637 0zM20.357 25.866a3.818 3.818 0 0 1 7.637 0zM20.357 22.557v-9.22h7.638z"
    })), zendesk_defs || (zendesk_defs = /*#__PURE__*/ react.createElement("defs", null, /*#__PURE__*/ react.createElement("filter", {
        id: "filter0_d_2301_173445",
        width: 38.891,
        height: 42.741,
        x: 0.19,
        y: 0.095,
        colorInterpolationFilters: "sRGB",
        filterUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ react.createElement("feFlood", {
        floodOpacity: 0,
        result: "BackgroundImageFix"
    }), /*#__PURE__*/ react.createElement("feColorMatrix", {
        "in": "SourceAlpha",
        result: "hardAlpha",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
    }), /*#__PURE__*/ react.createElement("feOffset", {
        dy: 1.905
    }), /*#__PURE__*/ react.createElement("feGaussianBlur", {
        stdDeviation: 1.905
    }), /*#__PURE__*/ react.createElement("feColorMatrix", {
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.200691 0"
    }), /*#__PURE__*/ react.createElement("feBlend", {
        in2: "BackgroundImageFix",
        result: "effect1_dropShadow_2301_173445"
    }), /*#__PURE__*/ react.createElement("feBlend", {
        "in": "SourceGraphic",
        in2: "effect1_dropShadow_2301_173445",
        result: "shape"
    })))));
};
/* harmony default export */ var zendesk = (SvgZendesk);

;// CONCATENATED MODULE: ./static/svg/header/platform/zoom_1.svg
var zoom_1_g, zoom_1_path, zoom_1_defs;
function zoom_1_extends() {
    zoom_1_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return zoom_1_extends.apply(this, arguments);
}

var SvgZoom1 = function SvgZoom1(props) {
    return /*#__PURE__*/ react.createElement("svg", zoom_1_extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 40,
        height: 43,
        fill: "none",
        viewBox: "0 0 40 43"
    }, props), zoom_1_g || (zoom_1_g = /*#__PURE__*/ react.createElement("g", {
        filter: "url(#filter0_d_2264_200020)"
    }, /*#__PURE__*/ react.createElement("path", {
        fill: "#0073EA",
        stroke: "#fff",
        strokeWidth: 1.427,
        d: "m21.014 3.087 12.16 7.04a2.77 2.77 0 0 1 1.382 2.398v14.08a2.77 2.77 0 0 1-1.381 2.399l-12.161 7.04a2.75 2.75 0 0 1-2.759 0l-12.161-7.04a2.77 2.77 0 0 1-1.38-2.399v-14.08c0-.99.526-1.904 1.38-2.398l12.161-7.04a2.75 2.75 0 0 1 2.759 0Z"
    }))), zoom_1_path || (zoom_1_path = /*#__PURE__*/ react.createElement("path", {
        fill: "#fff",
        fillRule: "evenodd",
        d: "M26.592 18.644c.08.138.107.295.115.472l.012.236v1.65l.011.236c.024.386.308.67.697.695l.235.012v-2.593l.011-.236c.01-.175.036-.335.117-.474a.943.943 0 0 1 1.632.003c.08.138.105.298.115.471l.011.236v1.65l.012.236a.72.72 0 0 0 .696.695l.235.012v-2.829a1.886 1.886 0 0 0-3.3-1.247 1.884 1.884 0 0 0-2.47-.315c-.184-.205-.595-.324-.831-.324v4.715l.236-.012c.394-.026.68-.303.695-.695l.012-.236v-1.65l.012-.236c.01-.178.035-.334.115-.473a.945.945 0 0 1 1.632 0m-16.14 3.29.236.01h3.536l-.012-.234c-.032-.388-.306-.671-.695-.696l-.236-.012h-2.122l2.829-2.83-.012-.234a.713.713 0 0 0-.695-.697l-.236-.01-3.536-.001.012.236c.03.384.309.673.695.695l.236.012h2.121l-2.828 2.83.011.235a.72.72 0 0 0 .696.695m12.512-4.014a2.358 2.358 0 1 1-3.334 3.334 2.358 2.358 0 0 1 3.334-3.334m-.667.668a1.416 1.416 0 1 1-2.003 2 1.416 1.416 0 0 1 2.003-2m-5.95-1.358a2.357 2.357 0 1 1-1.669 4.024 2.358 2.358 0 0 1 1.666-4.024zm1 1.357a1.415 1.415 0 1 1-2.003 2 1.415 1.415 0 0 1 2.002-2",
        clipRule: "evenodd"
    })), zoom_1_defs || (zoom_1_defs = /*#__PURE__*/ react.createElement("defs", null, /*#__PURE__*/ react.createElement("filter", {
        id: "filter0_d_2264_200020",
        width: 38.83,
        height: 42.685,
        x: 0.219,
        y: 0.113,
        colorInterpolationFilters: "sRGB",
        filterUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ react.createElement("feFlood", {
        floodOpacity: 0,
        result: "BackgroundImageFix"
    }), /*#__PURE__*/ react.createElement("feColorMatrix", {
        "in": "SourceAlpha",
        result: "hardAlpha",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
    }), /*#__PURE__*/ react.createElement("feOffset", {
        dy: 1.89
    }), /*#__PURE__*/ react.createElement("feGaussianBlur", {
        stdDeviation: 1.89
    }), /*#__PURE__*/ react.createElement("feColorMatrix", {
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.200691 0"
    }), /*#__PURE__*/ react.createElement("feBlend", {
        in2: "BackgroundImageFix",
        result: "effect1_dropShadow_2264_200020"
    }), /*#__PURE__*/ react.createElement("feBlend", {
        "in": "SourceGraphic",
        in2: "effect1_dropShadow_2264_200020",
        result: "shape"
    })))));
};
/* harmony default export */ var zoom_1 = (SvgZoom1);

;// CONCATENATED MODULE: ./static/svg/header/platform/gmail.svg
var gmail_g, gmail_g2, gmail_defs;
function gmail_extends() {
    gmail_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return gmail_extends.apply(this, arguments);
}

var SvgGmail = function SvgGmail(props) {
    return /*#__PURE__*/ react.createElement("svg", gmail_extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 40,
        height: 43,
        fill: "none",
        viewBox: "0 0 40 43"
    }, props), gmail_g || (gmail_g = /*#__PURE__*/ react.createElement("g", {
        filter: "url(#filter0_d_2306_173600)"
    }, /*#__PURE__*/ react.createElement("path", {
        fill: "#fff",
        stroke: "#fff",
        strokeWidth: 1.427,
        d: "m21.014 3.084 12.161 7.04a2.77 2.77 0 0 1 1.38 2.399v14.079c0 .99-.526 1.904-1.38 2.399l-12.16 7.04a2.75 2.75 0 0 1-2.76 0L6.095 29a2.77 2.77 0 0 1-1.381-2.399v-14.08c0-.99.526-1.904 1.38-2.398l12.161-7.04a2.75 2.75 0 0 1 2.76 0Z"
    }))), gmail_g2 || (gmail_g2 = /*#__PURE__*/ react.createElement("g", {
        clipPath: "url(#clip0_2306_173600)"
    }, /*#__PURE__*/ react.createElement("path", {
        fill: "#4285F4",
        d: "M12.136 25.962h2.652v-6.44L11 16.683v8.144c0 .629.51 1.136 1.136 1.136"
    }), /*#__PURE__*/ react.createElement("path", {
        fill: "#34A853",
        d: "M23.879 25.961h2.651c.629 0 1.137-.51 1.137-1.136V16.68l-3.788 2.84"
    }), /*#__PURE__*/ react.createElement("path", {
        fill: "#FBBC04",
        d: "M23.879 14.138v4.924l3.788-2.841v-1.515c0-1.405-1.605-2.207-2.728-1.364"
    }), /*#__PURE__*/ react.createElement("path", {
        fill: "#EA4335",
        d: "M14.788 19.061v-4.924l4.546 3.409 4.545-3.41v4.925l-4.546 3.41"
    }), /*#__PURE__*/ react.createElement("path", {
        fill: "#C5221F",
        d: "M11 14.707v1.515l3.788 2.84V14.14l-1.06-.796C12.601 12.5 11 13.302 11 14.707"
    }))), gmail_defs || (gmail_defs = /*#__PURE__*/ react.createElement("defs", null, /*#__PURE__*/ react.createElement("clipPath", {
        id: "clip0_2306_173600"
    }, /*#__PURE__*/ react.createElement("path", {
        fill: "#fff",
        d: "M11 13h16.667v12.5H11z"
    })), /*#__PURE__*/ react.createElement("filter", {
        id: "filter0_d_2306_173600",
        width: 38.83,
        height: 42.685,
        x: 0.22,
        y: 0.11,
        colorInterpolationFilters: "sRGB",
        filterUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ react.createElement("feFlood", {
        floodOpacity: 0,
        result: "BackgroundImageFix"
    }), /*#__PURE__*/ react.createElement("feColorMatrix", {
        "in": "SourceAlpha",
        result: "hardAlpha",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
    }), /*#__PURE__*/ react.createElement("feOffset", {
        dy: 1.89
    }), /*#__PURE__*/ react.createElement("feGaussianBlur", {
        stdDeviation: 1.89
    }), /*#__PURE__*/ react.createElement("feColorMatrix", {
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.200691 0"
    }), /*#__PURE__*/ react.createElement("feBlend", {
        in2: "BackgroundImageFix",
        result: "effect1_dropShadow_2306_173600"
    }), /*#__PURE__*/ react.createElement("feBlend", {
        "in": "SourceGraphic",
        in2: "effect1_dropShadow_2306_173600",
        result: "shape"
    })))));
};
/* harmony default export */ var gmail = (SvgGmail);

// EXTERNAL MODULE: ./constants/work-managment-logos.js
var work_managment_logos = __webpack_require__(74329);
;// CONCATENATED MODULE: ./static/svg/header/platform/miro.svg
var miro_rect, miro_g, miro_defs;
function miro_extends() {
    miro_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return miro_extends.apply(this, arguments);
}

var SvgMiro = function SvgMiro(props) {
    return /*#__PURE__*/ react.createElement("svg", miro_extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 40,
        height: 40,
        fill: "none",
        viewBox: "0 0 40 40"
    }, props), miro_rect || (miro_rect = /*#__PURE__*/ react.createElement("rect", {
        width: 40,
        height: 40,
        fill: "#fff",
        rx: 4
    })), miro_g || (miro_g = /*#__PURE__*/ react.createElement("g", {
        clipPath: "url(#clip0_2274_200071)"
    }, /*#__PURE__*/ react.createElement("path", {
        fill: "#FFD02F",
        d: "M3 4h33v33H3z"
    }), /*#__PURE__*/ react.createElement("path", {
        fill: "#050038",
        d: "M25.487 7.4h-3.523l3.127 4.847L18.48 7.4h-3.523l3.127 6.352L11.473 7.4H7.95l3.076 8.2-3.076 16h3.523l6.611-17.156L14.957 31.6h3.523l6.611-18.66-3.127 18.66h3.523l6.663-20.497z"
    }))), miro_defs || (miro_defs = /*#__PURE__*/ react.createElement("defs", null, /*#__PURE__*/ react.createElement("clipPath", {
        id: "clip0_2274_200071"
    }, /*#__PURE__*/ react.createElement("rect", {
        width: 33,
        height: 33,
        x: 3,
        y: 3,
        fill: "#fff",
        rx: 4
    })))));
};
/* harmony default export */ var miro = (SvgMiro);

;// CONCATENATED MODULE: ./static/svg/header/platform/Tracket_1.svg
var Tracket_1_rect, Tracket_1_path;
function Tracket_1_extends() {
    Tracket_1_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return Tracket_1_extends.apply(this, arguments);
}

var SvgTracket1 = function SvgTracket1(props) {
    return /*#__PURE__*/ react.createElement("svg", Tracket_1_extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 40,
        height: 40,
        fill: "none",
        viewBox: "0 0 40 40"
    }, props), Tracket_1_rect || (Tracket_1_rect = /*#__PURE__*/ react.createElement("rect", {
        width: 40,
        height: 40,
        fill: "#fff",
        rx: 4
    })), Tracket_1_path || (Tracket_1_path = /*#__PURE__*/ react.createElement("path", {
        fill: "#5A32FA",
        d: "m18.985 27.28-2.073 3.561a10 10 0 0 1-3.276-3.306l3.542-2.027a5.9 5.9 0 0 0 1.807 1.773M21.83 28.166v4.128c-1.657-.05-3.152-.464-4.53-1.226l2.075-3.564a5.9 5.9 0 0 0 2.455.662M30.523 17.354l-3.506 2.005a5.9 5.9 0 0 0-1.813-1.86l2.054-3.516a9.9 9.9 0 0 1 3.265 3.371M26.805 31.06a9.75 9.75 0 0 1-4.525 1.231v-4.125a5.9 5.9 0 0 0 2.453-.662zM30.46 27.527a9.95 9.95 0 0 1-3.267 3.306l-2.069-3.552a5.9 5.9 0 0 0 1.805-1.774zM31.88 22.684a9.9 9.9 0 0 1-1.197 4.452l-3.522-2.016a5.8 5.8 0 0 0 .692-2.436zM31.884 22.237H27.86a5.8 5.8 0 0 0-.624-2.48l3.507-2a9.9 9.9 0 0 1 1.14 4.48M21.152 12.53v1.799c0 1.18-.96 2.14-2.141 2.14h-2.773v5.064c0 .274.018 1.032.018 1.032.023.431.07.789.148 1.125.118.505.3.986.545 1.433l-3.537 2.023a9.8 9.8 0 0 1-1.198-4.593V16.47h-1.88A1.334 1.334 0 0 1 9 15.136V12.53h3.213v-2.228L16.238 8v4.53z"
    })));
};
/* harmony default export */ var Tracket_1 = (SvgTracket1);

// EXTERNAL MODULE: ./styles/color-consts.js
var color_consts = __webpack_require__(273);
// EXTERNAL MODULE: ./constants/links.js + 20 modules
var links = __webpack_require__(27639);
// EXTERNAL MODULE: ./utils/general.js
var general = __webpack_require__(56093);
// EXTERNAL MODULE: ./styles/colors.js
var colors = __webpack_require__(12573);
// EXTERNAL MODULE: ./client/services/cluster-config-service/cluster-config-service.js
var cluster_config_service = __webpack_require__(79092);
// EXTERNAL MODULE: ./utils/url.js
var url = __webpack_require__(8339);
// EXTERNAL MODULE: ./segments/desktop/core-components/square-tags/square-tags.js + 4 modules
var square_tags = __webpack_require__(76416);
// EXTERNAL MODULE: ./constants/clusters.js
var clusters = __webpack_require__(16961);
// EXTERNAL MODULE: ./segments/desktop/core-components/button/button-consts.js
var button_consts = __webpack_require__(75650);
// EXTERNAL MODULE: ./constants/sizes.js
var sizes = __webpack_require__(77869);
// EXTERNAL MODULE: ./client/services/hubspot-service/hubspot-constants.js
var hubspot_constants = __webpack_require__(22638);
;// CONCATENATED MODULE: ./segments/desktop/header/layouts/base-header/base-header-service.js
// Header menus data =================================================================
















// import BoardsColoredIcon from "static/svg/header/boards_colored.svg";









// import EnterpriseAgilityColoredIcon from "static/svg/header/enterprise_agility_colored.svg";


















// platform icons






























var PRODUCTS_MENU_ID = "products";
var USE_CASES_MENU_ID = "use-cases";
var FEATURES_MENU_ID = "features";
var RESOURCES_MENU_ID = "resources";
// structured header
var SOLUTIONS_MENU_ID = "solutions";
var TEAMS_MENU_ID = "teams";
var PLATFORM_MENU_ID = "platform";
var CUSTOMERS_MENU_ID = "customers";
var DESKTOP_HEADER_BASE_CLASS_NAME = "base-header-desktop-component";
var PRODUCTS_PRODUCTS_SECTION_ID = "products";
var PRODUCTS_MORE_SECTION_ID = "more";
var BY_TEAM_SECTION_ID = "by-team";
var BY_BUSINESS_SIZE_SECTION_ID = "by-business-size";
var BY_INDUSTRY_SECTION_ID = "by-industry";
var KEY_FEATURES_SECTION_ID = "key-features";
var INTEGRATIONS_SECTION_ID = "integrations";
var ADD_ONS_SECTION_ID = "add-ons";
var RESOURCES_LEARN_SECTION_ID = "learn";
var RESOURCES_CONNECT_SECTION_ID = "connect";
var RESOURCES_EXPLORE_SECTION_ID = "explore";
var RESOURCES_BUILD_SECTION_ID = "build";
var TOP_STORIES_SECTION_ID = "top-stories";
var GET_INVOLVED_SECTION_ID = "get-involved";
var LEADING_COMPANIES_SECTION_ID = "leading-companies";
var WORK_MANAGEMENT_SECTION_ID = "work-management";
var CRM_SECTION_ID = "crm";
var DEV_SECTION_ID = "dev";
var SERVICE_SECTION_ID = "service";
var ICON_TYPES = {
    fill: "fill",
    outline: "outline"
};
var MENU_SECTION_CLASSNAMES = {
    products: "products",
    mondayProducts: "mondayProducts",
    moreProducts: "moreProducts",
    useCases: "use-cases",
    features: "features",
    resources: "resources",
    integrations: "integrations",
    addOns: "addOns"
};
var MENU_SECTION_ITEM_TYPE = {
    base: "base",
    product: "product",
    secondaryProduct: "secondary-product",
    useCase: "use-case",
    useCaseByWorkflow: "use-case-by-workflow",
    feature: "feature",
    resource: "resource",
    story: "story",
    byTeam: "by-team",
    byIndustry: "by-industry",
    innerMenuBottomItem: "inner-menu-bottom-item",
    integration: "integration",
    addOn: "addOn"
};
var mobileProductsSectionMenuItems = [
    {
        id: PRODUCTS_PRODUCTS_SECTION_ID,
        title: "header.products.section.withWm.text.title",
        subtitle: "header.products.section.withWm.text.subtitle",
        mobileTitle: "header.products.section.products.mobileTitle",
        classname: MENU_SECTION_CLASSNAMES.mondayProducts,
        maxNumberOfItemsInColumn: 3,
        noSeparator: true,
        menuSectionItems: [
            {
                itemType: MENU_SECTION_ITEM_TYPE.product,
                mobileIcon: wm_logo,
                icon: monday_work_management_square,
                iconStrokeColor: colors/* default.gainsboro */.Z.gainsboro,
                iconType: ICON_TYPES.fill,
                title: "header.tabs.products.mondayWorkManagement.title",
                subtitle: "header.tabs.products.mondayWorkManagement.subtitle1",
                url: links/* WORK_MANAGEMENT_MINI_SITE_LINK */.ler,
                hoverBackgroundColor: (0,general/* hexToRgba */.a7)(colors/* default */.Z[color_consts.WORK_OS_IRIS_COLOR_NAME], 0.16)
            },
            {
                itemType: MENU_SECTION_ITEM_TYPE.product,
                mobileIcon: mobile_crm_logo,
                icon: monday_crm_square/* default */.Z,
                iconStrokeColor: colors/* default.gainsboro */.Z.gainsboro,
                iconType: ICON_TYPES.fill,
                title: "header.tabs.products.mondaySalesCRM.title",
                subtitle: "header.tabs.products.mondaySalesCRM.subtitle",
                url: links/* CRM_MINI_SITE_LINK */.mgz,
                hoverBackgroundColor: (0,general/* hexToRgba */.a7)(colors/* default */.Z[color_consts.CRM_GREEN_COLOR_NAME], 0.16),
                tags: {
                    title: "header.tabs.products.tags.title",
                    color: "#025050",
                    backgroundColor: (0,general/* hexToRgba */.a7)(colors/* default */.Z[color_consts.CRM_GREEN_COLOR_NAME], 0.16),
                    list: [
                        "header.tabs.products.mondaySalesCRM.tags.contactManagement",
                        "header.tabs.products.mondaySalesCRM.tags.salesPipeline",
                        "header.tabs.products.mondaySalesCRM.tags.leadManagement"
                    ]
                }
            },
            {
                itemType: MENU_SECTION_ITEM_TYPE.product,
                mobileIcon: dev_logo_new,
                icon: monday_dev_square/* default */.Z,
                iconStrokeColor: colors/* default.gainsboro */.Z.gainsboro,
                iconType: ICON_TYPES.fill,
                title: "header.tabs.products.mondayDev.title",
                subtitle: "header.tabs.products.mondayDev.subtitle1",
                url: links/* SOFTWARE_MINI_SITE_LINK */.DDD,
                hoverBackgroundColor: (0,general/* hexToRgba */.a7)(colors/* default */.Z[color_consts.DEV_GREEN_COLOR_NAME], 0.16)
            },
            {
                itemType: MENU_SECTION_ITEM_TYPE.product,
                mobileIcon: service_logo,
                iconStrokeColor: colors/* default.gainsboro */.Z.gainsboro,
                iconType: ICON_TYPES.fill,
                title: "header.tabs.products.mondayService.title",
                subtitle: "header.tabs.products.mondayService.subtitle",
                url: links/* SERVICE_MINI_SITE_LINK */.Kon,
                hoverBackgroundColor: (0,general/* hexToRgba */.a7)(colors/* default */.Z[color_consts.BRAND_SERVICE_PRIMARY_COLOR_NAME], 0.16),
                hasBetaTag: true
            }
        ]
    },
    {
        id: PRODUCTS_MORE_SECTION_ID,
        classname: MENU_SECTION_CLASSNAMES.moreProducts,
        title: "header.products.section.more",
        titleLine: true,
        menuSectionItems: [
            {
                itemType: MENU_SECTION_ITEM_TYPE.secondaryProduct,
                icon: workforms_colored,
                iconType: ICON_TYPES.fill,
                title: "header.tabs.products.more.workForms.title",
                url: links/* WORKFORMS_HOMEPAGE_LINK */.o2N,
                openInNewTab: true
            },
            {
                itemType: MENU_SECTION_ITEM_TYPE.secondaryProduct,
                icon: workcanvas_colored,
                iconType: ICON_TYPES.fill,
                title: "header.tabs.products.more.workCanvas.title",
                url: links/* CANVAS_HOMEPAGE_LINK */.gOl,
                openInNewTab: true
            }
        ]
    }
];
var TAG_TYPES = {
    DEFAULT: "default",
    BULLET: "bullet"
};
var productsSectionMenuItems = [
    {
        id: PRODUCTS_PRODUCTS_SECTION_ID,
        title: "header.products.section.withWm.text.title",
        mobileTitle: "header.products.section.products.mobileTitle",
        classname: MENU_SECTION_CLASSNAMES.mondayProducts,
        maxNumberOfItemsInColumn: 3,
        noSeparator: true,
        menuSectionItems: [
            {
                itemType: MENU_SECTION_ITEM_TYPE.product,
                mobileIcon: mobile_crm_logo,
                icon: monday_work_management_square,
                iconStrokeColor: colors/* default.gainsboro */.Z.gainsboro,
                iconType: ICON_TYPES.fill,
                title: "header.tabs.products.mondayWorkManagement.title",
                subtitle: "header.tabs.products.mondayWorkManagement.subtitle1",
                url: links/* WORK_MANAGEMENT_MINI_SITE_LINK */.ler,
                hoverBackgroundColor: (0,general/* hexToRgba */.a7)(colors/* default */.Z[color_consts.WORK_OS_IRIS_COLOR_NAME], 0.16),
                tags: {
                    title: "header.tabs.products.tags.title",
                    color: colors/* default */.Z[color_consts.DARK_WORK_OS_IRIS_COLOR_NAME],
                    backgroundColor: (0,general/* hexToRgba */.a7)("#babafd", 0.2),
                    list: [
                        "header.tabs.products.mondayWorkManagement.tags.projectAndTaskManagement",
                        "header.tabs.products.mondayWorkManagement.tags.operations",
                        "header.tabs.products.mondayWorkManagement.tags.buildYourOwn"
                    ]
                }
            },
            {
                itemType: MENU_SECTION_ITEM_TYPE.product,
                mobileIcon: mobile_crm_logo,
                icon: monday_crm_square/* default */.Z,
                iconStrokeColor: colors/* default.gainsboro */.Z.gainsboro,
                iconType: ICON_TYPES.fill,
                title: "header.tabs.products.mondaySalesCRM.title",
                subtitle: "header.tabs.products.mondaySalesCRM.subtitle",
                url: links/* CRM_MINI_SITE_LINK */.mgz,
                hoverBackgroundColor: (0,general/* hexToRgba */.a7)(colors/* default */.Z[color_consts.CRM_GREEN_COLOR_NAME], 0.16),
                tags: {
                    title: "header.tabs.products.tags.title",
                    color: "#025050",
                    backgroundColor: (0,general/* hexToRgba */.a7)(colors/* default */.Z[color_consts.CRM_GREEN_COLOR_NAME], 0.16),
                    list: [
                        "header.tabs.products.mondaySalesCRM.tags.contactManagement",
                        "header.tabs.products.mondaySalesCRM.tags.salesPipeline",
                        "header.tabs.products.mondaySalesCRM.tags.leadManagement"
                    ]
                }
            },
            {
                itemType: MENU_SECTION_ITEM_TYPE.product,
                mobileIcon: dev_logo_new,
                icon: monday_dev_square/* default */.Z,
                iconStrokeColor: colors/* default.gainsboro */.Z.gainsboro,
                iconType: ICON_TYPES.fill,
                title: "header.tabs.products.mondayDev.title",
                subtitle: "header.tabs.products.mondayDev.subtitle1",
                url: links/* SOFTWARE_MINI_SITE_LINK */.DDD,
                hoverBackgroundColor: (0,general/* hexToRgba */.a7)(colors/* default */.Z[color_consts.DEV_GREEN_COLOR_NAME], 0.16),
                tags: {
                    title: "header.tabs.products.tags.title",
                    color: "#015727",
                    backgroundColor: (0,general/* hexToRgba */.a7)(colors/* default */.Z[color_consts.DEV_GREEN_COLOR_NAME], 0.08),
                    list: [
                        "header.tabs.products.mondayDev.tags.roadmapPlanning",
                        "header.tabs.products.mondayDev.tags.bugTracking",
                        "header.tabs.products.mondayDev.tags.scrumAndKanban"
                    ]
                }
            }
        ]
    },
    {
        id: PRODUCTS_PRODUCTS_SECTION_ID,
        mobileTitle: "header.products.section.products.mobileTitle",
        classname: MENU_SECTION_CLASSNAMES.mondayProducts,
        maxNumberOfItemsInColumn: 3,
        menuSectionItems: [
            {
                itemType: MENU_SECTION_ITEM_TYPE.product,
                mobileIcon: mobile_marketer_logo,
                icon: monday_marketer_square/* default */.Z,
                iconStrokeColor: colors/* default.gainsboro */.Z.gainsboro,
                iconType: ICON_TYPES.fill,
                title: "header.tabs.products.mondayMarketer.title",
                subtitle: "header.tabs.products.mondayMarketer.subtitle",
                url: links/* MARKETING_MANAGEMENT_MINI_SITE_LINK */.Txj,
                hoverBackgroundColor: (0,general/* hexToRgba */.a7)(colors/* default */.Z[color_consts.MARKETING_RED_COLOR_NAME], 0.16),
                tags: {
                    title: "header.tabs.products.tags.title",
                    color: "#9A0550",
                    backgroundColor: (0,general/* hexToRgba */.a7)(colors/* default */.Z[color_consts.MARKETING_RED_COLOR_NAME], 0.08),
                    list: [
                        "header.tabs.products.mondayMarketer.tags.contentCalendar",
                        "header.tabs.products.mondayMarketer.tags.marketingStrategy",
                        "header.tabs.products.mondayMarketer.tags.creativeRequests"
                    ]
                }
            },
            {
                itemType: MENU_SECTION_ITEM_TYPE.product,
                mobileIcon: mobile_projects_logo,
                icon: monday_projects_square/* default */.Z,
                iconStrokeColor: colors/* default.gainsboro */.Z.gainsboro,
                iconType: ICON_TYPES.fill,
                title: "header.tabs.products.mondayProjects.title",
                subtitle: "header.tabs.products.mondayProjects.subtitle",
                url: links/* PROJECT_MANAGEMENT_MINI_SITE_LINK */.JgV,
                hoverBackgroundColor: (0,general/* hexToRgba */.a7)(colors/* default */.Z[color_consts.PROJECTS_ORANGE_COLOR_NAME], 0.16),
                tags: {
                    title: "header.tabs.products.tags.title",
                    color: "#BC5004",
                    backgroundColor: (0,general/* hexToRgba */.a7)(colors/* default */.Z[color_consts.PROJECTS_ORANGE_COLOR_NAME], 0.08),
                    list: [
                        "header.tabs.products.mondayProjects.tags.advancedProjects",
                        "header.tabs.products.mondayProjects.tags.portfolioManagement",
                        "header.tabs.products.mondayProjects.tags.criticalPath"
                    ]
                }
            }
        ]
    },
    {
        id: PRODUCTS_MORE_SECTION_ID,
        classname: MENU_SECTION_CLASSNAMES.moreProducts,
        title: "header.products.section.more",
        titleLine: true,
        menuSectionItems: [
            {
                itemType: MENU_SECTION_ITEM_TYPE.secondaryProduct,
                icon: workforms_colored,
                iconType: ICON_TYPES.fill,
                title: "header.tabs.products.more.workForms.title",
                url: links/* WORKFORMS_HOMEPAGE_LINK */.o2N,
                openInNewTab: true
            },
            {
                itemType: MENU_SECTION_ITEM_TYPE.secondaryProduct,
                icon: workcanvas_colored,
                iconType: ICON_TYPES.fill,
                title: "header.tabs.products.more.workCanvas.title",
                url: links/* CANVAS_HOMEPAGE_LINK */.gOl,
                openInNewTab: true
            }
        ]
    }
];
var useCasesSectionMenuItems = [
    {
        id: BY_TEAM_SECTION_ID,
        title: "header.useCases.section.byTeam",
        titleLine: true,
        classname: MENU_SECTION_CLASSNAMES.useCases,
        maxNumberOfItemsInColumn: 4,
        menuSectionItems: [
            {
                itemType: MENU_SECTION_ITEM_TYPE.useCase,
                icon: marketing_colored,
                iconColor: color_consts.MARKETING_RED_COLOR_NAME,
                title: "header.tabs.workflows.byTeam.marketing",
                url: links/* WORK_MANAGEMENT_FOR_MARKETING_MINI_SITE_LINK */.qAD,
                outline: true
            },
            {
                itemType: MENU_SECTION_ITEM_TYPE.useCaseByWorkflow,
                icon: project_management_colored_2,
                title: "header.tabs.workflows.byWorkflow.projectManagement.title",
                description: "header.tabs.workflows.byWorkflow.projectManagement.description",
                url: links/* WORK_MANAGEMENT_FOR_PMO_MINI_SITE_LINK */.Y42
            },
            {
                itemType: MENU_SECTION_ITEM_TYPE.useCase,
                icon: sales_colored_1,
                iconColor: color_consts.CRM_GREEN_COLOR_NAME,
                title: "header.tabs.workflows.byTeam.sales",
                url: links/* CRM_MINI_SITE_LINK */.mgz,
                outline: true
            },
            {
                itemType: MENU_SECTION_ITEM_TYPE.useCase,
                icon: dev_colored,
                iconColor: color_consts.DEV_GREEN_COLOR_NAME,
                title: "header.tabs.teams.byTeam.productDevelopers",
                url: links/* SOFTWARE_MINI_SITE_LINK */.DDD,
                outline: true
            },
            {
                itemType: MENU_SECTION_ITEM_TYPE.useCase,
                icon: operations_colored,
                title: "header.tabs.workflows.byTeam.operations",
                url: links/* OPERATIONS_CLUSTER_LINK */.R9t,
                outline: true
            },
            {
                itemType: MENU_SECTION_ITEM_TYPE.useCase,
                icon: it_colored_1,
                title: "header.tabs.workflows.byTeam.it",
                url: links/* SERVICE_MINI_SITE_LINK */.Kon,
                outline: true
            },
            {
                itemType: MENU_SECTION_ITEM_TYPE.useCase,
                icon: hr_colored_1,
                title: "header.tabs.workflows.byTeam.hr",
                url: links/* HR_USE_CASES_LINK */.n$n,
                outline: true
            }
        ]
    },
    {
        id: BY_BUSINESS_SIZE_SECTION_ID,
        title: "header.useCases.section.byBusinessSize",
        titleLine: true,
        classname: MENU_SECTION_CLASSNAMES.useCases,
        maxNumberOfItemsInColumn: 4,
        menuSectionItems: [
            {
                itemType: MENU_SECTION_ITEM_TYPE.useCase,
                icon: enterprise_colored_1,
                title: "header.tabs.workflows.byBusinessSize.enterprise",
                url: links/* ENTERPRISE_PAGE_LINK */.RVF
            },
            {
                itemType: MENU_SECTION_ITEM_TYPE.useCase,
                icon: small_business_colored_1,
                title: "header.tabs.workflows.byBusinessSize.smallBusiness",
                url: links/* SMB_PAGE_LINK */.qDl
            },
            {
                itemType: MENU_SECTION_ITEM_TYPE.useCase,
                icon: nonprofit_colored,
                title: "header.tabs.workflows.byBusinessSize.nonprofit",
                url: links/* NGO_PAGE_LINK */.htU
            }
        ]
    },
    {
        id: BY_INDUSTRY_SECTION_ID,
        title: "header.tabs.solutions.byTeam.industries.title",
        titleLine: true,
        classname: MENU_SECTION_CLASSNAMES.useCases,
        maxNumberOfItemsInColumn: 4,
        menuSectionItems: [
            {
                itemType: MENU_SECTION_ITEM_TYPE.byIndustry,
                icon: retail_colored,
                hoverBackgroundColor: colors/* default */.Z[color_consts.BACKGROUND_GRAY_COLOR_NAME],
                title: "header.tabs.solutions.byTeam.industries.retail.title",
                url: links/* RETAIL_PAGE_LINK */.fjW
            },
            {
                itemType: MENU_SECTION_ITEM_TYPE.byIndustry,
                icon: media_colored,
                hoverBackgroundColor: colors/* default */.Z[color_consts.BACKGROUND_GRAY_COLOR_NAME],
                title: "header.tabs.solutions.byTeam.industries.media.title",
                url: links/* MEDIA_PAGE_LINK */.Dx_
            },
            {
                itemType: MENU_SECTION_ITEM_TYPE.byIndustry,
                icon: construction_colored,
                hoverBackgroundColor: colors/* default */.Z[color_consts.BACKGROUND_GRAY_COLOR_NAME],
                title: "header.tabs.solutions.byTeam.industries.construction.title",
                url: links/* CONSTRUCTION_MINI_SITE_LINK */.ikI
            }
        ]
    }
];
var featuresSectionMenuItems = [
    {
        id: KEY_FEATURES_SECTION_ID,
        maxNumberOfItemsInColumn: 2,
        menuSectionItems: [
            {
                itemType: MENU_SECTION_ITEM_TYPE.feature,
                icon: dashboards_colored,
                title: "header.tabs.features.keyFeatures.dashboards.title",
                description: "header.tabs.features.keyFeatures.dashboards.description",
                outline: true,
                url: links/* DASHBOARDS_PAGE_LINK */.yCu
            },
            {
                itemType: MENU_SECTION_ITEM_TYPE.feature,
                icon: integrations_colored,
                title: "header.tabs.features.keyFeatures.integrations.title",
                description: "header.tabs.features.keyFeatures.integrations.description",
                outline: true,
                url: links/* INTEGRATIONS_PAGE_LINK */.oUX
            },
            {
                itemType: MENU_SECTION_ITEM_TYPE.feature,
                icon: automations_colored,
                title: "header.tabs.features.keyFeatures.automations.title",
                description: "header.tabs.features.keyFeatures.automations.description",
                outline: true,
                url: links/* AUTOMATIONS_PAGE_LINK */.cPO
            },
            {
                itemType: MENU_SECTION_ITEM_TYPE.feature,
                icon: ai_icon,
                title: "header.tabs.features.keyFeatures.ai.title",
                description: "header.tabs.features.keyFeatures.ai.description",
                outline: true,
                url: links/* AI_PAGE_LINK */.lro
            },
            {
                itemType: MENU_SECTION_ITEM_TYPE.feature,
                icon: kanban_colored,
                title: "header.tabs.features.keyFeatures.kanban.title",
                description: "header.tabs.features.keyFeatures.kanban.description",
                outline: true,
                url: links/* KANBAN_PAGE_LINK */.ivN
            },
            {
                itemType: MENU_SECTION_ITEM_TYPE.feature,
                icon: docs_colored,
                title: "header.tabs.features.keyFeatures.docs.title",
                description: "header.tabs.features.keyFeatures.docs.description",
                outline: true,
                url: links/* WORKDOCS_PAGE_LINK */.RdE
            },
            {
                itemType: MENU_SECTION_ITEM_TYPE.feature,
                icon: gantt_colored,
                title: "header.tabs.features.keyFeatures.gantt.title",
                description: "header.tabs.features.keyFeatures.gantt.description",
                outline: true,
                url: links/* GANTT_PAGE_LINK */.TA3
            },
            {
                itemType: MENU_SECTION_ITEM_TYPE.feature,
                icon: forms_icon_new,
                title: "header.tabs.features.keyFeatures.forms.title",
                description: "header.tabs.features.keyFeatures.forms.description",
                outline: true,
                url: links/* FORMS_PAGE_LINK */.ua2
            }
        ]
    }
];
var resourcesSectionMenuItems = [
    {
        id: RESOURCES_LEARN_SECTION_ID,
        classname: MENU_SECTION_CLASSNAMES.resources,
        title: "header.tabs.resources.section.learn",
        titleLine: true,
        noSeparator: true,
        maxNumberOfItemsInColumn: 5,
        menuSectionItems: [
            {
                itemType: MENU_SECTION_ITEM_TYPE.resource,
                title: "header.tabs.resources.learn.knowledgeBase.title",
                description: "header.tabs.resources.learn.knowledgeBase.description",
                url: links/* HELP_CENTER_LINK */.j3e
            },
            {
                itemType: MENU_SECTION_ITEM_TYPE.resource,
                title: "header.tabs.resources.learn.whatsNew.title",
                description: "header.tabs.resources.learn.whatsNew.description",
                url: links/* WHATS_NEW_PAGE_LINK */.Lmq
            },
            {
                itemType: MENU_SECTION_ITEM_TYPE.resource,
                title: "header.tabs.resources.learn.aboutUs.title",
                description: "header.tabs.resources.learn.aboutUs.description",
                url: links/* ABOUT_US_PAGE_LINK */.iAZ
            },
            // {
            //   itemType: MENU_SECTION_ITEM_TYPE.resource,
            //   title: "header.tabs.resources.learn.resourcesHub.title",
            //   description: "header.tabs.resources.learn.resourcesHub.description",
            // },
            {
                itemType: MENU_SECTION_ITEM_TYPE.resource,
                title: "header.tabs.resources.learn.blog.title",
                description: "header.tabs.resources.learn.blog.description",
                url: links/* BLOG_PAGE_LINK */.xR0
            },
            {
                itemType: MENU_SECTION_ITEM_TYPE.resource,
                title: "header.tabs.resources.connect.BuilderCertificationsText.title",
                description: "header.tabs.resources.connect.BuilderCertificationsText.description",
                url: links/* BUILDERS_CERTIFICATIONS_PAGE_LINK */.QHq
            }
        ]
    },
    {
        id: RESOURCES_CONNECT_SECTION_ID,
        title: "header.tabs.resources.section.connect",
        titleLine: true,
        noSeparator: true,
        maxNumberOfItemsInColumn: 5,
        menuSectionItems: [
            {
                itemType: MENU_SECTION_ITEM_TYPE.resource,
                title: "header.tabs.resources.connect.support.title",
                description: "header.tabs.resources.connect.support.description",
                url: links/* SUPPORT_PAGE_LINK */.jX6
            },
            {
                itemType: MENU_SECTION_ITEM_TYPE.resource,
                title: "header.tabs.resources.connect.partners.title",
                description: "header.tabs.resources.connect.partners.description1",
                url: links/* PARTNERS_PAGE_LINK */.MW2
            },
            {
                itemType: MENU_SECTION_ITEM_TYPE.resource,
                title: "header.tabs.resources.connect.globalEvents.title",
                description: "header.tabs.resources.connect.globalEvents.description",
                url: links/* GLOBAL_EVENTS_PAGE_LINK */.O5z
            },
            {
                itemType: MENU_SECTION_ITEM_TYPE.resource,
                hoverBackgroundColor: colors/* default */.Z[color_consts.BACKGROUND_GRAY_COLOR_NAME],
                title: "header.tabs.resources.connect.community.title",
                description: "header.tabs.resources.connect.community.description",
                url: links/* COMMUNITY_LINK */.gcb
            }
        ]
    },
    {
        id: RESOURCES_EXPLORE_SECTION_ID,
        title: "header.tabs.resources.section.build",
        titleLine: true,
        noSeparator: true,
        maxNumberOfItemsInColumn: 5,
        menuSectionItems: [
            {
                itemType: MENU_SECTION_ITEM_TYPE.resource,
                title: "header.tabs.resources.explore.appsDeveloper.title",
                description: "header.tabs.resources.explore.appsDeveloper.description",
                url: links/* APPS_DEVELOPER_LINK */.FE7
            },
            {
                itemType: MENU_SECTION_ITEM_TYPE.resource,
                title: "header.tabs.resources.explore.templateCenter.title",
                description: "header.tabs.resources.explore.templateCenter.description1",
                url: links/* TEMPLATE_CENTER_PAGE_LINK */.EDy
            },
            {
                itemType: MENU_SECTION_ITEM_TYPE.resource,
                title: "header.tabs.resources.explore.spaces.title",
                description: "header.tabs.resources.explore.spaces.description",
                url: links/* MONDAY_SPACES_PAGE_LINK */.UN3
            }
        ]
    },
    {
        id: TOP_STORIES_SECTION_ID,
        title: "header.tabs.resources.section.customersStories",
        titleLine: true,
        noSeparator: true,
        maxNumberOfItemsInColumn: 2,
        backgroundColor: color_consts.BACKGROUND_GRAY_COLOR_NAME,
        hideOnMobile: true,
        menuSectionItems: [
            {
                itemType: MENU_SECTION_ITEM_TYPE.story,
                hoverBackgroundColor: colors/* default */.Z[color_consts.WHITE_COLOR_NAME],
                imageSrc: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/Home%20Page%20-%202022%20Rebrand/header/Header_asset.png",
                description: "header.tabs.resources.topStories.whyCustomersUse",
                url: links/* MONDAY_STORIES_PAGE */.Ce8,
                button: true
            }
        ]
    }
];
var solutionsMenu = {
    innerMenu: {
        items: [
            {
                id: "By product",
                title: "header.tabs.solutions.byProduct.title.byMonday",
                subItems: [
                    {
                        id: "Work management",
                        title: "header.tabs.solutions.byProduct.workManagement",
                        subtitle: "Run all aspects of work",
                        icon: wm_logo,
                        content: {
                            menuSections: [
                                {
                                    id: WORK_MANAGEMENT_SECTION_ID,
                                    title: "header.tabs.products.mondayWorkManagement.subtitle1",
                                    titleUrl: links/* WORK_MANAGEMENT_MINI_SITE_LINK */.ler,
                                    titleImage: work_managment_logos/* default.WM_BIGGER_DESKTOP_LOGO */.Z.WM_BIGGER_DESKTOP_LOGO,
                                    titleCTA: {
                                        title: "signup.learnMore",
                                        buttonType: button_consts/* REGULAR_BUTTON_TYPE */.ys,
                                        eventInfo: "learnMore",
                                        color: color_consts.BRAND_WORK_MANAGEMENT_PRIMARY_COLOR_NAME,
                                        outline: true,
                                        buttonSize: sizes.SM,
                                        url: links/* WORK_MANAGEMENT_MINI_SITE_LINK */.ler
                                    },
                                    maxNumberOfItemsInColumn: 3,
                                    seeMoreItem: {
                                        title: "header.seeAllUseCases",
                                        eventInfo: "seeAll",
                                        url: links/* WORK_MANAGEMENT_MINI_SITE_LINK */.ler
                                    },
                                    menuSectionItems: [
                                        {
                                            title: "header.tabs.solutions.byProduct.workManagement.projectManagement.title",
                                            hoverBackgroundColor: colors/* default */.Z[color_consts.BACKGROUND_GRAY_COLOR_NAME],
                                            description: "header.tabs.solutions.byProduct.workManagement.projectManagement.description",
                                            url: (0,url.addParamToURL)(links/* WORK_MANAGEMENT_MINI_SITE_LINK */.ler, square_tags/* PRESELECTED_TAG_PARAM_NAME */.x, clusters.PROJECT_MANAGEMENT_USE_CASE)
                                        },
                                        {
                                            title: "header.tabs.solutions.byProduct.workManagement.taskManagement.title",
                                            hoverBackgroundColor: colors/* default */.Z[color_consts.BACKGROUND_GRAY_COLOR_NAME],
                                            description: "header.tabs.solutions.byProduct.workManagement.taskManagement.description",
                                            url: (0,url.addParamToURL)(links/* WORK_MANAGEMENT_MINI_SITE_LINK */.ler, square_tags/* PRESELECTED_TAG_PARAM_NAME */.x, clusters.TASK_MANAGEMENT)
                                        },
                                        {
                                            title: "header.tabs.solutions.byProduct.workManagement.resourceManagement.title",
                                            hoverBackgroundColor: colors/* default */.Z[color_consts.BACKGROUND_GRAY_COLOR_NAME],
                                            description: "header.tabs.solutions.byProduct.workManagement.resourceManagement.description",
                                            url: (0,url.addParamToURL)(links/* WORK_MANAGEMENT_MINI_SITE_LINK */.ler, square_tags/* PRESELECTED_TAG_PARAM_NAME */.x, clusters.RESOURCE_MANAGEMENT)
                                        },
                                        {
                                            title: "header.tabs.solutions.byProduct.workManagement.portfolioManagement.title",
                                            hoverBackgroundColor: colors/* default */.Z[color_consts.BACKGROUND_GRAY_COLOR_NAME],
                                            description: "header.tabs.solutions.byProduct.workManagement.portfolioManagement.description",
                                            url: (0,url.addParamToURL)(links/* WORK_MANAGEMENT_MINI_SITE_LINK */.ler, square_tags/* PRESELECTED_TAG_PARAM_NAME */.x, clusters.PORTFOLIO_MANAGEMENT)
                                        },
                                        {
                                            title: "header.tabs.solutions.byProduct.workManagement.businessOperations.title",
                                            hoverBackgroundColor: colors/* default */.Z[color_consts.BACKGROUND_GRAY_COLOR_NAME],
                                            description: "header.tabs.solutions.byProduct.workManagement.businessOperations.description",
                                            url: (0,url.addParamToURL)(links/* WORK_MANAGEMENT_MINI_SITE_LINK */.ler, square_tags/* PRESELECTED_TAG_PARAM_NAME */.x, clusters.BUSINESS_OPERATIONS)
                                        },
                                        {
                                            title: "header.tabs.solutions.byProduct.workManagement.goalsAndStrategy.title",
                                            hoverBackgroundColor: colors/* default */.Z[color_consts.BACKGROUND_GRAY_COLOR_NAME],
                                            description: "header.tabs.solutions.byProduct.workManagement.goalsAndStrategy.description",
                                            url: (0,url.addParamToURL)(links/* WORK_MANAGEMENT_MINI_SITE_LINK */.ler, square_tags/* PRESELECTED_TAG_PARAM_NAME */.x, clusters.STRATEGIC_PLANNING)
                                        }
                                    ]
                                },
                                {
                                    id: TOP_STORIES_SECTION_ID,
                                    title: "header.tabs.solutions.byProduct.workManagement.rightSection.title",
                                    maxNumberOfItemsInColumn: 1,
                                    backgroundColor: color_consts.WHITE_COLOR_NAME,
                                    menuSectionItems: [
                                        {
                                            itemType: MENU_SECTION_ITEM_TYPE.story,
                                            backgroundColor: colors/* default */.Z[color_consts.GHOST_WHITE_COLOR_NAME],
                                            hoverBackgroundColor: colors/* default */.Z[color_consts.GHOST_WHITE_COLOR_NAME],
                                            imageSrc: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/Home%20Page%20-%202022%20Rebrand/header/Wm_image.png",
                                            description: "header.tabs.solutions.byProduct.workManagement.rightSection.card.description",
                                            url: links/* TEMPLATE_CENTER_PAGE_LINK */.EDy,
                                            buttonText: "header.tabs.solutions.byProduct.workManagement.rightSection.card.buttonText.startWithAtemplate",
                                            button: true
                                        }
                                    ]
                                }
                            ]
                        }
                    },
                    {
                        id: "CRM",
                        title: "header.tabs.solutions.byProduct.crm",
                        subtitle: "Streamline sales processes",
                        icon: mobile_crm_logo,
                        content: {
                            menuSections: [
                                {
                                    id: CRM_SECTION_ID,
                                    title: "header.tabs.products.mondaySalesCRM.subtitle",
                                    titleUrl: links/* CRM_MINI_SITE_LINK */.mgz,
                                    titleImage: "https://dapulse-res.cloudinary.com/image/upload/remote_mondaycom_static/uploads/Yotam_Ron/logo-crm-only.png",
                                    titleCTA: {
                                        title: "signup.learnMore",
                                        outline: true,
                                        eventInfo: "learnMore",
                                        color: color_consts.CRM_DARK_TINT_01_COLOR_NAME,
                                        buttonType: button_consts/* REGULAR_BUTTON_TYPE */.ys,
                                        buttonSize: sizes.SM,
                                        url: links/* CRM_MINI_SITE_LINK */.mgz
                                    },
                                    maxNumberOfItemsInColumn: 3,
                                    seeMoreItem: {
                                        eventInfo: "seeAll",
                                        title: "header.seeAllUseCases",
                                        url: links/* CRM_MINI_SITE_LINK */.mgz
                                    },
                                    menuSectionItems: [
                                        {
                                            title: "header.tabs.solutions.byProduct.salesCRM.salesPipeline.title",
                                            hoverBackgroundColor: colors/* default */.Z[color_consts.BACKGROUND_GRAY_COLOR_NAME],
                                            description: "header.tabs.solutions.byProduct.salesCRM.salesPipeline.description",
                                            url: (0,url.addParamToURL)(links/* CRM_MINI_SITE_LINK */.mgz, square_tags/* PRESELECTED_TAG_PARAM_NAME */.x, clusters.SALES_PIPELINE)
                                        },
                                        {
                                            title: "header.tabs.solutions.byProduct.salesCRM.contactManagement.title",
                                            hoverBackgroundColor: colors/* default */.Z[color_consts.BACKGROUND_GRAY_COLOR_NAME],
                                            description: "header.tabs.solutions.byProduct.salesCRM.contactManagement.description",
                                            url: (0,url.addParamToURL)(links/* CRM_MINI_SITE_LINK */.mgz, square_tags/* PRESELECTED_TAG_PARAM_NAME */.x, clusters.CONTACT_MANAGEMENT)
                                        },
                                        {
                                            title: "header.tabs.solutions.byProduct.salesCRM.customerProjects.title",
                                            hoverBackgroundColor: colors/* default */.Z[color_consts.BACKGROUND_GRAY_COLOR_NAME],
                                            description: "header.tabs.solutions.byProduct.salesCRM.customerProjects.description",
                                            url: (0,url.addParamToURL)(links/* CRM_MINI_SITE_LINK */.mgz, square_tags/* PRESELECTED_TAG_PARAM_NAME */.x, clusters.CUSTOMER_PROJECTS)
                                        },
                                        {
                                            title: "header.tabs.solutions.byProduct.salesCRM.leadCapturing.title",
                                            hoverBackgroundColor: colors/* default */.Z[color_consts.BACKGROUND_GRAY_COLOR_NAME],
                                            description: "header.tabs.solutions.byProduct.salesCRM.leadCapturing.description",
                                            url: (0,url.addParamToURL)(links/* CRM_MINI_SITE_LINK */.mgz, square_tags/* PRESELECTED_TAG_PARAM_NAME */.x, clusters.LEADS_CAPTURING)
                                        },
                                        {
                                            title: "header.tabs.solutions.byProduct.salesCRM.leadManagement.title",
                                            hoverBackgroundColor: colors/* default */.Z[color_consts.BACKGROUND_GRAY_COLOR_NAME],
                                            description: "header.tabs.solutions.byProduct.salesCRM.leadManagement.description",
                                            url: (0,url.addParamToURL)(links/* CRM_MINI_SITE_LINK */.mgz, square_tags/* PRESELECTED_TAG_PARAM_NAME */.x, clusters.LEAD_MANAGEMENT)
                                        },
                                        {
                                            title: "header.tabs.solutions.byProduct.salesCRM.customerOnboarding.title",
                                            hoverBackgroundColor: colors/* default */.Z[color_consts.BACKGROUND_GRAY_COLOR_NAME],
                                            description: "header.tabs.solutions.byProduct.salesCRM.customerOnboarding.description",
                                            url: (0,url.addParamToURL)(links/* CRM_MINI_SITE_LINK */.mgz, square_tags/* PRESELECTED_TAG_PARAM_NAME */.x, clusters.CUSTOMER_ONBOARDING)
                                        }
                                    ]
                                },
                                {
                                    id: TOP_STORIES_SECTION_ID,
                                    title: "header.tabs.solutions.byProduct.crm.rightSection.title",
                                    maxNumberOfItemsInColumn: 1,
                                    backgroundColor: color_consts.WHITE_COLOR_NAME,
                                    menuSectionItems: [
                                        {
                                            itemType: MENU_SECTION_ITEM_TYPE.story,
                                            backgroundColor: colors/* default */.Z[color_consts.GHOST_WHITE_COLOR_NAME],
                                            hoverBackgroundColor: colors/* default */.Z[color_consts.GHOST_WHITE_COLOR_NAME],
                                            imageSrc: "https://dapulse-res.cloudinary.com/image/upload/v1669619701/Generator_featured%20images/Home%20Page%20-%202022%20Rebrand/header/crm_image.png",
                                            description: "header.tabs.solutions.byProduct.crm.rightSection.card.description",
                                            url: links/* CRM_MINI_SITE_LINK */.mgz,
                                            buttonText: "header.tabs.solutions.byProduct.crm.rightSection.card.buttonText",
                                            button: true
                                        }
                                    ]
                                }
                            ]
                        }
                    },
                    {
                        id: "Dev",
                        title: "header.tabs.solutions.byProduct.dev",
                        subtitle: "Manage product lifecycles",
                        icon: dev_logo_new,
                        content: {
                            menuSections: [
                                {
                                    id: DEV_SECTION_ID,
                                    title: "header.tabs.products.mondayDev.subtitle1",
                                    titleUrl: links/* SOFTWARE_MINI_SITE_LINK */.DDD,
                                    titleImage: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/Home%20Page%20-%202022%20Rebrand/Dev_new_logo_July23/bigger-desktop_close_monday_dev_logo1.png",
                                    titleCTA: {
                                        title: "signup.learnMore",
                                        buttonType: button_consts/* REGULAR_BUTTON_TYPE */.ys,
                                        buttonSize: sizes.SM,
                                        outline: true,
                                        eventInfo: "learnMore",
                                        color: color_consts.BRAND_GREEN_DARK_TINT_01_COLOR_NAME,
                                        url: links/* SOFTWARE_MINI_SITE_LINK */.DDD
                                    },
                                    maxNumberOfItemsInColumn: 3,
                                    seeMoreItem: {
                                        eventInfo: "seeAll",
                                        title: "header.seeAllUseCases",
                                        url: links/* SOFTWARE_MINI_SITE_LINK */.DDD
                                    },
                                    menuSectionItems: [
                                        {
                                            title: "header.tabs.solutions.byProduct.dev.sprintManagement.title",
                                            hoverBackgroundColor: colors/* default */.Z[color_consts.BACKGROUND_GRAY_COLOR_NAME],
                                            description: "header.tabs.solutions.byProduct.dev.sprintManagement.description",
                                            url: (0,url.addParamToURL)(links/* SOFTWARE_MINI_SITE_LINK */.DDD, square_tags/* PRESELECTED_TAG_PARAM_NAME */.x, clusters.SPRINT_MANAGEMENT)
                                        },
                                        {
                                            title: "header.tabs.solutions.byProduct.dev.bugTracking.title",
                                            hoverBackgroundColor: colors/* default */.Z[color_consts.BACKGROUND_GRAY_COLOR_NAME],
                                            description: "header.tabs.solutions.byProduct.dev.bugTracking.description",
                                            url: (0,url.addParamToURL)(links/* SOFTWARE_MINI_SITE_LINK */.DDD, square_tags/* PRESELECTED_TAG_PARAM_NAME */.x, clusters.BUGS_TRACKING)
                                        },
                                        {
                                            title: "header.tabs.solutions.byProduct.dev.releasePlan.title",
                                            hoverBackgroundColor: colors/* default */.Z[color_consts.BACKGROUND_GRAY_COLOR_NAME],
                                            description: "header.tabs.solutions.byProduct.dev.releasePlan.description",
                                            url: (0,url.addParamToURL)(links/* SOFTWARE_MINI_SITE_LINK */.DDD, square_tags/* PRESELECTED_TAG_PARAM_NAME */.x, clusters.RELEASE_PLAN)
                                        },
                                        {
                                            title: "header.tabs.solutions.byProduct.dev.roadmapPlanning.title",
                                            hoverBackgroundColor: colors/* default */.Z[color_consts.BACKGROUND_GRAY_COLOR_NAME],
                                            description: "header.tabs.solutions.byProduct.dev.roadmapPlanning.description",
                                            url: (0,url.addParamToURL)(links/* SOFTWARE_MINI_SITE_LINK */.DDD, square_tags/* PRESELECTED_TAG_PARAM_NAME */.x, clusters.ROADMAP_PLANNING)
                                        },
                                        {
                                            title: "header.tabs.solutions.byProduct.dev.featureRequests.title",
                                            hoverBackgroundColor: colors/* default */.Z[color_consts.BACKGROUND_GRAY_COLOR_NAME],
                                            description: "header.tabs.solutions.byProduct.dev.featureRequests.description",
                                            url: (0,url.addParamToURL)(links/* SOFTWARE_MINI_SITE_LINK */.DDD, square_tags/* PRESELECTED_TAG_PARAM_NAME */.x, clusters.FEATURE_REQUESTS)
                                        },
                                        {
                                            title: "header.tabs.solutions.byProduct.dev.agileProjects.title",
                                            hoverBackgroundColor: colors/* default */.Z[color_consts.BACKGROUND_GRAY_COLOR_NAME],
                                            description: "header.tabs.solutions.byProduct.dev.agileProjects.description",
                                            url: (0,url.addParamToURL)(links/* SOFTWARE_MINI_SITE_LINK */.DDD, square_tags/* PRESELECTED_TAG_PARAM_NAME */.x, clusters.AGILE_PROJECTS)
                                        }
                                    ]
                                },
                                {
                                    id: TOP_STORIES_SECTION_ID,
                                    title: "header.tabs.solutions.byProduct.dev.rightSection.title",
                                    maxNumberOfItemsInColumn: 1,
                                    backgroundColor: color_consts.WHITE_COLOR_NAME,
                                    menuSectionItems: [
                                        {
                                            itemType: MENU_SECTION_ITEM_TYPE.story,
                                            backgroundColor: colors/* default */.Z[color_consts.GHOST_WHITE_COLOR_NAME],
                                            hoverBackgroundColor: colors/* default */.Z[color_consts.GHOST_WHITE_COLOR_NAME],
                                            imageSrc: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/Home%20Page%20-%202022%20Rebrand/header/dev_image.png",
                                            description: "header.tabs.solutions.byProduct.dev.rightSection.card.description",
                                            url: links/* SOFTWARE_MINI_SITE_LINK */.DDD,
                                            buttonText: "header.tabs.solutions.byProduct.dev.rightSection.card.buttonText",
                                            button: true
                                        }
                                    ]
                                }
                            ]
                        }
                    },
                    {
                        id: "Service",
                        title: "header.tabs.solutions.byProduct.service",
                        icon: service_logo,
                        hasBetaTag: true,
                        content: {
                            menuSections: [
                                {
                                    id: SERVICE_SECTION_ID,
                                    title: "header.tabs.products.mondayService.subtitle",
                                    titleUrl: links/* SERVICE_MINI_SITE_LINK */.Kon,
                                    titleImage: "https://dapulse-res.cloudinary.com/image/upload/remote_mondaycom_static/uploads/Yotam_Ron/service/Service-logo-h-26-header-V2.png",
                                    titleCTA: {
                                        title: "signup.learnMore",
                                        buttonType: button_consts/* REGULAR_BUTTON_TYPE */.ys,
                                        buttonSize: sizes.SM,
                                        outline: true,
                                        eventInfo: "learnMore",
                                        color: color_consts.BRAND_BLACK_TEXT_COLOR,
                                        url: links/* SERVICE_MINI_SITE_LINK */.Kon
                                    },
                                    maxNumberOfItemsInColumn: 3,
                                    seeMoreItem: {
                                        eventInfo: "seeAll",
                                        title: "header.seeAllUseCases",
                                        url: links/* SERVICE_MINI_SITE_LINK */.Kon
                                    },
                                    menuSectionItems: [
                                        {
                                            title: "header.tabs.solutions.byProduct.service.ticketManagement.title",
                                            hoverBackgroundColor: colors/* default */.Z[color_consts.BACKGROUND_GRAY_COLOR_NAME],
                                            description: "header.tabs.solutions.byProduct.service.ticketManagement.description",
                                            url: (0,url.addParamToURL)(links/* SERVICE_MINI_SITE_LINK */.Kon, square_tags/* PRESELECTED_TAG_PARAM_NAME */.x, clusters.TICKET_MANAGEMENT)
                                        },
                                        {
                                            title: "header.tabs.solutions.byProduct.service.employeeLifecycle.title",
                                            hoverBackgroundColor: colors/* default */.Z[color_consts.BACKGROUND_GRAY_COLOR_NAME],
                                            description: "header.tabs.solutions.byProduct.service.employeeLifecycle.description",
                                            url: (0,url.addParamToURL)(links/* SERVICE_MINI_SITE_LINK */.Kon, square_tags/* PRESELECTED_TAG_PARAM_NAME */.x, clusters.EMPLOYEE_LIFECYCLE)
                                        },
                                        {
                                            title: "header.tabs.solutions.byProduct.service.inventoryAndOrders.title",
                                            hoverBackgroundColor: colors/* default */.Z[color_consts.BACKGROUND_GRAY_COLOR_NAME],
                                            description: "header.tabs.solutions.byProduct.service.inventoryAndOrders.description",
                                            url: (0,url.addParamToURL)(links/* SERVICE_MINI_SITE_LINK */.Kon, square_tags/* PRESELECTED_TAG_PARAM_NAME */.x, clusters.INVENTORY_AND_ORDERS)
                                        },
                                        {
                                            title: "header.tabs.solutions.byProduct.service.customerPortal.title",
                                            hoverBackgroundColor: colors/* default */.Z[color_consts.BACKGROUND_GRAY_COLOR_NAME],
                                            description: "header.tabs.solutions.byProduct.service.customerPortal.description",
                                            url: (0,url.addParamToURL)(links/* SERVICE_MINI_SITE_LINK */.Kon, square_tags/* PRESELECTED_TAG_PARAM_NAME */.x, clusters.CUSTOMER_PORTAL)
                                        },
                                        {
                                            title: "header.tabs.solutions.byProduct.service.assetManagement.title",
                                            hoverBackgroundColor: colors/* default */.Z[color_consts.BACKGROUND_GRAY_COLOR_NAME],
                                            description: "header.tabs.solutions.byProduct.service.assetManagement.description",
                                            url: (0,url.addParamToURL)(links/* SERVICE_MINI_SITE_LINK */.Kon, square_tags/* PRESELECTED_TAG_PARAM_NAME */.x, clusters.ASSET_MANAGEMENT)
                                        },
                                        {
                                            title: "header.tabs.solutions.byProduct.service.serviceCatalog.title",
                                            hoverBackgroundColor: colors/* default */.Z[color_consts.BACKGROUND_GRAY_COLOR_NAME],
                                            description: "header.tabs.solutions.byProduct.service.serviceCatalog.description",
                                            url: (0,url.addParamToURL)(links/* SERVICE_MINI_SITE_LINK */.Kon, square_tags/* PRESELECTED_TAG_PARAM_NAME */.x, clusters.SERVICE_CATALOG)
                                        }
                                    ]
                                },
                                {
                                    id: TOP_STORIES_SECTION_ID,
                                    title: "header.tabs.solutions.byProduct.service.rightSection.title",
                                    maxNumberOfItemsInColumn: 1,
                                    backgroundColor: color_consts.WHITE_COLOR_NAME,
                                    menuSectionItems: [
                                        {
                                            itemType: MENU_SECTION_ITEM_TYPE.story,
                                            backgroundColor: colors/* default */.Z[color_consts.GHOST_WHITE_COLOR_NAME],
                                            hoverBackgroundColor: colors/* default */.Z[color_consts.GHOST_WHITE_COLOR_NAME],
                                            imageSrc: "https://dapulse-res.cloudinary.com/image/upload/remote_mondaycom_static/uploads/Yotam_Ron/service/service-tn-v1.png",
                                            description: "header.tabs.solutions.byProduct.service.rightSection.card.description",
                                            url: links/* SERVICE_MINI_SITE_LINK */.Kon,
                                            buttonText: "header.tabs.solutions.byProduct.service.rightSection.card.buttonText",
                                            button: true
                                        }
                                    ]
                                }
                            ]
                        }
                    }
                ]
            }
        ]
    },
    bottomPanel: {
        bottomItems: [
            {
                itemType: MENU_SECTION_ITEM_TYPE.secondaryProduct,
                icon: workforms_colored,
                iconType: ICON_TYPES.fill,
                title: "header.tabs.products.more.workForms.title",
                hoverBackgroundColor: colors/* default */.Z[color_consts.BACKGROUND_GRAY_COLOR_NAME],
                url: links/* WORKFORMS_HOMEPAGE_LINK */.o2N,
                openInNewTab: true
            },
            {
                itemType: MENU_SECTION_ITEM_TYPE.secondaryProduct,
                icon: workcanvas_colored,
                iconType: ICON_TYPES.fill,
                title: "header.tabs.products.more.workCanvas.title",
                hoverBackgroundColor: colors/* default */.Z[color_consts.BACKGROUND_GRAY_COLOR_NAME],
                url: links/* CANVAS_HOMEPAGE_LINK */.gOl,
                openInNewTab: true
            }
        ]
    }
};
var teamsMenu = {
    innerMenu: {
        items: [
            {
                id: "By team",
                title: "header.tabs.solutions.byTeam.title",
                subItems: [
                    {
                        id: "Team type",
                        title: "header.tabs.solutions.byTeam.teamType",
                        icon: team,
                        content: {
                            menuSections: [
                                {
                                    id: BY_TEAM_SECTION_ID,
                                    title: "header.tabs.solutions.byTeam.teamType.title",
                                    maxNumberOfItemsInColumn: 4,
                                    withTitleUnderline: true,
                                    menuSectionItems: [
                                        {
                                            itemType: MENU_SECTION_ITEM_TYPE.byTeam,
                                            icon: marketing_colored,
                                            iconColor: color_consts.MARKETING_RED_COLOR_NAME,
                                            hoverBackgroundColor: colors/* default */.Z[color_consts.BACKGROUND_GRAY_COLOR_NAME],
                                            title: "header.tabs.workflows.byTeam.marketing",
                                            description: "header.tabs.solutions.byTeam.marketing.description",
                                            url: links/* WORK_MANAGEMENT_FOR_MARKETING_MINI_SITE_LINK */.qAD
                                        },
                                        {
                                            itemType: MENU_SECTION_ITEM_TYPE.byTeam,
                                            icon: dev_colored,
                                            iconColor: color_consts.DEV_GREEN_COLOR_NAME,
                                            hoverBackgroundColor: colors/* default */.Z[color_consts.BACKGROUND_GRAY_COLOR_NAME],
                                            title: "header.tabs.solutions.byTeam.developers.title",
                                            description: "header.tabs.solutions.byTeam.developers.description",
                                            url: links/* SOFTWARE_MINI_SITE_LINK */.DDD
                                        },
                                        {
                                            itemType: MENU_SECTION_ITEM_TYPE.byTeam,
                                            icon: operations_colored,
                                            hoverBackgroundColor: colors/* default */.Z[color_consts.BACKGROUND_GRAY_COLOR_NAME],
                                            title: "header.tabs.workflows.byTeam.operations",
                                            description: "header.tabs.solutions.byTeam.operations.description",
                                            url: links/* OPERATIONS_CLUSTER_LINK */.R9t
                                        },
                                        {
                                            itemType: MENU_SECTION_ITEM_TYPE.byTeam,
                                            icon: hr_colored_1,
                                            hoverBackgroundColor: colors/* default */.Z[color_consts.BACKGROUND_GRAY_COLOR_NAME],
                                            title: "header.tabs.workflows.byTeam.hr",
                                            description: "header.tabs.solutions.byTeam.hr.description",
                                            url: links/* HR_USE_CASES_LINK */.n$n
                                        },
                                        {
                                            itemType: MENU_SECTION_ITEM_TYPE.byTeam,
                                            icon: sales_colored_1,
                                            iconColor: color_consts.CRM_GREEN_COLOR_NAME,
                                            hoverBackgroundColor: colors/* default */.Z[color_consts.BACKGROUND_GRAY_COLOR_NAME],
                                            title: "header.tabs.workflows.byTeam.sales",
                                            description: "header.tabs.solutions.byTeam.sales.description",
                                            url: links/* CRM_MINI_SITE_LINK */.mgz
                                        },
                                        {
                                            itemType: MENU_SECTION_ITEM_TYPE.byTeam,
                                            icon: pmo_colored,
                                            iconColor: color_consts.PROJECTS_ORANGE_COLOR_NAME,
                                            hoverBackgroundColor: colors/* default */.Z[color_consts.BACKGROUND_GRAY_COLOR_NAME],
                                            description: "header.tabs.solutions.byTeam.pmo.description",
                                            title: "header.tabs.workflows.byTeam.pmo",
                                            url: links/* WORK_MANAGEMENT_FOR_PMO_MINI_SITE_LINK */.Y42
                                        },
                                        {
                                            itemType: MENU_SECTION_ITEM_TYPE.byTeam,
                                            icon: it_colored_1,
                                            hoverBackgroundColor: colors/* default */.Z[color_consts.BACKGROUND_GRAY_COLOR_NAME],
                                            title: "header.tabs.workflows.byTeam.it",
                                            description: "header.tabs.solutions.byTeam.it.description",
                                            url: links/* SERVICE_MINI_SITE_LINK */.Kon
                                        }
                                    ]
                                },
                                {
                                    id: TOP_STORIES_SECTION_ID,
                                    title: "header.tabs.resources.section.featuredStory",
                                    maxNumberOfItemsInColumn: 2,
                                    backgroundColor: color_consts.WHITE_COLOR_NAME,
                                    menuSectionItems: [
                                        {
                                            itemType: MENU_SECTION_ITEM_TYPE.story,
                                            backgroundColor: colors/* default */.Z[color_consts.GHOST_WHITE_COLOR_NAME],
                                            hoverBackgroundColor: colors/* default */.Z[color_consts.GHOST_WHITE_COLOR_NAME],
                                            imageSrc: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/Home%20Page%20-%202022%20Rebrand/header/blog.png",
                                            description: "header.tabs.solutions.byTeam.teamType.rightSection.card.description",
                                            url: links/* WORKLOAD_BLOG_PAGE_LINK */.Pqs,
                                            openInNewTab: true,
                                            buttonText: "header.tabs.solutions.byTeam.teamType.rightSection.card.buttonText",
                                            button: true
                                        }
                                    ]
                                }
                            ]
                        }
                    },
                    {
                        id: "Company size",
                        title: "header.tabs.solutions.byTeam.companySize",
                        icon: company,
                        content: {
                            menuSections: [
                                {
                                    id: BY_BUSINESS_SIZE_SECTION_ID,
                                    title: "header.tabs.solutions.byTeam.companySize.title",
                                    withTitleUnderline: true,
                                    classname: MENU_SECTION_CLASSNAMES.useCases,
                                    maxNumberOfItemsInColumn: 2,
                                    menuSectionItems: [
                                        {
                                            itemType: MENU_SECTION_ITEM_TYPE.byTeam,
                                            icon: enterprise_colored_1,
                                            hoverBackgroundColor: colors/* default */.Z[color_consts.BACKGROUND_GRAY_COLOR_NAME],
                                            title: "header.tabs.workflows.byBusinessSize.enterprise",
                                            description: "header.tabs.solutions.byTeam.companySize.enterprise.description",
                                            url: links/* ENTERPRISE_PAGE_LINK */.RVF
                                        },
                                        {
                                            itemType: MENU_SECTION_ITEM_TYPE.byTeam,
                                            icon: small_business_colored_1,
                                            hoverBackgroundColor: colors/* default */.Z[color_consts.BACKGROUND_GRAY_COLOR_NAME],
                                            title: "header.tabs.solutions.byTeam.companySize.SMB.title",
                                            description: "header.tabs.solutions.byTeam.companySize.SMB.description",
                                            url: links/* SMB_PAGE_LINK */.qDl
                                        },
                                        {
                                            itemType: MENU_SECTION_ITEM_TYPE.byTeam,
                                            icon: nonprofit_colored,
                                            hoverBackgroundColor: colors/* default */.Z[color_consts.BACKGROUND_GRAY_COLOR_NAME],
                                            title: "header.tabs.workflows.byBusinessSize.nonprofit",
                                            description: "header.tabs.solutions.byTeam.companySize.nonProfit.description",
                                            url: links/* NGO_PAGE_LINK */.htU
                                        }
                                    ]
                                },
                                {
                                    title: "header.tabs.solutions.byTeam.rightSection.title",
                                    maxNumberOfItemsInColumn: 1,
                                    backgroundColor: color_consts.WHITE_COLOR_NAME,
                                    menuSectionItems: [
                                        {
                                            id: TOP_STORIES_SECTION_ID,
                                            itemType: MENU_SECTION_ITEM_TYPE.story,
                                            backgroundColor: colors/* default */.Z[color_consts.GHOST_WHITE_COLOR_NAME],
                                            hoverBackgroundColor: colors/* default */.Z[color_consts.GHOST_WHITE_COLOR_NAME],
                                            imageSrc: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/Home%20Page%20-%202022%20Rebrand/header/agile_enterprise.png",
                                            description: "header.tabs.solutions.byTeam.rightSection.card.description",
                                            url: links/* ENTERPRISE_AGILE_PAGE_LINK */.FdN,
                                            buttonText: "header.tabs.customers.section.rightSection.card.buttonText",
                                            button: true
                                        }
                                    ]
                                }
                            ]
                        }
                    },
                    {
                        id: "Industries",
                        title: "header.tabs.solutions.byTeam.industries",
                        icon: industry2,
                        content: {
                            menuSections: [
                                {
                                    id: BY_INDUSTRY_SECTION_ID,
                                    title: "header.tabs.solutions.byTeam.industries.title",
                                    withTitleUnderline: true,
                                    classname: MENU_SECTION_CLASSNAMES.useCases,
                                    maxNumberOfItemsInColumn: 2,
                                    menuSectionItems: [
                                        {
                                            itemType: MENU_SECTION_ITEM_TYPE.byIndustry,
                                            icon: retail_colored,
                                            hoverBackgroundColor: colors/* default */.Z[color_consts.BACKGROUND_GRAY_COLOR_NAME],
                                            title: "header.tabs.solutions.byTeam.industries.retail.title",
                                            description: "header.tabs.solutions.byTeam.industries.retail.description",
                                            url: links/* RETAIL_PAGE_LINK */.fjW
                                        },
                                        {
                                            itemType: MENU_SECTION_ITEM_TYPE.byIndustry,
                                            icon: construction_colored,
                                            hoverBackgroundColor: colors/* default */.Z[color_consts.BACKGROUND_GRAY_COLOR_NAME],
                                            title: "header.tabs.solutions.byTeam.industries.construction.title",
                                            description: "header.tabs.solutions.byTeam.industries.construction.description",
                                            url: links/* CONSTRUCTION_MINI_SITE_LINK */.ikI
                                        },
                                        {
                                            itemType: MENU_SECTION_ITEM_TYPE.byIndustry,
                                            icon: media_colored,
                                            hoverBackgroundColor: colors/* default */.Z[color_consts.BACKGROUND_GRAY_COLOR_NAME],
                                            title: "header.tabs.solutions.byTeam.industries.media.title",
                                            description: "header.tabs.solutions.byTeam.industries.media.description",
                                            url: links/* MEDIA_PAGE_LINK */.Dx_
                                        }
                                    ]
                                },
                                {
                                    title: "header.tabs.solutions.byTeam.industries.rightSection.title",
                                    maxNumberOfItemsInColumn: 1,
                                    backgroundColor: color_consts.WHITE_COLOR_NAME,
                                    menuSectionItems: [
                                        {
                                            id: TOP_STORIES_SECTION_ID,
                                            itemType: MENU_SECTION_ITEM_TYPE.story,
                                            backgroundColor: colors/* default */.Z[color_consts.GHOST_WHITE_COLOR_NAME],
                                            hoverBackgroundColor: colors/* default */.Z[color_consts.GHOST_WHITE_COLOR_NAME],
                                            imageSrc: "https://dapulse-res.cloudinary.com/image/upload/remote_mondaycom_static/uploads/Yotam_Ron/200324-retail/retail-header-tn-v2.png",
                                            description: "header.tabs.solutions.byTeam.industries.rightSection.description",
                                            url: (0,url.addParamToURL)(links/* CONTACT_SALES_PAGE_LINK */.yMV, hubspot_constants/* URL_PARAM_FROM */.sy, "industries"),
                                            buttonText: "header.tabs.solutions.byTeam.industries.rightSection.buttonText",
                                            button: true
                                        }
                                    ]
                                }
                            ]
                        }
                    }
                ]
            }
        ]
    },
    bottomPanel: {
        bottomItems: [
            {
                itemType: MENU_SECTION_ITEM_TYPE.secondaryProduct,
                icon: workforms_colored,
                iconType: ICON_TYPES.fill,
                title: "header.tabs.products.more.workForms.title",
                hoverBackgroundColor: colors/* default */.Z[color_consts.BACKGROUND_GRAY_COLOR_NAME],
                url: links/* WORKFORMS_HOMEPAGE_LINK */.o2N,
                openInNewTab: true
            },
            {
                itemType: MENU_SECTION_ITEM_TYPE.secondaryProduct,
                icon: workcanvas_colored,
                iconType: ICON_TYPES.fill,
                title: "header.tabs.products.more.workCanvas.title",
                hoverBackgroundColor: colors/* default */.Z[color_consts.BACKGROUND_GRAY_COLOR_NAME],
                url: links/* CANVAS_HOMEPAGE_LINK */.gOl,
                openInNewTab: true
            }
        ]
    }
};
var platformMenu = {
    innerMenu: {
        items: [
            {
                id: "The platform",
                title: "header.tabs.platform.thePlatform",
                subItems: [
                    {
                        id: "Key features",
                        title: "header.tabs.platform.keyFeatures.title",
                        icon: keyFeatures,
                        content: {
                            menuSections: [
                                {
                                    id: KEY_FEATURES_SECTION_ID,
                                    title: "header.tabs.platform.keyFeatures.create.title",
                                    withTitleUnderline: true,
                                    classname: MENU_SECTION_CLASSNAMES.features,
                                    maxNumberOfItemsInColumn: 4,
                                    menuSectionItems: [
                                        {
                                            itemType: MENU_SECTION_ITEM_TYPE.feature,
                                            icon: dashboards_colored,
                                            title: "header.tabs.features.keyFeatures.dashboards.title",
                                            hoverBackgroundColor: colors/* default */.Z[color_consts.BACKGROUND_GRAY_COLOR_NAME],
                                            description: "header.tabs.features.keyFeatures.dashboards.description",
                                            url: links/* DASHBOARDS_PAGE_LINK */.yCu
                                        },
                                        {
                                            itemType: MENU_SECTION_ITEM_TYPE.feature,
                                            icon: integrations_colored,
                                            title: "header.tabs.features.keyFeatures.integrations.title",
                                            hoverBackgroundColor: colors/* default */.Z[color_consts.BACKGROUND_GRAY_COLOR_NAME],
                                            description: "header.tabs.features.keyFeatures.integrations.description",
                                            url: links/* INTEGRATIONS_PAGE_LINK */.oUX
                                        },
                                        {
                                            itemType: MENU_SECTION_ITEM_TYPE.feature,
                                            icon: automations_colored,
                                            title: "header.tabs.features.keyFeatures.automations.title",
                                            hoverBackgroundColor: colors/* default */.Z[color_consts.BACKGROUND_GRAY_COLOR_NAME],
                                            description: "header.tabs.features.keyFeatures.automations.description",
                                            url: links/* AUTOMATIONS_PAGE_LINK */.cPO
                                        },
                                        {
                                            itemType: MENU_SECTION_ITEM_TYPE.feature,
                                            icon: ai_icon,
                                            title: "header.tabs.features.keyFeatures.ai.title",
                                            hoverBackgroundColor: colors/* default */.Z[color_consts.BACKGROUND_GRAY_COLOR_NAME],
                                            description: "header.tabs.features.keyFeatures.ai.description",
                                            url: links/* AI_PAGE_LINK */.lro
                                        },
                                        {
                                            itemType: MENU_SECTION_ITEM_TYPE.feature,
                                            icon: kanban_colored,
                                            title: "header.tabs.features.keyFeatures.kanban.title",
                                            hoverBackgroundColor: colors/* default */.Z[color_consts.BACKGROUND_GRAY_COLOR_NAME],
                                            description: "header.tabs.features.keyFeatures.kanban.description",
                                            url: links/* KANBAN_PAGE_LINK */.ivN
                                        },
                                        {
                                            itemType: MENU_SECTION_ITEM_TYPE.feature,
                                            icon: docs_colored,
                                            title: "header.tabs.features.keyFeatures.docs.title",
                                            hoverBackgroundColor: colors/* default */.Z[color_consts.BACKGROUND_GRAY_COLOR_NAME],
                                            description: "header.tabs.features.keyFeatures.docs.description",
                                            url: links/* WORKDOCS_PAGE_LINK */.RdE
                                        },
                                        {
                                            itemType: MENU_SECTION_ITEM_TYPE.feature,
                                            icon: gantt_colored,
                                            title: "header.tabs.features.keyFeatures.gantt.title",
                                            hoverBackgroundColor: colors/* default */.Z[color_consts.BACKGROUND_GRAY_COLOR_NAME],
                                            description: "header.tabs.features.keyFeatures.gantt.description",
                                            url: links/* GANTT_PAGE_LINK */.TA3
                                        },
                                        {
                                            itemType: MENU_SECTION_ITEM_TYPE.feature,
                                            icon: forms_icon_new,
                                            title: "header.tabs.features.keyFeatures.forms.title",
                                            hoverBackgroundColor: colors/* default */.Z[color_consts.BACKGROUND_GRAY_COLOR_NAME],
                                            description: "header.tabs.features.keyFeatures.forms.description",
                                            url: links/* FORMS_PAGE_LINK */.ua2
                                        }
                                    ]
                                },
                                {
                                    id: TOP_STORIES_SECTION_ID,
                                    title: "header.tabs.platform.keyFeatures.rightSection.title",
                                    maxNumberOfItemsInColumn: 1,
                                    backgroundColor: color_consts.WHITE_COLOR_NAME,
                                    menuSectionItems: [
                                        {
                                            itemType: MENU_SECTION_ITEM_TYPE.story,
                                            backgroundColor: colors/* default */.Z[color_consts.GHOST_WHITE_COLOR_NAME],
                                            hoverBackgroundColor: colors/* default */.Z[color_consts.GHOST_WHITE_COLOR_NAME],
                                            imageSrc: "https://dapulse-res.cloudinary.com/image/upload/v1669716137/Generator_featured%20images/Home%20Page%20-%202022%20Rebrand/header/byateam_image.png",
                                            url: links/* COMPARE_LINK */.zB0,
                                            description: "header.tabs.platform.keyFeatures.rightSection.card.description",
                                            button: true,
                                            buttonText: "header.tabs.customers.section.rightSection.card.buttonText"
                                        }
                                    ]
                                }
                            ]
                        }
                    },
                    {
                        id: "Integrations",
                        title: "Integrations",
                        icon: integrations_1,
                        content: {
                            title: "header.tabs.platform.integrations.connect.title",
                            menuSections: [
                                {
                                    id: INTEGRATIONS_SECTION_ID,
                                    classname: MENU_SECTION_CLASSNAMES.integrations,
                                    title: "header.tabs.platform.integrations.connect.forDevelopment.title",
                                    maxNumberOfItemsInColumn: 4,
                                    noSeparator: true,
                                    seeMoreItem: {
                                        title: "header.tabs.platform.integrations.connect.buttonText",
                                        url: links/* INTEGRATIONS_APPS_LINK */.Ccw
                                    },
                                    menuSectionItems: [
                                        {
                                            itemType: MENU_SECTION_ITEM_TYPE.integration,
                                            icon: github,
                                            iconType: ICON_TYPES.fill,
                                            title: "header.tabs.platform.integrations.connect.forDevelopment.gitHub",
                                            hoverBackgroundColor: colors/* default */.Z[color_consts.BACKGROUND_GRAY_COLOR_NAME],
                                            url: links/* APPS_GITHUB_LINK */.BK3
                                        },
                                        {
                                            itemType: MENU_SECTION_ITEM_TYPE.integration,
                                            icon: jira_1,
                                            iconType: ICON_TYPES.fill,
                                            title: "header.tabs.platform.integrations.connect.forDevelopment.jiraCloud",
                                            hoverBackgroundColor: colors/* default */.Z[color_consts.BACKGROUND_GRAY_COLOR_NAME],
                                            url: links/* APPS_JIRA_CLOUD_LINK */.LJp
                                        },
                                        {
                                            itemType: MENU_SECTION_ITEM_TYPE.integration,
                                            icon: pagerduty_1,
                                            iconType: ICON_TYPES.fill,
                                            title: "header.tabs.platform.integrations.connect.forDevelopment.pagerDuty",
                                            hoverBackgroundColor: colors/* default */.Z[color_consts.BACKGROUND_GRAY_COLOR_NAME],
                                            url: links/* APPS_PAGER_DUTY_LINK */.qM
                                        },
                                        {
                                            itemType: MENU_SECTION_ITEM_TYPE.integration,
                                            icon: gitlab_1,
                                            iconType: ICON_TYPES.fill,
                                            title: "header.tabs.platform.integrations.connect.forDevelopment.gitLab",
                                            hoverBackgroundColor: colors/* default */.Z[color_consts.BACKGROUND_GRAY_COLOR_NAME],
                                            url: links/* APPS_GITLAB_LINK */.LcP
                                        }
                                    ]
                                },
                                {
                                    id: INTEGRATIONS_SECTION_ID,
                                    classname: MENU_SECTION_CLASSNAMES.integrations,
                                    title: "header.tabs.platform.integrations.connect.forMarketing.title",
                                    noSeparator: true,
                                    maxNumberOfItemsInColumn: 4,
                                    menuSectionItems: [
                                        {
                                            itemType: MENU_SECTION_ITEM_TYPE.integration,
                                            icon: mailchimp,
                                            iconType: ICON_TYPES.fill,
                                            title: "header.tabs.platform.integrations.connect.forMarketing.mailchimp",
                                            hoverBackgroundColor: colors/* default */.Z[color_consts.BACKGROUND_GRAY_COLOR_NAME],
                                            url: links/* APPS_MAILCHIMP_LINK */.rG7
                                        },
                                        {
                                            itemType: MENU_SECTION_ITEM_TYPE.integration,
                                            icon: hubspot,
                                            iconType: ICON_TYPES.fill,
                                            title: "header.tabs.platform.integrations.connect.forMarketing.hubSpot",
                                            hoverBackgroundColor: colors/* default */.Z[color_consts.BACKGROUND_GRAY_COLOR_NAME],
                                            url: links/* APPS_HUBSPOT_LINK */.g0b
                                        },
                                        {
                                            itemType: MENU_SECTION_ITEM_TYPE.integration,
                                            icon: surveymonkey,
                                            iconType: ICON_TYPES.fill,
                                            title: "header.tabs.platform.integrations.connect.forMarketing.surveyMonkey",
                                            hoverBackgroundColor: colors/* default */.Z[color_consts.BACKGROUND_GRAY_COLOR_NAME],
                                            url: links/* APPS_SURVEY_MONKEY_LINK */.yZo
                                        },
                                        {
                                            itemType: MENU_SECTION_ITEM_TYPE.integration,
                                            icon: googleads_1,
                                            iconType: ICON_TYPES.fill,
                                            title: "header.tabs.platform.integrations.connect.forMarketing.googleAds",
                                            hoverBackgroundColor: colors/* default */.Z[color_consts.BACKGROUND_GRAY_COLOR_NAME],
                                            url: links/* APPS_ADS_LINK */.C83
                                        }
                                    ]
                                },
                                {
                                    id: INTEGRATIONS_SECTION_ID,
                                    classname: MENU_SECTION_CLASSNAMES.integrations,
                                    title: "header.tabs.platform.integrations.connect.forCollaboration.title",
                                    noSeparator: true,
                                    maxNumberOfItemsInColumn: 4,
                                    menuSectionItems: [
                                        {
                                            itemType: MENU_SECTION_ITEM_TYPE.integration,
                                            icon: zoom_1,
                                            iconType: ICON_TYPES.fill,
                                            title: "header.tabs.platform.integrations.connect.forCollaboration.zoom",
                                            hoverBackgroundColor: colors/* default */.Z[color_consts.BACKGROUND_GRAY_COLOR_NAME],
                                            url: links/* APPS_ZOOM_LINK */.sxP
                                        },
                                        {
                                            itemType: MENU_SECTION_ITEM_TYPE.integration,
                                            icon: drive,
                                            iconType: ICON_TYPES.fill,
                                            title: "header.tabs.platform.integrations.connect.forCollaboration.googleDrive",
                                            hoverBackgroundColor: colors/* default */.Z[color_consts.BACKGROUND_GRAY_COLOR_NAME],
                                            url: links/* APPS_DRIVE_LINK */.vcQ
                                        },
                                        {
                                            itemType: MENU_SECTION_ITEM_TYPE.integration,
                                            icon: mt_1,
                                            iconType: ICON_TYPES.fill,
                                            title: "header.tabs.platform.integrations.connect.forCollaboration.microsoftTeams",
                                            hoverBackgroundColor: colors/* default */.Z[color_consts.BACKGROUND_GRAY_COLOR_NAME],
                                            url: links/* APPS_TEAMS_LINK */.pTo
                                        },
                                        {
                                            itemType: MENU_SECTION_ITEM_TYPE.integration,
                                            icon: slack_1,
                                            iconType: ICON_TYPES.fill,
                                            title: "header.tabs.platform.integrations.connect.forCollaboration.slack",
                                            hoverBackgroundColor: colors/* default */.Z[color_consts.BACKGROUND_GRAY_COLOR_NAME],
                                            url: links/* APPS_SLACK_LINK */.fiz
                                        }
                                    ]
                                },
                                {
                                    id: INTEGRATIONS_SECTION_ID,
                                    classname: MENU_SECTION_CLASSNAMES.integrations,
                                    title: "header.tabs.platform.integrations.connect.forCommunication.title",
                                    noSeparator: true,
                                    maxNumberOfItemsInColumn: 4,
                                    menuSectionItems: [
                                        {
                                            itemType: MENU_SECTION_ITEM_TYPE.integration,
                                            title: "header.tabs.platform.integrations.connect.forCommunication.outlook",
                                            icon: outlook,
                                            iconType: ICON_TYPES.fill,
                                            hoverBackgroundColor: colors/* default */.Z[color_consts.BACKGROUND_GRAY_COLOR_NAME],
                                            url: links/* APPS_OUTLOOK_LINK */.Hqq
                                        },
                                        {
                                            itemType: MENU_SECTION_ITEM_TYPE.integration,
                                            icon: gmail,
                                            iconType: ICON_TYPES.fill,
                                            title: "header.tabs.platform.integrations.connect.forCommunication.gmail",
                                            hoverBackgroundColor: colors/* default */.Z[color_consts.BACKGROUND_GRAY_COLOR_NAME],
                                            url: links/* APPS_GMAIL_LINK */.RtI
                                        },
                                        {
                                            itemType: MENU_SECTION_ITEM_TYPE.integration,
                                            icon: zendesk,
                                            iconType: ICON_TYPES.fill,
                                            title: "header.tabs.platform.integrations.connect.forCommunication.zendesk",
                                            hoverBackgroundColor: colors/* default */.Z[color_consts.BACKGROUND_GRAY_COLOR_NAME],
                                            url: links/* APPS_ZENDESK_LINK */.qQP
                                        },
                                        {
                                            itemType: MENU_SECTION_ITEM_TYPE.integration,
                                            icon: twilio_1,
                                            iconType: ICON_TYPES.fill,
                                            title: "header.tabs.platform.integrations.connect.forCommunication.twilio",
                                            hoverBackgroundColor: colors/* default */.Z[color_consts.BACKGROUND_GRAY_COLOR_NAME],
                                            url: links/* APPS_TWILIO_LINK */.z6N
                                        }
                                    ]
                                }
                            ]
                        }
                    },
                    {
                        id: "Add-ons",
                        title: "Add-ons",
                        icon: addOns_1,
                        content: {
                            title: "header.tabs.platform.addOns.extend.title",
                            menuSections: [
                                {
                                    id: ADD_ONS_SECTION_ID,
                                    classname: MENU_SECTION_CLASSNAMES.addOns,
                                    title: "header.tabs.platform.addOns.extend.popular.title",
                                    maxNumberOfItemsInColumn: 4,
                                    noSeparator: true,
                                    seeMoreItem: {
                                        title: "header.tabs.platform.addOns.extend.buttonText",
                                        url: links/* APPS_MARKETPLACE_LINK */.IHo
                                    },
                                    menuSectionItems: [
                                        {
                                            itemType: MENU_SECTION_ITEM_TYPE.addOn,
                                            icon: miro,
                                            iconType: ICON_TYPES.fill,
                                            iconStrokeColor: colors/* default */.Z[color_consts.BRAND_WORK_MANAGEMENT_LIGHTER_TINT_01],
                                            title: "header.tabs.platform.addOns.extend.popular.miro",
                                            hoverBackgroundColor: colors/* default */.Z[color_consts.BACKGROUND_GRAY_COLOR_NAME],
                                            url: links/* MIRO_APP_PAGE_LINK */.goo
                                        },
                                        {
                                            itemType: MENU_SECTION_ITEM_TYPE.addOn,
                                            imageSrc: "https://dapulse-res.cloudinary.com/image/upload/f_auto,q_auto/remote_mondaycom_static/svg/header/platform/DocuGen.svg",
                                            title: "header.tabs.platform.addOns.extend.popular.docuGen",
                                            hoverBackgroundColor: colors/* default */.Z[color_consts.BACKGROUND_GRAY_COLOR_NAME],
                                            url: links/* DOCU_GEN_APP_PAGE_LINK */.nIm
                                        }
                                    ]
                                },
                                {
                                    id: ADD_ONS_SECTION_ID,
                                    classname: MENU_SECTION_CLASSNAMES.addOns,
                                    title: "header.tabs.platform.addOns.extend.forMarketing.title",
                                    noSeparator: true,
                                    maxNumberOfItemsInColumn: 4,
                                    menuSectionItems: [
                                        {
                                            itemType: MENU_SECTION_ITEM_TYPE.addOn,
                                            imageSrc: "https://dapulse-res.cloudinary.com/image/upload/f_auto,q_auto/remote_mondaycom_static/svg/header/platform/Easyform.svg",
                                            title: "header.tabs.platform.addOns.extend.forMarketing.easyform",
                                            hoverBackgroundColor: colors/* default */.Z[color_consts.BACKGROUND_GRAY_COLOR_NAME],
                                            url: links/* EASYFORM_APP_PAGE_LINK */.L3E
                                        },
                                        {
                                            itemType: MENU_SECTION_ITEM_TYPE.addOn,
                                            imageSrc: "https://dapulse-res.cloudinary.com/image/upload/f_auto,q_auto/remote_mondaycom_static/svg/header/platform/Figma.svg",
                                            title: "header.tabs.platform.addOns.extend.forMarketing.figma",
                                            hoverBackgroundColor: colors/* default */.Z[color_consts.BACKGROUND_GRAY_COLOR_NAME],
                                            url: links/* FIGMA_APP_PAGE_LINK */.wxc
                                        }
                                    ]
                                },
                                {
                                    id: ADD_ONS_SECTION_ID,
                                    classname: MENU_SECTION_CLASSNAMES.addOns,
                                    title: "header.tabs.platform.addOns.extend.forTeamManagement.title",
                                    noSeparator: true,
                                    maxNumberOfItemsInColumn: 4,
                                    menuSectionItems: [
                                        {
                                            itemType: MENU_SECTION_ITEM_TYPE.addOn,
                                            icon: Tracket_1,
                                            iconType: ICON_TYPES.fill,
                                            iconStrokeColor: colors/* default */.Z[color_consts.BRAND_WORK_MANAGEMENT_LIGHTER_TINT_01],
                                            title: "header.tabs.platform.addOns.extend.forTeamManagement.tracket",
                                            hoverBackgroundColor: colors/* default */.Z[color_consts.BACKGROUND_GRAY_COLOR_NAME],
                                            url: links/* TRACKET_APP_PAGE_LINK */.epH
                                        },
                                        {
                                            itemType: MENU_SECTION_ITEM_TYPE.addOn,
                                            imageSrc: "https://dapulse-res.cloudinary.com/image/upload/f_auto,q_auto/remote_mondaycom_static/svg/header/platform/Team_View.svg",
                                            title: "header.tabs.platform.addOns.extend.forTeamManagement.teamView",
                                            hoverBackgroundColor: colors/* default */.Z[color_consts.BACKGROUND_GRAY_COLOR_NAME],
                                            url: links/* TEAM_VIEW_APP_PAGE_LINK */.Oek
                                        }
                                    ]
                                },
                                {
                                    id: ADD_ONS_SECTION_ID,
                                    classname: MENU_SECTION_CLASSNAMES.addOns,
                                    title: "header.tabs.platform.addOns.extend.forProductivity.title",
                                    noSeparator: true,
                                    maxNumberOfItemsInColumn: 4,
                                    menuSectionItems: [
                                        {
                                            itemType: MENU_SECTION_ITEM_TYPE.addOn,
                                            title: "header.tabs.platform.addOns.extend.forProductivity.1View",
                                            imageSrc: "https://dapulse-res.cloudinary.com/image/upload/f_auto,q_auto/remote_mondaycom_static/svg/header/platform/1View.svg",
                                            hoverBackgroundColor: colors/* default */.Z[color_consts.BACKGROUND_GRAY_COLOR_NAME],
                                            url: links/* ONE_VIEW_APP_PAGE_LINK */.U6d
                                        },
                                        {
                                            itemType: MENU_SECTION_ITEM_TYPE.integration,
                                            imageSrc: "https://dapulse-res.cloudinary.com/image/upload/f_auto,q_auto/remote_mondaycom_static/svg/header/platform/Approvals.svg",
                                            title: "header.tabs.platform.addOns.extend.forProductivity.approvals",
                                            hoverBackgroundColor: colors/* default */.Z[color_consts.BACKGROUND_GRAY_COLOR_NAME],
                                            url: links/* APPROVALS_APP_PAGE_LINK */.Wkm
                                        }
                                    ]
                                }
                            ]
                        }
                    }
                ]
            }
        ],
        bottomItem: {
            itemType: MENU_SECTION_ITEM_TYPE.innerMenuBottomItem,
            title: "header.tabs.platform.whyWorkOS.title",
            hoverBackgroundColor: colors/* default */.Z[color_consts.BACKGROUND_GRAY_COLOR_NAME],
            description: "header.tabs.platform.whyWorkOS.description",
            url: links/* WHY_WORK_OS_LINK */.kpx,
            openInNewTab: true
        }
    }
};
var customersMenu = {
    content: {
        menuSections: [
            {
                id: LEADING_COMPANIES_SECTION_ID,
                title: "header.tabs.customers.section.leadingCompanies",
                noSeparator: true,
                withTitleUnderline: true,
                maxNumberOfItemsInColumn: 2,
                seeMoreItem: {
                    title: "header.tabs.customers.section.leadingCompanies.buttonText",
                    url: links/* CUSTOMERS_PAGE_LINK */.iN6
                },
                menuSectionItems: [
                    {
                        title: "header.tabs.customers.section.leadingCompanies.zippo.title",
                        hoverBackgroundColor: colors/* default */.Z[color_consts.BACKGROUND_GRAY_COLOR_NAME],
                        description: "header.tabs.customers.section.leadingCompanies.zippo.description",
                        url: links/* ZIPPO_CUSTOMER_PAGE_LINK */.$UX
                    },
                    {
                        title: "header.tabs.customers.section.leadingCompanies.nissan.title",
                        hoverBackgroundColor: colors/* default */.Z[color_consts.BACKGROUND_GRAY_COLOR_NAME],
                        description: "header.tabs.customers.section.leadingCompanies.nissan.description",
                        url: links/* NISSAN_CUSTOMER_PAGE_LINK */.$0S
                    },
                    {
                        title: "header.tabs.customers.section.leadingCompanies.softwareAG.title",
                        hoverBackgroundColor: colors/* default */.Z[color_consts.BACKGROUND_GRAY_COLOR_NAME],
                        description: "header.tabs.customers.section.leadingCompanies.softwareAG.description",
                        url: links/* SOFTWARE_AG_CUSTOMER_PAGE_LINK */.q4d
                    },
                    {
                        title: "header.tabs.customers.section.leadingCompanies.farfetch.title",
                        hoverBackgroundColor: colors/* default */.Z[color_consts.BACKGROUND_GRAY_COLOR_NAME],
                        description: "header.tabs.customers.section.leadingCompanies.farfetch.description",
                        url: links/* FARFETCH_CUSTOMER_PAGE_LINK */.ZsN
                    }
                ]
            },
            {
                id: GET_INVOLVED_SECTION_ID,
                title: "header.tabs.customers.section.getInvolved",
                withTitleUnderline: true,
                maxNumberOfItemsInColumn: 2,
                menuSectionItems: [
                    {
                        title: "header.tabs.customers.section.getInvolved.community.title",
                        hoverBackgroundColor: colors/* default */.Z[color_consts.BACKGROUND_GRAY_COLOR_NAME],
                        description: "header.tabs.customers.section.getInvolved.community.description",
                        url: links/* COMMUNITY_LINK */.gcb,
                        openInNewTab: true
                    },
                    {
                        title: "header.tabs.customers.section.getInvolved.reviews.title",
                        hoverBackgroundColor: colors/* default */.Z[color_consts.BACKGROUND_GRAY_COLOR_NAME],
                        description: "header.tabs.customers.section.getInvolved.reviews.description",
                        url: links/* G2_WRITE_A_REVIEW_PAGE_LINK */.jHu,
                        openInNewTab: true
                    }
                ]
            },
            {
                id: TOP_STORIES_SECTION_ID,
                title: "header.tabs.customers.section.rightSection.title",
                maxNumberOfItemsInColumn: 1,
                backgroundColor: color_consts.BACKGROUND_GRAY_COLOR_NAME,
                menuSectionItems: [
                    {
                        itemType: MENU_SECTION_ITEM_TYPE.story,
                        backgroundColor: colors/* default */.Z[color_consts.GHOST_WHITE_COLOR_NAME],
                        hoverBackgroundColor: colors/* default */.Z[color_consts.GHOST_WHITE_COLOR_NAME],
                        imageSrc: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/Home%20Page%20-%202022%20Rebrand/header/efficiency_image.png",
                        description: "header.tabs.customers.section.rightSection.card.description",
                        url: links/* EFFICIENCY_IMPACT_PAGE_LINK */.Lip,
                        openInNewTab: true,
                        button: true,
                        buttonText: "header.tabs.customers.section.rightSection.card.buttonText"
                    }
                ]
            }
        ]
    },
    bottomPanel: {
        isSocialProofDisplayed: true
    }
};
var resourcesMenu = {
    content: {
        menuSections: [
            {
                id: RESOURCES_LEARN_SECTION_ID,
                title: "header.tabs.resources.section.learn",
                noSeparator: true,
                withTitleUnderline: true,
                maxNumberOfItemsInColumn: 5,
                menuSectionItems: [
                    {
                        itemType: MENU_SECTION_ITEM_TYPE.resource,
                        hoverBackgroundColor: colors/* default */.Z[color_consts.BACKGROUND_GRAY_COLOR_NAME],
                        title: "header.tabs.resources.learn.knowledgeBase.title",
                        description: "header.tabs.resources.learn.knowledgeBase.description",
                        url: links/* HELP_CENTER_LINK */.j3e
                    },
                    {
                        itemType: MENU_SECTION_ITEM_TYPE.resource,
                        title: "header.tabs.resources.learn.whatsNew.newTitle",
                        description: "header.tabs.resources.learn.whatsNew.description",
                        isPopular: true,
                        badgeText: "header.menuItem.new",
                        badgeColorName: color_consts.WORK_OS_IRIS_COLOR_NAME,
                        badgeTextColorName: color_consts.WHITE_COLOR_NAME,
                        badgeStrokeColorName: "transparent",
                        url: links/* WHATS_NEW_PAGE_LINK */.Lmq
                    },
                    {
                        itemType: MENU_SECTION_ITEM_TYPE.resource,
                        hoverBackgroundColor: colors/* default */.Z[color_consts.BACKGROUND_GRAY_COLOR_NAME],
                        title: "header.tabs.resources.learn.aboutUs.title",
                        description: "header.tabs.resources.learn.aboutUs.description",
                        url: links/* ABOUT_US_PAGE_LINK */.iAZ
                    },
                    {
                        itemType: MENU_SECTION_ITEM_TYPE.resource,
                        hoverBackgroundColor: colors/* default */.Z[color_consts.BACKGROUND_GRAY_COLOR_NAME],
                        title: "header.tabs.resources.learn.blog.title",
                        description: "header.tabs.resources.learn.blog.description",
                        url: "header.blog"
                    },
                    {
                        itemType: MENU_SECTION_ITEM_TYPE.resource,
                        title: "header.tabs.resources.connect.BuilderCertificationsText.title",
                        description: "header.tabs.resources.connect.BuilderCertificationsText.description",
                        url: links/* BUILDERS_CERTIFICATIONS_PAGE_LINK */.QHq
                    }
                ]
            },
            {
                id: RESOURCES_CONNECT_SECTION_ID,
                title: "header.tabs.resources.section.connect",
                noSeparator: true,
                withTitleUnderline: true,
                maxNumberOfItemsInColumn: 4,
                menuSectionItems: [
                    {
                        itemType: MENU_SECTION_ITEM_TYPE.resource,
                        hoverBackgroundColor: colors/* default */.Z[color_consts.BACKGROUND_GRAY_COLOR_NAME],
                        title: "header.tabs.resources.connect.support.title",
                        description: "header.tabs.resources.connect.support.description",
                        url: links/* SUPPORT_PAGE_LINK */.jX6
                    },
                    {
                        itemType: MENU_SECTION_ITEM_TYPE.resource,
                        hoverBackgroundColor: colors/* default */.Z[color_consts.BACKGROUND_GRAY_COLOR_NAME],
                        title: "header.tabs.resources.connect.partners.title",
                        description: "header.tabs.resources.connect.partners.description1",
                        url: links/* PARTNERS_PAGE_LINK */.MW2
                    },
                    {
                        itemType: MENU_SECTION_ITEM_TYPE.resource,
                        hoverBackgroundColor: colors/* default */.Z[color_consts.BACKGROUND_GRAY_COLOR_NAME],
                        title: "header.tabs.resources.connect.globalEvents.title",
                        description: "header.tabs.resources.connect.globalEvents.description",
                        url: links/* GLOBAL_EVENTS_PAGE_LINK */.O5z
                    },
                    {
                        itemType: MENU_SECTION_ITEM_TYPE.resource,
                        hoverBackgroundColor: colors/* default */.Z[color_consts.BACKGROUND_GRAY_COLOR_NAME],
                        title: "header.tabs.resources.connect.community.title",
                        description: "header.tabs.resources.connect.community.description",
                        url: links/* COMMUNITY_LINK */.gcb
                    }
                ]
            },
            {
                id: RESOURCES_BUILD_SECTION_ID,
                title: "header.tabs.resources.section.build",
                withTitleUnderline: true,
                maxNumberOfItemsInColumn: 3,
                menuSectionItems: [
                    {
                        itemType: MENU_SECTION_ITEM_TYPE.resource,
                        hoverBackgroundColor: colors/* default */.Z[color_consts.BACKGROUND_GRAY_COLOR_NAME],
                        title: "header.tabs.resources.explore.appsDeveloper.title",
                        description: "header.tabs.resources.explore.appsDeveloper.description",
                        url: links/* APPS_DEVELOPER_LINK */.FE7
                    },
                    {
                        itemType: MENU_SECTION_ITEM_TYPE.resource,
                        hoverBackgroundColor: colors/* default */.Z[color_consts.BACKGROUND_GRAY_COLOR_NAME],
                        title: "header.tabs.resources.explore.templateCenter.title",
                        description: "header.tabs.resources.explore.templateCenter.description1",
                        url: links/* TEMPLATE_CENTER_PAGE_LINK */.EDy
                    },
                    {
                        itemType: MENU_SECTION_ITEM_TYPE.resource,
                        hoverBackgroundColor: colors/* default */.Z[color_consts.BACKGROUND_GRAY_COLOR_NAME],
                        title: "header.tabs.resources.explore.spaces.title",
                        description: "header.tabs.resources.explore.spaces.description",
                        url: links/* MONDAY_SPACES_PAGE_LINK */.UN3
                    }
                ]
            },
            {
                id: TOP_STORIES_SECTION_ID,
                title: "header.tabs.resources.section.successStories",
                maxNumberOfItemsInColumn: 2,
                backgroundColor: color_consts.WHITE_COLOR_NAME,
                menuSectionItems: [
                    {
                        itemType: MENU_SECTION_ITEM_TYPE.story,
                        backgroundColor: colors/* default */.Z[color_consts.GHOST_WHITE_COLOR_NAME],
                        hoverBackgroundColor: colors/* default */.Z[color_consts.GHOST_WHITE_COLOR_NAME],
                        imageSrc: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/Home%20Page%20-%202022%20Rebrand/header/Customer%20tab/nissan.png",
                        description: "header.tabs.resources.topStories.howCustomersEmpowers",
                        imageFloatingCaption: "header.tabs.resources.topStories.savedPerMonth",
                        url: links/* MONDAY_STORIES_PAGE */.Ce8,
                        button: true,
                        buttonText: "header.menuItem.button.exploreAllCustomerStories"
                    },
                    {
                        itemType: MENU_SECTION_ITEM_TYPE.story,
                        backgroundColor: colors/* default */.Z[color_consts.GHOST_WHITE_COLOR_NAME],
                        hoverBackgroundColor: colors/* default */.Z[color_consts.GHOST_WHITE_COLOR_NAME],
                        imageSrc: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/Home%20Page%20-%202022%20Rebrand/header/Customer%20tab/efficency.png",
                        description: "header.tabs.resources.topStories.discoverEfficiency",
                        url: links/* EFFICIENCY_IMPACT_PAGE_LINK */.Lip,
                        button: true,
                        buttonText: "header.menuItem.button.exploreAllUseCases"
                    }
                ]
            }
        ]
    }
};
var _obj;
/** * Structured Header sections definitions - End ** */ var StructuredHeaderMenuComponentMapping = (_obj = {}, (0,_define_property/* default */.Z)(_obj, SOLUTIONS_MENU_ID, "StructuredHeaderMenuComponent"), (0,_define_property/* default */.Z)(_obj, TEAMS_MENU_ID, "StructuredHeaderMenuComponent"), (0,_define_property/* default */.Z)(_obj, PLATFORM_MENU_ID, "StructuredHeaderMenuComponent"), (0,_define_property/* default */.Z)(_obj, CUSTOMERS_MENU_ID, "StructuredHeaderMenuComponent"), (0,_define_property/* default */.Z)(_obj, RESOURCES_MENU_ID, "StructuredHeaderMenuComponent"), _obj);
var _obj1;
var SectionsHeadersMenuItemsMapping = (_obj1 = {}, (0,_define_property/* default */.Z)(_obj1, PRODUCTS_MENU_ID, productsSectionMenuItems), (0,_define_property/* default */.Z)(_obj1, USE_CASES_MENU_ID, useCasesSectionMenuItems), (0,_define_property/* default */.Z)(_obj1, FEATURES_MENU_ID, featuresSectionMenuItems), (0,_define_property/* default */.Z)(_obj1, RESOURCES_MENU_ID, resourcesSectionMenuItems), _obj1);
var _obj2;
var StructuredHeaderMenuMapping = (_obj2 = {}, (0,_define_property/* default */.Z)(_obj2, SOLUTIONS_MENU_ID, solutionsMenu), (0,_define_property/* default */.Z)(_obj2, TEAMS_MENU_ID, teamsMenu), (0,_define_property/* default */.Z)(_obj2, PLATFORM_MENU_ID, platformMenu), (0,_define_property/* default */.Z)(_obj2, CUSTOMERS_MENU_ID, customersMenu), (0,_define_property/* default */.Z)(_obj2, RESOURCES_MENU_ID, resourcesMenu), _obj2);
// ===========================================================================================
// Header service functions
var isDesktopMinisiteSecondaryMenuActive = function() {
    var headerElement = document.querySelector(".".concat(DESKTOP_HEADER_BASE_CLASS_NAME));
    if (!headerElement) return false;
    return headerElement.classList.contains("scroll-started") && !headerElement.classList.contains("scrolled-threshold");
};
var shouldRenderSecondaryMenu = function(isClusterMiniSitePage, pageClusterConfig, useProductMiniSiteConfig) {
    return isClusterMiniSitePage && (0,cluster_config_service/* isMiniSiteConfigValid */.cJ)(pageClusterConfig, {
        useProductMiniSiteConfig: useProductMiniSiteConfig
    });
};


/***/ }),

/***/ 72428:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

/* harmony default export */ __webpack_exports__["Z"] = ({
    BASIC_HEADER_HEIGHT: 72,
    SECONDARY_HEADER_HEIGHT: 56,
    HEADER_CONTENT_HORIZONTAL_PADDING: 32,
    MOBILE_MINI_SITE_BASIC_HEADER_HEIGHT: 52,
    MOBILE_MINI_SITE_SECONDARY_HEADER_HEIGHT: 44,
    SIGNUP_POPUP_SCREEN_RIGHT_MARGIN: 16,
    SIGNUP_POPUP_SCREEN_WIDTH: 346,
    SIGNUP_POPUP_SCREEN_HEIGHT: 404,
    PRODUCTS_SWITCHER_SCREEN_WIDTH: 300,
    PRODUCTS_SWITCHER_NEW_USERS_SCREEN_HEIGHT: 375,
    PRODUCTS_SWITCHER_EXISTING_USERS_SCREEN_HEIGHT: 270,
    PRODUCTS_SWITCHER_SCREEN_RIGHT_MARGIN: 32
});


/***/ }),

/***/ 36233:
/***/ (function(module) {


var getExactEventNameAbTestVariant = function(abTestExactEventName, abTestVariants) {
    if (!abTestExactEventName || !abTestVariants || abTestVariants.length == 0) return null;
    var test = abTestVariants.find(function(abTest) {
        return abTest.name === abTestExactEventName;
    });
    return test ? test.variant : null;
};
module.exports = {
    getExactEventNameAbTestVariant: getExactEventNameAbTestVariant
};


/***/ }),

/***/ 46724:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "p": function() { return /* binding */ enterV13TestIfNeeded; },
  "EF": function() { return /* binding */ getFreeTierFeaturesByAbTest; },
  "FW": function() { return /* binding */ getFreeTierSeatsCountByAbTest; },
  "_n": function() { return /* binding */ getIsFreeOver20ColumnTypes; },
  "J6": function() { return /* binding */ getIsUnlimitedBoards; },
  "gd": function() { return /* binding */ shouldHideBasic; },
  "GV": function() { return /* binding */ shouldSeeProductsPricingPage; },
  "fy": function() { return /* binding */ shouldSeeV10PricingVersion; },
  "H6": function() { return /* binding */ shouldShowPricingSubTitleV2; },
  "u0": function() { return /* binding */ shouldShowPurchaseNow; },
  "Ce": function() { return /* binding */ shouldShowTalkToSalesCta; },
  "RT": function() { return /* binding */ shouldShowTypeformContactUs; }
});

// UNUSED EXPORTS: shouldSeeV11PricingVersion, shouldSeeV12PricingVersion, shouldSeeV13PricingVersion

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./services/new-ab-tests/new-ab-tests-service.js
var new_ab_tests_service = __webpack_require__(41871);
// EXTERNAL MODULE: ./services/cookies-service.js
var cookies_service = __webpack_require__(67798);
// EXTERNAL MODULE: ./constants/new-ab-tests.js
var new_ab_tests = __webpack_require__(60734);
// EXTERNAL MODULE: ./constants/cookies.js
var constants_cookies = __webpack_require__(13019);
// EXTERNAL MODULE: ./constants/pricing-versions.js
var pricing_versions = __webpack_require__(78803);
var pricing_versions_default = /*#__PURE__*/__webpack_require__.n(pricing_versions);
// EXTERNAL MODULE: ./constants/pricing.js
var pricing = __webpack_require__(55674);
// EXTERNAL MODULE: ./constants/pricing/pricing-page/features/value_feature_collections.js
var value_feature_collections = __webpack_require__(78217);
;// CONCATENATED MODULE: ./constants/monetization-ab-tests.ts
var PURCHASE_NOW_AB_TEST = {
    test_name: "purchase_now_ab_test",
    new_variation_name: "new_with_purchase_now_button"
};
var PRICING_SUB_TITLE_V2_AB_TEST = {
    test_name: "pricing_page_sub_title_v2_ab_test",
    new_variation_name: "new_pricing_with_sub_title_v2"
};
var HOMEPAGE_PLATFORM_PRICING_CONTACT_US_CTA_AB_TEST = {
    test_name: "homepage_platform_pricing_contact_us_cta_ab_test",
    new_variation_name: "new_cta_with_talk_to_sales"
};
var HOMEPAGE_PRICING_ENTERPRISE_CONTACT_US_TYPEFORM_FEATURE_FLAG = {
    test_name: "homepage_pricing_enterprise_contact_us_typeform_feature_flag",
    new_variation_name: "new_homepage_pricing_enterprise_contact_us_typeform_feature_flag"
};

;// CONCATENATED MODULE: ./constants/force-pricing.ts
var PRICING_SUB_TITLE_V2 = "sub_title_v2";
var FORCE_TALK_TO_SALES = "talk_to_sales";

// EXTERNAL MODULE: ./utils/mobile.js
var mobile = __webpack_require__(34955);
// EXTERNAL MODULE: ./constants/pricing/pricing-page/features/value_features.js
var value_features = __webpack_require__(49127);
;// CONCATENATED MODULE: ./services/ab-tests/monetization-ab-tests-service.js












var shouldHideBasic = function(param) {
    var abTests = param.abTests, forcePricing = param.forcePricing, cookies = param.cookies, hasStudentPlan = param.hasStudentPlan;
    if (hasStudentPlan) return true; // First we check if we're in student plan mode - in this mode we don't show the basic tier
    var ref = cookies || {}, platformCookieValue = ref[constants_cookies.PLATFORM_HIDE_BASIC_COOKIE]; // The visitor might have came from the platform before, so we check if we hide basic in the platform
    if (platformCookieValue) return platformCookieValue === "true";
    if (forcePricing === "without_basic") return true; // We want to test it by ourselves so we use force_pricing query param.
    return (0,new_ab_tests_service.getAbTestVariantNew)(abTests, new_ab_tests.HOMEPAGE_HIDE_BASIC_AB_TEST.test_name) === new_ab_tests.HOMEPAGE_HIDE_BASIC_AB_TEST.new_variation_name;
};
var shouldSeeProductsPricingPage = function(param) {
    var forcePricing = param.forcePricing;
    return forcePricing === "products";
};
var shouldSeeV10PricingVersion = function(param) {
    var _cookies = param.cookies, cookies = _cookies === void 0 ? {} : _cookies, _abTests = param.abTests, abTests = _abTests === void 0 ? [] : _abTests, forcePricing = param.forcePricing;
    if (forcePricing === "v10") return true;
    var platformCookie = cookies[constants_cookies.PLATFORM_PRICING_VERSION_COOKIE];
    if (platformCookie) return platformCookie === (pricing_versions_default()).VERSION_10;
    var abTestVariant = (0,new_ab_tests_service.getAbTestVariantNew)(abTests, new_ab_tests.HOMEPAGE_V10_PRICING_VERSION_AB_TEST.test_name);
    return abTestVariant === new_ab_tests.HOMEPAGE_V10_PRICING_VERSION_AB_TEST.new_variation_name;
};
var shouldSeeV11PricingVersion = function(param) {
    var _cookies = param.cookies, cookies = _cookies === void 0 ? {} : _cookies, forcePricing = param.forcePricing, currency = param.currency;
    if (forcePricing === "v11") return true;
    var platformCookie = cookies[PLATFORM_PRICING_VERSION_COOKIE];
    if (platformCookie) return platformCookie === PricingVersions.VERSION_11;
    if (currency === "jpy") return true;
    return false;
};
var shouldSeeV13PricingVersion = function(param) {
    var _cookies = param.cookies, cookies = _cookies === void 0 ? {} : _cookies, _abTests = param.abTests, abTests = _abTests === void 0 ? [] : _abTests, forcePricing = param.forcePricing, isV13PricingVersion = param.isV13PricingVersion;
    if (forcePricing === PricingVersions.VERSION_13) return true;
    var platformCookie = cookies[PLATFORM_PRICING_VERSION_COOKIE];
    if (platformCookie) return platformCookie === PricingVersions.VERSION_13;
    var homepageCookie = cookies[HOMEPAGE_PRICING_VERSION_COOKIE];
    if (homepageCookie) return homepageCookie === PricingVersions.VERSION_13;
    if (isV13PricingVersion) return true; // For testing
    var abTestVariant = getAbTestVariantNew(abTests, HOMEPAGE_V13_PRICING_VERSION_AB_TEST.test_name);
    return abTestVariant === HOMEPAGE_V13_PRICING_VERSION_AB_TEST.new_variation_name;
};
var enterV13TestIfNeeded = function(abTests, cookies, forcePricing, isV13PricingVersion) {
    if (cookies === null || cookies === void 0 ? void 0 : cookies[constants_cookies.PLATFORM_PRICING_VERSION_COOKIE]) return;
    if (forcePricing) return;
    // Report to Bigbrain that the user entered the test
    var abTestVariant = (0,new_ab_tests_service.getAbTestVariantNew)(abTests, new_ab_tests.HOMEPAGE_V13_PRICING_VERSION_AB_TEST.test_name, true);
    if (isV13PricingVersion || abTestVariant === new_ab_tests.HOMEPAGE_V13_PRICING_VERSION_AB_TEST.new_variation_name) {
        (0,cookies_service/* setCookieIfNeeded */.cr)(constants_cookies.HOMEPAGE_PRICING_VERSION_COOKIE, (pricing_versions_default()).VERSION_13, {
            expires: 90
        });
    } else {
        (0,cookies_service/* setCookieIfNeeded */.cr)(constants_cookies.HOMEPAGE_PRICING_VERSION_COOKIE, (pricing_versions_default()).DEFAULT_VERSION, {
            expires: 90
        });
    }
};
var shouldSeeV12PricingVersion = function(param) {
    var _cookies = param.cookies, cookies = _cookies === void 0 ? {} : _cookies, _abTests = param.abTests, abTests = _abTests === void 0 ? [] : _abTests, forcePricing = param.forcePricing;
    if (forcePricing === PricingVersions.VERSION_12) return true;
    var platformCookie = cookies[PLATFORM_PRICING_VERSION_COOKIE];
    if (platformCookie) return platformCookie === PricingVersions.VERSION_12;
    var homepageCookie = cookies[HOMEPAGE_PRICING_VERSION_COOKIE];
    if (homepageCookie) return homepageCookie === PricingVersions.VERSION_12;
    var abTestVariant = getAbTestVariantNew(abTests, HOMEPAGE_V12_PRICING_VERSION_AB_TEST.test_name);
    return abTestVariant === HOMEPAGE_V12_PRICING_VERSION_AB_TEST.new_variation_name;
};
var getFreeTierVersion = function(cookies, forcePricing) {
    var platformCookie = cookies[constants_cookies.PLATFORM_FREE_TIER_VERSION_COOKIE];
    var forceFreeTierVersion = forcePricing || platformCookie;
    var _obj;
    var variantToVersion = (_obj = {}, (0,_define_property/* default */.Z)(_obj, new_ab_tests.HOMEPAGE_FREE_TIER_2022_ABC_TEST.new_variation_name_b, "2022_a"), (0,_define_property/* default */.Z)(_obj, new_ab_tests.HOMEPAGE_FREE_TIER_2022_ABC_TEST.new_variation_name_c, "2022_b"), _obj);
    var freeTierVersion = forceFreeTierVersion || variantToVersion[new_ab_tests.HOMEPAGE_FREE_TIER_2022_ABC_TEST.new_variation_name_b];
    return freeTierVersion;
};
var getFreeTierFeaturesByAbTest = function(param) {
    var _cookies = param.cookies, cookies = _cookies === void 0 ? {} : _cookies, forcePricing = param.forcePricing;
    var freeTierVersion = getFreeTierVersion(cookies, forcePricing);
    switch(freeTierVersion){
        case "2022_a":
            return [
                value_features.UP_TO_THREE_BOARDS,
                value_features.UNLIMITED_DOCS,
                value_features.OVER_200_TEMPLATES,
                value_features.LIMITED_COLUMN_TYPES,
                value_features.UP_TO_X_TEAM_MEMBERS(pricing/* FREE_TIER_2021_SEATS_LIMIT */.F3),
                value_features.MOBILE
            ];
        case "2022_b":
            return [
                value_features.UP_TO_THREE_BOARDS,
                value_features.UNLIMITED_DOCS,
                value_features.OVER_200_TEMPLATES,
                value_features.LIMITED_COLUMN_TYPES,
                value_features.UP_TO_X_TEAM_MEMBERS(pricing/* FREE_TIER_2022_SEATS_LIMIT */.no),
                value_features.MOBILE
            ];
        default:
            return value_feature_collections/* FREE_TIER_VALUE_FEATURES */.tL;
    }
};
var getFreeTierSeatsCountByAbTest = function(param) {
    var _cookies = param.cookies, cookies = _cookies === void 0 ? {} : _cookies, forcePricing = param.forcePricing;
    var freeTierVersion = getFreeTierVersion(cookies, forcePricing);
    switch(freeTierVersion){
        case "2022_a":
            return pricing/* FREE_TIER_2021_SEATS_LIMIT */.F3;
        case "2022_b":
            return pricing/* FREE_TIER_2022_SEATS_LIMIT */.no;
        default:
            return pricing/* FREE_TIER_2021_SEATS_LIMIT */.F3;
    }
};
var getIsFreeOver20ColumnTypes = function(param) {
    var _cookies = param.cookies, cookies = _cookies === void 0 ? {} : _cookies, forcePricing = param.forcePricing;
    var freeTierVersion = getFreeTierVersion(cookies, forcePricing);
    switch(freeTierVersion){
        case "2022_a":
            return false;
        case "2022_b":
            return false;
        default:
            return true;
    }
};
var getIsUnlimitedBoards = function(param) {
    var _cookies = param.cookies, cookies = _cookies === void 0 ? {} : _cookies, forcePricing = param.forcePricing;
    var freeTierVersion = getFreeTierVersion(cookies, forcePricing);
    switch(freeTierVersion){
        case "2022_a":
            return false;
        case "2022_b":
            return false;
        default:
            return true;
    }
};
var shouldShowPurchaseNow = function(param) {
    var _abTests = param.abTests, abTests = _abTests === void 0 ? [] : _abTests, forcePricing = param.forcePricing;
    if (forcePricing === "purchase_now") return true;
    if ((0,mobile/* isMobile */.tq)()) return false;
    var abTestVariant = (0,new_ab_tests_service.getAbTestVariantNew)(abTests, PURCHASE_NOW_AB_TEST.test_name, true);
    return abTestVariant === PURCHASE_NOW_AB_TEST.new_variation_name;
};
var shouldShowPricingSubTitleV2 = function(param) {
    var _abTests = param.abTests, abTests = _abTests === void 0 ? [] : _abTests, forcePricing = param.forcePricing;
    if (forcePricing === PRICING_SUB_TITLE_V2) return true;
    var abTestVariant = (0,new_ab_tests_service.getAbTestVariantNew)(abTests, PRICING_SUB_TITLE_V2_AB_TEST.test_name, true);
    return abTestVariant === PRICING_SUB_TITLE_V2_AB_TEST.new_variation_name;
};
var shouldShowTalkToSalesCta = function(param) {
    var _abTests = param.abTests, abTests = _abTests === void 0 ? [] : _abTests, forcePricing = param.forcePricing;
    if (forcePricing === FORCE_TALK_TO_SALES) return true;
    var abTestVariant = (0,new_ab_tests_service.getAbTestVariantNew)(abTests, HOMEPAGE_PLATFORM_PRICING_CONTACT_US_CTA_AB_TEST.test_name, true);
    return abTestVariant === HOMEPAGE_PLATFORM_PRICING_CONTACT_US_CTA_AB_TEST.new_variation_name;
};
var shouldShowTypeformContactUs = function(param) {
    var _abTests = param.abTests, abTests = _abTests === void 0 ? [] : _abTests;
    var abTestVariant = (0,new_ab_tests_service.getAbTestVariantNew)(abTests, HOMEPAGE_PRICING_ENTERPRISE_CONTACT_US_TYPEFORM_FEATURE_FLAG.test_name, true);
    return abTestVariant === HOMEPAGE_PRICING_ENTERPRISE_CONTACT_US_TYPEFORM_FEATURE_FLAG.new_variation_name;
};


/***/ }),

/***/ 15650:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "c0": function() { return /* binding */ getCurrencyName; },
  "hU": function() { return /* binding */ getCurrencySign; },
  "$H": function() { return /* binding */ getCurrencyWithPriceDisplay; },
  "j": function() { return /* binding */ shouldSeeContactUs; }
});

// UNUSED EXPORTS: AUD_COUNTRIES, CAD_COUNTRIES, EURO_COUNTRIES, GBP_COUNTRIES, JPY_COUNTRIES, PESO_COUNTRIES, REAL_COUNTRIES, USD_CURRENCY, getCurrencyData, getCurrencyShortText, setCurrencyCookie

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./services/cookies-service.js
var cookies_service = __webpack_require__(67798);
// EXTERNAL MODULE: ./constants/cookies.js
var cookies = __webpack_require__(13019);
// EXTERNAL MODULE: ./constants/pricing.js
var pricing = __webpack_require__(55674);
// EXTERNAL MODULE: ./constants/localization.js
var localization = __webpack_require__(72632);
// EXTERNAL MODULE: ./services/pricing/pricing-page/clusterized-pricing-page-service.js + 5 modules
var clusterized_pricing_page_service = __webpack_require__(69017);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
;// CONCATENATED MODULE: ./segments/desktop/core-components/pricing/price-with-currency/price-with-currency.scss.js

var StyledPriceWithCurrency = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("span", {
    target: "esqe350"
})("display:flex;align-items:flex-end;.currency-sign-and-text{display:inline-flex;flex-direction:column;align-items:center;margin-right:2%;margin-bottom:3%;.currency-sign{font-size:0.65em;}.currency-text{font-size:0.2em;font-weight:bold;}}");

;// CONCATENATED MODULE: ./segments/desktop/core-components/pricing/price-with-currency/price-with-currency.js



var PriceWithCurrency = function(param) {
    var price = param.price, currency = param.currency, currencySign = param.currencySign, className = param.className;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledPriceWithCurrency, {
        className: "price-with-currency",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                className: "currency-sign-and-text",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: classnames_default()("currency-sign", className),
                        children: currencySign
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: classnames_default()("currency-text", className),
                        children: currency.toUpperCase()
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: className,
                children: price
            })
        ]
    });
};
/* harmony default export */ var price_with_currency = (PriceWithCurrency);

;// CONCATENATED MODULE: ./services/pricing-service.js







var CURRENCY_SIGN_RIGHT_OF_NUMBER_LOCALES = [
    localization.FRENCH_LOCALE_ID,
    localization.GERMAN_LOCALE_ID
];
var USD_CURRENCY = "usd";
var EURO_COUNTRIES = [
    "ad",
    "at",
    "be",
    "cy",
    "ee",
    "fi",
    "fr",
    "de",
    "gr",
    "ie",
    "it",
    "lv",
    "lt",
    "lu",
    "mt",
    "mc",
    "me",
    "nl",
    "pt",
    "sm",
    "sk",
    "si",
    "es",
    // NEW - starting from Jul 2022
    "al",
    "bh",
    "by",
    "ba",
    "bg",
    "hr",
    "cz",
    "dk",
    "eg",
    "fo",
    "ge",
    "gi",
    "hu",
    "is",
    "jo",
    "kw",
    "li",
    "mk",
    "md",
    "ma",
    "no",
    "om",
    "pl",
    "qa",
    "ro",
    "rs",
    "se",
    "ch",
    "sa",
    "tn",
    "tr",
    "ug",
    "ua",
    "ae",
    "va",
    "ye" // Yemen
];
var GBP_COUNTRIES = [
    "gb",
    "je",
    "gg",
    "im",
    "gs",
    "uk" // United Kingdom
];
var CAD_COUNTRIES = [
    "ca" // Canada
];
var AUD_COUNTRIES = [
    "au" // Australia
];
var PESO_COUNTRIES = [
    "mx" // Mexico
];
var REAL_COUNTRIES = [
    "br" // Brazil
];
var JPY_COUNTRIES = [
    "jp" // Japan
];
var CONTACT_US_THRESHOLD = 50;
var setCurrencyCookie = function setCurrencyCookie(currencyShortText) {
    (0,cookies_service/* setCookie */.d8)(cookies.CURRENCY_COOKIE_NAME, currencyShortText);
};
var getCurrencyFromCountry = function(country) {
    if (country) {
        var countryCode = country.toLowerCase();
        if (EURO_COUNTRIES.indexOf(countryCode) > -1) {
            setCurrencyCookie("eur");
            return "eur";
        }
        if (GBP_COUNTRIES.indexOf(countryCode) > -1) {
            setCurrencyCookie("gbp");
            return "gbp";
        }
        if (CAD_COUNTRIES.indexOf(countryCode) > -1) {
            setCurrencyCookie("cad");
            return "cad";
        }
        if (AUD_COUNTRIES.indexOf(countryCode) > -1) {
            setCurrencyCookie("aud");
            return "aud";
        }
        if (PESO_COUNTRIES.indexOf(countryCode) > -1) {
            setCurrencyCookie("mxn");
            return "mxn";
        }
        if (REAL_COUNTRIES.indexOf(countryCode) > -1) {
            setCurrencyCookie("brl");
            return "brl";
        }
        if (JPY_COUNTRIES.indexOf(countryCode) > -1) {
            setCurrencyCookie("jpy");
            return "jpy";
        }
        //default to usd
        setCurrencyCookie("usd");
        return "usd";
    } else {
        //no country cookie - we return undefined and rely on the default configuration file
        //TODO: log an error? we are server side.
        return undefined;
    }
};
var getCurrency = function(forceCurrencyShortText, pricingDefaults, countryCode) {
    // first check query param exists.
    if (forceCurrencyShortText) {
        return forceCurrencyShortText;
    }
    if (countryCode) {
        return getCurrencyFromCountry(countryCode);
    }
    return (pricingDefaults === null || pricingDefaults === void 0 ? void 0 : pricingDefaults.defaultCurrency) || USD_CURRENCY;
};
var getCurrencyData = function getCurrencyData(currency) {
    var currenciesArray = pricing/* SUPPORTED_CURRENCIES.filter */.ck.filter(function(currencyItem) {
        //find not supported in ie
        return currencyItem.name === currency;
    });
    return currenciesArray[0];
};
var getCurrencyShortText = function getCurrencyShortText(currency) {
    var currencyData = getCurrencyData(currency);
    if (currencyData.shouldDisplayText) {
        return currencyData.currencyShortText;
    }
    return null;
};
var getCurrencyName = function(param) {
    var forceCurrency = param.forceCurrency, _pricingDefaults = param.pricingDefaults, pricingDefaults = _pricingDefaults === void 0 ? {} : _pricingDefaults, countryCode = param.countryCode;
    var shortCurrencyText = getCurrency(forceCurrency, pricingDefaults, countryCode);
    var currencyArray = pricing/* SUPPORTED_CURRENCIES.filter */.ck.filter(function(supportedCurrency) {
        //find not supported in ie
        return supportedCurrency.currencyShortText.toLowerCase() === shortCurrencyText.toLowerCase();
    });
    return currencyArray[0].name;
};
var getCurrencySign = function getCurrencySign(currency) {
    var currencyData = getCurrencyData(currency);
    return currencyData.currencySign;
};
var shouldShowCurrencyText = function(currency) {
    var lowerCaseCurrency = currency.toLowerCase();
    switch(lowerCaseCurrency){
        case "cad":
        case "aud":
        case "mxn":
            return true;
        default:
            return false;
    }
};
// For some locales, the currency sign (e.g. $) comes to the right of the price value.
var getCurrencyWithPriceDisplay = function(param) {
    var price = param.price, currency = param.currency, _localeId = param.localeId, localeId = _localeId === void 0 ? localization.ENGLISH_LOCALE_ID : _localeId, _hideCurrency = param.hideCurrency, hideCurrency = _hideCurrency === void 0 ? false : _hideCurrency, className = param.className;
    if (hideCurrency) {
        return price;
    }
    var currencySign = getCurrencySign(currency);
    var shouldShowCurrencyToTheRight = CURRENCY_SIGN_RIGHT_OF_NUMBER_LOCALES.includes(localeId);
    if (!hideCurrency && shouldShowCurrencyText(currency)) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(price_with_currency, {
            price: price,
            currency: currency,
            currencySign: currencySign,
            className: className
        });
    }
    return shouldShowCurrencyToTheRight ? "".concat(price, " ").concat(currencySign) : "".concat(currencySign).concat(price);
};
var getContactUsThreshold = function(param) {
    var clusterConfig = param.clusterConfig, abTests = param.abTests, cookies = param.cookies, forcePricing = param.forcePricing;
    var _clusterConfig_payments_view_pricing, _clusterConfig_payments_view;
    if (!(0,clusterized_pricing_page_service/* isInClusterTest */.dn)(clusterConfig, {
        abTests: abTests,
        cookies: cookies,
        forcePricing: forcePricing
    })) return CONTACT_US_THRESHOLD;
    return (clusterConfig === null || clusterConfig === void 0 ? void 0 : (_clusterConfig_payments_view = clusterConfig.payments_view) === null || _clusterConfig_payments_view === void 0 ? void 0 : (_clusterConfig_payments_view_pricing = _clusterConfig_payments_view.pricing) === null || _clusterConfig_payments_view_pricing === void 0 ? void 0 : _clusterConfig_payments_view_pricing.contact_us_threshold) || CONTACT_US_THRESHOLD;
};
var shouldSeeContactUs = function shouldSeeContactUs(tier, usersCount) {
    var contactUsThresholdOptions = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return tier === pricing/* TIERS.ENTERPRISE */.Iy.ENTERPRISE || usersCount.includes("+") || Number(usersCount) >= getContactUsThreshold(contactUsThresholdOptions);
};


/***/ }),

/***/ 12403:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CF": function() { return /* binding */ applyFreeUsersIfNeeded; },
/* harmony export */   "KX": function() { return /* binding */ applyDiscountIfNeeded; },
/* harmony export */   "pZ": function() { return /* binding */ shouldHideCrossedOutPrice; },
/* harmony export */   "qV": function() { return /* binding */ getMaxFreeUsersFromClusterConfig; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(29815);
/* harmony import */ var lodash_isEmpty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(41609);
/* harmony import */ var lodash_isEmpty__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_isEmpty__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _pricing_page_clusterized_pricing_page_service__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(69017);



var getDiscountFromClusterConfig = function(clusterConfig, abTests, cookies, forcePricing) {
    var _clusterConfig_payments_view_pricing, _clusterConfig_payments_view;
    var discount = clusterConfig === null || clusterConfig === void 0 ? void 0 : (_clusterConfig_payments_view = clusterConfig.payments_view) === null || _clusterConfig_payments_view === void 0 ? void 0 : (_clusterConfig_payments_view_pricing = _clusterConfig_payments_view.pricing) === null || _clusterConfig_payments_view_pricing === void 0 ? void 0 : _clusterConfig_payments_view_pricing.discount;
    if (!lodash_isEmpty__WEBPACK_IMPORTED_MODULE_0___default()(discount) && (0,_pricing_page_clusterized_pricing_page_service__WEBPACK_IMPORTED_MODULE_1__/* .isInClusterTest */ .dn)(clusterConfig, {
        abTests: abTests,
        cookies: cookies,
        forcePricing: forcePricing
    })) {
        return discount;
    }
};
var getFreeUsersFromClusterConfig = function(clusterConfig, abTests, cookies, forcePricing) {
    var _clusterConfig_payments_view_pricing_users_count_options, _clusterConfig_payments_view_pricing, _clusterConfig_payments_view;
    var freeOptions = clusterConfig === null || clusterConfig === void 0 ? void 0 : (_clusterConfig_payments_view = clusterConfig.payments_view) === null || _clusterConfig_payments_view === void 0 ? void 0 : (_clusterConfig_payments_view_pricing = _clusterConfig_payments_view.pricing) === null || _clusterConfig_payments_view_pricing === void 0 ? void 0 : (_clusterConfig_payments_view_pricing_users_count_options = _clusterConfig_payments_view_pricing.users_count_options) === null || _clusterConfig_payments_view_pricing_users_count_options === void 0 ? void 0 : _clusterConfig_payments_view_pricing_users_count_options.free_options;
    if (!lodash_isEmpty__WEBPACK_IMPORTED_MODULE_0___default()(freeOptions) && (0,_pricing_page_clusterized_pricing_page_service__WEBPACK_IMPORTED_MODULE_1__/* .isInClusterTest */ .dn)(clusterConfig, {
        abTests: abTests,
        cookies: cookies,
        forcePricing: forcePricing
    })) {
        return freeOptions;
    }
};
var getMaxFreeUsersFromClusterConfig = function(clusterConfig, abTests, cookies, forcePricing) {
    var freeOptions = getFreeUsersFromClusterConfig(clusterConfig, abTests, cookies, forcePricing);
    if ((freeOptions === null || freeOptions === void 0 ? void 0 : freeOptions.length) > 0) {
        var _Math;
        return (_Math = Math).max.apply(_Math, (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(freeOptions));
    }
};
var applyDiscountIfNeeded = function(price, tier, period, clusterConfig, abTests, cookies, forcePricing) {
    var discount = getDiscountFromClusterConfig(clusterConfig, abTests, cookies, forcePricing);
    if (lodash_isEmpty__WEBPACK_IMPORTED_MODULE_0___default()(discount)) return price;
    var value = discount.value, validTiers = discount.valid_tiers, validPeriods = discount.valid_periods;
    if (!value) return price;
    var isValidTier = lodash_isEmpty__WEBPACK_IMPORTED_MODULE_0___default()(validTiers) || validTiers.includes(tier);
    var isValidPeriod = lodash_isEmpty__WEBPACK_IMPORTED_MODULE_0___default()(validPeriods) || validPeriods.includes(period);
    var isDiscountValidForPlan = isValidTier && isValidPeriod;
    if (!isDiscountValidForPlan) return price;
    return price * (1 - value);
};
var applyFreeUsersIfNeeded = function(price, initialUsersCount, clusterConfig, abTests, cookies, forcePricing) {
    var usersCount = initialUsersCount;
    var maxFreeUsers = getMaxFreeUsersFromClusterConfig(clusterConfig, abTests, cookies, forcePricing);
    if (maxFreeUsers > 0) {
        usersCount = initialUsersCount - maxFreeUsers;
    }
    return Math.max(price * usersCount, 0);
};
var shouldHideCrossedOutPrice = function(clusterConfig, abTests, cookies, forcePricing) {
    var _clusterConfig_payments_view_pricing, _clusterConfig_payments_view;
    var discount = clusterConfig === null || clusterConfig === void 0 ? void 0 : (_clusterConfig_payments_view = clusterConfig.payments_view) === null || _clusterConfig_payments_view === void 0 ? void 0 : (_clusterConfig_payments_view_pricing = _clusterConfig_payments_view.pricing) === null || _clusterConfig_payments_view_pricing === void 0 ? void 0 : _clusterConfig_payments_view_pricing.discount;
    if (!lodash_isEmpty__WEBPACK_IMPORTED_MODULE_0___default()(discount) && (0,_pricing_page_clusterized_pricing_page_service__WEBPACK_IMPORTED_MODULE_1__/* .isInClusterTest */ .dn)(clusterConfig, {
        abTests: abTests,
        cookies: cookies,
        forcePricing: forcePricing
    })) {
        return discount.hide_crossed_out_discount;
    }
    return false;
};


/***/ }),

/***/ 70533:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B": function() { return /* binding */ shouldShowYearlyPrices; },
/* harmony export */   "K": function() { return /* binding */ getPeriods; }
/* harmony export */ });
/* harmony import */ var constants_pricing__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(55674);
/* harmony import */ var lodash_isEmpty__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41609);
/* harmony import */ var lodash_isEmpty__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash_isEmpty__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _pricing_page_clusterized_pricing_page_service__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(69017);



var getClusterPeriodsConfig = function(clusterConfig, abTests, cookies, forcePricing) {
    var _clusterConfig_payments_view_pricing, _clusterConfig_payments_view;
    var periods = clusterConfig === null || clusterConfig === void 0 ? void 0 : (_clusterConfig_payments_view = clusterConfig.payments_view) === null || _clusterConfig_payments_view === void 0 ? void 0 : (_clusterConfig_payments_view_pricing = _clusterConfig_payments_view.pricing) === null || _clusterConfig_payments_view_pricing === void 0 ? void 0 : _clusterConfig_payments_view_pricing.periods;
    if (!lodash_isEmpty__WEBPACK_IMPORTED_MODULE_1___default()(periods) && (0,_pricing_page_clusterized_pricing_page_service__WEBPACK_IMPORTED_MODULE_2__/* .isInClusterTest */ .dn)(clusterConfig, {
        abTests: abTests,
        cookies: cookies,
        forcePricing: forcePricing
    })) {
        return periods;
    }
    return {};
};
var getPeriods = function(clusterConfig, abTests, cookies, forcePricing) {
    var periods = constants_pricing__WEBPACK_IMPORTED_MODULE_0__/* .ORDERED_PERIOD_NAMES */ .yv;
    var clusterPeriodsConfig = getClusterPeriodsConfig(clusterConfig, abTests, cookies, forcePricing);
    var ref = clusterPeriodsConfig || {}, tmp = ref.hidden_periods, hiddenPeriods = tmp === void 0 ? [] : tmp;
    return lodash_isEmpty__WEBPACK_IMPORTED_MODULE_1___default()(hiddenPeriods) ? periods : periods.filter(function(period) {
        return !hiddenPeriods.includes(period);
    });
};
var shouldShowYearlyPrices = function(clusterConfig, abTests, cookies, forcePricing) {
    var clusterPeriodsConfig = getClusterPeriodsConfig(clusterConfig, abTests, cookies, forcePricing);
    var display = clusterPeriodsConfig.display;
    return (display === null || display === void 0 ? void 0 : display.price_display) === constants_pricing__WEBPACK_IMPORTED_MODULE_0__/* .PERIODS.yearly */ .z5.yearly;
};


/***/ }),

/***/ 3223:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "xS": function() { return /* binding */ getPricingModelService; },
  "rM": function() { return /* binding */ getPricingVersion; },
  "qM": function() { return /* binding */ getPricingVersionForSales; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./constants/pricing-versions.js
var pricing_versions = __webpack_require__(78803);
var pricing_versions_default = /*#__PURE__*/__webpack_require__.n(pricing_versions);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(52951);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(88029);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 4 modules
var _create_super = __webpack_require__(60460);
// EXTERNAL MODULE: ./node_modules/lodash/isEmpty.js
var isEmpty = __webpack_require__(41609);
var isEmpty_default = /*#__PURE__*/__webpack_require__.n(isEmpty);
// EXTERNAL MODULE: ./services/pricing/pricing-page/clusterized-pricing-page-service.js + 5 modules
var clusterized_pricing_page_service = __webpack_require__(69017);
// EXTERNAL MODULE: ./constants/pricing.js
var pricing = __webpack_require__(55674);
// EXTERNAL MODULE: ./services/pricing/discounts-service.js
var discounts_service = __webpack_require__(12403);
// EXTERNAL MODULE: ./services/pricing/periods-service.js
var periods_service = __webpack_require__(70533);
;// CONCATENATED MODULE: ./services/pricing/pricing-model/base-pricing-model-service.js





var BasePricingModelService = /*#__PURE__*/ function() {
    "use strict";
    function BasePricingModelService() {
        (0,_class_call_check/* default */.Z)(this, BasePricingModelService);
    }
    (0,_create_class/* default */.Z)(BasePricingModelService, [
        {
            key: "getPlanPrice",
            value: function getPlanPrice(tier, currency, billingPeriod, userCount, pricingVersion, clusterConfig, abTests, cookies, forcePricing) {
                var hideDiscount = arguments.length > 9 && arguments[9] !== void 0 ? arguments[9] : false;
                var prices = this.getPrices({
                    pricingVersion: pricingVersion
                });
                if (tier === pricing/* TIERS.FREE */.Iy.FREE) return 0;
                var basePrice = (0,discounts_service/* applyFreeUsersIfNeeded */.CF)(prices[billingPeriod][tier][currency], userCount, clusterConfig, abTests, cookies, forcePricing);
                var price = (0,periods_service/* shouldShowYearlyPrices */.B)(clusterConfig, abTests, cookies, forcePricing) ? basePrice * 12 : basePrice;
                return hideDiscount ? price : (0,discounts_service/* applyDiscountIfNeeded */.KX)(price, tier, billingPeriod, clusterConfig, abTests, cookies, forcePricing);
            }
        },
        {
            key: "shouldShowUserOptions",
            value: function shouldShowUserOptions() {
                return true;
            }
        },
        {
            key: "getDefaultUserOption",
            value: function getDefaultUserOption() {
                return "0";
            }
        },
        {
            key: "getUserOptions",
            value: function getUserOptions() {
                var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                return {};
            }
        },
        {
            key: "getPrices",
            value: function getPrices() {
                return [];
            }
        }
    ]);
    return BasePricingModelService;
}();


// EXTERNAL MODULE: ./services/pricing/product-prices.js
var product_prices = __webpack_require__(43331);
;// CONCATENATED MODULE: ./services/pricing/pricing-model/buckets-pricing-model-service.js










var BucketsPricingModelService = /*#__PURE__*/ function(BasePricingModelService) {
    "use strict";
    (0,_inherits/* default */.Z)(BucketsPricingModelService, BasePricingModelService);
    var _super = (0,_create_super/* default */.Z)(BucketsPricingModelService);
    function BucketsPricingModelService() {
        (0,_class_call_check/* default */.Z)(this, BucketsPricingModelService);
        return _super.apply(this, arguments);
    }
    (0,_create_class/* default */.Z)(BucketsPricingModelService, [
        {
            key: "shouldShowUserOptions",
            value: function shouldShowUserOptions() {
                return true;
            }
        },
        {
            key: "getClusterUserOptions",
            value: function getClusterUserOptions() {
                var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var _clusterConfig_payments_view_pricing, _clusterConfig_payments_view;
                var clusterConfig = options.clusterConfig, abTests = options.abTests, forcePricing = options.forcePricing, cookies = options.cookies;
                var users_count_options = clusterConfig === null || clusterConfig === void 0 ? void 0 : (_clusterConfig_payments_view = clusterConfig.payments_view) === null || _clusterConfig_payments_view === void 0 ? void 0 : (_clusterConfig_payments_view_pricing = _clusterConfig_payments_view.pricing) === null || _clusterConfig_payments_view_pricing === void 0 ? void 0 : _clusterConfig_payments_view_pricing.users_count_options;
                if (!isEmpty_default()(clusterConfig) && (0,clusterized_pricing_page_service/* isInClusterTest */.dn)(clusterConfig, {
                    abTests: abTests,
                    forcePricing: forcePricing,
                    cookies: cookies
                })) {
                    return users_count_options === null || users_count_options === void 0 ? void 0 : users_count_options.all_options;
                }
            }
        },
        {
            key: "getDefaultUserOption",
            value: function getDefaultUserOption() {
                var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var clusterUserOptions = this.getClusterUserOptions(options);
                if ((clusterUserOptions === null || clusterUserOptions === void 0 ? void 0 : clusterUserOptions.length) > 0) return clusterUserOptions[0];
                return "3";
            }
        },
        {
            key: "getUserOptions",
            value: function getUserOptions() {
                var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var clusterUserOptions = this.getClusterUserOptions(options);
                if ((clusterUserOptions === null || clusterUserOptions === void 0 ? void 0 : clusterUserOptions.length) > 0) return clusterUserOptions;
                return [
                    "3",
                    "5",
                    "10",
                    "15",
                    "20",
                    "25",
                    "30",
                    "40",
                    "50",
                    "100",
                    pricing/* MAX_TEAM_SIZE */.fY
                ];
            }
        },
        {
            key: "getPrices",
            value: function getPrices(param) {
                var _pricingVersion = param.pricingVersion, pricingVersion = _pricingVersion === void 0 ? (pricing_versions_default()).DEFAULT_VERSION : _pricingVersion;
                return product_prices/* productPrices.core */.A.core[pricingVersion];
            }
        }
    ]);
    return BucketsPricingModelService;
}(BasePricingModelService);


// EXTERNAL MODULE: ./services/pricing-service.js + 2 modules
var pricing_service = __webpack_require__(15650);
;// CONCATENATED MODULE: ./services/pricing/pricing-model/services.js




var getPricingModelService = function(pricingVersion) {
    var _obj;
    var pricingModelsModelsMapping = (_obj = {}, (0,_define_property/* default */.Z)(_obj, (pricing_versions_default()).VERSION_9, BucketsPricingModelService), (0,_define_property/* default */.Z)(_obj, (pricing_versions_default()).VERSION_13, BucketsPricingModelService), _obj);
    var PricingModelService = pricingModelsModelsMapping[pricingVersion] || pricingModelsModelsMapping[(pricing_versions_default()).DEFAULT_VERSION];
    return new PricingModelService();
};
var getPricingVersion = function() {
    var forcePricing = (arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}).forcePricing;
    if (forcePricing) {
        var forcePricingVersionNumberArray = forcePricing.match(/\d+(?:\.\d+)?/g);
        if (forcePricingVersionNumberArray.length > 0) {
            var forcePricingVersionNumber = forcePricingVersionNumberArray[0];
            if (pricing_versions_default().ALLOWED_VERSIONS.includes("".concat(forcePricingVersionNumber))) {
                return forcePricing;
            }
        }
    }
    return (pricing_versions_default()).DEFAULT_VERSION;
};
var getPricingVersionForSales = function(param) {
    var forcePricing = param.forcePricing, cookies = param.cookies, abTests = param.abTests, forceCurrency = param.forceCurrency, countryCode = param.countryCode;
    var currency = (0,pricing_service/* getCurrencyName */.c0)({
        forceCurrency: forceCurrency,
        countryCode: countryCode
    });
    return getPricingVersion({
        forcePricing: forcePricing,
        cookies: cookies,
        abTests: abTests,
        currency: currency
    });
};


/***/ }),

/***/ 85920:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Am": function() { return /* binding */ getFirstTranslatedString; },
/* harmony export */   "Kn": function() { return /* binding */ isObject; },
/* harmony export */   "LZ": function() { return /* binding */ EMPTY_ARRAY; },
/* harmony export */   "RW": function() { return /* binding */ applyOverrides; },
/* harmony export */   "X2": function() { return /* binding */ runForEachTier; }
/* harmony export */ });
/* harmony import */ var lodash_isString__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(47037);
/* harmony import */ var lodash_isString__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_isString__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var constants_pricing__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(55674);
/* harmony import */ var services_localization_keys_all_json__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(55551);
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}



var isObject = function(value) {
    return typeof value === "object" && value !== null;
};
var runForEachTier = function(callback) {
    Object.keys(constants_pricing__WEBPACK_IMPORTED_MODULE_1__/* .TIERS */ .Iy).forEach(function(tierKey) {
        return callback(constants_pricing__WEBPACK_IMPORTED_MODULE_1__/* .TIERS */ .Iy[tierKey]);
    });
};
var EMPTY_ARRAY = []; // used in multiple places.
var getFirstTranslatedString = function(stringsArray) {
    if (!stringsArray || stringsArray.length === 0) return "";
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = stringsArray[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var key = _step.value;
            if (services_localization_keys_all_json__WEBPACK_IMPORTED_MODULE_2__[key]) {
                return key; // will be translated by the component.
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    // couldn't find a translation for this value - treating it as a regular string, possibly enclosed in an array.
    if (Array.isArray(stringsArray)) {
        return "".concat(stringsArray[0]);
    }
    return "".concat(stringsArray);
};
var applyOverrides = function(originalObject, overridesObject, keys) {
    var returnedObject = _object_spread({}, originalObject);
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = keys[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var key = _step.value;
            var overrideValue = overridesObject === null || overridesObject === void 0 ? void 0 : overridesObject[key];
            if (lodash_isString__WEBPACK_IMPORTED_MODULE_0___default()(overrideValue) || Array.isArray(overrideValue)) {
                returnedObject[key] = getFirstTranslatedString(overridesObject[key]);
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return returnedObject;
};


/***/ }),

/***/ 69017:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "LF": function() { return /* binding */ getPricingPageSectionsFromClusterConfig; },
  "vT": function() { return /* binding */ getTierDescriptionsFromClusterConfig; },
  "A2": function() { return /* binding */ getValueFeaturesFromClusterConfig; },
  "dn": function() { return /* binding */ isInClusterTest; }
});

// EXTERNAL MODULE: ./node_modules/lodash/isString.js
var isString = __webpack_require__(47037);
var isString_default = /*#__PURE__*/__webpack_require__.n(isString);
// EXTERNAL MODULE: ./node_modules/lodash/compact.js
var compact = __webpack_require__(39693);
var compact_default = /*#__PURE__*/__webpack_require__.n(compact);
// EXTERNAL MODULE: ./constants/pricing.js
var pricing = __webpack_require__(55674);
// EXTERNAL MODULE: ./constants/pricing/pricing-page/tier-descriptions/index.js
var pricing_page_tier_descriptions = __webpack_require__(87529);
// EXTERNAL MODULE: ./services/cookies-service.js
var cookies_service = __webpack_require__(67798);
// EXTERNAL MODULE: ./services/new-ab-tests/new-ab-tests-service.js
var new_ab_tests_service = __webpack_require__(41871);
// EXTERNAL MODULE: ./constants/pricing/pricing-page/sections/default_sections.js
var default_sections = __webpack_require__(16168);
// EXTERNAL MODULE: ./constants/pricing/pricing-page/features/features.js + 3 modules
var features = __webpack_require__(61980);
;// CONCATENATED MODULE: ./constants/pricing/pricing-page/sections/clusters/marketing.js


var COMMUNICATION_ESSENTIALS = function(param) {
    var cookies = param.cookies, abTests = param.abTests;
    return {
        sectionName: "pricingPage.features.sections.communication_essentials",
        features: [
            features.COMMUNICATION_WITH_CONTEXT,
            features.COLLABORATIVE_WHITEBOARD,
            features.INTEGRATIONS_WITH_GMAIL_AND_OUTLOOK,
            features.STORAGE({
                cookies: cookies,
                abTests: abTests
            })
        ]
    };
};
var COLLABORATION_AND_SHARING_ESSENTIALS = function(param) {
    var hasStudentPlan = param.hasStudentPlan;
    return {
        sectionName: "pricingPage.features.sections.collaboration_and_sharing_essentials",
        features: [
            features.EMBED_DOCUMENTS_AND_BRIEFS,
            features.MARKETING_REQUESTS_WITH_FORMS,
            features.READY_MADE_MARKETING_TEMPLATES,
            features.DEADLINE_MANAGEMENT,
            features.SHARE_BOARD_WITH_EXTERNAL_GUESTS,
            features.UNLIMITED_VIEWERS,
            features.AUTOMATIONS,
            features.MARKETING_INTEGRATIONS,
            features.TIMELINE({
                hasStudentPlan: hasStudentPlan
            })
        ]
    };
};
var INSIGHTS_ESSENTIALS = {
    sectionName: "pricingPage.features.sections.insights_essentials",
    features: [
        features.MARKETING_DASHBOARDS,
        features.MARKETING_CALENDAR,
        features.DAILY_REPORTS
    ]
};
var MARKETING_OTHER_ESSENTIALS = {
    sectionName: "pricingPage.features.sections.other_essentials",
    features: [
        features.IMPORT_EXPORT_EXCEL,
        features.UNLIMITED_BOARDS,
        features.ADVANCED_COLUMN_TYPES,
        features.MOBILE,
        features.ACTIVITY_LOG,
        features.ZOOM_INTEGRATION
    ]
};
var MARKETING_ADVANCED_SECTION = function(param) {
    var hasStudentPlan = param.hasStudentPlan;
    return {
        sectionName: "pricingPage.features.sections.advanced",
        features: [
            features.KANBAN_VIEW,
            features.MAP,
            features.SEARCH,
            features.FORMS_CUSTOMIZATION({
                hasStudentPlan: hasStudentPlan
            }),
            features.TIME_TRACKING,
            features.CHART_VIEW({
                hasStudentPlan: hasStudentPlan
            }),
            features.FORMULA({
                hasStudentPlan: hasStudentPlan
            }),
            features.TAGS,
            features.PRIVATE_BOARDS
        ]
    };
};

// EXTERNAL MODULE: ./constants/pricing/pricing-page/sections/free_tier_essentials.js
var free_tier_essentials = __webpack_require__(8876);
;// CONCATENATED MODULE: ./constants/pricing/pricing-page/sections/default_essentials.js

var DEFAULT_ESSENTIALS = function(cookies, abTests) {
    return {
        sectionName: "pricingPage.features.sections.essentials",
        features: [
            features.UNLIMITED_VIEWERS,
            features.UNLIMITED_BOARDS,
            features.UNLIMITED_DOCS,
            features.COLUMN_TYPES({
                cookies: cookies
            }),
            features.MOBILE,
            features.STORAGE({
                cookies: cookies,
                abTests: abTests
            }),
            features.ACTIVITY_LOG
        ]
    };
};

;// CONCATENATED MODULE: ./constants/pricing/pricing-page/sections/all_sections.js




var ESSENTIALS = function(param) {
    var abTests = param.abTests, cookies = param.cookies, hasFreeTier = param.hasFreeTier;
    if (hasFreeTier) {
        return (0,free_tier_essentials/* getFreeTierEssentials */.b)(abTests, cookies);
    }
    return DEFAULT_ESSENTIALS(cookies, abTests);
};
var ALL_SECTIONS = {
    ESSENTIALS: ESSENTIALS,
    REMOTE_WORK_FEATURES_SECTION: default_sections/* REMOTE_WORK_FEATURES_SECTION */.RV,
    ADVANCED: default_sections/* ADVANCED */.UO,
    SECURITY: default_sections/* SECURITY */.lG,
    ADVANCED_REPORTING: default_sections/* ADVANCED_REPORTING */.k3,
    SUPPORT: default_sections/* SUPPORT */.wL,
    COMMUNICATION_ESSENTIALS: COMMUNICATION_ESSENTIALS,
    ADMINISTRATION_AND_CONTROL: default_sections/* ADMINISTRATION_AND_CONTROL */.Xn,
    SECURITY_NEW: default_sections/* SECURITY_NEW */._h,
    SUPPORT_NEW: default_sections/* SUPPORT_NEW */.QA,
    COLLABORATION_AND_SHARING_ESSENTIALS: COLLABORATION_AND_SHARING_ESSENTIALS,
    INSIGHTS_ESSENTIALS: INSIGHTS_ESSENTIALS,
    MARKETING_OTHER_ESSENTIALS: MARKETING_OTHER_ESSENTIALS,
    MARKETING_ADVANCED_SECTION: MARKETING_ADVANCED_SECTION,
    CUSTOMER_FAVORITES: default_sections/* CUSTOMER_FAVORITES */.Kk,
    COLLABORATION: default_sections/* COLLABORATION */.iz,
    PRODUCTIVITY: default_sections/* PRODUCTIVITY */.nD,
    VIEWS_AND_REPORTING: default_sections/* VIEWS_AND_REPORTING */.uK,
    SECURITY_AND_PRIVACY: default_sections/* SECURITY_AND_PRIVACY */.K8,
    ENTERPRISE_REPORTING_AND_ANALYTICS: default_sections/* ENTERPRISE_REPORTING_AND_ANALYTICS */.zw
};
/* harmony default export */ var all_sections = (ALL_SECTIONS);

// EXTERNAL MODULE: ./constants/bigbrain-event-types.js
var bigbrain_event_types = __webpack_require__(65023);
// EXTERNAL MODULE: ./services/bigbrain-service.js
var bigbrain_service = __webpack_require__(65488);
// EXTERNAL MODULE: ./services/pricing/pricing-page/clusterization/clusterized-pricing-page-helper-service.js
var clusterized_pricing_page_helper_service = __webpack_require__(85920);
;// CONCATENATED MODULE: ./services/pricing/pricing-page/clusterization/clusterized-pricing-page-features-service.js
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}








var DEFAULT_FEATURE_KEYS = [
    "name",
    "description"
];
var DEFAULT_SECTION_KEYS = [
    "sectionName"
];
var isFeatureValid = function(feature) {
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = DEFAULT_FEATURE_KEYS[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var key = _step.value;
            if (!isString_default()(feature[key]) || feature[key].length === 0) {
                return false;
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    if (!feature.tiers || Object.keys(feature.tiers).length === 0) return false;
    return true;
};
var isSectionValid = function(section) {
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = DEFAULT_SECTION_KEYS[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var key = _step.value;
            if (!isString_default()(section[key]) || section[key].length === 0) {
                return false;
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    if (!section.features || section.features.length === 0) return false;
    return true;
};
var convertStringToFeatureTierValue = function(stringValue) {
    if (!stringValue) return false;
    if (stringValue == "true") return true;
    return (0,clusterized_pricing_page_helper_service/* getFirstTranslatedString */.Am)(clusterized_pricing_page_helper_service/* EMPTY_ARRAY.concat */.LZ.concat(stringValue));
};
var getFeatureTierValue = function(tier, tiersObject, feature) {
    if (tiersObject && tiersObject[tier]) {
        return {
            value: convertStringToFeatureTierValue(tiersObject[tier])
        };
    } else if (tier === pricing/* TIERS.FREE */.Iy.FREE) {
        // free tier gets, by default, the value of the basic tier, unless defined otherwise.
        return getFeatureTierValue(pricing/* TIERS.BASIC */.Iy.BASIC, tiersObject, feature);
    } else if (!(feature === null || feature === void 0 ? void 0 : feature.tiers[tier])) {
        // no value defined for this tier, and it's a new feature
        return {
            value: false
        };
    }
    return feature.tiers[tier];
};
var generateDefaultTiersObject = function() {
    var tiersObject = {};
    (0,clusterized_pricing_page_helper_service/* runForEachTier */.X2)(function(tier) {
        tiersObject[tier] = {
            value: false
        };
    });
    return tiersObject;
};
/**
 * Retrieves a feature's default values by that feature's name, and returns those values as a feature object.
 * @param {*} featureName - assumed to be uppercased, to match the constant.
 * @param {*} abTests - for features whose default value depends on A/B test variants.
 * @param {*} cookies - for features whose default value depends on cookies.
 */ var getExistingFeature = function(featureName, param) {
    var abTests = param.abTests, cookies = param.cookies, hasStudentPlan = param.hasStudentPlan, hasFreeTier = param.hasFreeTier;
    if (typeof features[featureName] === "function") {
        return features[featureName]({
            abTests: abTests,
            cookies: cookies,
            hasStudentPlan: hasStudentPlan,
            hasFreeTier: hasFreeTier
        });
    }
    var feature = features[featureName];
    return feature ? _object_spread({}, feature) : null;
};
var convertFeature = function(featureNameOrObject, param) {
    var abTests = param.abTests, cookies = param.cookies, hasStudentPlan = param.hasStudentPlan, hasFreeTier = param.hasFreeTier;
    if (isString_default()(featureNameOrObject)) {
        // shortcut - if a string is provided and it matches an existing code feature, it will be used.
        var feature = getExistingFeature(featureNameOrObject, {
            abTests: abTests,
            cookies: cookies,
            hasFreeTier: hasFreeTier,
            hasStudentPlan: hasStudentPlan
        });
        if (!feature) {
            (0,bigbrain_service.trackEvent)(bigbrain_event_types.PRICING_PAGE_MISSING_CLUSTER_INFO_ENCOUNTERED, {
                kind: "name",
                placement: "features",
                data: featureNameOrObject
            });
            return null;
        }
        return feature;
    }
    // got an object - verifying that it has a name (either an existing feature's or an override)
    var feature1 = featureNameOrObject.feature, featureName = featureNameOrObject.featureName, overrides = featureNameOrObject.overrides; // 'featureName' for backwards compatibility - TODO remove after fixing existing configs.
    if (!feature1 && !featureName && !(overrides === null || overrides === void 0 ? void 0 : overrides.name)) {
        (0,bigbrain_service.trackEvent)(bigbrain_event_types.PRICING_PAGE_MISSING_CLUSTER_INFO_ENCOUNTERED, {
            kind: "object",
            placement: "features",
            data: featureNameOrObject
        });
        return null; // must have either an existing feature's name, or a new one.
    }
    // overriding name and description:
    var existingFeature = getExistingFeature(feature1, {
        abTests: abTests,
        cookies: cookies,
        hasStudentPlan: hasStudentPlan,
        hasFreeTier: hasFreeTier
    }) || getExistingFeature(featureName, {
        abTests: abTests,
        cookies: cookies,
        hasFreeTier: hasFreeTier,
        hasStudentPlan: hasStudentPlan
    }) || {}; // using an existing feature if one matches the name. Features can be identified either by 'feature' or 'featureName'.
    var featureWithOverrides = (0,clusterized_pricing_page_helper_service/* applyOverrides */.RW)(existingFeature, featureNameOrObject === null || featureNameOrObject === void 0 ? void 0 : featureNameOrObject.overrides, DEFAULT_FEATURE_KEYS);
    // overriding tiers:
    var tiers = (overrides || {}).tiers;
    if (!featureWithOverrides.tiers) {
        // new feature - no tiers defined
        featureWithOverrides.tiers = generateDefaultTiersObject();
    }
    (0,clusterized_pricing_page_helper_service/* runForEachTier */.X2)(function(tier) {
        featureWithOverrides.tiers[tier] = getFeatureTierValue(tier, tiers, featureWithOverrides);
    });
    if (!isFeatureValid(featureWithOverrides)) return null;
    return featureWithOverrides;
};
/**
 * Retrieves a section's default values (name and features list) by that section's name, and returns those as a
 * section object.
 * @param {*} sectionName
 * @param {*} abTests - in case the section data depends on AB tests.
 * @param {*} cookies - in case the section data depends on cookies.
 */ var getExistingSection = function(sectionName, param) {
    var abTests = param.abTests, cookies = param.cookies, hasStudentPlan = param.hasStudentPlan, hasFreeTier = param.hasFreeTier;
    var originalSection;
    if (typeof all_sections[sectionName] === "function") {
        originalSection = all_sections[sectionName]({
            abTests: abTests,
            cookies: cookies,
            hasStudentPlan: hasStudentPlan,
            hasFreeTier: hasFreeTier
        });
    } else {
        originalSection = all_sections[sectionName];
    }
    return originalSection ? _object_spread({}, originalSection) : null;
};
var convertSection = function(sectionNameOrObject, param) {
    var abTests = param.abTests, cookies = param.cookies, hasStudentPlan = param.hasStudentPlan, hasFreeTier = param.hasFreeTier;
    if (isString_default()(sectionNameOrObject)) {
        // shortcut - if a string is provided and it matches an existing code section, that section will be used.
        var section = getExistingSection(sectionNameOrObject, {
            abTests: abTests,
            cookies: cookies,
            hasFreeTier: hasFreeTier,
            hasStudentPlan: hasStudentPlan
        });
        if (!section) {
            (0,bigbrain_service.trackEvent)(bigbrain_event_types.PRICING_PAGE_MISSING_CLUSTER_INFO_ENCOUNTERED, {
                kind: "name",
                placement: "sections",
                data: sectionNameOrObject
            });
            return null;
        }
        return section;
    }
    // creating a section object using the given input
    var section1 = sectionNameOrObject.section, sectionName = sectionNameOrObject.sectionName, overrides = sectionNameOrObject.overrides; // 'sectionName' for backwards compatibility - TODO remove after fixing existing configs
    if (!section1 && !sectionName && !(overrides === null || overrides === void 0 ? void 0 : overrides.sectionName)) {
        (0,bigbrain_service.trackEvent)(bigbrain_event_types.PRICING_PAGE_MISSING_CLUSTER_INFO_ENCOUNTERED, {
            placement: "sections",
            kind: "object",
            data: sectionNameOrObject
        });
        return null; // must have an existing section's name, or a new one.
    }
    var existingSection = getExistingSection(section1, {
        abTests: abTests,
        cookies: cookies,
        hasStudentPlan: hasStudentPlan,
        hasFreeTier: hasFreeTier
    }) || getExistingSection(sectionName, {
        abTests: abTests,
        cookies: cookies,
        hasStudentPlan: hasStudentPlan,
        hasFreeTier: hasFreeTier
    }) || {}; // using an existing section if one matches the name.
    var sectionWithOverrides = (0,clusterized_pricing_page_helper_service/* applyOverrides */.RW)(existingSection, overrides, DEFAULT_SECTION_KEYS);
    if (!sectionWithOverrides.features) {
        sectionWithOverrides.features = [];
    }
    if (overrides === null || overrides === void 0 ? void 0 : overrides.features) {
        sectionWithOverrides.features = compact_default()(overrides.features.map(function(feature) {
            return convertFeature(feature, {
                abTests: abTests,
                cookies: cookies,
                hasStudentPlan: hasStudentPlan,
                hasFreeTier: hasFreeTier
            });
        }));
    }
    if (!isSectionValid(sectionWithOverrides)) return null;
    return sectionWithOverrides;
};
var convertSectionToPricingPageSection = function(value, param) {
    var abTests = param.abTests, cookies = param.cookies, hasStudentPlan = param.hasStudentPlan, hasFreeTier = param.hasFreeTier;
    return convertSection(value, {
        abTests: abTests,
        cookies: cookies,
        hasStudentPlan: hasStudentPlan,
        hasFreeTier: hasFreeTier
    });
};

// EXTERNAL MODULE: ./constants/pricing/pricing-page/value-features/index.js
var value_features = __webpack_require__(69078);
// EXTERNAL MODULE: ./constants/pricing/pricing-page/features/value_features.js
var features_value_features = __webpack_require__(49127);
;// CONCATENATED MODULE: ./services/pricing/pricing-page/clusterization/clusterized-pricing-page-value-features-service.js
function clusterized_pricing_page_value_features_service_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function clusterized_pricing_page_value_features_service_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            clusterized_pricing_page_value_features_service_define_property(target, key, source[key]);
        });
    }
    return target;
}








var isValueFeatureValid = function(valueFeature) {
    return isString_default()(valueFeature === null || valueFeature === void 0 ? void 0 : valueFeature.name) && isString_default()(valueFeature === null || valueFeature === void 0 ? void 0 : valueFeature.text) && valueFeature.name.length > 0 && valueFeature.text.length > 0;
};
var getExistingValueFeature = function(valueFeatureName) {
    if (isValueFeatureValid(features_value_features[valueFeatureName])) {
        return clusterized_pricing_page_value_features_service_object_spread({}, features_value_features[valueFeatureName]);
    }
    return null;
};
var getValueFeatureOrNull = function(valueFeatureNameOrObject) {
    if (isString_default()(valueFeatureNameOrObject)) {
        // shortcut - if a string is provided and it matches an existing code value feature, it will be used.
        var valueFeature = getExistingValueFeature(valueFeatureNameOrObject);
        if (!valueFeature) {
            // missing value feature - emitting event
            (0,bigbrain_service.trackEvent)(bigbrain_event_types.PRICING_PAGE_MISSING_CLUSTER_INFO_ENCOUNTERED, {
                placement: "value_features",
                kind: "name",
                data: valueFeatureNameOrObject
            });
        }
        return valueFeature; // will be null if no such value feature exists.
    } else if ((0,clusterized_pricing_page_helper_service/* isObject */.Kn)(valueFeatureNameOrObject)) {
        var feature = valueFeatureNameOrObject.feature, name = valueFeatureNameOrObject.name, overrides = valueFeatureNameOrObject.overrides; // 'name' is there for backwards compatibility - TODO remove
        var existingFeature = getExistingValueFeature(feature) || getExistingValueFeature(name) || {};
        var overrideKeys = [
            "name",
            "text",
            "link"
        ];
        var resultingFeature = (0,clusterized_pricing_page_helper_service/* applyOverrides */.RW)(existingFeature, overrides, overrideKeys);
        if (!isValueFeatureValid(resultingFeature)) {
            // no source for the value feature's name and text (either a code-based existing feature or config-delivered) -
            // returning null.
            (0,bigbrain_service.trackEvent)(bigbrain_event_types.PRICING_PAGE_MISSING_CLUSTER_INFO_ENCOUNTERED, {
                placement: "value_features",
                kind: "object",
                data: valueFeatureNameOrObject
            });
            return null;
        }
        return resultingFeature;
    }
    // value must be a string or an object.
    (0,bigbrain_service.trackEvent)(bigbrain_event_types.PRICING_PAGE_MISSING_CLUSTER_INFO_ENCOUNTERED, {
        placement: "value_features",
        kind: "invalid_type",
        data: valueFeatureNameOrObject
    });
    return null;
};
var getClusterizedValueFeatures = function(clusterValueFeatures, param) {
    var hasStudentPlan = param.hasStudentPlan, hasFreeTier = param.hasFreeTier, abTests = param.abTests, cookies = param.cookies, forcePricing = param.forcePricing;
    var valueFeaturesObject = clusterized_pricing_page_value_features_service_object_spread({}, (0,value_features/* DEFAULT_VALUE_FEATURES_PER_TIER */.S)({
        hasStudentPlan: hasStudentPlan,
        hasFreeTier: hasFreeTier,
        abTests: abTests,
        cookies: cookies,
        forcePricing: forcePricing
    }));
    // overriding default values (using existing value features) on a per-tier basis
    (0,clusterized_pricing_page_helper_service/* runForEachTier */.X2)(function(tier) {
        if (tier === pricing/* TIERS.FREE */.Iy.FREE) return;
        // the Individual plan top features aren't shown at the moment, since it's a reduced, controlled plan.
        var tierClusterFeatures = clusterValueFeatures[tier];
        if (Array.isArray(tierClusterFeatures) && tierClusterFeatures.length > 0) {
            valueFeaturesObject[tier] = compact_default()(tierClusterFeatures.map(getValueFeatureOrNull));
        }
    });
    return valueFeaturesObject;
};

;// CONCATENATED MODULE: ./services/pricing/pricing-page/clusterized-pricing-page-service.js
function clusterized_pricing_page_service_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function clusterized_pricing_page_service_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            clusterized_pricing_page_service_define_property(target, key, source[key]);
        });
    }
    return target;
}









var isInClusterTest = function(clusterConfig, param) {
    var abTests = param.abTests, cookies = param.cookies, forcePricing = param.forcePricing;
    return true;
    return false;
    if (!(clusterConfig === null || clusterConfig === void 0 ? void 0 : clusterConfig.payments_view)) return false; // no payments config -> no AB test
    var abTestConfig = (clusterConfig === null || clusterConfig === void 0 ? void 0 : clusterConfig.payments_view).abTestConfig;
    if (!(abTestConfig === null || abTestConfig === void 0 ? void 0 : abTestConfig.homepage)) return true; // cluster pricing config is active by default if there isn't a homepage test
    var _homepage = abTestConfig.homepage, disableTest = _homepage.disableTest, testName = _homepage.testName, newVariationName = _homepage.newVariationName, sendBigBrainEvent = _homepage.sendBigBrainEvent, syncCookieName = _homepage.syncCookieName, syncCookieValue = _homepage.syncCookieValue, homepageSyncCookieName = _homepage.homepageSyncCookieName, configForcePricing = _homepage.forcePricing;
    // checking: the test was manually disabled for now
    if (disableTest === "true" || disableTest === true) {
        return true;
    }
    // checking: 'forcePricing' value was passed
    if (configForcePricing && configForcePricing === forcePricing) {
        return true;
    }
    // checking: the user already received a platform variant
    // TODO return after caching issues have been fully cleared
    if (cookies) {
        var matchingPlatformCookie = cookies[syncCookieName];
        if (matchingPlatformCookie && syncCookieValue && matchingPlatformCookie === syncCookieValue) {
            // otherwise, undefined === undefined.
            return true; // achieved via platform <--> homepage test synchronization.
        }
    }
    var abTestVariant = (0,new_ab_tests_service.getAbTestVariantNew)(abTests, testName, sendBigBrainEvent);
    // if we want to synchronize the homepage's AB test result to the platform:
    // TODO return after caching issues have been fully cleared
    if (isString_default()(homepageSyncCookieName) && isString_default()(abTestVariant)) {
        (0,cookies_service/* setCookieIfNeeded */.cr)(homepageSyncCookieName, abTestVariant);
    }
    return abTestVariant === newVariationName;
};
// Expected input:
// { sections:
//  ([ESSENTIALS, ...] or [{sectionName: 'ESSENTIALS', overrides: ...}])
// }
var getPricingPageSectionsFromClusterConfig = function(pricingConfig, param) {
    var _abTests = param.abTests, abTests = _abTests === void 0 ? {} : _abTests, _cookies = param.cookies, cookies = _cookies === void 0 ? {} : _cookies, _hasStudentPlan = param.hasStudentPlan, hasStudentPlan = _hasStudentPlan === void 0 ? false : _hasStudentPlan, _hasFreeTier = param.hasFreeTier, hasFreeTier = _hasFreeTier === void 0 ? false : _hasFreeTier;
    if (!(0,clusterized_pricing_page_helper_service/* isObject */.Kn)(pricingConfig) || !Array.isArray(pricingConfig.sections)) return;
    var sections = pricingConfig.sections;
    return compact_default()(sections.map(function(section) {
        return convertSectionToPricingPageSection(section, {
            abTests: abTests,
            cookies: cookies,
            hasStudentPlan: hasStudentPlan,
            hasFreeTier: hasFreeTier
        });
    }));
};
var getTierDescriptionsFromClusterConfig = function(pricingConfig, clusterId, param) {
    var hasStudentPlan = param.hasStudentPlan, cookies = param.cookies, abTests = param.abTests, forcePricing = param.forcePricing;
    if (!(0,clusterized_pricing_page_helper_service/* isObject */.Kn)(pricingConfig) || !(0,clusterized_pricing_page_helper_service/* isObject */.Kn)(pricingConfig.tier_descriptions)) return;
    // getting default tier descriptions
    var tier_descriptions = pricingConfig.tier_descriptions;
    var returnedDescriptions = clusterized_pricing_page_service_object_spread({}, (0,pricing_page_tier_descriptions/* getDefaultTierDescriptions */.O)({
        hasStudentPlan: hasStudentPlan
    }));
    // overriding them if any exist
    if ((0,clusterized_pricing_page_helper_service/* isObject */.Kn)(tier_descriptions)) {
        (0,clusterized_pricing_page_helper_service/* runForEachTier */.X2)(function(tier) {
            if (tier === pricing/* TIERS.FREE */.Iy.FREE) return; // Individual plan sees the same descriptions regardless of cluster.
            if (isString_default()(tier_descriptions[tier])) {
                returnedDescriptions[tier] = tier_descriptions[tier];
            }
        });
    }
    return returnedDescriptions;
};
var getValueFeaturesFromClusterConfig = function(clusterValueFeatures, param) {
    var hasStudentPlan = param.hasStudentPlan, hasFreeTier = param.hasFreeTier, abTests = param.abTests, cookies = param.cookies;
    if (!clusterValueFeatures || !(0,clusterized_pricing_page_helper_service/* isObject */.Kn)(clusterValueFeatures)) return;
    return getClusterizedValueFeatures(clusterValueFeatures, {
        hasStudentPlan: hasStudentPlan,
        hasFreeTier: hasFreeTier,
        abTests: abTests,
        cookies: cookies
    });
};


/***/ }),

/***/ 43331:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A": function() { return /* binding */ productPrices; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(14924);
/* harmony import */ var constants_pricing_versions__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(78803);
/* harmony import */ var constants_pricing_versions__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(constants_pricing_versions__WEBPACK_IMPORTED_MODULE_0__);


var free = {
    usd: 0,
    euro: 0,
    gbp: 0,
    cad: 0,
    aud: 0,
    brl: 0,
    mxn: 0,
    inr: 0,
    jpy: 0
};
var _obj, _obj1, _obj2, _obj3, _obj4;
var productPrices = {
    core: (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, constants_pricing_versions__WEBPACK_IMPORTED_MODULE_0__.VERSION_9, {
        monthly: {
            free: free,
            basic: {
                usd: 10,
                euro: 10,
                gbp: 9,
                cad: 14,
                aud: 14,
                brl: 43,
                mxn: 200,
                inr: 750,
                jpy: 1100
            },
            standard: {
                usd: 12,
                euro: 12,
                gbp: 11,
                cad: 17,
                aud: 17,
                brl: 55,
                mxn: 240,
                inr: 900,
                jpy: 1400
            },
            pro: {
                usd: 20,
                euro: 20,
                gbp: 18,
                cad: 27,
                aud: 27,
                brl: 91,
                mxn: 400,
                inr: 1500,
                jpy: 2200
            },
            enterprise: {
                usd: 46,
                euro: 46,
                gbp: 40,
                cad: 62,
                aud: 62,
                brl: 217,
                mxn: 920,
                inr: 3450,
                jpy: 4700
            }
        },
        yearly: {
            free: free,
            basic: {
                usd: 8,
                euro: 8,
                gbp: 7,
                cad: 11,
                aud: 11,
                brl: 35,
                mxn: 160,
                inr: 600,
                jpy: 900
            },
            standard: {
                usd: 10,
                euro: 10,
                gbp: 9,
                cad: 14,
                aud: 14,
                brl: 45,
                mxn: 200,
                inr: 750,
                jpy: 1100
            },
            pro: {
                usd: 16,
                euro: 16,
                gbp: 14,
                cad: 22,
                aud: 22,
                brl: 75,
                mxn: 320,
                inr: 1200,
                jpy: 1800
            },
            enterprise: {
                usd: 38,
                euro: 38,
                gbp: 33,
                cad: 51,
                aud: 51,
                brl: 178,
                mxn: 760,
                inr: 2850,
                jpy: 4200
            }
        }
    }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, constants_pricing_versions__WEBPACK_IMPORTED_MODULE_0__.VERSION_10, {
        monthly: {
            free: free,
            basic: {
                usd: 8,
                euro: 8,
                gbp: 6,
                cad: 10,
                aud: 10,
                brl: 37,
                mxn: 150,
                inr: 550,
                jpy: 850
            },
            standard: {
                usd: 12,
                euro: 12,
                gbp: 11,
                cad: 17,
                aud: 17,
                brl: 60,
                mxn: 240,
                inr: 900,
                jpy: 1400
            },
            pro: {
                usd: 27,
                euro: 27,
                gbp: 23,
                cad: 37,
                aud: 37,
                brl: 135,
                mxn: 540,
                inr: 2000,
                jpy: 3000
            },
            enterprise: {
                usd: 54,
                euro: 54,
                gbp: 46,
                cad: 74,
                aud: 74,
                brl: 270,
                mxn: 1100,
                inr: 4025,
                jpy: 6100
            }
        },
        yearly: {
            free: free,
            basic: {
                usd: 6,
                euro: 6,
                gbp: 5,
                cad: 8,
                aud: 8,
                brl: 30,
                mxn: 120,
                inr: 450,
                jpy: 700
            },
            standard: {
                usd: 10,
                euro: 10,
                gbp: 9,
                cad: 14,
                aud: 14,
                brl: 50,
                mxn: 200,
                inr: 750,
                jpy: 1100
            },
            pro: {
                usd: 22,
                euro: 22,
                gbp: 19,
                cad: 30,
                aud: 30,
                brl: 110,
                mxn: 440,
                inr: 1650,
                jpy: 2500
            },
            enterprise: {
                usd: 44,
                euro: 44,
                gbp: 38,
                cad: 60,
                aud: 60,
                brl: 220,
                mxn: 900,
                inr: 3300,
                jpy: 5000
            }
        }
    }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, constants_pricing_versions__WEBPACK_IMPORTED_MODULE_0__.VERSION_11, {
        monthly: {
            free: free,
            basic: {
                usd: 10,
                euro: 10,
                gbp: 9,
                cad: 14,
                aud: 14,
                brl: 43,
                mxn: 200,
                inr: 750,
                jpy: 1300
            },
            standard: {
                usd: 12,
                euro: 12,
                gbp: 11,
                cad: 17,
                aud: 17,
                brl: 55,
                mxn: 240,
                inr: 900,
                jpy: 1700
            },
            pro: {
                usd: 20,
                euro: 20,
                gbp: 18,
                cad: 27,
                aud: 27,
                brl: 91,
                mxn: 400,
                inr: 1500,
                jpy: 3300
            },
            enterprise: {
                usd: 46,
                euro: 46,
                gbp: 40,
                cad: 62,
                aud: 62,
                brl: 217,
                mxn: 920,
                inr: 3450,
                jpy: 4700
            }
        },
        yearly: {
            free: free,
            basic: {
                usd: 8,
                euro: 8,
                gbp: 7,
                cad: 11,
                aud: 11,
                brl: 35,
                mxn: 160,
                inr: 600,
                jpy: 1100
            },
            standard: {
                usd: 10,
                euro: 10,
                gbp: 9,
                cad: 14,
                aud: 14,
                brl: 45,
                mxn: 200,
                inr: 750,
                jpy: 1400
            },
            pro: {
                usd: 16,
                euro: 16,
                gbp: 14,
                cad: 22,
                aud: 22,
                brl: 75,
                mxn: 320,
                inr: 1200,
                jpy: 2700
            },
            enterprise: {
                usd: 38,
                euro: 38,
                gbp: 33,
                cad: 51,
                aud: 51,
                brl: 178,
                mxn: 760,
                inr: 2850,
                jpy: 4200
            }
        }
    }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, constants_pricing_versions__WEBPACK_IMPORTED_MODULE_0__.VERSION_12, {
        monthly: {
            free: free,
            basic: {
                usd: 10,
                euro: 10,
                gbp: 9,
                cad: 14,
                aud: 14,
                brl: 43,
                mxn: 200,
                inr: 750,
                jpy: 1300
            },
            standard: {
                usd: 12,
                euro: 12,
                gbp: 11,
                cad: 17,
                aud: 17,
                brl: 55,
                mxn: 240,
                inr: 900,
                jpy: 1700
            },
            pro: {
                usd: 24,
                euro: 24,
                gbp: 21,
                cad: 32,
                aud: 32,
                brl: 108,
                mxn: 475,
                inr: 1780,
                jpy: 3300
            },
            enterprise: {
                usd: 54,
                euro: 54,
                gbp: 46,
                cad: 74,
                aud: 74,
                brl: 270,
                mxn: 1100,
                inr: 4025,
                jpy: 6100
            }
        },
        yearly: {
            free: free,
            basic: {
                usd: 8,
                euro: 8,
                gbp: 7,
                cad: 11,
                aud: 11,
                brl: 35,
                mxn: 160,
                inr: 600,
                jpy: 1100
            },
            standard: {
                usd: 10,
                euro: 10,
                gbp: 9,
                cad: 14,
                aud: 14,
                brl: 45,
                mxn: 200,
                inr: 750,
                jpy: 1400
            },
            pro: {
                usd: 19,
                euro: 19,
                gbp: 17,
                cad: 26,
                aud: 26,
                brl: 89,
                mxn: 380,
                inr: 1425,
                jpy: 2700
            },
            enterprise: {
                usd: 44,
                euro: 44,
                gbp: 38,
                cad: 60,
                aud: 60,
                brl: 220,
                mxn: 900,
                inr: 3300,
                jpy: 5000
            }
        }
    }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, constants_pricing_versions__WEBPACK_IMPORTED_MODULE_0__.VERSION_13, {
        monthly: {
            free: free,
            basic: {
                usd: 12,
                euro: 12,
                gbp: 11,
                cad: 17,
                aud: 17,
                brl: 49,
                mxn: 240,
                inr: 890,
                jpy: 1530
            },
            standard: {
                usd: 14,
                euro: 14,
                gbp: 13,
                cad: 20,
                aud: 20,
                brl: 65,
                mxn: 280,
                inr: 1060,
                jpy: 1990
            },
            pro: {
                usd: 24,
                euro: 24,
                gbp: 21,
                cad: 32,
                aud: 32,
                brl: 105,
                mxn: 480,
                inr: 1770,
                jpy: 3890
            },
            enterprise: {
                usd: 54,
                euro: 54,
                gbp: 47,
                cad: 73,
                aud: 73,
                brl: 255,
                mxn: 1080,
                inr: 4070,
                jpy: 8700
            }
        },
        yearly: {
            free: free,
            basic: {
                usd: 9,
                euro: 9,
                gbp: 8,
                cad: 13,
                aud: 13,
                brl: 41,
                mxn: 190,
                inr: 710,
                jpy: 1300
            },
            standard: {
                usd: 12,
                euro: 12,
                gbp: 11,
                cad: 17,
                aud: 17,
                brl: 53,
                mxn: 240,
                inr: 890,
                jpy: 1650
            },
            pro: {
                usd: 19,
                euro: 19,
                gbp: 17,
                cad: 26,
                aud: 26,
                brl: 89,
                mxn: 380,
                inr: 1400,
                jpy: 3200
            },
            enterprise: {
                usd: 44,
                euro: 44,
                gbp: 39,
                cad: 60,
                aud: 60,
                brl: 210,
                mxn: 900,
                inr: 3360,
                jpy: 7200
            }
        }
    }), _obj),
    marketing: (_obj1 = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj1, constants_pricing_versions__WEBPACK_IMPORTED_MODULE_0__.VERSION_9, {
        monthly: {
            free: free,
            basic: {
                usd: 2.5,
                euro: 2.5,
                gbp: 2,
                cad: 3.3,
                aud: 3.3,
                brl: 12,
                mxn: 50,
                inr: 187.5,
                jpy: 280
            },
            standard: {
                usd: 4,
                euro: 4,
                gbp: 3,
                cad: 5.3,
                aud: 5.3,
                brl: 20,
                mxn: 80,
                inr: 300,
                jpy: 450
            },
            pro: {
                usd: 7.5,
                euro: 7.5,
                gbp: 6,
                cad: 10,
                aud: 10,
                brl: 36,
                mxn: 150,
                inr: 562.5,
                jpy: 845
            },
            enterprise: free
        },
        yearly: {
            free: free,
            basic: {
                usd: 2,
                euro: 2,
                gbp: 1.5,
                cad: 2.65,
                aud: 2.65,
                brl: 10,
                mxn: 40,
                inr: 150,
                jpy: 225
            },
            standard: {
                usd: 3,
                euro: 3,
                gbp: 2.3,
                cad: 4,
                aud: 4,
                brl: 15,
                mxn: 60,
                inr: 225,
                jpy: 350
            },
            pro: {
                usd: 6,
                euro: 6,
                gbp: 4.6,
                cad: 8,
                aud: 8,
                brl: 30,
                mxn: 120,
                inr: 450,
                jpy: 680
            },
            enterprise: free
        }
    }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj1, constants_pricing_versions__WEBPACK_IMPORTED_MODULE_0__.VERSION_10, {
        monthly: {
            free: free,
            basic: {
                usd: 2.5,
                euro: 2.5,
                gbp: 2,
                cad: 3.3,
                aud: 3.3,
                brl: 12,
                mxn: 50,
                inr: 187.5,
                jpy: 280
            },
            standard: {
                usd: 4,
                euro: 4,
                gbp: 3,
                cad: 5.3,
                aud: 5.3,
                brl: 20,
                mxn: 80,
                inr: 300,
                jpy: 450
            },
            pro: {
                usd: 7.5,
                euro: 7.5,
                gbp: 6,
                cad: 10,
                aud: 10,
                brl: 36,
                mxn: 150,
                inr: 562.5,
                jpy: 845
            },
            enterprise: free
        },
        yearly: {
            free: free,
            basic: {
                usd: 2,
                euro: 2,
                gbp: 1.5,
                cad: 2.65,
                aud: 2.65,
                brl: 10,
                mxn: 40,
                inr: 150,
                jpy: 225
            },
            standard: {
                usd: 3,
                euro: 3,
                gbp: 2.3,
                cad: 4,
                aud: 4,
                brl: 15,
                mxn: 60,
                inr: 225,
                jpy: 350
            },
            pro: {
                usd: 6,
                euro: 6,
                gbp: 4.6,
                cad: 8,
                aud: 8,
                brl: 30,
                mxn: 120,
                inr: 450,
                jpy: 680
            },
            enterprise: free
        }
    }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj1, constants_pricing_versions__WEBPACK_IMPORTED_MODULE_0__.VERSION_11, {
        monthly: {
            free: free,
            basic: {
                usd: 2.5,
                euro: 2.5,
                gbp: 2,
                cad: 3.3,
                aud: 3.3,
                brl: 12,
                mxn: 50,
                inr: 187.5,
                jpy: 280
            },
            standard: {
                usd: 4,
                euro: 4,
                gbp: 3,
                cad: 5.3,
                aud: 5.3,
                brl: 20,
                mxn: 80,
                inr: 300,
                jpy: 450
            },
            pro: {
                usd: 7.5,
                euro: 7.5,
                gbp: 6,
                cad: 10,
                aud: 10,
                brl: 36,
                mxn: 150,
                inr: 562.5,
                jpy: 845
            },
            enterprise: free
        },
        yearly: {
            free: free,
            basic: {
                usd: 2,
                euro: 2,
                gbp: 1.5,
                cad: 2.65,
                aud: 2.65,
                brl: 10,
                mxn: 40,
                inr: 150,
                jpy: 225
            },
            standard: {
                usd: 3,
                euro: 3,
                gbp: 2.3,
                cad: 4,
                aud: 4,
                brl: 15,
                mxn: 60,
                inr: 225,
                jpy: 350
            },
            pro: {
                usd: 6,
                euro: 6,
                gbp: 4.6,
                cad: 8,
                aud: 8,
                brl: 30,
                mxn: 120,
                inr: 450,
                jpy: 680
            },
            enterprise: free
        }
    }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj1, constants_pricing_versions__WEBPACK_IMPORTED_MODULE_0__.VERSION_12, {
        monthly: {
            free: free,
            basic: {
                usd: 2.5,
                euro: 2.5,
                gbp: 2,
                cad: 3.3,
                aud: 3.3,
                brl: 12,
                mxn: 50,
                inr: 187.5,
                jpy: 280
            },
            standard: {
                usd: 4,
                euro: 4,
                gbp: 3,
                cad: 5.3,
                aud: 5.3,
                brl: 20,
                mxn: 80,
                inr: 300,
                jpy: 450
            },
            pro: {
                usd: 7.5,
                euro: 7.5,
                gbp: 6,
                cad: 10,
                aud: 10,
                brl: 36,
                mxn: 150,
                inr: 562.5,
                jpy: 845
            },
            enterprise: free
        },
        yearly: {
            free: free,
            basic: {
                usd: 2,
                euro: 2,
                gbp: 1.5,
                cad: 2.65,
                aud: 2.65,
                brl: 10,
                mxn: 40,
                inr: 150,
                jpy: 225
            },
            standard: {
                usd: 3,
                euro: 3,
                gbp: 2.3,
                cad: 4,
                aud: 4,
                brl: 15,
                mxn: 60,
                inr: 225,
                jpy: 350
            },
            pro: {
                usd: 6,
                euro: 6,
                gbp: 4.6,
                cad: 8,
                aud: 8,
                brl: 30,
                mxn: 120,
                inr: 450,
                jpy: 680
            },
            enterprise: free
        }
    }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj1, constants_pricing_versions__WEBPACK_IMPORTED_MODULE_0__.VERSION_13, {
        monthly: {
            free: free,
            basic: {
                usd: 2.5,
                euro: 2.5,
                gbp: 2,
                cad: 3.3,
                aud: 3.3,
                brl: 12,
                mxn: 50,
                inr: 187.5,
                jpy: 280
            },
            standard: {
                usd: 4,
                euro: 4,
                gbp: 3,
                cad: 5.3,
                aud: 5.3,
                brl: 20,
                mxn: 80,
                inr: 300,
                jpy: 450
            },
            pro: {
                usd: 7.5,
                euro: 7.5,
                gbp: 6,
                cad: 10,
                aud: 10,
                brl: 36,
                mxn: 150,
                inr: 562.5,
                jpy: 845
            },
            enterprise: free
        },
        yearly: {
            free: free,
            basic: {
                usd: 2,
                euro: 2,
                gbp: 1.5,
                cad: 2.65,
                aud: 2.65,
                brl: 10,
                mxn: 40,
                inr: 150,
                jpy: 225
            },
            standard: {
                usd: 3,
                euro: 3,
                gbp: 2.3,
                cad: 4,
                aud: 4,
                brl: 15,
                mxn: 60,
                inr: 225,
                jpy: 350
            },
            pro: {
                usd: 6,
                euro: 6,
                gbp: 4.6,
                cad: 8,
                aud: 8,
                brl: 30,
                mxn: 120,
                inr: 450,
                jpy: 680
            },
            enterprise: free
        }
    }), _obj1),
    crm: (_obj2 = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj2, constants_pricing_versions__WEBPACK_IMPORTED_MODULE_0__.VERSION_9, {
        monthly: {
            free: free,
            basic: {
                usd: 2.5,
                euro: 2.5,
                gbp: 2,
                cad: 3.3,
                aud: 3.3,
                brl: 12,
                mxn: 50,
                inr: 187.5,
                jpy: 280
            },
            standard: {
                usd: 5,
                euro: 5,
                gbp: 4,
                cad: 6.6,
                aud: 6.6,
                brl: 24,
                mxn: 100,
                inr: 375,
                jpy: 560
            },
            pro: {
                usd: 10,
                euro: 10,
                gbp: 8,
                cad: 13.2,
                aud: 13.2,
                brl: 48,
                mxn: 200,
                inr: 750,
                jpy: 1125
            },
            enterprise: free
        },
        yearly: {
            free: free,
            basic: {
                usd: 2,
                euro: 2,
                gbp: 1.5,
                cad: 2.65,
                aud: 2.65,
                brl: 10,
                mxn: 40,
                inr: 150,
                jpy: 225
            },
            standard: {
                usd: 4,
                euro: 4,
                gbp: 3,
                cad: 5.3,
                aud: 5.3,
                brl: 20,
                mxn: 80,
                inr: 300,
                jpy: 450
            },
            pro: {
                usd: 8,
                euro: 8,
                gbp: 6,
                cad: 10.6,
                aud: 10.6,
                brl: 40,
                mxn: 160,
                inr: 600,
                jpy: 900
            },
            enterprise: free
        }
    }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj2, constants_pricing_versions__WEBPACK_IMPORTED_MODULE_0__.VERSION_10, {
        monthly: {
            free: free,
            basic: {
                usd: 2.5,
                euro: 2.5,
                gbp: 2,
                cad: 3.3,
                aud: 3.3,
                brl: 12,
                mxn: 50,
                inr: 187.5,
                jpy: 280
            },
            standard: {
                usd: 5,
                euro: 5,
                gbp: 4,
                cad: 6.6,
                aud: 6.6,
                brl: 24,
                mxn: 100,
                inr: 375,
                jpy: 560
            },
            pro: {
                usd: 10,
                euro: 10,
                gbp: 8,
                cad: 13.2,
                aud: 13.2,
                brl: 48,
                mxn: 200,
                inr: 750,
                jpy: 1125
            },
            enterprise: free
        },
        yearly: {
            free: free,
            basic: {
                usd: 2,
                euro: 2,
                gbp: 1.5,
                cad: 2.65,
                aud: 2.65,
                brl: 10,
                mxn: 40,
                inr: 150,
                jpy: 225
            },
            standard: {
                usd: 4,
                euro: 4,
                gbp: 3,
                cad: 5.3,
                aud: 5.3,
                brl: 20,
                mxn: 80,
                inr: 300,
                jpy: 450
            },
            pro: {
                usd: 8,
                euro: 8,
                gbp: 6,
                cad: 10.6,
                aud: 10.6,
                brl: 40,
                mxn: 160,
                inr: 600,
                jpy: 900
            },
            enterprise: free
        }
    }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj2, constants_pricing_versions__WEBPACK_IMPORTED_MODULE_0__.VERSION_11, {
        monthly: {
            free: free,
            basic: {
                usd: 2.5,
                euro: 2.5,
                gbp: 2,
                cad: 3.3,
                aud: 3.3,
                brl: 12,
                mxn: 50,
                inr: 187.5,
                jpy: 280
            },
            standard: {
                usd: 5,
                euro: 5,
                gbp: 4,
                cad: 6.6,
                aud: 6.6,
                brl: 24,
                mxn: 100,
                inr: 375,
                jpy: 560
            },
            pro: {
                usd: 10,
                euro: 10,
                gbp: 8,
                cad: 13.2,
                aud: 13.2,
                brl: 48,
                mxn: 200,
                inr: 750,
                jpy: 1125
            },
            enterprise: free
        },
        yearly: {
            free: free,
            basic: {
                usd: 2,
                euro: 2,
                gbp: 1.5,
                cad: 2.65,
                aud: 2.65,
                brl: 10,
                mxn: 40,
                inr: 150,
                jpy: 225
            },
            standard: {
                usd: 4,
                euro: 4,
                gbp: 3,
                cad: 5.3,
                aud: 5.3,
                brl: 20,
                mxn: 80,
                inr: 300,
                jpy: 450
            },
            pro: {
                usd: 8,
                euro: 8,
                gbp: 6,
                cad: 10.6,
                aud: 10.6,
                brl: 40,
                mxn: 160,
                inr: 600,
                jpy: 900
            },
            enterprise: free
        }
    }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj2, constants_pricing_versions__WEBPACK_IMPORTED_MODULE_0__.VERSION_12, {
        monthly: {
            free: free,
            basic: {
                usd: 2.5,
                euro: 2.5,
                gbp: 2,
                cad: 3.3,
                aud: 3.3,
                brl: 12,
                mxn: 50,
                inr: 187.5,
                jpy: 280
            },
            standard: {
                usd: 5,
                euro: 5,
                gbp: 4,
                cad: 6.6,
                aud: 6.6,
                brl: 24,
                mxn: 100,
                inr: 375,
                jpy: 560
            },
            pro: {
                usd: 10,
                euro: 10,
                gbp: 8,
                cad: 13.2,
                aud: 13.2,
                brl: 48,
                mxn: 200,
                inr: 750,
                jpy: 1125
            },
            enterprise: free
        },
        yearly: {
            free: free,
            basic: {
                usd: 2,
                euro: 2,
                gbp: 1.5,
                cad: 2.65,
                aud: 2.65,
                brl: 10,
                mxn: 40,
                inr: 150,
                jpy: 225
            },
            standard: {
                usd: 4,
                euro: 4,
                gbp: 3,
                cad: 5.3,
                aud: 5.3,
                brl: 20,
                mxn: 80,
                inr: 300,
                jpy: 450
            },
            pro: {
                usd: 8,
                euro: 8,
                gbp: 6,
                cad: 10.6,
                aud: 10.6,
                brl: 40,
                mxn: 160,
                inr: 600,
                jpy: 900
            },
            enterprise: free
        }
    }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj2, constants_pricing_versions__WEBPACK_IMPORTED_MODULE_0__.VERSION_13, {
        monthly: {
            free: free,
            basic: {
                usd: 3,
                euro: 3,
                gbp: 2,
                cad: 4,
                aud: 4,
                brl: 16,
                mxn: 60,
                inr: 210,
                jpy: 330
            },
            standard: {
                usd: 6,
                euro: 6,
                gbp: 5,
                cad: 8,
                aud: 8,
                brl: 29,
                mxn: 120,
                inr: 440,
                jpy: 680
            },
            pro: {
                usd: 9,
                euro: 9,
                gbp: 10,
                cad: 16,
                aud: 16,
                brl: 59,
                mxn: 220,
                inr: 880,
                jpy: 1330
            },
            enterprise: free
        },
        yearly: {
            free: free,
            basic: {
                usd: 3,
                euro: 3,
                gbp: 2,
                cad: 5,
                aud: 3,
                brl: 12,
                mxn: 40,
                inr: 170,
                jpy: 260
            },
            standard: {
                usd: 5,
                euro: 5,
                gbp: 3,
                cad: 6,
                aud: 6,
                brl: 24,
                mxn: 90,
                inr: 350,
                jpy: 530
            },
            pro: {
                usd: 9,
                euro: 9,
                gbp: 7,
                cad: 13,
                aud: 13,
                brl: 46,
                mxn: 180,
                inr: 720,
                jpy: 1050
            },
            enterprise: free
        }
    }), _obj2),
    projectManagement: (_obj3 = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj3, constants_pricing_versions__WEBPACK_IMPORTED_MODULE_0__.VERSION_9, {
        monthly: {
            free: free,
            basic: {
                usd: 2,
                euro: 2,
                gbp: 1.5,
                cad: 2.65,
                aud: 2.65,
                brl: 10,
                mxn: 40,
                inr: 150,
                jpy: 225
            },
            standard: {
                usd: 2.5,
                euro: 2.5,
                gbp: 2,
                cad: 3.3,
                aud: 3.3,
                brl: 12,
                mxn: 50,
                inr: 187.5,
                jpy: 280
            },
            pro: {
                usd: 5,
                euro: 5,
                gbp: 4,
                cad: 6.6,
                aud: 6.6,
                brl: 24,
                mxn: 100,
                inr: 375,
                jpy: 560
            },
            enterprise: free
        },
        yearly: {
            free: free,
            basic: {
                usd: 1,
                euro: 1,
                gbp: 0.75,
                cad: 1.3,
                aud: 1.3,
                brl: 5,
                mxn: 20,
                inr: 75,
                jpy: 115
            },
            standard: {
                usd: 2,
                euro: 2,
                gbp: 1.5,
                cad: 2.65,
                aud: 2.65,
                brl: 10,
                mxn: 40,
                inr: 150,
                jpy: 225
            },
            pro: {
                usd: 4,
                euro: 4,
                gbp: 3,
                cad: 5.3,
                aud: 5.3,
                brl: 20,
                mxn: 80,
                inr: 300,
                jpy: 450
            },
            enterprise: free
        }
    }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj3, constants_pricing_versions__WEBPACK_IMPORTED_MODULE_0__.VERSION_10, {
        monthly: {
            free: free,
            basic: {
                usd: 2,
                euro: 2,
                gbp: 1.5,
                cad: 2.65,
                aud: 2.65,
                brl: 10,
                mxn: 40,
                inr: 150,
                jpy: 225
            },
            standard: {
                usd: 2.5,
                euro: 2.5,
                gbp: 2,
                cad: 3.3,
                aud: 3.3,
                brl: 12,
                mxn: 50,
                inr: 187.5,
                jpy: 280
            },
            pro: {
                usd: 5,
                euro: 5,
                gbp: 4,
                cad: 6.6,
                aud: 6.6,
                brl: 24,
                mxn: 100,
                inr: 375,
                jpy: 560
            },
            enterprise: free
        },
        yearly: {
            free: free,
            basic: {
                usd: 1,
                euro: 1,
                gbp: 0.75,
                cad: 1.3,
                aud: 1.3,
                brl: 5,
                mxn: 20,
                inr: 75,
                jpy: 115
            },
            standard: {
                usd: 2,
                euro: 2,
                gbp: 1.5,
                cad: 2.65,
                aud: 2.65,
                brl: 10,
                mxn: 40,
                inr: 150,
                jpy: 225
            },
            pro: {
                usd: 4,
                euro: 4,
                gbp: 3,
                cad: 5.3,
                aud: 5.3,
                brl: 20,
                mxn: 80,
                inr: 300,
                jpy: 450
            },
            enterprise: free
        }
    }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj3, constants_pricing_versions__WEBPACK_IMPORTED_MODULE_0__.VERSION_11, {
        monthly: {
            free: free,
            basic: {
                usd: 2,
                euro: 2,
                gbp: 1.5,
                cad: 2.65,
                aud: 2.65,
                brl: 10,
                mxn: 40,
                inr: 150,
                jpy: 225
            },
            standard: {
                usd: 2.5,
                euro: 2.5,
                gbp: 2,
                cad: 3.3,
                aud: 3.3,
                brl: 12,
                mxn: 50,
                inr: 187.5,
                jpy: 280
            },
            pro: {
                usd: 5,
                euro: 5,
                gbp: 4,
                cad: 6.6,
                aud: 6.6,
                brl: 24,
                mxn: 100,
                inr: 375,
                jpy: 560
            },
            enterprise: free
        },
        yearly: {
            free: free,
            basic: {
                usd: 1,
                euro: 1,
                gbp: 0.75,
                cad: 1.3,
                aud: 1.3,
                brl: 5,
                mxn: 20,
                inr: 75,
                jpy: 115
            },
            standard: {
                usd: 2,
                euro: 2,
                gbp: 1.5,
                cad: 2.65,
                aud: 2.65,
                brl: 10,
                mxn: 40,
                inr: 150,
                jpy: 225
            },
            pro: {
                usd: 4,
                euro: 4,
                gbp: 3,
                cad: 5.3,
                aud: 5.3,
                brl: 20,
                mxn: 80,
                inr: 300,
                jpy: 450
            },
            enterprise: free
        }
    }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj3, constants_pricing_versions__WEBPACK_IMPORTED_MODULE_0__.VERSION_12, {
        monthly: {
            free: free,
            basic: {
                usd: 2,
                euro: 2,
                gbp: 1.5,
                cad: 2.65,
                aud: 2.65,
                brl: 10,
                mxn: 40,
                inr: 150,
                jpy: 225
            },
            standard: {
                usd: 2.5,
                euro: 2.5,
                gbp: 2,
                cad: 3.3,
                aud: 3.3,
                brl: 12,
                mxn: 50,
                inr: 187.5,
                jpy: 280
            },
            pro: {
                usd: 5,
                euro: 5,
                gbp: 4,
                cad: 6.6,
                aud: 6.6,
                brl: 24,
                mxn: 100,
                inr: 375,
                jpy: 560
            },
            enterprise: free
        },
        yearly: {
            free: free,
            basic: {
                usd: 1,
                euro: 1,
                gbp: 0.75,
                cad: 1.3,
                aud: 1.3,
                brl: 5,
                mxn: 20,
                inr: 75,
                jpy: 115
            },
            standard: {
                usd: 2,
                euro: 2,
                gbp: 1.5,
                cad: 2.65,
                aud: 2.65,
                brl: 10,
                mxn: 40,
                inr: 150,
                jpy: 225
            },
            pro: {
                usd: 4,
                euro: 4,
                gbp: 3,
                cad: 5.3,
                aud: 5.3,
                brl: 20,
                mxn: 80,
                inr: 300,
                jpy: 450
            },
            enterprise: free
        }
    }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj3, constants_pricing_versions__WEBPACK_IMPORTED_MODULE_0__.VERSION_13, {
        monthly: {
            free: free,
            basic: {
                usd: 2,
                euro: 2,
                gbp: 1.5,
                cad: 2.65,
                aud: 2.65,
                brl: 10,
                mxn: 40,
                inr: 150,
                jpy: 225
            },
            standard: {
                usd: 2.5,
                euro: 2.5,
                gbp: 2,
                cad: 3.3,
                aud: 3.3,
                brl: 12,
                mxn: 50,
                inr: 187.5,
                jpy: 280
            },
            pro: {
                usd: 5,
                euro: 5,
                gbp: 4,
                cad: 6.6,
                aud: 6.6,
                brl: 24,
                mxn: 100,
                inr: 375,
                jpy: 560
            },
            enterprise: free
        },
        yearly: {
            free: free,
            basic: {
                usd: 1,
                euro: 1,
                gbp: 0.75,
                cad: 1.3,
                aud: 1.3,
                brl: 5,
                mxn: 20,
                inr: 75,
                jpy: 115
            },
            standard: {
                usd: 2,
                euro: 2,
                gbp: 1.5,
                cad: 2.65,
                aud: 2.65,
                brl: 10,
                mxn: 40,
                inr: 150,
                jpy: 225
            },
            pro: {
                usd: 4,
                euro: 4,
                gbp: 3,
                cad: 5.3,
                aud: 5.3,
                brl: 20,
                mxn: 80,
                inr: 300,
                jpy: 450
            },
            enterprise: free
        }
    }), _obj3),
    software: (_obj4 = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj4, constants_pricing_versions__WEBPACK_IMPORTED_MODULE_0__.VERSION_9, {
        monthly: {
            free: free,
            basic: {
                usd: 2,
                euro: 2,
                gbp: 1.5,
                cad: 2.65,
                aud: 2.65,
                brl: 10,
                mxn: 40,
                inr: 150,
                jpy: 225
            },
            standard: {
                usd: 2.5,
                euro: 2.5,
                gbp: 2,
                cad: 3.3,
                aud: 3.3,
                brl: 12,
                mxn: 50,
                inr: 187.5,
                jpy: 280
            },
            pro: {
                usd: 5,
                euro: 5,
                gbp: 4,
                cad: 6.6,
                aud: 6.6,
                brl: 24,
                mxn: 100,
                inr: 375,
                jpy: 560
            },
            enterprise: free
        },
        yearly: {
            free: free,
            basic: {
                usd: 1,
                euro: 1,
                gbp: 0.75,
                cad: 1.3,
                aud: 1.3,
                brl: 5,
                mxn: 20,
                inr: 75,
                jpy: 115
            },
            standard: {
                usd: 2,
                euro: 2,
                gbp: 1.5,
                cad: 2.65,
                aud: 2.65,
                brl: 10,
                mxn: 40,
                inr: 150,
                jpy: 225
            },
            pro: {
                usd: 4,
                euro: 4,
                gbp: 3,
                cad: 5.3,
                aud: 5.3,
                brl: 20,
                mxn: 80,
                inr: 300,
                jpy: 450
            },
            enterprise: free
        }
    }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj4, constants_pricing_versions__WEBPACK_IMPORTED_MODULE_0__.VERSION_10, {
        monthly: {
            free: free,
            basic: {
                usd: 2,
                euro: 2,
                gbp: 1.5,
                cad: 2.65,
                aud: 2.65,
                brl: 10,
                mxn: 40,
                inr: 150,
                jpy: 225
            },
            standard: {
                usd: 2.5,
                euro: 2.5,
                gbp: 2,
                cad: 3.3,
                aud: 3.3,
                brl: 12,
                mxn: 50,
                inr: 187.5,
                jpy: 280
            },
            pro: {
                usd: 5,
                euro: 5,
                gbp: 4,
                cad: 6.6,
                aud: 6.6,
                brl: 24,
                mxn: 100,
                inr: 375,
                jpy: 560
            },
            enterprise: free
        },
        yearly: {
            free: free,
            basic: {
                usd: 1,
                euro: 1,
                gbp: 0.75,
                cad: 1.3,
                aud: 1.3,
                brl: 5,
                mxn: 20,
                inr: 75,
                jpy: 115
            },
            standard: {
                usd: 2,
                euro: 2,
                gbp: 1.5,
                cad: 2.65,
                aud: 2.65,
                brl: 10,
                mxn: 40,
                inr: 150,
                jpy: 225
            },
            pro: {
                usd: 4,
                euro: 4,
                gbp: 3,
                cad: 5.3,
                aud: 5.3,
                brl: 20,
                mxn: 80,
                inr: 300,
                jpy: 450
            },
            enterprise: free
        }
    }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj4, constants_pricing_versions__WEBPACK_IMPORTED_MODULE_0__.VERSION_11, {
        monthly: {
            free: free,
            basic: {
                usd: 2,
                euro: 2,
                gbp: 1.5,
                cad: 2.65,
                aud: 2.65,
                brl: 10,
                mxn: 40,
                inr: 150,
                jpy: 225
            },
            standard: {
                usd: 2.5,
                euro: 2.5,
                gbp: 2,
                cad: 3.3,
                aud: 3.3,
                brl: 12,
                mxn: 50,
                inr: 187.5,
                jpy: 280
            },
            pro: {
                usd: 5,
                euro: 5,
                gbp: 4,
                cad: 6.6,
                aud: 6.6,
                brl: 24,
                mxn: 100,
                inr: 375,
                jpy: 560
            },
            enterprise: free
        },
        yearly: {
            free: free,
            basic: {
                usd: 1,
                euro: 1,
                gbp: 0.75,
                cad: 1.3,
                aud: 1.3,
                brl: 5,
                mxn: 20,
                inr: 75,
                jpy: 115
            },
            standard: {
                usd: 2,
                euro: 2,
                gbp: 1.5,
                cad: 2.65,
                aud: 2.65,
                brl: 10,
                mxn: 40,
                inr: 150,
                jpy: 225
            },
            pro: {
                usd: 4,
                euro: 4,
                gbp: 3,
                cad: 5.3,
                aud: 5.3,
                brl: 20,
                mxn: 80,
                inr: 300,
                jpy: 450
            },
            enterprise: free
        }
    }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj4, constants_pricing_versions__WEBPACK_IMPORTED_MODULE_0__.VERSION_12, {
        monthly: {
            free: free,
            basic: {
                usd: 2,
                euro: 2,
                gbp: 1.5,
                cad: 2.65,
                aud: 2.65,
                brl: 10,
                mxn: 40,
                inr: 150,
                jpy: 225
            },
            standard: {
                usd: 2.5,
                euro: 2.5,
                gbp: 2,
                cad: 3.3,
                aud: 3.3,
                brl: 12,
                mxn: 50,
                inr: 187.5,
                jpy: 280
            },
            pro: {
                usd: 5,
                euro: 5,
                gbp: 4,
                cad: 6.6,
                aud: 6.6,
                brl: 24,
                mxn: 100,
                inr: 375,
                jpy: 560
            },
            enterprise: free
        },
        yearly: {
            free: free,
            basic: {
                usd: 1,
                euro: 1,
                gbp: 0.75,
                cad: 1.3,
                aud: 1.3,
                brl: 5,
                mxn: 20,
                inr: 75,
                jpy: 115
            },
            standard: {
                usd: 2,
                euro: 2,
                gbp: 1.5,
                cad: 2.65,
                aud: 2.65,
                brl: 10,
                mxn: 40,
                inr: 150,
                jpy: 225
            },
            pro: {
                usd: 4,
                euro: 4,
                gbp: 3,
                cad: 5.3,
                aud: 5.3,
                brl: 20,
                mxn: 80,
                inr: 300,
                jpy: 450
            },
            enterprise: free
        }
    }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj4, constants_pricing_versions__WEBPACK_IMPORTED_MODULE_0__.VERSION_13, {
        monthly: {
            free: free,
            basic: {
                usd: 0,
                euro: 0,
                gbp: -0.5,
                cad: -0.3,
                aud: -0.3,
                brl: 4,
                mxn: 0,
                inr: 10,
                jpy: -5
            },
            standard: {
                usd: 0.5,
                euro: 0.5,
                gbp: 0,
                cad: 0.3,
                aud: 0.3,
                brl: 2,
                mxn: 10,
                inr: 27.5,
                jpy: -10
            },
            pro: {
                usd: 1,
                euro: 1,
                gbp: 1,
                cad: 1.6,
                aud: 1.6,
                brl: 10,
                mxn: 20,
                inr: 105,
                jpy: -30
            },
            enterprise: free
        },
        yearly: {
            free: free,
            basic: {
                usd: 0,
                euro: 0,
                gbp: -0.2,
                cad: -0.7,
                aud: -0.7,
                brl: -1,
                mxn: -10,
                inr: -35,
                jpy: -85
            },
            standard: {
                usd: 0,
                euro: 0,
                gbp: -0.5,
                cad: -0.3,
                aud: -0.3,
                brl: 2,
                mxn: 0,
                inr: 10,
                jpy: -25
            },
            pro: {
                usd: 1,
                euro: 1,
                gbp: 0,
                cad: 1.3,
                aud: 1.3,
                brl: 6,
                mxn: 20,
                inr: 100,
                jpy: -50
            },
            enterprise: free
        }
    }), _obj4),
    service: (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, constants_pricing_versions__WEBPACK_IMPORTED_MODULE_0__.VERSION_13, {
        monthly: {
            standard: {
                usd: 15,
                euro: 15,
                gbp: 12,
                cad: 19,
                aud: 19,
                brl: 61,
                mxn: 300,
                inr: 1115,
                jpy: 1997
            },
            pro: {
                usd: 20,
                euro: 20,
                gbp: 17,
                cad: 27,
                aud: 27,
                brl: 87,
                mxn: 400,
                inr: 1530,
                jpy: 2160
            },
            enterprise: free
        },
        yearly: {
            standard: {
                usd: 14,
                euro: 14,
                gbp: 12,
                cad: 18,
                aud: 18,
                brl: 60,
                mxn: 280,
                inr: 1060,
                jpy: 1925
            },
            pro: {
                usd: 19,
                euro: 19,
                gbp: 16,
                cad: 26,
                aud: 26,
                brl: 77,
                mxn: 380,
                inr: 1450,
                jpy: 2025
            },
            enterprise: free
        }
    })
};


/***/ }),

/***/ 29919:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "GB": function() { return /* binding */ StoreUTMDataForEnrichment; },
/* harmony export */   "Xk": function() { return /* binding */ getEnrichmentEntriesForSales; },
/* harmony export */   "uC": function() { return /* binding */ storeNumberOfSeats; }
/* harmony export */ });
/* unused harmony export getSingleEnrichmentEntry */
/* harmony import */ var utils_url__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8339);
/* harmony import */ var utils_url__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(utils_url__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var client_services_hubspot_service_hubspot_constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(22638);
/* harmony import */ var client_services_exceptions_handling_service_exceptions_handling_service__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(53989);



var getSingleEnrichmentEntry = function(paramName, hubspotApiName) {
    var _localStorage;
    var paramValue = JSON.parse(((_localStorage = localStorage) === null || _localStorage === void 0 ? void 0 : _localStorage.getItem(paramName)) || "null");
    if (paramValue) {
        var value = paramValue.value;
        return {
            name: hubspotApiName,
            value: value
        };
    }
};
var getEnrichmentEntriesForSales = function() {
    try {
        var enrichmentEntries = [];
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = client_services_hubspot_service_hubspot_constants__WEBPACK_IMPORTED_MODULE_1__/* .SALES_ENRICHMENT_PARAM_LIST */ .zj[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var item = _step.value;
                var paramName = item.paramName, hubspotApiName = item.hubspotApiName;
                var singleEnrichmentEntry = getSingleEnrichmentEntry(paramName, hubspotApiName);
                if (singleEnrichmentEntry) {
                    enrichmentEntries.push(singleEnrichmentEntry);
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return enrichmentEntries;
    } catch (e) {
        (0,client_services_exceptions_handling_service_exceptions_handling_service__WEBPACK_IMPORTED_MODULE_2__/* .handleClientException */ .N)({
            e: e
        });
        return [];
    }
};
var storeEnrichmentParamInLocalStorage = function(param) {
    var paramName = param.paramName, paramValue = param.paramValue, _storeOnlyOnFirstTimeInSession = param.storeOnlyOnFirstTimeInSession, storeOnlyOnFirstTimeInSession = _storeOnlyOnFirstTimeInSession === void 0 ? false : _storeOnlyOnFirstTimeInSession;
    var _localStorage, _localStorage1;
    if (storeOnlyOnFirstTimeInSession && ((_localStorage = localStorage) === null || _localStorage === void 0 ? void 0 : _localStorage.getItem(paramName))) return;
    (_localStorage1 = localStorage) === null || _localStorage1 === void 0 ? void 0 : _localStorage1.setItem(paramName, JSON.stringify({
        value: paramValue,
        timestamp: Date.now()
    }));
};
var storeUtmDataFromUrl = function() {
    var salesEnrichementUrlParamList = client_services_hubspot_service_hubspot_constants__WEBPACK_IMPORTED_MODULE_1__/* .SALES_ENRICHMENT_PARAM_LIST.filter */ .zj.filter(function(item) {
        return item.type === client_services_hubspot_service_hubspot_constants__WEBPACK_IMPORTED_MODULE_1__/* .SALES_ENRICHMENT_PARAM_TYPES.URL_PARAM */ .sD.URL_PARAM;
    });
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = salesEnrichementUrlParamList[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var item = _step.value;
            var paramName = item.paramName;
            var paramValue = (0,utils_url__WEBPACK_IMPORTED_MODULE_0__.getDecodedParamFromQuery)(window.location, paramName);
            if (paramValue) {
                storeEnrichmentParamInLocalStorage({
                    paramName: paramName,
                    paramValue: paramValue,
                    storeOnlyOnFirstTimeInSession: true
                });
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
};
var storeNumberOfSeats = function(numberOfSeats) {
    storeEnrichmentParamInLocalStorage({
        paramName: client_services_hubspot_service_hubspot_constants__WEBPACK_IMPORTED_MODULE_1__/* .NUMBER_OF_SEATS_PARAM */ .AB,
        paramValue: numberOfSeats
    });
};
var StoreUTMDataForEnrichment = function() {
    try {
        storeUtmDataFromUrl();
    } catch (e) {
        (0,client_services_exceptions_handling_service_exceptions_handling_service__WEBPACK_IMPORTED_MODULE_2__/* .handleClientException */ .N)({
            e: e
        });
    }
};


/***/ }),

/***/ 6941:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {


function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
var CONTACT_SALES_REGIONS = (__webpack_require__(31766).CONTACT_SALES_REGIONS);
// DEFAULT
var DEFAULT_NO_SDR_TYPE = "DEFAULT_NO_SDR";
// TEST
var TEST_REGION_TYPE = "TEST_SALES_ONLY";
// *****************************
var overrideTypeformContactSalesWithVariantDataIfNeeded = function(param) {
    var contactSalesData = param.contactSalesData, getNewVariantForTest = param.getNewVariantForTest;
    if (!getNewVariantForTest) return contactSalesData;
    var newProps = {};
    if (contactSalesData.variantFormId) {
        newProps.formId = contactSalesData.variantFormId;
    }
    if (contactSalesData.variantPrefetchImages) {
        newProps.prefetchImages = contactSalesData.prefetchImages;
    }
    return _object_spread({}, contactSalesData, newProps);
};
var getTypeformContactSalesData = function(param) {
    var country = param.country, isTest = param.isTest, _getNewVariantForTest = param.getNewVariantForTest, getNewVariantForTest = _getNewVariantForTest === void 0 ? false : _getNewVariantForTest;
    // this function can not return null - must return a regionType from CONTACT_SALES_REGIONS
    if (isTest) {
        return CONTACT_SALES_REGIONS[TEST_REGION_TYPE];
    }
    var regions = Object.keys(CONTACT_SALES_REGIONS);
    var regionType = regions.find(function(region) {
        var _CONTACT_SALES_REGIONS_region;
        return (_CONTACT_SALES_REGIONS_region = CONTACT_SALES_REGIONS[region]) === null || _CONTACT_SALES_REGIONS_region === void 0 ? void 0 : _CONTACT_SALES_REGIONS_region.countries.includes(country);
    }) || DEFAULT_NO_SDR_TYPE;
    return overrideTypeformContactSalesWithVariantDataIfNeeded({
        contactSalesData: CONTACT_SALES_REGIONS[regionType],
        getNewVariantForTest: getNewVariantForTest
    });
};
module.exports = {
    getTypeformContactSalesData: getTypeformContactSalesData
};


/***/ }),

/***/ 15728:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ap": function() { return /* binding */ shouldGetTypeformExperience; }
/* harmony export */ });
/* unused harmony exports getTestIsNewVariantByRegion, isEligibleToGetTypeform */
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(14924);
/* harmony import */ var services_ab_tests_acquisition_ab_test_service__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(77784);
/* harmony import */ var services_ab_tests_acquisition_ab_test_service__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(services_ab_tests_acquisition_ab_test_service__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var constants_typeform_contact_sales__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(13979);



var _obj;
var regionToTestMap = (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, constants_typeform_contact_sales__WEBPACK_IMPORTED_MODULE_1__/* .EMEA_GEO_REGION */ .ZZ, services_ab_tests_acquisition_ab_test_service__WEBPACK_IMPORTED_MODULE_0__.shouldGetContactSalesTypeformEmeaTest), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, constants_typeform_contact_sales__WEBPACK_IMPORTED_MODULE_1__/* .AUSTRALIA_NEW_ZEALAND_GEO_REGION */ .hr, services_ab_tests_acquisition_ab_test_service__WEBPACK_IMPORTED_MODULE_0__.shouldGetContactSalesTypeformAnzTest), _obj);
var getTestIsNewVariantByRegion = function(param) {
    var region = param.region, abTests = param.abTests, sendBigBrainEvent = param.sendBigBrainEvent;
    var testByRegion = regionToTestMap[region] || function() {
        return false;
    };
    return testByRegion(abTests, sendBigBrainEvent);
};
var isEligibleToGetTypeform = function(region) {
    return region === constants_typeform_contact_sales__WEBPACK_IMPORTED_MODULE_1__/* .EMEA_GEO_REGION */ .ZZ || region === constants_typeform_contact_sales__WEBPACK_IMPORTED_MODULE_1__/* .AUSTRALIA_NEW_ZEALAND_GEO_REGION */ .hr || region === constants_typeform_contact_sales__WEBPACK_IMPORTED_MODULE_1__/* .AMERICA_GEO_REGION */ .Ux;
};
var shouldGetTypeformExperience = function(param) {
    var abTests = param.abTests, isTypeformDisabled = param.isTypeformDisabled, cloudfrontViewerCountry = param.cloudfrontViewerCountry, testTypeformContactSales = param.testTypeformContactSales, forceTypeformContactSalesExperience = param.forceTypeformContactSalesExperience, _sendBigBrainEvent = param.sendBigBrainEvent, sendBigBrainEvent = _sendBigBrainEvent === void 0 ? false : _sendBigBrainEvent;
    if (isTypeformDisabled) return false;
    if (forceTypeformContactSalesExperience) return true;
    if ((0,constants_typeform_contact_sales__WEBPACK_IMPORTED_MODULE_1__/* .isTypeformDisabledForRegion */ .nk)(cloudfrontViewerCountry)) return false;
    if ((0,constants_typeform_contact_sales__WEBPACK_IMPORTED_MODULE_1__/* .isTypeformFullyReleasedForCountry */ .FC)(cloudfrontViewerCountry)) return true;
    var region = (0,constants_typeform_contact_sales__WEBPACK_IMPORTED_MODULE_1__/* .getContactSalesRegionByCountry */ .Wz)(cloudfrontViewerCountry);
    return isEligibleToGetTypeform(region) && (testTypeformContactSales || getTestIsNewVariantByRegion({
        region: region,
        abTests: abTests,
        sendBigBrainEvent: sendBigBrainEvent
    }));
};


/***/ }),

/***/ 12783:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "M": function() { return /* binding */ ConditionalWrapper; }
/* harmony export */ });
var ConditionalWrapper = function(param) {
    var condition = param.condition, wrapper = param.wrapper, children = param.children;
    return condition ? wrapper(children) : children;
};


/***/ }),

/***/ 11685:
/***/ (function(module) {


var getCapitilizedString = function(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
};
/**
 * returns the given string, surrounded by quotes
 * @param {*} str
 */ var addQuotesIfMissing = function(str) {
    if (!str) {
        return str;
    }
    if (!str.startsWith('"')) {
        str = '"' + str;
    }
    if (!str.endsWith('"')) {
        str += '"';
    }
    return str;
};
var toCamelCase = function(str) {
    if (!str) {
        return "";
    }
    var result = str // Lower cases the string
    .toLowerCase() // Replaces any - or _ characters with a space
    .replace(/[-_]+/g, " ") // Removes any non alphanumeric characters
    .replace(/[^\w\s]/g, "") // Uppercases the first character in each group immediately following a space
    // (delimited by spaces)
    .replace(/ (.)/g, function($1) {
        return $1.toUpperCase();
    });
    // upper case first letter
    return result.substring(0, 1).toUpperCase() + result.substring(1);
};
var toKebabCase = function(str) {
    var _str_match_map, _str_match;
    return str === null || str === void 0 ? void 0 : (_str_match = str.match(/[A-Z]{2,}(?=[A-Z][a-z]+[0-9]*|\b)|[A-Z]?[a-z]+[0-9]*|[A-Z]|[0-9]+/g)) === null || _str_match === void 0 ? void 0 : (_str_match_map = _str_match.map(function(x) {
        return x.toLowerCase();
    })) === null || _str_match_map === void 0 ? void 0 : _str_match_map.join("-");
};
// Returns the words count in the given text
var getWordsCount = function(text) {
    if (!text || !text.match) {
        return 0;
    }
    return text.match(/\S+/g).length;
};
// THIS IS TEMPORARY FIX FOR TEMPLATES GENERATOR
// Because historically a lot of pages contain bold tags
// With no closing tag in the end, causing the page to break
var encloseBoldTag = function(str) {
    if (!str || !str.match) {
        return str;
    }
    var openningBoldsCount = (str.replace(/ /g, "").match(/<b>/g) || []).length;
    var closingBoldsCount = (str.replace(/ /g, "").match(/<\/b>/g) || []).length;
    return openningBoldsCount > closingBoldsCount ? "".concat(str, "</b>") : str;
};
module.exports = {
    getCapitilizedString: getCapitilizedString,
    addQuotesIfMissing: addQuotesIfMissing,
    toCamelCase: toCamelCase,
    toKebabCase: toKebabCase,
    getWordsCount: getWordsCount,
    encloseBoldTag: encloseBoldTag
};


/***/ })

}]);